(function() {
    'use strict';

    angular
        .module('sceaApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'nemLogging',
            'ui-leaflet',
            'angular-loading-bar',
            'dndLists',
            'hc.marked', 'hljs', 'angular-markdown-editor',
            'treeGrid'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitCycleInfoDialogController', VisitCycleInfoDialogController);

    VisitCycleInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'VisitCycle', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VisitCycleInfoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, VisitCycle, ParseLinks, AlertService, pagingParams, paginationConstants) {
    	var vm = this;
    	
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = 'storeGrade';
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VisitCycleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VisitCycle.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.visitCycles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'storeGrade';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitCycleDialogController', VisitCycleDialogController)
        .directive('capitalize', function() {
			return {
				require : 'ngModel',
				link : function(scope, element, attrs, modelCtrl) {
					var capitalize = function(inputValue) {
						if (inputValue == undefined)
							inputValue = '';
						var capitalized = inputValue.toUpperCase();
						if (capitalized !== inputValue) {
							modelCtrl.$setViewValue(capitalized);
							modelCtrl.$render();
						}
						return capitalized;
					}
					modelCtrl.$parsers.push(capitalize);
					capitalize(scope[attrs.ngModel]); // capitalize initial value
				}
			};
		});

    VisitCycleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VisitCycle'];

    function VisitCycleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VisitCycle) {
        var vm = this;
        vm.visitCycle = entity;
        vm.buttonCancel = false;
        vm.buttonSave = false;
        
        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:visitCycleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.buttonCancel = true;
            vm.buttonSave = true;
            if (vm.visitCycle.id !== null) {
                VisitCycle.update(vm.visitCycle, onSaveSuccess, onSaveError);
            } else {
                VisitCycle.save(vm.visitCycle, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitCycleDetailController', VisitCycleDetailController);

    VisitCycleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VisitCycle'];

    function VisitCycleDetailController($scope, $rootScope, $stateParams, entity, VisitCycle) {
        var vm = this;
        vm.visitCycle = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:visitCycleUpdate', function(event, result) {
            vm.visitCycle = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitCycleDeleteController',VisitCycleDeleteController);

    VisitCycleDeleteController.$inject = ['$uibModalInstance', 'entity', 'VisitCycle'];

    function VisitCycleDeleteController($uibModalInstance, entity, VisitCycle) {
        var vm = this;
        vm.visitCycle = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            VisitCycle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('visit-cycle', {
            parent: 'system-administration',
            url: '/system-administration/outlet-management/visit-cycle?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.visitCycle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system-administration/visit-cycle/visit-cycles.html',
                    controller: 'VisitCycleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visitCycle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('visit-cycle-detail', {
            parent: 'system-administration',
            url: '/visit-cycle/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.visitCycle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system-administration/visit-cycle/visit-cycle-detail.html',
                    controller: 'VisitCycleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visitCycle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VisitCycle', function($stateParams, VisitCycle) {
                    return VisitCycle.get({id : $stateParams.id});
                }]
            }
        })
        .state('visit-cycle.new', {
            parent: 'visit-cycle',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system-administration/visit-cycle/visit-cycle-dialog.html',
                    controller: 'VisitCycleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                storeGrade: null,
                                visitTime: null,
                                cycle: null,
                                deleteable: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('visit-cycle', null, { reload: true });
                }, function() {
                    $state.go('visit-cycle');
                });
            }]
        })
        .state('visit-cycle.edit', {
            parent: 'visit-cycle',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system-administration/visit-cycle/visit-cycle-dialog.html',
                    controller: 'VisitCycleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VisitCycle', function(VisitCycle) {
                            return VisitCycle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('visit-cycle', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visit-cycle.delete', {
            parent: 'visit-cycle',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system-administration/visit-cycle/visit-cycle-delete-dialog.html',
                    controller: 'VisitCycleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VisitCycle', function(VisitCycle) {
                            return VisitCycle.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('visit-cycle', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('VisitCycle', VisitCycle);

    VisitCycle.$inject = ['$resource'];

    function VisitCycle ($resource) {
        var resourceUrl =  'api/visit-cycles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('VisitCycleSearch', VisitCycleSearch);

    VisitCycleSearch.$inject = ['$resource'];

    function VisitCycleSearch($resource) {
        var resourceUrl =  'api/_search/visit-cycles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitCycleController', VisitCycleController);

    VisitCycleController.$inject = ['$scope', '$state', 'VisitCycle', 'VisitCycleSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VisitCycleController ($scope, $state, VisitCycle, VisitCycleSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = 'storeGrade';
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VisitCycleSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VisitCycle.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.visitCycles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'storeGrade';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-administration', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('achievement-data-adjustment', {
            parent: 'system-administration',
            url: '/system-administration/achievement-data-adjustment',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.achievement.home.title'
            },
            views: {
                'content@': {
                	 templateUrl: 'app/system-administration/achievement/achievements.html',
                     controller: 'AchievementController',
                     controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('achievement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('dashboardParams');
                    $translatePartialLoader.addPart('storeType');
                    $translatePartialLoader.addPart('callPlanType');
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('adjustedAccumulation');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Achievement', Achievement);

    Achievement.$inject = ['$resource'];

    function Achievement ($resource) {
        var resourceUrl =  'api/adjusted-accumulations';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { 
            	method:'PUT',
            	isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AchievementController', AchievementController);

    AchievementController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'DashboardParams', 'Achievement', 'Calendar'];

    function AchievementController ($scope, $state,  $stateParams, $filter, DashboardParams, Achievement, Calendar) {
       var vm = this;
       vm.achievement = [];
       vm.dashboardParams = null;
       vm.achievement.year = null;
       vm.achievement.month = null;
       vm.achievement.week = null;
       vm.isDisabled = true;
       vm.getWeeks = getWeeks;
       vm.data = [];
            		
       vm.options = {
   			years: [],
   			months: [],
   			weeks: [],
   			dataType: { type: null },
   			storeType: { type: null },
   			callPlanType: {type: null},
   			callPlan: { status: null, max: null },
   			popAV: { status: null, max: null },
   			popHA: { status: null, max: null },
   			equipment: { status: null, max: null },
   			fixture: { status: null, max: null },
   			internet: { status: null, max: null },
   			totalValue: null,
   			adjustedData: { status: null }
   		}
       
       vm.onClickGetData = function(year, month, week, storeType, callPlanType){
    	    if(vm.options.dataType.type == 'month'){
  				week = null;
  				vm.showDisabled = true;
  				getData(year, month, week, storeType, callPlanType);
  			}else{
  				month = null;
  				vm.showDisabled = true;
  				getData(year, month, week, storeType, callPlanType);
  			}
       }
       
       var onSaveSuccess = function (result) {
    	   $scope.$emit('sceaApp:achievementUpdate', result);
           vm.isSaving = false;
       };

       var onSaveError = function () {
           vm.isSaving = false;
       };
       
       vm.save = function(){
	   		var objUpdated = [];

    	   	angular.forEach(vm.achievements, function(achievement, key) {
    	   		var tempAchievement = {};
    	   		if(achievement.statusUpdate == true) {
    	   			tempAchievement.callPlan = achievement.callPlan / 100;
    	   			tempAchievement.callPlanId = achievement.callPlanId;
    	   			    	   			
    	   			tempAchievement.popAV = achievement.popAV / 100;
    	   			tempAchievement.popAVId = achievement.popAVId;
    	   			
    	   			tempAchievement.popHA = achievement.popHA / 100;
    	   			tempAchievement.popHAId = achievement.popHAId;
    	   			
    	   			tempAchievement.equipment = achievement.equipment / 100;
    	   			tempAchievement.equipmentId = achievement.equipmentId;
    	   			
    	   			tempAchievement.fixture = achievement.fixture / 100;
    	   			tempAchievement.fixtureId = achievement.fixtureId;
    	   			
    	   			tempAchievement.internet = achievement.internet / 100;
    	   			tempAchievement.internetId = achievement.internetId;
    	   			
    	   			
    	   			tempAchievement.dataType = achievement.dataType;
    	   			tempAchievement.popAllId = achievement.popAllId;
    	   			tempAchievement.vde = achievement.vde;
    	   			objUpdated.push(tempAchievement);
    	   		}
    	   		if(vm.achievements.length-1 == key) {
    	   		    Achievement.update(objUpdated, onSaveSuccess, onSaveError);	
    	   		}
    	   	})
    	   	
       }
       
       vm.init = function() {
    	   DashboardParams.get(function(result){
    		   vm.dashboardParams = result;
	    	   
					getYears();
					getMonths();
					getWeeks(vm.achievement.year, vm.achievement.month); 
				    
					vm.options.dataType.type = 'month';
					vm.options.storeType.type = 'VDE';
					vm.options.callPlanType.type = 'ACOJTGT';
					vm.buttonSave = 'save';
    			});
		}
		vm.init();
		
		vm.onClickYear = function(value){
			vm.showDisabled = false;
		}
		
		vm.onClickStoreType = function(value){
			if(value == 'VDE' || value == 'PERFECT' || value == 'RIS' || value == 'PC'){
				vm.showDisabled = false;
			}
		}
		
		vm.onClickDataType = function(value){
			if(value == 'month' || value == 'week'){
				vm.showDisabled = false;
			}
		}
		
		vm.onClickOptionsDataType = function(value){
			vm.showDisabled = false;
		}
		
		vm.onClickCallPlanType = function(value){
			if(value == 'ACOJTGT' || value == 'ACOJRCP' || value == 'ACTGT' || value == 'ACRCP'){
				vm.showDisabled = false;
			}
		}
		
		vm.changeCallPlan = function(index, value) {
			if(vm.achievements[index].callPlan == null){
				vm.achievements[index].callPlan = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		vm.changePopAV = function(index, value){
			if(vm.achievements[index].popAV == null){
				vm.achievements[index].popAV = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		vm.changePopHA = function(index, value){
			if(vm.achievements[index].popHA == null){
				vm.achievements[index].popHA = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		vm.changeEquipment = function(index, value){
			if(vm.achievements[index].equipment == null){
				vm.achievements[index].equipment = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		vm.changeFixture = function(index, value){
			if(vm.achievements[index].fixture == null){
				vm.achievements[index].fixture = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		vm.changeInternet = function(index, value){
			if(vm.achievements[index].internet == null){
				vm.achievements[index].internet = 0;
			}
			vm.achievements[index].statusUpdate = true;
		}
		
		function initCalendar() {
			 	vm.achievement.year = new Date().getFullYear();
			 	vm.achievement.month = (new Date().getMonth() + 1).toString();
			 	vm.getWeeks(vm.achievement.year);
	        }
		 initCalendar();
		 
		function getYears() {
			Calendar.queryYears(function(result) {		
				vm.options.years = result;
				getWeeks(vm.achievement.year);
			});
		}
		
		function getMonths() {
			Calendar.queryMonths(function(result) {		
				vm.options.months = result;
			});
		}
		
		function getWeeks(year, month) {
			Calendar.queryWeeks({year: year, month: month}, function(result) {
				vm.options.weeks = result;
				vm.achievement.week = vm.options.weeks[0];
			});
		}
		
		function getData(year, month, week, storeType, callPlanType){
			Achievement.query({year: year, month: month, week: week, storeType: storeType, callPlanType: callPlanType}, function(data){
				if(data.length == 0){
					vm.achievements = data;
					vm.isDisabled = true;
				}else{
					vm.achievements = data;
					angular.forEach(vm.achievements, function(achievement, key) {
						if(isNaN(achievement.callPlan)){
							achievement.callPlan = 0;
							achievement.flagCallPlan = 'NaN';
						}else if(!isFinite(achievement.callPlan)){
							achievement.callPlan = 100;
							achievement.flagCallPlan = 'Infinity';
						}else if(achievement.callPlan > 1){
							achievement.callPlan = 100;
						}else{
							achievement.callPlan *= 100;
							achievement.callPlan = $filter('number')(achievement.callPlan, 0);
							achievement.callPlan = parseInt(achievement.callPlan);
							achievement.flagCallPlan = 'Number';
						}
						  
						if(isNaN(achievement.popAV)){
							achievement.popAV = 0;
							achievement.flagPopAV = 'NaN';
						}else if(!isFinite(achievement.popAV)){
							achievement.popAV = 100;
							achievement.flagPopAV = 'Infinity';
						}else if(achievement.popAV > 1){
							achievement.popAV = 100;
						}else{
							achievement.popAV *= 100;
							achievement.popAV = $filter('number')(achievement.popAV, 0);
							achievement.popAV = parseInt(achievement.popAV);
							achievement.flagPopAV = 'Number';
						}
						
						if(isNaN(achievement.popHA)){
							achievement.popHA = 0;
							achievement.flagPopHA = 'NaN';
						}else if(!isFinite(achievement.popHA)){
							achievement.popHA = 100;
							achievement.flagPopHA = 'Infinity';
						}else if(achievement.popHA > 1){
							achievement.popHA = 100;
						}else{
							achievement.popHA *= 100;
							achievement.popHA = $filter('number')(achievement.popHA, 0);
							achievement.popHA = parseInt(achievement.popHA);
							achievement.flagPopHA = 'Number';
						}
						
						if(isNaN(achievement.equipment)){
							achievement.equipment = 0;
							achievement.flagEquipment = 'NaN';
						}else if(!isFinite(achievement.equipment)){
							achievement.equipment = 100;
							achievement.flagEquipment = 'Infinity';
						}else if(achievement.equipment > 1){
							achievement.equipment = 100;
						}else{
							achievement.equipment *= 100;
							achievement.equipment = $filter('number')(achievement.equipment, 0);
							achievement.equipment = parseInt(achievement.equipment);
							achievement.flagEquipment = 'Number';
						}
						
						if(isNaN(achievement.fixture)){
							achievement.fixture = 0;
							achievement.flagFixture = 'NaN';
						}else if(!isFinite(achievement.fixture)){
							achievement.fixture = 100;
							achievement.flagFixture = 'Infinity';
						}else if(achievement.fixture > 1){
							achievement.fixture = 100;
						}else{
							achievement.fixture *= 100;
							achievement.fixture = $filter('number')(achievement.fixture, 0);
							achievement.fixture = parseInt(achievement.fixture);
							achievement.flagFixture = 'Number';
						}
						
						if(isNaN(achievement.internet)){
							achievement.internet = 0;
							achievement.flagInternet = 'NaN';
						}else if(!isFinite(achievement.internet)){
							achievement.internet = 100;
							achievement.flagInternet = 'Infinity';
						}else if(achievement.internet > 1){
							achievement.internet = 100;
						}else{
							achievement.internet *= 100;
							achievement.internet = $filter('number')(achievement.internet, 0);
							achievement.internet = parseInt(achievement.internet);
							achievement.flagInternet = 'Number';
						}
					});
					vm.isDisabled = false;
				}
			});
			
		}
	}
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'updateManager': {
                url: 'api/usermanager',
                method:'POST'
            },
            'exportAsCsv': {
                url: 'api/users/csv',
                method: 'GET',
                transformResponse: function (data, headersGetter) {
                    var filename = "users.csv";
                    var blob = new Blob([data], {type: "text/csv;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            getInternal: {
                url: 'api/users/internal',
                method: 'GET',
                isArray: true
            },
            'andCriteria': {
                url: 'api/users%3AandCriteria',
                method: 'GET',
                isArray: true
            },
            'andOrCriteria': {
                url: 'api/users%3AandOrCriteria',
                method: 'POST',
                isArray: true
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/_search/users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ExcelReport', ExcelReport);

    ExcelReport.$inject = ['$resource'];

    function ExcelReport ($resource) {
        var resourceUrl =  'api/excel-report';

        return $resource(resourceUrl, {}, {
            'reportCallPlan': { 
            	method:'POST',
            	url: 'api/excel-report/call-plan',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'reportOtherBrandDisplay': { 
            	method:'POST',
            	url: 'api/excel-report/display-other-brand',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'reportPOP': { 
            	method:'POST',
            	url: 'api/excel-report/row-data-pop',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'reportStoreCompleteness': { 
            	method:'POST',
            	url: 'api/excel-report/store-completeness',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'exportProjectList':{
            	url: 'api/excel-report/project-instances',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (!angular.isDefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('pageRibbon', pageRibbon);

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login (credentials) {
            
              var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
              };
            return $http.post('api/authenticate', data).success(authenticateSuccess);


            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
            
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
	'use strict';
	angular.module('sceaApp').factory('Task', Task);

	Task.$inject = [ '$resource' ];

	function Task($resource) {
        var resourceUrl =  'bpm-rest/runtime/tasks/:taskId';

		return $resource(resourceUrl, {}, {
			'query': { method: 'GET', isArray: false },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete':{ method: 'DELETE' },
            
            'getVariable': { 
            	url: 'bpm-rest/runtime/tasks/:taskId/variables/:variableName',
            	method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
		});
	}
})();
;
(function() {
	'use strict';
	angular.module('sceaApp').factory('SceaProcessInstance', SceaProcessInstance);

	SceaProcessInstance.$inject = [ '$resource' ];

	function SceaProcessInstance($resource) {
		return $resource(null, {}, {
			'getProcessInstance': {
				url: 'api/projects/instances',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			},
			'getHistoricProcessInstance': {
				url: 'api/projects/historic-instances',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			},
			'getRuntimeTask': {
				url: 'api/runtime/tasks',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			},
			'getHistoricTask': {
				url: 'api/history/historic-task-instances',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			},
			'submitForm': {
				url: 'api/projects/form-data',
                method: 'POST'
			}
		});
	}
})();
;
(function() {
	'use strict';
	angular.module('sceaApp').factory('ProcessInstance', ProcessInstance);

	ProcessInstance.$inject = [ '$resource' ];

	function ProcessInstance($resource) {
        var resourceUrl =  'bpm-rest/runtime/process-instances/:processInstanceId';

		return $resource(resourceUrl, {}, {
			'query': { method: 'GET', isArray: false },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'deleteProcessInstance': { method: 'DELETE' },
            
            'getDiagram': {
            	url: 'runtime/process-instances/:processInstanceId/diagram',
            	method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var blob = new Blob([data], {type: "image/png;charset=UTF-8"});
                    
                    var result = {};
                    result.headers = headersGetter();
                    result.data = data;
                    result.blob = blob;
                     
                    return result;
                }
            }
		});
	}
})();
;
(function(){
	'use strict';
	angular.module('sceaApp').factory('ProcessDefinition', ProcessDefinition);
	
	ProcessDefinition.$inject = ['$resource'];
	
	function ProcessDefinition($resource) {
		var service = $resource('bpm-rest/repository/process-definitions/:id',{}, {
			'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' }
		});
		return service;
	}
})();;
(function() {
	'use strict';
	angular.module('sceaApp').factory('History', History);

	History.$inject = [ '$resource' ];

	function History($resource) {
        var resourceUrl =  'bpm-rest/history/historic-process-instances/:processInstanceId';

		return $resource(resourceUrl, {}, {
			'query': { method: 'GET', isArray: false },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete':{ method: 'DELETE' },

			'getHistoricTask' : {
				url: 'bpm-rest/history/historic-task-instances',
				method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			},
			'getHistoricDetail' : {
				url: 'bpm-rest/history/historic-detail',
				method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
			}
		});
	}
})();
;
(function() {
	'use strict';
	angular.module('sceaApp').factory('Form', Form);

	Form.$inject = [ '$resource' ];

	function Form($resource) {
        var resourceUrl =  'bpm-rest/form/form-data';

		return $resource(resourceUrl, {}, {
			'query': { method: 'GET', isArray: false },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'delete':{ method: 'DELETE' },
            'submitStartForm' : {
            	url: 'api/projects/form-data',
            	method: 'POST'
            }
		});
	}
})();
;
(function(){
	'use strict';
	angular.module('sceaApp').factory('Deployment', Deployment);
	
	Deployment.$inject = ['$resource'];
	
	function Deployment($resource) {
		var service = $resource('bpm-rest/repository/deployments/:id',{}, {
			'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
		});
		return service;
	}
})();;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitAuditDialogController', VisitAuditDialogController)
        .config(['markedProvider', 'hljsServiceProvider', function(markedProvider, hljsServiceProvider) {
        	markedProvider
				.setOptions({
					gfm : true,
					tables : true,
					sanitize : true,
					highlight : function(code, lang) {
						if (lang) {
							return hljs.highlight(lang,
									code, true).value;
						} else {
							return hljs
									.highlightAuto(code).value;
						}
					}
			});

			hljsServiceProvider.setOptions({
				tabReplace : '    '
			});
        }]);

    VisitAuditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'marked'];

    function VisitAuditDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, marked) {
        var vm = this;
        vm.visitAudit = entity;
        vm.noteActive = 1;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitAuditDetailController', VisitAuditDetailController);

    VisitAuditDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VisitAudit', 'User', 'TPop', 'Calendar', 'TTicketOrder'];

    function VisitAuditDetailController($scope, $rootScope, $stateParams, entity, VisitAudit, User, TPop, Calendar, TTicketOrder) {
        var vm = this;
        vm.visitAudit = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:visitAuditUpdate', function(event, result) {
            vm.visitAudit = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitAuditDeleteController',VisitAuditDeleteController);

    VisitAuditDeleteController.$inject = ['$uibModalInstance', 'entity', 'VisitAudit'];

    function VisitAuditDeleteController($uibModalInstance, entity, VisitAudit) {
        var vm = this;
        vm.visitAudit = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            VisitAudit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('visit-audit', {
            parent: 'report',
            url: '/visit-audit?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.visitAudit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/visit-audit/visit-audits.html',
                    controller: 'VisitAuditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visitAudit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('visit-audit.detail', {
            parent: 'visit-audit',
            url: '/{id}/detail',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/report/visit-audit/visit-audit-dialog.html',
                    controller: 'VisitAuditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VisitAudit', function(VisitAudit) {
                            return VisitAudit.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('visit-audit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('VisitAudit', VisitAudit);

    VisitAudit.$inject = ['$resource', 'DateUtils'];

    function VisitAudit ($resource, DateUtils) {
        var resourceUrl =  'api/visit-audits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.surveyStart = DateUtils.convertDateTimeFromServer(data.surveyStart);
                    data.surveyEnd = DateUtils.convertDateTimeFromServer(data.surveyEnd);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('VisitAuditSearch', VisitAuditSearch);

    VisitAuditSearch.$inject = ['$resource'];

    function VisitAuditSearch($resource) {
        var resourceUrl =  'api/_search/visit-audits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VisitAuditController', VisitAuditController);

    VisitAuditController.$inject = ['$scope', '$state', 'VisitAudit', 'VisitAuditSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VisitAuditController ($scope, $state, VisitAudit, VisitAuditSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VisitAuditSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VisitAudit.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.visitAudits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('vdo-audit-row-data', {
            parent: 'report',
            url: '/report/vdo-audit-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.vdoAudit'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/vdo-audit-row-data/vdo-audit-row-data.html',
                    controller: 'VdoAuditRowDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VdoAuditRowDataController', VdoAuditRowDataController);

		VdoAuditRowDataController.$inject = ['$scope', '$state', '$sce', 'ApplicationSetting'];

    function VdoAuditRowDataController ($scope, $state, $sce, ApplicationSetting) {
        var vm = this;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;
    				address += '?__report=vdo-audit/VdoAuditRowData.rptdesign';

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('store-completeness-report', {
        	parent: 'report',
            url: '/report/store-completeness',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.storeCompletenessReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/store-completeness-report/store-completeness-reports.html',
                    controller: 'StoreCompletenessReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('storeCompletenessReport');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('StoreCompletenessReportController', StoreCompletenessReportController);

    StoreCompletenessReportController.$inject = ['$scope', '$state', 'Principal', 'Area', 'User', 'Calendar', 'ExcelReport'];

    function StoreCompletenessReportController ($scope, $state, Principal, Area, User, Calendar, ExcelReport) {
        var vm = this;
        vm.options = {
        	all: true,
        	filterType: 'employee'
        }
		vm.area = {
			regions: Area.queryByLevelId({areaLevelId : 1},
				function(result) {
					vm.area.region = result[0];
					if(vm.area.region != null) {
						vm.getBranchs(vm.area.region.id);
					}
			}),
			branchs: [],
			cities: []
		}
		vm.employee = {
    		/*
			vdrs: Employee.query({role: 'VDH'},
				function(result) {
					vm.employee.vdr = result[0];
					if(vm.employee.vdr != null) {
						vm.getVdos(vm.employee.vdr.id);
					}
			}),*/
			vdos: User.query({roleName: 'VDO'}, function(result) {
				vm.employee.vdo = result[0];
				if(vm.employee.vdo != null) {
					vm.getVdes(vm.employee.vdo.id);
				}
			}),
			vdes: []
		}
		vm.calendar = {
			years: Calendar.queryYears(),
			months: Calendar.queryMonths(),
			weeks: []
		}

        vm.isVdo = false;
        vm.getBranchs = getBranchs;
        vm.getCities = getCities;
        vm.getVdos = getVdos;
        vm.getVdes = getVdes;
        vm.getWeeks = getWeeks;
        vm.init = init;
        vm.init();

        function init() {
            getAccount();
            initCalendar();
        }

        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] == 'VDO') {
            			isVdo();
            			break;
            		}
            	}
            });
        }

        function isVdo() {
			vm.isVdo = true;
			vm.options.all = false,
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

        function initCalendar() {
        	vm.calendar.year = new Date().getFullYear();
        	vm.calendar.month = (new Date().getMonth() + 1).toString();
        	vm.getWeeks(vm.calendar.year,vm.calendar.month);
        }

		function getBranchs(regionId) {
			vm.area.branch = null;
			vm.area.city = null;
        	vm.area.branchs = Area.queryByParentIdAndLevelId({parentId: regionId, areaLevelId : 2});
        }

        function getCities(branchId) {
			vm.area.cities = [];
			vm.area.city = null;
        	if(branchId != null) {
        		vm.area.cities = Area.queryByParentIdAndLevelId({parentId: branchId, areaLevelId : 3});
        	}
        }

        function getVdos() {
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

        function getVdos(managerId) {
        	vm.employee.vdo = null;
        	vm.employee.vde = null;
        	vm.employee.vdos = Employee.query({role: 'VDO', managerId: managerId});
        }

        function getVdes(managerId) {
        	vm.employee.vdes = [];
        	vm.employee.vde = null;
        	if(managerId) {
        		vm.employee.vdes = User.query({roleName: 'VDE', managerId: managerId});
        	}
        }

        function getWeeks(year, month) {
			Calendar.queryWeeks({year: year, month: month}, function(result) {
				vm.calendar.weeks = result;
				vm.calendar.week = vm.calendar.weeks[0];
			});
        }

        vm.generate = function() {
        	vm.isSaving = true;

        	var filter = generateFilter();
        	var calendar = getCalendar();

        	ExcelReport.reportStoreCompleteness({
        		allWeek: false,
        		categoryId: 0,
        		filter: filter.type,
        		filterId: filter.id,
        		month: calendar.month,
        		week: calendar.week,
        		year: calendar.year
        	}, function() {
            	vm.isSaving = false;
        	});

        	function generateFilter() {
        		var result = { type: null, id: null };

        		if(vm.options.all == false) {
	        		if(vm.options.filterType == 'area') {
	        			if(vm.area.city != null) {
	        				result.type = 'CITY';
	        				result.id = vm.area.city.id;
	        			} else if(vm.area.branch != null) {
	        				result.type = 'BRANCH';
	        				result.id = vm.area.branch.id;
	        			} else if(vm.area.region != null) {
	        				result.type = 'REGION';
	        				result.id = vm.area.region.id;
	        			}
	        		} else if(vm.options.filterType == 'employee') {
	        			if(vm.employee.vde != null) {
	        				result.type = 'VDE';
	        				result.id = vm.employee.vde.id;
	        			} else if(vm.employee.vdo != null) {
	        				result.type = 'VDO';
	        				result.id = vm.employee.vdo.id;
	        			} else if(vm.employee.vdr != null) {
	        				result.type = 'VDR';
	        				result.id = vm.employee.vdr.id;
	        			}
	        		}
        		} else {
    				result.type = 'ALL';
    				result.id = 0;
        		}
    			return result;
        	}

        	function getCalendar() {
        		var result = {
        			year: vm.calendar.year,
        			month: parseInt(vm.calendar.month),
        			week: vm.calendar.week
        		};
        		if(vm.calendar.week == 'All') {
        			result.week = 0;
        		}
    			return result;
        	}
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('row-data-pop-report', {
            parent: 'report',
            url: '/report/row-data-pop',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.rowDataPopReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/row-data-pop-report/row-data-pop-reports.html',
                    controller: 'RowDataPopReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('rowDataPopReport');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RowDataPopReportController', RowDataPopReportController);

    RowDataPopReportController.$inject = ['$scope', '$state', 'Principal', 'Area', 'Employee', 'ProductCategory', 'ExcelReport'];

    function RowDataPopReportController ($scope, $state, Principal, Area, Employee, ProductCategory, ExcelReport) {
        var vm = this;
        vm.options = {
        	all: true,
        	filterType: 'employee'
        }
		vm.area = {
			regions: Area.queryByLevelId({areaLevelId : 1},
				function(result) {
					vm.area.region = result[0];
					if(vm.area.region != null) {
						vm.getBranchs(vm.area.region.id);
					}
			}),
			branchs: [],
			cities: []
		}
		vm.employee = {
			vdrs: Employee.query({role: 'VDH'},
				function(result) {
					vm.employee.vdr = result[0];
					if(vm.employee.vdr != null) {
						vm.getVdos(vm.employee.vdr.id);
					}
			}),
			vdos: [],
			vdes: []
		}
        vm.categories = ProductCategory.getAllProductCategories({level: 2},function(result) {
        	vm.category = result[0];
        });

        vm.isVdo = false;
        vm.getBranchs = getBranchs;
        vm.getCities = getCities;
        vm.getVdos = getVdos;
        vm.getVdes = getVdes;

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] == 'VDO') {
            			isVdo();
            			break;
            		}
            	}
            });
        }

        function isVdo() {
			vm.isVdo = true;
			vm.options.all = false,
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

		function getBranchs(regionId) {
			vm.area.branch = null;
			vm.area.city = null;
        	vm.area.branchs = Area.queryByParentIdAndLevelId({parentId: regionId, areaLevelId : 2});
        }

        function getCities(branchId) {
			vm.area.cities = [];
			vm.area.city = null;
        	if(branchId != null) {
        		vm.area.cities = Area.queryByParentIdAndLevelId({parentId: branchId, areaLevelId : 3});
        	}
        }

        function getVdos() {
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

        function getVdos(managerId) {
        	vm.employee.vdo = null;
        	vm.employee.vde = null;
        	vm.employee.vdos = Employee.query({role: 'VDO', managerId: managerId});
        }

        function getVdes(managerId) {
        	vm.employee.vdes = [];
        	vm.employee.vde = null;
        	if(managerId) {
        		vm.employee.vdes = Employee.query({role: 'VDE', managerId: managerId});
        	}
        }

        vm.generate = function() {
        	vm.isSaving = true;

        	var filter = generateFilter();

        	ExcelReport.reportPOP({
        		allWeek: true,
        		categoryId: vm.category.id,
        		filter: filter.type,
        		filterId: filter.id,
        		month: 0,
        		week: 0,
        		year: 0
        	}, function() {
            	vm.isSaving = false;
        	});

        	function generateFilter() {
        		var result = { type: null, id: null };

        		if(vm.options.all == false) {
	        		if(vm.options.filterType == 'area') {
	        			if(vm.area.city != null) {
	        				result.type = 'CITY';
	        				result.id = vm.area.city.id;
	        			} else if(vm.area.branch != null) {
	        				result.type = 'BRANCH';
	        				result.id = vm.area.branch.id;
	        			} else if(vm.area.region != null) {
	        				result.type = 'REGION';
	        				result.id = vm.area.region.id;
	        			}
	        		} else if(vm.options.filterType == 'employee') {
	        			if(vm.employee.vde != null) {
	        				result.type = 'VDE';
	        				result.id = vm.employee.vde.id;
	        			} else if(vm.employee.vdo != null) {
	        				result.type = 'VDO';
	        				result.id = vm.employee.vdo.id;
	        			} else if(vm.employee.vdr != null) {
	        				result.type = 'VDR';
	        				result.id = vm.employee.vdr.id;
	        			}
	        		}
        		} else {
    				result.type = 'ALL';
    				result.id = 0;
        		}
    			return result;
        	}
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('retail-mapping-row-data', {
            parent: 'report',
            url: '/report/retail-mapping-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.retailMapping.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/retail-mapping-row-data/retail-mapping-row-data.html',
                    controller: 'RetailMappingRowDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingRowDataController', RetailMappingRowDataController);

    RetailMappingRowDataController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function RetailMappingRowDataController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'row-data') {
    				address += '?__report=retail-mapping/RetailMappingRowData.rptdesign';
    			}

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
  'use strict';

  angular
      .module('sceaApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('request-status-pop-report', {
      parent: 'report',
      url: '/report/request-status-pop-report',
      data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'sceaApp.requestStatusPopReport.home.title'
      },
      views: {
        'content@': {
          templateUrl: 'app/report/request-status-pop-report/request-status-pop-report.html',
          controller: 'RequestStatusPopReportController',
          controllerAs: 'vm'
        }
      },
      params: {
        page: {
          value: '1',
          squash: true
        },
        sort: {
          value: 'id,asc',
          squash: true
        },
        search: null
      },
      resolve: {
        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
          return {
            page: PaginationUtil.parsePage($stateParams.page),
            sort: $stateParams.sort,
            predicate: PaginationUtil.parsePredicate($stateParams.sort),
            ascending: PaginationUtil.parseAscending($stateParams.sort),
            search: $stateParams.search
          };
        }],
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('requestStatusPopReport');
          $translatePartialLoader.addPart('orderPop');
          $translatePartialLoader.addPart('requestStatus');
          $translatePartialLoader.addPart('global');
          return $translate.refresh();
        }]
      }
    })
  }
})();
;
(function() {
  'use strict';

  angular
    .module('sceaApp')
    .controller('RequestStatusPopReportController', RequestStatusPopReportController);

    RequestStatusPopReportController.$inject = ['$scope', '$state', 'OrderPop', 'OrderPopSearch', 'Outlet', 'Pop', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RequestStatusPopReportController ($scope, $state, OrderPop, OrderPopSearch, Outlet, Pop, ParseLinks, AlertService, pagingParams, paginationConstants) {
      var vm = this;
      vm.loadAll = loadAll;
      vm.loadPage = loadPage;
      vm.predicate = pagingParams.predicate;
      vm.reverse = pagingParams.ascending;
      vm.transition = transition;
      vm.clear = clear;
      vm.search = search;
      vm.searchQuery = pagingParams.search;
      vm.currentSearch = pagingParams.search;

      vm.getPopDetail = getPopDetail;
      vm.index = null;

      vm.loadAll();

      function loadAll () {
        if (pagingParams.search) {
          OrderPopSearch.query({
            query: pagingParams.search,
            page: pagingParams.page - 1,
            size: paginationConstants.itemsPerPage,
            sort: sort()
          }, onSuccess, onError);
        } else {
          OrderPop.query({
            page: pagingParams.page - 1,
            size: paginationConstants.itemsPerPage,
            sort: sort()
          }, onSuccess, onError);
        }
        function sort() {
          var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
          if (vm.predicate !== 'id') {
            result.push('id');
          }
          return result;
        }
        function onSuccess(data, headers) {
          vm.links = ParseLinks.parse(headers('link'));
          vm.totalItems = headers('X-Total-Count');
          vm.queryCount = vm.totalItems;
          vm.orderPops = data;
          vm.page = pagingParams.page;
        }
        function onError(error) {
          AlertService.error(error.data.message);
        }
      }

      function loadPage (page) {
        vm.page = page;
        vm.transition();
      }

      function transition () {
        $state.transitionTo($state.$current, {
          page: vm.page,
          sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
          search: vm.currentSearch
        });
      }

      function search (searchQuery) {
        if (!searchQuery){
          return vm.clear();
        }
        vm.links = null;
        vm.page = 1;
        vm.predicate = '_score';
        vm.reverse = false;
        vm.currentSearch = searchQuery;
        vm.transition();
      }

      function clear () {
        vm.links = null;
        vm.page = 1;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.currentSearch = null;
        vm.transition();
      }

      function getPopDetail(popId) {
        if (vm.popLoaded != popId) {
          return Pop.get({
            id: popId
          }, function(dataPop) {
            vm.popDetail = dataPop;
            console.log(popId + 'loaded');
          });
        }
      }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('report-promotion', {
            parent: 'report',
            url: '/report/promotion',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.promotion.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-promotion/report-promotion.html',
                    controller: 'ReportPromotionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportPromotionController', ReportPromotionController);

    ReportPromotionController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportPromotionController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'row-data') {
    				address += '?__report=promotion/PromotionRowData.rptdesign';
    			}

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('pop-dashboard', {
            parent: 'report',
            url: '/report/pop-dashboard',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.dashboard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/dashboard/report-pop-dashboard.html',
                    controller: 'ReportPopDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('reportPopChecklist');
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('pop');
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'dashboard'
                    };
                }
            }
        })
        .state('pop-row-data', {
            parent: 'report',
            url: '/report/pop-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.pop.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/report-pop.html',
                    controller: 'ReportPopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        })
        .state('pop-checklist', {
            parent: 'report',
            url: '/report/pop-checklist',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.checklist'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/checklist/report-pop-checklist.html',
                    controller: 'ReportPopChecklistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('reportPopChecklist');
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'checklist'
                    };
                }
            }
        })
        .state('pop-difference', {
            parent: 'report',
            url: '/report/pop-difference',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.difference'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/report-pop.html',
                    controller: 'ReportPopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'difference'
                    };
                }
            }
        })
        .state('pop-request-row-data', {
                    parent: 'report',
                    url: '/report/pop-request-row-data',
                    data: {
                        authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                        pageTitle: 'global.menu.report.pop.requestRowData'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/report/report-pop/report-pop.html',
                            controller: 'ReportPopController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', function ($translate) {
                            return $translate.refresh();
                        }],
                        submenu: function () {
                            return {
                                title: 'request-row-data'
                            };
                        }
                    }
                })
        .state('pop-summary-request', {
            parent: 'report',
            url: '/report/pop-summary-request',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.summaryRequest'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/report-pop.html',
                    controller: 'ReportPopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'summary-request'
                    };
                }
            }
        })
        .state('inventory-valuation', {
            parent: 'report',
            url: '/report/inventory-valuation',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.inventoryValuation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/report-pop.html',
                    controller: 'ReportPopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'inventory-valuation'
                    };
                }
            }
        })
        .state('stock-move', {
            parent: 'report',
            url: '/report/stock-move',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.pop.inventoryValuation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-pop/report-pop.html',
                    controller: 'ReportPopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'stock-move'
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportPopController', ReportPopController);

    ReportPopController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportPopController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'row-data') {
    				address += '?__report=pop/PopRowData.rptdesign';
    			} else if(vm.submenu == 'checklist') {
    				address += '?__report=pop/PopChecklist.rptdesign';
    			} else if(vm.submenu == 'difference') {
    				address += '?__report=pop/PopDisplayDifference.rptdesign';
                } else if(vm.submenu == 'summary-request') {
    				address += '?__report=pop/PopSummaryRequest.rptdesign';
    			} else if(vm.submenu == 'request-row-data') {
                    address += '?__report=pop/PopRequestRowData.rptdesign';
                } else if(vm.submenu == 'inventory-valuation') {
                    address += '?__report=pop/InventoryValuation.rptdesign';
                }   else if(vm.submenu == 'stock-move') {
                    address += '?__report=pop/StockMove.rptdesign';
                }

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportPopDashboardDetailController', ReportPopDashboardDetailController);

    ReportPopDashboardDetailController.$inject = ['$uibModalInstance', 'outlet', 'entity'];

    function ReportPopDashboardDetailController ($uibModalInstance, outlet, entity) {
        var vm = this;

        vm.title = null
        vm.product = []
        
        vm.predicate = 'product'
        vm.reverse = true // desc
        vm.sort = sort


        onInit();

        function onInit() {
            vm.title = outlet.name

            vm.product = entity.map(function (each) {
                return {
                    name : each.display.productProductCode,
                    qty : each.display.qty,
                    item : each.popDtls.map(function (item) {
                        return {
                            name : item.popPopName,
                            qty : item.qty
                        }
                    })
                }
            });

        }

        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function sort(propertyName) {
            vm.reverse = (vm.predicate == propertyName) ? !vm.reverse : false;
            vm.predicate = propertyName;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportPopDashboardController', ReportPopDashboardController);

    ReportPopDashboardController.$inject = ['$uibModal', 'Dashboard', 'OutletAccount', 'OutletType', 'VisitCycle', 'Area', 'ProductCategory'];

    function ReportPopDashboardController ($uibModal, Dashboard, OutletAccount, OutletType, VisitCycle, Area, ProductCategory) {
        var vm = this;

        vm.getBranchs = getBranchs;
        vm.changeResultGraph = changeResultGraph;
        vm.detailDashboardDialog = detailDashboardDialog;
        
        vm.branch = {
            name : 'ALL',
            type : 'Region',
            compliance : 0,
        }
        vm.outlets = []
        vm.area = {}
        vm.selectedRegion = null;
        vm.selectedBranch = null;
        vm.selectedAccount = null;
        vm.selectedStoryType = null;
        vm.selectedGrade = null;
        vm.selectedDIV = null;
        vm.onlyRISOutlet = true;

        vm.accounts = OutletAccount.query();
        vm.storyType = OutletType.query();
        vm.grades = VisitCycle.query();
        vm.div = ProductCategory.getAllProductCategories({level: 1});

        
        onInit();


        function onInit() {
            vm.area = {
                regions: Area.queryByLevelId({areaLevelId : 1},
                    function(result) {
                        if(vm.area.region != null) {
                            vm.getBranchs(vm.area.region.id);
                        }
                }),
                branchs: [],

            }

            vm.dashboardInit = Dashboard.popDashboard({
                regionId: 0,
                accountId: 0,
                outletTypeId: 0,
                divId: 0,
                risStatus: true,
                gradeId: 0,
                branchId : 0
            }, _onSuccess, _onError)

        }
        
        function getBranchs(regionId) {
			vm.selectedBranch = null;
			vm.selectedCity = null;
			if(regionId) {
			    vm.area.branchs = Area.queryByParentIdAndLevelId({parentId: regionId, areaLevelId : 2});
			}
        }

        function changeResultGraph() {
            vm.dashboardInit.$cancelRequest();
            if (vm.newDashboard) {
                vm.newDashboard.$cancelRequest();
            }

            vm.newDashboard = Dashboard.popDashboard({
                regionId: vm.selectedRegion ? vm.selectedRegion.id : 0,
                accountId: vm.selectedAccount ? vm.selectedAccount.id : 0,
                outletTypeId: vm.selectedStoryType ? vm.selectedStoryType.id : 0,
                divId: vm.selectedDIV ? vm.selectedDIV.id : 0,
                risStatus: vm.onlyRISOutlet,
                gradeId: vm.selectedGrade ? vm.selectedGrade.id : 0,
                branchId : vm.selectedBranch ? vm.selectedBranch.id : 0

            }, _onSuccess, _onError)

        }

        function detailDashboardDialog(outlet) {
            var id = outlet.id,
                div = vm.selectedDIV ? vm.selectedDIV.id : 0

            $uibModal.open({
                templateUrl: 'app/report/report-pop/dashboard/report-pop-dashboard-detail.html',
                controller: 'ReportPopDashboardDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    outlet : outlet,
                    entity: ['Dashboard', function(Dashboard) {
                        return Dashboard.popDashboardDetail({
                            id : id,
                            divId : div
                        }).$promise;
                    }],
                }
            }).result.then(function(data) {

            }, function(error) {

            });
        }

        function _onSuccess(data) {
            vm.branch = {
                name : vm.selectedBranch ? vm.selectedBranch.areaName : vm.selectedRegion ? vm.selectedRegion.areaName : 'ALL',
                type : vm.selectedBranch ? "Branch" : "Region",
                compliance : data.areaCompliance.compliance,
            }
            vm.outlets = data.outletCompliance.map(function (outlet) {
                return {
                    id: outlet.id,
                    name: outlet.name,
                    bar :  outlet.compliance,
                }
            });

        }

        function _onError(error) {
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportPopChecklistController', ReportPopChecklistController);

    ReportPopChecklistController.$inject = ['$scope', '$state', 'DynamicForm', 'Channel', 'OutletAccount', 'Area', 'User', 'Calendar', 'ApplicationSetting', '$window'];

    function ReportPopChecklistController ($scope, $state, DynamicForm, Channel, OutletAccount, Area, User, Calendar, ApplicationSetting, $window) {
        var vm = this;
        vm.getBranchs = getBranchs;
        vm.getCities = getCities;
        vm.getVdes = getVdes;
        vm.getSpvs = getSpvs;
        vm.getPcs = getPcs;
        vm.getMonths = getMonths;
        vm.getWeeks = getWeeks;
        vm.isDisplayOnly = false;

        ApplicationSetting.queryByKey({
            key: 'BIRT_VIEWER_ADDRESS'
        }, function(data) {
            vm.birtViewerAddress = data.value += '?__report=pop/PopChecklist.rptdesign';
        });

        vm.bizUnits = DynamicForm.getBusinessUnit(function(result) {
            vm.selectedBizUnit = result[0];
        });

        vm.types = ['ALL', 'Targeted'];
        vm.selectedType = vm.types[0];

        vm.channels = Channel.query();

        vm.accounts = OutletAccount.query();

        vm.roles = ['ALL', 'VDE', 'PC'];
        vm.selectedRole = vm.roles[0];

		vm.area = {
			regions: Area.queryByLevelId({areaLevelId : 1},
				function(result) {
					if(vm.area.region != null) {
						vm.getBranchs(vm.area.region.id);
					}
			}),
			branchs: [],
			cities: []
		}

		vm.employee = {
			vdos: User.query({roleName: 'VDO'}, function(result) {
				if(vm.employee.vdo != null) {
					vm.getVdes(vm.employee.vdo.id);
				}
			}),
			vdes: [],
			arcos: User.query({roleName: 'ARCO'}, function(result) {
                if(vm.employee.arco != null) {
                    vm.getSpvs(vm.employee.arco.id);
                }
            }),
            spvs: [],
            pcs: []
		}

		vm.calendar = {
			years: Calendar.queryYears(),
			months: Calendar.queryMonths(),
			weeks: []
		}

		function getBranchs(regionId) {
			vm.selectedBranch = null;
			vm.selectedCity = null;
			if(regionId) {
			    vm.area.branchs = Area.queryByParentIdAndLevelId({parentId: regionId, areaLevelId : 2});
			}
        }

        function getCities(branchId) {
			vm.area.cities = [];
			vm.selectedCity = null;
        	if(branchId) {
        		vm.area.cities = Area.queryByParentIdAndLevelId({parentId: branchId, areaLevelId : 3});
        	}
        }

        function getVdes(managerId) {
        	vm.employee.vdes = [];
        	vm.selectedVde = null;
        	if(managerId) {
        		vm.employee.vdes = User.query({roleName: 'VDE', managerId: managerId});
        	}
        }

        function getSpvs(managerId) {
            vm.employee.spvs = [];
            vm.selectedSpv = null;
            vm.employee.pcs = [];
            vm.selectedPc = null;
            if(managerId) {
                vm.employee.spvs = User.query({roleName: 'SPV', managerId: managerId});
            }
        }

        function getPcs(managerId) {
            vm.employee.pcs = [];
            vm.selectedPc = null;
            if(managerId) {
                vm.employee.pcs = User.query({roleName: 'PC', managerId: managerId});
            }
        }

        function getMonths() {
            vm.selectedMonth = null;
            vm.selectedWeek = null;
        }

        function getWeeks(year, month) {
			Calendar.queryWeeks({year: year, month: month}, function(result) {
				vm.calendar.weeks = result;
			});
        }

        vm.generate = function() {
        	var url = vm.birtViewerAddress.replace('frameset', 'run');
        	url = url.concat('&__format=xlsx');

        	url = url.concat("&display="+vm.isDisplayOnly);
        	url = url.concat("&category="+vm.selectedBizUnit.id);
        	url = url.concat("&type="+vm.selectedType.toLowerCase());
        	if(vm.selectedChannel) {
        	    url = url.concat("&channel="+vm.selectedChannel.id);
        	}
        	if(vm.selectedAccount) {
                url = url.concat("&account="+vm.selectedAccount.id);
            }
            url = url.concat("&role="+vm.selectedRole);
            if(vm.selectedRole == 'VDE') {
                var allVdo = vm.selectedVdo==null;
                url = url.concat("&all_vdo="+allVdo);
                if(vm.selectedVdo) {
                    url = url.concat("&VDO="+vm.selectedVdo.id);
                }
                if(vm.selectedVde) {
                    url = url.concat("&VDE="+vm.selectedVde.id);
                }
            } else if(vm.selectedRole == 'PC') {
                var allArco = vm.selectedArco==null;
                url = url.concat("&all_arco="+allArco);
                if(vm.selectedArco) {
                    url = url.concat("&ARCO="+vm.selectedArco.id);
                }
                if(vm.selectedSpv) {
                    url = url.concat("&SPV="+vm.selectedSpv.id);
                }
                if(vm.selectedPc) {
                    url = url.concat("&PC="+vm.selectedPc.id);
                }
            }
            if(vm.selectedRegion) {
                url = url.concat("&Region="+vm.selectedRegion.id);
            }
            if(vm.selectedBranch) {
                url = url.concat("&Branch="+vm.selectedBranch.id);
            }
            if(vm.selectedCity) {
                url = url.concat("&City="+vm.selectedCity.id);
            }
            if(vm.selectedYear) {
                url = url.concat("&year="+vm.selectedYear);
            }
            if(vm.selectedMonth) {
                url = url.concat("&month="+vm.selectedMonth);
            }
            if(vm.selectedWeek) {
                url = url.concat("&week="+vm.selectedWeek);
            }

            $window.open(url, '_blank');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('internet-row-data', {
            parent: 'report',
            url: '/report/internet-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.internet.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-internet/report-internet.html',
                    controller: 'ReportInternetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportInternetController', ReportInternetController);

    ReportInternetController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportInternetController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;
        
        vm.submenu = submenu.title;
        
    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;
    			
    			if(vm.submenu == 'row-data') {
    				address += '?__report=internet/InternetRowData.rptdesign';
    			}
    			
    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('image-row-data', {
            parent: 'report',
            url: '/report/image-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.image.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-image/report-image.html',
                    controller: 'ReportImageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportImageController', ReportImageController);

    ReportImageController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportImageController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'row-data') {
    				address += '?__report=image/image.rptdesign';
    			}

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('fixture-row-data', {
            parent: 'report',
            url: '/report/fixture-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.fixture.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-fixture/report-fixture.html',
                    controller: 'ReportFixtureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        })
        .state('fixture-planogram', {
            parent: 'report',
            url: '/report/fixture-planogram',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
                pageTitle: 'global.menu.report.fixture.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-fixture/report-fixture.html',
                    controller: 'ReportFixtureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'planogram'
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportFixtureController', ReportFixtureController);

    ReportFixtureController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportFixtureController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'row-data') {
    				address += '?__report=fixture/FixtureRowData.rptdesign';
    			} else if(vm.submenu == 'planogram') {
    				address += '?__report=fixture/PlanogramRowData.rptdesign';
    			}

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('equipment-row-data', {
            parent: 'report',
            url: '/report/equipment-row-data',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'global.menu.report.equipment.rowData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report-equipment/report-equipment.html',
                    controller: 'ReportEquipmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'row-data'
                    };
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportEquipmentController', ReportEquipmentController);

    ReportEquipmentController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportEquipmentController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;
        
        vm.submenu = submenu.title;
        
    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;
    			
    			if(vm.submenu == 'row-data') {
    				address += '?__report=equipment/EquipmentRowData.rptdesign';
    			}
    			
    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('report', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('other-brand-display-report', {
            parent: 'report',
            url: '/report/other-brand-display',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.otherBrandDisplayReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/other-brand-display-report/other-brand-display-reports.html',
                    controller: 'OtherBrandDisplayReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('otherBrandDisplayReport');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherBrandDisplayReportController', OtherBrandDisplayReportController);

    OtherBrandDisplayReportController.$inject = ['$scope', '$state', 'Principal', 'Area', 'User', 'Calendar', 'ExcelReport'];

    function OtherBrandDisplayReportController ($scope, $state, Principal, Area, User, Calendar, ExcelReport) {
        var vm = this;
        vm.options = {
        	all: true,
        	filterType: 'employee'
        }
		vm.area = {
			regions: Area.queryByParentIdAndLevelId({areaLevelId : 1},
				function(result) {
					vm.area.region = result[0];
					if(vm.area.region != null) {
						vm.getBranchs(vm.area.region.id);
					}
			}),
			branchs: [],
			cities: []
		}
		vm.employee = {
        	/*
			vdrs: Employee.query({role: 'VDH'},
				function(result) {
					vm.employee.vdr = result[0];
					if(vm.employee.vdr != null) {
						vm.getVdos(vm.employee.vdr.id);
					}
			}),*/
			vdos: User.query({roleName: 'VDO'}, function(result) {
				vm.employee.vdo = result[0];
				if(vm.employee.vdo != null) {
					vm.getVdes(vm.employee.vdo.id);
				}
			}),
			vdes: []
		}
		vm.calendar = {
			years: Calendar.queryYears(),
			months: Calendar.queryMonths()
		}

        vm.isVdo = false;
        vm.getBranchs = getBranchs;
        vm.getCities = getCities;
        vm.getVdos = getVdos;
        vm.getVdes = getVdes;
        vm.init = init;
        vm.init();

        function init() {
            getAccount();
            initCalendar();
        }

        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] == 'VDO') {
            			isVdo();
            			break;
            		}
            	}
            });
        }

        function isVdo() {
			vm.isVdo = true;
			vm.options.all = false,
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

        function initCalendar() {
        	vm.calendar.year = new Date().getFullYear();
        	vm.calendar.month = (new Date().getMonth() + 1).toString();
        }

		function getBranchs(regionId) {
			vm.area.branch = null;
			vm.area.city = null;
        	vm.area.branchs = Area.queryByParentIdAndLevelId({parentId: regionId, areaLevelId : 2});
        }

        function getCities(branchId) {
			vm.area.cities = [];
			vm.area.city = null;
        	if(branchId != null) {
        		vm.area.cities = Area.queryByParentIdAndLevelId({parentId: branchId, areaLevelId : 3});
        	}
        }

        function getVdos() {
        	vm.employee.vdos  = Employee.query({role: 'VDO'},
        		function(result) {
					vm.employee.vdo = result[0];
					if(vm.employee.vdo != null) {
						vm.getVdes(vm.employee.vdo.id);
					}
			});
        }

        function getVdos(managerId) {
        	vm.employee.vdo = null;
        	vm.employee.vde = null;
        	vm.employee.vdos = Employee.query({role: 'VDO', managerId: managerId});
        }

        function getVdes(managerId) {
        	vm.employee.vdes = [];
        	vm.employee.vde = null;
        	if(managerId) {
        		vm.employee.vdes = User.query({roleName: 'VDE', managerId: managerId});
        	}
        }

        vm.generate = function() {
        	vm.isSaving = true;

        	var filter = generateFilter();
        	var calendar = getCalendar();

        	ExcelReport.reportOtherBrandDisplay({
        		allWeek: false,
        		categoryId: 0,
        		filter: filter.type,
        		filterId: filter.id,
        		month: calendar.month,
        		week: calendar.week,
        		year: calendar.year
        	}, function() {
            	vm.isSaving = false;
        	});

        	function generateFilter() {
        		var result = { type: null, id: null };

        		if(vm.options.all == false) {
	        		if(vm.options.filterType == 'area') {
	        			if(vm.area.city != null) {
	        				result.type = 'CITY';
	        				result.id = vm.area.city.id;
	        			} else if(vm.area.branch != null) {
	        				result.type = 'BRANCH';
	        				result.id = vm.area.branch.id;
	        			} else if(vm.area.region != null) {
	        				result.type = 'REGION';
	        				result.id = vm.area.region.id;
	        			}
	        		} else if(vm.options.filterType == 'employee') {
	        			if(vm.employee.vde != null) {
	        				result.type = 'VDE';
	        				result.id = vm.employee.vde.id;
	        			} else if(vm.employee.vdo != null) {
	        				result.type = 'VDO';
	        				result.id = vm.employee.vdo.id;
	        			} else if(vm.employee.vdr != null) {
	        				result.type = 'VDR';
	        				result.id = vm.employee.vdr.id;
	        			}
	        		}
        		} else {
    				result.type = 'ALL';
    				result.id = 0;
        		}
    			return result;
        	}

        	function getCalendar() {
        		var result = {
        			year: vm.calendar.year,
        			month: parseInt(vm.calendar.month),
        			week: 0
        		};
    			return result;
        	}
        }
    }
})();
;
(function() {
	'use strict';

	angular
		.module('sceaApp').controller('IncentiveParamsDialogController', IncentiveParamsDialogController);

		IncentiveParamsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DashboardParams', 'Calendar'];

	function IncentiveParamsDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, DashboardParams, Calendar) {
		var vm = this;
		vm.dashboardParams = entity;
		
		vm.options = {
			years: [],
			months: [],
			weeks: [],
			dataType: { type: null },
			callPlan: { status: null, max: null },
			pop: { status: null, max: null },
			equipment: { status: null, max: null },
			fixture: { status: null, max: null },
			internet: { status: null, max: null },
			totalValue: null,
			adjustedData: { status: null }
		}		

		vm.init = function() {
			getYears();
			getMonths();
			getWeeks(vm.dashboardParams.year);

			if(vm.dashboardParams.month == null
					|| vm.dashboardParams.month == 0) {
				vm.options.dataType.type = 'week';
			} else {
				vm.options.dataType.type = 'month';
			}
			if(vm.dashboardParams.month != null) {
				vm.dashboardParams.month = vm.dashboardParams.month.toString();
			}
			if(vm.dashboardParams.callPlan != 0) {
				vm.options.callPlan.status = true;
			}
			vm.options.callPlan.max = vm.dashboardParams.callPlan;
			if(vm.dashboardParams.pop != 0) {
				vm.options.pop.status = true;
			}
			vm.options.pop.max = vm.dashboardParams.pop;
			if(vm.dashboardParams.equipment != 0) {
				vm.options.equipment.status = true;
			}
			vm.options.equipment.max = vm.dashboardParams.equipment;
			if(vm.dashboardParams.fixture != 0) {
				vm.options.fixture.status = true;
			}
			vm.options.fixture.max = vm.dashboardParams.fixture;
			if(vm.dashboardParams.internet != 0) {
				vm.options.internet.status = true;
			}
			vm.options.internet.max = vm.dashboardParams.internet;
			vm.options.totalValue = 100;
			vm.options.adjustedData.status = true;
		}
		
		vm.changeDataType = function() {
        	if(vm.options.dataType.type == 'month'){
	    		angular.element('.form-group:eq(1) > div > select').focus();
	    	} else if(vm.options.dataType.type == 'week'){
	    		angular.element('.form-group:eq(2) > div > select').focus();
	        }
		}
		
		vm.changePortion = function() {
			validationInputValue();
			vm.options.totalValue = setTotalValue();
			setMaxValue(vm.options.totalValue);
		}

		vm.setFocus = function(value, key) {
			if(value == true) {
				angular.element('.form-group:eq(' + key + ') > div > div > input').focus();
			}
		}

        vm.save = function () {
			vm.isSaving = true;

			vm.dashboardParams.month = parseInt(vm.dashboardParams.month);
			if(vm.options.dataType.type == 'month') {
				vm.dashboardParams.week = null;
			} else if(vm.options.dataType.type == 'week') {
				vm.dashboardParams.month = null;
			}

			DashboardParams.update(vm.dashboardParams, onSaveSuccess, onSaveError);
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

		function getYears() {
			Calendar.queryYears(function(result) {		
				vm.options.years = result;
			});
		}
		
		function getMonths() {
			Calendar.queryMonths(function(result) {		
				vm.options.months = result;
				if(vm.dashboardParams.month == null) {
					vm.dashboardParams.month = vm.options.months[0].toString();
				}
			});
		}
		
		function getWeeks(year) {
			Calendar.queryWeeks({year: year}, function(result) {
				vm.options.weeks = result;
				if(vm.dashboardParams.week == null) {
					vm.dashboardParams.week = vm.options.weeks[0];
				}
			});
		}
		
		function validationInputValue() {
			if(vm.dashboardParams.callPlan == null
				|| vm.dashboardParams.callPlan > vm.options.callPlan.max) {
				vm.dashboardParams.callPlan = vm.options.callPlan.max;
			}
			if(vm.options.callPlan.status == false) {
				vm.dashboardParams.callPlan = 0;
			}
			
			if(vm.dashboardParams.pop < 0 || vm.dashboardParams.pop == null
					|| vm.dashboardParams.pop > vm.options.pop.max) {
				vm.dashboardParams.pop = vm.options.pop.max;
			}
			if(vm.options.pop.status == false) {
				vm.dashboardParams.pop = 0;
			}
			if(vm.dashboardParams.equipment < 0
					|| vm.dashboardParams.equipment == null
					|| vm.dashboardParams.equipment > vm.options.equipment.max) {
				vm.dashboardParams.equipment = vm.options.equipment.max;
			}
			if(vm.options.equipment.status == false) {
				vm.dashboardParams.equipment = 0;
			}
			if(vm.dashboardParams.fixture < 0
					|| vm.dashboardParams.fixture == null
					|| vm.dashboardParams.fixture > vm.options.fixture.max) {
				vm.dashboardParams.fixture = vm.options.fixture.max;
			}
			if(vm.options.fixture.status == false) {
				vm.dashboardParams.fixture = 0;
			}
			if(vm.dashboardParams.internet < 0
					|| vm.dashboardParams.internet == null
					|| vm.dashboardParams.internet > vm.options.internet.max) {
				vm.dashboardParams.internet = vm.options.internet.max;
			}
			if(vm.options.internet.status == false) {
				vm.dashboardParams.internet = 0;
			}
		}
		
		function setTotalValue() {
			var totalValue = 0;
			if(vm.options.callPlan.status	 == true) {
				totalValue = totalValue + vm.dashboardParams.callPlan;
			}
			if(vm.options.pop.status == true) {
				totalValue = totalValue + vm.dashboardParams.pop;
			}
			if(vm.options.equipment.status == true) {
				totalValue = totalValue+ vm.dashboardParams.equipment;
			}
			if(vm.options.fixture.status == true) {
				totalValue = totalValue + vm.dashboardParams.fixture;
			}
			if(vm.options.internet.status == true) {
				totalValue = totalValue + vm.dashboardParams.internet;
			}
			return totalValue;
		}
		
		function setMaxValue(totalValue) {
			var maxValue = 100;
			vm.options.callPlan.max = maxValue - vm.options.totalValue + vm.dashboardParams.callPlan;
			vm.options.pop.max = maxValue - vm.options.totalValue + vm.dashboardParams.pop;
			vm.options.equipment.max = maxValue - vm.options.totalValue + vm.dashboardParams.equipment;
			vm.options.fixture.max = maxValue - vm.options.totalValue + vm.dashboardParams.fixture;
			vm.options.internet.max = maxValue - vm.options.totalValue + vm.dashboardParams.internet;
		}

        $timeout(function (){
            angular.element('.form-group:eq(0) > div > select').focus();
        });
        
		function onSaveSuccess(result) {
            $scope.$emit('sceaApp:dashboardParamsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
		}
		
		function onSaveError(result) {
            vm.init();
            vm.isSaving = false;
		}
	}
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report-incentive', {
            parent: 'report',
            url: '/report/incentive',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.incentiveReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/incentive/incentive.html',
                    controller: 'IncentiveController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('dashboard');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('IncentiveController', IncentiveController);

    IncentiveController.$inject = ['$scope', '$state', '$uibModal', '$filter', 'Dashboard', 'DashboardParams', 'orderByFilter'];

    function IncentiveController ($scope, $state, $uibModal, $filter, Dashboard, DashboardParams, orderByFilter) {
        var vm = this;

        vm.dashboardDatas = [];
		vm.dashboardParams = null;
		vm.exportVdeProgressing = false;
    	vm.pageDashboard = 1;

    	vm.loadMoreDashboard = loadMoreDashboard;

        vm.loadDashboard = function() {
            Dashboard.query(function(result) {
            	vm.dashboardDatas = result;

                for (var i = 0; i < result.length; i++) {
					if (isNaN(vm.dashboardDatas[i].achievement)) {
						vm.dashboardDatas[i].achievement = 0;
					} else {
						vm.dashboardDatas[i].achievement = result[i].achievement;
					}
				}
            });
        };
        vm.loadDashboard();

        function loadMoreDashboard() {
            vm.disableLoadDashboard = true;

            Dashboard.query({
                page: vm.pageDashboard
            }, function(data, headers) {
            	angular.forEach(data, function(dashboardData) {
					if (isNaN(dashboardData.achievement)) {
						dashboardData.achievement = 0;
					} else {
						dashboardData.achievement = dashboardData.achievement;
					}

                	vm.dashboardDatas.push(dashboardData);
            	});

            	var totalNow = vm.dashboardDatas.length + data.length;
                var totalItems = headers('X-Total-Count');

                if(totalNow == totalItems) {
                	vm.disableLoadDashboard = true;
                } else {
                	vm.disableLoadDashboard = false;
                }
            	vm.pageDashboard++;
            });
        }

        vm.loadDashboardParams = function() {
    		DashboardParams.get(function(result){
    			vm.dashboardParams = result;
    		});
        };
        vm.loadDashboardParams();

        vm.exportVde = function() {
        	vm.exportVdeProgressing = true;
            Dashboard.exportExcel().$promise.then(function(data){
            	vm.exportVdeProgressing = false;
            },function(error){
            	// error
            });
        }

        vm.openOption = function() {
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/report/incentive/incentive-params/incentive-params-dialog.html',
            	controller: 'IncentiveParamsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "lg",
                resolve: {
                    entity: ['DashboardParams', function(DashboardParams) {
                        return vm.dashboardParams;
                    }],
                    mainTranslatePartialLoader: ['$stateParams', '$translate', '$translatePartialLoader',
                        function ($stateParams, $translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dashboardParams');
                        $translatePartialLoader.addPart('storeType');
                        $translatePartialLoader.addPart('callPlanType');
                        $translatePartialLoader.addPart('calendar');
                        return $translate.refresh();
                    }]
                }
            });

            modalInstance.result.then(function (result) {
            	vm.dashboardParams = result;
                vm.loadDashboard();
            }, function () {
                vm.loadDashboardParams();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider
        .state('call-plan-all-outlet', {
            parent: 'report',
            url: '/report/call-plan-all-outlet',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.callPlanReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/call-plan-report/call-plan-report.html',
                    controller: 'ReportCallPlanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }],
                submenu: function () {
                    return {
                        title: 'all-outlet'
                    };
                }
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ReportCallPlanController', ReportCallPlanController);

    ReportCallPlanController.$inject = ['$scope', '$state', '$sce', 'submenu', 'ApplicationSetting'];

    function ReportCallPlanController ($scope, $state, $sce, submenu, ApplicationSetting) {
        var vm = this;

        vm.submenu = submenu.title;

    	function init() {
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			var address = data.value;

    			if(vm.submenu == 'all-outlet') {
    				address += '?__report=call-plan/CallPlanByAllOutlet.rptdesign';
    			}

    			vm.birtViewerAddress = $sce.trustAsResourceUrl(address);
    		});
    	}
    	init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDialogController4', VDETaskPlanningDialogController4);

    VDETaskPlanningDialogController4.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'vde', 'last', 'Calendar', 'VDETaskPlanning'];

    function VDETaskPlanningDialogController4 ($timeout, $scope, $state, $stateParams, $uibModalInstance, $uibModal, entity, vde, last, Calendar, VDETaskPlanning) {
        var vm = this;
        var isChange = false;
        vm.vdeTaskPlanningsPerWeek = entity;
        vm.vde = vde;
        vm.isLast = last;
        vm.reverse = false;
        
        vm.ok = function() {
        	if(isChange) {
                $uibModalInstance.close(vm.vdeTaskPlanningsPerWeek);        		
        	} else {
        		vm.clear();    		
        	}
        };
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addVdeTaskPlanning = function() {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/outlet-employee/outlet-employee-detail.html',
            	controller: 'OutletEmployeeDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		calendarId: [function() {
            			return vm.calendarId
            		}],
            		vde: [function() {
            			return vm.vde
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
        
        vm.deleteVdeTaskPlanning = function(vdeTaskPlanning) {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/v-de-task-planning/v-de-task-planning-delete-dialog.html',
            	controller: 'VDETaskPlanningDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		entity: [function() {
            			return vdeTaskPlanning;
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDialogController3', VDETaskPlanningDialogController3);

    VDETaskPlanningDialogController3.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'vde', 'last', 'Calendar', 'VDETaskPlanning'];

    function VDETaskPlanningDialogController3 ($timeout, $scope, $state, $stateParams, $uibModalInstance, $uibModal, entity, vde, last, Calendar, VDETaskPlanning) {
        var vm = this;
        var isChange = false;
        vm.vdeTaskPlanningsPerWeek = entity;
        vm.vde = vde;
        vm.isLast = last;
        vm.reverse = false;
        
        vm.ok = function() {
        	if(isChange) {
                $uibModalInstance.close(vm.vdeTaskPlanningsPerWeek);        		
        	} else {
        		vm.clear();    		
        	}
        };
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addVdeTaskPlanning = function() {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/outlet-employee/outlet-employee-detail.html',
            	controller: 'OutletEmployeeDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		calendarId: [function() {
            			return vm.calendarId
            		}],
            		vde: [function() {
            			return vm.vde
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
        
        vm.deleteVdeTaskPlanning = function(vdeTaskPlanning) {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/v-de-task-planning/v-de-task-planning-delete-dialog.html',
            	controller: 'VDETaskPlanningDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		entity: [function() {
            			return vdeTaskPlanning;
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDialogController2', VDETaskPlanningDialogController2);

    VDETaskPlanningDialogController2.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'vde', 'last', 'Calendar', 'VDETaskPlanning'];

    function VDETaskPlanningDialogController2 ($timeout, $scope, $state, $stateParams, $uibModalInstance, $uibModal, entity, vde, last, Calendar, VDETaskPlanning) {
        var vm = this;
        var isChange = false;
        vm.vdeTaskPlanningsPerWeek = entity;
        vm.vde = vde;
        vm.isLast = last;
        vm.reverse = false;
        
        vm.ok = function() {
        	if(isChange) {
                $uibModalInstance.close(vm.vdeTaskPlanningsPerWeek);        		
        	} else {
        		vm.clear();    		
        	}
        };
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addVdeTaskPlanning = function() {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/outlet-employee/outlet-employee-detail.html',
            	controller: 'OutletEmployeeDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		calendarId: [function() {
            			return vm.calendarId
            		}],
            		vde: [function() {
            			return vm.vde
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
        
        vm.deleteVdeTaskPlanning = function(vdeTaskPlanning) {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/v-de-task-planning/v-de-task-planning-delete-dialog.html',
            	controller: 'VDETaskPlanningDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		entity: [function() {
            			return vdeTaskPlanning;
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDialogController', VDETaskPlanningDialogController);

    VDETaskPlanningDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'vde', 'last', 'Calendar', 'VDETaskPlanning'];

    function VDETaskPlanningDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance, $uibModal, entity, vde, last, Calendar, VDETaskPlanning) {
        var vm = this;
        var isChange = false;
        vm.vdeTaskPlanningsPerWeek = entity;
        vm.vde = vde;
        vm.isLast = last;
        vm.reverse = false;
        vm.calendarId = $stateParams.calendarId;
        vm.calendar = Calendar.get({id: vm.calendarId}, function(result) {
        	vm.week = result.week;
        });
        vm.currentCalendar = Calendar.getCurrent();
        
        vm.ok = function() {
        	if(isChange) {
                $uibModalInstance.close(vm.vdeTaskPlanningsPerWeek);        		
        	} else {
        		vm.clear();    		
        	}
        };
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.addVdeTaskPlanning = function() {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/outlet-employee/outlet-employee-detail.html',
            	controller: 'OutletEmployeeDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		calendarId: [function() {
            			return vm.calendarId
            		}],
            		vde: [function() {
            			return vm.vde
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
        
        vm.deleteVdeTaskPlanning = function(vdeTaskPlanning) {
        	isChange = true;
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/merchandiser-activity/v-de-task-planning/v-de-task-planning-delete-dialog.html',
            	controller: 'VDETaskPlanningDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "md",
            	resolve: {
            		entity: [function() {
            			return vdeTaskPlanning;
            		}]
            	}
            });

            modalInstance.result.then(function(result) {
            	vm.vdeTaskPlanningsPerWeek = VDETaskPlanning.query({vdeId: vm.vde.id, calendarId : vm.calendarId});
            });   	
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDetailController', VDETaskPlanningDetailController);

    VDETaskPlanningDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VDETaskPlanning', 'Calendar', 'Outlet'];

    function VDETaskPlanningDetailController($scope, $rootScope, $stateParams, entity, VDETaskPlanning, Calendar, Outlet) {
        var vm = this;
        vm.vDETaskPlanning = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:vDETaskPlanningUpdate', function(event, result) {
            vm.vDETaskPlanning = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningDeleteController',VDETaskPlanningDeleteController);

    VDETaskPlanningDeleteController.$inject = ['$uibModalInstance', 'entity', 'VDETaskPlanning'];

    function VDETaskPlanningDeleteController($uibModalInstance, entity, VDETaskPlanning) {
        var vm = this;
        vm.vDETaskPlanning = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            VDETaskPlanning.delete({id: id},
                function (result) {
                    $uibModalInstance.close(true);
                }, function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('VDETaskPlanning', VDETaskPlanning);

    VDETaskPlanning.$inject = ['$resource'];

    function VDETaskPlanning ($resource) {
        var resourceUrl =  'api/vde-task-plannings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryOutletsActuals': { 
            	url: 'api/vde-task-plannings/outlets/actuals',
            	method: 'GET',
            	isArray: true
            },
            'queryOutletsRecommendations': { 
            	url: 'api/vde-task-plannings/outlets/recommendations',
            	method: 'GET',
            	isArray: true
            },
            'queryOutletsTargets': { 
            	url: 'api/vde-task-plannings/outlets/targets',
            	method: 'GET',
            	isArray: true
            },
            'querySummaries': { 
            	url: 'api/vde-task-plannings/summaries',
            	method: 'GET',
            	isArray: true,
            	transformResponse: function(data) {
            		data = angular.fromJson(data);
            		var dataCopy = JSON.parse(JSON.stringify(data));
            	
            		// get max week length
            		var maxWeeksElem = 0;
            		var arrIdxHasMaxWeek = 0;
            		for( var i = 0; i < data.length; i++) {
            			if(data[i].weeks && data[i].weeks.length > maxWeeksElem){
            				maxWeeksElem = data[i].weeks.length;
            				arrIdxHasMaxWeek = i;
            			}
            		}
            		
            		var weekNums = [];
            		for(var i = 0; i < data[arrIdxHasMaxWeek].weeks.length; i++){
            			weekNums.push(data[arrIdxHasMaxWeek].weeks[i])
            		}

            		//
            		var template = JSON.parse(JSON.stringify(weekNums));
            		template.forEach(function(el, index, theArray){
            			theArray[index].value = 0;
            		});
            		for( var i = 0; i < data.length; i++) {
            			if(data[i].weeks.length < weekNums.length) {
            				var copyOri = JSON.parse(JSON.stringify(data[i].weeks));
            				var newWeeks = JSON.parse(JSON.stringify(template));
            				for(var h = 0; h < copyOri.length; h++){
            					var modWe = newWeeks.find(function(w){
            						return w.week === copyOri[h].week;
            					});
            					modWe.value = copyOri[h].value;
            				}
            				dataCopy[i].weeks = JSON.parse(JSON.stringify(newWeeks));
            			}
            		}
            		return dataCopy;
            	}
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('VDETaskPlanningSearch', VDETaskPlanningSearch);

    VDETaskPlanningSearch.$inject = ['$resource'];

    function VDETaskPlanningSearch($resource) {
        var resourceUrl =  'api/_search/v-de-task-plannings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VDETaskPlanningController', VDETaskPlanningController);

    VDETaskPlanningController.$inject = ['$rootScope', '$scope', '$state', '$q', '$timeout', 'VDETaskPlanning', 'VDETaskPlanningSearch', 'AlertService', 'Calendar'];

    function VDETaskPlanningController ($rootScope, $scope, $state, $q, $timeout, VDETaskPlanning, VDETaskPlanningSearch, AlertService, Calendar) {
		var defer = $q.defer();
		
        var vm = this;
        vm.vdeTaskPlannings = [];
        vm.data = [];
        vm.currentCalendar = Calendar.getCurrent(function(months) {	
    		vm.month = vm.currentCalendar.month.toString();
		});
		
		vm.months = Calendar.queryMonths();
		
		$timeout(function() {
			var vdo = $rootScope.vdo;
			if(vdo != null) {
				vm.vdeTaskPlannings = VDETaskPlanning.querySummaries({
					vdoId: vdo.id,
					year: getYear(),
					month: vm.month });	
				defer.resolve(vm.vdeTaskPlannings);
			}
		}, 500);
		
        function getYear() {
			var result = new Date().getFullYear();
			return result;
		}

		vm.updateVdeTaskPlannings = function(vdo, month) {
			if(vdo != null && month != null) {
				VDETaskPlanning.querySummaries({
					vdoId : vdo.id,
					year : getYear(),
					month : parseInt(month)
				}, onSuccess, onError);
			}

			function onSuccess(result) {
				vm.vdeTaskPlannings = result;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}
        
		vm.onChangeMonth = function(month) {
			vm.updateVdeTaskPlannings($rootScope.vdo, month);
		}
		
		$rootScope.$watch('vdo', function(vdo) {
			if(vdo != null) {
				vm.updateVdeTaskPlannings(vdo, vm.month);
			}
		});
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('taskDetail', {
        	parent: 'merchandiser-activity',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.tasks.home.title'
            },
            views: {
            	'content@': {
            		templateUrl: 'app/merchandiser-activity/task/taskDetail.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm'
                }
            },
        	url: '/merchandiser-activity/store-completion/tasksDetail',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('task');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = ['$scope', '$state', '$stateParams', '$timeout', '$filter', 'entity',
    	'AlertService', 'Attachment', 'DataUtils', 'DynamicForm', 'Form', 'History', 'Outlet', 'OutletSearch', 'Principal', 'ProcessInstance', 'Project', 'ProjectColumn', 'SceaProcessInstance', 'Task'];

    function TaskDetailController ($scope, $state, $stateParams, $timeout, $filter, entity,
    	AlertService, Attachment, DataUtils, DynamicForm, Form, History, Outlet, OutletSearch, Principal, ProcessInstance, Project, ProjectColumn, SceaProcessInstance, Task) {
    	
        var vm = this;
        vm.task = entity;
        vm.taskDetailed = {};
        vm.historicTasks = {};
        vm.form = [];
        vm.formDataHistoric = [];
        
        vm.taskId = $stateParams.id;
        vm.statusForm = $stateParams.status;
        
        vm.isHistoric = false;
        vm.isApprove = false;

        vm.tasks = [];
        vm.size = 100;

        vm.getOutlet = getOutlet;
        vm.init = init;
        vm.init();
        
        var idAttachmentFiles = [];
        var idALongVariables = [];        
        var indexBusinessUnit = 0;
        var indexOutlet = 0;
		
        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] != 'ROLE_ADMIN') {
            			vm.role = account.authorities[i];
            			if(vm.role == 'VDO') {
            	        	SceaProcessInstance.getProcessInstance(function(result) {
            	        		if(result.length > 0) {
                    	        	vm.task.$promise.then(function(task){
                    	        		var flag = false;
                    	        		angular.forEach(result.data, function(data, key) {
                    	        			if(task.processInstanceId == data.processInstanceId) {
                    	        				flag = true;
                    	        			}
                    	        			
                    	        			if(result.data.length-1 == key) {
                    	        				if(!flag) {
                    	        	                $state.go('task');                	        					
                    	        				}
                    	        			}
                    	        		});
                    	        	});            	        			
            	        		} else {
    	        	                $state.go('task');             	        			
            	        		}
            	        	});
            			} else {
            				init();
            			}
            			break;
            		}
            	}
            });
        };
        getAccount();
        
        function init() {
        	if(vm.statusForm == 'edit') {
                userValidation();
                
        		Task.get({
            		includeProcessVariables: true,
        			taskId: $stateParams.id
        		}, onSuccess, onError);
        	} else if(vm.statusForm == 'detail') {
        		Task.get({
            		includeProcessVariables: true,
        			taskId: $stateParams.id
        		}, onSuccess, onError);
        	} else if(vm.statusForm == 'historic') {
        		vm.isHistoric = true;
        		
        		History.getHistoricTask({
            		includeProcessVariables: true,
            		taskId: vm.taskId
            	}, onSuccess, onError);
        	} else {
                $state.go('task-detail', { id: vm.taskId, status: 'detail' });        		
        	}
        	
        	function onSuccess(result) {
            	if(vm.statusForm == 'historic') {
                	vm.task = result.data[0];
                	vm.getTasksList();
                	
                	for(var i=0; i<vm.task.variables.length; i++) {
                		if(vm.task.variables[i].name == 'project') {
                			getProjectColumn(vm.task.variables[i].id);                			
                			break;
                		}
                	}
            	} else {
            		vm.task = result;
            		getFormRunningTask();
            		vm.getTasksList();
            		
            		Task.getVariable({
            			taskId: vm.taskId, 
            			variableName: 'project'
            		}, function(result) {            			
            			var strings = result.value;
    					var json = JSON.stringify(eval("(" + strings + ")"));
    					var obj = JSON.parse(json);
    					
                    	getProjectColumn(obj.id);
            		});
            	}
        	}

            function onError(error) {
                AlertService.error(error.data.message);                	
            }
        }
        
        vm.getTasksList = function() {        	
    		History.getHistoricTask({
    			processInstanceId: vm.task.processInstanceId,
        		includeProcessVariables: true,
        		sort: 'startTime',
        		order: 'desc',
    			size: vm.size
    		}, function(result) {
                vm.tasks = result;
    		}, function() {
                AlertService.error(error.data.message);
    		});
        }
        
        function getProjectColumn(id) {
   			ProjectColumn.get({
   				projectId: id
  			}, function(result) {
  				angular.forEach(result, function(variable, key) {
		    		vm.form[variable.columnId] = {};
		 			vm.form[variable.columnId].name = variable.columnName;
		    		vm.form[variable.columnId].alias = variable.columnAlias;
		    		vm.form[variable.columnId].type = variable.columnType;

	    			if(result.length-1 == key) {
	    				getHistoricTasks();
	    				
	    				if(vm.statusForm == 'historic') {
		    				getFormHistoricTask();	    					
	    				}
	    			}
	  			});
	  		});
        }
        
        function getFormRunningTask() {
            vm.businessUnit = DynamicForm.getBusinessUnit();
            vm.loadingOutlet = false;
            vm.attachment = [];
            
            Form.get({
           		taskId: vm.taskId
           	}, onSuccess, onError);

            function onSuccess(result) {
           		vm.taskDetailed = result;
           		
           		generateFormValue(vm.taskDetailed);
            }

            function onError(error) {
                AlertService.error(error.data.message);                	
            }
        }
    	
    	function getFormHistoricTask() {
    		History.getHistoricDetail({
        		taskId: vm.taskId
        	}, function(result) {
            	vm.taskDetailed.formProperties = [];
            	
            	angular.forEach(result.data, function(detail, key) {
            		var obj = {};
            		obj.type = vm.form[detail.propertyId].type;
            		obj.name = vm.form[detail.propertyId].name;
            		obj.alias = vm.form[detail.propertyId].alias;
            		obj.value = detail.propertyValue;
            		obj.writable = false;
            		
            		vm.taskDetailed.formProperties.push(obj);
					
					if(result.data.length-1 == key) {
		           		generateFormValue(vm.taskDetailed);
					}
            	});
        	});                		
    	}
    	
    	function getHistoricTasks() {
        	History.getHistoricTask({
        		includeProcessVariables: true,
        		processInstanceId: vm.task.processInstanceId,
        		taskDeleteReasonLike: 'completed',
        		sort: 'startTime',
        		order: 'desc',
        		size: vm.size
        	}, function(result) {
        		vm.historicTasks = result;
        		
        		angular.forEach(result.data, function(historicTask, keyData) {
            		vm.historicTasks.data[keyData].formProperties = [];
                	
            		History.getHistoricDetail({
                		taskId: historicTask.id
                	}, function(result) {
                		if(result.data.length > 0) {
                        	angular.forEach(result.data, function(detail, key) {
                        		var obj = {};
                        		obj.type = vm.form[detail.propertyId].type;
                        		obj.name = vm.form[detail.propertyId].name;
                        		obj.alias = vm.form[detail.propertyId].alias;
                        		obj.value = detail.propertyValue;
                        		obj.writable = false;
                        		
                        		vm.historicTasks.data[keyData].formProperties.push(obj);
                        		
                        		if(result.data.length-1 == key) {
                	           		generateFormValue(vm.historicTasks.data[keyData]);
                        		}
                        	});
                		}  		
                	});

            		if(result.data.length-1 == keyData) {
            			History.get({
            				processInstanceId: historicTask.processInstanceId
            			}, function(result) {
            				vm.historicTasks.data.push(result);
            				
            				vm.historicTasks.data[vm.historicTasks.data.length-1].category = 'Proposal-VDO';
            				vm.historicTasks.data[vm.historicTasks.data.length-1].deleteReason = 'completed';
            				vm.historicTasks.data[vm.historicTasks.data.length-1].endTime = result.startTime;
                    		vm.historicTasks.data[vm.historicTasks.data.length-1].formProperties = [];
            				
                    		History.getHistoricDetail({
                    			processInstanceId: historicTask.processInstanceId
                        	}, function(result) {
                            	angular.forEach(result.data, function(detail, key) {
                            		var obj = {};
                            		obj.type = vm.form[detail.propertyId].type;
                            		obj.name = vm.form[detail.propertyId].name;
                            		obj.alias = vm.form[detail.propertyId].alias;
                            		obj.value = detail.propertyValue;
                            		obj.writable = false;
                            		
                            		vm.historicTasks.data[vm.historicTasks.data.length-1].formProperties.push(obj);
                            		
                            		if(result.data.length-1 == key) {
                    	           		generateFormValue(vm.historicTasks.data[vm.historicTasks.data.length-1]);
                            		}
                            	});
                        	});

            			});
            		}
        		});
        	});
    	}

        function generateFormValue(objParams) {        	
        	angular.forEach(objParams.formProperties, function(variable, keyVariable) {
        		if(variable.name == 'Approval') {
        	        vm.isApprove = true;
        	        if(variable.value == 'approve') {
            			objParams.approved = 'Approved';
            		} else {
            			objParams.approved = 'Rejected';            			
            		}
        		}
        		if(variable.type == 'boolean') {
        			if(variable.value == null) {
            			objParams.formProperties[keyVariable].value = false;
        			} else {
            			objParams.formProperties[keyVariable].value = (variable.value === 'true');        				
        			}
        		}
        		if(variable.type == 'long' || variable.type == 'double') {
        			objParams.formProperties[keyVariable].value = parseInt(variable.value);
        			idALongVariables.push(keyVariable);
        			if(isNaN(objParams.formProperties[keyVariable].value)) {
        				objParams.formProperties[keyVariable].value = null;
        			}
        		}
        		if(variable.type == 'date' && variable.value != null) {
        			variable.value = new Date(variable.value);
					objParams.formProperties[keyVariable].value = $filter('date')(variable.value, 'medium');	
        		}
        		if(variable.type == 'scea_project') {
        			if(objParams.formProperties[keyVariable].value != null) {
            			Project.get({id: objParams.formProperties[keyVariable].value}, function(result) {
            				objParams.formProperties[keyVariable].value = result.projectName;
            			});
            		}
        		}
        		if(variable.type == 'scea_file') {
        			if(variable.writable) {
            			idAttachmentFiles.push(keyVariable);
            			vm.attachment[keyVariable] = {};            				
        			}
        			if(objParams.formProperties[keyVariable].value != null) {
        				Attachment.get({id: objParams.formProperties[keyVariable].value}, function(result) {
        					objParams.formProperties[keyVariable].value = result;
        				});
        			} 
        		}
        		if(variable.type == 'scea_business_unit') {
        			indexBusinessUnit = keyVariable;
					objParams.formProperties[keyVariable].idValue = variable.value;     
        			DynamicForm.getABusinessUnit({id: variable.value}, function(result) {  
    					objParams.formProperties[keyVariable].value = result.name;        				
        			})
        		}
        		if(variable.type == 'scea_outlet') {
        			indexOutlet = keyVariable;
        			if(objParams.formProperties[keyVariable].value != null) {
    					objParams.formProperties[keyVariable].idValue = parseInt(variable.value);  
            			Outlet.get({id: objParams.formProperties[keyVariable].value}, function(result) {
            				objParams.formProperties[keyVariable].value = result.outletName;
            			});
            		}
        		}        		
        		if(vm.statusForm == 'detail') {
        			objParams.formProperties[keyVariable].writable = false;
        		}
        	});
        }
        
        function userValidation() {
        	Task.get({taskId: $stateParams.id}, function(result) {
            	var category = result.category;
				var strings = category.split('-');
				var role = strings[1];
	    		
	            Principal.identity().then(function(account) {
	            	var isValid = false;
	            	for(var i=0; i<account.authorities.length; i++) {
	            		if(account.authorities[i] == role) {
	            			isValid = true;
	            			getFormRunningTask();
	            			break;
	            		}
	            		if(account.authorities.length-1 == i && isValid == false){
	                        $state.go('task-detail', { id: vm.taskId, status: 'detail' });
	            		}
	            	}
	            });
        	});
        }
        
        function getOutlet(value) {
        	vm.loadingOutlet = true;
            return OutletSearch.query({
                query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingOutlet = false;
                return response;
            }, function(response){
            	vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        }
        
        vm.closeProject = function() {
        	ProcessInstance.deleteProcessInstance({
        		processInstanceId: vm.task.processInstanceId
        	}, function(result) {
                $state.go('task');
        	});
        }
        
        vm.setContent = function ($file, attachment) {
            if($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        attachment.content = base64Data;
                        attachment.name = $file.name;
                        attachment.size = $file.size;
                        attachment.contentContentType = $file.type;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        
        vm.openDatePicker = function(obj) {
            obj.opened = true;
        };
        
        vm.download = function(file) {
        	if(file.id != null) {
        		Attachment.download({id: file.id});
        	}
        }
       
        vm.calculate = function(index) {
        	var obj = {};
        	if(vm.taskDetailed.formProperties[indexBusinessUnit].value != null) {
            	obj.bizUnitId = parseInt(vm.taskDetailed.formProperties[indexBusinessUnit].idValue);
            	
            	if(vm.taskDetailed.formProperties[indexOutlet].value != null) {
            		obj.outletId = vm.taskDetailed.formProperties[indexOutlet].idValue;
            		
                	obj.fieldName = vm.taskDetailed.formProperties[index].id;
                	obj.variables = {};

                	angular.forEach(idALongVariables, function(idALongVariable, key) {
                		var property = vm.taskDetailed.formProperties[idALongVariable].id;
                		var value = vm.taskDetailed.formProperties[idALongVariable].value;
                		
                		obj.variables[property] = value;

                		if(idALongVariables.length-1 == key) {
                			DynamicForm.calculateFormula(obj, function(result) {
                        		vm.taskDetailed.formProperties[index].value = result.value;
                        	});
                		}
                	});
            	} else {
                    AlertService.error('Store is empty');
            	}
        	} else {
                AlertService.error('Business Unit is empty');
        	}
        }
        
        vm.save = function(params) {
        	vm.isSaving = true;
        	
        	if(idAttachmentFiles.length == 0) {
    			submitTask(params);        		
        	} else {
	        	angular.forEach(idAttachmentFiles, function(idAttachmentFile, key) {        		
	        		if(vm.attachment[idAttachmentFile].content != null) {
			        	var obj = {};
			        	obj.content = vm.attachment[idAttachmentFile].content;
			        	obj.fileName = vm.attachment[idAttachmentFile].name;
			        	obj.contentContentType = vm.attachment[idAttachmentFile].contentContentType;
			        	obj.creationDate = new Date();
			        	obj.size = vm.attachment[idAttachmentFile].size;
			        	
			        	Attachment.upload(obj, function(result) {
			        		setAttachmentFile(result, key);
			        	});
	        		}
	        	});
        	}
        	
        	function setAttachmentFile(obj, key) {
        		var id = idAttachmentFiles[key];
				vm.taskDetailed.formProperties[id].value = obj;
				
				if(idAttachmentFiles.length-1 == key) {
        			submitTask(params);
        		}
        	}
        };
        
        var submitTask = function(params) {
            var obj = {};
            obj.variables = [];
            
            angular.forEach(vm.taskDetailed.formProperties, function(variable, key) {
        		if(variable.writable == true){
                var property = {}
                property = variable;

        		if(variable.type == 'scea_outlet' && variable.value != null) {
        			property.value = variable.value.id;
        		}
        		if(variable.type == 'date' && variable.value != null) {
        			property.value = $filter('date')(variable.value, variable.datePattern);
        		}
        		if(variable.type == 'scea_file' && variable.value == null) {
        			var file = vm.attachment[key];

		        	var files = {};
		        	files.content = file.content;
		        	files.fileName = file.name;
		        	files.contentContentType = file.contentContentType;
		        	files.creationDate = new Date();
		        	files.size = file.size;
		        	
		        	Attachment.upload(files, function(result) {
	        			property.value = result.id;
		        	});
        		}
        		if(variable.type == 'scea_file' && variable.value != null) {
        			property.value = variable.value.id;
        		}
        		if(variable.name == 'Approval') {
        			property.value = params;
        		}
        		
        		obj.variables.push(property);
        		}
        		if(vm.taskDetailed.formProperties.length-1 == key) {
        			generateWritable(obj.variables);
        		}
        	});
            
        	function generateWritable(variables) {
        		var obj = {};
        		
        		obj.taskId = vm.taskId;
        		obj.properties = [];

            	angular.forEach(variables, function(variable, key) {
            		if(variable.writable == true){
            			obj.properties.push(variable);
            		}
            		
            		if(variables.length-1 == key) {
            			Form.save(obj, onSaveSuccess, onSaveError);
            		}
            	});
        	}
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:taskUpdate', result);
            vm.isSaving = false;
            $state.go('task', null, { reload: true });
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
		
		vm.splitCategory = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[0];
			}
		};
		
		vm.splitCandidate = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[1];
			}
		};
		
		vm.getVariableValue = function(obj, params) {
			var result = '';
			angular.forEach(obj, function(value, key) {
				if(params == value.name) {
					if(params == 'project') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.projectName;
					} else if(params == 'business_unit') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.name;
					} else if(params == 'store') {
						var store = JSON.parse(value.value);
						result = store.outletName;
					} else {
						result = value.value;
					}
				}
			});
			return result;
		};
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task', {
            parent: 'merchandiser-activity',
            url: '/merchandiser-activity/store-completion/tasks',
            data: {
                authorities: ['ROLE_ADMIN', 'SPV', 'VDO'],
                pageTitle: 'sceaApp.tasks.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/merchandiser-activity/task/tasks.html',
                    controller: 'TasksController',
                    controllerAs: 'vm'
                },
                'inbox@task': {
                    templateUrl: 'app/merchandiser-activity/task/inbox.html',
                    controller: 'InboxController',
                    controllerAs: 'vm'
                },
                'allTasks@task': {
                    templateUrl: 'app/merchandiser-activity/task/alltasks.html',
                    controller: 'AllTasksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('task');
                	$translatePartialLoader.addPart('attachment');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-detail', {
            parent: 'merchandiser-activity',
            url: '/merchandiser-activity/store-completion/task/{id}/{status}',
            data: {
                authorities: ['ROLE_ADMIN', 'SPV', 'VDO'],
                pageTitle: 'sceaApp.task.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/merchandiser-activity/task/task-detail.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                	$translatePartialLoader.addPart('attachment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Task', function($stateParams, Task) {
                	if($stateParams.status != 'historic'){
                		return Task.get({taskId: $stateParams.id});
                	} else {
                		return null;
                	}
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TasksController', TasksController);

    TasksController.$inject = ['$scope', '$state'];

    function TasksController ($scope, $state) {
        var vm = this;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InboxController', InboxController);

    InboxController.$inject = ['$scope', '$state', 'AlertService', 'Principal', 'SceaProcessInstance'];

    function InboxController($scope, $state, AlertService, Principal, SceaProcessInstance) {
        var vm = this;
        vm.inboxTasks = [];
        vm.page = 1;
        vm.size = 20;
        vm.start = 0;
		
        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] != 'ROLE_ADMIN') {
            			vm.role = account.authorities[i];
            			if(vm.role == 'VDO') {
            				getProjectId(vm.role);
            			} else {
                			getRuntimeTasks(vm.role, null);            				
            			}
            			break;
            		}
            	}
            });
        };
        getAccount();

        var getProjectId = function(role) {
        	var ids = '';
        	SceaProcessInstance.getProcessInstance(function(result) {
        		angular.forEach(result.data, function(project, key) {
            		if(key != 0) {
            			ids += ',';
            		}
        			ids += project.processInstanceId;
        			
            		if(result.data.length-1 == key) {
            			getRuntimeTasks(role, ids);
            		}
        		});
        	});
        }
        
        var getRuntimeTasks = function(role, projectId) {
        	if(vm.inboxTasks.size != null) {
        		vm.start = parseInt(vm.page) * parseInt(vm.tasks.size) - parseInt(vm.tasks.size);
        	}

			if(projectId == null) {
				SceaProcessInstance.getRuntimeTask({
	        		includeProcessVariables: true,
	        		candidateGroup: role,
	    			start: vm.start,
	    			size: vm.size
		    	}, onSuccess, onError);
			} else {
				SceaProcessInstance.getRuntimeTask({
	        		includeProcessVariables: true,
	        		processInstanceIds: projectId,
	    			start: vm.start,
	    			size: vm.size
		    	}, onSuccess, onError);				
			}

            function onSuccess(data) {
                vm.totalItems = data.total;
                vm.queryCount = vm.totalItems;
                vm.inboxTasks = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
		};
		
		vm.splitCategory = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[0];
			}
		};
		
		vm.splitCandidate = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[1];
			}
		};
		
		vm.getVariableValue = function(obj, params) {
			var result = '';
			angular.forEach(obj, function(value, key) {
				if(params == value.name) {
					if(params == 'project') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.projectName;
					} else if(params == 'business_unit') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.name;
					} else if(params == 'store') {
						var store = JSON.parse(value.value);
						result = store.outletName;
					} else {
						result = value.value;
					}
				}
			});
			return result;
		};
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AllTasksController', AllTasksController);

    AllTasksController.$inject = ['$scope', '$state', 'AlertService', 'Principal', 'SceaProcessInstance', 'UserGroup'];

    function AllTasksController ($scope, $state, AlertService, Principal, SceaProcessInstance, UserGroup) {
        var vm = this;
        vm.role = null;
    	vm.projectIds = null;
        vm.tasks = [];
        vm.isInvolvement = true;
        vm.isMoreFilter = true;
        vm.filter = {
        	assignedToMe: true,
        	assignedToOthers: true,
        	assignee: null,
        	completed: false,
        }
		vm.others = '';
        vm.page = 1;
        vm.size = 20;
        vm.start = 0;
        vm.loadAll = loadAll;
		
        function getAccount() {
            Principal.identity().then(function(account) {
            	for(var i=0; i<account.authorities.length; i++) {
            		if(account.authorities[i] != 'ROLE_ADMIN') {
            			vm.role = account.authorities[i];
            			setOthers(account.authorities[i]);
            			
            			if(vm.role == 'VDO') {
            				setProjectId();
            			} else {
            		        vm.loadAll();
            			}
            			break;
            		}
            	}
            });
        };
        getAccount();
        
        function setOthers(myRole) {
        	vm.roles = UserGroup.query(function(result) {
	        	angular.forEach(result, function(role, key) {
	        		if(role.name != 'ROLE_ADMIN' && role.name != myRole) {
	        			vm.others = vm.others.concat(role.name);
		        		if(result.length-1 != key) {
		        			vm.others = vm.others.concat(',');
		        		}
	        		}
	        	})
	        });
        }

        var setProjectId = function() {
        	vm.projectIds = '';
        	SceaProcessInstance.getProcessInstance(function(result) {
        		angular.forEach(result.data, function(project, key) {
            		if(key != 0) {
            			vm.projectIds += ',';
            		}
            		vm.projectIds += project.processInstanceId;
        			
            		if(result.data.length-1 == key) {
        		        vm.loadAll();
            		}
        		});
        	});
        }
        
        function loadAll() {
        	if(vm.tasks.size != null) {
        		vm.start = parseInt(vm.page) * parseInt(vm.tasks.size) - parseInt(vm.tasks.size);
        	}

			if(vm.projectIds == null) {
	        	if(vm.isInvolvement){
	        		vm.isHistoric = false;
	        		
	            	if(vm.filter.assignedToMe && vm.filter.assignedToOthers) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else if(vm.filter.assignedToMe) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	            			candidateGroup: vm.role,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else if(vm.filter.assignedToOthers) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	            			candidateGroups: vm.others,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	            		vm.tasks = [];
	                    vm.totalItems = 0;
	            	}        		
	        	}
	        	if(vm.isAssignment){
	        		vm.isHistoric = false;
	        		
	        		if(vm.filter.assignee != null) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	            			candidateGroup: vm.filter.assignee,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	}
	        	}
	        	if(vm.isMoreFilter){
	        		if(vm.filter.completed) {
	            		vm.isHistoric = true;
	            		
	    				SceaProcessInstance.getHistoricTask({
	    	        		includeProcessVariables: true,
	                		taskDeleteReasonLike: 'completed',
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	            		vm.isHistoric = false;
	            		
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	}
	        	}
			} else {
	        	if(vm.isInvolvement){
	        		vm.isHistoric = false;
	        		
	            	if(vm.filter.assignedToMe && vm.filter.assignedToOthers) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else if(vm.filter.assignedToMe) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	            			candidateGroup: vm.role,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else if(vm.filter.assignedToOthers) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	            			candidateGroups: vm.others,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	            		vm.tasks = [];
	                    vm.totalItems = 0;
	            	}        		
	        	}
	        	if(vm.isAssignment){
	        		vm.isHistoric = false;
	        		
	        		if(vm.filter.assignee != null) {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	            			candidateGroup: vm.filter.assignee,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	}
	        	}
	        	if(vm.isMoreFilter){
	        		if(vm.filter.completed) {
	            		vm.isHistoric = true;
	            		
	    				SceaProcessInstance.getHistoricTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	                		taskDeleteReasonLike: 'completed',
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	} else {
	            		vm.isHistoric = false;
	            		
	    				SceaProcessInstance.getRuntimeTask({
	    	        		includeProcessVariables: true,
	    	        		processInstanceIds: vm.projectIds,
	    	    			start: vm.start,
	    	    			size: vm.size
	    		    	}, onSuccess, onError);
	            	}
	        	}
			}
        	
            function onSuccess(data) {
                vm.totalItems = data.total;
                vm.queryCount = vm.totalItems;
                vm.tasks = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.updateFilter = function(){
            vm.page = 1;
            vm.size = 20;
            vm.start = 0;
            vm.totalItems = 0;
            vm.queryCount = 0;
            loadAll();
        }
		
		vm.splitCategory = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[0];
			}
		};
		
		vm.splitCandidate = function(input) {
			if(input == null) return '';
			else {
				var string = input.split('-');
				return string[1];
			}
		};
		
		vm.getVariableValue = function(obj, params) {
			var result = '';
			angular.forEach(obj, function(value, key) {
				if(params == value.name) {
					if(params == 'project') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.projectName;
					} else if(params == 'business_unit') {
						var businessUnit = JSON.parse(value.value);
						result = businessUnit.name;
					} else if(params == 'store') {
						var store = JSON.parse(value.value);
						result = store.outletName;
					} else {
						result = value.value;
					}
				}
			});
			return result;
		};
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectListDialogController', ProjectListDialogController)   
        .directive('dynamicForm', function () {
		    return {
		        restrict: 'E',
		        templateUrl: "app/layouts/dynamic-form/dynamic-form.html"
		    };
		})
    	.directive('format', ['$filter', function ($filter) {
		    return {
		        require: '?ngModel',
		        link: function (scope, elem, attrs, ctrl) {
		            if (!ctrl) return;
		
		            ctrl.$formatters.unshift(function (a) {
		                return $filter(attrs.format)(ctrl.$modelValue)
		            });
		            
		            ctrl.$parsers.unshift(function (viewValue) {
		                var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
		                elem.val($filter(attrs.format)(plainNumber));
		                return plainNumber;
		            });
	            }
	        };
	    }]);

    ProjectListDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$filter', 'orderByFilter',
                                           'AlertService', 'Attachment', 'DataUtils', 'DynamicForm', 'Form', 'OutletSearch', 'Project', 'SceaProcessInstance'];

    function ProjectListDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance, $filter, orderByFilter,
    		AlertService, Attachment, DataUtils, DynamicForm, Form, OutletSearch, Project, SceaProcessInstance) {
        var vm = this;
        Project.query(function(result) {
        	vm.projects = orderByFilter(result, 'id', false);
        });
        vm.getOutlet = getOutlet;
        
        var idAttachmentFiles = [];
        var idALongVariables = [];        
        var indexBusinessUnit = 0;
        var indexOutlet = 0;
        
        vm.generateForm = function(project) {
        	vm.project = project;
            vm.businessUnit = DynamicForm.getBusinessUnit();
            vm.loadingOutlet = false;
            vm.attachment = [];
            
            if(project.processDefinitionId != null) {
	            vm.taskDetailed = Form.get({processDefinitionId : project.processDefinitionId}, 
	            	function(result) {
	            	angular.forEach(result.formProperties, function(variable, key) {
	            		if(variable.type == 'scea_file') {
	            			idAttachmentFiles.push(key);
	            			vm.attachment[key] = {};
	            		}
	            		if(variable.type == 'long') {
	            			idALongVariables.push(key);
	            		}
	            		if(variable.type == 'scea_business_unit') {
	            			indexBusinessUnit = key;
	            		}
	            		if(variable.type == 'scea_outlet') {
	            			indexOutlet = key;
	            		}
	            		if(variable.type == 'scea_project') {
	            			vm.taskDetailed.formProperties[key].value = project.id;
	            		}
	            	});
	            });
            } else {
            	vm.taskDetailed = [];
                idAttachmentFiles = [];
                idALongVariables = [];        
                indexBusinessUnit = 0;
                indexOutlet = 0;
            }
        }
        
        function getOutlet(value) {
        	vm.loadingOutlet = true;
            return OutletSearch.query({
                query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingOutlet = false;
                return response;
            }, function(response){
            	vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        }
        
        vm.setContent = function ($file, attachment) {
            if($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        attachment.content = base64Data;
                        attachment.name = $file.name;
                        attachment.size = $file.size;
                        attachment.contentContentType = $file.type;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        
        vm.openDatePicker = function(obj) {
            obj.opened = true;
        };
        
        vm.calculate = function(index) {
        	var obj = {};
        	if(vm.taskDetailed.formProperties[indexBusinessUnit].value != null) {
            	obj.bizUnitId = parseInt(vm.taskDetailed.formProperties[indexBusinessUnit].value);
            	
            	if(vm.taskDetailed.formProperties[indexOutlet].value != null) {
            		obj.outletId = vm.taskDetailed.formProperties[indexOutlet].value.id;
            		
                	obj.fieldName = vm.taskDetailed.formProperties[index].id;
                	obj.variables = {};

                	angular.forEach(idALongVariables, function(idALongVariable, key) {
                		var property = vm.taskDetailed.formProperties[idALongVariable].id;
                		var value = vm.taskDetailed.formProperties[idALongVariable].value;
                		
                		obj.variables[property] = value;

                		if(idALongVariables.length-1 == key) {
                			DynamicForm.calculateFormula(obj, function(result) {
                        		vm.taskDetailed.formProperties[index].value = result.value;
                        	});
                		}
                	});
            	} else {
                    AlertService.error('Store is empty');
            	}
        	} else {
                AlertService.error('Business Unit is empty');
        	}
        }
        
        vm.save = function() {
        	vm.isSaving = true;
        	
        	angular.forEach(idAttachmentFiles, function(idAttachmentFile, key) {        		
        		if(vm.attachment[idAttachmentFile] != null) {
		        	var obj = {};
		        	obj.content = vm.attachment[idAttachmentFile].content;
		        	obj.fileName = vm.attachment[idAttachmentFile].name;
		        	obj.contentContentType = vm.attachment[idAttachmentFile].contentContentType;
		        	obj.creationDate = new Date();
		        	obj.size = vm.attachment[idAttachmentFile].size;
		        	
		        	Attachment.upload(obj, function(result) {
		        		setAttachmentFile(result, key);
		        	});
        		}
        	});
        	
        	function setAttachmentFile(obj, key) {
        		var id = idAttachmentFiles[key];
				vm.taskDetailed.formProperties[id].value = obj.id;
				
				if(idAttachmentFiles.length-1 == key) {
        			startProcessInstance();
        		}
        	}
        };
        
        var startProcessInstance = function () {
            var obj = {};
            obj.processDefinitionId = vm.project.processDefinitionId;
            obj.businessKey = vm.project.projectName;
            obj.properties = [];
            
            angular.forEach(vm.taskDetailed.formProperties, function(variable, key) {
                var property = {}
                property = variable;
                
        		if(variable.type == 'scea_outlet' && variable.value != null) {
        			property.value = variable.value.id;
        		}
        		if(variable.type == 'date' && variable.value != null) {
        			property.value = $filter('date')(variable.value, variable.datePattern);
        		}
        		if(variable.type == 'long' && variable.value != null) {
        			property.value = parseInt(variable.value);
        		}
        		
        		obj.properties.push(property);
        		
        		if(vm.taskDetailed.formProperties.length-1 == key) {
        			SceaProcessInstance.submitForm(obj, onSaveSuccess, onSaveError);
        		}
        	});
        };

        var onSaveSuccess = function (result) {
            vm.isSaving = false;
            $scope.$emit('sceaApp:projectListUpdate', result);
            $uibModalInstance.close(result);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-list', {
            parent: 'merchandiser-activity',
            url: '/merchandiser-activity/store-completion/project-list',
            data: {
                authorities: ['ROLE_ADMIN', 'SPV', 'VDO'],
                pageTitle: 'sceaApp.projectList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/merchandiser-activity/project-list/projects.html',
                    controller: 'ProjectsController',
                    controllerAs: 'vm'
                },
	            'project-list@project-list': {
	                templateUrl: 'app/merchandiser-activity/project-list/project-lists.html'
	            },
	            'columns@project-list': {
	                templateUrl: 'app/merchandiser-activity/project-list/columns.html'
	            }
	        },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('projectList');
                	$translatePartialLoader.addPart('attachment');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-list.new', {
            parent: 'project-list',
            url: '/new-project',
            data: {
                authorities: ['ROLE_ADMIN', 'VDO', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/merchandiser-activity/project-list/project-list-dialog.html',
                    controller: 'ProjectListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function() {
                    $state.go('project-list', null, { reload: true });
                }, function() {
                    $state.go('project-list');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectsController', ProjectController);

    ProjectController.$inject = ['$filter', '$scope', '$state', '$uibModal',
                                 'AlertService', 'Attachment', 'orderByFilter', 'ProcessInstance', 'Project', 'ProjectColumn', 'SceaProcessInstance'];

    function ProjectController ($filter, $scope, $state, $uibModal, 
    		AlertService, Attachment, orderByFilter, ProcessInstance, Project, ProjectColumn, SceaProcessInstance) {
        var vm = this;
        vm.variables = [];
        vm.project = null;
        vm.instancesList = [];
        vm.historicInstancesList = [];
        vm.pageRunning = 1;
        vm.sizeRunning = 20;
        vm.startRunning = 0;
        vm.pageHistoric = 1;
        vm.sizeHistoric = 20;
        vm.startHistoric = 0;
        vm.isHistoric = false;
    	vm.inputVariable = null;
        vm.removedVariables = [];
		vm.models = {
			selected : null,
			lists : []
		}
        
        Project.query(function(result) {
            vm.projects = orderByFilter(result, 'id', false);
        	vm.project = vm.projects[0];
        	vm.updateProject(vm.project);
        });
        
        vm.updateProject = function(project) {
        	if(project != null) {
        		if(project.processDefinitionId != null) {
                	var key = project.projectName;
                	if(!vm.isHistoric) {
                		vm.loadRunning();
                	} else {
                		vm.loadHistoric();
                    }
                	
	                vm.removedVariables = [];
	                vm.models.lists = [];

        			ProjectColumn.get({
        				projectId: project.id
        			}, function(result) {
    					var resultOrder = orderByFilter(result, 'sequence', false);
    					
    					angular.forEach(resultOrder, function(variable) {
    						if(variable.active) {
			    	        	vm.models.lists.push(variable);
    						} else {
    							vm.removedVariables.push(variable);
    						}
    					});
        			});
	        	} else {
	                vm.removedVariables = [];
	                vm.models.lists = [];
	        		vm.clear();
	        	}
        	}
        };
        
        function loadAll() {
        	if(!vm.isHistoric) {
            	if(vm.instancesList.size != null) {
            		vm.startRunning = parseInt(vm.pageRunning) * parseInt(vm.instancesList.size) - parseInt(vm.instancesList.size);
            	}

            	SceaProcessInstance.getProcessInstance({
            		businessKey: vm.project.projectName,
            		start: vm.startRunning,
            		size: vm.sizeRunning
            	}, onSuccess, onError);
        	}
        	if(vm.isHistoric) {
            	if(vm.historicInstancesList.size != null) {
            		vm.startHistoric = parseInt(vm.pageHistoric) * parseInt(vm.historicInstancesList.size) - parseInt(vm.historicInstancesList.size);
            	}

            	SceaProcessInstance.getHistoricProcessInstance({
            		businessKey: vm.project.projectName,
            		start: vm.startRunning,
            		size: vm.sizeRunning
            	}, onSuccess, onError);
        	}
        	
        	function onSuccess(result) {                
            	if(!vm.isHistoric) {
                    vm.totalItemsRunning = result.total;
                    vm.queryCountRunning = vm.totalItemsRunning;
        			vm.instancesList = result;
        			
	        		angular.forEach(vm.instancesList.data, function(runningTask, keyData) {
			        	parseData(vm.instancesList.data[keyData]);
		        	});            		
            	}
            	if(vm.isHistoric) {
                    vm.totalItemsHistoric = result.total;
                    vm.queryCountHistoric = vm.totalItemsHistoric;
        			vm.historicInstancesList = result;
        			
	        		angular.forEach(vm.historicInstancesList.data, function(historicTask, keyData) {
			        	parseData(vm.historicInstancesList.data[keyData]);
		        	});
            	}
        	}

            function onError(error) {
                AlertService.error(error.data.message);                	
            }
            
            function parseData(objParams) {    			
            	angular.forEach(objParams.variables, function(variable, keyVariable) {
    				if(variable.type == 'date') {
    					variable.value = $filter('date')(variable.value, 'medium');								
    				}
    				if(variable.type == 'scea_business_unit' || variable.type == 'scea_outlet' || 
    						variable.type == 'scea_project' || variable.type == 'scea_file') {

    					var strings = variable.value;
    					var json = JSON.stringify(eval("(" + strings + ")"));
    					var obj = JSON.parse(json);
    					
    					if(variable.type == 'scea_business_unit') {
    						objParams.variables[keyVariable].value = obj.name;
    					}
    					if(variable.type == 'scea_outlet') {
    						objParams.variables[keyVariable].value = obj.outletName;
    					}
    					if(variable.type == 'scea_project') {
    						objParams.variables[keyVariable].value = obj.projectName;
    					}
    					if(variable.type == 'scea_file') {
    						objParams.variables[keyVariable].value = obj;
    					}
    				}
    				if(vm.isHistoric) {
    					objParams.variables[keyVariable].writable = false;					
    				}
        		});
            }
        }
        
        vm.clear = function() {
            vm.instancesList = [];
            vm.historicInstancesList = [];  
            vm.pageRunning = 1;
            vm.sizeRunning = 20;
            vm.startRunning = 0;
            vm.pageHistoric = 1;
            vm.sizeHistoric = 20;
            vm.startHistoric = 0;  	            	
        }
        
        vm.loadRunning = function() {
            if(vm.project != null) {
        		if(vm.project.processDefinitionId != null) {
		        	vm.isHistoric = false;
		        	vm.clear();
		        	loadAll();
        		}
        	}
        }
        
        vm.loadHistoric = function() {
            if(vm.project != null) {
        		if(vm.project.processDefinitionId != null) {
		        	vm.isHistoric = true;
		        	vm.clear();
		        	loadAll();
        		}
    		}
        }

    	vm.downloadFile = function(file) {
        	Attachment.download({id: file.id});        		
    	}
    	
    	vm.openDiagram = function(data) {
    		ProcessInstance.getDiagram({ 
    			processInstanceId: data.id 
    		}, function(result) {
				var modalInstance = $uibModal.open({
                    templateUrl: 'app/merchandiser-activity/project-list/diagram-dialog.html',
                    controller: 'DiagramDialogController',
                    controllerAs: 'vm',
					size : 'lg',
					resolve : {
						diagram : function() {
							return result.blob;
						}
					}
				});
    		});
    	}
		
        vm.addInputVariable = function(variable) {
			if(variable != null) {
				addVariable(variable.columnAlias);
		        vm.inputVariable = '';
			}
        }

		vm.exportExcel = function() {
			var modalInstance = $uibModal.open({
                templateUrl: 'app/merchandiser-activity/project-list/export-dialog.html',
                controller: 'ExportDialogController',
				controllerAs: 'vm',
				size: 'md',
				resolve: {
					isHistoric: function() {
						return vm.isHistoric;
					},
					project: function() {
						return vm.project;
					}
				}
			});
    	}
        
		$scope.$watch('vm.inputVariable', function(newVariable, oldVariable) {
			if(newVariable != null && newVariable != '' && newVariable != oldVariable) {
				addVariable(newVariable);
		        vm.inputVariable = '';
			}
		}, true);
        
        function addVariable(variable) {
        	for(var i=0; i<vm.removedVariables.length; i++) {
        		if(vm.removedVariables[i].columnAlias == variable) {
                	var obj = vm.removedVariables[i];
                	obj.active = true;
                	obj.sequence = vm.models.lists.length+1;
                	
                	ProjectColumn.update(obj);
                	
        			vm.models.lists.push(vm.removedVariables[i]);
        			vm.removedVariables.splice(i, 1);
        			break;
        		}
        	}
        }
        
        vm.removeColumn = function(index) {
        	var obj = vm.models.lists[index];
        	obj.active = false;
        	obj.sequence = 0;
        	
        	ProjectColumn.update(obj);
        	
	        vm.removedVariables.push(vm.models.lists[index]);
        	vm.models.lists.splice(index, 1);
        	
        	updateSequence();
        }
        
        vm.moveColumn = function(index) {        	
        	vm.models.lists.splice(index, 1);
        	updateSequence();
        }
        
        vm.updateAlias = function(index) {
        	vm.isDisabledAlias[index] = true;
        	
        	var obj = vm.models.lists[index];
        	if(obj.columnAlias == null || obj.columnAlias == '') {
        		obj.columnAlias = obj.columnName;
        	}
        	
        	ProjectColumn.update(obj);
        }
        
        function updateSequence() {        	
        	angular.forEach(vm.models.lists, function(column, key) {
            	vm.isDisabledAlias[key] = true;
            	
            	var obj = vm.models.lists[key];
            	obj.sequence = key+1;
        		
            	ProjectColumn.update(obj);
        	});        	
        }
		
		$scope.$watch('vm.models', function(model) {
			vm.variables = model.lists;
		}, true);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ExportDialogController', ExportDialogController);

    ExportDialogController.$inject = ['$filter', '$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'ExcelReport', 'isHistoric', 'orderByFilter', 'Project', 'project'];

    function ExportDialogController ($filter, $timeout, $scope, $state, $stateParams, $uibModalInstance, ExcelReport, isHistoric, orderByFilter, Project, project) {
        var vm = this;
        var projectMap = {};
    	vm.project = project.id.toString();
        vm.isHistoric = isHistoric.toString();
        vm.date = {
        	from: null,
        	to: null	
        }
        Project.query(function(result) {
            vm.projects = orderByFilter(result, 'id', false);
        	angular.forEach(result, function(project) {
        		projectMap[project.id] = {};
        		projectMap[project.id].name = project.projectName;
        	})
        });
        
        vm.save = function() {
        	vm.isSaving = true;
        	
        	var obj = {};
        	if(vm.project != 'allProject') {
            	obj.allProjects = false;
            	obj.businessKey = projectMap[vm.project].name;
            	obj.projectId = parseInt(vm.project);  
        	} else {
            	obj.allProjects = true;    		
        	}
        	obj.isHistoric = vm.isHistoric;
        	obj.startTimeFrom = $filter('date')(vm.date.from, 'yyyy-MM-dd');
        	obj.startTimeTo = $filter('date')(vm.date.to, 'yyyy-MM-dd');
        	
        	ExcelReport.exportProjectList(obj, onSaveSuccess, onSaveError);
        };

        var onSaveSuccess = function (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DiagramDialogController', DiagramDialogController);

    DiagramDialogController.$inject = ['$scope', 'diagram', 'DataUtils'];

    function DiagramDialogController ($scope, diagram, DataUtils) {
        var vm = this;

        function init() {	
        	DataUtils.toBase64(diagram, function(base64Data) {
        		$scope.$apply(function() {
        			vm.diagram = base64Data;
        		});
        	});   	
        }
        init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletEmployeeDialogController', OutletEmployeeDialogController);

    OutletEmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModal', '$uibModalInstance', 'entity', 'employee', 'Outlet', 'Employee', 'VisitCycle'];

    function OutletEmployeeDialogController($timeout, $scope, $stateParams, $uibModal, $uibModalInstance, entity, employee, Outlet, Employee, VisitCycle) {
        var vm = this;
        var modalLoading;
        vm.outlet = entity;
    	vm.employee = employee;
        vm.visitcycles = VisitCycle.query();
        
        employee.$promise.then(function(data) {
            vm.employees = Employee.query({
            	role: 'VDE', 
            	managerId: data.managerId
            });
        });
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:outletUpdate', result);
            modalLoading.dismiss('cancel');
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            modalLoading.dismiss('cancel');
            vm.isSaving = false;
        };

        vm.updateEmployee = function(employee) {
        	vm.outlet.employeeId = employee.id;
        	vm.outlet.employeeName = employee.firstName;
        }
        
        vm.save = function () {
        	openModal();
            vm.isSaving = true;
            if (vm.outlet.id !== null) {
                Outlet.update(vm.outlet, onSaveSuccess, onSaveError);
            } else {
                Outlet.save(vm.outlet, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function openModal() {
            modalLoading = $uibModal.open({
                animation: true,
            	templateUrl: 'app/merchandiser-activity/outlet-employee/loading-dialog.html',
                backdrop: 'static',
            	size: 'sm'
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletEmployeeDetailController', OutletEmployeeDetailController);

    OutletEmployeeDetailController.$inject = ['$rootScope', '$scope', '$state', '$uibModalInstance', '$stateParams', 'calendarId', 'vde', 'Outlet', 'VDETaskPlanning'];

    function OutletEmployeeDetailController($rootScope, $scope, $state, $uibModalInstance, $stateParams, calendarId, vde, Outlet, VDETaskPlanning) {
        var vm = this;
        vm.calendarId = calendarId;
        vm.vde = vde;
        vm.outletsByEmployee = [];
        
		$rootScope.$watch('vdo', function(vdo) {
			if(vdo != null) {
		        vm.outletsByEmployee = Outlet.queryByEmployee({id: vdo.id});
			}
		});
        
        var unsubscribe = $rootScope.$on('sceaApp:outletUpdate', function(event, result) {
            vm.outlet = result;
        });
        $scope.$on('$destroy', unsubscribe);
        
        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:vDETaskPlanningUpdate', result);
            $uibModalInstance.close(result);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.addOutlet = function (outlet) {
            var vdeTaskPlanning = {
            	calendarId: vm.calendarId,
            	employeeId: vm.vde.id,
            	outletCode: outlet.outletCode,
            	outletId: outlet.id,
            	outletName: outlet.outletName,
            	recommendation: false,
            	storeGrade: outlet.visitCycleStoreGrade,
            	visited: false
            };
            
            VDETaskPlanning.save(vdeTaskPlanning, onSaveSuccess, onSaveError);
        };
        
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletEmployeeDeleteController',OutletEmployeeDeleteController);

    OutletEmployeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Outlet'];

    function OutletEmployeeDeleteController($uibModalInstance, entity, Outlet) {
        var vm = this;
        vm.outlet = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Outlet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Outlet', Outlet);

    Outlet.$inject = ['$resource'];

    function Outlet ($resource) {
        var resourceUrl =  'api/outlets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByEmployee': { 
            	method: 'GET', 
            	isArray: true,
            	url: 'api/outlets/employees/:id'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletEmployeeController', OutletEmployeeController);

    OutletEmployeeController.$inject = ['$rootScope', '$scope', '$state', '$uibModal', 'Outlet'];

    function OutletEmployeeController ($rootScope, $scope, $state, $uibModal, Outlet) {
        var vm = this;
        vm.outletsByEmployee = [];
        
		$rootScope.$watch('vdo', function(vdo) {
			if(vdo != null) {
		        vm.outletsByEmployee = Outlet.queryByEmployee({id: vdo.id});
			}
		});
		
        vm.openInfoDialog = function() {
            var modalInstance = $uibModal.open({
            	animation: $scope.animationsEnabled,
            	templateUrl: 'app/system-administration/visit-cycle/visit-cycle-info-dialog.html',
            	controller: 'VisitCycleInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: "sm",
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    mainTranslatePartialLoader: ['$stateParams', '$translate', '$translatePartialLoader', 
                        function ($stateParams, $translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('visitCycle');
                        return $translate.refresh();
                    }]
                }
            });

            modalInstance.result.then(function() {
                $state.go('^');
            });   	
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobDialogController', OtherJobDialogController);

    OtherJobDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TFileImageOtherJob', 'OtherJob'];

    function OtherJobDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TFileImageOtherJob, OtherJob) {
        var vm = this;
        vm.otherJob = entity;

        if(vm.otherJob.$promise) {
        	vm.otherJob.$promise.then(function(data) {
        		TFileImageOtherJob.query({
        			formNo: data.formNo
        		}, function(data) {
        			vm.images = data;
        			vm.image = data[0];
        		});
        	});
        }
        
        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:otherJobUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function (status) {
            vm.isSaving = true;
            
            vm.otherJob.status = status;
            
            if (vm.otherJob.id !== null) {
                OtherJob.update(vm.otherJob, onSaveSuccess, onSaveError);
            } else {
                OtherJob.save(vm.otherJob, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobDetailController', OtherJobDetailController);

    OtherJobDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OtherJob', 'TicketOrder', 'Outlet', 'OtherJobType'];

    function OtherJobDetailController($scope, $rootScope, $stateParams, entity, OtherJob, TicketOrder, Outlet, OtherJobType) {
        var vm = this;
        vm.otherJob = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:otherJobUpdate', function(event, result) {
            vm.otherJob = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobDeleteController',OtherJobDeleteController);

    OtherJobDeleteController.$inject = ['$uibModalInstance', 'entity', 'OtherJob'];

    function OtherJobDeleteController($uibModalInstance, entity, OtherJob) {
        var vm = this;
        vm.otherJob = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OtherJob.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('other-job-approval', {
            parent: 'merchandiser-activity',
            url: '/merchandiser-activity/other-job-approval?page&sort&search&status',
            data: {
                authorities: ['ROLE_ADMIN', 'VDO', 'ARCO', 'VDR'],
                pageTitle: 'sceaApp.otherJob.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/merchandiser-activity/other-job-approval/other-jobs.html',
                    controller: 'OtherJobController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                status: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        status: $stateParams.status
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherJob');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('other-job-approval.edit', {
            parent: 'other-job-approval',
            url: '/{id}/detail',
            data: {
                authorities: ['ROLE_ADMIN', 'VDO', 'ARCO']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/merchandiser-activity/other-job-approval/other-job-dialog.html',
                    controller: 'OtherJobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OtherJob', function(OtherJob) {
                            return OtherJob.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-job-approval', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OtherJob', OtherJob);

    OtherJob.$inject = ['$resource', 'DateUtils'];

    function OtherJob ($resource, DateUtils) {
        var resourceUrl =  'api/other-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.surveyStart = DateUtils.convertDateTimeFromServer(data.surveyStart);
                    data.surveyEnd = DateUtils.convertDateTimeFromServer(data.surveyEnd);
                    data.submitDate = DateUtils.convertDateTimeFromServer(data.submitDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OtherJobSearch', OtherJobSearch);

    OtherJobSearch.$inject = ['$resource'];

    function OtherJobSearch($resource) {
        var resourceUrl =  'api/_search/other-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobController', OtherJobController);

    OtherJobController.$inject = ['$scope', '$state', 'OtherJob', 'OtherJobSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OtherJobController ($scope, $state, OtherJob, OtherJobSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchStatus = pagingParams.status;
        vm.currentStatus = pagingParams.status;
        vm.getInOutletTime = getInOutletTime;
        vm.loadAll();

        function loadAll () {
        	if(vm.searchStatus == null) {
        		vm.searchStatus = 'needApproval';
        	}

            if (pagingParams.search) {
            	var queryStatus = ' AND status:';
            	if(pagingParams.status == 'needApproval') {
            		queryStatus += '1';
            	} else if(pagingParams.status == 'approved') {
            		queryStatus += '2';
            	} else if(pagingParams.status =='rejected') {
            		queryStatus += '3';
            	}

            	var query = '(outlet.outletName:"*'+pagingParams.search+'*" OR '+'employee.firstName:"*'+pagingParams.search+'*")';

                OtherJobSearch.query({
                    query: query + queryStatus,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OtherJob.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.otherJobs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                status: vm.currentStatus
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.currentStatus = vm.searchStatus;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.currentStatus = null;
            vm.transition();
        }

        function getInOutletTime(otherJob) {
        	var diff = moment(otherJob.surveyEnd).diff(moment(otherJob.surveyStart)),
        		duration = moment.duration(diff),
        		days = duration.days(),
        		stringDays = '',
        		time,
        		hours = duration.hours(),
        		mins = duration.minutes(),
        		secs = duration.seconds();

        	if(days > 0) {
        		stringDays = days + ' Day(s) ';
        	}

        	time = stringDays + hours + ":" + mins + ":" + secs;

        	return time;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('merchandiser-activity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VdeOutletDialogController', VdeOutletDialogController);

    VdeOutletDialogController.$inject = ['$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'outlets', 'Calendar', 'Outlet', 'TicketOrder'];

    function VdeOutletDialogController ($scope, $state, $stateParams, $uibModalInstance, $uibModal, outlets, Calendar, Outlet, TicketOrder) {
        var vm = this;

        vm.outlets = outlets;
    	vm.reverse = true;
    	vm.predicate = 'outletCode';

        vm.addOutlet = addOutlet;
    	vm.clear = clear;
        vm.deleteOutlet = deleteOutlet;

        function addOutlet() {
            var modalInstance = $uibModal.open({
                templateUrl:
                    "app/merchandiser-activity/call-plan-creation/vde-outlet-add-dialog.html",
                controller: "VdeOutletAddDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "md",
                resolve: {
                    outlets: [
                        "Outlet",
                        function (Outlet) {
                            return Outlet.queryByVdo({
                                id: $stateParams.vdeId
                            }).$promise.then(function (outlets) {
                                if (outlets && outlets.length) {
                                    return outlets.map(function (o) {
                                        return Object.assign(o, {
                                            searchField: {
                                                name: o.outletName,
                                                code: o.outletCode
                                            },
                                        });
                                    });
                                } else {
                                    return [];
                                }
                            });
                        }
                    ]
                }
            });

            modalInstance.result.then(function(result) {}, function() {
            	vm.outlets = TicketOrder.queryOutlets({
            		employeeId: $stateParams.vdeId,
            		calendarId : $stateParams.calendarId
            	});
            });
        }

        function deleteOutlet(outlet) {
        	TicketOrder.delete({id: outlet.ticketOrderId}, function(data) {
        		TicketOrder.queryOutlets({
        			employeeId: $stateParams.vdeId,
        			calendarId : $stateParams.calendarId
        		}, function(data) {
        	        vm.outlets = data;
        		});
        	});
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VdeOutletAddDialogController', VdeOutletAddDialogController);

    VdeOutletAddDialogController.$inject = ['$scope', '$state', '$uibModalInstance', '$stateParams', 'outlets', 'Outlet', 'TicketOrder'];

    function VdeOutletAddDialogController($scope, $state, $uibModalInstance, $stateParams, outlets, Outlet, TicketOrder) {
        var vm = this;

        vm.outlets = outlets;
    	vm.reverse = true;
    	vm.predicate = 'outletCode';

        vm.addOutlet = addOutlet;
    	vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addOutlet(outlet) {
        	TicketOrder.save({
            	outletId: outlet.id,
            	employeeId: parseInt($stateParams.vdeId),
            	calendarId: parseInt($stateParams.calendarId),
            	flagAsynch: 0,
            	ticketWfStat: 0
        	});
        }
    }
})();
;
(function() {
    'use strict';

    angular
    	.module('sceaApp')
    	.config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('call-plan-creation', {
            parent: 'merchandiser-activity',
            url: '/merchandiser-activity/call-plan-creation',
            data: {
                authorities: ['ROLE_ADMIN', 'VDO', 'VDR'],
                pageTitle: 'sceaApp.callPlanCreation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/merchandiser-activity/call-plan-creation/call-plan-creations.html',
                    controller: 'CallPlanCreationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('outlet');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('callPlanCreation');
                	$translatePartialLoader.addPart('ticketOrder');
                	$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('call-plan-creation.outlet', {
            parent: 'call-plan-creation',
            url: '/{vdoId}/{vdeId}/week/{calendarId}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDO', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'TicketOrder', function($stateParams, $state, $uibModal, TicketOrder) {
                $uibModal.open({
                    templateUrl: 'app/merchandiser-activity/call-plan-creation/vde-outlet-dialog.html',
                    controller: 'VdeOutletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	outlets: ['TicketOrder', function(TicketOrder) {
                            return TicketOrder.queryOutlets({employeeId: $stateParams.vdeId, calendarId : $stateParams.calendarId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('call-plan-creation', null, { reload: true });
                }, function() {
                    $state.go('call-plan-creation', null, { reload: true });
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('CallPlanCreationController', CallPlanCreationController);

    CallPlanCreationController.$inject = ['$rootScope', '$scope', '$state', '$filter', 'Principal', 'Calendar', 'User', 'TicketOrder'];

    function CallPlanCreationController ($rootScope, $scope, $state, $filter, Principal, Calendar, User, TicketOrder) {
        var vm = this;
        var monthNow, yearNow;
        vm.pageVdo = 1;
		
        vm.getVdeSummaries = getVdeSummaries;
        
        
		function init() {
			vm.months = Calendar.queryMonths();
			
			monthNow = moment().month() + 1;
			monthNow = monthNow.toString();
			vm.month = monthNow.toString();
			
			yearNow = moment().year();
			vm.years = [yearNow-1, yearNow];
			
			yearNow = yearNow.toString();
			vm.year = yearNow.toString();
			
            Principal.identity().then(function(account) {
            	var filters = $filter('filter')(account.authorities, 'VDO', true);
            	
            	if(filters.length > 0) {
                    User.get({login : account.login}, function(data) {
                    	vm.vdos = [data];
                    	vm.vdo = data;
                    	
        				getVdeSummaries(vm.vdo.id, yearNow, monthNow);
                    });
            	} else {
        			getVdo();
            	}
            });
		}
		init();

		function getVdo() {
			User.query({
				roleName: 'VDO'
			}, function(data, headers) {
				vm.vdos = data;
				vm.vdo = vm.vdos[0];
				
				getVdeSummaries(vm.vdo.id, yearNow, monthNow);

            	var totalNow = vm.vdos.length;
                var totalItems = headers('X-Total-Count');

                if(totalNow != totalItems) {
                	getMoreVdo(vm.pageVdo);
                }
			});
		}
		
        function getMoreVdo(page) {
        	User.query({
				roleName: 'VDO',
                page: page
            }, function(data, headers) {
            	angular.forEach(data, function(vdo) {
            		vm.vdos.push(vdo);
            	});

            	var totalNow = vm.vdos.length;
                var totalItems = headers('X-Total-Count');

                if(totalNow != totalItems) {
                	vm.pageVdo++;
                	getMoreVdo(vm.pageVdo);
                }
            });
        }

		function getVdeSummaries(vdoId, year, month) {
	        TicketOrder.queryVdeSummaries({
	        	vdoId: vdoId,
	        	year: year,
	    		month: month
	        }, function(data) {
	        	vm.vdeSummaries = data;
	        });			
		}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go("home", {
                week: null,
                month: null,
                year: null,
                vdr: null,
                vdoCoo: null,
                vdo: null,
                showChart: null,
            });
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('DynamicForm', DynamicForm);

    DynamicForm.$inject = ['$resource'];

    function DynamicForm ($resource) {

        return $resource(null, {}, {
        	'getBusinessUnit' : {
        		url: 'api/bussiness-units',
            	method: 'GET',
            	isArray: true 		
        	},
        	'getABusinessUnit' : {
        		url: 'api/bussiness-units/:id',
            	method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }	
        	},
        	'calculateFormula' : {
        		url: 'api/formula',
            	method: 'POST',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var result = {};
                    result['value'] = data;
                    return result;
                }
        	}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('MetabaseDashboardController', MetabaseDashboardController);

    MetabaseDashboardController.$inject = ['DashboardSetting', '$sce', 'AlertService', 'currentUser', 'pagingParams'];

    function MetabaseDashboardController (DashboardSetting, $sce, AlertService, currentUser, pagingParams) {
        var vm = this;

        vm.account = currentUser;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.isAdmin = vm.account.authorities.includes('ROLE_ADMIN');

        vm.loadAll = loadAll;
        vm.selectDashboard = selectDashboard;
        vm.isLoading = true;

        vm.loadAll();

        function loadAll () {
            DashboardSetting.metabaseEmbeddedUrl({
                page: 0,
                size: 100,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data) {
                vm.isLoading = false;
                vm.metabaseResources = data;

                vm.metabaseResources.map(function(d){
                    var saveUrl = {
                        safeUrl: $sce.trustAsResourceUrl(metabaseParameter(d.metabaseEmbeddedUrl))
                    };

                    return Object.assign(d, saveUrl);
                });
                vm.selectedDashboard = vm.metabaseResources[0];
                vm.selectedUrl = vm.selectedDashboard.safeUrl;
            }
            function onError(error) {
                vm.isLoading = false;
                AlertService.error(error.data.message);
            }
        }

        function selectDashboard(dashboardResource) {
            vm.selectedDashboard = dashboardResource;
            vm.selectedUrl = vm.selectedDashboard.safeUrl;
        }

        function metabaseParameter(url) {
            if (vm.isAdmin) {
                return url;
            }

            return url + '?user_login=' + vm.account.login + '#hide_parameters=user_login';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home', {
            parent: 'app',
            url: '/?week&month&year&showChart&vdr&vdoCoo&vdo',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('dashboardParams');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard', {
            parent: 'app',
            url: '/dashboard',
            data: {
                authorities: []
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/metabase-dashboard/metabase-dashboard.html',
                    controller: 'MetabaseDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                currentUser: ['Principal', 'User', function(Principal, User) {
                    return Principal.identity();
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$state', '$filter', 'Principal', 'LoginService', '$rootScope'];

    function HomeController ($scope, $state, $filter, Principal, LoginService, $rootScope) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = false;
        vm.login = LoginService.open;
        vm.register = register;
        $rootScope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                if (vm.isAuthenticated()) {
                    $state.go('dashboard');
                }
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('VdoCallplanDetailController', VdoCallplanDetailController);

        VdoCallplanDetailController.$inject = ['$scope', '$state', 'filterParams', 'Principal', 'User', 'Calendar', 'Dashboard', '$uibModal', 'CalendarSearch'];

    function VdoCallplanDetailController ($scope, $state, filterParams, Principal, User, Calendar, Dashboard, $uibModal, CalendarSearch) {
        var vm = this;

        vm.back = back;
        vm.updateParams = updateParams;
        vm.updateWeeks = updateWeeks;
        vm.openOutletDialog = openOutletDialog;

		function init() {
            getAccount();

            vm.predicate = '-achievement';
            vm.calendar = {
                year: filterParams.year,
                month: filterParams.month,
                week: filterParams.week
            }

            vm.years = Calendar.queryYears();
            vm.months = Calendar.queryMonths();
            vm.weeks = Calendar.queryWeeks({
                year: vm.calendar.year,
                month: vm.calendar.month
            });
		}
        init();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.user = User.get({login: account.login});

                if(vm.user.$promise) {
                    vm.user.$promise.then(function(data) {
                        getVdoCallplan(data, vm.calendar);
                    });
                }
            });
        }

        function updateWeeks(year, month) {
            vm.weeks = Calendar.queryWeeks({
                year: year,
                month: month
            }, function(data) {
                vm.calendar.week = String(data[0]);

                updateParams(vm.calendar);
            });
        }

        function updateParams(calendar) {
            $state.go('vdo-callplan-detail', {
                week: calendar.week,
                month: calendar.month,
                year: calendar.year,
                showChart: filterParams.showChart,
                vdr: filterParams.vdr,
                vdoCoo: filterParams.vdoCoo,
                vdo: filterParams.vdo
            });
        }

		function getVdoCallplan(user, calendar) {
            if(calendar.year && calendar.week) {
                Dashboard.getAsmVdeCallplan({
                    userId: user.id,
                    year: calendar.year,
                    week: calendar.week
                }, function(data) {
                    var sumActual = 0;
                    var sumTarget = 0;
                    var sumAchievement = 0;

                    angular.forEach(data, function(eachData, key) {
                        (eachData.roleName == 'VDE') ? eachData.roleName = 'VDO' : null;

                        eachData.achievement = eachData.achievements.actual / eachData.achievements.target * 100;
                        if(isNaN(eachData.achievement)) {
                            eachData.achievement = 0;
                        }

                        sumActual += eachData.achievements.actual;
                        sumTarget += eachData.achievements.target;
                        sumAchievement += eachData.achievement;
                    });

                    data.sumActual = sumActual;
                    data.sumTarget = sumTarget;
                    data.sumAchievement = data.sumActual/data.sumTarget * 100;
                    // data.sumAchievement = sumAchievement / data.length;

                    if(isNaN(data.sumAchievementTotal)) {
                        data.sumAchievementTotal = 0;
                    }

                    vm.vdoSummaries = data;
                });
            }
        }

        function back(calendar) {
            $state.go('home', {
                week: calendar.week,
                month: calendar.month,
                year: calendar.year,
                showChart: filterParams.showChart,
                vdr: filterParams.vdr,
                vdoCoo: filterParams.vdoCoo,
                vdo: filterParams.vdo
            });
        }

        function openOutletDialog(employeeId) {
            var outletDialog = $uibModal.open({
                templateUrl:
                    "app/home/dashboard-asm/modal/call-plan-outlet-dialog.html",
                controller: "CallPlanOutletDialogController",
                controllerAs: "vm",
                backdrop: "static",
                size: "md",
                resolve: {
                    calendar: function () {
                        var query = "week:" + vm.calendar.week + " AND " + "month:" + vm.calendar.month + " AND " + "year:" + vm.calendar.year;
                        return CalendarSearch.query({
                            query: query,
                            sort: "_score,desc",
                            size: 1,
                        }).$promise.then(
                            function (calendars) {
                                return calendars[0];
                            },
                            function () {
                                return null;
                            }
                        );
                    },
                    employeeId: function () {
                        return employeeId;
                    }
                },
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopTrackingDetailController', PopTrackingDetailController);

        PopTrackingDetailController.$inject = ['$scope', '$state', '$stateParams', 'Principal', 'User', 'Calendar', 'Dashboard'];

    function PopTrackingDetailController ($scope, $state, $stateParams, Principal, User, Calendar, Dashboard) {
        var vm = this;
        
        vm.back = back;
        vm.updateParams = updateParams;
        vm.updateWeeks = updateWeeks;

		function init() {
            getAccount();

            vm.predicate = '-achievement';

            if ($stateParams.showChart != null) {
                vm.showChart = $stateParams.showChart == 'true';
            }

            vm.calendar = {
                year: String($stateParams.year),
                month: String($stateParams.month),
                week: String($stateParams.week)
            }

            vm.years = Calendar.queryYears();
            vm.months = Calendar.queryMonths();
            vm.weeks = Calendar.queryWeeks({
                year: vm.calendar.year,
                month: vm.calendar.month
            });
		}
        init();
        
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.user = User.get({login: account.login});

                if(vm.user.$promise) {
                    vm.user.$promise.then(function(data) {
                        getPopTracking(data, vm.calendar);
                    });
                }
            });
        }

        function updateWeeks(year, month) {
            vm.weeks = Calendar.queryWeeks({
                year: year,
                month: month
            }, function(data) {
                vm.calendar.week = String(data[0]);

                updateParams(vm.calendar);
            });
        }

        function updateParams(calendar) {
            $state.go('pop-tracking-detail', {
                week: calendar.week,
                month: calendar.month,
                year: calendar.year
            });
        }

		function getPopTracking(user, calendar) {
            if(calendar.year && calendar.week) {
                Dashboard.getAsmPopTracking({
                    userId: user.id,
                    year: calendar.year,
                    week: calendar.week
                }, function(data) {
                    var sumActual = 0;
                    var sumTarget = 0;
                    var sumAchievement = 0;

                    angular.forEach(data, function(eachData) {
                        (eachData.roleName == 'VDE') ? eachData.roleName = 'VDO' : null;

                        eachData.achievement = eachData.achievements.actual / eachData.achievements.target * 100;
                        if(isNaN(eachData.achievement)) {
                            eachData.achievement = 0;
                        }
                        
                        sumActual += eachData.achievements.actual;
                        sumTarget += eachData.achievements.target;
                        sumAchievement += eachData.achievement;
                    });
                    
                    data.sumActual = sumActual;
                    data.sumTarget = sumTarget;
                    data.sumAchievement = sumAchievement / data.length; 

                    vm.popTracking = data;
                });
            }
        }
        
        function back(calendar) {
            $state.go('home', {
                week: calendar.week,
                month: calendar.month,
                year: calendar.year,
                showChart: vm.showChart
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopComplianceDetailController', PopComplianceDetailController);

    PopComplianceDetailController.$inject = ['$scope', '$state', 'filterParams', 'Principal', 'User', 'Calendar', 'Dashboard',
        'years', 'months', 'weeks','currentUser', 'vdrList', 'vdoList', 'vdeList'];

    function PopComplianceDetailController ($scope, $state, filterParams, Principal, User, Calendar, Dashboard,
        years, months, weeks, currentUser, vdrList, vdoList, vdeList) {
        var vm = this;

        vm.back = back;
        vm.updateWeeks = updateWeeks;
        vm.transition = transition;
        vm.onVdrChange = onVdrChange;
        vm.onVdoChange = onVdoChange;
        vm.onVdeChange = onVdeChange;

        vm.showChart = filterParams.showChart === 'true';
        vm.isAdmin = currentUser ? currentUser.authorities.includes('ROLE_ADMIN') : false;
        vm.isVdr = currentUser ? currentUser.authorities.includes('VDR') : false;
        vm.isVdo = currentUser ? currentUser.authorities.includes('VDO') : false;
        vm.isVde = currentUser ? currentUser.authorities.includes('VDE') : false;
        vm.showData = vm.showData = 'total';

        vm.vdr = vdrList;
        vm.vdo = vdoList;
        vm.vde = vdeList;
        vm.weeks = weeks;
        vm.months = months;
        vm.years = years;
        vm.currentUser = currentUser;
        vm.calendar = {
            year: filterParams.year,
            month: filterParams.month,
            week: filterParams.week,
        }
        vm.selectedRole = {
            vdr: filterParams.vdr ? vm.vdr.find(function(vdr){return vdr.id == filterParams.vdr}) : null,
            vdo: filterParams.vdoCoo ? vm.vdo.find(function(vdoCoo){return vdoCoo.id == filterParams.vdoCoo}) : null,
            vde: filterParams.vdo ? vm.vde.find(function(vdo){return vdo.id == filterParams.vdo}) : null,
        }
        vm.predicate = 'actualAv';
        vm.reverse = false;

        if (!filterParams.vdo && !filterParams.vdoCoo && !filterParams.vdo) {
            if (vm.isVde) {
                User.getInternal({ roleName: 'VDE', managerId: currentUser.managerId }, function (vde) {
                    vm.vde = vde
                    vm.selectedRole.vde = vm.vde.find(function(vde){return vde.id == currentUser.id})
                });

                User.getInternal({ roleName: 'VDO'}, function (vdo) {
                    vm.vdo = vdo
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.managerId});
                    vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == vm.selectedRole.vdo.managerId});
                });
            } else if (vm.isVdo) {
                vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == currentUser.managerId});

                User.getInternal({ roleName: 'VDO', managerId: currentUser.managerId }, function (vdo) {
                    vm.vdo = vdo
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.id})
                });

                User.getInternal({ roleName: 'VDE', managerId: currentUser.id }, function (vde) {
                    vm.vde = vde
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.id})
                });
            } else if (vm.isVdr) {
                vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == currentUser.id});
            }
        }

        loadAll();

		function loadAll() {
            var userId;

            if (filterParams.vdo){
                userId = filterParams.vdo
            } else if (filterParams.vdoCoo) {
                userId = filterParams.vdoCoo
            } else if (filterParams.vdr) {
                userId = filterParams.vdr
            } else {
                userId = vm.currentUser.id
            }

            if (!userId || !filterParams.week || !filterParams.year) {
                return;
            }

            Dashboard.getAsmPopCompliance({
                userId: userId,
                year: filterParams.year,
                week: filterParams.week
            }, function(data) {
                vm.popCompliance = data.map(function(eachData){
                    return {
                        employeeName: eachData.employeeName,
                        actualAv : eachData.achievements.actual_av,
                        targetAv : eachData.achievements.target_av,
                        achievementAv : (eachData.achievements.actual_av && eachData.achievements.target_av) ? eachData.achievements.actual_av / eachData.achievements.target_av * 100 : 0,
                        actualHa : eachData.achievements.actual_ha,
                        targetHa : eachData.achievements.target_ha,
                        achievementHa : (eachData.achievements.actual_ha && eachData.achievements.target_ha) ? eachData.achievements.actual_ha / eachData.achievements.target_ha * 100 : 0,
                        actualCe : eachData.achievements.actual_total,
                        targetCe : eachData.achievements.target_total,
                        achievementCe : (eachData.achievements.actual_total && eachData.achievements.target_total) ? eachData.achievements.actual_total / eachData.achievements.target_total * 100 : 0,
                    }
                });

                vm.total = {
                    actualAv: sumArrByProp(vm.popCompliance, 'actualAv'),
                    targetAv: sumArrByProp(vm.popCompliance, 'targetAv'),
                    achievementAv: avgArrAchievementByProp(vm.popCompliance, 'achievementAv'),
                    actualHa: sumArrByProp(vm.popCompliance, 'actualHa'),
                    targetHa: sumArrByProp(vm.popCompliance, 'targetHa'),
                    achievementHa: avgArrAchievementByProp(vm.popCompliance, 'achievementHa'),
                    actualCe: sumArrByProp(vm.popCompliance, 'actualCe'),
                    targetCe: sumArrByProp(vm.popCompliance, 'targetCe'),
                    achievementCe: avgArrAchievementByProp(vm.popCompliance, 'achievementCe'),
                }
            });

            function sumArrByProp(arr, prop) {
                var sum = arr.reduce(function(acc, current){
                    return acc += current[prop];
                }, 0);
                return sum;
            }

            function avgArrAchievementByProp(arr, prop) {
                var filter;

                if (prop === 'achievementAv') {
                    filter = 'targetAv';
                } else if(prop === 'achievementHa') {
                    filter = 'targetHa';
                } else if(prop === 'achievementCe') {
                    filter = 'targetCe';
                } else {
                    return;
                }

                var nonZeroTarget = arr.filter(function(each){
                    return each[filter];
                });

                var sum = nonZeroTarget.reduce(function(acc, current){
                    return acc += current[prop];
                }, 0);

                var avg = sum / nonZeroTarget.length;

                return isNaN(avg) ? 0 : avg;
            }
		}

        function updateWeeks() {
            vm.weeks = Calendar.queryWeeks({
                year: vm.calendar.year,
                month: vm.calendar.month
            }, function (weeks) {
                vm.calendar.week = weeks.length ? weeks[0].toString() : null;
                vm.transition();
            });
        }

        function back() {
            $state.go('home', {
                showChart: vm.showChart,
                week: vm.calendar.week,
                month: vm.calendar.month,
                year: vm.calendar.year,
                vdr: vm.selectedRole.vdr ? vm.selectedRole.vdr.id : null,
                vdoCoo: vm.selectedRole.vdo ? vm.selectedRole.vdo.id : null,
                vdo: vm.selectedRole.vde ? vm.selectedRole.vde.id : null
            });
        }

        // event change role
        function onVdrChange() {
            vm.selectedRole.vdo = null;
            vm.selectedRole.vde = null;
            vm.transition();
        }

        function onVdoChange() {
            vm.selectedRole.vde = null;
            vm.transition();
        }

        function onVdeChange() {
            vm.transition();
        }

        function transition() {
            $state.go('pop-compliance-detail', {
                showChart: vm.showChart,
                week: vm.calendar.week,
                month: vm.calendar.month,
                year: vm.calendar.year,
                vdr: vm.selectedRole.vdr ? vm.selectedRole.vdr.id : null,
                vdoCoo: vm.selectedRole.vdo ? vm.selectedRole.vdo.id : null,
                vdo: vm.selectedRole.vde ? vm.selectedRole.vde.id : null
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('CallPlanOutletDialogController', CallPlanOutletDialogController);

    CallPlanOutletDialogController.$inject = ['$uibModalInstance', 'calendar', 'employeeId', 'TicketOrder', 'AlertService'];

    function CallPlanOutletDialogController ($uibModalInstance, calendar, employeeId, TicketOrder, AlertService) {
        var vm = this;
        vm.clear = clear;
        vm.bgColorStat = {
            'Not Downloaded' : 'lightgrey',
            'Succeed' : 'lightgreen',
            'Failed' : 'lightpink',
            'In Progress' : 'yellow',
        }
        vm.total = {
            todo: 0,
            failed: 0,
            success: 0,
            created: 0
        }
        vm.ticketOrders = [];

        loadTickerOrder();

        function loadTickerOrder() {
            vm.loading = true;
            TicketOrder.queryOutlets({
                employeeId: employeeId,
                calendarId : calendar.id
            }, onSuccess, onError);

            function onSuccess(ticketOrders) {
                vm.loading = false;
                vm.ticketOrders = ticketOrders;
                vm.total = {
                    todo: filterTicketByStatus(vm.ticketOrders, 'In Progress'),
                    failed: filterTicketByStatus(vm.ticketOrders, 'Failed'),
                    success: filterTicketByStatus(vm.ticketOrders, 'Succeed'),
                    created: filterTicketByStatus(vm.ticketOrders, 'Not Downloaded')
                }
            }

            function onError() {
                vm.loading = false;
                AlertService.error(error.data.message);
            }

            function filterTicketByStatus(data, status) {
                var tickets = data.filter(function(eachData){
                    return eachData.status === status;
                });
                return tickets.length;
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('DashboardParams', DashboardParams);

    DashboardParams.$inject = ['$resource'];

    function DashboardParams ($resource) {
        var resourceUrl =  'api/dashboard-params/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DashboardAsmController', DashboardAsmController);

    DashboardAsmController.$inject = ['$scope', '$state', 'filterParams', 'Principal', 'User', 'Calendar', 'Dashboard',
        'years', 'months', 'weeks', 'currentUser', 'currentCalendar', 'vdrList', 'vdoList', 'vdeList'];

    function DashboardAsmController($scope, $state, filterParams, Principal, User, Calendar, Dashboard,
        years, months, weeks, currentUser, currentCalendar, vdrList, vdoList, vdeList) {
        var vm = this;
        var sName = "";
        var sData = [];
        var arrWeek = [];

        vm.showChart = filterParams.showChart === 'true';
        vm.updateWeeks = updateWeeks;
        vm.getAsmSummariesCp = getAsmSummariesInvoke;
        vm.getAsmSummariesPc = getAsmSummariesInvoke;
        vm.getAsmSummariesPt = getAsmSummariesInvoke;
        vm.getAsmSummariesDp = getAsmSummariesDPS;

        vm.transition = transition;
        vm.onVdrChange = onVdrChange;
        vm.onVdoChange = onVdoChange;
        vm.onVdeChange = onVdeChange;

        vm.isAdmin = currentUser ? currentUser.authorities.includes('ROLE_ADMIN') : false;
        vm.isVdr = currentUser ? currentUser.authorities.includes('VDR') : false;
        vm.isVdo = currentUser ? currentUser.authorities.includes('VDO') : false;
        vm.isVde = currentUser ? currentUser.authorities.includes('VDE') : false;

        vm.vdr = vdrList;
        vm.vdo = vdoList;
        vm.vde = vdeList;
        vm.weeks = weeks;
        vm.months = months;
        vm.years = years;
        vm.currentUser = currentUser;
        vm.calendar = {
            year: filterParams.year ? filterParams.year : currentCalendar.year ? currentCalendar.year.toString() : null,
            month: filterParams.month ? filterParams.month : currentCalendar.month ? currentCalendar.month.toString() : null,
            week: filterParams.week ? filterParams.week : currentCalendar.week ? currentCalendar.week.toString() : null,
        }
        vm.selectedRole = {
            vdr: filterParams.vdr ? vm.vdr.find(function(vdr){return vdr.id == filterParams.vdr}) : null,
            vdo: filterParams.vdoCoo ? vm.vdo.find(function(vdoCoo){return vdoCoo.id == filterParams.vdoCoo}) : null,
            vde: filterParams.vdo ? vm.vde.find(function(vdo){return vdo.id == filterParams.vdo}) : null,
        }

        if (!filterParams.vdo && !filterParams.vdoCoo && !filterParams.vdo) {
            if (vm.isVde) {
                User.getInternal({ roleName: 'VDE', managerId: currentUser.managerId }, function (vde) {
                    vm.vde = vde
                    vm.selectedRole.vde = vm.vde.find(function(vde){return vde.id == currentUser.id})
                });

                User.getInternal({ roleName: 'VDO'}, function (vdo) {
                    vm.vdo = vdo
                    console.log(vm.vdo);
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.managerId});
                    vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == vm.selectedRole.vdo.managerId});
                });
            } else if (vm.isVdo) {
                vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == currentUser.managerId});

                User.getInternal({ roleName: 'VDO', managerId: currentUser.managerId }, function (vdo) {
                    vm.vdo = vdo
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.id})
                });

                User.getInternal({ roleName: 'VDE', managerId: currentUser.id }, function (vde) {
                    vm.vde = vde
                    vm.selectedRole.vdo = vm.vdo.find(function(vdo){return vdo.id == currentUser.id})
                });
            } else if (vm.isVdr) {
                vm.selectedRole.vdr = vm.vdr.find(function(vdr){return vdr.id == currentUser.id});
            }
        }

        loadData();

        function loadData() {
            var userId;

            if (filterParams.vdo){
                userId = filterParams.vdo
            } else if (filterParams.vdoCoo) {
                userId = filterParams.vdoCoo
            } else if (filterParams.vdr) {
                userId = filterParams.vdr
            } else {
                userId = vm.currentUser.id
            }

            if (!userId) {
                return;
            }

            if (vm.showChart) {
                getAsmChart(userId, vm.calendar, "CALLPLANACOJTGT");
                getAsmChart(userId, vm.calendar, "POPALL");
                getAsmChart(userId, vm.calendar, "POPMOVEMENT");
            } else {
                getAsmSummariesInvoke(userId, vm.calendar, "CALLPLANACOJTGT")
                getAsmSummariesInvoke(userId, vm.calendar, "POPALL")
                getAsmSummariesInvoke(userId, vm.calendar, "POPMOVEMENT")
                getAsmSummariesDPS(userId, vm.calendar, "DPSTOCKLEVEL")
            }

        }

        function updateWeeks() {
            vm.weeks = Calendar.queryWeeks({
                year: vm.calendar.year,
                month: vm.calendar.month
            }, function (weeks) {
                vm.calendar.week = weeks.length ? weeks[0].toString() : null;
                vm.transition();
            });
        }

        // load chart
        function getAsmChart(userId, calendar, categories) {

            if (calendar.year && calendar.month) {

                // total weekly
                Dashboard.getAsmChart({
                    userId: userId,
                    year: calendar.year,
                    month: calendar.month,
                    storeType: 'VDE',
                    category: categories
                }, function (data) {
                    sData = [];
                    arrWeek = [];
                    var tempUrl;
                    var sumPercentage = 0;
                    var countData = 0;
                    angular.forEach(data, function (eachData) {
                        if (eachData.week) {
                            var url;

                            if (categories === "CALLPLANACOJTGT") {
                                url = 'vdo-callplan-detail';
                            } else if (categories === "POPALL") {
                                url = 'pop-compliance-detail';
                            } else {
                                url = 'pop-tracking-detail';
                            }

                            arrWeek.push(eachData.week);

                            var percentage = eachData.percentage * 100;
                            var fixedPercentage = parseFloat(percentage.toFixed(2));
                            sData.push({
                                url: url,
                                y: fixedPercentage,
                                week: eachData.week
                            });
                            tempUrl = url;
                            sumPercentage += fixedPercentage;
                            countData++;
                        }
                    });
                    arrWeek.push("Average")

                    var fixedPercentage = parseFloat((sumPercentage / countData).toFixed(2));
                    sData.push({
                        url: null,
                        y: fixedPercentage,
                        week: "AVG"
                    });

                    if (categories == "CALLPLANACOJTGT") {
                        sName = "VDO CALLPLAN";
                        chartInvoke("chart1", sName, sData, arrWeek);
                    } else if (categories == "POPALL") {
                        sName = "POP COMPLIANCE";
                        chartInvoke("chart2", sName, sData, arrWeek);
                    } else {
                        // sName = "POP TRACKING";
                        // chartInvoke("chart3", sName, sData, arrWeek);
                    }
                });

            }
        }

        // total summary
        function getAsmSummariesInvoke(userId, calendar, categories) {
            if (calendar.year && calendar.week) {
                Dashboard.getAsmSummaries({
                    userId: userId,
                    year: calendar.year,
                    week: calendar.week,
                    storeType: 'VDE',
                    category: categories
                }, function (data) {
                    if (categories == "CALLPLANACOJTGT") {
                        vm.asmSummariesCp = data;
                    } else if (categories == "POPALL") {
                        vm.asmSummariesPc = data;
                    } else {
                        vm.asmSummariesPt = data;
                    }
                });
            }
        }

        function getAsmSummariesDPS(userId, calendar, categories) {
            if (calendar.year && calendar.week) {
                Dashboard.getAsmDropPointStockLevel({
                    userId: userId,
                    year: calendar.year,
                    week: calendar.week,
                    storeType: 'VDE',
                    category: categories
                }, function (e) {
                    console.log('e: ', e);

                    vm.asmSummariesDp = e;
                });
            }
        }

        // highchart
        function chartInvoke(idContainer, chartName, ChartSeries, arrWeek) {
            var weeks = arrWeek;

            Highcharts.chart(idContainer, {
                credits: false,
                chart: {
                    type: 'column'
                },
                title: {
                    text: chartName
                },
                xAxis: {

                    // categories: arrWeek,
                    type: 'category',
                    crosshair: true,
                    title: {
                        text: 'Week'
                    },
                    labels: {
                        formatter: function () {
                            return '<a href="' + this.chart.series[0].options.data[this.value].url +
                                '" target="_parent">' + this.chart.series[0].options.data[this.value].week +
                                '</a>';
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: 'Percentage (%)'
                    }
                },
                tooltip: {
                    // headerFormat: '<span style="font-size:10px">week'+weeks[this.x]+'</span><table>',
                    // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    // '<td style="padding:0"><b>{point.y:.2f}%</b></td></tr>',
                    // footerFormat: '</table>',
                    shared: true,
                    useHTML: true,
                    formatter: function () {
                        var w = weeks
                        var s = '<span style="font-size:10px">week ' +
                            weeks[this.x] +
                            '</span><table> <tr><td style="color:';

                        $.each(this.points, function (i, point) {
                            s += point.series.color + ';padding:0">' +
                                point.series.name + ': </td> <td style="padding:0"><b>' +
                                point.y.toFixed(2) + '%</b></td></tr></table>';
                        });

                        return s;
                    }
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true
                        }
                    },
                    series: {
                        cursor: 'pointer',
                        point: {
                            events: {
                                click: function (a, b, c) {
                                    console.log(a.point.options);
                                    var week = a.point.options.week;
                                    var url = a.point.options.url;
                                    if(!url) {
                                        return;
                                    }
                                    $state.go(url, {
                                        showChart: vm.showChart,
                                        week: week,
                                        month: vm.calendar.month,
                                        year: vm.calendar.year,
                                        vdr: vm.selectedRole.vdr ? vm.selectedRole.vdr.id : null,
                                        vdoCoo: vm.selectedRole.vdo ? vm.selectedRole.vdo.id : null,
                                        vdo: vm.selectedRole.vde ? vm.selectedRole.vde.id : null
                                    });
                                }
                            }
                        }
                    }
                },
                series: [{
                    showInLegend: false,
                    name: sName,
                    data: sData

                }]
            });
        }

        // event change role
        function onVdrChange() {
            vm.selectedRole.vdo = null;
            vm.selectedRole.vde = null;
            vm.transition();
        }

        function onVdoChange() {
            vm.selectedRole.vde = null;
            vm.transition();
        }

        function onVdeChange() {
            vm.transition();
        }

        function transition() {
            $state.go('home', {
                showChart: vm.showChart,
                week: vm.calendar.week,
                month: vm.calendar.month,
                year: vm.calendar.year,
                vdr: vm.selectedRole.vdr ? vm.selectedRole.vdr.id : null,
                vdoCoo: vm.selectedRole.vdo ? vm.selectedRole.vdo.id : null,
                vdo: vm.selectedRole.vde ? vm.selectedRole.vde.id : null
            });
        }
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource'];

    function Dashboard ($resource) {
        var resourceUrl =  'api/dashboard/';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'popDashboard': { 
            	method:'GET',
            	url: 'api/dashboard/pop-dashboard',
                cancellable: true
            },
            'popDashboardDetail': { 
            	method:'GET',
            	url: 'api/dashboard/pop-dashboard/:id',
                isArray: true
            },
            'exportExcel': { 
            	method:'GET',
            	url: 'api/dashboard/export-excel',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                    var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'getAsmSummaries': {
            	url: 'api/dashboard/total',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getAsmVdeCallplan': {
            	url: 'api/dashboard/vde-callplan',
                method: 'GET',
                isArray: true
            },
            'getAsmPopCompliance': {
            	url: 'api/dashboard/pop-compliance',
                method: 'GET',
                isArray: true
            },
            'getAsmPopTracking': {
            	url: 'api/dashboard/pop-movement',
                method: 'GET',
                isArray: true
            },
            'getAsmDropPointStockLevel': {
            	url: 'api/dashboard/total?category=DPSTOCKLEVEL',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getAsmChart': {
                url: 'api/dashboard/total-weekly',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function(){
    'use strict';
    angular
        .module('sceaApp')
        .factory('UserGroup', UserGroup);

    UserGroup.$inject = ['$resource'];

    function UserGroup ($resource) {
        var resourceUrl = 'api/groups/:id';

        return $resource ( resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('upload-retail-mapping-allocation', {
            parent: 'entity',
            url: '/upload-retail-mapping-allocation',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.uploadRetailMappingAllocation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/upload-retail-mapping-allocation/upload-retail-mapping-allocation.html',
                    controller: 'UploadRetailMappingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('uploadRetailMappingAllocation');
                	$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('UploadRetailMappingController', UploadRetailMappingController);

    UploadRetailMappingController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload'];

    function UploadRetailMappingController ($scope, $state, $timeout, DataUtils, Upload) {
        var vm = this;

        vm.listOrderData = {};

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setlistOrderData = setlistOrderData;
        vm.upload = upload;

        function setlistOrderData(file) {
            if(file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

            	vm.listOrderData.dataContentType = file.type;
            	vm.listOrderData.fileName = file.name;
            	vm.listOrderData.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlets/retail-mapping-user/import',
                data: {file: file}
            }).then(function (response) {
                $timeout(function () {
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                });
            }, function (response) {
                vm.logs = response.data;

                if (response.status > 0)
                    file.error = response.status + ': ' + response.data;
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '% ';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketResultDialogController', TicketResultDialogController);

    TicketResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketResult'];

    function TicketResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketResult) {
        var vm = this;
        vm.ticketResult = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:ticketResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.ticketResult.id !== null) {
                TicketResult.update(vm.ticketResult, onSaveSuccess, onSaveError);
            } else {
                TicketResult.save(vm.ticketResult, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketResultDetailController', TicketResultDetailController);

    TicketResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TicketResult'];

    function TicketResultDetailController($scope, $rootScope, $stateParams, entity, TicketResult) {
        var vm = this;
        vm.ticketResult = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:ticketResultUpdate', function(event, result) {
            vm.ticketResult = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketResultDeleteController',TicketResultDeleteController);

    TicketResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketResult'];

    function TicketResultDeleteController($uibModalInstance, entity, TicketResult) {
        var vm = this;
        vm.ticketResult = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TicketResult.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-result', {
            parent: 'entity',
            url: '/ticket-result?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.ticketResult.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-result/ticket-results.html',
                    controller: 'TicketResultController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketResult');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-result-detail', {
            parent: 'entity',
            url: '/ticket-result/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.ticketResult.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-result/ticket-result-detail.html',
                    controller: 'TicketResultDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketResult');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketResult', function($stateParams, TicketResult) {
                    return TicketResult.get({id : $stateParams.id});
                }]
            }
        })
        .state('ticket-result.new', {
            parent: 'ticket-result',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-result/ticket-result-dialog.html',
                    controller: 'TicketResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                resultCode: null,
                                resultDesc: null,
                                activityId: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-result', null, { reload: true });
                }, function() {
                    $state.go('ticket-result');
                });
            }]
        })
        .state('ticket-result.edit', {
            parent: 'ticket-result',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-result/ticket-result-dialog.html',
                    controller: 'TicketResultDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketResult', function(TicketResult) {
                            return TicketResult.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-result.delete', {
            parent: 'ticket-result',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-result/ticket-result-delete-dialog.html',
                    controller: 'TicketResultDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketResult', function(TicketResult) {
                            return TicketResult.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-result', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TicketResult', TicketResult);

    TicketResult.$inject = ['$resource'];

    function TicketResult ($resource) {
        var resourceUrl =  'api/ticket-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TicketResultSearch', TicketResultSearch);

    TicketResultSearch.$inject = ['$resource'];

    function TicketResultSearch($resource) {
        var resourceUrl =  'api/_search/ticket-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketResultController', TicketResultController);

    TicketResultController.$inject = ['$scope', '$state', 'TicketResult', 'TicketResultSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TicketResultController ($scope, $state, TicketResult, TicketResultSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TicketResultSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TicketResult.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ticketResults = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketOrderDialogController', TicketOrderDialogController);

    TicketOrderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketOrder', 'User', 'Outlet', 'TicketResult', 'Calendar'];

    function TicketOrderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketOrder, User, Outlet, TicketResult, Calendar) {
        var vm = this;
        vm.ticketOrder = entity;
        vm.employees = User.query();
        vm.outlets = Outlet.query();
        vm.ticketresults = TicketResult.query();
        vm.calendars = Calendar.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:ticketOrderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.ticketOrder.id !== null) {
                TicketOrder.update(vm.ticketOrder, onSaveSuccess, onSaveError);
            } else {
                TicketOrder.save(vm.ticketOrder, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.targetDate = false;
        vm.datePickerOpenStatus.expiredDate = false;
        vm.datePickerOpenStatus.periodStart = false;
        vm.datePickerOpenStatus.periodEnd = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketOrderDetailController', TicketOrderDetailController);

    TicketOrderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TicketOrder', 'Outlet', 'TicketResult', 'Calendar'];

    function TicketOrderDetailController($scope, $rootScope, $stateParams, entity, TicketOrder, Outlet, TicketResult, Calendar) {
        var vm = this;
        vm.ticketOrder = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:ticketOrderUpdate', function(event, result) {
            vm.ticketOrder = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketOrderDeleteController',TicketOrderDeleteController);

    TicketOrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketOrder'];

    function TicketOrderDeleteController($uibModalInstance, entity, TicketOrder) {
        var vm = this;
        vm.ticketOrder = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TicketOrder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('ticket-order', {
//            parent: 'entity',
//            url: '/ticket-order?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.ticketOrder.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/ticket-order/ticket-orders.html',
//                    controller: 'TicketOrderController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('ticketOrder');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('ticket-order-detail', {
//            parent: 'entity',
//            url: '/ticket-order/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.ticketOrder.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/ticket-order/ticket-order-detail.html',
//                    controller: 'TicketOrderDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('ticketOrder');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TicketOrder', function($stateParams, TicketOrder) {
//                    return TicketOrder.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('ticket-order.new', {
//            parent: 'ticket-order',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/ticket-order/ticket-order-dialog.html',
//                    controller: 'TicketOrderDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                activityId: null,
//                                createdDate: null,
//                                targetDate: null,
//                                flagAsynch: null,
//                                ticketWfStat: null,
//                                ticketDesc: null,
//                                expiredDate: null,
//                                periodStart: null,
//                                periodEnd: null,
//                                resultNote: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('ticket-order', null, { reload: true });
//                }, function() {
//                    $state.go('ticket-order');
//                });
//            }]
//        })
//        .state('ticket-order.edit', {
//            parent: 'ticket-order',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/ticket-order/ticket-order-dialog.html',
//                    controller: 'TicketOrderDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TicketOrder', function(TicketOrder) {
//                            return TicketOrder.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('ticket-order', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('ticket-order.delete', {
//            parent: 'ticket-order',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/ticket-order/ticket-order-delete-dialog.html',
//                    controller: 'TicketOrderDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TicketOrder', function(TicketOrder) {
//                            return TicketOrder.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('ticket-order', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TicketOrder', TicketOrder);

    TicketOrder.$inject = ['$resource', 'DateUtils'];

    function TicketOrder ($resource, DateUtils) {
        var resourceUrl =  'api/ticket-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    data.targetDate = DateUtils.convertDateTimeFromServer(data.targetDate);
                    data.expiredDate = DateUtils.convertDateTimeFromServer(data.expiredDate);
                    data.periodStart = DateUtils.convertDateTimeFromServer(data.periodStart);
                    data.periodEnd = DateUtils.convertDateTimeFromServer(data.periodEnd);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryOutlets': {
            	url: 'api/ticket-orders/outlets',
            	method: 'GET', 
            	isArray: true
            },
            'querySpvSummaries': {
            	url: 'api/ticket-orders/spv/summaries',
            	method: 'GET', 
            	isArray: true
            },
            'queryVdeSummaries': {
            	url: 'api/ticket-orders/vde/summaries',
            	method: 'GET', 
            	isArray: true
            },
            'getDashboardsAsm': {
            	url: 'api/ticket-orders/vde/dashboards/total',
            	method: 'GET', 
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TicketOrderSearch', TicketOrderSearch);

    TicketOrderSearch.$inject = ['$resource'];

    function TicketOrderSearch($resource) {
        var resourceUrl =  'api/_search/ticket-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TicketOrderController', TicketOrderController);

    TicketOrderController.$inject = ['$scope', '$state', 'TicketOrder', 'TicketOrderSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TicketOrderController ($scope, $state, TicketOrder, TicketOrderSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TicketOrderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TicketOrder.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ticketOrders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TStoreCompletenessDialogController', TStoreCompletenessDialogController);

    TStoreCompletenessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TStoreCompleteness', 'TPop', 'StoreCompleteness'];

    function TStoreCompletenessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TStoreCompleteness, TPop, StoreCompleteness) {
        var vm = this;
        vm.tStoreCompleteness = entity;
        vm.tpops = TPop.query();
        vm.storecompletenesses = StoreCompleteness.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tStoreCompletenessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tStoreCompleteness.id !== null) {
                TStoreCompleteness.update(vm.tStoreCompleteness, onSaveSuccess, onSaveError);
            } else {
                TStoreCompleteness.save(vm.tStoreCompleteness, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TStoreCompletenessDetailController', TStoreCompletenessDetailController);

    TStoreCompletenessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TStoreCompleteness', 'TPop', 'StoreCompleteness'];

    function TStoreCompletenessDetailController($scope, $rootScope, $stateParams, entity, TStoreCompleteness, TPop, StoreCompleteness) {
        var vm = this;
        vm.tStoreCompleteness = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tStoreCompletenessUpdate', function(event, result) {
            vm.tStoreCompleteness = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TStoreCompletenessDeleteController',TStoreCompletenessDeleteController);

    TStoreCompletenessDeleteController.$inject = ['$uibModalInstance', 'entity', 'TStoreCompleteness'];

    function TStoreCompletenessDeleteController($uibModalInstance, entity, TStoreCompleteness) {
        var vm = this;
        vm.tStoreCompleteness = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TStoreCompleteness.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-store-completeness', {
//            parent: 'entity',
//            url: '/t-store-completeness?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tStoreCompleteness.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-store-completeness/t-store-completenesses.html',
//                    controller: 'TStoreCompletenessController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tStoreCompleteness');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-store-completeness-detail', {
//            parent: 'entity',
//            url: '/t-store-completeness/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tStoreCompleteness.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-store-completeness/t-store-completeness-detail.html',
//                    controller: 'TStoreCompletenessDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tStoreCompleteness');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TStoreCompleteness', function($stateParams, TStoreCompleteness) {
//                    return TStoreCompleteness.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-store-completeness.new', {
//            parent: 't-store-completeness',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-store-completeness/t-store-completeness-dialog.html',
//                    controller: 'TStoreCompletenessDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                value: null,
//                                formNo: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('t-store-completeness');
//                });
//            }]
//        })
//        .state('t-store-completeness.edit', {
//            parent: 't-store-completeness',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-store-completeness/t-store-completeness-dialog.html',
//                    controller: 'TStoreCompletenessDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TStoreCompleteness', function(TStoreCompleteness) {
//                            return TStoreCompleteness.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-store-completeness.delete', {
//            parent: 't-store-completeness',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-store-completeness/t-store-completeness-delete-dialog.html',
//                    controller: 'TStoreCompletenessDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TStoreCompleteness', function(TStoreCompleteness) {
//                            return TStoreCompleteness.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TStoreCompleteness', TStoreCompleteness);

    TStoreCompleteness.$inject = ['$resource'];

    function TStoreCompleteness ($resource) {
        var resourceUrl =  'api/t-store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TStoreCompletenessSearch', TStoreCompletenessSearch);

    TStoreCompletenessSearch.$inject = ['$resource'];

    function TStoreCompletenessSearch($resource) {
        var resourceUrl =  'api/_search/t-store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TStoreCompletenessController', TStoreCompletenessController);

    TStoreCompletenessController.$inject = ['$scope', '$state', 'TStoreCompleteness', 'TStoreCompletenessSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TStoreCompletenessController ($scope, $state, TStoreCompleteness, TStoreCompletenessSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TStoreCompletenessSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TStoreCompleteness.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tStoreCompletenesses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopPlanogramDialogController', TPopPlanogramDialogController);

    TPopPlanogramDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPopPlanogram', 'TPop', 'PlanogramProduct'];

    function TPopPlanogramDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPopPlanogram, TPop, PlanogramProduct) {
        var vm = this;
        vm.tPopPlanogram = entity;
        vm.tpops = TPop.query();
        vm.planogramproducts = PlanogramProduct.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopPlanogramUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPopPlanogram.id !== null) {
                TPopPlanogram.update(vm.tPopPlanogram, onSaveSuccess, onSaveError);
            } else {
                TPopPlanogram.save(vm.tPopPlanogram, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopPlanogramDetailController', TPopPlanogramDetailController);

    TPopPlanogramDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPopPlanogram', 'TPop', 'PlanogramProduct'];

    function TPopPlanogramDetailController($scope, $rootScope, $stateParams, entity, TPopPlanogram, TPop, PlanogramProduct) {
        var vm = this;
        vm.tPopPlanogram = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopPlanogramUpdate', function(event, result) {
            vm.tPopPlanogram = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopPlanogramDeleteController',TPopPlanogramDeleteController);

    TPopPlanogramDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPopPlanogram'];

    function TPopPlanogramDeleteController($uibModalInstance, entity, TPopPlanogram) {
        var vm = this;
        vm.tPopPlanogram = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPopPlanogram.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop-planogram', {
//            parent: 'entity',
//            url: '/t-pop-planogram?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopPlanogram.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-planogram/t-pop-planograms.html',
//                    controller: 'TPopPlanogramController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopPlanogram');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-planogram-detail', {
//            parent: 'entity',
//            url: '/t-pop-planogram/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopPlanogram.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-planogram/t-pop-planogram-detail.html',
//                    controller: 'TPopPlanogramDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopPlanogram');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPopPlanogram', function($stateParams, TPopPlanogram) {
//                    return TPopPlanogram.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop-planogram.new', {
//            parent: 't-pop-planogram',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-planogram/t-pop-planogram-dialog.html',
//                    controller: 'TPopPlanogramDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                formNo: null,
//                                value: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-planogram', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop-planogram');
//                });
//            }]
//        })
//        .state('t-pop-planogram.edit', {
//            parent: 't-pop-planogram',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-planogram/t-pop-planogram-dialog.html',
//                    controller: 'TPopPlanogramDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPopPlanogram', function(TPopPlanogram) {
//                            return TPopPlanogram.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-planogram', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop-planogram.delete', {
//            parent: 't-pop-planogram',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-planogram/t-pop-planogram-delete-dialog.html',
//                    controller: 'TPopPlanogramDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPopPlanogram', function(TPopPlanogram) {
//                            return TPopPlanogram.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-planogram', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPopPlanogram', TPopPlanogram);

    TPopPlanogram.$inject = ['$resource'];

    function TPopPlanogram ($resource) {
        var resourceUrl =  'api/t-pop-planograms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopPlanogramSearch', TPopPlanogramSearch);

    TPopPlanogramSearch.$inject = ['$resource'];

    function TPopPlanogramSearch($resource) {
        var resourceUrl =  'api/_search/t-pop-planograms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopPlanogramController', TPopPlanogramController);

    TPopPlanogramController.$inject = ['$scope', '$state', 'TPopPlanogram', 'TPopPlanogramSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopPlanogramController ($scope, $state, TPopPlanogram, TPopPlanogramSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopPlanogramSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPopPlanogram.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPopPlanograms = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopInternetDialogController', TPopInternetDialogController);

    TPopInternetDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPopInternet', 'TPop', 'Internet'];

    function TPopInternetDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPopInternet, TPop, Internet) {
        var vm = this;
        vm.tPopInternet = entity;
        vm.tpops = TPop.query();
        vm.internets = Internet.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopInternetUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPopInternet.id !== null) {
                TPopInternet.update(vm.tPopInternet, onSaveSuccess, onSaveError);
            } else {
                TPopInternet.save(vm.tPopInternet, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopInternetDetailController', TPopInternetDetailController);

    TPopInternetDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPopInternet', 'TPop', 'Internet'];

    function TPopInternetDetailController($scope, $rootScope, $stateParams, entity, TPopInternet, TPop, Internet) {
        var vm = this;
        vm.tPopInternet = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopInternetUpdate', function(event, result) {
            vm.tPopInternet = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopInternetDeleteController',TPopInternetDeleteController);

    TPopInternetDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPopInternet'];

    function TPopInternetDeleteController($uibModalInstance, entity, TPopInternet) {
        var vm = this;
        vm.tPopInternet = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPopInternet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop-internet', {
//            parent: 'entity',
//            url: '/t-pop-internet?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopInternet.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-internet/t-pop-internets.html',
//                    controller: 'TPopInternetController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopInternet');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-internet-detail', {
//            parent: 'entity',
//            url: '/t-pop-internet/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopInternet.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-internet/t-pop-internet-detail.html',
//                    controller: 'TPopInternetDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopInternet');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPopInternet', function($stateParams, TPopInternet) {
//                    return TPopInternet.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop-internet.new', {
//            parent: 't-pop-internet',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-internet/t-pop-internet-dialog.html',
//                    controller: 'TPopInternetDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                formNo: null,
//                                value: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-internet', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop-internet');
//                });
//            }]
//        })
//        .state('t-pop-internet.edit', {
//            parent: 't-pop-internet',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-internet/t-pop-internet-dialog.html',
//                    controller: 'TPopInternetDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPopInternet', function(TPopInternet) {
//                            return TPopInternet.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-internet', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop-internet.delete', {
//            parent: 't-pop-internet',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-internet/t-pop-internet-delete-dialog.html',
//                    controller: 'TPopInternetDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPopInternet', function(TPopInternet) {
//                            return TPopInternet.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-internet', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPopInternet', TPopInternet);

    TPopInternet.$inject = ['$resource'];

    function TPopInternet ($resource) {
        var resourceUrl =  'api/t-pop-internets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopInternetSearch', TPopInternetSearch);

    TPopInternetSearch.$inject = ['$resource'];

    function TPopInternetSearch($resource) {
        var resourceUrl =  'api/_search/t-pop-internets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopInternetController', TPopInternetController);

    TPopInternetController.$inject = ['$scope', '$state', 'TPopInternet', 'TPopInternetSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopInternetController ($scope, $state, TPopInternet, TPopInternetSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopInternetSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPopInternet.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPopInternets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopFixtureDialogController', TPopFixtureDialogController);

    TPopFixtureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPopFixture', 'TPop', 'Fixtures', 'ProductCategory'];

    function TPopFixtureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPopFixture, TPop, Fixtures, ProductCategory) {
        var vm = this;
        vm.tPopFixture = entity;
        vm.tpops = TPop.query();
        vm.fixtures = Fixtures.query();
        vm.productcategories = ProductCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopFixtureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPopFixture.id !== null) {
                TPopFixture.update(vm.tPopFixture, onSaveSuccess, onSaveError);
            } else {
                TPopFixture.save(vm.tPopFixture, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopFixtureDetailController', TPopFixtureDetailController);

    TPopFixtureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPopFixture', 'TPop', 'Fixtures', 'ProductCategory'];

    function TPopFixtureDetailController($scope, $rootScope, $stateParams, entity, TPopFixture, TPop, Fixtures, ProductCategory) {
        var vm = this;
        vm.tPopFixture = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopFixtureUpdate', function(event, result) {
            vm.tPopFixture = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopFixtureDeleteController',TPopFixtureDeleteController);

    TPopFixtureDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPopFixture'];

    function TPopFixtureDeleteController($uibModalInstance, entity, TPopFixture) {
        var vm = this;
        vm.tPopFixture = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPopFixture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop-fixture', {
//            parent: 'entity',
//            url: '/t-pop-fixture?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopFixture.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-fixture/t-pop-fixtures.html',
//                    controller: 'TPopFixtureController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopFixture');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-fixture-detail', {
//            parent: 'entity',
//            url: '/t-pop-fixture/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopFixture.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-fixture/t-pop-fixture-detail.html',
//                    controller: 'TPopFixtureDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopFixture');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPopFixture', function($stateParams, TPopFixture) {
//                    return TPopFixture.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop-fixture.new', {
//            parent: 't-pop-fixture',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-fixture/t-pop-fixture-dialog.html',
//                    controller: 'TPopFixtureDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                formNo: null,
//                                value: null,
//                                target: null,
//                                remarks: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop-fixture');
//                });
//            }]
//        })
//        .state('t-pop-fixture.edit', {
//            parent: 't-pop-fixture',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-fixture/t-pop-fixture-dialog.html',
//                    controller: 'TPopFixtureDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPopFixture', function(TPopFixture) {
//                            return TPopFixture.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop-fixture.delete', {
//            parent: 't-pop-fixture',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-fixture/t-pop-fixture-delete-dialog.html',
//                    controller: 'TPopFixtureDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPopFixture', function(TPopFixture) {
//                            return TPopFixture.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPopFixture', TPopFixture);

    TPopFixture.$inject = ['$resource'];

    function TPopFixture ($resource) {
        var resourceUrl =  'api/t-pop-fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopFixtureSearch', TPopFixtureSearch);

    TPopFixtureSearch.$inject = ['$resource'];

    function TPopFixtureSearch($resource) {
        var resourceUrl =  'api/_search/t-pop-fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopFixtureController', TPopFixtureController);

    TPopFixtureController.$inject = ['$scope', '$state', 'TPopFixture', 'TPopFixtureSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopFixtureController ($scope, $state, TPopFixture, TPopFixtureSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopFixtureSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPopFixture.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPopFixtures = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopEquipmentDialogController', TPopEquipmentDialogController);

    TPopEquipmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPopEquipment', 'TPop', 'Equipment'];

    function TPopEquipmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPopEquipment, TPop, Equipment) {
        var vm = this;
        vm.tPopEquipment = entity;
        vm.tpops = TPop.query();
        vm.equipment = Equipment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopEquipmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPopEquipment.id !== null) {
                TPopEquipment.update(vm.tPopEquipment, onSaveSuccess, onSaveError);
            } else {
                TPopEquipment.save(vm.tPopEquipment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopEquipmentDetailController', TPopEquipmentDetailController);

    TPopEquipmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPopEquipment', 'TPop', 'Equipment'];

    function TPopEquipmentDetailController($scope, $rootScope, $stateParams, entity, TPopEquipment, TPop, Equipment) {
        var vm = this;
        vm.tPopEquipment = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopEquipmentUpdate', function(event, result) {
            vm.tPopEquipment = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopEquipmentDeleteController',TPopEquipmentDeleteController);

    TPopEquipmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPopEquipment'];

    function TPopEquipmentDeleteController($uibModalInstance, entity, TPopEquipment) {
        var vm = this;
        vm.tPopEquipment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPopEquipment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop-equipment', {
//            parent: 'entity',
//            url: '/t-pop-equipment?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopEquipment.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-equipment/t-pop-equipments.html',
//                    controller: 'TPopEquipmentController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopEquipment');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-equipment-detail', {
//            parent: 'entity',
//            url: '/t-pop-equipment/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopEquipment.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-equipment/t-pop-equipment-detail.html',
//                    controller: 'TPopEquipmentDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopEquipment');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPopEquipment', function($stateParams, TPopEquipment) {
//                    return TPopEquipment.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop-equipment.new', {
//            parent: 't-pop-equipment',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-equipment/t-pop-equipment-dialog.html',
//                    controller: 'TPopEquipmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                formNo: null,
//                                value: null,
//                                target: null,
//                                remarks: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop-equipment');
//                });
//            }]
//        })
//        .state('t-pop-equipment.edit', {
//            parent: 't-pop-equipment',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-equipment/t-pop-equipment-dialog.html',
//                    controller: 'TPopEquipmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPopEquipment', function(TPopEquipment) {
//                            return TPopEquipment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop-equipment.delete', {
//            parent: 't-pop-equipment',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-equipment/t-pop-equipment-delete-dialog.html',
//                    controller: 'TPopEquipmentDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPopEquipment', function(TPopEquipment) {
//                            return TPopEquipment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPopEquipment', TPopEquipment);

    TPopEquipment.$inject = ['$resource'];

    function TPopEquipment ($resource) {
        var resourceUrl =  'api/t-pop-equipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopEquipmentSearch', TPopEquipmentSearch);

    TPopEquipmentSearch.$inject = ['$resource'];

    function TPopEquipmentSearch($resource) {
        var resourceUrl =  'api/_search/t-pop-equipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopEquipmentController', TPopEquipmentController);

    TPopEquipmentController.$inject = ['$scope', '$state', 'TPopEquipment', 'TPopEquipmentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopEquipmentController ($scope, $state, TPopEquipment, TPopEquipmentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopEquipmentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPopEquipment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPopEquipments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDtlDialogController', TPopDtlDialogController);

    TPopDtlDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPopDtl', 'TPop', 'Pop', 'Product'];

    function TPopDtlDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPopDtl, TPop, Pop, Product) {
        var vm = this;
        vm.tPopDtl = entity;
        vm.tpops = TPop.query();
        vm.pops = Pop.query();
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopDtlUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPopDtl.id !== null) {
                TPopDtl.update(vm.tPopDtl, onSaveSuccess, onSaveError);
            } else {
                TPopDtl.save(vm.tPopDtl, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDtlDetailController', TPopDtlDetailController);

    TPopDtlDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPopDtl', 'TPop', 'Pop', 'Product'];

    function TPopDtlDetailController($scope, $rootScope, $stateParams, entity, TPopDtl, TPop, Pop, Product) {
        var vm = this;
        vm.tPopDtl = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopDtlUpdate', function(event, result) {
            vm.tPopDtl = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDtlDeleteController',TPopDtlDeleteController);

    TPopDtlDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPopDtl'];

    function TPopDtlDeleteController($uibModalInstance, entity, TPopDtl) {
        var vm = this;
        vm.tPopDtl = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPopDtl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop-dtl', {
//            parent: 'entity',
//            url: '/t-pop-dtl?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopDtl.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-dtl/t-pop-dtls.html',
//                    controller: 'TPopDtlController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopDtl');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-dtl-detail', {
//            parent: 'entity',
//            url: '/t-pop-dtl/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPopDtl.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop-dtl/t-pop-dtl-detail.html',
//                    controller: 'TPopDtlDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPopDtl');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPopDtl', function($stateParams, TPopDtl) {
//                    return TPopDtl.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop-dtl.new', {
//            parent: 't-pop-dtl',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-dtl/t-pop-dtl-dialog.html',
//                    controller: 'TPopDtlDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                qty: null,
//                                formNo: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-dtl', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop-dtl');
//                });
//            }]
//        })
//        .state('t-pop-dtl.edit', {
//            parent: 't-pop-dtl',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-dtl/t-pop-dtl-dialog.html',
//                    controller: 'TPopDtlDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPopDtl', function(TPopDtl) {
//                            return TPopDtl.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-dtl', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop-dtl.delete', {
//            parent: 't-pop-dtl',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop-dtl/t-pop-dtl-delete-dialog.html',
//                    controller: 'TPopDtlDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPopDtl', function(TPopDtl) {
//                            return TPopDtl.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop-dtl', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPopDtl', TPopDtl);

    TPopDtl.$inject = ['$resource'];

    function TPopDtl ($resource) {
        var resourceUrl =  'api/t-pop-dtls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopDtlSearch', TPopDtlSearch);

    TPopDtlSearch.$inject = ['$resource'];

    function TPopDtlSearch($resource) {
        var resourceUrl =  'api/_search/t-pop-dtls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDtlController', TPopDtlController);

    TPopDtlController.$inject = ['$scope', '$state', 'TPopDtl', 'TPopDtlSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopDtlController ($scope, $state, TPopDtl, TPopDtlSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopDtlSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPopDtl.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPopDtls = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDialogController', TPopDialogController);

    TPopDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TPop', 'Employee', 'Outlet', 'TicketOrder'];

    function TPopDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TPop, Employee, Outlet, TicketOrder) {
        var vm = this;
        vm.tPop = entity;
        vm.employees = Employee.query();
        vm.outlets = Outlet.query();
        vm.ticketorders = TicketOrder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tPopUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tPop.id !== null) {
                TPop.update(vm.tPop, onSaveSuccess, onSaveError);
            } else {
                TPop.save(vm.tPop, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.submitDate = false;
        vm.datePickerOpenStatus.surveyStart = false;
        vm.datePickerOpenStatus.surveyEnd = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDetailController', TPopDetailController);

    TPopDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TPop', 'Employee', 'Outlet', 'TicketOrder'];

    function TPopDetailController($scope, $rootScope, $stateParams, entity, TPop, Employee, Outlet, TicketOrder) {
        var vm = this;
        vm.tPop = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tPopUpdate', function(event, result) {
            vm.tPop = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopDeleteController',TPopDeleteController);

    TPopDeleteController.$inject = ['$uibModalInstance', 'entity', 'TPop'];

    function TPopDeleteController($uibModalInstance, entity, TPop) {
        var vm = this;
        vm.tPop = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TPop.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('t-pop', {
//            parent: 'entity',
//            url: '/t-pop?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPop.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop/t-pops.html',
//                    controller: 'TPopController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPop');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('t-pop-detail', {
//            parent: 'entity',
//            url: '/t-pop/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.tPop.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/t-pop/t-pop-detail.html',
//                    controller: 'TPopDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('tPop');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'TPop', function($stateParams, TPop) {
//                    return TPop.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('t-pop.new', {
//            parent: 't-pop',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop/t-pop-dialog.html',
//                    controller: 'TPopDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                submitDate: null,
//                                surveyStart: null,
//                                surveyEnd: null,
//                                formNo: null,
//                                value: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop', null, { reload: true });
//                }, function() {
//                    $state.go('t-pop');
//                });
//            }]
//        })
//        .state('t-pop.edit', {
//            parent: 't-pop',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop/t-pop-dialog.html',
//                    controller: 'TPopDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['TPop', function(TPop) {
//                            return TPop.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('t-pop.delete', {
//            parent: 't-pop',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/t-pop/t-pop-delete-dialog.html',
//                    controller: 'TPopDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['TPop', function(TPop) {
//                            return TPop.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('t-pop', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TPop', TPop);

    TPop.$inject = ['$resource', 'DateUtils'];

    function TPop ($resource, DateUtils) {
        var resourceUrl =  'api/t-pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.submitDate = DateUtils.convertDateTimeFromServer(data.submitDate);
                    data.surveyStart = DateUtils.convertDateTimeFromServer(data.surveyStart);
                    data.surveyEnd = DateUtils.convertDateTimeFromServer(data.surveyEnd);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TPopSearch', TPopSearch);

    TPopSearch.$inject = ['$resource'];

    function TPopSearch($resource) {
        var resourceUrl =  'api/_search/t-pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TPopController', TPopController);

    TPopController.$inject = ['$scope', '$state', 'TPop', 'TPopSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TPopController ($scope, $state, TPop, TPopSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TPopSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TPop.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tPops = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TFileImageOtherJobDialogController', TFileImageOtherJobDialogController);

    TFileImageOtherJobDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TFileImageOtherJob'];

    function TFileImageOtherJobDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TFileImageOtherJob) {
        var vm = this;
        vm.tFileImageOtherJob = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:tFileImageOtherJobUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tFileImageOtherJob.id !== null) {
                TFileImageOtherJob.update(vm.tFileImageOtherJob, onSaveSuccess, onSaveError);
            } else {
                TFileImageOtherJob.save(vm.tFileImageOtherJob, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.createdDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TFileImageOtherJobDetailController', TFileImageOtherJobDetailController);

    TFileImageOtherJobDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TFileImageOtherJob'];

    function TFileImageOtherJobDetailController($scope, $rootScope, $stateParams, entity, TFileImageOtherJob) {
        var vm = this;
        vm.tFileImageOtherJob = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:tFileImageOtherJobUpdate', function(event, result) {
            vm.tFileImageOtherJob = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TFileImageOtherJobDeleteController',TFileImageOtherJobDeleteController);

    TFileImageOtherJobDeleteController.$inject = ['$uibModalInstance', 'entity', 'TFileImageOtherJob'];

    function TFileImageOtherJobDeleteController($uibModalInstance, entity, TFileImageOtherJob) {
        var vm = this;
        vm.tFileImageOtherJob = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TFileImageOtherJob.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('t-file-image-other-job', {
            parent: 'entity',
            url: '/t-file-image-other-job?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.tFileImageOtherJob.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/t-file-image-other-job/t-file-image-other-jobs.html',
                    controller: 'TFileImageOtherJobController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tFileImageOtherJob');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('t-file-image-other-job-detail', {
            parent: 'entity',
            url: '/t-file-image-other-job/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.tFileImageOtherJob.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/t-file-image-other-job/t-file-image-other-job-detail.html',
                    controller: 'TFileImageOtherJobDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tFileImageOtherJob');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TFileImageOtherJob', function($stateParams, TFileImageOtherJob) {
                    return TFileImageOtherJob.get({id : $stateParams.id});
                }]
            }
        })
        .state('t-file-image-other-job.new', {
            parent: 't-file-image-other-job',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/t-file-image-other-job/t-file-image-other-job-dialog.html',
                    controller: 'TFileImageOtherJobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdDate: null,
                                filePath: null,
                                fileName: null,
                                longitudeX: null,
                                latitudeY: null,
                                fileDesc: null,
                                formNo: null,
                                fileFlag: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('t-file-image-other-job', null, { reload: true });
                }, function() {
                    $state.go('t-file-image-other-job');
                });
            }]
        })
        .state('t-file-image-other-job.edit', {
            parent: 't-file-image-other-job',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/t-file-image-other-job/t-file-image-other-job-dialog.html',
                    controller: 'TFileImageOtherJobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TFileImageOtherJob', function(TFileImageOtherJob) {
                            return TFileImageOtherJob.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('t-file-image-other-job', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('t-file-image-other-job.delete', {
            parent: 't-file-image-other-job',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/t-file-image-other-job/t-file-image-other-job-delete-dialog.html',
                    controller: 'TFileImageOtherJobDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TFileImageOtherJob', function(TFileImageOtherJob) {
                            return TFileImageOtherJob.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('t-file-image-other-job', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('TFileImageOtherJob', TFileImageOtherJob);

    TFileImageOtherJob.$inject = ['$resource', 'DateUtils'];

    function TFileImageOtherJob ($resource, DateUtils) {
        var resourceUrl =  'api/file-image-other-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.createdDate = DateUtils.convertLocalDateToServer(data.createdDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.createdDate = DateUtils.convertLocalDateToServer(data.createdDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('TFileImageOtherJobSearch', TFileImageOtherJobSearch);

    TFileImageOtherJobSearch.$inject = ['$resource'];

    function TFileImageOtherJobSearch($resource) {
        var resourceUrl =  'api/_search/t-file-image-other-jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('TFileImageOtherJobController', TFileImageOtherJobController);

    TFileImageOtherJobController.$inject = ['$scope', '$state', 'TFileImageOtherJob', 'TFileImageOtherJobSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TFileImageOtherJobController ($scope, $state, TFileImageOtherJob, TFileImageOtherJobSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TFileImageOtherJobSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TFileImageOtherJob.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tFileImageOtherJobs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('StoreCompletenessDialogController', StoreCompletenessDialogController);

    StoreCompletenessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StoreCompleteness', 'StoreCompletenessSearch'];

    function StoreCompletenessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StoreCompleteness, StoreCompletenessSearch) {
        var vm = this;
        vm.storeCompleteness = entity;
        vm.getParent = getParent;
        vm.loadingParent = false;
        //vm.storecompletenesses = StoreCompleteness.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        vm.onSelectParent = function(item, model, label) {
            vm.storeCompleteness.parentId = model.id;
            vm.storeCompleteness.parentDescription = model.description;
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:storeCompletenessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.storeCompleteness.id !== null) {
                StoreCompleteness.update(vm.storeCompleteness, onSaveSuccess, onSaveError);
            } else {
                StoreCompleteness.save(vm.storeCompleteness, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function getParent(value) {
			vm.loadingParent = true;
			return StoreCompletenessSearch.query({
				query : '*' + value + '*'
			}).$promise.then(function(response) {
				vm.loadingParent = false;
				return response;
			}, function(response) {
				vm.loadingParent = false;
				AlertService.error(response.data.message);
			});
		}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('StoreCompletenessDetailController', StoreCompletenessDetailController);

    StoreCompletenessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'StoreCompleteness'];

    function StoreCompletenessDetailController($scope, $rootScope, $stateParams, entity, StoreCompleteness) {
        var vm = this;
        vm.storeCompleteness = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:storeCompletenessUpdate', function(event, result) {
            vm.storeCompleteness = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('StoreCompletenessDeleteController',StoreCompletenessDeleteController);

    StoreCompletenessDeleteController.$inject = ['$uibModalInstance', 'entity', 'StoreCompleteness'];

    function StoreCompletenessDeleteController($uibModalInstance, entity, StoreCompleteness) {
        var vm = this;
        vm.storeCompleteness = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            StoreCompleteness.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('store-completeness', {
            parent: 'entity',
            url: '/store-completeness?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.storeCompleteness.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-completeness/store-completenesses.html',
                    controller: 'StoreCompletenessController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeCompleteness');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-completeness-detail', {
            parent: 'entity',
            url: '/store-completeness/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.storeCompleteness.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store-completeness/store-completeness-detail.html',
                    controller: 'StoreCompletenessDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storeCompleteness');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StoreCompleteness', function($stateParams, StoreCompleteness) {
                    return StoreCompleteness.get({id : $stateParams.id});
                }]
            }
        })
        .state('store-completeness.new', {
            parent: 'store-completeness',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-completeness/store-completeness-dialog.html',
                    controller: 'StoreCompletenessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sequence: null,
                                description: null,
                                insertable: null,
                                deleted: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('store-completeness', null, { reload: true });
                }, function() {
                    $state.go('store-completeness');
                });
            }]
        })
        .state('store-completeness.edit', {
            parent: 'store-completeness',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-completeness/store-completeness-dialog.html',
                    controller: 'StoreCompletenessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StoreCompleteness', function(StoreCompleteness) {
                            return StoreCompleteness.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('store-completeness', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('store-completeness.delete', {
            parent: 'store-completeness',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store-completeness/store-completeness-delete-dialog.html',
                    controller: 'StoreCompletenessDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StoreCompleteness', function(StoreCompleteness) {
                            return StoreCompleteness.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('store-completeness', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('StoreCompleteness', StoreCompleteness);

    StoreCompleteness.$inject = ['$resource'];

    function StoreCompleteness ($resource) {
        var resourceUrl =  'api/store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('StoreCompletenessSearch', StoreCompletenessSearch);

    StoreCompletenessSearch.$inject = ['$resource'];

    function StoreCompletenessSearch($resource) {
        var resourceUrl =  'api/_search/store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('StoreCompletenessController', StoreCompletenessController);

    StoreCompletenessController.$inject = ['$scope', '$state', 'StoreCompleteness', 'StoreCompletenessSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function StoreCompletenessController ($scope, $state, StoreCompleteness, StoreCompletenessSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                StoreCompletenessSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                StoreCompleteness.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.storeCompletenesses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SelloutDialogController', SelloutDialogController);

    SelloutDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sellout', 'Outlet', 'ProductCategory', 'OutletSearch'];

    function SelloutDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sellout, Outlet, ProductCategory, OutletSearch) {
        var vm = this;
        vm.sellout = entity;
        vm.outlets = Outlet.query();
        vm.loadingOutlet = false;
        vm.getOutlet = getOutlet;
        vm.productcategories = ProductCategory.getAllProductCategories({level:2});
        vm.outlet = null;
        
        if (vm.sellout.$promise) {
        	vm.sellout.$promise.then(function(data) {
        		vm.outlet = {
					"id" : data.outletId,
					"outletName" : data.outletOutletName
				}
        		if(vm.outlet == null){
        			vm.outlet = null;
	       		}
			}, function(error) {
				console.log(error);
			});
		}
        
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:selloutUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.outlet){
            	vm.sellout.outletId = vm.outlet.id;
            }else{
            	vm.sellout.outletId = null;
            }	
            if (vm.sellout.id !== null) {
                Sellout.update(vm.sellout, onSaveSuccess, onSaveError);
            } else {
                Sellout.save(vm.sellout, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function getOutlet(value) {
        	vm.loadingOutlet = true;
            return OutletSearch.query({
            	query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingOutlet = false;
                return response;
            }, function(response){
            	vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SelloutDetailController', SelloutDetailController);

    SelloutDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Sellout', 'Outlet', 'ProductCategory'];

    function SelloutDetailController($scope, $rootScope, $stateParams, entity, Sellout, Outlet, ProductCategory) {
        var vm = this;
        vm.sellout = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:selloutUpdate', function(event, result) {
            vm.sellout = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SelloutDeleteController',SelloutDeleteController);

    SelloutDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sellout'];

    function SelloutDeleteController($uibModalInstance, entity, Sellout) {
        var vm = this;
        vm.sellout = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Sellout.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sellout', {
            parent: 'entity',
            url: '/sellout?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.sellout.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sellout/sellouts.html',
                    controller: 'SelloutController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sellout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sellout-detail', {
            parent: 'entity',
            url: '/sellout/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.sellout.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sellout/sellout-detail.html',
                    controller: 'SelloutDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sellout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sellout', function($stateParams, Sellout) {
                    return Sellout.get({id : $stateParams.id});
                }]
            }
        })
        .state('sellout.new', {
            parent: 'sellout',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sellout/sellout-dialog.html',
                    controller: 'SelloutDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                month: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sellout', null, { reload: true });
                }, function() {
                    $state.go('sellout');
                });
            }]
        })
        .state('sellout.edit', {
            parent: 'sellout',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sellout/sellout-dialog.html',
                    controller: 'SelloutDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sellout', function(Sellout) {
                            return Sellout.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sellout', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sellout.delete', {
            parent: 'sellout',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sellout/sellout-delete-dialog.html',
                    controller: 'SelloutDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sellout', function(Sellout) {
                            return Sellout.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sellout', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Sellout', Sellout);

    Sellout.$inject = ['$resource'];

    function Sellout ($resource) {
        var resourceUrl =  'api/sellouts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('SelloutSearch', SelloutSearch);

    SelloutSearch.$inject = ['$resource'];

    function SelloutSearch($resource) {
        var resourceUrl =  'api/_search/sellouts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SelloutController', SelloutController);

    SelloutController.$inject = ['$scope', '$state', 'Sellout', 'SelloutSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SelloutController ($scope, $state, Sellout, SelloutSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SelloutSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Sellout.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sellouts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RisProductTargetImportController', RisProductTargetImportController);

    RisProductTargetImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function RisProductTargetImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/ris-product-targets/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RisProductTargetDialogController', RisProductTargetDialogController);

    RisProductTargetDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RisProductTarget', 'Outlet', 'OutletSearch', 'Product', 'ProductSearch'];

    function RisProductTargetDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, RisProductTarget, Outlet, OutletSearch, Product, ProductSearch) {
        var vm = this;

        vm.clear = clear;
        vm.getOutlet = getOutlet;
        vm.getProduct = getProduct;
        vm.save = save;

        vm.risProductTarget = entity;
        vm.products = Product.query();

        if (vm.risProductTarget.$promise) {
            vm.risProductTarget.$promise.then(function (data) {
                if (data.outletId != null) {
                    Outlet.get({ id: data.outletId }, function (outlet) {
                        vm.outlet = outlet;
                    });
                }
                if (data.productId != null) {
                    Product.get({ id: data.productId }, function (product) {
                        vm.product = product;
                    });
                }
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.outlet) {
                vm.risProductTarget.outletId = vm.outlet.id;
                vm.risProductTarget.outletOutletCode = vm.outlet.outletCode;
            }

            if (vm.product) {
                vm.risProductTarget.productId = vm.product.id;
                vm.risProductTarget.productProductCode = vm.product.productCode;
            }

            if (vm.risProductTarget.id !== null) {
                RisProductTarget.update(vm.risProductTarget, onSaveSuccess, onSaveError);
            } else {
                RisProductTarget.save(vm.risProductTarget, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('sceaApp:risProductTargetUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getOutlet(value) {
            vm.loadingOutlet = true;
            return OutletSearch.query({
                query: '*' + value + '*'
            }).$promise.then(function (response) {
                vm.loadingOutlet = false;
                return response;
            }, function (response) {
                vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        }

        function getProduct(value) {
            vm.loadingProduct = true;
            return ProductSearch.query({
                query: '*' + value + '*'
            }).$promise.then(function (response) {
                vm.loadingProduct = false;
                return response;
            }, function (response) {
                vm.loadingProduct = false;
                AlertService.error(response.data.message);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RisProductTargetDetailController', RisProductTargetDetailController);

    RisProductTargetDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RisProductTarget', 'Outlet', 'Product'];

    function RisProductTargetDetailController($scope, $rootScope, $stateParams, previousState, entity, RisProductTarget, Outlet, Product) {
        var vm = this;

        vm.risProductTarget = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sceaApp:risProductTargetUpdate', function(event, result) {
            vm.risProductTarget = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RisProductTargetDeleteController',RisProductTargetDeleteController);

    RisProductTargetDeleteController.$inject = ['$uibModalInstance', 'entity', 'RisProductTarget'];

    function RisProductTargetDeleteController($uibModalInstance, entity, RisProductTarget) {
        var vm = this;

        vm.risProductTarget = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RisProductTarget.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ris-product-target', {
            parent: 'entity',
            url: '/ris-product-target?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.risProductTarget.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ris-product-target/ris-product-targets.html',
                    controller: 'RisProductTargetController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('risProductTarget');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ris-product-target-detail', {
            parent: 'entity',
            url: '/ris-product-target/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.risProductTarget.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-detail.html',
                    controller: 'RisProductTargetDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('risProductTarget');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RisProductTarget', function($stateParams, RisProductTarget) {
                    return RisProductTarget.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ris-product-target',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ris-product-target-detail.edit', {
            parent: 'ris-product-target-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-dialog.html',
                    controller: 'RisProductTargetDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RisProductTarget', function(RisProductTarget) {
                            return RisProductTarget.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ris-product-target.new', {
            parent: 'ris-product-target',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-dialog.html',
                    controller: 'RisProductTargetDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                target: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ris-product-target', null, { reload: 'ris-product-target' });
                }, function() {
                    $state.go('ris-product-target');
                });
            }]
        })
        .state('ris-product-target.edit', {
            parent: 'ris-product-target',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-dialog.html',
                    controller: 'RisProductTargetDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RisProductTarget', function(RisProductTarget) {
                            return RisProductTarget.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ris-product-target', null, { reload: 'ris-product-target' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ris-product-target.delete', {
            parent: 'ris-product-target',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-delete-dialog.html',
                    controller: 'RisProductTargetDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RisProductTarget', function(RisProductTarget) {
                            return RisProductTarget.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ris-product-target', null, { reload: 'ris-product-target' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ris-product-target-import',{
            parent: 'entity',
            url: '/ris-product-target-import',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.risProductTarget.import.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ris-product-target/ris-product-target-import.html',
                    controller: 'RisProductTargetImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('risProductTarget');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ris-product-target',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('RisProductTarget', RisProductTarget);

    RisProductTarget.$inject = ['$resource'];

    function RisProductTarget ($resource) {
        var resourceUrl =  'api/ris-product-targets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('RisProductTargetSearch', RisProductTargetSearch);

    RisProductTargetSearch.$inject = ['$resource'];

    function RisProductTargetSearch($resource) {
        var resourceUrl =  'api/_search/ris-product-targets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RisProductTargetController', RisProductTargetController);

    RisProductTargetController.$inject = ['$state', 'RisProductTarget', 'RisProductTargetSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RisProductTargetController($state, RisProductTarget, RisProductTargetSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RisProductTargetSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RisProductTarget.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.risProductTargets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingSubCategoryDialogController', RetailMappingSubCategoryDialogController);

    RetailMappingSubCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RetailMappingSubCategory', 'RetailMappingCategory'];

    function RetailMappingSubCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RetailMappingSubCategory, RetailMappingCategory) {
        var vm = this;
        vm.retailMappingSubCategory = entity;
        vm.retailmappingcategories = RetailMappingCategory.query();
        vm.retailmappingsubcategories = RetailMappingSubCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:retailMappingSubCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.retailMappingSubCategory.id !== null) {
                RetailMappingSubCategory.update(vm.retailMappingSubCategory, onSaveSuccess, onSaveError);
            } else {
                RetailMappingSubCategory.save(vm.retailMappingSubCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingSubCategoryDetailController', RetailMappingSubCategoryDetailController);

    RetailMappingSubCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RetailMappingSubCategory', 'RetailMappingCategory'];

    function RetailMappingSubCategoryDetailController($scope, $rootScope, $stateParams, entity, RetailMappingSubCategory, RetailMappingCategory) {
        var vm = this;
        vm.retailMappingSubCategory = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:retailMappingSubCategoryUpdate', function(event, result) {
            vm.retailMappingSubCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingSubCategoryDeleteController',RetailMappingSubCategoryDeleteController);

    RetailMappingSubCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'RetailMappingSubCategory'];

    function RetailMappingSubCategoryDeleteController($uibModalInstance, entity, RetailMappingSubCategory) {
        var vm = this;
        vm.retailMappingSubCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RetailMappingSubCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('retail-mapping-sub-category', {
            parent: 'entity',
            url: '/retail-mapping-sub-category?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingSubCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-sub-category/retail-mapping-sub-categories.html',
                    controller: 'RetailMappingSubCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingSubCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('retail-mapping-sub-category-detail', {
            parent: 'entity',
            url: '/retail-mapping-sub-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingSubCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-sub-category/retail-mapping-sub-category-detail.html',
                    controller: 'RetailMappingSubCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingSubCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RetailMappingSubCategory', function($stateParams, RetailMappingSubCategory) {
                    return RetailMappingSubCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('retail-mapping-sub-category.new', {
            parent: 'retail-mapping-sub-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-sub-category/retail-mapping-sub-category-dialog.html',
                    controller: 'RetailMappingSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-sub-category', null, { reload: true });
                }, function() {
                    $state.go('retail-mapping-sub-category');
                });
            }]
        })
        .state('retail-mapping-sub-category.edit', {
            parent: 'retail-mapping-sub-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-sub-category/retail-mapping-sub-category-dialog.html',
                    controller: 'RetailMappingSubCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RetailMappingSubCategory', function(RetailMappingSubCategory) {
                            return RetailMappingSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('retail-mapping-sub-category.delete', {
            parent: 'retail-mapping-sub-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-sub-category/retail-mapping-sub-category-delete-dialog.html',
                    controller: 'RetailMappingSubCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RetailMappingSubCategory', function(RetailMappingSubCategory) {
                            return RetailMappingSubCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-sub-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('RetailMappingSubCategory', RetailMappingSubCategory);

    RetailMappingSubCategory.$inject = ['$resource'];

    function RetailMappingSubCategory ($resource) {
        var resourceUrl =  'api/retail-mapping-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('RetailMappingSubCategorySearch', RetailMappingSubCategorySearch);

    RetailMappingSubCategorySearch.$inject = ['$resource'];

    function RetailMappingSubCategorySearch($resource) {
        var resourceUrl =  'api/_search/retail-mapping-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingSubCategoryController', RetailMappingSubCategoryController);

    RetailMappingSubCategoryController.$inject = ['$scope', '$state', 'RetailMappingSubCategory', 'RetailMappingSubCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RetailMappingSubCategoryController ($scope, $state, RetailMappingSubCategory, RetailMappingSubCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RetailMappingSubCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RetailMappingSubCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.retailMappingSubCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingPhotoCategoryDialogController', RetailMappingPhotoCategoryDialogController);

    RetailMappingPhotoCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RetailMappingPhotoCategory'];

    function RetailMappingPhotoCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RetailMappingPhotoCategory) {
        var vm = this;
        vm.retailMappingPhotoCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:retailMappingPhotoCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.retailMappingPhotoCategory.id !== null) {
                RetailMappingPhotoCategory.update(vm.retailMappingPhotoCategory, onSaveSuccess, onSaveError);
            } else {
                RetailMappingPhotoCategory.save(vm.retailMappingPhotoCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingPhotoCategoryDetailController', RetailMappingPhotoCategoryDetailController);

    RetailMappingPhotoCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RetailMappingPhotoCategory'];

    function RetailMappingPhotoCategoryDetailController($scope, $rootScope, $stateParams, entity, RetailMappingPhotoCategory) {
        var vm = this;
        vm.retailMappingPhotoCategory = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:retailMappingPhotoCategoryUpdate', function(event, result) {
            vm.retailMappingPhotoCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingPhotoCategoryDeleteController',RetailMappingPhotoCategoryDeleteController);

    RetailMappingPhotoCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'RetailMappingPhotoCategory'];

    function RetailMappingPhotoCategoryDeleteController($uibModalInstance, entity, RetailMappingPhotoCategory) {
        var vm = this;
        vm.retailMappingPhotoCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RetailMappingPhotoCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('retail-mapping-photo-category', {
            parent: 'entity',
            url: '/retail-mapping-photo-category?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingPhotoCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-photo-category/retail-mapping-photo-categories.html',
                    controller: 'RetailMappingPhotoCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingPhotoCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('retail-mapping-photo-category-detail', {
            parent: 'entity',
            url: '/retail-mapping-photo-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingPhotoCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-photo-category/retail-mapping-photo-category-detail.html',
                    controller: 'RetailMappingPhotoCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingPhotoCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RetailMappingPhotoCategory', function($stateParams, RetailMappingPhotoCategory) {
                    return RetailMappingPhotoCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('retail-mapping-photo-category.new', {
            parent: 'retail-mapping-photo-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-photo-category/retail-mapping-photo-category-dialog.html',
                    controller: 'RetailMappingPhotoCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-photo-category', null, { reload: true });
                }, function() {
                    $state.go('retail-mapping-photo-category');
                });
            }]
        })
        .state('retail-mapping-photo-category.edit', {
            parent: 'retail-mapping-photo-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-photo-category/retail-mapping-photo-category-dialog.html',
                    controller: 'RetailMappingPhotoCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RetailMappingPhotoCategory', function(RetailMappingPhotoCategory) {
                            return RetailMappingPhotoCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-photo-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('retail-mapping-photo-category.delete', {
            parent: 'retail-mapping-photo-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-photo-category/retail-mapping-photo-category-delete-dialog.html',
                    controller: 'RetailMappingPhotoCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RetailMappingPhotoCategory', function(RetailMappingPhotoCategory) {
                            return RetailMappingPhotoCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-photo-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('RetailMappingPhotoCategory', RetailMappingPhotoCategory);

    RetailMappingPhotoCategory.$inject = ['$resource'];

    function RetailMappingPhotoCategory ($resource) {
        var resourceUrl =  'api/retail-mapping-photo-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('RetailMappingPhotoCategorySearch', RetailMappingPhotoCategorySearch);

    RetailMappingPhotoCategorySearch.$inject = ['$resource'];

    function RetailMappingPhotoCategorySearch($resource) {
        var resourceUrl =  'api/_search/retail-mapping-photo-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingPhotoCategoryController', RetailMappingPhotoCategoryController);

    RetailMappingPhotoCategoryController.$inject = ['$scope', '$state', 'RetailMappingPhotoCategory', 'RetailMappingPhotoCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RetailMappingPhotoCategoryController ($scope, $state, RetailMappingPhotoCategory, RetailMappingPhotoCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RetailMappingPhotoCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RetailMappingPhotoCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.retailMappingPhotoCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingCategoryDialogController', RetailMappingCategoryDialogController);

    RetailMappingCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RetailMappingCategory'];

    function RetailMappingCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RetailMappingCategory) {
        var vm = this;
        vm.retailMappingCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:retailMappingCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.retailMappingCategory.id !== null) {
                RetailMappingCategory.update(vm.retailMappingCategory, onSaveSuccess, onSaveError);
            } else {
                RetailMappingCategory.save(vm.retailMappingCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingCategoryDetailController', RetailMappingCategoryDetailController);

    RetailMappingCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RetailMappingCategory'];

    function RetailMappingCategoryDetailController($scope, $rootScope, $stateParams, entity, RetailMappingCategory) {
        var vm = this;
        vm.retailMappingCategory = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:retailMappingCategoryUpdate', function(event, result) {
            vm.retailMappingCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingCategoryDeleteController',RetailMappingCategoryDeleteController);

    RetailMappingCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'RetailMappingCategory'];

    function RetailMappingCategoryDeleteController($uibModalInstance, entity, RetailMappingCategory) {
        var vm = this;
        vm.retailMappingCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            RetailMappingCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('retail-mapping-category', {
            parent: 'entity',
            url: '/retail-mapping-category?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-category/retail-mapping-categories.html',
                    controller: 'RetailMappingCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingCategory');
                    $translatePartialLoader.addPart('division');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('retail-mapping-category-detail', {
            parent: 'entity',
            url: '/retail-mapping-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.retailMappingCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/retail-mapping-category/retail-mapping-category-detail.html',
                    controller: 'RetailMappingCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('retailMappingCategory');
                    $translatePartialLoader.addPart('division');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RetailMappingCategory', function($stateParams, RetailMappingCategory) {
                    return RetailMappingCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('retail-mapping-category.new', {
            parent: 'retail-mapping-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-category/retail-mapping-category-dialog.html',
                    controller: 'RetailMappingCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                division: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-category', null, { reload: true });
                }, function() {
                    $state.go('retail-mapping-category');
                });
            }]
        })
        .state('retail-mapping-category.edit', {
            parent: 'retail-mapping-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-category/retail-mapping-category-dialog.html',
                    controller: 'RetailMappingCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RetailMappingCategory', function(RetailMappingCategory) {
                            return RetailMappingCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('retail-mapping-category.delete', {
            parent: 'retail-mapping-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/retail-mapping-category/retail-mapping-category-delete-dialog.html',
                    controller: 'RetailMappingCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RetailMappingCategory', function(RetailMappingCategory) {
                            return RetailMappingCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('retail-mapping-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('RetailMappingCategory', RetailMappingCategory);

    RetailMappingCategory.$inject = ['$resource'];

    function RetailMappingCategory ($resource) {
        var resourceUrl =  'api/retail-mapping-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('RetailMappingCategorySearch', RetailMappingCategorySearch);

    RetailMappingCategorySearch.$inject = ['$resource'];

    function RetailMappingCategorySearch($resource) {
        var resourceUrl =  'api/_search/retail-mapping-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RetailMappingCategoryController', RetailMappingCategoryController);

    RetailMappingCategoryController.$inject = ['$scope', '$state', 'RetailMappingCategory', 'RetailMappingCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RetailMappingCategoryController ($scope, $state, RetailMappingCategory, RetailMappingCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RetailMappingCategorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RetailMappingCategory.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.retailMappingCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDtlDialogController', PromotionDtlDialogController);

    PromotionDtlDialogController.$inject = ['$location', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'AlertService', 'promotion', 'entity', 'PromotionDtl', 'Outlet', 'OutletSearch', 'PromoMaterial', 'PromoMaterialSearch'];

    function PromotionDtlDialogController ($location, $timeout, $scope, $stateParams, $uibModalInstance, AlertService, promotion, entity, PromotionDtl, Outlet, OutletSearch, PromoMaterial, PromoMaterialSearch) {
        var vm = this;

        vm.clear = clear;
        vm.getPromoMaterial = getPromoMaterial;
        vm.getOutlet = getOutlet;

        (function() {
            vm.promotion = promotion;
            vm.promotionDtl = entity;
            
            if(vm.promotion.$promise){
                vm.promotion.$promise.then(function(data) {
                        if(checkExpiredPromotion(data.validUntil)){
                            vm.clear();
                        } else {
                    }
                });
            }

            if(vm.promotionDtl.$promise) {
                vm.promotionDtl.$promise.then(function(data) {
                    if(checkExpiredPromotion(vm.promotion.validUntil)){
                        vm.clear();
                    }

                    if(data.promotionId != null) {
                        PromoMaterial.get({id: data.promoMaterialId}, function(promoMaterial) {
                            vm.promoMaterial = promoMaterial;
                        });
                    }
                    
                    if(data.outletId != null) {
                        Outlet.get({id: data.outletId}, function(outlet) {
                            vm.outlet = outlet;
                        });
                    }
                });
            }
            
        })();

        function checkExpiredPromotion(params) {
            var checkExpired = moment(params).isBefore(moment());
            return (checkExpired) ? true : false;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:promotionDtlUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

            if(vm.promoMaterial) {
            	vm.promotionDtl.promoMaterialId = vm.promoMaterial.id;
                vm.promotionDtl.promoMaterialName = vm.promoMaterial.name;
            }

            if(vm.outlet) {
            	vm.promotionDtl.outletId = vm.outlet.id;
            	vm.promotionDtl.outletOutletName = vm.outlet.outletName;
            }

            if (vm.promotionDtl.id !== null) {
                PromotionDtl.update(vm.promotionDtl, onSaveSuccess, onSaveError);
            } else {
                PromotionDtl.save(vm.promotionDtl, onSaveSuccess, onSaveError);
            }
        };
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        };

        function getPromoMaterial(value) {
        	vm.loadingPromoMaterial = true;
            return PromoMaterialSearch.query({
                query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingPromoMaterial = false;
                return response;
            }, function(response){
            	vm.loadingPromoMaterial = false;
                AlertService.error(response.data.message);
            });
        }
        
        function getOutlet(value) {
        	vm.loadingOutlet = true;
            return OutletSearch.query({
                query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingOutlet = false;
                return response;
            }, function(response){
            	vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDtlDetailController', PromotionDtlDetailController);

    PromotionDtlDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PromotionDtl', 'Outlet', 'PromoMaterial', 'Promotion'];

    function PromotionDtlDetailController($scope, $rootScope, $stateParams, entity, PromotionDtl, Outlet, PromoMaterial, Promotion) {
        var vm = this;
        vm.promotionDtl = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:promotionDtlUpdate', function(event, result) {
            vm.promotionDtl = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDtlDeleteController',PromotionDtlDeleteController);

    PromotionDtlDeleteController.$inject = ['$uibModalInstance', 'promotion', 'entity', 'PromotionDtl'];

    function PromotionDtlDeleteController($uibModalInstance, promotion, entity, PromotionDtl) {
        var vm = this;

        vm.promotion = promotion;
        vm.promotionDtl = entity;

        if(vm.promotionDtl.$promise) {
            vm.promotionDtl.$promise.then(function(data) {
                if(checkExpiredPromotion(vm.promotion.validUntil)){
                    vm.clear();
                }
            });
        }

        function checkExpiredPromotion(params) {
            var checkExpired = moment(params).isBefore(moment());
            return (checkExpired) ? true : false;
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PromotionDtl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
/*
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('promotion-dtl', {
            parent: 'entity',
            url: '/promotion-dtl?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promotionDtl.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtls.html',
                    controller: 'PromotionDtlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promotionDtl');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('promotion-dtl-detail', {
            parent: 'entity',
            url: '/promotion-dtl/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promotionDtl.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-detail.html',
                    controller: 'PromotionDtlDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promotionDtl');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PromotionDtl', function($stateParams, PromotionDtl) {
                    return PromotionDtl.get({id : $stateParams.id});
                }]
            }
        })
        .state('promotion-dtl.new', {
            parent: 'promotion-dtl',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-dialog.html',
                    controller: 'PromotionDtlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                allocationQty: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('promotion-dtl', null, { reload: true });
                }, function() {
                    $state.go('promotion-dtl');
                });
            }]
        })
        .state('promotion-dtl.edit', {
            parent: 'promotion-dtl',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-dialog.html',
                    controller: 'PromotionDtlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PromotionDtl', function(PromotionDtl) {
                            return PromotionDtl.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion-dtl', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promotion-dtl.delete', {
            parent: 'promotion-dtl',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-delete-dialog.html',
                    controller: 'PromotionDtlDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PromotionDtl', function(PromotionDtl) {
                            return PromotionDtl.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion-dtl', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
*/;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PromotionDtl', PromotionDtl);

    PromotionDtl.$inject = ['$resource'];

    function PromotionDtl ($resource) {
        var resourceUrl =  'api/promotion-dtls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByPromotion': {
            	url: 'api/promotions/:promotionId/promotion-dtls',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PromotionDtlSearch', PromotionDtlSearch);

    PromotionDtlSearch.$inject = ['$resource'];

    function PromotionDtlSearch($resource) {
        var resourceUrl =  'api/_search/promotion-dtls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDtlController', PromotionDtlController);

    PromotionDtlController.$inject = ['$scope', '$state', '$stateParams', '$timeout', 'PromotionDtl', 'PromotionDtlSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DataUtils', 'Upload'];

    function PromotionDtlController ($scope, $state, $stateParams, $timeout, PromotionDtl, PromotionDtlSearch, ParseLinks, AlertService, pagingParams, paginationConstants, DataUtils, Upload) {
      var vm = this;
      var parentVm = $scope.$parent.vm;

      vm.validUntil = moment(parentVm.promotion.validUntil).format('DD-MM-YYYY');
      
      vm.checkExpiredPromotion = checkExpiredPromotion;
      vm.loadAll = loadAll;
      vm.loadPage = loadPage;
      vm.predicate = pagingParams.predicate;
      vm.reverse = pagingParams.ascending;
      vm.clear = clear;
      vm.search = search;
      vm.searchQuery = pagingParams.search;
      vm.currentSearch = pagingParams.search;

      vm.setlistOrderData = setlistOrderData;
      vm.upload = upload;
      vm.transition = transition;
      console.log($stateParams.id)
      vm.loadAll();

      function checkExpiredPromotion () {
        var checkExpired = moment($scope.$parent.vm.promotion.validUntil).isAfter(moment());
        return (checkExpired) ? true : false;
      }

      function loadAll () {
          PromotionDtl.queryByPromotion({
          	promotionId: $stateParams.id,
            page: pagingParams.page - 1,
            size: paginationConstants.itemsPerPage,
            sort: sort()
          }, onSuccess, onError);

          function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
          }
          function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.promotionDtls = data;
            vm.page = pagingParams.page;
          }
          function onError(error) {
            AlertService.error(error.data.message);
          }
      }

      function loadPage (page) {
        vm.page = page;
      }

      function search (searchQuery) {
        if (!searchQuery){
          return vm.clear();
        }
        vm.links = null;
        vm.page = 1;
        vm.predicate = '_score';
        vm.reverse = false;
        vm.currentSearch = searchQuery;
      }

      function clear () {
        vm.links = null;
        vm.page = 1;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.currentSearch = null;
      }

      function transition () {
        $state.transitionTo($state.$current, {
            page: vm.page,
            sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            search: vm.currentSearch,
            id: $stateParams.id
        });
    }

      vm.listOrderData = {};

      vm.byteSize = DataUtils.byteSize;
      vm.openFile = DataUtils.openFile;

      function setlistOrderData ($file) {
        if($file) {
          vm.file = $file;
          vm.isUploading = false;
          vm.isUploadFinished = false;

          vm.listOrderData.dataContentType = $file.type;
          vm.listOrderData.fileName = $file.name;
          vm.listOrderData.size = $file.size;
        }
      }

      function upload (file) {
        vm.isUploading = true;

        Upload.upload({
          url: 'api/promotions/' + $stateParams.id + '/promotion-dtls/import',
          promotionId: $stateParams.id,
          file: file
        }).then(function (resp) {
          vm.loadAll();
          $timeout(function () {
            vm.file.result = 'Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data;
          });
        }, function (resp) {
          vm.loadAll();
          if (resp.status > 0) vm.file.error = resp.status + ': ' + resp.data;
          if (resp.headers('x-sceaapp-error') == 'error.importerror') AlertService.error('please check your excel file format');
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          vm.file.progress = 'Progress: ' + progressPercentage + '% ';
        })

        vm.isUploadFinished = true;
      }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDialogController', PromotionDialogController);

    PromotionDialogController.$inject = ['$timeout', '$location', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Promotion'];

    function PromotionDialogController ($timeout, $location, $scope, $stateParams, $uibModalInstance, entity, Promotion) {
        var vm = this;
        
        vm.checkValidDate = checkValidDate;

        (function() {
            vm.promotion = entity;

            if(vm.promotion.$promise) {
                vm.promotion.$promise.then(function(data) {
                    if(checkExpiredPromotion(data)){
                        vm.clear();
                    }
                });
            }
        })();

        function checkExpiredPromotion (params) {
            var checkExpired = moment(params.validUntil).isBefore(moment());
            return (checkExpired) ? true : false;
        }

        vm.date = {
            validFrom: vm.promotion.validFrom ? new Date(moment(vm.promotion.validFrom, formatDate).format()) : new Date(),
            validUntil: vm.promotion.validUntil ? new Date(moment(vm.promotion.validUntil, formatDate).format()) : new Date()
        };

        vm.datePickerOptions = {
            validFrom: { minDate: new Date() }
        };

        if(entity.validFrom != null && entity.validUntil != null) {
            checkValidDate();        	
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:promotionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            var validUntil = moment(vm.promotion.validUntil).endOf('day');
            vm.promotion.validUntil = validUntil._d;
            
            if (vm.promotion.id !== null) {
                Promotion.update(vm.promotion, onSaveSuccess, onSaveError);
            } else {
                Promotion.save(vm.promotion, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {
            validFrom: false,
            validUntil: false
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function checkValidDate(validFrom) {
            if (vm.date.validUntil) {
                vm.date.validUntil = (moment(validFrom).isAfter(vm.date.validUntil)) ? null : vm.date.validUntil;
            } else {
                vm.date.validUntil = new Date(validFrom);
            }

            vm.datePickerOptions.validUntil = {
                minDate: new Date(validFrom),
                initDate: new Date(validFrom)
            };

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDetailController', PromotionDetailController);

    PromotionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Promotion', 'PromotionDtl'];

    function PromotionDetailController($scope, $rootScope, $stateParams, entity, Promotion, PromotionDtl) {
        var vm = this;

        vm.promotion = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:promotionUpdate', function(event, result) {
            vm.promotion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionDeleteController',PromotionDeleteController);

    PromotionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Promotion'];

    function PromotionDeleteController($uibModalInstance, entity, Promotion) {
        var vm = this;

        (function() {
            vm.promotion = entity;

            if(vm.promotion.$promise) {
                vm.promotion.$promise.then(function(data) {
                    if(!checkExpiredPromotion(data)){
                        vm.clear();
                    }
                });
            }
        })();

        function checkExpiredPromotion (params) {
            var checkExpired = moment(params.validUntil).isAfter(moment());
            return (checkExpired) ? true : false;
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        vm.confirmDelete = function (id) {
            Promotion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('promotion', {
            parent: 'entity',
            url: '/promotion?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promotion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promotion/promotions.html',
                    controller: 'PromotionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promotion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('promotion-detail', {
            parent: 'entity',
            url: '/promotion/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promotion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promotion/promotion-detail.html',
                    controller: 'PromotionDetailController',
                    controllerAs: 'vm'
                },
	            'promotion-dtls@promotion-detail': {
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtls.html',
                    controller: 'PromotionDtlController',
                    controllerAs: 'vm'
	            }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promotionDtl');
                    $translatePartialLoader.addPart('promotion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Promotion', function($stateParams, Promotion) {
                    return Promotion.get({id : $stateParams.id});             
                }]
            }
        })
        .state('promotion-dtl-detail', {
            parent: 'promotion-detail',
            url: '/promotion-dtl/{dtlId}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promotionDtl.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-detail.html',
                    controller: 'PromotionDtlDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promotionDtl');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PromotionDtl', function($stateParams, PromotionDtl) {
                    return PromotionDtl.get({id : $stateParams.dtlId});
                }]
            }
        })
        .state('promotion-dtl-new', {
            parent: 'promotion-detail',
            url: '/promotion-dtl/1/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-dialog.html',
                    controller: 'PromotionDtlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        promotion: ['Promotion', function(Promotion) {
                            return Promotion.get({id : $stateParams.id});             
                        }],
                        entity: function () {
                            return {
                                allocationQty: null,
                                id: null,
                                outletId: null,
                                outletOutletName: null,
                                promoMaterialId: null,
                                promoMaterialName: null,
                                promotionId: null,
                                promotionName: null,
                                received: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('promotion-detail', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promotion-dtl-edit', {
            parent: 'promotion-detail',
            url: '/promotion-dtl/{dtlId}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-dialog.html',
                    controller: 'PromotionDtlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        promotion: ['Promotion', function(Promotion) {
                            return Promotion.get({id : $stateParams.id});             
                        }],
                        entity: ['PromotionDtl', function(PromotionDtl) {
                            return PromotionDtl.get({id : $stateParams.dtlId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion-detail', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promotion-dtl-delete', {
            parent: 'promotion-detail',
            url: '/promotion-dtl/{dtlId}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion-dtl/promotion-dtl-delete-dialog.html',
                    controller: 'PromotionDtlDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        promotion: ['Promotion', function(Promotion) {
                            return Promotion.get({id : $stateParams.id});             
                        }],
                        entity: ['PromotionDtl', function(PromotionDtl) {
                            return PromotionDtl.get({id : $stateParams.dtlId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion-detail', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promotion.new', {
            parent: 'promotion',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion/promotion-dialog.html',
                    controller: 'PromotionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                validFrom: null,
                                validUntil: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('promotion', null, { reload: true });
                }, function() {
                    $state.go('promotion');
                });
            }]
        })
        .state('promotion.edit', {
            parent: 'promotion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion/promotion-dialog.html',
                    controller: 'PromotionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Promotion', function(Promotion) {
                            return Promotion.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promotion.delete', {
            parent: 'promotion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promotion/promotion-delete-dialog.html',
                    controller: 'PromotionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Promotion', function(Promotion) {
                            return Promotion.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promotion', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Promotion', Promotion);

    Promotion.$inject = ['$resource', 'DateUtils'];

    function Promotion ($resource, DateUtils) {
        var resourceUrl =  'api/promotions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.validFrom = DateUtils.convertDateTimeFromServer(data.validFrom);
                    data.validUntil = DateUtils.convertDateTimeFromServer(data.validUntil);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PromotionSearch', PromotionSearch);

    PromotionSearch.$inject = ['$resource'];

    function PromotionSearch($resource) {
        var resourceUrl =  'api/_search/promotions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromotionController', PromotionController);

    PromotionController.$inject = ['$scope', '$state', 'Promotion', 'PromotionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PromotionController ($scope, $state, Promotion, PromotionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.checkExpiredPromotion = checkExpiredPromotion;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function checkExpiredPromotion (params) {
            var checkExpired = moment(params.date).isAfter(moment());
            return (checkExpired) ? true : false;
        }

        function loadAll () {
            if (pagingParams.search) {
                PromotionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Promotion.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.promotions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromoMaterialDialogController', PromoMaterialDialogController);

    PromoMaterialDialogController.$inject = ['$timeout', '$scope', 'AlertService', '$uibModalInstance', 'entity', 'PromoMaterial', 'ProductCategorySearch'];

    function PromoMaterialDialogController ($timeout, $scope, AlertService, $uibModalInstance, entity, PromoMaterial, ProductCategorySearch) {
        var vm = this;
        vm.promoMaterial = entity;
        vm.getProductCategory = getProductCategory;
        
        function getProductCategory(value) {
            vm.loadingProduct = true;

            return ProductCategorySearch.query({
                query: "*"+value+"*"
            }).$promise.then(function(response){
                vm.loadingProduct = false;
                return response;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:promoMaterialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.promoMaterial.productCategoryId = vm.selectedProduct.id;
            vm.isSaving = true;
            if (vm.promoMaterial.id !== null) {
                PromoMaterial.update(vm.promoMaterial, onSaveSuccess, onSaveError);
            } else {
                PromoMaterial.save(vm.promoMaterial, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromoMaterialDetailController', PromoMaterialDetailController);

    PromoMaterialDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PromoMaterial', 'ProductCategory'];

    function PromoMaterialDetailController($scope, $rootScope, $stateParams, entity, PromoMaterial, ProductCategory) {
        var vm = this;
        vm.promoMaterial = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:promoMaterialUpdate', function(event, result) {
            vm.promoMaterial = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromoMaterialDeleteController',PromoMaterialDeleteController);

    PromoMaterialDeleteController.$inject = ['$uibModalInstance', 'entity', 'PromoMaterial'];

    function PromoMaterialDeleteController($uibModalInstance, entity, PromoMaterial) {
        var vm = this;
        vm.promoMaterial = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PromoMaterial.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('promo-material', {
            parent: 'entity',
            url: '/promo-material?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promoMaterial.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promo-material/promo-materials.html',
                    controller: 'PromoMaterialController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promoMaterial');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('promo-material-detail', {
            parent: 'entity',
            url: '/promo-material/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.promoMaterial.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promo-material/promo-material-detail.html',
                    controller: 'PromoMaterialDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promoMaterial');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PromoMaterial', function($stateParams, PromoMaterial) {
                    return PromoMaterial.get({id : $stateParams.id});
                }]
            }
        })
        .state('promo-material.new', {
            parent: 'promo-material',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-material/promo-material-dialog.html',
                    controller: 'PromoMaterialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('promo-material', null, { reload: true });
                }, function() {
                    $state.go('promo-material');
                });
            }]
        })
        .state('promo-material.edit', {
            parent: 'promo-material',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-material/promo-material-dialog.html',
                    controller: 'PromoMaterialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PromoMaterial', function(PromoMaterial) {
                            return PromoMaterial.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promo-material', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promo-material.delete', {
            parent: 'promo-material',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-material/promo-material-delete-dialog.html',
                    controller: 'PromoMaterialDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PromoMaterial', function(PromoMaterial) {
                            return PromoMaterial.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('promo-material', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PromoMaterial', PromoMaterial);

    PromoMaterial.$inject = ['$resource'];

    function PromoMaterial ($resource) {
        var resourceUrl =  'api/promo-materials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PromoMaterialSearch', PromoMaterialSearch);

    PromoMaterialSearch.$inject = ['$resource'];

    function PromoMaterialSearch($resource) {
        var resourceUrl =  'api/_search/promo-materials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PromoMaterialController', PromoMaterialController);

    PromoMaterialController.$inject = ['$scope', '$state', 'PromoMaterial', 'PromoMaterialSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PromoMaterialController ($scope, $state, PromoMaterial, PromoMaterialSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PromoMaterialSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PromoMaterial.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.promoMaterials = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectColumnDialogController', ProjectColumnDialogController);

    ProjectColumnDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectColumn', 'Project'];

    function ProjectColumnDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectColumn, Project) {
        var vm = this;
        vm.projectColumn = entity;
        vm.projects = Project.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:projectColumnUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.projectColumn.id !== null) {
                ProjectColumn.update(vm.projectColumn, onSaveSuccess, onSaveError);
            } else {
                ProjectColumn.save(vm.projectColumn, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectColumnDetailController', ProjectColumnDetailController);

    ProjectColumnDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProjectColumn', 'Project'];

    function ProjectColumnDetailController($scope, $rootScope, $stateParams, entity, ProjectColumn, Project) {
        var vm = this;
        vm.projectColumn = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:projectColumnUpdate', function(event, result) {
            vm.projectColumn = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectColumnDeleteController',ProjectColumnDeleteController);

    ProjectColumnDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectColumn'];

    function ProjectColumnDeleteController($uibModalInstance, entity, ProjectColumn) {
        var vm = this;
        vm.projectColumn = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProjectColumn.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('project-column', {
//            parent: 'entity',
//            url: '/project-column',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.projectColumn.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/project-column/project-columns.html',
//                    controller: 'ProjectColumnController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('projectColumn');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('project-column-detail', {
//            parent: 'entity',
//            url: '/project-column/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.projectColumn.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/project-column/project-column-detail.html',
//                    controller: 'ProjectColumnDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('projectColumn');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'ProjectColumn', function($stateParams, ProjectColumn) {
//                    return ProjectColumn.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('project-column.new', {
//            parent: 'project-column',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/project-column/project-column-dialog.html',
//                    controller: 'ProjectColumnDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                columnId: null,
//                                columnName: null,
//                                columnAlias: null,
//                                sequence: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('project-column', null, { reload: true });
//                }, function() {
//                    $state.go('project-column');
//                });
//            }]
//        })
//        .state('project-column.edit', {
//            parent: 'project-column',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/project-column/project-column-dialog.html',
//                    controller: 'ProjectColumnDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['ProjectColumn', function(ProjectColumn) {
//                            return ProjectColumn.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('project-column', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('project-column.delete', {
//            parent: 'project-column',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/project-column/project-column-delete-dialog.html',
//                    controller: 'ProjectColumnDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['ProjectColumn', function(ProjectColumn) {
//                            return ProjectColumn.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('project-column', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ProjectColumn', ProjectColumn);

    ProjectColumn.$inject = ['$resource'];

    function ProjectColumn ($resource) {
        var resourceUrl =  'api/project-columns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true
            },
            'getbyColumnId': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProjectColumnSearch', ProjectColumnSearch);

    ProjectColumnSearch.$inject = ['$resource'];

    function ProjectColumnSearch($resource) {
        var resourceUrl =  'api/_search/project-columns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectColumnController', ProjectColumnController);

    ProjectColumnController.$inject = ['$scope', '$state', 'ProjectColumn', 'ProjectColumnSearch'];

    function ProjectColumnController ($scope, $state, ProjectColumn, ProjectColumnSearch) {
        var vm = this;
        vm.projectColumns = [];
        vm.loadAll = function() {
            ProjectColumn.query(function(result) {
                vm.projectColumns = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProjectColumnSearch.query({query: vm.searchQuery}, function(result) {
                vm.projectColumns = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 
                                       'DataUtils', 'Deployment', 'ProcessDefinition', 'Project', 'Upload'];

    function ProjectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, 
    		DataUtils, Deployment, ProcessDefinition, Project, Upload) {    	
        var vm = this;
        vm.project = entity;
        vm.deployAndGetProcessProgress = false;
        vm.deployError = true;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.project.id !== null) {
                Project.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                Project.save(vm.project, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
            console.log($uibModalInstance);
            if(vm.deploymentId) {
            	Deployment.delete({id:vm.deploymentId})
            }
        };
        
        vm.nullValue = function(){
        	vm.project.processDefinitionId = null;
        }
        
        vm.deployBpmFile = function(file, errFiles) {
        	//vm.deployAndGetProcessProgress = true;
        	vm.bpm_file = file;
        	vm.errFile = errFiles && errFiles[0];
        	vm.deployError = true;
        	if(file) {
        		file.upload = Upload.upload({
        			url: 'bpm-rest/repository/deployments',
        			data: {file: file}
        		});
        		
        		file.upload.then(function(response){
        			$timeout(function() {
        				file.result = response.data;
        			});
        			vm.deploymentId = response.data.id;
        			ProcessDefinition.query({deploymentId: vm.deploymentId},function(result){
        				vm.project.processDefinitionId = result.data[0].id;
        				///vm.deployAndGetProcessProgress = false;
        			});
        		},function(response) {
        			if(response.status > 0) {
        				vm.deployError = false;
        				vm.bpm_file = null;
        				//vm.deployAndGetProcessProgress = false;
        				vm.errorMsg = response.data.exception;
//        				console.log(response);
        			}
        		}, function(evt) {
        			file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        		});
        	}
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Project'];

    function ProjectDetailController($scope, $rootScope, $stateParams, entity, Project) {
        var vm = this;
        vm.project = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:projectUpdate', function(event, result) {
            vm.project = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectDeleteController',ProjectDeleteController);

    ProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project'];

    function ProjectDeleteController($uibModalInstance, entity, Project) {
        var vm = this;
        vm.project = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Project.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project', {
            parent: 'entity',
            url: '/project?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/projects.html',
                    controller: 'ProjectController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-detail', {
            parent: 'entity',
            url: '/project/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.project.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/project-detail.html',
                    controller: 'ProjectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.get({id : $stateParams.id});
                }]
            }
        })
        .state('project.new', {
            parent: 'project',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard  : false,
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectName: null,
                                processDefinitionId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: true });
                }, function() {
                    $state.go('project');
                });
            }]
        })
        .state('project.edit', {
            parent: 'project',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard  : false,
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.delete', {
            parent: 'project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Project', Project);

    Project.$inject = ['$resource'];

    function Project ($resource) {
        var resourceUrl =  'api/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProjectSearch', ProjectSearch);

    ProjectSearch.$inject = ['$resource'];

    function ProjectSearch($resource) {
        var resourceUrl =  'api/_search/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['$scope', '$state', 'Project', 'ProjectSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProjectController ($scope, $state, Project, ProjectSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProjectSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Project.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductInchDialogController', ProductInchDialogController);

    ProductInchDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductInch'];

    function ProductInchDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductInch) {
        var vm = this;
        vm.productInch = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:productInchUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productInch.id !== null) {
                ProductInch.update(vm.productInch, onSaveSuccess, onSaveError);
            } else {
                ProductInch.save(vm.productInch, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductInchDetailController', ProductInchDetailController);

    ProductInchDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductInch'];

    function ProductInchDetailController($scope, $rootScope, $stateParams, entity, ProductInch) {
        var vm = this;
        vm.productInch = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:productInchUpdate', function(event, result) {
            vm.productInch = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductInchDeleteController',ProductInchDeleteController);

    ProductInchDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductInch'];

    function ProductInchDeleteController($uibModalInstance, entity, ProductInch) {
        var vm = this;
        vm.productInch = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductInch.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-inch', {
            parent: 'entity',
            url: '/product-inch?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.productInch.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-inch/product-inches.html',
                    controller: 'ProductInchController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productInch');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-inch-detail', {
            parent: 'entity',
            url: '/product-inch/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.productInch.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-inch/product-inch-detail.html',
                    controller: 'ProductInchDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productInch');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductInch', function($stateParams, ProductInch) {
                    return ProductInch.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-inch.new', {
            parent: 'product-inch',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-inch/product-inch-dialog.html',
                    controller: 'ProductInchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                deskripsi: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-inch', null, { reload: true });
                }, function() {
                    $state.go('product-inch');
                });
            }]
        })
        .state('product-inch.edit', {
            parent: 'product-inch',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-inch/product-inch-dialog.html',
                    controller: 'ProductInchDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductInch', function(ProductInch) {
                            return ProductInch.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-inch', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-inch.delete', {
            parent: 'product-inch',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-inch/product-inch-delete-dialog.html',
                    controller: 'ProductInchDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductInch', function(ProductInch) {
                            return ProductInch.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-inch', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ProductInch', ProductInch);

    ProductInch.$inject = ['$resource'];

    function ProductInch ($resource) {
        var resourceUrl =  'api/product-inches/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProductInchSearch', ProductInchSearch);

    ProductInchSearch.$inject = ['$resource'];

    function ProductInchSearch($resource) {
        var resourceUrl =  'api/_search/product-inches/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductInchController', ProductInchController);

    ProductInchController.$inject = ['$scope', '$state', 'ProductInch', 'ProductInchSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductInchController ($scope, $state, ProductInch, ProductInchSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProductInchSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProductInch.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productInches = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductCategoryDialogController', ProductCategoryDialogController);

    ProductCategoryDialogController.$inject = ['$timeout', '$q', '$scope', 'level', 'child', '$uibModalInstance', 'entity', 'ProductCategory', 'ProductCategorySearch', 'AlertService'];

    function ProductCategoryDialogController ($timeout, $q, $scope, level, child, $uibModalInstance, entity, ProductCategory, ProductCategorySearch, AlertService) {
        var vm = this;
        vm.productCategory = entity;
        vm.productcategories = [];
        vm.getProductCategory = getProductCategory;
        vm.loadingProductCategory = false;
        vm.parent = null;
        vm.level = level;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:productCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.$onInit = function () {

            // TODO set granchild if has child
            if (child) {
                child.forEach(function (data) {
                    data.child.$promise.then(function (tos) {
                        data.hasGrandChild = tos.length || 0
                    })
                });
            }


            if (vm.productCategory.$promise) {
                vm.productCategory.$promise.then(function(data) {
                    vm.parent = {
                        "id" : data.parentId,
                        "categoryName" : data.parentName
                    }
                }, function(error) {
                    console.log(error);
                });
            }

            function filterCurrentId(each) {
                return each.id != vm.productCategory.id
            }

            // TODO set data for available search. actually use getProductCategory method
            if (level) {
                if (level == 1) {
                    if (child.length == 0) {
                        var res = _getChild([1,2]).then(function (data) {
                            vm.productcategories = data.flat(2).filter(filterCurrentId);
                        });
                    }else if(child.length > 0){
                        var hasGrandChild = child.some(function (some) {
                            return some.hasGrandChild > 0
                        });
                        if (hasGrandChild) {
                            var res = _getChild([1]).then(function (data) {
                                vm.productcategories = data.flat(2).filter(filterCurrentId);
                            });
                        }
                    }
                }else if(level == 2){
                    if (child.length == 0) {
                        var res = _getChild([1,2]).then(function (data) {
                            vm.productcategories = data.flat(2).filter(filterCurrentId);
                        });
                    }else{
                        var res = _getChild([1]).then(function (data) {
                            vm.productcategories = data.flat(2).filter(filterCurrentId);
                        });
                    }
                }else {
                    var res = _getChild([1,2]).then(function (data) {
                        vm.productcategories = data.flat(2).filter(filterCurrentId);
                    });
                }
            }else {
                var res = _getChild([1,2]).then(function (data) {
                    vm.productcategories = data.flat(2).filter(filterCurrentId);
                });
            }
        }

        vm.save = function () {
            vm.isSaving = true;
            if(vm.parent){
            	vm.productCategory.parentId = vm.parent.id;
            }else{
            	vm.productCategory.parentId = null;
            }	

            if (vm.productCategory.id !== null) {
                ProductCategory.update(vm.productCategory, onSaveSuccess, onSaveError);
            } else {
                ProductCategory.save(vm.productCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function getProductCategory(value) {
        	vm.loadingProductCategory = true;
            return ProductCategorySearch.query({
            	query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingProductCategory = false;
                return response;
            }, function(response){
            	vm.loadingProductCategory = false;
                AlertService.error(response.data.message);
            });
        };

        // private function

        /**
         * get child from api
         * @param {Array} level number for loop level
         * @returns Array list childs
         */
        function _getChild(level) {
            var childs = [];
            level.forEach(function (lv) {
                var data = ProductCategory.getAllProductCategories({level : lv}).$promise;
                childs = [].concat(childs, data);
            });
            return $q.all(childs)
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductCategoryDetailController', ProductCategoryDetailController);

    ProductCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductCategory'];

    function ProductCategoryDetailController($scope, $rootScope, $stateParams, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:productCategoryUpdate', function(event, result) {
            vm.productCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductCategoryDeleteController',ProductCategoryDeleteController);

    ProductCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductCategory'];

    function ProductCategoryDeleteController($uibModalInstance, entity, ProductCategory) {
        var vm = this;
        vm.productCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ProductCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-category', {
            parent: 'entity',
            url: '/product-category?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.productCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category/product-categories.html',
                    controller: 'ProductCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-category-detail', {
            parent: 'entity',
            url: '/product-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.productCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category/product-category-detail.html',
                    controller: 'ProductCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductCategory', function($stateParams, ProductCategory) {
                    return ProductCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-category.new', {
            parent: 'product-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-dialog.html',
                    controller: 'ProductCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                categoryName: null,
                                deleted: false,
                                id: null
                            };
                        },
                        level: function() {
                            return null;
                        },
                        child: function() {
                            return null;
                        }
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('product-category');
                });
            }]
        })
        .state('product-category.edit', {
            parent: 'product-category',
            url: '/{id}/edit?level',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-dialog.html',
                    controller: 'ProductCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductCategory', function(ProductCategory) {
                            return ProductCategory.get({id : $stateParams.id}).$promise;
                        }],
                        level: function() {
                            return $stateParams.level;
                        },
                        child: ['ProductCategory', function(ProductCategory) {
                            return ProductCategory.queryChild({id : $stateParams.id}, function (data) {
                                data.forEach(function (each) {
                                    each.child = ProductCategory.queryChild({id : each.id});
                                    return each.child
                                });
                            }).$promise;
                        }],
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-category.delete', {
            parent: 'product-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category/product-category-delete-dialog.html',
                    controller: 'ProductCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductCategory', function(ProductCategory) {
                            return ProductCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ProductCategory', ProductCategory);

    ProductCategory.$inject = ['$resource'];

    function ProductCategory ($resource) {
        var resourceUrl =  'api/product-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllProductCategories' : {
            	url:'api/product-categories/level/:level', 
            	method: 'GET', 
            	isArray: true
            },
            'queryChild' : {
            	url:'api/product-categories/:id/children', 
            	method: 'GET', 
            	isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProductCategorySearch', ProductCategorySearch);

    ProductCategorySearch.$inject = ['$resource'];

    function ProductCategorySearch($resource) {
        var resourceUrl =  'api/_search/product-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductCategoryController', ProductCategoryController);

    ProductCategoryController.$inject = ['$scope', '$state', 'ProductCategory', 'ProductCategorySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductCategoryController ($scope, $state, ProductCategory, ProductCategorySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();
        vm.productCategories = []
        vm.expandProp = {
            field: 'id',
            displayName: 'Id',
            sortable : true,
            sortingType : "number",
        }
        vm.filterString = null;
        vm.colDefinitions = [
            {
                field: "categoryName",
                displayName: "Category Name",
                sortable : true,
                filterable: true,
            },
            {
                field: "parentName",
                displayName: "Parent Name",
                sortable : false,
                filterable: true
            },
            {
                field: "actions",
                displayName: " ",
                sortable: false,
                filterable: false,
                cellTemplate:
                "<div class=\"btn-group flex-btn-group-container\">"
                + "<button type=\"submit\" ui-sref=\"product-category-detail({id:row.branch[col.field]})\" class=\"btn btn-info btn-sm\">"
                + "<span class=\"glyphicon glyphicon-eye-open\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>"
                + "</button>"
                + "<button type=\"submit\" ui-sref=\"product-category.edit({id:row.branch[col.field], level : row.level })\" class=\"btn btn-primary btn-sm\">"
                + "<span class=\"glyphicon glyphicon-pencil\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>"
                + "</button>"
                + "<button type=\"submit\" ui-sref=\"product-category.delete({id:row.branch[col.field]})\" class=\"btn btn-danger btn-sm\">"
                + "<span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>"
                + "</button>"
                + "</div>"
            }
        ];
        $scope.myTree = {};

        function loadAll () {
            ProductCategory.query({
                page: 0,
                size: 2000,
                sort: 'id,asc'
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                data.forEach(addActionsProps);
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productCategories = _listToTree(data);
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            function addActionsProps(each) {
                each.actions = each.id
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (searchQuery === '' || null) {
                vm.filterString = null;
                return;
            }
            vm.filterString = searchQuery;
        }

        function clear () {
            vm.filterString = null;
            vm.searchQuery = null;
            $scope.myTree.collapse_all();
        }
        

        // private function

        function _listToTree(list) {
            var map = {};
            var node;
            var roots = [];
            var i;

            for (i = 0; i < list.length; i += 1) {
                map[list[i].id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }

            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.parentId) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.parentId]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product', 'ProductCategory', 'LaunchPeriod', 'ProductInch'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product, ProductCategory, LaunchPeriod, ProductInch) {
        var vm = this;
        vm.product = entity;
        vm.dataCategory = [];
        vm.productCategories = ProductCategory.getAllProductCategories({level: 3});
        vm.launchperiods = LaunchPeriod.query({size: 2000});
        vm.productinches = ProductInch.query({size: 2000});
         
        if (vm.productCategories.$promise) {
        	vm.productCategories.$promise.then(function(data) {
        		for(var i=0; i<data.length; i++){
        			vm.dataCategory[i] = {
						"id" : data[i].id,
						"categoryName" : data[i].categoryName
					}
        		}	
           	}, function(error) {
				console.log(error);
			});
		}
        
        if (vm.product.$promise) {
        	vm.product.$promise.then(function(data) {
        		vm.productCategory = {
					"id" : data.productCategoryId,
					"categoryName" : data.productCategoryCategoryName
				}
           		if(vm.productCategory == null){
           			vm.productCategory = null;
	       		}
			}, function(error) {
				console.log(error);
			});
		}
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.productCategory){
            	vm.product.productCategoryId = vm.productCategory.id;
            }else{
            	vm.product.productCategoryId = null;
            }
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Product', 'ProductCategory', 'LaunchPeriod', 'ProductInch'];

    function ProductDetailController($scope, $rootScope, $stateParams, entity, Product, ProductCategory, LaunchPeriod, ProductInch) {
        var vm = this;
        vm.product = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;
        vm.product = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'entity',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id});
                }]
            }
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                productCode: null,
                                shortCode: null,
                                productName: null,
                                target: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('product');
                });
            }]
        })
        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryProductPops': { 
            	url: 'api/products/:id/productpops',
            	method: 'GET', 
            	isArray: true
            },
            'saveProductPops': { 
            	url: 'api/products/:id/productpops',
            	method: 'POST'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ProductSearch', ProductSearch);

    ProductSearch.$inject = ['$resource'];

    function ProductSearch($resource) {
        var resourceUrl =  'api/_search/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$state', 'Product', 'ProductSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductController ($scope, $state, Product, ProductSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                var querySplit = pagingParams.search.split(/-|\//);
                var query = '';

                if(querySplit.length > 0) {
                    query += '(';

                    angular.forEach(querySplit, function(eachSplit, index) {
                        query += eachSplit;

                        if(index != querySplit.length - 1) {
                            query += ' AND '
                        }
                    });
                    
                    query += '*)';
                } else {
                    query = pagingParams.search;
                }

                ProductSearch.query({
                    query: query + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Product.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PrincipalDialogController', PrincipalDialogController);

    PrincipalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PrincipalName'];

    function PrincipalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Principal) {
        var vm = this;
        vm.principal = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:principalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.principal.id !== null) {
                Principal.update(vm.principal, onSaveSuccess, onSaveError);
            } else {
                Principal.save(vm.principal, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PrincipalDetailController', PrincipalDetailController);

    PrincipalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PrincipalName'];

    function PrincipalDetailController($scope, $rootScope, $stateParams, entity, Principal) {
        var vm = this;
        vm.principal = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:principalUpdate', function(event, result) {
            vm.principal = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PrincipalDeleteController',PrincipalDeleteController);

    PrincipalDeleteController.$inject = ['$uibModalInstance', 'entity', 'PrincipalName'];

    function PrincipalDeleteController($uibModalInstance, entity, Principal) {
        var vm = this;
        vm.principal = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Principal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('principal', {
            parent: 'entity',
            url: '/principal?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.principal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/principal/principals.html',
                    controller: 'PrincipalController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('principal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('principal-detail', {
            parent: 'entity',
            url: '/principal/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.principal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/principal/principal-detail.html',
                    controller: 'PrincipalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('principal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PrincipalName', function($stateParams, Principal) {
                    return Principal.get({id : $stateParams.id});
                }]
            }
        })
        .state('principal.new', {
            parent: 'principal',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/principal/principal-dialog.html',
                    controller: 'PrincipalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('principal', null, { reload: true });
                }, function() {
                    $state.go('principal');
                });
            }]
        })
        .state('principal.edit', {
            parent: 'principal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/principal/principal-dialog.html',
                    controller: 'PrincipalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PrincipalName', function(Principal) {
                            return Principal.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('principal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('principal.delete', {
            parent: 'principal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/principal/principal-delete-dialog.html',
                    controller: 'PrincipalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PrincipalName', function(Principal) {
                            return Principal.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('principal', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PrincipalName', Principal);

    Principal.$inject = ['$resource'];

    function Principal ($resource) {
        var resourceUrl =  'api/principals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PrincipalSearch', PrincipalSearch);

    PrincipalSearch.$inject = ['$resource'];

    function PrincipalSearch($resource) {
        var resourceUrl =  'api/_search/principals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PrincipalController', PrincipalController);

    PrincipalController.$inject = ['$scope', '$state', 'PrincipalName', 'PrincipalSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PrincipalController ($scope, $state, Principal, PrincipalSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PrincipalSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Principal.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.principals = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopPairVersionImportController', PopPairVersionImportController);

    PopPairVersionImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function PopPairVersionImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/pop-pair-versions/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopPairVersionFormController', PopPairVersionFormController);

    PopPairVersionFormController.$inject = ['$scope', '$state', '$filter', 'AlertService', 'ParseLinks', 'pagingParams', 'paginationConstants', 'entity', 'PopPairVersion', 'ProductCategory', 'Product', 'ProductSearch', 'PopSearch'];

    function PopPairVersionFormController($scope, $state, $filter, AlertService, ParseLinks, pagingParams, paginationConstants, entity, PopPairVersion, ProductCategory, Product, ProductSearch, PopSearch) {
        var vm = this;

        vm.clearSearchProduct = clearSearchProduct;
        vm.getAllProduct = getAllProduct;
        vm.getPop = getPop;
        vm.loadPageProduct = loadPageProduct;
        vm.savePopPairVersion = savePopPairVersion;
        vm.searchProduct = searchProduct;
        vm.selectPop = selectPop;
        vm.selectProduct = selectProduct;
        vm.updateCategory = updateCategory;
        vm.updatePopList = updatePopList;

        (function () {
            vm.popPairVersion = entity;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.searchProductQuery = pagingParams.searchProduct;
            vm.currentSearch = pagingParams.search;

            vm.disableEdit = (vm.popPairVersion.id) ? true : false;

            getProductCategory();
        })();

        function getProductCategory() {
            ProductCategory.getAllProductCategories({
                level: 2
            }, function (data) {
                vm.categories = data;
                vm.category = data[0];

                updateCategory(vm.category);
            });
        }

        function updateCategory(category) {
            ProductCategory.queryChild({
                id: category.id
            }, function (data) {
                vm.queryCategory = '(';

                angular.forEach(data, function (categoryChild, key) {
                    vm.queryCategory += 'productCategory.id:' + categoryChild.id;

                    if (key != data.length - 1) {
                        vm.queryCategory += ' OR ';
                    }
                });

                vm.queryCategory += ')';

                getAllProduct();
            });
        }

        function getAllProduct() {
            vm.product = null;

            if (vm.currentSearch) {
                var querySplit = vm.currentSearch.split(/-|\//);
                var queryProductCode = '';

                if (querySplit.length > 0) {
                    queryProductCode += '(';

                    angular.forEach(querySplit, function (eachSplit, index) {
                        queryProductCode += eachSplit;

                        if (index !== querySplit.length - 1) {
                            queryProductCode += ' AND ';
                        }
                    });

                    queryProductCode += '*)';
                } else {
                    queryProductCode = vm.currentSearch;
                }

                ProductSearch.query({
                    query: 'productCode:' + queryProductCode + ' '
                            + 'AND deleted:false AND ' + vm.queryCategory,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Product.query({
                    categoryParentId: vm.category.id,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPageProduct(page) {
            vm.page = page;
            vm.getAllProduct();
        }

        function searchProduct(searchQuery) {
            if (!searchQuery) {
                return vm.clearSearchProduct();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.getAllProduct();
        }

        function clearSearchProduct() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.searchProductQuery = null;
            vm.getAllProduct();
        }

        function selectProduct(product) {
            vm.product = product;

            if (vm.currentProduct !== vm.product) {
                getPops(product);
                vm.currentProduct = product;
            }
        }

        function getPops(product) {
            vm.isSaving = true;

            vm.pops = {
                table1: { title: 'normal', list: [] },
                table2: { title: 'conditional1', list: [] },
                table3: { title: 'conditional2', list: [] },
                table4: { title: 'conditional3', list: [] }
            }

            PopPairVersion.getProductPops({
                popPairVersionId: vm.popPairVersion.id,
                productId: product.id
            }, function (data) {
                angular.forEach(data, function (pop) {
                    if (pop.conditional1) {
                        vm.pops.table2.list.push(pop);
                    } else if (pop.conditional2) {
                        vm.pops.table3.list.push(pop);
                    } else if (pop.conditional3) {
                        vm.pops.table4.list.push(pop);
                    } else {
                        vm.pops.table1.list.push(pop);
                    }
                });

                for (var key in vm.pops) {
                    vm.pops[key].list = $filter('orderBy')(vm.pops[key].list, 'id', false);
                }

                vm.isSaving = false;
            }, function () {
                vm.isSaving = false;
            });
        }

        function getPop(value) {
            vm.loadingPop = true;

            var querySplit = value.split(/-|\//);
            var query = '';

            if (querySplit.length > 0) {
                query += '(';

                angular.forEach(querySplit, function (eachSplit, index) {
                    query += eachSplit;

                    if (index !== querySplit.length - 1) {
                        query += ' AND ';
                    }
                });

                query += '*)';
            } else {
                query = value;
            }

            return PopSearch.query({
                query: 'popName:' + query + ' AND deleted:false'
            }).$promise.then(function (response) {
                vm.loadingPop = false;

                var pops = [];
                var length = response.length;
                for (var i = 0; i < length; i++) {
                    if (response[i].id != 1 && response[i].id != 2) {
                        var unique = true;

                        for (var key in vm.pops) {
                            var filters = $filter('filter')(vm.pops[key].list, {
                                id: {
                                    pop: {
                                        id: response[i].id,
                                        popName: response[i].popName,
                                        productCategory: response[i].productCategory
                                    }
                                }
                            });

                            if (filters.length > 0) {
                                unique = false;
                            }
                        }

                        if (unique) {
                            pops.push(response[i]);
                        }
                    }
                }
                pops = $filter('orderBy')(pops, 'id');

                return pops;
            }, function (response) {
                vm.loadingPop = false;
                AlertService.error(response.data.message);
            });
        }

        function selectPop(pop) {
            vm.isSaving = true;
            vm.pop = null;

            var popPost = {
                conditional1: false,
                conditional2: false,
                conditional3: false,
                id: {
                    pop: pop
                }
            };
            var pops = vm.pops.table1.list;

            pops.push(popPost);

            PopPairVersion.updateProductPops({
                popPairVersionId: vm.popPairVersion.id,
                productId: vm.product.id
            }, pops, function (data) {
                vm.isSaving = false;
            }, function () {
                vm.isSaving = false;
            });
        }

        function updatePopList(tableContent) {
            vm.isSaving = true;

            var selectedPop = tableContent.list
                .find(function(pop) { return pop.moved === true; });
            
            var index = tableContent.list.indexOf(selectedPop);

            tableContent.list.splice(index, 1);

            var pops = [];

            for (var property in vm.pops) {
                angular.forEach(vm.pops[property].list, function (pop) {
                    pop.conditional1 = false;
                    pop.conditional2 = false;
                    pop.conditional3 = false;

                    if(pop[vm.pops[property].title] !== undefined) {
                        pop[vm.pops[property].title] = true;
                    }

                    pops.push(pop);
                });
            }

            PopPairVersion.updateProductPops({
                popPairVersionId: vm.popPairVersion.id,
                productId: vm.product.id
            }, pops, function (data) {
                vm.isSaving = false;
            }, function () {
                vm.isSaving = false;
            });
        }

        function savePopPairVersion() {
            vm.isSaving = true;
            if (vm.popPairVersion.id !== null) {
                PopPairVersion.update(vm.popPairVersion, onSaveSuccess, onSaveError);
            } else {
                PopPairVersion.save(vm.popPairVersion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $state.go('pop-pair-version.edit', { id: result.id });
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopPairVersionDetailController', PopPairVersionDetailController);

    PopPairVersionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$filter', 'AlertService', 'ParseLinks', 'entity', 'PopPairVersion', 'ProductCategory', 'ProductSearch', 'Product'];

    function PopPairVersionDetailController($scope, $rootScope, $stateParams, $filter, AlertService, ParseLinks, entity, PopPairVersion, ProductCategory, ProductSearch, Product) {
        var vm = this;

        vm.getAllProduct = getAllProduct;
        vm.selectProduct = selectProduct;
        
        var unsubscribe = $rootScope.$on('sceaApp:popPairVersionUpdate', function(event, result) {
            vm.popPairVersion = result;
        });
        $scope.$on('$destroy', unsubscribe);

        (function () {
            vm.popPairVersion = entity;
            vm.page = 1;

            getAllProduct();
        })();
        
        function getAllProduct() {
            vm.product = null;

            PopPairVersion.getProducts({
                id: vm.popPairVersion.id,
                page: vm.page - 1,
                size: 20
            }, onSuccess, onError);
                
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;

                selectProduct(data[0]);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function selectProduct(product) {
            vm.product = product;

            if (vm.currentProduct !== vm.product) {
                getPops(product);
                vm.currentProduct = product;
            }
        }

        function getPops(product) {
            vm.pops = {
                table1: { title: 'normal', list: [] },
                table2: { title: 'conditional1', list: [] },
                table3: { title: 'conditional2', list: [] },
                table4: { title: 'conditional3', list: [] }
            }

            PopPairVersion.getProductPops({
                popPairVersionId: vm.popPairVersion.id,
                productId: product.id
            }, function (data) {
                angular.forEach(data, function (pop) {
                    if (pop.conditional1) {
                        vm.pops.table2.list.push(pop);
                    } else if (pop.conditional2) {
                        vm.pops.table3.list.push(pop);
                    } else if (pop.conditional3) {
                        vm.pops.table4.list.push(pop);
                    } else {
                        vm.pops.table1.list.push(pop);
                    }
                });

                for (var key in vm.pops) {
                    vm.pops[key].list = $filter('orderBy')(vm.pops[key].list, 'id', false);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopPairVersionDeleteController',PopPairVersionDeleteController);

    PopPairVersionDeleteController.$inject = ['$uibModalInstance', 'entity', 'PopPairVersion'];

    function PopPairVersionDeleteController($uibModalInstance, entity, PopPairVersion) {
        var vm = this;
        vm.popPairVersion = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PopPairVersion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pop-pair-version', {
            parent: 'entity',
            url: '/pop-pair-version?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.popPairVersion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-versions.html',
                    controller: 'PopPairVersionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popPairVersion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pop-pair-version-detail', {
            parent: 'entity',
            url: '/pop-pair-version/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.popPairVersion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-version-detail.html',
                    controller: 'PopPairVersionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popPairVersion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PopPairVersion', function($stateParams, PopPairVersion) {
                    return PopPairVersion.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('pop-pair-version.new', {
            parent: 'pop-pair-version',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-version-form.html',
                    controller: 'PopPairVersionFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popPairVersion');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        name: null,
                        id: null,
                        productpops: []
                    };
                }
            }
        })
        .state('pop-pair-version.edit', {
            parent: 'pop-pair-version',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-version-form.html',
                    controller: 'PopPairVersionFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popPairVersion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PopPairVersion', function($stateParams, PopPairVersion) {
                    return PopPairVersion.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('pop-pair-version.delete', {
            parent: 'pop-pair-version',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-version-delete-dialog.html',
                    controller: 'PopPairVersionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PopPairVersion', function(PopPairVersion) {
                            return PopPairVersion.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('pop-pair-version', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pop-pair-version.import',{
            parent: 'entity',
            url: '/pop-pair-version-import',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.popPairVersion.import.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-pair-version/pop-pair-version-import.html',
                    controller: 'PopPairVersionImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader){
                    $translatePartialLoader.addPart('popPairVersion');
                    return $translate.refresh();
                }],
                previousState: ['$state', function($state){
                    var currentStateData = {
                        name: $state.current.name || 'pop-pair-version',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PopPairVersion', PopPairVersion);

    PopPairVersion.$inject = ['$resource'];

    function PopPairVersion ($resource) {
        var resourceUrl =  'api/pop-pair-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getProducts': {
                url: 'api/pop-pair-versions/:id/products',
                method: 'GET',
                isArray: true
            },
            'getProductPops': {
                url: 'api/pop-pair-versions/:popPairVersionId/products/:productId/productpops',
                method: 'GET',
                isArray: true
            },
            'updateProductPops': {
                url: 'api/pop-pair-versions/:popPairVersionId/products/:productId/productpops',
                method: 'PUT'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PopPairVersionSearch', PopPairVersionSearch);

    PopPairVersionSearch.$inject = ['$resource'];

    function PopPairVersionSearch($resource) {
        var resourceUrl =  'api/_search/pop-pair-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopPairVersionController', PopPairVersionController);

    PopPairVersionController.$inject = ['$scope', '$state', 'PopPairVersion', 'PopPairVersionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PopPairVersionController ($scope, $state, PopPairVersion, PopPairVersionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PopPairVersionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PopPairVersion.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.popPairVersions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopInvDialogController', PopInvDialogController);

    PopInvDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'PopInv', 'Pop'];

    function PopInvDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, PopInv, Pop) {
        var vm = this;
        vm.popInv = entity;
        vm.pops = Pop.query({filter: 'popinv-is-null'});
        $q.all([vm.popInv.$promise, vm.pops.$promise]).then(function() {
            if (!vm.popInv.popId) {
                return $q.reject();
            }
            return Pop.get({id : vm.popInv.popId}).$promise;
        }).then(function(pop) {
            vm.pops.push(pop);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:popInvUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.popInv.id !== null) {
                PopInv.update(vm.popInv, onSaveSuccess, onSaveError);
            } else {
                PopInv.save(vm.popInv, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopInvDetailController', PopInvDetailController);

    PopInvDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PopInv', 'Pop'];

    function PopInvDetailController($scope, $rootScope, $stateParams, entity, PopInv, Pop) {
        var vm = this;
        vm.popInv = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:popInvUpdate', function(event, result) {
            vm.popInv = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopInvDeleteController',PopInvDeleteController);

    PopInvDeleteController.$inject = ['$uibModalInstance', 'entity', 'PopInv'];

    function PopInvDeleteController($uibModalInstance, entity, PopInv) {
        var vm = this;
        vm.popInv = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PopInv.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pop-inv', {
            parent: 'entity',
            url: '/pop-inv?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.popInv.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-inv/pop-invs.html',
                    controller: 'PopInvController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popInv');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pop-inv-detail', {
            parent: 'entity',
            url: '/pop-inv/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.popInv.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop-inv/pop-inv-detail.html',
                    controller: 'PopInvDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('popInv');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PopInv', function($stateParams, PopInv) {
                    return PopInv.get({id : $stateParams.id});
                }]
            }
        })
        .state('pop-inv.new', {
            parent: 'pop-inv',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop-inv/pop-inv-dialog.html',
                    controller: 'PopInvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pop-inv', null, { reload: true });
                }, function() {
                    $state.go('pop-inv');
                });
            }]
        })
        .state('pop-inv.edit', {
            parent: 'pop-inv',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop-inv/pop-inv-dialog.html',
                    controller: 'PopInvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PopInv', function(PopInv) {
                            return PopInv.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('pop-inv', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pop-inv.delete', {
            parent: 'pop-inv',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop-inv/pop-inv-delete-dialog.html',
                    controller: 'PopInvDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PopInv', function(PopInv) {
                            return PopInv.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('pop-inv', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PopInv', PopInv);

    PopInv.$inject = ['$resource'];

    function PopInv ($resource) {
        var resourceUrl =  'api/pop-invs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PopInvSearch', PopInvSearch);

    PopInvSearch.$inject = ['$resource'];

    function PopInvSearch($resource) {
        var resourceUrl =  'api/_search/pop-invs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopInvController', PopInvController);

    PopInvController.$inject = ['$scope', '$state', 'PopInv', 'PopInvSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PopInvController ($scope, $state, PopInv, PopInvSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PopInvSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PopInv.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.popInvs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopDialogController', PopDialogController);

    PopDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pop', 'ProductCategory'];

    function PopDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pop, ProductCategory) {
        var vm = this;
        vm.pop = entity;
        vm.objPop = null;
        vm.parentProduct = [];
        vm.productcategories = ProductCategory.getAllProductCategories({level:1});
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:popUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };
        
        vm.save = function () {
        	vm.isSaving = true;
            if (vm.pop.id !== null) {
                Pop.update(vm.pop, onSaveSuccess, onSaveError);
            } else {
                Pop.save(vm.pop, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopDetailController', PopDetailController);

    PopDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Pop', 'ProductCategory'];

    function PopDetailController($scope, $rootScope, $stateParams, entity, Pop, ProductCategory) {
        var vm = this;
        vm.pop = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:popUpdate', function(event, result) {
            vm.pop = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopDeleteController',PopDeleteController);

    PopDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pop'];

    function PopDeleteController($uibModalInstance, entity, Pop) {
        var vm = this;
        vm.pop = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Pop.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pop', {
            parent: 'entity',
            url: '/pop?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.pop.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop/pops.html',
                    controller: 'PopController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('pop');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pop-detail', {
            parent: 'entity',
            url: '/pop/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.pop.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pop/pop-detail.html',
                    controller: 'PopDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pop');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pop', function($stateParams, Pop) {
                    return Pop.get({id : $stateParams.id});
                }]
            }
        })
        .state('pop.new', {
            parent: 'pop',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop/pop-dialog.html',
                    controller: 'PopDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                popName: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pop', null, { reload: true });
                }, function() {
                    $state.go('pop');
                });
            }]
        })
        .state('pop.edit', {
            parent: 'pop',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop/pop-dialog.html',
                    controller: 'PopDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pop', function(Pop) {
                            return Pop.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('pop', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pop.delete', {
            parent: 'pop',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pop/pop-delete-dialog.html',
                    controller: 'PopDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pop', function(Pop) {
                            return Pop.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('pop', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Pop', Pop);

    Pop.$inject = ['$resource'];

    function Pop ($resource) {
        var resourceUrl =  'api/pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PopSearch', PopSearch);

    PopSearch.$inject = ['$resource'];

    function PopSearch($resource) {
        var resourceUrl =  'api/_search/pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PopController', PopController);

    PopController.$inject = ['$scope', '$state', 'Pop', 'PopSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PopController ($scope, $state, Pop, PopSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                var querySplit = pagingParams.search.split(/-|\//);
                var query = '';

                if(querySplit.length > 0) {
                    query += '(';

                    angular.forEach(querySplit, function(eachSplit, index) {
                        query += eachSplit;

                        if(index != querySplit.length - 1) {
                            query += ' AND '
                        }
                    });
                    
                    query += '*)';
                } else {
                    query = pagingParams.search;
                }
                
            	PopSearch.query({
                    query: query + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
            	Pop.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pops = data;
                vm.page = pagingParams.page;
                vm.links = data.length;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
        
        /*
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        
       
        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PopSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pop.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pops = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramProductDialogController', PlanogramProductDialogController);

    PlanogramProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlanogramProduct', 'Planogram', 'Fixtures', 'Product'];

    function PlanogramProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlanogramProduct, Planogram, Fixtures, Product) {
        var vm = this;
        vm.planogramProduct = entity;
        vm.planograms = Planogram.query();
        vm.fixtures = Fixtures.query();
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:planogramProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.planogramProduct.id !== null) {
                PlanogramProduct.update(vm.planogramProduct, onSaveSuccess, onSaveError);
            } else {
                PlanogramProduct.save(vm.planogramProduct, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramProductDetailController', PlanogramProductDetailController);

    PlanogramProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PlanogramProduct', 'Planogram', 'Fixtures', 'Product'];

    function PlanogramProductDetailController($scope, $rootScope, $stateParams, entity, PlanogramProduct, Planogram, Fixtures, Product) {
        var vm = this;
        vm.planogramProduct = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:planogramProductUpdate', function(event, result) {
            vm.planogramProduct = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramProductDeleteController',PlanogramProductDeleteController);

    PlanogramProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlanogramProduct'];

    function PlanogramProductDeleteController($uibModalInstance, entity, PlanogramProduct) {
        var vm = this;
        vm.planogramProduct = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PlanogramProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('planogram-product', {
//            parent: 'entity',
//            url: '/planogram-product?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramProduct.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-product/planogram-products.html',
//                    controller: 'PlanogramProductController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramProduct');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('planogram-product-detail', {
//            parent: 'entity',
//            url: '/planogram-product/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramProduct.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-product/planogram-product-detail.html',
//                    controller: 'PlanogramProductDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramProduct');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'PlanogramProduct', function($stateParams, PlanogramProduct) {
//                    return PlanogramProduct.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('planogram-product.new', {
//            parent: 'planogram-product',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-product/planogram-product-dialog.html',
//                    controller: 'PlanogramProductDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-product', null, { reload: true });
//                }, function() {
//                    $state.go('planogram-product');
//                });
//            }]
//        })
//        .state('planogram-product.edit', {
//            parent: 'planogram-product',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-product/planogram-product-dialog.html',
//                    controller: 'PlanogramProductDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['PlanogramProduct', function(PlanogramProduct) {
//                            return PlanogramProduct.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-product', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('planogram-product.delete', {
//            parent: 'planogram-product',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-product/planogram-product-delete-dialog.html',
//                    controller: 'PlanogramProductDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['PlanogramProduct', function(PlanogramProduct) {
//                            return PlanogramProduct.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-product', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PlanogramProduct', PlanogramProduct);

    PlanogramProduct.$inject = ['$resource'];

    function PlanogramProduct ($resource) {
        var resourceUrl =  'api/planogram-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PlanogramProductSearch', PlanogramProductSearch);

    PlanogramProductSearch.$inject = ['$resource'];

    function PlanogramProductSearch($resource) {
        var resourceUrl =  'api/_search/planogram-products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramProductController', PlanogramProductController);

    PlanogramProductController.$inject = ['$scope', '$state', 'PlanogramProduct', 'PlanogramProductSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PlanogramProductController ($scope, $state, PlanogramProduct, PlanogramProductSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PlanogramProductSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PlanogramProduct.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.planogramProducts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFixtureDialogController', PlanogramFixtureDialogController);

    PlanogramFixtureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlanogramFixture', 'Planogram', 'Fixtures'];

    function PlanogramFixtureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlanogramFixture, Planogram, Fixtures) {
        var vm = this;
        vm.planogramFixture = entity;
        vm.planograms = Planogram.query();
        vm.fixtures = Fixtures.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:planogramFixtureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.planogramFixture.id !== null) {
                PlanogramFixture.update(vm.planogramFixture, onSaveSuccess, onSaveError);
            } else {
                PlanogramFixture.save(vm.planogramFixture, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFixtureDetailController', PlanogramFixtureDetailController);

    PlanogramFixtureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PlanogramFixture', 'Planogram', 'Fixtures'];

    function PlanogramFixtureDetailController($scope, $rootScope, $stateParams, entity, PlanogramFixture, Planogram, Fixtures) {
        var vm = this;
        vm.planogramFixture = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:planogramFixtureUpdate', function(event, result) {
            vm.planogramFixture = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFixtureDeleteController',PlanogramFixtureDeleteController);

    PlanogramFixtureDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlanogramFixture'];

    function PlanogramFixtureDeleteController($uibModalInstance, entity, PlanogramFixture) {
        var vm = this;
        vm.planogramFixture = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PlanogramFixture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('planogram-fixture', {
//            parent: 'entity',
//            url: '/planogram-fixture?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramFixture.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-fixture/planogram-fixtures.html',
//                    controller: 'PlanogramFixtureController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramFixture');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('planogram-fixture-detail', {
//            parent: 'entity',
//            url: '/planogram-fixture/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramFixture.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-fixture/planogram-fixture-detail.html',
//                    controller: 'PlanogramFixtureDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramFixture');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'PlanogramFixture', function($stateParams, PlanogramFixture) {
//                    return PlanogramFixture.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('planogram-fixture.new', {
//            parent: 'planogram-fixture',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-fixture/planogram-fixture-dialog.html',
//                    controller: 'PlanogramFixtureDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                target: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('planogram-fixture');
//                });
//            }]
//        })
//        .state('planogram-fixture.edit', {
//            parent: 'planogram-fixture',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-fixture/planogram-fixture-dialog.html',
//                    controller: 'PlanogramFixtureDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['PlanogramFixture', function(PlanogramFixture) {
//                            return PlanogramFixture.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('planogram-fixture.delete', {
//            parent: 'planogram-fixture',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-fixture/planogram-fixture-delete-dialog.html',
//                    controller: 'PlanogramFixtureDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['PlanogramFixture', function(PlanogramFixture) {
//                            return PlanogramFixture.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-fixture', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PlanogramFixture', PlanogramFixture);

    PlanogramFixture.$inject = ['$resource'];

    function PlanogramFixture ($resource) {
        var resourceUrl =  'api/planogram-fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PlanogramFixtureSearch', PlanogramFixtureSearch);

    PlanogramFixtureSearch.$inject = ['$resource'];

    function PlanogramFixtureSearch($resource) {
        var resourceUrl =  'api/_search/planogram-fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFixtureController', PlanogramFixtureController);

    PlanogramFixtureController.$inject = ['$scope', '$state', 'PlanogramFixture', 'PlanogramFixtureSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PlanogramFixtureController ($scope, $state, PlanogramFixture, PlanogramFixtureSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PlanogramFixtureSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PlanogramFixture.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.planogramFixtures = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramEquipmentDialogController', PlanogramEquipmentDialogController);

    PlanogramEquipmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlanogramEquipment', 'Planogram', 'Equipment'];

    function PlanogramEquipmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlanogramEquipment, Planogram, Equipment) {
        var vm = this;
        vm.planogramEquipment = entity;
        vm.planograms = Planogram.query();
        vm.equipment = Equipment.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:planogramEquipmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.planogramEquipment.id !== null) {
                PlanogramEquipment.update(vm.planogramEquipment, onSaveSuccess, onSaveError);
            } else {
                PlanogramEquipment.save(vm.planogramEquipment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramEquipmentDetailController', PlanogramEquipmentDetailController);

    PlanogramEquipmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PlanogramEquipment', 'Planogram', 'Equipment'];

    function PlanogramEquipmentDetailController($scope, $rootScope, $stateParams, entity, PlanogramEquipment, Planogram, Equipment) {
        var vm = this;
        vm.planogramEquipment = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:planogramEquipmentUpdate', function(event, result) {
            vm.planogramEquipment = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramEquipmentDeleteController',PlanogramEquipmentDeleteController);

    PlanogramEquipmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlanogramEquipment'];

    function PlanogramEquipmentDeleteController($uibModalInstance, entity, PlanogramEquipment) {
        var vm = this;
        vm.planogramEquipment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PlanogramEquipment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('planogram-equipment', {
//            parent: 'entity',
//            url: '/planogram-equipment?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramEquipment.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-equipment/planogram-equipments.html',
//                    controller: 'PlanogramEquipmentController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramEquipment');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('planogram-equipment-detail', {
//            parent: 'entity',
//            url: '/planogram-equipment/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.planogramEquipment.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/planogram-equipment/planogram-equipment-detail.html',
//                    controller: 'PlanogramEquipmentDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('planogramEquipment');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'PlanogramEquipment', function($stateParams, PlanogramEquipment) {
//                    return PlanogramEquipment.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('planogram-equipment.new', {
//            parent: 'planogram-equipment',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-equipment/planogram-equipment-dialog.html',
//                    controller: 'PlanogramEquipmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                target: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('planogram-equipment');
//                });
//            }]
//        })
//        .state('planogram-equipment.edit', {
//            parent: 'planogram-equipment',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-equipment/planogram-equipment-dialog.html',
//                    controller: 'PlanogramEquipmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['PlanogramEquipment', function(PlanogramEquipment) {
//                            return PlanogramEquipment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('planogram-equipment.delete', {
//            parent: 'planogram-equipment',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/planogram-equipment/planogram-equipment-delete-dialog.html',
//                    controller: 'PlanogramEquipmentDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['PlanogramEquipment', function(PlanogramEquipment) {
//                            return PlanogramEquipment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('planogram-equipment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('PlanogramEquipment', PlanogramEquipment);

    PlanogramEquipment.$inject = ['$resource'];

    function PlanogramEquipment ($resource) {
        var resourceUrl =  'api/planogram-equipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PlanogramEquipmentSearch', PlanogramEquipmentSearch);

    PlanogramEquipmentSearch.$inject = ['$resource'];

    function PlanogramEquipmentSearch($resource) {
        var resourceUrl =  'api/_search/planogram-equipments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramEquipmentController', PlanogramEquipmentController);

    PlanogramEquipmentController.$inject = ['$scope', '$state', 'PlanogramEquipment', 'PlanogramEquipmentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PlanogramEquipmentController ($scope, $state, PlanogramEquipment, PlanogramEquipmentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PlanogramEquipmentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PlanogramEquipment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.planogramEquipments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function () {
    'use_strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFormController', PlanogramFormController);

    PlanogramFormController.$inject = ['$scope', '$state', '$q', 'Calendar', 'ProductCategory', 'Outlet', 'OutletSearch', 'entity', 'Planogram', '$uibModal', 'limitToFilter', 'ProductSearch'];

    function PlanogramFormController($scope, $state, $q, Calendar, ProductCategory, Outlet, OutletSearch, entity, Planogram, $uibModal, limitToFilter, ProductSearch) {
        var vm = this;

        // method
        vm.getOutlet = getOutlet;
        vm.datePickerOpenStatus = false;
        vm.openCalendar = openCalendar;
        vm.onSelectOutlet = onSelectOutlet;
        vm.onSelectFixture = onSelectFixture;
        vm.onSelectSubFixture = onSelectSubFixture;
        vm.onSelectFixtureProduct = onSelectFixtureProduct;
        vm.onSelectEquipmentCategories = onSelectEquipmentCategories;
        vm.onSelectEquipmentSubCategories = onSelectEquipmentSubCategories;
        vm.savePlanogramMaster = savePlanogramMaster;
        vm.openFixtureDialog = openFixtureDialog;
        vm.openSubFixtureDialog = openSubFixtureDialog;
        vm.openMaterialDialog = openMaterialDialog;
        vm.openImportFixtureDialog = openImportFixtureDialog;
        vm.openImportEquipmentDialog = openImportEquipmentDialog;
        vm.putFixture = putFixture;
        vm.putEquipment = putEquipment;
        vm.deleteFixture = deleteFixture;
        vm.deleteFixtureProduct = deleteFixtureProduct;
        vm.deleteEquipmentProduct = deleteEquipmentProduct;
        vm.loadEquipmentCategories = loadEquipmentCategories;
        vm.getProductFixture = getProductFixture;

        // init function
        (function () {

            // object planogram master
            vm.planogram = entity;

            // kondisi edit
            if (vm.planogram.id) {
                vm.isEditing = true;

                getOutletById(vm.planogram.outletId);

                Planogram.getFixturePlanogram({
                    id: vm.planogram.id,
                }, function (data) {
                    angular.forEach(data, function (e) {
                        e.saved = true;
                    });
                    vm.fixtures = data;
                });
            }

            vm.dateOptions = {
                dateDisabled: disabled1,
                startingDay: 1,
                minDate: new Date(),
                showButtonBar: false
            };

        })();

        function openCalendar() {
            vm.datePickerOpenStatus = true;
        }

        function openFixtureDialog() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/planogram/fixture/planogram-fixture-dialog.html',
                size: 'sm',
                controller: 'PlanogramFixtureDialog',
                controllerAs: 'vm',
                resolve: {
                    resFixture: function () {
                        return vm.fixtures;
                    }
                }
            }).result.then(function (res) {
                var redRes = res
                    .reduce(function (acc, idx) {
                        if (idx.status) {
                            acc.push({
                                categoryId: idx.categoryId,
                                categoryName: idx.categoryCategoryName,
                                fixtureId: idx.id,
                                fixtureName: idx.fixtureName,
                                id: null,
                                planogramId: vm.planogram.id,
                                target: 0
                            });
                        }
                        return acc;
                    }, []);
                vm.fixtures = vm.fixtures.concat(redRes);
            }, function () {

            });
        }

        function openSubFixtureDialog() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/planogram/fixture/planogram-subfixture-dialog.html',
                size: 'sm',
                controller: 'PlanogramSubFixtureDialog',
                controllerAs: 'vm',
                resolve: {
                    resFixture: function () {
                        return { id: vm.selectedFixtureId, name: vm.selectedFixtureName }
                    },
                    resSubFixture: function () {
                        return vm.subFixtures;
                    }
                }
            }).result.then(function (res) {
                var redRes = res
                    .reduce(function (acc, idx) {
                        if (idx.status) {
                            acc.push({
                                categoryId: idx.categoryId,
                                categoryName: idx.categoryCategoryName,
                                fixtureId: idx.id,
                                fixtureName: idx.fixtureName,
                                id: null,
                                planogramId: vm.planogram.id,
                                target: 0
                            });
                        }
                        return acc;
                    }, []);
                vm.subFixtures = vm.subFixtures.concat(redRes);
            }, function () {

            });
        }

        function openImportFixtureDialog() {
            $uibModal.open({
                templateUrl: 'app/entities/planogram/import/planogram-import-fixture.html',
                controller: 'PlanogramImportFixtureController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    planogramId: function () {
                        return vm.planogram.id;
                    }
                }
            }).result.then(function () {
                Planogram.getFixturePlanogram({
                    id: vm.planogram.id,
                }, function (data) {
                    angular.forEach(data, function (e) {
                        e.saved = true;
                    });
                    vm.fixtures = data;
                });
            }, function () {
                $state.go('^');
            });
        }

        function openImportEquipmentDialog() {
            $uibModal.open({
                templateUrl: 'app/entities/planogram/import/planogram-import-equipment.html',
                controller: 'PlanogramImportEquipmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    planogramId: function () {
                        return vm.planogram.id;
                    }
                }
            }).result.then(function () {
                loadEquipmentCategories();
            }, function () {
                $state.go('^');
            });
        }

        // load fixture categories
        function loadFixtureCategories(id) {
            Planogram.getProductCategoriesFixturePlanogram({
                id: id
            }, function (data) {
                vm.fixtureCategory = data;
            });
        }

        // load equipment categories
        function loadEquipmentCategories() {
            if (vm.planogram.id) {
                Planogram.getEquipmentsCategory({
                    id: vm.planogram.id,
                    root: true
                }, function (data) {
                    vm.equipmentCategories = data
                });

                getCategories();
            }
        }

        // disable weekend selection
        function disabled1(data) {
            var date = data.date, mode = data.mode;
            return mode === 'day'
                && (date.getDay() === 0 || date.getDay() === 2
                    || date.getDay() === 3 || date.getDay() === 4
                    || date.getDay() === 5 || date.getDay() === 6);
        }

        function getOutletById(id) {
            Outlet.get({ id: id }, function (data) {
                vm.outlet = data;
            });
        }

        // get outlet from db
        function getOutlet(value) {
            vm.loadingOutlet = true;
            return OutletSearch.query({
                query: '*' + value + '*'
            }).$promise.then(function (response) {
                vm.loadingOutlet = false;
                return limitToFilter(response, 5);
            }, function (response) {
                vm.loadingOutlet = false;
                AlertService.error(response.data.message);
            });
        }

        function getProductFixture(value) {
            var querySplit = value.split(/-|\//);
            var query = '';

            if (querySplit.length > 0) {
                query += '(';

                angular.forEach(querySplit, function (eachSplit, index) {
                    query += eachSplit;

                    if (index != querySplit.length - 1) {
                        query += ' AND '
                    }
                });

                query += '*)';
            } else {
                query = value;
            }

            vm.loadingProductFixture = true;
            return ProductSearch.query({
                query: query + ' AND deleted:false'
            }).$promise.then(function (response) {
                vm.loadingSku = false;
                var filteredResponse = response
                    .filter(function (each) {
                        var anyProducts = vm.fixtureProducts
                            .find(function (source) {
                                return source.id === each.id;
                            });
                        return !anyProducts;
                    });
                return limitToFilter(filteredResponse, 5);
            }, function (response) {
                vm.loadingSku = false;
            });
        }

        // on select outlet
        function onSelectOutlet(item) {
            vm.planogram.outletId = item.id;
            vm.planogram.outletOutletName = item.outletOutletName;
        }

        function onSelectFixture(param) {
            vm.selectedFixtureId = param.fixtureId;
            vm.selectedFixtureName = param.fixtureName;
            vm.selectedSubFixtureId = null;

            Planogram.getFixturePlanogram({
                id: vm.planogram.id,
                parentId: param.fixtureId
            }, function (data) {
                angular.forEach(data, function (e) {
                    e.saved = true;
                });
                vm.subFixtures = data;
            });
        }

        function onSelectSubFixture(id) {

            vm.selectedSubFixtureId = id;

            Planogram.getProductFixturesPlanogram({
                id: vm.planogram.id,
                fixtureId: id
            }, function (data) {
                vm.fixtureProducts = data;
            });
        }

        function onSelectFixtureProduct(item) {

            Planogram.updateProductFixture({
                id: vm.planogram.id
            }, {
                    fixtureId: vm.selectedSubFixtureId,
                    productId: item.id
                }, function (data) {
                    vm.fixtureProducts = vm.fixtureProducts.concat(item);
                    vm.productOpt = null;
                }, function (err) {
                });
        }

        function savePlanogramMaster(param) {
            vm.isSaving = true;
            if (param == 'edit') {
                vm.isEditing = false;
            } else {
                if (vm.planogram.id) {
                    Planogram.updatePlanogram(vm.planogram, onSaveSuccess, onSaveError);
                } else {
                    Planogram.savePlanogram(vm.planogram, onSaveSuccess, onSaveError);
                }
            }
        }

        // for fixture db interaction
        function putFixture(param) {
            Planogram.updatePlanogramFixture({
                id: vm.planogram.id
            }, {
                    fixtureId: param.fixtureId,
                    target: param.target
                }, function (data) {
                    param.saved = true;
                }, function (err) {
                    param.saved = false;
                })
        }

        function putEquipment(param) {
            Planogram.updatePlanogramEquipment({
                id: vm.planogram.id
            }, {
                    equipmentId: param.equipmentId,
                    target: param.target
                }, function (data) {
                    param.saved = true;
                }, function (err) {
                    param.saved = false;
                });
        }

        function deleteFixture(param, index, lvl) {
            Planogram.deletePlanogramFixture({
                id: vm.planogram.id,
                fixtureId: param.fixtureId
            }, function () {
                if (lvl === 1) {
                    vm.fixtures.splice(index, 1);
                    vm.selectedFixtureId = null;
                    vm.selectedSubFixtureId = null;
                } else {
                    vm.selectedSubFixtureId = null;
                    vm.subFixtures.splice(index, 1);
                }
            })
        }

        function deleteFixtureProduct(product, index) {
            Planogram.deleteFixtureProduct({
                id: vm.planogram.id,
                fixtureId: vm.selectedSubFixtureId,
                productId: product.id
            }, function () {
                vm.fixtureProducts.splice(index, 1);
            });

        }

        function deleteEquipmentProduct(material, index) {
            Planogram.deleteEquipmentProduct({
                id: vm.planogram.id,
                equipmentId: material.equipmentId
            }, function () {
                vm.materials.splice(index, 1);
                if(!vm.materials.length){

                    var catKeyIndex = findIndexById(vm.categoryEquipmentTree, vm.selectedCategory.id);
                    var subKeyIndex = findIndexById(vm.categoryEquipmentTree[catKeyIndex].childs, vm.selectedSubCategory.id);
                    vm.categoryEquipmentTree[catKeyIndex].childs.splice(subKeyIndex, 1);
                    vm.selectedSubCategory = null;
                    if(!vm.categoryEquipmentTree[catKeyIndex].childs.length){
                        vm.categoryEquipmentTree.splice(catKeyIndex,1);
                        vm.selectedCategory = null;
                    }
                }
            });
        }

        function onSaveSuccess(result) {
            vm.isEditing = true;
            $state.go('planogram.edit', { id: result.id });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        /* FLAG */
        function getCategories() {
            Planogram.getEquipmentsCategory({
                id: vm.planogram.id,
            }, function (data) {
                vm.categoryEquipmentTree = generateTree(data, null);
            });
        }
        
        function getMaterials(planogramId, categoryId) {
            return Planogram.getProductEquipmentsPlanogram({
                id: planogramId,
                categoryId: categoryId
            });
        }

        function generateTree(data, parentId) {
            return data.reduce(function (result, each) {
                if (each.parentId == parentId) {
                    each.childs = generateTree(data, each.id);

                    result.push(each);
                }

                return result;
            }, []);
        }

        function onSelectEquipmentCategories(category) {
            vm.selectedCategory = category;
            vm.selectedSubCategory = null;
        }

        function onSelectEquipmentSubCategories(subCategory) {
            vm.selectedSubCategory = subCategory;

            vm.materials = getMaterials(vm.planogram.id, subCategory.id);
        }

        function findIndexById(array, id) {
            var data = array.find(function(each) {
                return each.id === id;
            });

            return array.indexOf(data);
        }

        function openMaterialDialog() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/planogram/fixture/planogram-material-dialog.html',
                size: 'sm',
                controller: 'PlanogramMaterialDialog',
                controllerAs: 'vm',
                resolve: {
                    planogramId: function () {
                        return vm.planogram.id;
                    }
                }
            }).result.then(function (result) {
                var isCategoryExist = vm.categoryEquipmentTree.find(function(each) {
                        return each.id === result.category.id;
                    });

                /* push category when not found */
                isCategoryExist ||
                    vm.categoryEquipmentTree.push(result.category);

                /* set category */
                var indexCategory = findIndexById(vm.categoryEquipmentTree, result.category.id);
                
                vm.selectedCategory = vm.categoryEquipmentTree[indexCategory];

                var isSubCategoryExist = vm.selectedCategory.childs.find(function(each) {
                        return each.id === result.subCategory.id;
                    });

                /* push subCategory when not found */
                isSubCategoryExist ||
                    vm.categoryEquipmentTree[indexCategory].childs.push(result.subCategory);

                /* set subCategory */
                var indexSubCategory = findIndexById(vm.selectedCategory.childs, result.subCategory.id);
                
                vm.selectedSubCategory = vm.selectedCategory.childs[indexSubCategory];

                /* set materials */
                var existingMaterials = getMaterials(vm.planogram.id, result.subCategory.id);

                existingMaterials.$promise.then(function(data) {
                    vm.materials = [].concat(data, result.materials);
                });
            }, function () {

            });
        }
    }
})();;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramExportController', PlanogramExportController);

    PlanogramExportController.$inject = [];

    function PlanogramExportController () {
        var vm = this;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramDetailController', PlanogramDetailController);

    PlanogramDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Planogram', 'Outlet', '$locale'];

    function PlanogramDetailController($scope, $rootScope, $stateParams, entity, Planogram, Outlet, $locale) {
        var vm = this;

        vm.planogram = entity;

        vm.onSelectFixtureCategory = onSelectFixtureCategory;
        vm.onSelectFixture = onSelectFixture;
        vm.onSelectSubFixture = onSelectSubFixture;
        vm.loadEquipmentCategories = loadEquipmentCategories;
        vm.onSelectEquipmentCategories = onSelectEquipmentCategories;
        vm.onSelectEquipmentSubCategories = onSelectEquipmentSubCategories;

        (function () {
            vm.dateFormat = $locale.DATETIME_FORMATS.customTime;
            loadFixtureCategories(vm.planogram.id);
        })();

        // load fixture categories
        function loadFixtureCategories(id) {
            Planogram.getProductCategoriesFixturePlanogram({
                id: id
            }, function (data) {
                vm.fixtureCategory = data;
            });
        }

        // load equipment categories
        function loadEquipmentCategories() {
            Planogram.getEquipmentsCategory({
                id: vm.planogram.id,
                root: true
            }, function (data) {
                vm.equipmentCategories = data
            });
        }

        // all onSelect function in fixture tab  
        function onSelectFixtureCategory(index) {
            vm.selectedIndexFixtureCategory = index;

            // delete sub index
            vm.selectedIndexFixture = null;
            vm.selectedIndexSubFixture = null;

            Planogram.getFixturePlanogram({
                id: vm.planogram.id,
                categoryId: index
            }, function (data) {
                vm.fixtures = data;
            });
        }

        function onSelectFixture(index) {
            vm.selectedIndexFixture = index;
            // delete sub index
            vm.selectedIndexSubFixture = null;

            Planogram.getFixturePlanogram({
                id: vm.planogram.id,
                parentId: index
            }, function (data) {
                vm.subFixtures = data;
            });
        }

        function onSelectSubFixture(index) {
            vm.selectedIndexSubFixture = index;
            Planogram.getProductFixturesPlanogram({
                id: vm.planogram.id,
                fixtureId: index
            }, function (data) {
                vm.fixtureProducts = data;
            });
        }

        // all onSelect function in equipment tab
        function onSelectEquipmentCategories(index) {
            vm.selectedIndexEquipmentCategory = index;

            // delete sub index
            vm.selectedIndexEquipmentSubCategory = null;

            Planogram.getEquipmentsCategory({
                id: vm.planogram.id,
                root: false,
                parentId: index
            }, function (data) {
                vm.equipmentSubCategories = data;
            });
        }

        function onSelectEquipmentSubCategories(index) {
            vm.selectedIndexEquipmentSubCategory = index;

            Planogram.getProductEquipmentsPlanogram({
                id: vm.planogram.id,
                categoryId: index
            }, function (data) {
                vm.equipmentProducts = data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramDeleteController',PlanogramDeleteController);

    PlanogramDeleteController.$inject = ['$uibModalInstance', 'entity', 'Planogram'];

    function PlanogramDeleteController($uibModalInstance, entity, Planogram) {
        var vm = this;
        vm.planogram = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Planogram.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('planogram', {
                parent: 'entity',
                url: '/planogram?page&sort&search',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                    pageTitle: 'sceaApp.planogram.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/planogram/planograms.html',
                        controller: 'PlanogramController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('planogram');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('fixtures');
                        $translatePartialLoader.addPart('equipment');
                        $translatePartialLoader.addPart('calendar');
                        $translatePartialLoader.addPart('planogramFixture');
                        return $translate.refresh();
                    }]
                }
            })
            .state('planogram.export', {
                parent: 'planogram',
                url: '/export',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/planogram/planogram-export.html',
                        controller: 'PlanogramExportController',
                        controllerAs: 'vm'
                    },
                    'fixtures@planogram.export': {
                        templateUrl: 'app/entities/planogram/fixtures-export.html',
                        controller: 'FixturesExportController',
                        controllerAs: 'vm'
                    },
                    'equipment@planogram.export': {
                        templateUrl: 'app/entities/planogram/equipment-export.html',
                        controller: 'EquipmentExportController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('planogram.new', {
                parent: 'planogram',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/planogram/planogram-form.html',
                        controller: 'PlanogramFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            outletId: null,
                            outletOutletName: null,
                            periodStart: null
                        }
                    }
                }
            }).state('planogram.edit', {
                parent: 'planogram',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/planogram/planogram-form.html',
                        controller: 'PlanogramFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('planogram');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Planogram', function ($stateParams, Planogram) {
                        return Planogram.getPlanogramById({ id: $stateParams.id }).$promise;
                    }]
                }
            })
            .state('planogram.delete', {
                parent: 'planogram',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/planogram/planogram-delete-dialog.html',
                        controller: 'PlanogramDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Planogram', function (Planogram) {
                                return Planogram.get({ id: $stateParams.id });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('planogram', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('planogram-detail', {
                parent: 'planogram',
                url: '/{id}/detail',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/planogram/planogram-detail.html',
                        controller: 'PlanogramDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams','Planogram', function ($stateParams, Planogram) {
                        return Planogram.getPlanogramById({ id: $stateParams.id }).$promise;
                    }]
                }
            });
    }
})();
;
(function () {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Planogram', Planogram);

    Planogram.$inject = ['$resource', 'DateUtils'];

    function Planogram($resource, DateUtils) {
        var resourceUrl = 'api/planograms/:id';

        return $resource(resourceUrl, {}, {
            'queryPlanogram': { method: 'GET', isArray: true },
            'getPlanogramById': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.periodStart = DateUtils.convertDateTimeFromServer(data.periodStart);
                    return data;
                }
            },
            'updatePlanogram': { method: 'PUT' },
            'savePlanogram': { method: 'POST' },
            'getProductCategoriesFixturePlanogram': {
                url: 'api/planograms/:id/fixtures/product-categories',
                method: 'GET',
                isArray: true
            },
            'getFixturePlanogram': {
                url: 'api/planograms/:id/fixtures',
                method: 'GET',
                isArray: true
            },
            'getProductFixturesPlanogram': {
                url: 'api/planograms/:id/products',
                method: 'GET',
                isArray: true
            },
            'getEquipmentsCategory': {
                url: 'api/planograms/:id/equipment-categories',
                method: 'GET',
                isArray: true
            },
            'getProductEquipmentsPlanogram': {
                url: 'api/planograms/:id/equipments',
                method: 'GET',
                isArray: true
            },
            'updatePlanogramFixture': {
                url: 'api/planograms/:id/fixtures',
                method: 'PUT'
            },
            'updateProductFixture': {
                url: 'api/planograms/:id/products',
                method: 'PUT'
            },
            'updatePlanogramEquipment': {
                url: 'api/planograms/:id/equipments',
                method: 'PUT'
            },
            'deletePlanogramFixture': {
                url: 'api/planograms/:id/fixtures/:fixtureId',
                method: 'DELETE'
            },
            'deleteFixtureProduct': {
                url: 'api/planograms/:id/fixtures/:fixtureId/products/:productId',
                method: 'DELETE'
            },
            'deleteEquipmentProduct' : {
                url: 'api/planograms/:id/equipments/:equipmentId',
                method: 'DELETE'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PlanogramSearch', PlanogramSearch);

    PlanogramSearch.$inject = ['$resource'];

    function PlanogramSearch($resource) {
        var resourceUrl =  'api/_search/planograms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramController', PlanogramController);

    PlanogramController.$inject = ['$scope', '$state', 'Planogram', 'PlanogramSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$locale'];

    function PlanogramController ($scope, $state, Planogram, PlanogramSearch, ParseLinks, AlertService, pagingParams, paginationConstants, $locale) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            vm.dateFormat = $locale.DATETIME_FORMATS.customTime;

            if (pagingParams.search) {
                PlanogramSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Planogram.queryPlanogram({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.planogram = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramImportFixtureController',PlanogramImportFixtureController);

    PlanogramImportFixtureController.$inject = ['$uibModalInstance', '$scope', '$window', '$state', '$timeout', 'DataUtils', 'Planogram', 'Upload', 'planogramId'];

    function PlanogramImportFixtureController($uibModalInstance, $scope, $window, $state, $timeout, DataUtils, Planogram, Upload, planogramId) {
        var vm = this;

        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.clear = function() {
            $uibModalInstance.close(true);
        };
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;
            console.log(planogramId);

            Upload.upload({
                url: 'api/planograms/' + planogramId + '/fixture-product/import',
                data: {file: file}
            }).then(function(response){
                console.log(response);
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                    $uibModalInstance.close(true);
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramImportEquipmentController',PlanogramImportEquipmentController);

    PlanogramImportEquipmentController.$inject = ['$uibModalInstance', '$scope', '$window', '$state', '$timeout', 'DataUtils', 'Planogram', 'Upload', 'planogramId'];

    function PlanogramImportEquipmentController($uibModalInstance, $scope, $window, $state, $timeout, DataUtils, Planogram, Upload, planogramId) {
        var vm = this;

        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.clear = function() {
            $uibModalInstance.close(true);
        };
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/planograms/' + planogramId + '/equipment/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                    $uibModalInstance.close(true);
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use_strict';

    angular
        .module('sceaApp')
        .controller('FixturesExportController', FixturesExportController);

    FixturesExportController.$inject = ['$scope', '$state', '$q', 'Calendar', 'ProductCategory', 'Fixtures'];

    function FixturesExportController($scope, $state, $q, Calendar, ProductCategory, Fixtures) {
        var vm = this;

        vm.getWeeks = getWeeks;
        vm.exportAsCsv = exportAsCsv;

        (function (){

            vm.isExporting = false;

            // model input
            vm.exportRequest = {
                year: null,
                month: null,
                week: null,
                categoryId: null
            }

            // options data for year
            Calendar.queryYears(function(data) {
                vm.years = data;
            });

            // options data for month
            Calendar.queryMonths(function(data) {
                vm.months = data;
            });

            // options data for category 
            vm.productcategories = ProductCategory.getAllProductCategories({level: 2});
        })();

        // a method to get weeks option data
        function getWeeks(year, month){
            if(year && month){
                Calendar.queryWeeks({
                    year: year,
                    month: month
                }, function(data){
                    vm.weeks = data;
                });
            } else {
                vm.exportRequest.month = null;
                vm.exportRequest.week = null;
            }
        }

        // a mehtod to export data to csv
        function exportAsCsv(){
            vm.isExporting = true;
            Fixtures.exportAsCsv(vm.exportRequest, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.isExporting = false;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramSubFixtureDialog', PlanogramSubFixtureDialog);

    PlanogramSubFixtureDialog.$inject = ['$scope', '$uibModalInstance', 'resSubFixture', 'resFixture', 'ProductCategory', 'Fixtures'];

    function PlanogramSubFixtureDialog($scope, $uibModalInstance, resSubFixture, resFixture, ProductCategory, Fixtures) {
        var vm = this;

        vm.addSubFixture = addSubFixture;
        vm.cancel = cancel;
        vm.checkAll = checkAll;

        (function () {
            vm.fixtureName = resFixture.name;

            Fixtures.query({
                parent: resFixture.id
            }, function (data, headers) {
                Fixtures.query({
                    parent: resFixture.id,
                    size: headers('x-total-count')
                }, function (data) {
                    vm.subFixtures = data
                        .filter(function (each) {
                            var anyFixture = resSubFixture
                                .find(function (source) {
                                    return source.fixtureId === each.id;
                                });

                            return !anyFixture;
                        });
                });
            })
        })()

        function checkAll(isChecked) {
            if (isChecked) {
                angular.forEach(vm.subFixtures, function (e) {
                    e.status = true;
                });
            } else {
                angular.forEach(vm.subFixtures, function (e) {
                    e.status = false;
                });
            }
        }

        function addSubFixture() {
            $uibModalInstance.close(vm.subFixtures);
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramMaterialDialog', PlanogramMaterialDialog);

    PlanogramMaterialDialog.$inject = ['$scope', '$uibModalInstance', 'Equipment', 'Planogram', 'planogramId'];

    function PlanogramMaterialDialog($scope, $uibModalInstance, Equipment, Planogram, planogramId) {
        var vm = this;

        vm.addMaterial = addMaterial;
        vm.cancel = cancel;
        vm.onChangeCategories = onChangeCategories;
        vm.onChangeSubCategories = onChangeSubCategories;
        vm.checkAll = checkAll;

        (function () {
            Equipment.getEquipmentCategory({
                root: true
            }, function (data) {
                vm.categories = data;
                vm.catOption = data[0];

                Equipment.getEquipmentCategory({
                    root: false,
                    parentId: vm.catOption.id
                }, function (data) {
                    vm.subCategories = data;
                    vm.subOption = data[0];
                    Equipment.getEquipmentCategory({
                        root: false,
                        parentId: vm.subOption.id
                    }, function (data) {
                        vm.notFilteredMaterials = data;
                        Planogram.getProductEquipmentsPlanogram({
                            id: planogramId,
                            categoryId: vm.subOption.id
                        }, function (data) {
                            vm.materials = vm.notFilteredMaterials
                                .filter(function (each) {
                                    var anyMaterial = data
                                        .find(function (source) {
                                            return source.equipmentId === each.id;
                                        });
                                    return !anyMaterial;
                                });
                        });
                    });
                });
            });
        })();

        function onChangeCategories(id) {
            vm.check = false;
            Equipment.getEquipmentCategory({
                root: false,
                parentId: id
            }, function (data) {
                vm.subCategories = data;
                vm.subOption = data[0];

                if (!data.length) {
                    vm.subOption = null;
                    vm.materials = [];
                } else {
                    Equipment.getEquipmentCategory({
                        root: false,
                        parentId: vm.subOption.id
                    }, function (data, headers) {
                        vm.notFilteredMaterials = data;
                        Planogram.getProductEquipmentsPlanogram({
                            id: planogramId,
                            categoryId: vm.subOption.id
                        }, function (data) {
                            vm.materials = vm.notFilteredMaterials
                                .filter(function (each) {
                                    var anyMaterial = data
                                        .find(function (source) {
                                            return source.equipmentId === each.id;
                                        });
                                    return !anyMaterial;
                                });
                        });
                    });
                }
            });
        }

        function onChangeSubCategories(id) {
            vm.check = false;
            Equipment.getEquipmentCategory({
                root: false,
                parentId: id
            }, function (data) {
                vm.notFilteredMaterials = data;
                Planogram.getProductEquipmentsPlanogram({
                    id: planogramId,
                    categoryId: vm.subOption.id
                }, function (data) {
                    vm.materials = vm.notFilteredMaterials
                        .filter(function (each) {
                            var anyMaterial = data
                                .find(function (source) {
                                    return source.equipmentId === each.id;
                                });
                            return !anyMaterial;
                        });
                });
            });
        }

        function checkAll(isChecked) {
            if (isChecked) {
                angular.forEach(vm.materials, function (e) {
                    e.status = true;
                });
            } else {
                angular.forEach(vm.materials, function (e) {
                    e.status = false;
                });
            }
        }

        function addMaterial() {
            vm.catOption.childs = [];
            var reduceMaterials = vm.materials
                .reduce(function (acc, idx) {
                    idx.status && acc.push({
                        id: null,
                        equipmentEquipmentName: idx.equipmentName,
                        equipmentId: idx.id,
                        target: 0
                    });
                    return acc;
                }, []);

            var result = {
                category: vm.catOption,
                subCategory: vm.subOption,
                materials: reduceMaterials
            };

            $uibModalInstance.close(result);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PlanogramFixtureDialog', PlanogramFixtureDialog);

    PlanogramFixtureDialog.$inject = ['$scope', '$uibModalInstance', 'resFixture', 'ProductCategory', 'Fixtures'];

    function PlanogramFixtureDialog($scope, $uibModalInstance, resFixture, ProductCategory, Fixtures) {
        var vm = this;

        vm.addFixture = addFixture;
        vm.cancel = cancel;
        vm.changeFixtureList = changeFixtureList;
        vm.checkAll = checkAll;

        (function () {
            ProductCategory.getAllProductCategories({
                level: 2
            }, function (data) {
                vm.categories = data;
                vm.option = data[0];
                getFixtures(vm.option.id);
            });
        })()

        function changeFixtureList(id) {
            vm.check = false;
            getFixtures(id)
        }

        function getFixtures(id) {
            Fixtures.query({
                categoryId: id,
                parent: 'null'
            }, function (data) {
                vm.fixtures = data
                    .filter(function (each) {
                        var anyFixture = resFixture
                            .find(function (source) {
                                return source.fixtureId === each.id;
                            });

                        return !anyFixture;
                    });
            })
        }

        function checkAll(isChecked) {
            if (isChecked) {
                angular.forEach(vm.fixtures, function (e) {
                    e.status = true;
                });
            } else {
                angular.forEach(vm.fixtures, function (e) {
                    e.status = false;
                });
            }
        }

        function addFixture() {
            $uibModalInstance.close(vm.fixtures);
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use_strict';

    angular
        .module('sceaApp')
        .controller('EquipmentExportController', EquipmentExportController);

    EquipmentExportController.$inject = ['$scope', '$state', '$q', 'Calendar', 'ProductCategory', 'Equipment'];

    function EquipmentExportController($scope, $state, $q, Calendar, ProductCategory, Equipment) {
        var vm = this;

        vm.getWeeks = getWeeks;
        vm.exportAsCsv = exportAsCsv;

        (function (){

            vm.isExporting = false;

            // model input
            vm.exportRequest = {
                year: null,
                month: null,
                week: null
            }

            // options data for year
            Calendar.queryYears(function(data) {
                vm.years = data;
            });

            // options data for month
            Calendar.queryMonths(function(data) {
                vm.months = data;
            });

        })();

        // a method to get weeks option data
        function getWeeks(year, month){
            if(year && month){
                Calendar.queryWeeks({
                    year: year,
                    month: month
                }, function(data){
                    vm.weeks = data;
                });
            } else {
                vm.exportRequest.month = null;
                vm.exportRequest.week = null;
            }
        }

        // a mehtod to export data to csv
        function exportAsCsv(){
            vm.isExporting = true;
            Equipment.exportAsCsv(vm.exportRequest, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.isExporting = false;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
    }
})();;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletpointDialogController', OutletpointDialogController);

    OutletpointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity',
        'Outletpoint', 'Outlet', 'Droppoint', 'OutletSearch', 'DroppointSearch'];

    function OutletpointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Outletpoint,
        Outlet, Droppoint, OutletSearch, DroppointSearch) {

        var vm = this;
        vm.outletpoint = entity;

        vm.searchingOutlet = false;
        vm.searchingDroppoint = false;
        vm.selectedOutlet;
        vm.selectedDroppoint;

        if (vm.outletpoint.$promise) {
            vm.outletpoint.$promise.then(function(outletpoint){
                if (outletpoint.outletId) {
                    Outlet.get({id: outletpoint.outletId}, function(outlet){
                        vm.selectedOutlet = outlet;
                    });
                }

                if (outletpoint.droppointId) {
                    Droppoint.get({id: outletpoint.droppointId}, function(droppoint){
                        vm.selectedDroppoint = droppoint;
                    });
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:outletpointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.outletpoint.id !== null) {
                Outletpoint.update(vm.outletpoint, onSaveSuccess, onSaveError);
            } else {
                Outletpoint.save(vm.outletpoint, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.$watch(angular.bind(this, function(){
            return this.selectedOutlet;
        }), function(newValue, oldValue){
            if (newValue){
                vm.outletpoint.outletId = newValue.id;
            } else {
                vm.outletpoint.outletId = null;
            }
        });

        $scope.$watch(angular.bind(this, function(){
            return this.selectedDroppoint;
        }), function(newValue, oldValue){
            if (newValue) {
                vm.outletpoint.droppointId = newValue.id;
            } else {
                vm.outletpoint.droppointId = null;
            }

        });

        vm.searchOutlet = function(keyword) {
            vm.searchingOutlet = true;
            return OutletSearch.query({query: keyword, filter: 'outletpoint-is-null'})
                .$promise.then(function(data){
                    vm.searchingOutlet = false;
                    return data;
                }, function(error){
                    vm.searchingOutlet = false;
                });
        }

        vm.searchDroppoint = function(keyword) {
            vm.searchingDroppoint = true;
            return DroppointSearch.query({query: keyword})
                .$promise.then(function(data){
                    vm.searchingDroppoint = false;
                    return data;
                }, function(error){
                    vm.searchingDroppoint = false;
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletpointDetailController', OutletpointDetailController);

    OutletpointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Outletpoint', 'Outlet', 'Droppoint'];

    function OutletpointDetailController($scope, $rootScope, $stateParams, entity, Outletpoint, Outlet, Droppoint) {
        var vm = this;
        vm.outletpoint = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:outletpointUpdate', function(event, result) {
            vm.outletpoint = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletpointDeleteController',OutletpointDeleteController);

    OutletpointDeleteController.$inject = ['$uibModalInstance', 'entity', 'Outletpoint'];

    function OutletpointDeleteController($uibModalInstance, entity, Outletpoint) {
        var vm = this;
        vm.outletpoint = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Outletpoint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outletpoint', {
            parent: 'entity',
            url: '/outletpoint?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletpoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outletpoint/outletpoints.html',
                    controller: 'OutletpointController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletpoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('outletpoint-detail', {
            parent: 'entity',
            url: '/outletpoint/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletpoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outletpoint/outletpoint-detail.html',
                    controller: 'OutletpointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletpoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Outletpoint', function($stateParams, Outletpoint) {
                    return Outletpoint.get({id : $stateParams.id});
                }]
            }
        })
        .state('outletpoint.new', {
            parent: 'outletpoint',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outletpoint/outletpoint-dialog.html',
                    controller: 'OutletpointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('outletpoint', null, { reload: true });
                }, function() {
                    $state.go('outletpoint');
                });
            }]
        })
        .state('outletpoint.edit', {
            parent: 'outletpoint',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outletpoint/outletpoint-dialog.html',
                    controller: 'OutletpointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Outletpoint', function(Outletpoint) {
                            return Outletpoint.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outletpoint', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outletpoint.delete', {
            parent: 'outletpoint',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outletpoint/outletpoint-delete-dialog.html',
                    controller: 'OutletpointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Outletpoint', function(Outletpoint) {
                            return Outletpoint.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outletpoint', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Outletpoint', Outletpoint);

    Outletpoint.$inject = ['$resource'];

    function Outletpoint ($resource) {
        var resourceUrl =  'api/outletpoints/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OutletpointSearch', OutletpointSearch);

    OutletpointSearch.$inject = ['$resource'];

    function OutletpointSearch($resource) {
        var resourceUrl =  'api/_search/outletpoints/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletpointController', OutletpointController);

    OutletpointController.$inject = ['$scope', '$state', 'Outletpoint', 'OutletpointSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OutletpointController ($scope, $state, Outletpoint, OutletpointSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OutletpointSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Outletpoint.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outletpoints = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletTypeDialogController', OutletTypeDialogController);

    OutletTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OutletType'];

    function OutletTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OutletType) {
        var vm = this;
        vm.outletType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:outletTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.outletType.id !== null) {
                OutletType.update(vm.outletType, onSaveSuccess, onSaveError);
            } else {
                OutletType.save(vm.outletType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletTypeDetailController', OutletTypeDetailController);

    OutletTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OutletType'];

    function OutletTypeDetailController($scope, $rootScope, $stateParams, entity, OutletType) {
        var vm = this;
        vm.outletType = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:outletTypeUpdate', function(event, result) {
            vm.outletType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletTypeDeleteController',OutletTypeDeleteController);

    OutletTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'OutletType'];

    function OutletTypeDeleteController($uibModalInstance, entity, OutletType) {
        var vm = this;
        vm.outletType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OutletType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outlet-type', {
            parent: 'entity',
            url: '/outlet-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-type/outlet-types.html',
                    controller: 'OutletTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('outlet-type-detail', {
            parent: 'entity',
            url: '/outlet-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-type/outlet-type-detail.html',
                    controller: 'OutletTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OutletType', function($stateParams, OutletType) {
                    return OutletType.get({id : $stateParams.id});
                }]
            }
        })
        .state('outlet-type.new', {
            parent: 'outlet-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-type/outlet-type-dialog.html',
                    controller: 'OutletTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                outletTypeName: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('outlet-type', null, { reload: true });
                }, function() {
                    $state.go('outlet-type');
                });
            }]
        })
        .state('outlet-type.edit', {
            parent: 'outlet-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-type/outlet-type-dialog.html',
                    controller: 'OutletTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OutletType', function(OutletType) {
                            return OutletType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-type.delete', {
            parent: 'outlet-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-type/outlet-type-delete-dialog.html',
                    controller: 'OutletTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OutletType', function(OutletType) {
                            return OutletType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OutletType', OutletType);

    OutletType.$inject = ['$resource'];

    function OutletType ($resource) {
        var resourceUrl =  'api/outlet-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OutletTypeSearch', OutletTypeSearch);

    OutletTypeSearch.$inject = ['$resource'];

    function OutletTypeSearch($resource) {
        var resourceUrl =  'api/_search/outlet-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletTypeController', OutletTypeController);

    OutletTypeController.$inject = ['$scope', '$state', 'OutletType', 'OutletTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OutletTypeController ($scope, $state, OutletType, OutletTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OutletTypeSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OutletType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outletTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletRetailMappingImportController', OutletRetailMappingImportController);

    OutletRetailMappingImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function OutletRetailMappingImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlet-retail-mappings/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletRetailMappingDialogController', OutletRetailMappingDialogController);

    OutletRetailMappingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlertService', 'OutletRetailMapping', 'Channel', 'User', 'UserSearch'];

    function OutletRetailMappingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AlertService, OutletRetailMapping, Channel, User, UserSearch) {
        var vm = this;

        vm.clear = clear;
        vm.getUser = getUser;
        vm.save = save;

        vm.outletRetailMapping = entity;
        vm.channels = Channel.query();

        if (vm.outletRetailMapping.$promise) {
            vm.outletRetailMapping.$promise.then(function(data) {
                if(data.retailMappingSurveyorLogin != null) {
                    User.get({login: data.retailMappingSurveyorLogin}, function(surveyor) {
                        vm.surveyor = surveyor;   
                    });
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.surveyor) {
                vm.outletRetailMapping.retailMappingSurveyorId = vm.surveyor.id;
                vm.outletRetailMapping.retailMappingSurveyorLogin = vm.surveyor.login;
            }

            if (vm.outletRetailMapping.id !== null) {
                OutletRetailMapping.update(vm.outletRetailMapping, onSaveSuccess, onSaveError);
            } else {
                OutletRetailMapping.save(vm.outletRetailMapping, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sceaApp:outletRetailMappingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getUser(role, value) {
            vm.loadingUser = true;

            return UserSearch.query({
                roleName: role,
                query: value
            }).$promise.then(function(response){
                vm.loadingUser = false;
                return response;
            }, function(response){
                vm.loadingUser = false;
                AlertService.error(response.data.message);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletRetailMappingDetailController', OutletRetailMappingDetailController);

    OutletRetailMappingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OutletRetailMapping', 'Channel', 'User'];

    function OutletRetailMappingDetailController($scope, $rootScope, $stateParams, previousState, entity, OutletRetailMapping, Channel, User) {
        var vm = this;

        vm.outletRetailMapping = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sceaApp:outletRetailMappingUpdate', function(event, result) {
            vm.outletRetailMapping = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletRetailMappingDeleteController',OutletRetailMappingDeleteController);

    OutletRetailMappingDeleteController.$inject = ['$uibModalInstance', 'entity', 'OutletRetailMapping'];

    function OutletRetailMappingDeleteController($uibModalInstance, entity, OutletRetailMapping) {
        var vm = this;

        vm.outletRetailMapping = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OutletRetailMapping.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outlet-retail-mapping', {
            parent: 'entity',
            url: '/outlet-retail-mapping?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletRetailMapping.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mappings.html',
                    controller: 'OutletRetailMappingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletRetailMapping');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('outlet-retail-mapping-detail', {
            parent: 'outlet-retail-mapping',
            url: '/outlet-retail-mapping/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletRetailMapping.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-detail.html',
                    controller: 'OutletRetailMappingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletRetailMapping');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OutletRetailMapping', function($stateParams, OutletRetailMapping) {
                    return OutletRetailMapping.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'outlet-retail-mapping',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('outlet-retail-mapping-detail.edit', {
            parent: 'outlet-retail-mapping-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-dialog.html',
                    controller: 'OutletRetailMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OutletRetailMapping', function(OutletRetailMapping) {
                            return OutletRetailMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-retail-mapping.new', {
            parent: 'outlet-retail-mapping',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-dialog.html',
                    controller: 'OutletRetailMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                address: null,
                                phoneNumber: null,
                                personInCharge: null,
                                picStatus: null,
                                provinsi: null,
                                kabupaten: null,
                                kecamatan: null,
                                kelurahan: null,
                                postalCode: null,
                                mcsOutletId: null,
                                withPromotor: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('outlet-retail-mapping', null, { reload: 'outlet-retail-mapping' });
                }, function() {
                    $state.go('outlet-retail-mapping');
                });
            }]
        })
        .state('outlet-retail-mapping.edit', {
            parent: 'outlet-retail-mapping',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-dialog.html',
                    controller: 'OutletRetailMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OutletRetailMapping', function(OutletRetailMapping) {
                            return OutletRetailMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-retail-mapping', null, { reload: 'outlet-retail-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-retail-mapping.delete', {
            parent: 'outlet-retail-mapping',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-delete-dialog.html',
                    controller: 'OutletRetailMappingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OutletRetailMapping', function(OutletRetailMapping) {
                            return OutletRetailMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-retail-mapping', null, { reload: 'outlet-retail-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-retail-mapping-import',{
                    parent: 'entity',
                    url: '/outlet-retail-mapping-import',
                    data: {
                        authorities: ['ROLE_ADMIN', 'VDR'],
                        pageTitle: 'sceaApp.outletRetailMapping.import.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/outlet-retail-mapping/outlet-retail-mapping-import.html',
                            controller: 'OutletRetailMappingImportController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('outletRetailMapping');
                            return $translate.refresh();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'outlet-retail-mapping',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OutletRetailMapping', OutletRetailMapping);

    OutletRetailMapping.$inject = ['$resource'];

    function OutletRetailMapping ($resource) {
        var resourceUrl =  'api/outlet-retail-mappings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OutletRetailMappingSearch', OutletRetailMappingSearch);

    OutletRetailMappingSearch.$inject = ['$resource'];

    function OutletRetailMappingSearch($resource) {
        var resourceUrl =  'api/_search/outlet-retail-mappings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletRetailMappingController', OutletRetailMappingController);

    OutletRetailMappingController.$inject = ['$state', 'OutletRetailMapping', 'OutletRetailMappingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OutletRetailMappingController($state, OutletRetailMapping, OutletRetailMappingSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OutletRetailMappingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OutletRetailMapping.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outletRetailMappings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletAccountDialogController', OutletAccountDialogController);

    OutletAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OutletAccount'];

    function OutletAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OutletAccount) {
        var vm = this;
        vm.outletAccount = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:outletAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.outletAccount.id !== null) {
                OutletAccount.update(vm.outletAccount, onSaveSuccess, onSaveError);
            } else {
                OutletAccount.save(vm.outletAccount, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletAccountDetailController', OutletAccountDetailController);

    OutletAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OutletAccount'];

    function OutletAccountDetailController($scope, $rootScope, $stateParams, entity, OutletAccount) {
        var vm = this;
        vm.outletAccount = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:outletAccountUpdate', function(event, result) {
            vm.outletAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletAccountDeleteController',OutletAccountDeleteController);

    OutletAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'OutletAccount'];

    function OutletAccountDeleteController($uibModalInstance, entity, OutletAccount) {
        var vm = this;
        vm.outletAccount = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OutletAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outlet-account', {
            parent: 'entity',
            url: '/outlet-account?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-account/outlet-accounts.html',
                    controller: 'OutletAccountController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('outlet-account-detail', {
            parent: 'entity',
            url: '/outlet-account/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outletAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet-account/outlet-account-detail.html',
                    controller: 'OutletAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outletAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OutletAccount', function($stateParams, OutletAccount) {
                    return OutletAccount.get({id : $stateParams.id});
                }]
            }
        })
        .state('outlet-account.new', {
            parent: 'outlet-account',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-account/outlet-account-dialog.html',
                    controller: 'OutletAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                accountName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('outlet-account', null, { reload: true });
                }, function() {
                    $state.go('outlet-account');
                });
            }]
        })
        .state('outlet-account.edit', {
            parent: 'outlet-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-account/outlet-account-dialog.html',
                    controller: 'OutletAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OutletAccount', function(OutletAccount) {
                            return OutletAccount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-account.delete', {
            parent: 'outlet-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet-account/outlet-account-delete-dialog.html',
                    controller: 'OutletAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OutletAccount', function(OutletAccount) {
                            return OutletAccount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OutletAccount', OutletAccount);

    OutletAccount.$inject = ['$resource'];

    function OutletAccount ($resource) {
        var resourceUrl =  'api/outlet-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OutletAccountSearch', OutletAccountSearch);

    OutletAccountSearch.$inject = ['$resource'];

    function OutletAccountSearch($resource) {
        var resourceUrl =  'api/_search/outlet-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletAccountController', OutletAccountController);

    OutletAccountController.$inject = ['$scope', '$state', 'OutletAccount', 'OutletAccountSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OutletAccountController ($scope, $state, OutletAccount, OutletAccountSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OutletAccountSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OutletAccount.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outletAccounts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletVdoImportController', OutletVdoImportController);

    OutletVdoImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function OutletVdoImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlets/vdo-mapping/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletPopPairVersionImportController', OutletPopPairVersionImportController);

    OutletPopPairVersionImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function OutletPopPairVersionImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlets/pop-pair-version-mapping/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();;
(function() {
    'use strict';

    angular
      .module('sceaApp')
      .controller('OutletMapController', OutletMapController);

    OutletMapController.$inject = ['$scope', '$state', 'leafletData', 'Outlet'];

    function OutletMapController ($scope, $state, leafletData, Outlet) {
        var vm = this;
        var outletMap = null;
        var baseMap = null;
        var control = null;

        vm.init = init;
        vm.init();

        function init() {

            Outlet.getGeoJson({}, onSuccess, onError);
            function onSuccess(data) {

                    var geoJsonData = {
                        'type': "Feature Collection",
                        'features': data.features
                    }

                    var markers = L.markerClusterGroup();
                    var geoJsonLayer = L.geoJson(geoJsonData, {
                        onEachFeature: function(feature, layer) {
                            var coords = L.latLng(feature.geometry.coordinates);
                            var popupHover = L.popup({ closeOnClick: false })
                                .setContent(feature.properties.code + ", " + feature.properties.name + "<br>" + "Click marker for more information");
                            var popupClick = L.popup({ closeOnClick: false });
                            layer.on('mouseover', function() {
                                layer.bindPopup(popupHover).openPopup();
                                Outlet.get({id: feature.id}, onSuccess, onError);
                                function onSuccess(data) {
                                    popupClick.setContent(
                                        "Code: " + data.outletCode + "<br>" +
                                        "Name: " + data.outletName + "<br>" +
                                        "Address: " + data.outletAddress + "<br>" +
                                        "Latitude: " + data.latitude + "<br>" +
                                        "Longitude: " + data.longitude + "<br>" +
                                        "Facility: " + data.outletFacility + "<br>" +
                                        "PC Status: " + data.pcStatus + "<br>" +
                                        "Perfect Store Status: " + data.perfectStoreStatus + "<br>" +
                                        "RIS Status: " + data.risStatus + "<br>"
                                    );
                                }
                                function onError(error) {
                                    AlertService.error(error.data.message);
                                }
                            });
                            layer.on('click', function() {
                                layer.bindPopup(popupClick);
                            });
                        }
                    });

                    markers.addLayer(geoJsonLayer);

                    outletMap.addLayer(markers);

                    outletMap.fitBounds(markers.getBounds());

                    var searchControl = new L.Control.Search({
                        layer: geoJsonLayer,
                        propertyName: 'name',
                        marker: false,
                        moveToLocation: function(coords) {
                            outletMap.setView(coords, 15);
                        }
                    });

                    outletMap.addControl( searchControl );

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            outletMap = L.map('outlet-map', {zoomControl: false}).setView([-1, 120], 5);
            outletMap.myLayers = [];

            var klikpetaStreets = L.tileLayer('https://map1.klikpeta.com/klikpeta_tiles/{z}/{x}/{y}.png',{
                maxZoom: 20
            });

        	var googleSat = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
        	    maxZoom: 20,
        	    subdomains:['mt0','mt1','mt2','mt3']
        	});

        	klikpetaStreets.addTo(outletMap);

        	baseMap = {
        		'Klikpeta Streets': klikpetaStreets,
        	    'Google Satellite': googleSat
        	};

    	    var groupedOverlays = { 'Batas Wilayah Demarkasi': {} };

    	    outletMap.control = L.control.groupedLayers(baseMap, groupedOverlays).addTo(outletMap);

        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletImportController', OutletImportController);

    OutletImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function OutletImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlets/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletGradeImportController', OutletGradeImportController);

    OutletGradeImportController.$inject = ['$scope', '$state', '$timeout', 'DataUtils', 'Upload', 'previousState'];

    function OutletGradeImportController($scope, $state, $timeout, DataUtils, Upload, previousState) {
        var vm = this;

        vm.previousState = previousState.name;
        vm.data = {}

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.setData = setData;
        vm.upload = upload;

        function setData(file) {
            if (file) {
                vm.file = file;
                vm.isUploading = false;
                vm.isUploadFinished = false;

                vm.data.dataContentType = file.type;
                vm.data.fileName = file.name;
                vm.data.size = file.size;
            }
        }

        function upload(file) {
            vm.isUploading = true;

            Upload.upload({
                url: 'api/outlets/grade-mapping/import',
                data: {file: file}
            }).then(function(response){
                $timeout(function(){
                    file.result = 'Success ' + response.config.data.file.name + 'uploaded. Response: ' + response.data;
                    vm.logs = false;
                });
            }, function(response){
                vm.logs = response.data;

                if (response.status > 0) {
                    file.error = response.status + ': ' + response.data;
                }
            }, function(evt){
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = 'Progress: ' + progressPercentage + '%';
            });

            vm.isUploadFinished = true;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletDialogController', OutletDialogController);

    OutletDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ParseLinks', 'AlertService', 'entity', 'Outlet', 'OutletSearch', 'Channel', 'OutletAccount', 'OutletType', 'User', 'Area', 'VisitCycle', 'UserSearch', 'AreaSearch', 'PopPairVersion', 'PopPairVersionSearch', 'leafletData'];

    function OutletDialogController($timeout, $scope, $stateParams, $uibModalInstance, ParseLinks, AlertService, entity, Outlet, OutletSearch, Channel, OutletAccount, OutletType, User, Area, VisitCycle, UserSearch, AreaSearch, PopPairVersion, PopPairVersionSearch, leafletData) {
        var vm = this;

        vm.outlet = entity;
        vm.channels = Channel.query();
        vm.outletaccounts = OutletAccount.query();
        vm.outlettypes = OutletType.query();
        vm.visitcycles = VisitCycle.query();
        vm.loadingUser = false;
        vm.loadingArea = false;
        vm.updateMarker = updateMarker;

        vm.getArea = getArea;
        vm.getPopPairVersion = getPopPairVersion;
        vm.getUser = getUser;
        vm.checkOutletCode = checkOutletCode;

        var drawControl, drawnItems;
        var marker = null;
        var baseMap = null;
        var control = null;

        if (vm.outlet.$promise) {
            vm.outlet.$promise.then(function (data) {
                if (data.promotorLogin != null) {
                    User.get({ login: data.promotorLogin }, function (promotor) {
                        vm.promotor = promotor;
                    });
                }

                if (data.vdoLogin != null) {
                    User.get({ login: data.vdoLogin }, function (vdo) {
                        vm.vdo = vdo;
                    });
                }

                if (data.rmSurveyorLogin != null) {
                    User.get({ login: data.rmSurveyorLogin }, function (rmSurveyor) {
                        vm.rmSurveyor = rmSurveyor;
                    });
                }

                if (data.areaId != null) {
                    Area.get({ id: data.areaId }, function (area) {
                        vm.outletArea = area;
                    });
                }

                if (data.popPairVersionId != null) {
                    PopPairVersion.get({ id: data.popPairVersionId }, function (popPairVersion) {
                        vm.popPairVersion = popPairVersion;
                    });
                }

                updateMarker();
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
            fixMapOnModal();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:outletUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;

            vm.outlet.promotorId = (vm.promotor) ? vm.promotor.id : null;
            vm.outlet.vdoId = (vm.vdo) ? vm.vdo.id : null;
            vm.outlet.rmSurveyorId = (vm.rmSurveyor) ? vm.rmSurveyor.id : null;
            vm.outlet.areaId = (vm.outletArea) ? vm.outletArea.id : null;
            vm.outlet.popPairVersionId = (vm.popPairVersion) ? vm.popPairVersion.id : null;

            if (vm.outlet.id !== null) {
                Outlet.update(vm.outlet, onSaveSuccess, onSaveError);
            } else {
                Outlet.save(vm.outlet, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getUser(role, value) {
            vm.loadingUser = true;
            var queryAndOrCriteria = {
                andCriteria: {
                    authorities: {
                        contains: role
                    }
                }
            };

            if (value) {
                queryAndOrCriteria = Object.assign(queryAndOrCriteria, {
                    orCriteria: {
                        id: {
                            equals: isNaN(value) ? '' : value
                        },
                        firstName: {
                            contains: value
                        }
                    }
                });
            }

            return User.andOrCriteria(queryAndOrCriteria).$promise.then(
                function (response) {
                    vm.loadingUser = false;
                    return response;
                },
                function (response) {
                    vm.loadingUser = false;
                    AlertService.error(response.data.message);
                }
            );
        }

        function getArea(value) {
            vm.loadingArea = true;
            return AreaSearch.query({
                query: 'areaName:*' + value + '* AND areaLevel.levelName:CITY'
            }).$promise.then(function (response) {
                vm.loadingArea = false;
                return response;
            }, function (response) {
                vm.loadingArea = false;
                AlertService.error(response.data.message);
            });
        };

        function getPopPairVersion(value) {
                vm.loadingPopPairVersion = true;
                return PopPairVersionSearch.query({
                    query: 'name:*' + value
                }).$promise.then(function (response) {
                    vm.loadingPopPairVersion = false;
                    return response;
                }, function (response) {
                    vm.loadingPopPairVersion = false;
                    AlertService.error(response.data.message);
                });
            };

        leafletData.getMap().then(function (map) {
            map.setView([-6.181, 106.821], 11);

            var klikpetaStreets = L.tileLayer('https://map1.klikpeta.com/klikpeta_tiles/{z}/{x}/{y}.png', {
                maxZoom: 20
            });

            klikpetaStreets.addTo(map);

            drawnItems = new L.FeatureGroup();

            map.addLayer(drawnItems);

            drawControl = new L.Control.Draw({
                position: 'topright',
                draw: {
                    polyline: false,
                    polygon: false,
                    rectangle: false,
                    circle: false,
                    marker: {
                        repeatMode: false,
                    }
                }
            });

            map.addControl(drawControl);
            map.on('draw:created', function (e) {
                marker = e.layer;
                drawnItems.addLayer(marker);

                var latLng = getLatLng(drawnItems);

                vm.outlet.latitude = latLng.lat;
                vm.outlet.longitude = latLng.lng;

                map.removeControl(drawControl);

                drawControl = new L.Control.Draw({
                    position: 'topright',
                    draw: false,
                    edit: {
                        featureGroup: drawnItems
                    }
                });

                map.addControl(drawControl);
            });
            map.on('draw:edited', function (e) {
                var latLng = getLatLng(drawnItems);

                vm.outlet.latitude = latLng.lat;
                vm.outlet.longitude = latLng.lng;
            });
            map.on('draw:deleted', function (e) {
                vm.outlet.latitude = null;
                vm.outlet.longitude = null;

                map.removeControl(drawControl);

                drawControl = new L.Control.Draw({
                    position: 'topright',
                    draw: {
                        polyline: false,
                        polygon: false,
                        rectangle: false,
                        circle: false,
                        marker: {
                            repeatMode: false
                        }
                    }
                });

                map.addControl(drawControl);
            });
            map.on('draw:drawstart', function (e) {
                vm.isDrawingMap = true;
            });
            map.on('draw:drawstop', function (e) {
                vm.isDrawingMap = false;
            });
            map.on('draw:editstart', function (e) {
                vm.isDrawingMap = true;
            });
            map.on('draw:editmove', function (e) {
                var latLng = getLatLng(drawnItems);

                vm.outlet.latitude = latLng.lat;
                vm.outlet.longitude = latLng.lng;
            });
            map.on('draw:editstop', function (e) {
                var latLng = getLatLng(drawnItems);

                vm.outlet.latitude = latLng.lat;
                vm.outlet.longitude = latLng.lng;

                vm.isDrawingMap = false;
            });
            map.on('draw:deletestart', function (e) {
                vm.isDrawingMap = true;
            });
            map.on('draw:deletestop', function (e) {
                vm.isDrawingMap = false;
            });
        });

        function getLatLng(drawnItems) {
            var shapes = [];

            drawnItems.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    shapes.push([layer.getLatLng()]);
                }
            });

            var latLng = shapes[0][0];
            return latLng;
        }

        function updateMarker() {
            if (vm.outlet.longitude != null && vm.outlet.latitude != null) {
                leafletData.getMap().then(function (map) {
                    if (marker != null) {
                        drawnItems.removeLayer(marker);
                    }

                    var latlng = L.latLng(vm.outlet.latitude, vm.outlet.longitude);
                    marker = L.marker(latlng, {}).addTo(map);

                    map.panTo(latlng);
                    drawnItems.addLayer(marker);

                    map.removeControl(drawControl);

                    drawControl = new L.Control.Draw({
                        position: 'topright',
                        draw: false,
                        edit: {
                            featureGroup: drawnItems
                        }
                    });

                    map.addControl(drawControl);
                });
            }
        }

        function fixMapOnModal() {
            leafletData.getMap().then(function (map) {
                map.invalidateSize();
            });
        }

        function checkOutletCode(code) {
            OutletSearch.query({
                query: 'outletCode:' + code
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                if (vm.totalItems > 0) {
                    $scope.editForm.outletCode.$setValidity('unique', false);
                }
            }
            function onError(error) {
                console.log(error.data.message);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletDetailController', OutletDetailController);

    OutletDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Outlet', 'Channel', 'OutletAccount', 'OutletType', 'Area', 'VisitCycle'];

    function OutletDetailController($scope, $rootScope, $stateParams, entity, Outlet, Channel, OutletAccount, OutletType, Area, VisitCycle) {
        var vm = this;
        vm.outlet = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:outletUpdate', function(event, result) {
            vm.outlet = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletDeleteController',OutletDeleteController);

    OutletDeleteController.$inject = ['$uibModalInstance', 'entity', 'Outlet'];

    function OutletDeleteController($uibModalInstance, entity, Outlet) {
        var vm = this;
        vm.outlet = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Outlet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('outlet', {
            parent: 'entity',
            url: '/outlet?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outlet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet/outlets.html',
                    controller: 'OutletController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outlet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('outlet-detail', {
            parent: 'entity',
            url: '/outlet/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outlet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet/outlet-detail.html',
                    controller: 'OutletDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outlet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Outlet', function($stateParams, Outlet) {
                    return Outlet.get({id : $stateParams.id});
                }]
            }
        })
        .state('outlet.new', {
            parent: 'outlet',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet/outlet-dialog.html',
                    controller: 'OutletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                outletCode: null,
                                outletName: null,
                                outletAddress: null,
                                latitude: null,
                                longitude: null,
                                outletFacility: null,
                                pcStatus: null,
                                perfectStoreStatus: null,
                                risStatus: null,
                                deleted: false,
                                startVisitWeek: null,
                                id: null,
                                popPairVersionId: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('outlet', null, { reload: true });
                }, function() {
                    $state.go('outlet');
                });
            }]
        })
        .state('outlet.edit', {
            parent: 'outlet',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet/outlet-dialog.html',
                    controller: 'OutletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Outlet', function(Outlet) {
                            return Outlet.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet.delete', {
            parent: 'outlet',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/outlet/outlet-delete-dialog.html',
                    controller: 'OutletDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Outlet', function(Outlet) {
                            return Outlet.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('outlet', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('outlet-map', {
            parent: 'outlet',
            url: '/map',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outlet.map.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet/outlet-map.html',
                    controller: 'OutletMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('outlet');
                    return $translate.refresh();
                }]
            }
        })
        .state('outlet-vdo-import',{
            parent: 'entity',
            url: '/outlet-vdo-import',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.outlet.import.vdoImport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/outlet/outlet-vdo-import.html',
                    controller: 'OutletVdoImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader){
                    $translatePartialLoader.addPart('outlet');
                    return $translate.refresh();
                }],
                previousState: ['$state', function($state){
                    var currentStateData = {
                        name: $state.current.name || 'outlet',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('outlet-import',{
                    parent: 'entity',
                    url: '/outlet-import',
                    data: {
                        authorities: ['ROLE_ADMIN', 'VDR'],
                        pageTitle: 'sceaApp.outlet.import.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/outlet/outlet-import.html',
                            controller: 'OutletImportController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader){
                            $translatePartialLoader.addPart('outlet');
                            return $translate.refresh();
                        }],
                        previousState: ['$state', function($state){
                            var currentStateData = {
                                name: $state.current.name || 'outlet',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                })
        .state('outlet-grade-import',{
                    parent: 'entity',
                    url: '/outlet-grade-import',
                    data: {
                        authorities: ['ROLE_ADMIN', 'VDR'],
                        pageTitle: 'sceaApp.outlet.import.gradeImport.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/outlet/outlet-grade-import.html',
                            controller: 'OutletGradeImportController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader){
                            $translatePartialLoader.addPart('outlet');
                            return $translate.refresh();
                        }],
                        previousState: ['$state', function($state){
                            var currentStateData = {
                                name: $state.current.name || 'outlet',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                })
        .state('outlet-pop-pair-version-import',{
                    parent: 'entity',
                    url: '/outlet-pop-pair-version-import',
                    data: {
                        authorities: ['ROLE_ADMIN', 'VDR'],
                        pageTitle: 'sceaApp.outlet.import.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/outlet/outlet-pop-pair-version-import.html',
                            controller: 'OutletPopPairVersionImportController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader){
                            $translatePartialLoader.addPart('outlet');
                            return $translate.refresh();
                        }],
                        previousState: ['$state', function($state){
                            var currentStateData = {
                                name: $state.current.name || 'outlet',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                });
    }

})();;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Outlet', Outlet);

    Outlet.$inject = ['$resource'];

    function Outlet ($resource) {
        var resourceUrl =  'api/outlets/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method:'PUT'
            },
            'queryByEmployee': {
            	url: 'api/outlets/employees/:id',
            	method: 'GET',
            	isArray: true
            },
            'queryBySpv': {
            	url: 'api/outlets/spv/:id',
            	method: 'GET',
            	isArray: true
            },
            'queryByVdo': {
            	url: 'api/outlets/vdo/:id',
            	method: 'GET',
            	isArray: true
            },
            'getGeoJson': {
                url: 'api/outlets/geojson',
                method: 'GET'
            },
            'exportAsCsv': {
                url: 'api/outlets/csv',
                method: 'GET',
                 transformResponse: function (data, headersGetter) {
                                    var filename = "outlets.csv";
                                    var blob = new Blob([data], {type: "text/csv;charset=UTF-8"});
                                    saveAs(blob, filename, true);
                                    return true;
                                }
            }


        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OutletSearch', OutletSearch);

    OutletSearch.$inject = ['$resource'];

    function OutletSearch($resource) {
        var resourceUrl =  'api/_search/outlets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OutletController', OutletController);

    OutletController.$inject = ['$scope', '$state', 'Outlet', 'OutletSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OutletController ($scope, $state, Outlet, OutletSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();
        vm.exportAsCsv = exportAsCsv;

        function exportAsCsv() {
            Outlet.exportAsCsv();
        }

        function loadAll () {
            if (pagingParams.search) {
                OutletSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Outlet.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outlets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobTypeDialogController', OtherJobTypeDialogController);

    OtherJobTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OtherJobType'];

    function OtherJobTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OtherJobType) {
        var vm = this;
        vm.otherJobType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:otherJobTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.otherJobType.id !== null) {
                OtherJobType.update(vm.otherJobType, onSaveSuccess, onSaveError);
            } else {
                OtherJobType.save(vm.otherJobType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobTypeDetailController', OtherJobTypeDetailController);

    OtherJobTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OtherJobType'];

    function OtherJobTypeDetailController($scope, $rootScope, $stateParams, entity, OtherJobType) {
        var vm = this;
        vm.otherJobType = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:otherJobTypeUpdate', function(event, result) {
            vm.otherJobType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobTypeDeleteController',OtherJobTypeDeleteController);

    OtherJobTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'OtherJobType'];

    function OtherJobTypeDeleteController($uibModalInstance, entity, OtherJobType) {
        var vm = this;
        vm.otherJobType = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OtherJobType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('other-job-type', {
            parent: 'entity',
            url: '/other-job-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.otherJobType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-job-type/other-job-types.html',
                    controller: 'OtherJobTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherJobType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('other-job-type-detail', {
            parent: 'entity',
            url: '/other-job-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.otherJobType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/other-job-type/other-job-type-detail.html',
                    controller: 'OtherJobTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('otherJobType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OtherJobType', function($stateParams, OtherJobType) {
                    return OtherJobType.get({id : $stateParams.id});
                }]
            }
        })
        .state('other-job-type.new', {
            parent: 'other-job-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-job-type/other-job-type-dialog.html',
                    controller: 'OtherJobTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                typeName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('other-job-type', null, { reload: true });
                }, function() {
                    $state.go('other-job-type');
                });
            }]
        })
        .state('other-job-type.edit', {
            parent: 'other-job-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-job-type/other-job-type-dialog.html',
                    controller: 'OtherJobTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OtherJobType', function(OtherJobType) {
                            return OtherJobType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-job-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('other-job-type.delete', {
            parent: 'other-job-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/other-job-type/other-job-type-delete-dialog.html',
                    controller: 'OtherJobTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OtherJobType', function(OtherJobType) {
                            return OtherJobType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('other-job-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OtherJobType', OtherJobType);

    OtherJobType.$inject = ['$resource'];

    function OtherJobType ($resource) {
        var resourceUrl =  'api/other-job-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OtherJobTypeSearch', OtherJobTypeSearch);

    OtherJobTypeSearch.$inject = ['$resource'];

    function OtherJobTypeSearch($resource) {
        var resourceUrl =  'api/_search/other-job-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobTypeController', OtherJobTypeController);

    OtherJobTypeController.$inject = ['$scope', '$state', 'OtherJobType', 'OtherJobTypeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OtherJobTypeController ($scope, $state, OtherJobType, OtherJobTypeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OtherJobTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OtherJobType.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.otherJobTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobStoreCompletenessDialogController', OtherJobStoreCompletenessDialogController);

    OtherJobStoreCompletenessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OtherJobStoreCompleteness', 'StoreCompleteness', 'OtherJob'];

    function OtherJobStoreCompletenessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OtherJobStoreCompleteness, StoreCompleteness, OtherJob) {
        var vm = this;
        vm.otherJobStoreCompleteness = entity;
        vm.storecompletenesses = StoreCompleteness.query();
        vm.otherjobs = OtherJob.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:otherJobStoreCompletenessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.otherJobStoreCompleteness.id !== null) {
                OtherJobStoreCompleteness.update(vm.otherJobStoreCompleteness, onSaveSuccess, onSaveError);
            } else {
                OtherJobStoreCompleteness.save(vm.otherJobStoreCompleteness, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobStoreCompletenessDetailController', OtherJobStoreCompletenessDetailController);

    OtherJobStoreCompletenessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OtherJobStoreCompleteness', 'StoreCompleteness', 'OtherJob'];

    function OtherJobStoreCompletenessDetailController($scope, $rootScope, $stateParams, entity, OtherJobStoreCompleteness, StoreCompleteness, OtherJob) {
        var vm = this;
        vm.otherJobStoreCompleteness = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:otherJobStoreCompletenessUpdate', function(event, result) {
            vm.otherJobStoreCompleteness = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobStoreCompletenessDeleteController',OtherJobStoreCompletenessDeleteController);

    OtherJobStoreCompletenessDeleteController.$inject = ['$uibModalInstance', 'entity', 'OtherJobStoreCompleteness'];

    function OtherJobStoreCompletenessDeleteController($uibModalInstance, entity, OtherJobStoreCompleteness) {
        var vm = this;
        vm.otherJobStoreCompleteness = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OtherJobStoreCompleteness.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('other-job-store-completeness', {
//            parent: 'entity',
//            url: '/other-job-store-completeness?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.otherJobStoreCompleteness.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/other-job-store-completeness/other-job-store-completenesses.html',
//                    controller: 'OtherJobStoreCompletenessController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('otherJobStoreCompleteness');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('other-job-store-completeness-detail', {
//            parent: 'entity',
//            url: '/other-job-store-completeness/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.otherJobStoreCompleteness.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/other-job-store-completeness/other-job-store-completeness-detail.html',
//                    controller: 'OtherJobStoreCompletenessDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('otherJobStoreCompleteness');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'OtherJobStoreCompleteness', function($stateParams, OtherJobStoreCompleteness) {
//                    return OtherJobStoreCompleteness.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('other-job-store-completeness.new', {
//            parent: 'other-job-store-completeness',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-store-completeness/other-job-store-completeness-dialog.html',
//                    controller: 'OtherJobStoreCompletenessDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                value: null,
//                                formNo: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('other-job-store-completeness');
//                });
//            }]
//        })
//        .state('other-job-store-completeness.edit', {
//            parent: 'other-job-store-completeness',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-store-completeness/other-job-store-completeness-dialog.html',
//                    controller: 'OtherJobStoreCompletenessDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['OtherJobStoreCompleteness', function(OtherJobStoreCompleteness) {
//                            return OtherJobStoreCompleteness.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('other-job-store-completeness.delete', {
//            parent: 'other-job-store-completeness',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-store-completeness/other-job-store-completeness-delete-dialog.html',
//                    controller: 'OtherJobStoreCompletenessDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['OtherJobStoreCompleteness', function(OtherJobStoreCompleteness) {
//                            return OtherJobStoreCompleteness.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-store-completeness', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OtherJobStoreCompleteness', OtherJobStoreCompleteness);

    OtherJobStoreCompleteness.$inject = ['$resource'];

    function OtherJobStoreCompleteness ($resource) {
        var resourceUrl =  'api/other-job-store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OtherJobStoreCompletenessSearch', OtherJobStoreCompletenessSearch);

    OtherJobStoreCompletenessSearch.$inject = ['$resource'];

    function OtherJobStoreCompletenessSearch($resource) {
        var resourceUrl =  'api/_search/other-job-store-completenesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobStoreCompletenessController', OtherJobStoreCompletenessController);

    OtherJobStoreCompletenessController.$inject = ['$scope', '$state', 'OtherJobStoreCompleteness', 'OtherJobStoreCompletenessSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OtherJobStoreCompletenessController ($scope, $state, OtherJobStoreCompleteness, OtherJobStoreCompletenessSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OtherJobStoreCompletenessSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OtherJobStoreCompleteness.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.otherJobStoreCompletenesses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobBrandDialogController', OtherJobBrandDialogController);

    OtherJobBrandDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OtherJobBrand', 'Brand', 'ProductInch', 'ProductCategory', 'OtherJob'];

    function OtherJobBrandDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OtherJobBrand, Brand, ProductInch, ProductCategory, OtherJob) {
        var vm = this;
        vm.otherJobBrand = entity;
        vm.brands = Brand.query();
        vm.productinches = ProductInch.query();
        vm.productcategories = ProductCategory.query();
        vm.otherjobs = OtherJob.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:otherJobBrandUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.otherJobBrand.id !== null) {
                OtherJobBrand.update(vm.otherJobBrand, onSaveSuccess, onSaveError);
            } else {
                OtherJobBrand.save(vm.otherJobBrand, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobBrandDetailController', OtherJobBrandDetailController);

    OtherJobBrandDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OtherJobBrand', 'Brand', 'ProductInch', 'ProductCategory', 'OtherJob'];

    function OtherJobBrandDetailController($scope, $rootScope, $stateParams, entity, OtherJobBrand, Brand, ProductInch, ProductCategory, OtherJob) {
        var vm = this;
        vm.otherJobBrand = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:otherJobBrandUpdate', function(event, result) {
            vm.otherJobBrand = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobBrandDeleteController',OtherJobBrandDeleteController);

    OtherJobBrandDeleteController.$inject = ['$uibModalInstance', 'entity', 'OtherJobBrand'];

    function OtherJobBrandDeleteController($uibModalInstance, entity, OtherJobBrand) {
        var vm = this;
        vm.otherJobBrand = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OtherJobBrand.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('other-job-brand', {
//            parent: 'entity',
//            url: '/other-job-brand?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.otherJobBrand.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/other-job-brand/other-job-brands.html',
//                    controller: 'OtherJobBrandController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('otherJobBrand');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('other-job-brand-detail', {
//            parent: 'entity',
//            url: '/other-job-brand/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.otherJobBrand.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/other-job-brand/other-job-brand-detail.html',
//                    controller: 'OtherJobBrandDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('otherJobBrand');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'OtherJobBrand', function($stateParams, OtherJobBrand) {
//                    return OtherJobBrand.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('other-job-brand.new', {
//            parent: 'other-job-brand',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-brand/other-job-brand-dialog.html',
//                    controller: 'OtherJobBrandDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                formNo: null,
//                                value: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-brand', null, { reload: true });
//                }, function() {
//                    $state.go('other-job-brand');
//                });
//            }]
//        })
//        .state('other-job-brand.edit', {
//            parent: 'other-job-brand',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-brand/other-job-brand-dialog.html',
//                    controller: 'OtherJobBrandDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['OtherJobBrand', function(OtherJobBrand) {
//                            return OtherJobBrand.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-brand', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('other-job-brand.delete', {
//            parent: 'other-job-brand',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/other-job-brand/other-job-brand-delete-dialog.html',
//                    controller: 'OtherJobBrandDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['OtherJobBrand', function(OtherJobBrand) {
//                            return OtherJobBrand.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('other-job-brand', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OtherJobBrand', OtherJobBrand);

    OtherJobBrand.$inject = ['$resource'];

    function OtherJobBrand ($resource) {
        var resourceUrl =  'api/other-job-brands/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OtherJobBrandSearch', OtherJobBrandSearch);

    OtherJobBrandSearch.$inject = ['$resource'];

    function OtherJobBrandSearch($resource) {
        var resourceUrl =  'api/_search/other-job-brands/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OtherJobBrandController', OtherJobBrandController);

    OtherJobBrandController.$inject = ['$scope', '$state', 'OtherJobBrand', 'OtherJobBrandSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OtherJobBrandController ($scope, $state, OtherJobBrand, OtherJobBrandSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OtherJobBrandSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OtherJobBrand.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.otherJobBrands = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OrderPopDialogController', OrderPopDialogController);

    OrderPopDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderPop', 'User', 'Outlet', 'Pop'];

    function OrderPopDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderPop, User, Outlet, Pop) {
        var vm = this;
        vm.orderPop = entity;
        vm.users = User.query();
        vm.outlets = Outlet.query();
        vm.pops = Pop.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:orderPopUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.orderPop.id !== null) {
                OrderPop.update(vm.orderPop, onSaveSuccess, onSaveError);
            } else {
                OrderPop.save(vm.orderPop, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.requestDate = false;
        vm.datePickerOpenStatus.sentDate = false;
        vm.datePickerOpenStatus.deliveredDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OrderPopDetailController', OrderPopDetailController);

    OrderPopDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'OrderPop', 'User', 'Outlet', 'Pop'];

    function OrderPopDetailController($scope, $rootScope, $stateParams, entity, OrderPop, User, Outlet, Pop) {
        var vm = this;
        vm.orderPop = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:orderPopUpdate', function(event, result) {
            vm.orderPop = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OrderPopDeleteController',OrderPopDeleteController);

    OrderPopDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderPop'];

    function OrderPopDeleteController($uibModalInstance, entity, OrderPop) {
        var vm = this;
        vm.orderPop = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            OrderPop.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-pop', {
            parent: 'entity',
            url: '/order-pop?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.orderPop.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pop/order-pops.html',
                    controller: 'OrderPopController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderPop');
                    $translatePartialLoader.addPart('requestStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('order-pop-detail', {
            parent: 'entity',
            url: '/order-pop/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.orderPop.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pop/order-pop-detail.html',
                    controller: 'OrderPopDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('orderPop');
                    $translatePartialLoader.addPart('requestStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrderPop', function($stateParams, OrderPop) {
                    return OrderPop.get({id : $stateParams.id});
                }]
            }
        })
        .state('order-pop.new', {
            parent: 'order-pop',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pop/order-pop-dialog.html',
                    controller: 'OrderPopDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                requestQty: null,
                                sentQty: null,
                                deliveredQty: null,
                                requestDate: null,
                                sentDate: null,
                                deliveredDate: null,
                                requestStatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('order-pop', null, { reload: true });
                }, function() {
                    $state.go('order-pop');
                });
            }]
        })
        .state('order-pop.edit', {
            parent: 'order-pop',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pop/order-pop-dialog.html',
                    controller: 'OrderPopDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPop', function(OrderPop) {
                            return OrderPop.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('order-pop', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pop.delete', {
            parent: 'order-pop',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pop/order-pop-delete-dialog.html',
                    controller: 'OrderPopDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OrderPop', function(OrderPop) {
                            return OrderPop.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('order-pop', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('OrderPop', OrderPop);

    OrderPop.$inject = ['$resource', 'DateUtils'];

    function OrderPop ($resource, DateUtils) {
        var resourceUrl =  'api/order-pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.requestDate = DateUtils.convertDateTimeFromServer(data.requestDate);
                    data.sentDate = DateUtils.convertDateTimeFromServer(data.sentDate);
                    data.deliveredDate = DateUtils.convertDateTimeFromServer(data.deliveredDate);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryOutlets': { 
            	url: 'api/order-pops/outlets',
            	method: 'GET', 
            	isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('OrderPopSearch', OrderPopSearch);

    OrderPopSearch.$inject = ['$resource'];

    function OrderPopSearch($resource) {
        var resourceUrl =  'api/_search/order-pops/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryOutlets': {
            	url: 'api/_search/order-pops/outlets',
            	method: 'GET',
            	isArray: true
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('OrderPopController', OrderPopController);

    OrderPopController.$inject = ['$scope', '$state', 'OrderPop', 'OrderPopSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderPopController ($scope, $state, OrderPop, OrderPopSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OrderPopSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrderPop.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderPops = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LaunchPeriodDialogController', LaunchPeriodDialogController);

    LaunchPeriodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LaunchPeriod'];

    function LaunchPeriodDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LaunchPeriod) {
        var vm = this;
        vm.launchPeriod = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:launchPeriodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.launchPeriod.id !== null) {
                LaunchPeriod.update(vm.launchPeriod, onSaveSuccess, onSaveError);
            } else {
                LaunchPeriod.save(vm.launchPeriod, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LaunchPeriodDetailController', LaunchPeriodDetailController);

    LaunchPeriodDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LaunchPeriod'];

    function LaunchPeriodDetailController($scope, $rootScope, $stateParams, entity, LaunchPeriod) {
        var vm = this;
        vm.launchPeriod = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:launchPeriodUpdate', function(event, result) {
            vm.launchPeriod = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LaunchPeriodDeleteController',LaunchPeriodDeleteController);

    LaunchPeriodDeleteController.$inject = ['$uibModalInstance', 'entity', 'LaunchPeriod'];

    function LaunchPeriodDeleteController($uibModalInstance, entity, LaunchPeriod) {
        var vm = this;
        vm.launchPeriod = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            LaunchPeriod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('launch-period', {
            parent: 'entity',
            url: '/launch-period?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.launchPeriod.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/launch-period/launch-periods.html',
                    controller: 'LaunchPeriodController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('launchPeriod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('launch-period-detail', {
            parent: 'entity',
            url: '/launch-period/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.launchPeriod.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/launch-period/launch-period-detail.html',
                    controller: 'LaunchPeriodDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('launchPeriod');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LaunchPeriod', function($stateParams, LaunchPeriod) {
                    return LaunchPeriod.get({id : $stateParams.id});
                }]
            }
        })
        .state('launch-period.new', {
            parent: 'launch-period',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/launch-period/launch-period-dialog.html',
                    controller: 'LaunchPeriodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                periodName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('launch-period', null, { reload: true });
                }, function() {
                    $state.go('launch-period');
                });
            }]
        })
        .state('launch-period.edit', {
            parent: 'launch-period',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/launch-period/launch-period-dialog.html',
                    controller: 'LaunchPeriodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LaunchPeriod', function(LaunchPeriod) {
                            return LaunchPeriod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('launch-period', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('launch-period.delete', {
            parent: 'launch-period',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/launch-period/launch-period-delete-dialog.html',
                    controller: 'LaunchPeriodDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LaunchPeriod', function(LaunchPeriod) {
                            return LaunchPeriod.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('launch-period', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('LaunchPeriod', LaunchPeriod);

    LaunchPeriod.$inject = ['$resource'];

    function LaunchPeriod ($resource) {
        var resourceUrl =  'api/launch-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('LaunchPeriodSearch', LaunchPeriodSearch);

    LaunchPeriodSearch.$inject = ['$resource'];

    function LaunchPeriodSearch($resource) {
        var resourceUrl =  'api/_search/launch-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LaunchPeriodController', LaunchPeriodController);

    LaunchPeriodController.$inject = ['$scope', '$state', 'LaunchPeriod', 'LaunchPeriodSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function LaunchPeriodController ($scope, $state, LaunchPeriod, LaunchPeriodSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                LaunchPeriodSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                LaunchPeriod.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.launchPeriods = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
	'use strict';

	angular.module('sceaApp').controller('InternetQaDialogController',
			InternetQaDialogController);

	InternetQaDialogController.$inject = [ '$timeout', '$scope',
			'$stateParams', '$uibModalInstance', 'entity', 'InternetQa',
			'InternetAnswerSearch', 'InternetSearch' ];

	function InternetQaDialogController($timeout, $scope, $stateParams,
			$uibModalInstance, entity, InternetQa, InternetAnswerSearch,
			InternetSearch) {
		var vm = this;
		vm.internetQa = entity;
		vm.getInternet = getInternet
		vm.loadingInternet = false;
		vm.getAnswer = getAnswer
		vm.loadingAnswer = false;

		//        vm.internetanswers = InternetAnswer.query();

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.onSelectInternet = function(item, model, label) {
			vm.internetQa.internetId = model.id;
			vm.internetQa.internetInternetName = model.internetName;
		}

		vm.onSelectAnswer = function(item, model, label) {
			vm.internetQa.answerId = model.id;
			vm.internetQa.answerAnswerName = model.answerName;
		}

		var onSaveSuccess = function(result) {
			$scope.$emit('sceaApp:internetQaUpdate', result);
			$uibModalInstance.close(result);
			vm.isSaving = false;
		};

		var onSaveError = function() {
			vm.isSaving = false;
		};

		vm.save = function() {
			vm.isSaving = true;
			if (vm.internetQa.id !== null) {
				InternetQa.update(vm.internetQa, onSaveSuccess, onSaveError);
			} else {
				InternetQa.save(vm.internetQa, onSaveSuccess, onSaveError);
			}
		};

		vm.clear = function() {
			$uibModalInstance.dismiss('cancel');
		};

		function getInternet(value) {
			vm.loadingInternet = true;
			return InternetSearch.query({
				query : '*' + value + '*'
			}).$promise.then(function(response) {
				vm.loadingInternet = false;
				return response;
			}, function(response) {
				vm.loadingInternet = false;
				AlertService.error(response.data.message);
			});
		}

		function getAnswer(value) {
			vm.loadingAnswer = true;
			return InternetAnswerSearch.query({
				query : '*' + value + '*'
			}).$promise.then(function(response) {
				vm.loadingAnswer = false;
				return response;
			}, function(response) {
				vm.loadingAnswer = false;
				AlertService.error(response.data.message);
			});
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetQaDetailController', InternetQaDetailController);

    InternetQaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'InternetQa', 'Internet', 'InternetAnswer'];

    function InternetQaDetailController($scope, $rootScope, $stateParams, entity, InternetQa, Internet, InternetAnswer) {
        var vm = this;
        vm.internetQa = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:internetQaUpdate', function(event, result) {
            vm.internetQa = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetQaDeleteController',InternetQaDeleteController);

    InternetQaDeleteController.$inject = ['$uibModalInstance', 'entity', 'InternetQa'];

    function InternetQaDeleteController($uibModalInstance, entity, InternetQa) {
        var vm = this;
        vm.internetQa = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            InternetQa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('internet-qa', {
            parent: 'entity',
            url: '/internet-qa?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetQa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-qa/internet-qas.html',
                    controller: 'InternetQaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetQa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('internet-qa-detail', {
            parent: 'entity',
            url: '/internet-qa/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetQa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-qa/internet-qa-detail.html',
                    controller: 'InternetQaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetQa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InternetQa', function($stateParams, InternetQa) {
                    return InternetQa.get({id : $stateParams.id});
                }]
            }
        })
        .state('internet-qa.new', {
            parent: 'internet-qa',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-qa/internet-qa-dialog.html',
                    controller: 'InternetQaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('internet-qa', null, { reload: true });
                }, function() {
                    $state.go('internet-qa');
                });
            }]
        })
        .state('internet-qa.edit', {
            parent: 'internet-qa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-qa/internet-qa-dialog.html',
                    controller: 'InternetQaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InternetQa', function(InternetQa) {
                            return InternetQa.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-qa', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('internet-qa.delete', {
            parent: 'internet-qa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-qa/internet-qa-delete-dialog.html',
                    controller: 'InternetQaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InternetQa', function(InternetQa) {
                            return InternetQa.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-qa', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('InternetQa', InternetQa);

    InternetQa.$inject = ['$resource'];

    function InternetQa ($resource) {
        var resourceUrl =  'api/internet-qas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('InternetQaSearch', InternetQaSearch);

    InternetQaSearch.$inject = ['$resource'];

    function InternetQaSearch($resource) {
        var resourceUrl =  'api/_search/internet-qas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetQaController', InternetQaController);

    InternetQaController.$inject = ['$scope', '$state', 'InternetQa', 'InternetQaSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InternetQaController ($scope, $state, InternetQa, InternetQaSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InternetQaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InternetQa.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.internetQas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetConnectionDialogController', InternetConnectionDialogController);

    InternetConnectionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InternetConnection'];

    function InternetConnectionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InternetConnection) {
        var vm = this;
        vm.internetConnection = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:internetConnectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.internetConnection.id !== null) {
                InternetConnection.update(vm.internetConnection, onSaveSuccess, onSaveError);
            } else {
                InternetConnection.save(vm.internetConnection, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetConnectionDetailController', InternetConnectionDetailController);

    InternetConnectionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'InternetConnection'];

    function InternetConnectionDetailController($scope, $rootScope, $stateParams, entity, InternetConnection) {
        var vm = this;
        vm.internetConnection = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:internetConnectionUpdate', function(event, result) {
            vm.internetConnection = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetConnectionDeleteController',InternetConnectionDeleteController);

    InternetConnectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'InternetConnection'];

    function InternetConnectionDeleteController($uibModalInstance, entity, InternetConnection) {
        var vm = this;
        vm.internetConnection = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            InternetConnection.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('internet-connection', {
            parent: 'entity',
            url: '/internet-connection?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetConnection.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-connection/internet-connections.html',
                    controller: 'InternetConnectionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetConnection');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('internet-connection-detail', {
            parent: 'entity',
            url: '/internet-connection/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetConnection.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-connection/internet-connection-detail.html',
                    controller: 'InternetConnectionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetConnection');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InternetConnection', function($stateParams, InternetConnection) {
                    return InternetConnection.get({id : $stateParams.id});
                }]
            }
        })
        .state('internet-connection.new', {
            parent: 'internet-connection',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-connection/internet-connection-dialog.html',
                    controller: 'InternetConnectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                connectionName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('internet-connection', null, { reload: true });
                }, function() {
                    $state.go('internet-connection');
                });
            }]
        })
        .state('internet-connection.edit', {
            parent: 'internet-connection',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-connection/internet-connection-dialog.html',
                    controller: 'InternetConnectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InternetConnection', function(InternetConnection) {
                            return InternetConnection.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-connection', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('internet-connection.delete', {
            parent: 'internet-connection',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-connection/internet-connection-delete-dialog.html',
                    controller: 'InternetConnectionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InternetConnection', function(InternetConnection) {
                            return InternetConnection.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-connection', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('InternetConnection', InternetConnection);

    InternetConnection.$inject = ['$resource'];

    function InternetConnection ($resource) {
        var resourceUrl =  'api/internet-connections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('InternetConnectionSearch', InternetConnectionSearch);

    InternetConnectionSearch.$inject = ['$resource'];

    function InternetConnectionSearch($resource) {
        var resourceUrl =  'api/_search/internet-connections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetConnectionController', InternetConnectionController);

    InternetConnectionController.$inject = ['$scope', '$state', 'InternetConnection', 'InternetConnectionSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InternetConnectionController ($scope, $state, InternetConnection, InternetConnectionSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InternetConnectionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InternetConnection.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.internetConnections = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetAnswerDialogController', InternetAnswerDialogController);

    InternetAnswerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InternetAnswer'];

    function InternetAnswerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InternetAnswer) {
        var vm = this;
        vm.internetAnswer = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:internetAnswerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.internetAnswer.id !== null) {
                InternetAnswer.update(vm.internetAnswer, onSaveSuccess, onSaveError);
            } else {
                InternetAnswer.save(vm.internetAnswer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetAnswerDetailController', InternetAnswerDetailController);

    InternetAnswerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'InternetAnswer'];

    function InternetAnswerDetailController($scope, $rootScope, $stateParams, entity, InternetAnswer) {
        var vm = this;
        vm.internetAnswer = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:internetAnswerUpdate', function(event, result) {
            vm.internetAnswer = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetAnswerDeleteController',InternetAnswerDeleteController);

    InternetAnswerDeleteController.$inject = ['$uibModalInstance', 'entity', 'InternetAnswer'];

    function InternetAnswerDeleteController($uibModalInstance, entity, InternetAnswer) {
        var vm = this;
        vm.internetAnswer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            InternetAnswer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('internet-answer', {
            parent: 'entity',
            url: '/internet-answer?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetAnswer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-answer/internet-answers.html',
                    controller: 'InternetAnswerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetAnswer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('internet-answer-detail', {
            parent: 'entity',
            url: '/internet-answer/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internetAnswer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet-answer/internet-answer-detail.html',
                    controller: 'InternetAnswerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internetAnswer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InternetAnswer', function($stateParams, InternetAnswer) {
                    return InternetAnswer.get({id : $stateParams.id});
                }]
            }
        })
        .state('internet-answer.new', {
            parent: 'internet-answer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-answer/internet-answer-dialog.html',
                    controller: 'InternetAnswerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                answerName: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('internet-answer', null, { reload: true });
                }, function() {
                    $state.go('internet-answer');
                });
            }]
        })
        .state('internet-answer.edit', {
            parent: 'internet-answer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-answer/internet-answer-dialog.html',
                    controller: 'InternetAnswerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InternetAnswer', function(InternetAnswer) {
                            return InternetAnswer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-answer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('internet-answer.delete', {
            parent: 'internet-answer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet-answer/internet-answer-delete-dialog.html',
                    controller: 'InternetAnswerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InternetAnswer', function(InternetAnswer) {
                            return InternetAnswer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet-answer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('InternetAnswer', InternetAnswer);

    InternetAnswer.$inject = ['$resource'];

    function InternetAnswer ($resource) {
        var resourceUrl =  'api/internet-answers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('InternetAnswerSearch', InternetAnswerSearch);

    InternetAnswerSearch.$inject = ['$resource'];

    function InternetAnswerSearch($resource) {
        var resourceUrl =  'api/_search/internet-answers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetAnswerController', InternetAnswerController);

    InternetAnswerController.$inject = ['$scope', '$state', 'InternetAnswer', 'InternetAnswerSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InternetAnswerController ($scope, $state, InternetAnswer, InternetAnswerSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InternetAnswerSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InternetAnswer.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.internetAnswers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetDialogController', InternetDialogController);

    InternetDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Internet', 'InternetConnection'];

    function InternetDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Internet, InternetConnection) {
        var vm = this;
        vm.internet = entity;
        vm.internetconnections = InternetConnection.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:internetUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.internet.id !== null) {
                Internet.update(vm.internet, onSaveSuccess, onSaveError);
            } else {
                Internet.save(vm.internet, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetDetailController', InternetDetailController);

    InternetDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Internet', 'InternetConnection'];

    function InternetDetailController($scope, $rootScope, $stateParams, entity, Internet, InternetConnection) {
        var vm = this;
        vm.internet = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:internetUpdate', function(event, result) {
            vm.internet = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetDeleteController',InternetDeleteController);

    InternetDeleteController.$inject = ['$uibModalInstance', 'entity', 'Internet'];

    function InternetDeleteController($uibModalInstance, entity, Internet) {
        var vm = this;
        vm.internet = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Internet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('internet', {
            parent: 'entity',
            url: '/internet?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet/internets.html',
                    controller: 'InternetController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('internet-detail', {
            parent: 'entity',
            url: '/internet/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.internet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/internet/internet-detail.html',
                    controller: 'InternetDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('internet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Internet', function($stateParams, Internet) {
                    return Internet.get({id : $stateParams.id});
                }]
            }
        })
        .state('internet.new', {
            parent: 'internet',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet/internet-dialog.html',
                    controller: 'InternetDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                internetName: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('internet', null, { reload: true });
                }, function() {
                    $state.go('internet');
                });
            }]
        })
        .state('internet.edit', {
            parent: 'internet',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet/internet-dialog.html',
                    controller: 'InternetDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Internet', function(Internet) {
                            return Internet.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('internet.delete', {
            parent: 'internet',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/internet/internet-delete-dialog.html',
                    controller: 'InternetDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Internet', function(Internet) {
                            return Internet.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('internet', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Internet', Internet);

    Internet.$inject = ['$resource'];

    function Internet ($resource) {
        var resourceUrl =  'api/internets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('InternetSearch', InternetSearch);

    InternetSearch.$inject = ['$resource'];

    function InternetSearch($resource) {
        var resourceUrl =  'api/_search/internets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('InternetController', InternetController);

    InternetController.$inject = ['$scope', '$state', 'Internet', 'InternetSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InternetController ($scope, $state, Internet, InternetSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InternetSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Internet.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.internets = data;
                vm.page = pagingParams.page;
                console.log(vm.totalItems);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FormulaFieldDialogController', FormulaFieldDialogController);

    FormulaFieldDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$filter', '$location', '$anchorScroll', 
                                            'entity', 'AlertService', 'FormulaField', 'ProjectColumn'];

    function FormulaFieldDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $filter, $location, $anchorScroll, 
    		entity, AlertService, FormulaField, ProjectColumn) {
        var vm = this;
        vm.formulaField = entity;
        vm.formulas = [];
        vm.projectColumn = [];
        vm.validationFormula = {};
        vm.dynamicPopover = 'app/entities/formula-widget/formula-widgets.html';
        vm.optionsField = ProjectColumn.query({isDecimalType: true}, function(result) {
        	angular.forEach(result, function(variable, key) {
	    		vm.projectColumn[variable.columnId] = {};
	 			vm.projectColumn[variable.columnId].columnName = variable.columnName;
	 			
	 			if(result.length-1 == key) {
		 	        generateFormula();
	 			}
        	});
        });
        
        function generateFormula() {
            if (vm.formulaField.$promise) {
    	    	vm.formulaField.$promise.then(function(data) {
    	    		var tempFormula = data.formula.split(" ");
                	
                    angular.forEach(tempFormula, function(formula, key) {
        	    		var label = null;
        	    		var value = null;
        	    		var type = null;
        	    		
            			if(formula.substring(0, 1) === "@") {                        	
                        	label = generateFormulaSellout(formula);
            				value = formula;
            				type = 'exponent';

                			vm.addFormula(label, value, type);
            			} else if(formula.substring(0, 1) === "#") {
            				var id = formula.replace(/#/g, '');
            				label = vm.projectColumn[id].columnName;
            				value = formula;
            				type = 'exponent';

                			vm.addFormula(label, value, type);
            			} else {
                        	label = formula;
            				value = formula;
            				type = 'opr';

                			vm.addFormula(label, value, type);
            			}            			
                    });
    	    	});
            }
        }
        
        vm.generateField = function(field) {
    		var label = field.columnName;
    		var value = '#' + field.columnId;
    		var type = 'exponent';
    		
			vm.addFormula(label, value, type);        	
        }
        
        function generateFormulaSellout(formula) {
			var parse = '';
			
        	var sellout = formula.substring(16, 22);
        	if(sellout == 'outlet') {
        		parse += 'Sell Out Outlet ';
        	} else if(sellout == 'branch') {
        		parse += 'Sell Out Branch ';
        	}

        	var properties = formula.substring(30, formula.length-1);
        	properties = properties.replace(/#/g, '');
        	properties = properties.replace(/inYear/g, 'Input Year');
        	properties = properties.replace(/lpYear/g, 'Last Project Year');
        	properties = properties.replace(/inMonth/g, 'Input Month');
        	properties = properties.replace(/lpMonth/g, 'Last Project Month');
        	properties = properties.split(",");
        	
        	angular.forEach(properties, function(result, key) {
        		if(key == 0) {
    				parse += 'from ';
        		}
        		if(key == 2) {
    				parse += ' to ';
        		}

        		if(key%2 != 0) {
    				parse += '/';
        		}

				parse += '{';
				
				var separators = ['\\\+', '-'];
				var tempParse = result.split(new RegExp(separators.join('|'), 'g'));

	    		if(tempParse.length > 1){
	    			if(tempParse[0].length < 3) {
	        			parse += $filter('translate')('sceaApp.calendar.months.' + tempParse[0]);
	        			parse += result.substring(tempParse[0].length, tempParse[0].length+1);
	    				parse += tempParse[1];
	    			} else {
	    				parse += result;
	    			}
	    		} else {
	    			if(result.length < 3) {
	    				parse += $filter('translate')('sceaApp.calendar.months.' + result);
	    			} else {
	    				parse += result;		    				
	    			}
	    		}

				parse += '}';
        	}); 
        	
			return parse;     	
        }
    	
	    vm.addFormula = function(label, value, type) {
    		if(vm.formulas[vm.formulas.length-1]) {
		    	if(vm.formulas[vm.formulas.length-1].type == 'exponent' && type == 'exponent') {
		    		vm.formulas.push({
			    		label: '+',
			    		value: '+',
			    		type: 'opr'
			    	});
		    	}
    		}
    		
	    	vm.formulas.push({
	    		label: label,
	    		value: value,
	    		type: type
	    	});
		}  
	    
	    vm.removeFormula = function(){
    		vm.formulas.splice(vm.formulas.length-1, 1); 
    	}
	    
	    vm.clearFormula = function(){
    		vm.formulas = [];
    	} 
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:formulaFieldUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
        	if(vm.validationFormula.status) {
                vm.isSaving = true;
                if (vm.formulaField.id !== null) {
                    FormulaField.update(vm.formulaField, onSaveSuccess, onSaveError);
                } else {
                    FormulaField.save(vm.formulaField, onSaveSuccess, onSaveError);
                }
        	} else {
                AlertService.error(vm.validationFormula.message);
        	}
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        vm.initWidget = function() {
        	gotoBottom();
        	vm.sellout = {
				formula : 'outlet',
				optionFromYear : 'inYear',
				oprFromYear : '+',
				inputFromYear : 0,
				optionFromMonth : 'inMonth',
				oprFromMonth : '+',
				inputFromMonth : 0,
				optionToYear : 'inYear',
				oprToYear : '+',
				inputToYear : 0,
				optionToMonth : 'inMonth',
				oprToMonth : '+',
				inputToMonth : 0
			}
        }
        
        function gotoBottom() {
            $location.hash('formulaWidget');            
            $anchorScroll();        	
        }
        
        vm.addSellout = function() {
        	var formula = '@formulaService.';
        	
        	if(vm.sellout.formula == 'outlet') {
        		formula += 'outletSellout(';
        	} else if(vm.sellout.formula == 'branch') {
        		formula += 'branchSellout(';
            }

    		formula += '#' + vm.sellout.optionFromYear;
        	if(vm.sellout.inputFromYear != 0) {
            	if(vm.sellout.inputFromYear > 0) {
            		formula += vm.sellout.oprFromYear + vm.sellout.inputFromYear;
            	} else {
            		formula += vm.sellout.inputFromYear;            		
            	}
        	}
    		formula += ',';    		

    		formula += '#' + vm.sellout.optionFromMonth;
        	if(vm.sellout.inputFromMonth != 0) {
            	if(vm.sellout.inputFromMonth > 0) {
            		formula += vm.sellout.oprFromMonth + vm.sellout.inputFromMonth;
            	} else {
            		formula += vm.sellout.inputFromMonth;            		
            	}
        	}
    		formula += ',';

    		formula += '#' + vm.sellout.optionToYear;
        	if(vm.sellout.inputToYear != 0) {
            	if(vm.sellout.inputToYear > 0) {
            		formula += vm.sellout.oprToYear + vm.sellout.inputToYear;
            	} else {
            		formula += vm.sellout.inputToYear;            		
            	}
        	}
    		formula += ',';    		

    		formula += '#' + vm.sellout.optionToMonth;
        	if(vm.sellout.inputToMonth != 0) {
            	if(vm.sellout.inputToMonth > 0) {
            		formula += vm.sellout.oprToMonth + vm.sellout.inputToMonth;
            	} else {
            		formula += vm.sellout.inputToMonth;            		
            	}
        	}
    		
    		formula += ')';
    		
        	var label = generateFormulaSellout(formula);
        	var value = formula;
        	var type = 'exponent';
        	
			vm.addFormula(label, value, type);

        	vm.sellout = {
        		formula: 'outlet',
        		optionFromYear: 'inYear',
        		oprFromYear: '+',
        		inputFromYear: 0,
        		optionFromMonth: 'inMonth',
        		oprFromMonth: '+',
        		inputFromMonth: 0,
        		optionToYear: 'inYear',
        		oprToYear: '+',
        		inputToYear: 0,
        		optionToMonth: 'inMonth',
        		oprToMonth: '+',
        		inputToMonth: 0
        	}
        }
        
        $scope.$watchCollection('vm.formulas', function(formulas, old) {
        	vm.validationFormula.status = true;
        	
        	if(formulas != old) {
        		if(formulas.length == 0) {
        			vm.formulaField.formula = null;
        		} else {
                	var tempFormula = '';
                	var validationString = '';
                	angular.forEach(formulas, function(formula, key) {
        			    if(formula.type == 'exponent') {
    						if(key > 0){
    	    					try {
    								var item = math.parse(formulas[key-1].value);
    					    		if(item.valueType == "number") {
    					    			tempFormula += " * " + formula.value;
    							        validationString += "*1";
    					    		} else { 
    							        tempFormula += formula.value;
    							        validationString += "1"; 
    					    		} 
        						} catch (e) {
        							tempFormula += ' ';
        							tempFormula += formula.value;
        					        validationString += "1";  
        						}
        						
	            		    	if(formulas[key-1].type == 'exponent') {
	            		    		var temp = vm.formulas[key];
	            		    		vm.formulas[key] = { label: '+', value: '+', type: 'opr' };
	            		    		vm.formulas.push(temp);
	            		    		
					    			tempFormula += " + " + formula.value;
							        validationString += "+1";
	            		    	}
    						} else {
    							tempFormula += formula.value;
    						    validationString += "1";  
    						}
    			        } else {
    				        try {
    							if(key > 0){
    								var item1 = math.parse(formulas[key-1].value);
    								var item2 = math.parse(formulas[key].value);
    					    		if(item1.valueType == "number") {
    		    				        tempFormula += formula.value;
    		    				        validationString += formula.value;			    			
    					    		}
    							} else {
		    				        tempFormula += formula.value;
		    				        validationString += formula.value;
    							}
    						} catch (e) {
								tempFormula += ' ';
	    				        tempFormula += formula.value;
	    				        validationString += formula.value;
    						}
    			        }
                    	
                    	if(vm.formulas.length-1 == key) {
                    		vm.formulaField.formula = tempFormula;

            	        	try { 
            		        	var parser = math.parser();
            		        	var result = parser.eval(validationString); 
            		        	if(result == "Infinity") {
            		        		vm.validationFormula.status = false;
            		        		vm.validationFormula.message = "Results Infinity";
            		        	}  
            	            }
            	            catch(error) {
            	            	vm.validationFormula.status = false;
            	        		vm.validationFormula.message = "Invalid Formula";
            	            } 
                    	}
                	});           			
        		}     		
        	}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FormulaFieldDetailController', FormulaFieldDetailController);

    FormulaFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$filter', 'entity', 'FormulaField', 'ProjectColumn'];

    function FormulaFieldDetailController($scope, $rootScope, $stateParams, $filter, entity, FormulaField, ProjectColumn) {
        var vm = this;
        vm.formulaField = entity;
	    vm.formulaField.$promise.then(function(data) {
	    	vm.formulaField.formula = data.formula.split(" ");
	    	
            angular.forEach(vm.formulaField.formula, function(formula, key) {
    			if(formula.substring(0, 1) === "@") {
    				var parse = '';
    				
    	        	var sellout = formula.substring(16, 22);
    	        	if(sellout == 'outlet') {
    	        		parse += 'Sell Out Outlet ';
    	        	} else if(sellout == 'branch') {
    	        		parse += 'Sell Out Branch ';
    	        	}

                	var properties = formula.substring(30, formula.length-1);
                	properties = properties.replace(/#/g, '');
                	properties = properties.replace(/inYear/g, 'Input Year');
                	properties = properties.replace(/lpYear/g, 'Last Project Year');
                	properties = properties.replace(/inMonth/g, 'Input Month');
                	properties = properties.replace(/lpMonth/g, 'Last Project Month');
                	properties = properties.split(",");
                	
                	angular.forEach(properties, function(result, key) {
                		if(key == 0) {
            				parse += 'from ';
                		}
                		if(key == 2) {
            				parse += ' to ';
                		}

                		if(key%2 != 0) {
            				parse += '/';
                		}

        				parse += '{';
        				
        				var separators = ['\\\+', '-'];
        				var tempParse = result.split(new RegExp(separators.join('|'), 'g'));

        	    		if(tempParse.length > 1){
        	    			if(tempParse[0].length < 3) {
        	        			parse += $filter('translate')('sceaApp.calendar.months.' + tempParse[0]);
        	        			parse += result.substring(tempParse[0].length, tempParse[0].length+1);
        	    				parse += tempParse[1];
        	    			} else {
        	    				parse += result;
        	    			}
        	    		} else {
        	    			if(result.length < 3) {
        	    				parse += $filter('translate')('sceaApp.calendar.months.' + result);
        	    			} else {
        	    				parse += result;		    				
        	    			}
        	    		}

        				parse += '}';
                	});
    				
                	vm.formulaField.formula[key] = parse;
    			}
    			
    			if(formula.substring(0, 1) === "#") {
    				var id = formula.replace(/#/g, '');
    				
    				var columnName = ProjectColumn.getbyColumnId({columnId: id});
    				columnName.$promise.then(function(data) {
        				vm.formulaField.formula[key] = data.columnName + ' ';
    				});
    			}
    			
    			vm.formulaField.formula[key] += ' ';
            });
	    });
        
        var unsubscribe = $rootScope.$on('sceaApp:formulaFieldUpdate', function(event, result) {
            vm.formulaField = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FormulaFieldDeleteController',FormulaFieldDeleteController);

    FormulaFieldDeleteController.$inject = ['$uibModalInstance', 'entity', 'FormulaField'];

    function FormulaFieldDeleteController($uibModalInstance, entity, FormulaField) {
        var vm = this;
        vm.formulaField = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FormulaField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('formula-field', {
            parent: 'entity',
            url: '/formula-field?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.formulaField.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/formula-field/formula-fields.html',
                    controller: 'FormulaFieldController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('formulaField');
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('formula-field-detail', {
            parent: 'entity',
            url: '/formula-field/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.formulaField.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/formula-field/formula-field-detail.html',
                    controller: 'FormulaFieldDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('formulaField');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FormulaField', function($stateParams, FormulaField) {
                    return FormulaField.get({id : $stateParams.id});
                }]
            }
        })
        .state('formula-field.new', {
            parent: 'formula-field',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formula-field/formula-field-dialog.html',
                    controller: 'FormulaFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                formula: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('formula-field', null, { reload: true });
                }, function() {
                    $state.go('formula-field');
                });
            }]
        })
        .state('formula-field.edit', {
            parent: 'formula-field',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formula-field/formula-field-dialog.html',
                    controller: 'FormulaFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FormulaField', function(FormulaField) {
                            return FormulaField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('formula-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('formula-field.delete', {
            parent: 'formula-field',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formula-field/formula-field-delete-dialog.html',
                    controller: 'FormulaFieldDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FormulaField', function(FormulaField) {
                            return FormulaField.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('formula-field', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('FormulaField', FormulaField);

    FormulaField.$inject = ['$resource'];

    function FormulaField ($resource) {
        var resourceUrl =  'api/formula-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('FormulaFieldSearch', FormulaFieldSearch);

    FormulaFieldSearch.$inject = ['$resource'];

    function FormulaFieldSearch($resource) {
        var resourceUrl =  'api/_search/formula-fields/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FormulaFieldController', FormulaFieldController);

    FormulaFieldController.$inject = ['$scope', '$state', '$filter', 
                                      'FormulaField', 'FormulaFieldSearch', 'ParseLinks', 'AlertService', 'pagingParams', 
                                      'paginationConstants', 'ProjectColumn'];

    function FormulaFieldController ($scope, $state, $filter, 
    		FormulaField, FormulaFieldSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ProjectColumn) {
        var vm = this;
        vm.formulaFields = [];
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FormulaFieldSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FormulaField.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.page = pagingParams.page; 
                vm.queryCount = vm.totalItems;
                vm.formulaFields = data;
                
                angular.forEach(vm.formulaFields, function(formulaField) {
                	formulaField.formula = formulaField.formula.split(" ");

                    angular.forEach(formulaField.formula, function(formula, key) {
            			if(formula.substring(0, 1) === "@") {
            				var parse = '';
            				
            	        	var sellout = formula.substring(16, 22);
            	        	if(sellout == 'outlet') {
            	        		parse += 'Sell Out Outlet ';
            	        	} else if(sellout == 'branch') {
            	        		parse += 'Sell Out Branch ';
            	        	}

                        	var properties = formula.substring(30, formula.length-1);
                        	properties = properties.replace(/#/g, '');
                        	properties = properties.replace(/inYear/g, 'Input Year');
                        	properties = properties.replace(/lpYear/g, 'Last Project Year');
                        	properties = properties.replace(/inMonth/g, 'Input Month');
                        	properties = properties.replace(/lpMonth/g, 'Last Project Month');
                        	properties = properties.split(",");
                        	
                        	angular.forEach(properties, function(result, key) {
                        		if(key == 0) {
                    				parse += 'from ';
                        		}
                        		if(key == 2) {
                    				parse += ' to ';
                        		}

                        		if(key%2 != 0) {
                    				parse += '/';
                        		}

                				parse += '{';
                				
                				var separators = ['\\\+', '-'];
                				var tempParse = result.split(new RegExp(separators.join('|'), 'g'));

                	    		if(tempParse.length > 1){
                	    			if(tempParse[0].length < 3) {
                	        			parse += $filter('translate')('sceaApp.calendar.months.' + tempParse[0]);
                	        			parse += result.substring(tempParse[0].length, tempParse[0].length+1);
                	    				parse += tempParse[1];
                	    			} else {
                	    				parse += result;
                	    			}
                	    		} else {
                	    			if(result.length < 3) {
                	    				parse += $filter('translate')('sceaApp.calendar.months.' + result);
                	    			} else {
                	    				parse += result;		    				
                	    			}
                	    		}

                				parse += '}';
                        	});
            				
            				formulaField.formula[key] = parse;
            			}
            			
            			if(formula.substring(0, 1) === "#") {
            				var id = formula.replace(/#/g, '');
            				
            				var columnName = ProjectColumn.getbyColumnId({columnId: id});
            				columnName.$promise.then(function(data) {
                				formulaField.formula[key] = data.columnName + ' ';
            				});
            			}
            			
        				formulaField.formula[key] += ' ';
                    });
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
    	function loadPage (page) {
            vm.page = page;
            vm.transition();
        }
        
        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
        
    }
})();
;
(function () {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ParentData', ParentData);

    ParentData.$inject = ['$localStorage'];

    function ParentData($localStorage) {

        var services = {
            setParentData : setParentData,
            getParentData : getParentData,
            clearParentData : clearParentData
        }

        if(!$localStorage.parentData) {
            $localStorage.parentData = [];
        }

        function setParentData(parents) {
            $localStorage.parentData = parents;
        }

        function getParentData() {
            return $localStorage.parentData;
        }

        function clearParentData() {
            delete $localStorage.parentData;
        }

        return services;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FixturesDialogController', FixturesDialogController);

    FixturesDialogController.$inject = ['$timeout', '$scope', 'ParentData', '$uibModalInstance', 'entity', 'Fixtures', 'ProductCategory', 'FixturesSearch', 'hasChild'];

    function FixturesDialogController ($timeout, $scope, ParentData, $uibModalInstance, entity, Fixtures, ProductCategory, FixturesSearch, hasChild) {
        var vm = this;
        vm.fixture = entity;
        vm.productCategories = ProductCategory.getAllProductCategories({level: 2});
        vm.loadingFixture = false;
        vm.fixtureParent = null;
        vm.disableParent = hasChild == 'true';
        vm.parents = ParentData.getParentData();

        if (vm.fixture.$promise) {
        	vm.fixture.$promise.then(function(data) {
                vm.parents = vm.parents.filter(function(parent){
                    return parent.id != vm.fixture.id;
                });
        		vm.fixtureParent = {
					"id" : data.parentId,
					"fixtureName" : data.parentName
				}
			}, function(error) {
				console.log(error);
			});
		}

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:fixturesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.fixtureParent){
            	vm.fixture.parentId = vm.fixtureParent.id;
            }else{
            	vm.fixture.parentId = null;
            }
            if (vm.fixture.id !== null) {
                Fixtures.update(vm.fixture, onSaveSuccess, onSaveError);
            } else {
                Fixtures.save(vm.fixture, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FixturesDetailController', FixturesDetailController);

    FixturesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Fixtures', 'ProductCategory'];

    function FixturesDetailController($scope, $rootScope, $stateParams, entity, Fixtures, ProductCategory) {
        var vm = this;
        vm.fixtures = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:fixturesUpdate', function(event, result) {
            vm.fixtures = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FixturesDeleteController',FixturesDeleteController);

    FixturesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fixtures'];

    function FixturesDeleteController($uibModalInstance, entity, Fixtures) {
        var vm = this;
        vm.fixtures = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Fixtures.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fixtures', {
            parent: 'entity',
            url: '/fixtures?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.fixtures.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fixtures/fixtures.html',
                    controller: 'FixturesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fixtures');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        .state('fixtures-detail', {
            parent: 'entity',
            url: '/fixtures/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.fixtures.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fixtures/fixtures-detail.html',
                    controller: 'FixturesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fixtures');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fixtures', function($stateParams, Fixtures) {
                    return Fixtures.get({id : $stateParams.id});
                }]
            }
        })
        .state('fixtures.new', {
            parent: 'fixtures',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixtures/fixtures-dialog.html',
                    controller: 'FixturesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fixtureName: null,
                                deleted: false,
                                id: null
                            };
                        },
                        hasChild: function() {
                            return 'false';
                        }
                    }
                }).result.then(function() {
                    $state.go('fixtures', null, { reload: true });
                }, function() {
                    $state.go('fixtures');
                });
            }]
        })
        .state('fixtures.edit', {
            parent: 'fixtures',
            url: '/{id}/edit?hasChild',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixtures/fixtures-dialog.html',
                    controller: 'FixturesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fixtures', function(Fixtures) {
                            return Fixtures.get({id : $stateParams.id});
                        }],
                        hasChild: function() {
                            return $stateParams.hasChild;
                        }
                    }
                }).result.then(function() {
                    $state.go('fixtures', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }],
        })
        .state('fixtures.delete', {
            parent: 'fixtures',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fixtures/fixtures-delete-dialog.html',
                    controller: 'FixturesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fixtures', function(Fixtures) {
                            return Fixtures.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('fixtures', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Fixtures', Fixtures);

    Fixtures.$inject = ['$resource'];

    function Fixtures($resource) {
        var resourceUrl = 'api/fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'exportAsCsv': {
                url: 'api/planograms/fixture/csv',
                method: 'GET',
                transformResponse: function (data, headersGetter) {
                    var filename = "fixtures.csv";
                    var blob = new Blob([data], { type: "text/csv;charset=UTF-8" });
                    saveAs(blob, filename, true);
                    return true;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('FixturesSearch', FixturesSearch);

    FixturesSearch.$inject = ['$resource'];

    function FixturesSearch($resource) {
        var resourceUrl =  'api/_search/fixtures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('FixturesController', FixturesController);

    FixturesController.$inject = ['$scope', '$state', 'Fixtures', 'ParentData', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FixturesController ($scope, $state, Fixtures, ParentData, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.fixtures = [];
        vm.expandProp = {
            field: 'id',
            displayName: 'Id',
            sortable : true,
            sortingType : "number",
        }
        vm.filterString = null;
        vm.colDefinitions = [
            {
                field: "fixtureName",
                displayName: "Fixture Name",
                sortable : true,
                filterable: true,
            },
            {
                field: "parentName",
                displayName: "Parent Name",
                sortable : false,
                filterable: true
            },
            {
                field: "categoryCategoryName",
                displayName: "Category Name",
                sortable : true,
                filterable: true
            },
            {
                field: "actions",
                displayName: " ",
                sortable: false,
                filterable: false,
                cellTemplate:
                "<div class=\"btn-group flex-btn-group-container\">"
                + "<button type=\"submit\" ui-sref=\"fixtures-detail({id:row.branch[col.field]})\" class=\"btn btn-info btn-sm\">"
                + "<span class=\"glyphicon glyphicon-eye-open\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span>"
                + "</button>"
                + "<button type=\"submit\" ui-sref=\"fixtures.edit({id:row.branch[col.field], hasChild: row.branch.children.length ? 'true' : 'false'})\" class=\"btn btn-primary btn-sm\">"
                + "<span class=\"glyphicon glyphicon-pencil\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>"
                + "</button>"
                + "<button type=\"submit\" ui-sref=\"fixtures.delete({id:row.branch[col.field]})\" class=\"btn btn-danger btn-sm\">"
                + "<span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;&nbsp;"
                + "<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>"
                + "</button>"
                + "</div>"
            }
        ];

        $scope.myTree = {};

        vm.loadAll();

        function loadAll () {
            Fixtures.query({
                page: 0,
                size: 2000,
                sort: 'id,asc'
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                data.forEach(addActionsProps);
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fixtures = listToTree(data);
                vm.page = pagingParams.page;
                vm.parents = data.filter(function(eachData) {
                    return !eachData.parentId;
                });
                ParentData.setParentData(vm.parents);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            function addActionsProps(each) {
                each.actions = each.id
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (searchQuery === '' || null) {
                vm.filterString = null;
                return;
            }
            vm.filterString = searchQuery;
        }

        function clear () {
            vm.filterString = null;
            vm.searchQuery = null;
            $scope.myTree.collapse_all();
        }

        function listToTree(list) {
            var map = {};
            var node;
            var roots = [];
            var i;

            for (i = 0; i < list.length; i += 1) {
                map[list[i].id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }

            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.parentId) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.parentId]].children.push(node);
                } else {
                    roots.push(node);
                }
            }
            return roots;
        }

        $scope.$on('$destroy', function(){
            ParentData.clearParentData();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('EquipmentDialogController', EquipmentDialogController);

    EquipmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Equipment', 'EquipmentSearch'];

    function EquipmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Equipment, EquipmentSearch) {
        var vm = this;
        vm.equipment = entity;
        vm.getParent = getParent;
        vm.loadingParent = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        vm.onSelectParent = function(item, model, label) {
            vm.equipment.parentId = model.id;
            vm.equipment.parentName = model.equipmentName;
        }
        
        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:equipmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            
            if (vm.equipment.id !== null) {
                Equipment.update(vm.equipment, onSaveSuccess, onSaveError);
            } else {
                Equipment.save(vm.equipment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function getParent(value) {
			vm.loadingParent = true;
			return EquipmentSearch.query({
				query : '*' + value + '*'
			}).$promise.then(function(response) {
				vm.loadingParent = false;
				return response;
			}, function(response) {
				vm.loadingParent = false;
				AlertService.error(response.data.message);
			});
		}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('EquipmentDetailController', EquipmentDetailController);

    EquipmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Equipment'];

    function EquipmentDetailController($scope, $rootScope, $stateParams, entity, Equipment) {
        var vm = this;
        vm.equipment = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:equipmentUpdate', function(event, result) {
            vm.equipment = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('EquipmentDeleteController',EquipmentDeleteController);

    EquipmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Equipment'];

    function EquipmentDeleteController($uibModalInstance, entity, Equipment) {
        var vm = this;
        vm.equipment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Equipment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('equipment', {
            parent: 'entity',
            url: '/equipment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.equipment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/equipment/equipment.html',
                    controller: 'EquipmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('equipment');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }]
            }
        })
        .state('equipment-detail', {
            parent: 'entity',
            url: '/equipment/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.equipment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/equipment/equipment-detail.html',
                    controller: 'EquipmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('equipment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Equipment', function($stateParams, Equipment) {
                    return Equipment.get({id : $stateParams.id});
                }]
            }
        })
        .state('equipment.new', {
            parent: 'equipment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/equipment/equipment-dialog.html',
                    controller: 'EquipmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                equipmentName: null,
                                highlight: null,
                                serialNumber: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('equipment', null, { reload: true });
                }, function() {
                    $state.go('equipment');
                });
            }]
        })
        .state('equipment.edit', {
            parent: 'equipment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/equipment/equipment-dialog.html',
                    controller: 'EquipmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Equipment', function(Equipment) {
                            return Equipment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('equipment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('equipment.delete', {
            parent: 'equipment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/equipment/equipment-delete-dialog.html',
                    controller: 'EquipmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Equipment', function(Equipment) {
                            return Equipment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('equipment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Equipment', Equipment);

    Equipment.$inject = ['$resource'];

    function Equipment($resource) {
        var resourceUrl = 'api/equipment/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'exportAsCsv': {
                url: 'api/planograms/equipment/csv',
                method: 'GET',
                transformResponse: function (data, headersGetter) {
                    var filename = "equipment.csv";
                    var blob = new Blob([data], { type: "text/csv;charset=UTF-8" });
                    saveAs(blob, filename, true);
                    return true;
                }
            },
            'getEquipmentCategory': {
                url: 'api/equipment-category',
                method: 'GET',
                isArray: true
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('EquipmentSearch', EquipmentSearch);

    EquipmentSearch.$inject = ['$resource'];

    function EquipmentSearch($resource) {
        var resourceUrl =  'api/_search/equipment/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('EquipmentController', EquipmentController);

    EquipmentController.$inject = ['$scope', '$state', 'Equipment', 'EquipmentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EquipmentController ($scope, $state, Equipment, EquipmentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EquipmentSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Equipment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.equipment = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DroppointDialogController', DroppointDialogController);

    DroppointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Droppoint', 'User', 'UserSearch', 'AlertService'];

    function DroppointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Droppoint, User,
        UserSearch, AlertService) {

        var vm = this;
        vm.droppoint = entity;
        //vm.users = User.query();
        vm.getUser = getUser;
        vm.loadingUser = false;

        if (vm.droppoint.$promise) {
            vm.droppoint.$promise.then(function(data) {
                if (data.picLogin != null) {
                    User.get({login: data.picLogin}, function(vdo) {
                        vm.vdo = vdo;
                    });
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:droppointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        function getUser(role, value) {
            vm.loadingUser = true;
            return UserSearch.query({
                roleName: role,
                query: value
            }).$promise.then(function (response) {
                vm.loadingUser = false;
                return response;
            }, function (response) {
                vm.loadingUser = false;
                AlertService.error(response.data.message);
            });
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.vdo) {
                vm.droppoint.picId = vm.vdo.id;
            } else {
                vm.droppoint.picId = null;
            }
            if (vm.droppoint.id !== null) {
                Droppoint.update(vm.droppoint, onSaveSuccess, onSaveError);
            } else {
                Droppoint.save(vm.droppoint, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DroppointDetailController', DroppointDetailController);

    DroppointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Droppoint', 'User'];

    function DroppointDetailController($scope, $rootScope, $stateParams, entity, Droppoint, User) {
        var vm = this;
        vm.droppoint = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:droppointUpdate', function(event, result) {
            vm.droppoint = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DroppointDeleteController',DroppointDeleteController);

    DroppointDeleteController.$inject = ['$uibModalInstance', 'entity', 'Droppoint'];

    function DroppointDeleteController($uibModalInstance, entity, Droppoint) {
        var vm = this;
        vm.droppoint = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Droppoint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('droppoint', {
            parent: 'entity',
            url: '/droppoint?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.droppoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/droppoint/droppoints.html',
                    controller: 'DroppointController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('droppoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('droppoint-detail', {
            parent: 'entity',
            url: '/droppoint/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.droppoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/droppoint/droppoint-detail.html',
                    controller: 'DroppointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('droppoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Droppoint', function($stateParams, Droppoint) {
                    return Droppoint.get({id : $stateParams.id});
                }]
            }
        })
        .state('droppoint.new', {
            parent: 'droppoint',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/droppoint/droppoint-dialog.html',
                    controller: 'DroppointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('droppoint', null, { reload: true });
                }, function() {
                    $state.go('droppoint');
                });
            }]
        })
        .state('droppoint.edit', {
            parent: 'droppoint',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/droppoint/droppoint-dialog.html',
                    controller: 'DroppointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Droppoint', function(Droppoint) {
                            return Droppoint.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('droppoint', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('droppoint.delete', {
            parent: 'droppoint',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/droppoint/droppoint-delete-dialog.html',
                    controller: 'DroppointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Droppoint', function(Droppoint) {
                            return Droppoint.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('droppoint', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Droppoint', Droppoint);

    Droppoint.$inject = ['$resource'];

    function Droppoint ($resource) {
        var resourceUrl =  'api/droppoints/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('DroppointSearch', DroppointSearch);

    DroppointSearch.$inject = ['$resource'];

    function DroppointSearch($resource) {
        var resourceUrl =  'api/_search/droppoints/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DroppointController', DroppointController);

    DroppointController.$inject = ['$scope', '$state', 'Droppoint', 'DroppointSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DroppointController ($scope, $state, Droppoint, DroppointSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DroppointSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Droppoint.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.droppoints = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DealerDialogController', DealerDialogController);

    DealerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dealer'];

    function DealerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dealer) {
        var vm = this;
        vm.dealer = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:dealerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.dealer.id !== null) {
                Dealer.update(vm.dealer, onSaveSuccess, onSaveError);
            } else {
                Dealer.save(vm.dealer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DealerDetailController', DealerDetailController);

    DealerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Dealer'];

    function DealerDetailController($scope, $rootScope, $stateParams, entity, Dealer) {
        var vm = this;
        vm.dealer = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:dealerUpdate', function(event, result) {
            vm.dealer = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DealerDeleteController',DealerDeleteController);

    DealerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dealer'];

    function DealerDeleteController($uibModalInstance, entity, Dealer) {
        var vm = this;
        vm.dealer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Dealer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dealer', {
            parent: 'entity',
            url: '/dealer?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.dealer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dealer/dealers.html',
                    controller: 'DealerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dealer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dealer-detail', {
            parent: 'entity',
            url: '/dealer/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.dealer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dealer/dealer-detail.html',
                    controller: 'DealerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dealer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dealer', function($stateParams, Dealer) {
                    return Dealer.get({id : $stateParams.id});
                }]
            }
        })
        .state('dealer.new', {
            parent: 'dealer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dealer/dealer-dialog.html',
                    controller: 'DealerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dealer_name: null,
                                dealer_address: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dealer', null, { reload: true });
                }, function() {
                    $state.go('dealer');
                });
            }]
        })
        .state('dealer.edit', {
            parent: 'dealer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dealer/dealer-dialog.html',
                    controller: 'DealerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dealer', function(Dealer) {
                            return Dealer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('dealer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dealer.delete', {
            parent: 'dealer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dealer/dealer-delete-dialog.html',
                    controller: 'DealerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dealer', function(Dealer) {
                            return Dealer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('dealer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Dealer', Dealer);

    Dealer.$inject = ['$resource'];

    function Dealer ($resource) {
        var resourceUrl =  'api/dealers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('DealerSearch', DealerSearch);

    DealerSearch.$inject = ['$resource'];

    function DealerSearch($resource) {
        var resourceUrl =  'api/_search/dealers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DealerController', DealerController);

    DealerController.$inject = ['$scope', '$state', 'Dealer', 'DealerSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DealerController ($scope, $state, Dealer, DealerSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DealerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dealer.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dealers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ChannelDialogController', ChannelDialogController);

    ChannelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Channel'];

    function ChannelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Channel) {
        var vm = this;
        vm.channel = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:channelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.channel.id !== null) {
                Channel.update(vm.channel, onSaveSuccess, onSaveError);
            } else {
                Channel.save(vm.channel, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ChannelDetailController', ChannelDetailController);

    ChannelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Channel'];

    function ChannelDetailController($scope, $rootScope, $stateParams, entity, Channel) {
        var vm = this;
        vm.channel = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:channelUpdate', function(event, result) {
            vm.channel = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ChannelDeleteController',ChannelDeleteController);

    ChannelDeleteController.$inject = ['$uibModalInstance', 'entity', 'Channel'];

    function ChannelDeleteController($uibModalInstance, entity, Channel) {
        var vm = this;
        vm.channel = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Channel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('channel', {
            parent: 'entity',
            url: '/channel?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.channel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/channel/channels.html',
                    controller: 'ChannelController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('channel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('channel-detail', {
            parent: 'entity',
            url: '/channel/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.channel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/channel/channel-detail.html',
                    controller: 'ChannelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('channel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Channel', function($stateParams, Channel) {
                    return Channel.get({id : $stateParams.id});
                }]
            }
        })
        .state('channel.new', {
            parent: 'channel',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/channel/channel-dialog.html',
                    controller: 'ChannelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                channelName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('channel', null, { reload: true });
                }, function() {
                    $state.go('channel');
                });
            }]
        })
        .state('channel.edit', {
            parent: 'channel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/channel/channel-dialog.html',
                    controller: 'ChannelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Channel', function(Channel) {
                            return Channel.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('channel.delete', {
            parent: 'channel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/channel/channel-delete-dialog.html',
                    controller: 'ChannelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Channel', function(Channel) {
                            return Channel.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('channel', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Channel', Channel);

    Channel.$inject = ['$resource'];

    function Channel ($resource) {
        var resourceUrl =  'api/channels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ChannelSearch', ChannelSearch);

    ChannelSearch.$inject = ['$resource'];

    function ChannelSearch($resource) {
        var resourceUrl =  'api/_search/channels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ChannelController', ChannelController);

    ChannelController.$inject = ['$scope', '$state', 'Channel', 'ChannelSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ChannelController ($scope, $state, Channel, ChannelSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ChannelSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Channel.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.channels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
	'use strict';

	angular.module('sceaApp').controller('CalendarDialogController',
			CalendarDialogController);

	CalendarDialogController.$inject = [ '$timeout', '$scope', '$stateParams',
			'$uibModalInstance', 'entity', 'Calendar' ];

	function CalendarDialogController($timeout, $scope, $stateParams,
			$uibModalInstance, entity, Calendar) {
		var vm = this;
        vm.checkValidDate = checkValidDate;

		vm.calendar = entity;

        if(entity.startDate != null && entity.endDate != null) {
            checkValidDate();
        }

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		var onSaveSuccess = function(result) {
			$scope.$emit('sceaApp:calendarUpdate', result);
			$uibModalInstance.close(result);
			vm.isSaving = false;
		};

		var onSaveError = function() {
			vm.isSaving = false;
		};

		vm.save = function() {
			vm.isSaving = true;

            var endDate = moment(vm.calendar.endDate).endOf('day');
            vm.calendar.endDate = endDate._d;

			if (vm.calendar.id !== null) {
				Calendar.update(vm.calendar, onSaveSuccess, onSaveError);
			} else {
				Calendar.save(vm.calendar, onSaveSuccess, onSaveError);
			}
		};

		vm.clear = function() {
			$uibModalInstance.dismiss('cancel');
		};

		vm.datePickerOpenStatus = {};
		vm.datePickerOpenStatus.startDate = false;
		vm.datePickerOpenStatus.endDate = false;

		vm.openCalendar = function(date) {
			vm.datePickerOpenStatus[date] = true;
		};

        function checkValidDate() {
        	if(vm.calendar.startDate != null && vm.calendar.endDate != null) {
            	var isValid = moment(vm.calendar.endDate).isAfter(vm.calendar.startDate);
            	if(isValid) {
            		vm.invalidDate = false;
            	} else {
            		vm.invalidDate = true;
            	}
        	}
        }
	}
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('CalendarDetailController', CalendarDetailController);

    CalendarDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Calendar'];

    function CalendarDetailController($scope, $rootScope, $stateParams, entity, Calendar) {
        var vm = this;
        vm.calendar = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:calendarUpdate', function(event, result) {
            vm.calendar = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('CalendarDeleteController',CalendarDeleteController);

    CalendarDeleteController.$inject = ['$uibModalInstance', 'entity', 'Calendar'];

    function CalendarDeleteController($uibModalInstance, entity, Calendar) {
        var vm = this;
        vm.calendar = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Calendar.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar', {
            parent: 'entity',
            url: '/calendar?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.calendar.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/calendar/calendars.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('calendar');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('calendar-detail', {
            parent: 'entity',
            url: '/calendar/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.calendar.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/calendar/calendar-detail.html',
                    controller: 'CalendarDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('calendar');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Calendar', function($stateParams, Calendar) {
                    return Calendar.get({id : $stateParams.id});
                }]
            }
        })
        .state('calendar.new', {
            parent: 'calendar',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-dialog.html',
                    controller: 'CalendarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                year: null,
                                month: null,
                                week: null,
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: true });
                }, function() {
                    $state.go('calendar');
                });
            }]
        })
        .state('calendar.edit', {
            parent: 'calendar',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-dialog.html',
                    controller: 'CalendarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Calendar', function(Calendar) {
                            return Calendar.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('calendar.delete', {
            parent: 'calendar',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/calendar-delete-dialog.html',
                    controller: 'CalendarDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Calendar', function(Calendar) {
                            return Calendar.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Calendar', Calendar);

    Calendar.$inject = ['$resource', 'DateUtils'];

    function Calendar ($resource, DateUtils) {
        var resourceUrl =  'api/calendars/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    return data;
                }
            },
            'getCurrent': {
            	url: 'api/calendars/current',
                method: 'GET',
                transformResponse: function (data) {
                    if(!data) {
                        return;
                    }
                    data = angular.fromJson(data);
                    data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'queryYears': {
            	url: 'api/calendars/years',
            	method: 'GET',
            	isArray: true
            },
            'queryMonths': {
            	url: 'api/calendars/months',
            	method: 'GET',
            	isArray: true
            },
            'queryWeeks': {
            	url: 'api/calendars/weeks',
            	method: 'GET',
            	isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('CalendarSearch', CalendarSearch);

    CalendarSearch.$inject = ['$resource'];

    function CalendarSearch($resource) {
        var resourceUrl =  'api/_search/calendars/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('CalendarController', CalendarController);

    CalendarController.$inject = ['$scope', '$state', 'Calendar', 'CalendarSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CalendarController ($scope, $state, Calendar, CalendarSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CalendarSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Calendar.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.calendars = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('BrandDialogController', BrandDialogController);

    BrandDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Brand'];

    function BrandDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Brand) {
        var vm = this;
        vm.brand = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:brandUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.brand.id !== null) {
                Brand.update(vm.brand, onSaveSuccess, onSaveError);
            } else {
                Brand.save(vm.brand, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('BrandDetailController', BrandDetailController);

    BrandDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Brand'];

    function BrandDetailController($scope, $rootScope, $stateParams, entity, Brand) {
        var vm = this;
        vm.brand = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:brandUpdate', function(event, result) {
            vm.brand = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('BrandDeleteController',BrandDeleteController);

    BrandDeleteController.$inject = ['$uibModalInstance', 'entity', 'Brand'];

    function BrandDeleteController($uibModalInstance, entity, Brand) {
        var vm = this;
        vm.brand = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Brand.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brand', {
            parent: 'entity',
            url: '/brand?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.brand.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brand/brands.html',
                    controller: 'BrandController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brand-detail', {
            parent: 'entity',
            url: '/brand/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.brand.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brand/brand-detail.html',
                    controller: 'BrandDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brand');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Brand', function($stateParams, Brand) {
                    return Brand.get({id : $stateParams.id});
                }]
            }
        })
        .state('brand.new', {
            parent: 'brand',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brand/brand-dialog.html',
                    controller: 'BrandDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                brandName: null,
                                flag: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brand', null, { reload: true });
                }, function() {
                    $state.go('brand');
                });
            }]
        })
        .state('brand.edit', {
            parent: 'brand',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brand/brand-dialog.html',
                    controller: 'BrandDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Brand', function(Brand) {
                            return Brand.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brand', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brand.delete', {
            parent: 'brand',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brand/brand-delete-dialog.html',
                    controller: 'BrandDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Brand', function(Brand) {
                            return Brand.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('brand', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Brand', Brand);

    Brand.$inject = ['$resource'];

    function Brand ($resource) {
        var resourceUrl =  'api/brands/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('BrandSearch', BrandSearch);

    BrandSearch.$inject = ['$resource'];

    function BrandSearch($resource) {
        var resourceUrl =  'api/_search/brands/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('BrandController', BrandController);

    BrandController.$inject = ['$scope', '$state', 'Brand', 'BrandSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function BrandController ($scope, $state, Brand, BrandSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                BrandSearch.query({
                    query: pagingParams.search + ' AND deleted:false',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Brand.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.brands = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AttachmentDialogController', AttachmentDialogController);

    AttachmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Attachment'];

    function AttachmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Attachment) {
        var vm = this;
        vm.attachment = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:attachmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.attachment.id !== null) {
                Attachment.update(vm.attachment, onSaveSuccess, onSaveError);
            } else {
                Attachment.save(vm.attachment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};

        vm.setContent = function ($file, attachment) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        attachment.content = base64Data;
                        attachment.contentContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.creationDate = false;

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AttachmentDetailController', AttachmentDetailController);

    AttachmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Attachment'];

    function AttachmentDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Attachment) {
        var vm = this;
        vm.attachment = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:attachmentUpdate', function(event, result) {
            vm.attachment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AttachmentDeleteController',AttachmentDeleteController);

    AttachmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attachment'];

    function AttachmentDeleteController($uibModalInstance, entity, Attachment) {
        var vm = this;
        vm.attachment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Attachment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('attachment', {
//            parent: 'entity',
//            url: '/attachment?page&sort&search',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.attachment.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/attachment/attachments.html',
//                    controller: 'AttachmentController',
//                    controllerAs: 'vm'
//                }
//            },
//            params: {
//                page: {
//                    value: '1',
//                    squash: true
//                },
//                sort: {
//                    value: 'id,asc',
//                    squash: true
//                },
//                search: null
//            },
//            resolve: {
//                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
//                    return {
//                        page: PaginationUtil.parsePage($stateParams.page),
//                        sort: $stateParams.sort,
//                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
//                        ascending: PaginationUtil.parseAscending($stateParams.sort),
//                        search: $stateParams.search
//                    };
//                }],
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('attachment');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('attachment-detail', {
//            parent: 'entity',
//            url: '/attachment/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.attachment.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/attachment/attachment-detail.html',
//                    controller: 'AttachmentDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('attachment');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'Attachment', function($stateParams, Attachment) {
//                    return Attachment.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('attachment.new', {
//            parent: 'attachment',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/attachment/attachment-dialog.html',
//                    controller: 'AttachmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                content: null,
//                                contentContentType: null,
//                                fileName: null,
//                                size: null,
//                                creationDate: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('attachment', null, { reload: true });
//                }, function() {
//                    $state.go('attachment');
//                });
//            }]
//        })
//        .state('attachment.edit', {
//            parent: 'attachment',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/attachment/attachment-dialog.html',
//                    controller: 'AttachmentDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['Attachment', function(Attachment) {
//                            return Attachment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('attachment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('attachment.delete', {
//            parent: 'attachment',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/attachment/attachment-delete-dialog.html',
//                    controller: 'AttachmentDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['Attachment', function(Attachment) {
//                            return Attachment.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('attachment', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Attachment', Attachment);

    Attachment.$inject = ['$resource', 'DateUtils'];

    function Attachment ($resource, DateUtils) {
        var resourceUrl =  'api/attachments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'upload': { method:'POST' },
            'download': {
            	url: 'api/attachments/:id/binary',
                method: 'GET',
            	data: '',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'arraybuffer',
                transformResponse: function (data, headersGetter) {
                    var contentDisposition = headersGetter('Content-Disposition');
                    var filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)[1];
                	var filetype = headersGetter('Content-Type');
                    var blob = new Blob([data], {type: filetype});
                    saveAs(blob, filename, true);
                    return true;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AttachmentSearch', AttachmentSearch);

    AttachmentSearch.$inject = ['$resource'];

    function AttachmentSearch($resource) {
        var resourceUrl =  'api/_search/attachments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AttachmentController', AttachmentController);

    AttachmentController.$inject = ['$scope', '$state', 'DataUtils', 'Attachment', 'AttachmentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AttachmentController ($scope, $state, DataUtils, Attachment, AttachmentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AttachmentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Attachment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attachments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaLevelDialogController', AreaLevelDialogController);

    AreaLevelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AreaLevel'];

    function AreaLevelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AreaLevel) {
        var vm = this;
        vm.areaLevel = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:areaLevelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.areaLevel.id !== null) {
                AreaLevel.update(vm.areaLevel, onSaveSuccess, onSaveError);
            } else {
                AreaLevel.save(vm.areaLevel, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaLevelDetailController', AreaLevelDetailController);

    AreaLevelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AreaLevel'];

    function AreaLevelDetailController($scope, $rootScope, $stateParams, entity, AreaLevel) {
        var vm = this;
        vm.areaLevel = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:areaLevelUpdate', function(event, result) {
            vm.areaLevel = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaLevelDeleteController',AreaLevelDeleteController);

    AreaLevelDeleteController.$inject = ['$uibModalInstance', 'entity', 'AreaLevel'];

    function AreaLevelDeleteController($uibModalInstance, entity, AreaLevel) {
        var vm = this;
        vm.areaLevel = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AreaLevel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('area-level', {
            parent: 'entity',
            url: '/area-level?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.areaLevel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area-level/area-levels.html',
                    controller: 'AreaLevelController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('areaLevel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('area-level-detail', {
            parent: 'entity',
            url: '/area-level/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.areaLevel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area-level/area-level-detail.html',
                    controller: 'AreaLevelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('areaLevel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AreaLevel', function($stateParams, AreaLevel) {
                    return AreaLevel.get({id : $stateParams.id});
                }]
            }
        })
        .state('area-level.new', {
            parent: 'area-level',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area-level/area-level-dialog.html',
                    controller: 'AreaLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                levelName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('area-level', null, { reload: true });
                }, function() {
                    $state.go('area-level');
                });
            }]
        })
        .state('area-level.edit', {
            parent: 'area-level',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area-level/area-level-dialog.html',
                    controller: 'AreaLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AreaLevel', function(AreaLevel) {
                            return AreaLevel.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('area-level', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('area-level.delete', {
            parent: 'area-level',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area-level/area-level-delete-dialog.html',
                    controller: 'AreaLevelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AreaLevel', function(AreaLevel) {
                            return AreaLevel.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('area-level', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('AreaLevel', AreaLevel);

    AreaLevel.$inject = ['$resource'];

    function AreaLevel ($resource) {
        var resourceUrl =  'api/area-levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AreaLevelSearch', AreaLevelSearch);

    AreaLevelSearch.$inject = ['$resource'];

    function AreaLevelSearch($resource) {
        var resourceUrl =  'api/_search/area-levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaLevelController', AreaLevelController);

    AreaLevelController.$inject = ['$scope', '$state', 'AreaLevel', 'AreaLevelSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AreaLevelController ($scope, $state, AreaLevel, AreaLevelSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AreaLevelSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AreaLevel.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.areaLevels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaDialogController', AreaDialogController);

    AreaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Area', 'AreaLevel', 'AreaSearch'];

    function AreaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Area, AreaLevel, AreaSearch) {
        var vm = this;
        vm.area = entity;
        vm.areas = Area.query();
        vm.arealevels = AreaLevel.query();
        vm.getArea = getArea;
        vm.loadingArea = false;
        vm.parent = null;
        
       if (vm.area.$promise) {
			vm.area.$promise.then(function(data) {
				vm.parent = {
					"id" : data.parentId,
					"areaName" : data.parentName
				}
			}, function(error) {
				console.log(error);
			});
		}
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        
        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:areaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(vm.parent){
            	vm.area.parentId = vm.parent.id;
            }else{
            	vm.area.parentId = null;
            }	
            if (vm.area.id !== null) {
            	Area.update(vm.area, onSaveSuccess, onSaveError);
            } else {          	
                Area.save(vm.area, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        function getArea(value) {
        	vm.loadingArea = true;
            return AreaSearch.query({
            	query: '*'+value+'*'
            }).$promise.then(function(response){
            	vm.loadingArea = false;
                return response;
            }, function(response){
            	vm.loadingArea = false;
                AlertService.error(response.data.message);
            });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaDetailController', AreaDetailController);

    AreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Area', 'AreaLevel'];

    function AreaDetailController($scope, $rootScope, $stateParams, entity, Area, AreaLevel) {
        var vm = this;
        vm.area = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:areaUpdate', function(event, result) {
            vm.area = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaDeleteController',AreaDeleteController);

    AreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Area'];

    function AreaDeleteController($uibModalInstance, entity, Area) {
        var vm = this;
        vm.area = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Area.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('area', {
            parent: 'entity',
            url: '/area?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.area.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area/areas.html',
                    controller: 'AreaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('area');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('area-detail', {
            parent: 'entity',
            url: '/area/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR'],
                pageTitle: 'sceaApp.area.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/area/area-detail.html',
                    controller: 'AreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('area');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Area', function($stateParams, Area) {
                    return Area.get({id : $stateParams.id});
                }]
            }
        })
        .state('area.new', {
            parent: 'area',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-dialog.html',
                    controller: 'AreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: true });
                }, function() {
                    $state.go('area');
                });
            }]
        })
        .state('area.edit', {
            parent: 'area',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-dialog.html',
                    controller: 'AreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Area', function(Area) {
                            return Area.get({id : $stateParams.id });
                        }]
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('area.delete', {
            parent: 'area',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'VDR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/area/area-delete-dialog.html',
                    controller: 'AreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Area', function(Area) {
                            return Area.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('area', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Area', Area);

    Area.$inject = ['$resource'];

    function Area ($resource) {
        var resourceUrl =  'api/areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByLevelId':{
            	url:'api/areas/area-levels/:areaLevelId',
            	method:'GET',
            	isArray:true},
            'queryByParentIdAndLevelId':{
                url:'api/areas/parent/:parentId/area-levels/:areaLevelId',
                method:'GET',
                isArray:true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AreaSearch', AreaSearch);

    AreaSearch.$inject = ['$resource'];

    function AreaSearch($resource) {
        var resourceUrl =  'api/_search/areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AreaController', AreaController);

    AreaController.$inject = ['$scope', '$state', 'Area', 'AreaSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AreaController ($scope, $state, Area, AreaSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AreaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Area.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.areas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AdjustedAccumulationDialogController', AdjustedAccumulationDialogController);

    AdjustedAccumulationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AdjustedAccumulation', 'User'];

    function AdjustedAccumulationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AdjustedAccumulation, User) {
        var vm = this;
        vm.adjustedAccumulation = entity;
        vm.employees = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:adjustedAccumulationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.adjustedAccumulation.id !== null) {
                AdjustedAccumulation.update(vm.adjustedAccumulation, onSaveSuccess, onSaveError);
            } else {
                AdjustedAccumulation.save(vm.adjustedAccumulation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.insertDate = false;
        vm.datePickerOpenStatus.lastUpdatedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AdjustedAccumulationDetailController', AdjustedAccumulationDetailController);

    AdjustedAccumulationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'AdjustedAccumulation'];

    function AdjustedAccumulationDetailController($scope, $rootScope, $stateParams, entity, AdjustedAccumulation) {
        var vm = this;
        vm.adjustedAccumulation = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:adjustedAccumulationUpdate', function(event, result) {
            vm.adjustedAccumulation = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AdjustedAccumulationDeleteController',AdjustedAccumulationDeleteController);

    AdjustedAccumulationDeleteController.$inject = ['$uibModalInstance', 'entity', 'AdjustedAccumulation'];

    function AdjustedAccumulationDeleteController($uibModalInstance, entity, AdjustedAccumulation) {
        var vm = this;
        vm.adjustedAccumulation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AdjustedAccumulation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('adjusted-accumulation', {
//            parent: 'entity',
//            url: '/adjusted-accumulation',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.adjustedAccumulation.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/adjusted-accumulation/adjusted-accumulations.html',
//                    controller: 'AdjustedAccumulationController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('adjustedAccumulation');
//                    $translatePartialLoader.addPart('category');
//                    $translatePartialLoader.addPart('storeType');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('adjusted-accumulation-detail', {
//            parent: 'entity',
//            url: '/adjusted-accumulation/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.adjustedAccumulation.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/adjusted-accumulation/adjusted-accumulation-detail.html',
//                    controller: 'AdjustedAccumulationDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('adjustedAccumulation');
//                    $translatePartialLoader.addPart('category');
//                    $translatePartialLoader.addPart('storeType');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'AdjustedAccumulation', function($stateParams, AdjustedAccumulation) {
//                    return AdjustedAccumulation.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('adjusted-accumulation.new', {
//            parent: 'adjusted-accumulation',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/adjusted-accumulation/adjusted-accumulation-dialog.html',
//                    controller: 'AdjustedAccumulationDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                insertDate: null,
//                                lastUpdatedDate: null,
//                                year: null,
//                                month: null,
//                                week: null,
//                                category: null,
//                                storeType: null,
//                                percentageYtd: null,
//                                percentageMtd: null,
//                                percentageWtd: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('adjusted-accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('adjusted-accumulation');
//                });
//            }]
//        })
//        .state('adjusted-accumulation.edit', {
//            parent: 'adjusted-accumulation',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/adjusted-accumulation/adjusted-accumulation-dialog.html',
//                    controller: 'AdjustedAccumulationDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['AdjustedAccumulation', function(AdjustedAccumulation) {
//                            return AdjustedAccumulation.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('adjusted-accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('adjusted-accumulation.delete', {
//            parent: 'adjusted-accumulation',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/adjusted-accumulation/adjusted-accumulation-delete-dialog.html',
//                    controller: 'AdjustedAccumulationDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['AdjustedAccumulation', function(AdjustedAccumulation) {
//                            return AdjustedAccumulation.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('adjusted-accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('AdjustedAccumulation', AdjustedAccumulation);

    AdjustedAccumulation.$inject = ['$resource', 'DateUtils'];

    function AdjustedAccumulation ($resource, DateUtils) {
        var resourceUrl =  'api/adjusted-accumulations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.insertDate = DateUtils.convertDateTimeFromServer(data.insertDate);
                    data.lastUpdatedDate = DateUtils.convertDateTimeFromServer(data.lastUpdatedDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AdjustedAccumulationSearch', AdjustedAccumulationSearch);

    AdjustedAccumulationSearch.$inject = ['$resource'];

    function AdjustedAccumulationSearch($resource) {
        var resourceUrl =  'api/_search/adjusted-accumulations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AdjustedAccumulationController', AdjustedAccumulationController);

    AdjustedAccumulationController.$inject = ['$scope', '$state', 'AdjustedAccumulation', 'AdjustedAccumulationSearch'];

    function AdjustedAccumulationController ($scope, $state, AdjustedAccumulation, AdjustedAccumulationSearch) {
        var vm = this;
        vm.adjustedAccumulations = [];
        vm.loadAll = function() {
            AdjustedAccumulation.query(function(result) {
                vm.adjustedAccumulations = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            AdjustedAccumulationSearch.query({query: vm.searchQuery}, function(result) {
                vm.adjustedAccumulations = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AccumulationDialogController', AccumulationDialogController);

    AccumulationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Accumulation', 'User'];

    function AccumulationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Accumulation, User) {
        var vm = this;
        vm.accumulation = entity;
        vm.employees = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:accumulationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.accumulation.id !== null) {
                Accumulation.update(vm.accumulation, onSaveSuccess, onSaveError);
            } else {
                Accumulation.save(vm.accumulation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.insertDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AccumulationDetailController', AccumulationDetailController);

    AccumulationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Accumulation'];

    function AccumulationDetailController($scope, $rootScope, $stateParams, entity, Accumulation) {
        var vm = this;
        vm.accumulation = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:accumulationUpdate', function(event, result) {
            vm.accumulation = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AccumulationDeleteController',AccumulationDeleteController);

    AccumulationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Accumulation'];

    function AccumulationDeleteController($uibModalInstance, entity, Accumulation) {
        var vm = this;
        vm.accumulation = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Accumulation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider
//        .state('accumulation', {
//            parent: 'entity',
//            url: '/accumulation',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.accumulation.home.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/accumulation/accumulations.html',
//                    controller: 'AccumulationController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('accumulation');
//                    $translatePartialLoader.addPart('category');
//                    $translatePartialLoader.addPart('storeType');
//                    $translatePartialLoader.addPart('global');
//                    return $translate.refresh();
//                }]
//            }
//        })
//        .state('accumulation-detail', {
//            parent: 'entity',
//            url: '/accumulation/{id}',
//            data: {
//                authorities: ['ROLE_USER'],
//                pageTitle: 'sceaApp.accumulation.detail.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/accumulation/accumulation-detail.html',
//                    controller: 'AccumulationDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('accumulation');
//                    $translatePartialLoader.addPart('category');
//                    $translatePartialLoader.addPart('storeType');
//                    return $translate.refresh();
//                }],
//                entity: ['$stateParams', 'Accumulation', function($stateParams, Accumulation) {
//                    return Accumulation.get({id : $stateParams.id});
//                }]
//            }
//        })
//        .state('accumulation.new', {
//            parent: 'accumulation',
//            url: '/new',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/accumulation/accumulation-dialog.html',
//                    controller: 'AccumulationDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                insertDate: null,
//                                category: null,
//                                year: null,
//                                month: null,
//                                week: null,
//                                targetYtd: null,
//                                actualYtd: null,
//                                targetMtd: null,
//                                actualMtd: null,
//                                targetWtd: null,
//                                actualWtd: null,
//                                storeType: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('accumulation');
//                });
//            }]
//        })
//        .state('accumulation.edit', {
//            parent: 'accumulation',
//            url: '/{id}/edit',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/accumulation/accumulation-dialog.html',
//                    controller: 'AccumulationDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['Accumulation', function(Accumulation) {
//                            return Accumulation.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('accumulation.delete', {
//            parent: 'accumulation',
//            url: '/{id}/delete',
//            data: {
//                authorities: ['ROLE_USER']
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/accumulation/accumulation-delete-dialog.html',
//                    controller: 'AccumulationDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['Accumulation', function(Accumulation) {
//                            return Accumulation.get({id : $stateParams.id});
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('accumulation', null, { reload: true });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
//    }
//
//})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('Accumulation', Accumulation);

    Accumulation.$inject = ['$resource', 'DateUtils'];

    function Accumulation ($resource, DateUtils) {
        var resourceUrl =  'api/accumulations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.insertDate = DateUtils.convertDateTimeFromServer(data.insertDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AccumulationSearch', AccumulationSearch);

    AccumulationSearch.$inject = ['$resource'];

    function AccumulationSearch($resource) {
        var resourceUrl =  'api/_search/accumulations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AccumulationController', AccumulationController);

    AccumulationController.$inject = ['$scope', '$state', 'Accumulation', 'AccumulationSearch'];

    function AccumulationController ($scope, $state, Accumulation, AccumulationSearch) {
        var vm = this;
        vm.accumulations = [];
        vm.loadAll = function() {
            Accumulation.query(function(result) {
                vm.accumulations = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            AccumulationSearch.query({query: vm.searchQuery}, function(result) {
                vm.accumulations = result;
            });
        };
        vm.loadAll();
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .filter('percentage', percentage);

    percentage.$inject = ['$filter'];

    function percentage($filter) {
        return percentageFilter;

        function percentageFilter (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        }
    }
})();;
(function(){
    'use strict';

    angular
        .module('sceaApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('sceaApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .directive('disableNegativeInput', disableNegativeInput);

    disableNegativeInput.$inject = [];

    function disableNegativeInput() {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModelCtrl) {
                function isNotAllowed(key) {
                    var minusCode = [189, 109];
                    
                    return minusCode.includes(key);
                }

                $element.bind('keydown', function(event) {
                    var key = event.keyCode;
                    if(isNotAllowed(key))
                        event.preventDefault();
                });
            }
        }
    }
})();;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .directive('disableDecimalInput', disableDecimalInput);

    disableDecimalInput.$inject = [];

    function disableDecimalInput() {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModelCtrl) {
                function isNotAllowed(key) {
                    var minusCode = [110, 190];

                    return minusCode.includes(key);
                }

                $element.bind('keydown', function (event) {
                    var key = event.keyCode;
                    if (isNotAllowed(key))
                        event.preventDefault();
                });
            }
        }
    }
})();;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sceaApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('dashboard', null, {reload: true});
                }

                $state.go('dashboard', null, {reload: true});

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params, {reload: true});
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('sceaApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('sceaApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-sceaApp-error');
                var entityKey = httpResponse.headers('X-sceaApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('sceaApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('sceaApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-sceaApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-sceaApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('sceaApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api\/.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
        angular
        .module('sceaApp')
        .constant('VERSION', "0.2.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
	'use strict';

	angular.module('sceaApp').controller('UserManagementDialogController',
			UserManagementDialogController);

	UserManagementDialogController.$inject = [ '$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'UserSearch' ];

	function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, JhiLanguageService, UserSearch) {
		var vm = this;

		vm.profiles = [ 'ROLE_ADMIN', 'ARCO', 'SPV', 'PC', 'VDR', 'VDO', 'VDE' ];
		vm.authorities = null;
		vm.clear = clear;
		vm.languages = null;
		vm.save = save;
		vm.user = entity;
		vm.getEmployee = getEmployee;

		vm.loadingEmployee = false;
        vm.managerOpt = null;
        vm.areaOpt = null;

        if (vm.user.$promise) {
        	 vm.user.$promise.then(function(data) {
        		 vm.user.authorities = data.authorities[0];

        		 vm.managerOpt = {
        			id : data.managerId,
        			firstName : data.managerName
        		 }

        		 if(vm.managerOpt.id == null){
        			 vm.managerOpt = null;
        		 }
			}, function(error) {
				console.log(error);
			});
		}

		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		function save() {
			vm.isSaving = true;
			
			if(vm.user.authorities.length == 0){
			    vm.user.authorities = null;
			}else{
			    vm.user.authorities = [vm.user.authorities];
			}

            if(vm.managerOpt){
            	vm.user.managerId = vm.managerOpt.id;
            }else{
            	vm.user.managerId = null;
            }

			if (vm.user.id !== null) {
				User.update(vm.user, onSaveSuccess, onSaveError);
			} else {
				User.save(vm.user, onSaveSuccess, onSaveError);
			}
		}

		function getEmployee(value) {
			vm.loadingEmployee = true;
			return UserSearch.query({
				query : '*' + value + '*'
			}).$promise.then(function(response) {
				vm.loadingEmployee = false;
				return response;
			}, function(response) {
				vm.loadingEmployee = false;
				AlertService.error(response.data.message);
			});
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort&id&login&email&firstName&lastName&employeeCode&managerName&activated&profiles',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                profiles: {
                    value: null
                },
                activated: {
                    value: null
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        id: $stateParams.id,
                        login: $stateParams.login,
                        email: $stateParams.email,
                        firstName: $stateParams.firstName,
                        lastName:$stateParams.lastName,
                        employeeCode: $stateParams.employeeCode,
                        managerName: $stateParams.managerName,
                        activated: $stateParams.activated,
                        profiles: $stateParams.profiles
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: [], employee: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['$scope', '$state','Principal', 'User', 'UserSearch','ParseLinks', 'paginationConstants', 'AlertService','pagingParams','JhiLanguageService'];

    function UserManagementController($scope, $state, Principal, User, UserSearch, ParseLinks, paginationConstants, AlertService, pagingParams, JhiLanguageService) {
        var vm = this;

        vm.profiles = [ null, 'ROLE_ADMIN', 'ARCO', 'SPV', 'PC', 'VDO', 'VDE' ];
        vm.roleUser = vm.profiles[0];
        vm.currentAccount = null;
        vm.languages = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.page = pagingParams.page;
        vm.totalItems = null;
        vm.users = [];
        vm.filter = {
            id: pagingParams.id,
            login: pagingParams.login,
            email: pagingParams.email,
            firstName: pagingParams.firstName,
            lastName:pagingParams.lastName,
            employeeCode: pagingParams.employeeCode,
            managerName: pagingParams.managerName,
            activated: pagingParams.activated ? pagingParams.activated : '',
            profiles: pagingParams.profiles
        };

        vm.ngModelOpt = { debounce: 200 };

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.setActive = setActive;
        vm.exportAsCsv = exportAsCsv;
        vm.buildQuery = buildQuery;
        vm.transition = transition;
        vm.filterChange = filterChange;

        vm.loadAll();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function exportAsCsv() {
            User.exportAsCsv();
        }

        function loadAll () {
            var query = {
                page: vm.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            };

            query = Object.assign(query, vm.buildQuery());

            User.andCriteria(query, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = data;
                vm.transition();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function transition () {
            $state.go($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                id: vm.filter.id,
                login: vm.filter.login,
                email: vm.filter.email,
                firstName: vm.filter.firstName,
                lastName: vm.filter.lastName,
                employeeCode: vm.filter.employeeCode,
                managerName: vm.filter.managerName,
                activated: vm.filter.activated ? vm.filter.activated : null,
                profiles: vm.filter.profiles
            }, {notify: false});
        }

        function buildQuery() {
            var query = {};
            if (vm.filter.id) {
                query = Object.assign(query, {'id.equals': vm.filter.id});
            }
            if (vm.filter.login) {
                query = Object.assign(query, {'login.contains': vm.filter.login});
            }
            if (vm.filter.email) {
                query = Object.assign(query, {'email.contains': vm.filter.email});
            }
            if (vm.filter.firstName) {
                query = Object.assign(query, {'firstName.contains': vm.filter.firstName});
            }
            if (vm.filter.lastName) {
                query = Object.assign(query, {'lastName.contains': vm.filter.lastName});
            }
            if (vm.filter.employeeCode) {
                query = Object.assign(query, {'employeeCode.contains': vm.filter.employeeCode});
            }
            if (vm.filter.managerName) {
                query = Object.assign(query, {'managerName.contains': vm.filter.managerName});
            }
            if (vm.filter.activated) {
                query = Object.assign(query, {'activated.equals': vm.filter.activated});
            }
            if (vm.filter.profiles) {
                query = Object.assign(query, {'authorities.contains': vm.filter.profiles});
            }

            return query;
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function filterChange() {
            vm.page = 1;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SpvOutletDialogController', SpvOutletDialogController);

    SpvOutletDialogController.$inject = ['$scope', '$state', '$stateParams', '$uibModalInstance', '$uibModal', 'outlets', 'Calendar', 'Outlet', 'TicketOrder'];

    function SpvOutletDialogController ($scope, $state, $stateParams, $uibModalInstance, $uibModal, outlets, Calendar, Outlet, TicketOrder) {
        var vm = this;

        vm.outlets = outlets;
    	vm.reverse = true;
    	vm.predicate = 'outletCode';

        vm.addOutlet = addOutlet;
    	vm.clear = clear;
        vm.deleteOutlet = deleteOutlet;

        function addOutlet() {
            var modalInstance = $uibModal.open({
            	templateUrl: 'app/admin/spv-call-plan-creation/spv-outlet-add-dialog.html',
            	controller: 'SpvOutletAddDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
            	size: 'md',
            	resolve: {
                	outlets: ['Outlet', function(Outlet) {
                        return Outlet.queryBySpv({id: $stateParams.employeeId});
                    }]
            	}
            });

            modalInstance.result.then(function(result) {}, function() {
            	vm.outlets = TicketOrder.queryOutlets({
            		employeeId: $stateParams.employeeId,
            		calendarId : $stateParams.calendarId
            	});
            });
        }

        function deleteOutlet(outlet) {
        	TicketOrder.delete({id: outlet.ticketOrderId}, function(data) {
        		TicketOrder.queryOutlets({
        			employeeId: $stateParams.employeeId,
        			calendarId : $stateParams.calendarId
        		}, function(data) {
        	        vm.outlets = data;
        		});
        	});
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SpvOutletAddDialogController', SpvOutletAddDialogController);

    SpvOutletAddDialogController.$inject = ['$scope', '$state', '$uibModalInstance', '$stateParams', 'outlets', 'AlertService', 'Outlet', 'OutletSearch', 'TicketOrder'];

    function SpvOutletAddDialogController($scope, $state, $uibModalInstance, $stateParams, outlets, AlertService, Outlet, OutletSearch, TicketOrder) {
        var vm = this;

        vm.outlets = outlets;
    	vm.reverse = true;
    	vm.predicate = 'outletCode';
    	
        vm.addOutlet = addOutlet;
    	vm.clear = clear;
    	vm.clearSearch = clearSearch;
        vm.loadAll = loadAll;
        vm.search = search;

    	outlets.$promise.then(function(data) {
    		vm.isLoadAllOutlet = true;
    		
            vm.predicate = 'outletCode';
            vm.page = 1;
            
            vm.loadAll();
    	});
    	
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addOutlet(outlet) {
        	TicketOrder.save({
            	outletId: outlet.id,
            	employeeId: parseInt($stateParams.employeeId),
            	calendarId: parseInt($stateParams.calendarId),
            	flagAsynch: 0,
            	ticketWfStat: 0
        	});
        }

        function loadAll () {
            if (vm.searchQuery) {
                OutletSearch.query({
                    query: vm.searchQuery,
                    page: vm.page - 1,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Outlet.query({
                    page: vm.page - 1,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'outletCode') {
                    result.push('outletCode');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.masterOutlets = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
        
        function clearSearch () {
            vm.page = 1;
            vm.predicate = 'outletCode';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.searchQuery = null;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('spv-call-plan-creation', {
            parent: 'admin',
            url: '/spv-call-plan-creation',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/spv-call-plan-creation/spv-call-plan-creation.html',
                    controller: 'SpvCallPlanCreationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	$translatePartialLoader.addPart('outlet');
                	$translatePartialLoader.addPart('calendar');
                	$translatePartialLoader.addPart('spvCallPlanCreation');
                	$translatePartialLoader.addPart('ticketOrder');
                	$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('spv-call-plan-creation.outlet', {
            parent: 'spv-call-plan-creation',
            url: '/{employeeId}/week/{calendarId}',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'TicketOrder', function($stateParams, $state, $uibModal, TicketOrder) {
                $uibModal.open({
                    templateUrl: 'app/admin/spv-call-plan-creation/spv-outlet-dialog.html',
                    controller: 'SpvOutletDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	outlets: ['TicketOrder', function(TicketOrder) {
                            return TicketOrder.queryOutlets({employeeId: $stateParams.employeeId, calendarId : $stateParams.calendarId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('spv-call-plan-creation', null, { reload: true });
                }, function() {
                    $state.go('spv-call-plan-creation', null, { reload: true });
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SpvCallPlanCreationController', SpvCallPlanCreationController);

    SpvCallPlanCreationController.$inject = ['$rootScope', '$scope', '$state', 'Calendar', 'TicketOrder'];

    function SpvCallPlanCreationController ($rootScope, $scope, $state, Calendar, TicketOrder) {
        var vm = this;
        var monthNow, yearNow;        
		
        vm.getSpvSummaries = getSpvSummaries;
        
		function init() {
			vm.months = Calendar.queryMonths();
			
			monthNow = moment().month() + 1;
			monthNow = monthNow.toString();
			vm.month = monthNow.toString();
			
			yearNow = moment().year();
			vm.years = [yearNow-1, yearNow];
			
			yearNow = yearNow.toString();
			vm.year = yearNow.toString();
			
			getSpvSummaries(yearNow, monthNow);
		}
		init();
		
		function getSpvSummaries(year, month) {
	        TicketOrder.querySpvSummaries({
	        	year: year,
	    		month: month
	        }, function(data) {
	        	vm.spvSummaries = data;
	        });			
		}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pop-fulfillment', {
            parent: 'admin',
            url: '/pop-fulfillment',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.popFulfillment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/pop-fulfillment/pop-fulfillment.html',
                    controller: 'PopFulfillmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pop');
                    $translatePartialLoader.addPart('orderPop');
                    $translatePartialLoader.addPart('popFulfillment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
  'use strict';

  angular
    .module('sceaApp')
    .controller('PopFulfillmentController', PopFulfillmentController);

  PopFulfillmentController.$inject = ['$scope', '$state', '$localStorage', '$filter', 'AlertService', 'OrderPop', 'OrderPopSearch', 'Pop'];

  function PopFulfillmentController ($scope, $state, $localStorage, $filter, AlertService, OrderPop, OrderPopSearch, Pop) {
    var vm = this;

    vm.back = back;
    vm.clearOutletOrder = clearOutletOrder;
    vm.checkStock = checkStock;
    vm.loadMoreOutletOrder = loadMoreOutletOrder;
    vm.next = next;
    vm.save = save;
    vm.searchOutletOrder = searchOutletOrder;
    vm.selectOutletOrder = selectOutletOrder;
    vm.generatePickingList = generatePickingList;

    vm.searchFields = ['code', 'city', 'name'];
    vm.selectField = selectField;

    function init() {
	  vm.today = new Date();
    	
      vm.pageOutletOrders = 1;
      vm.outletOrderPops = [];
      vm.badgeOrders = 0;
      getOutletOrders();

      vm.stocks = {};
    }
    init();

		    
    function selectField(item) {
		vm.selectedField = item;
	}

    function getOutletOrders() {
		if (vm.currentSearch) {
			OrderPopSearch.queryOutlets({
				field : vm.selectedField,
				query : vm.currentSearch,
				page : vm.pageOutletOrders - 1
			}, onSuccess, onError);
		} else {
			OrderPop.queryOutlets({
				page : vm.pageOutletOrders - 1
			}, onSuccess, onError);
		}

		function onSuccess(data, headers) {
			vm.outletOrderPops = data;

			var totalItems = headers('X-Total-Count');

			if (data.length == totalItems) {
				vm.disableLoadOutletOrders = true;
			} else {
				vm.disableLoadOutletOrders = false;
			}
		}

		function onError(error) {
			AlertService.error(error.data.message);
		}
	}

    function searchOutletOrder(value) {
		vm.page = 1;

		if (!vm.selectedField) {
			vm.selectedField = 'name';
		}

		vm.currentSearch = value;

		getOutletOrders();
	}

	function clearOutletOrder() {
		vm.page = 1;
		vm.currentSearch = null;
		vm.searchOrder = null;
		vm.selectedField = null;
		getOutletOrders();
	}

	function loadMoreOutletOrder() {
        vm.disableLoadOutletOrders = true;
        
		OrderPop.queryOutlets({
			page : vm.pageOutletOrders
		}, function(data, headers) {
			angular.forEach(data, function(outletOrder) {
				vm.outletOrderPops.push(outletOrder);
			});
			
			var totalNow = vm.outletOrderPops.length + data.length;
			var totalItems = headers('X-Total-Count');
			
            if(totalNow == totalItems) {
				vm.disableLoadOutletOrders = true;
            } else {
				vm.disableLoadOutletOrders = false;
            }
            
			vm.pageOutletOrders++;
		});
	}

			
    function selectOutletOrder(order) {
		if (order.selected) {
			vm.badgeOrders++;
		} else {
			if (vm.badgeOrders > 0) {
				vm.badgeOrders--;
			}
		}
	}

	function back() {
		vm.active = 0;
		vm.searchPop = '';
		vm.disableLoadOutletOrders = false;
		vm.stocks = {};
	}

	function next() {
		vm.active = 1;
		vm.disableLoadOutletOrders = true;

		getOrders();
	}
		
    function getOrders() {
    	vm.onProcess = true;
    	
    	vm.selectedOutlets = [];
		var outletIds = [];
		angular.forEach(vm.outletOrderPops, function(order) {
			if (order.selected) {
				vm.selectedOutlets.push(order);
				outletIds.push(order.id);
			}
		});

		OrderPop.query({
			status : 'REQUESTED',
			outletIds : outletIds
		}, function(data) {
			angular.forEach(data, function(orderPop) {
		    	vm.onProcess = true;
		    	
				orderPop.sentQty = orderPop.requestQty;
				orderPop.currentRequested = orderPop.sentQty;
				
				Pop.get({
					id : orderPop.popId
				}, function(data) {
					if(data.id) {
						orderPop.containPop = true;
						
						if (!vm.stocks[orderPop.popId]) {
							vm.stocks[orderPop.popId] = data;
							vm.stocks[orderPop.popId].remaining = data.stock - orderPop.sentQty;
						} else {
							vm.stocks[orderPop.popId].remaining -= orderPop.sentQty;
						}
					} else {
						orderPop.containPop = false;
					}

			    	vm.onProcess = false;
				});
			});

			vm.orderPops = data;
		});
	}
    
    function generatePickingList() {
    	angular.forEach(vm.orderPops, function(orderPop) {
			if(vm.stocks[orderPop.popId][orderPop.outletId]) {
				vm.stocks[orderPop.popId][orderPop.outletId] += orderPop.sentQty;
			} else {
				vm.stocks[orderPop.popId][orderPop.outletId] = orderPop.sentQty;
			}
    	});
    	
        var blob = new Blob([document.getElementById('exportable').innerHTML], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        saveAs(blob, "POP Refill.xls");
    }
		
    function checkStock(orderPop) {
    	// is there any stock?
    	if(vm.stocks[orderPop.popId].remaining > 0) {
    		// comparing fulfill qty with request qty
			if (orderPop.sentQty > orderPop.requestQty) {
				orderPop.sentQty = orderPop.requestQty;
			} else if (orderPop.sentQty < 0) {
				orderPop.sentQty = 0;
			}

    		// comparing fulfill qty with stock
			var currentRemaining = vm.stocks[orderPop.popId].remaining + orderPop.currentRequested;
		
			if (orderPop.sentQty > currentRemaining) {
				orderPop.sentQty = currentRemaining;
				
				vm.stocks[orderPop.popId].remaining = 0;
			} else {
				vm.stocks[orderPop.popId].remaining = currentRemaining- orderPop.sentQty;
			}
		
			orderPop.currentRequested = orderPop.sentQty;
    	} else {
    		orderPop.sentQty = 0;
    	}
	}

	function save() {
		for ( var key in vm.stocks) {
			vm.stocks[key].stock = vm.stocks[key].remaining;

			Pop.update(vm.stocks[key]);
		}

		angular.forEach(vm.orderPops, function(orderPop) {
			if (orderPop.sentQty == 0) {
				orderPop.requestStatus = 'NOTSENT';
			} else {
				orderPop.requestStatus = 'SENT';
			}

			OrderPop.update(orderPop, function(data) {
				$state.go('pop-fulfillment', null, {
					reload : true
				});
			});
		});
	}
  }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('sceaApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;

        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('edit-manager', {
            parent: 'admin',
            url: '/edit-manager',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.editManager.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/edit-manager/edit-manager.html',
                    controller: 'EditManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('editManager');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
  'use strict';

  angular
    .module('sceaApp')
    .controller('EditManagerController', EditManagerController);

  EditManagerController.$inject = ['$scope', '$state', '$filter', 'AlertService', 'User', 'UserSearch'];

  function EditManagerController ($scope, $state, $filter, AlertService, User, UserSearch) {
	  var vm = this;
	  
	  vm.searchBy = 'manager';
	  vm.predicate = 'firstName';
	  vm.reverse = true;
	  vm.predicateSelected = 'firstName';
	  vm.reverseSelected = true;
	  vm.isGetUsers = false;
	  vm.dataSearch = [];
	  vm.selectedUsers = [];
	  
	  vm.clear = clear;
	  vm.getNewManager = getNewManager;
	  vm.getUser = getUser;
	  vm.moveUsers = moveUsers;
	  vm.search = search;
      
      vm.selectAll = selectAll;
	  vm.selectUser = selectUser;
	  
	  function search(searchQuery) {
		  var managerId = null;

		  vm.dataSearch = [];
		  
		  if(vm.searchBy == 'manager' && vm.currentUser) {
			  managerId = vm.currentUser.id;  
			  
			  getUsers(0, managerId);
		  }

		  if(vm.searchBy == 'user') {
			  vm.dataSearch.push(vm.currentUser);
		  }
	  }
	  
	  function getUsers(page, managerId) {
		  vm.isGetUsers = true;
		  
          User.query({
        	  page: page,
        	  managerId: managerId,
        	  roleName: 'PC'
          }, function(data, headers) {
        	  angular.forEach(data, function(user) {
        		  user.selected = true;
            	  
        		  vm.dataSearch.push(user);
        	  });

              var users = headers('X-Total-Count');
              var totalNow = vm.dataSearch.length;
              
              if(totalNow != users) {
                  page++;
                  getUsers(page, managerId);
              } else {
        		  vm.isGetUsers = false;
              }
          });
	  }
	  
	  function clear() {
		  vm.searchQuery = null;
		  vm.currentUser = null;
		  vm.dataSearch = [];
	  }

      function getUser(value) {
    	  vm.loadingUser = true;

    	  var roleName;
		  if(vm.searchBy == 'user') {
			  roleName = 'PC';
		  }
		  
    	  return UserSearch.query({
    		  query: value,
    		  roleName: roleName
          }).$promise.then(function(response){
        	  vm.loadingUser = false;

              return response;
          }, function(response){
        	  vm.loadingUser = false;
              AlertService.error(response.data.message);
          });
      }

      function getNewManager(value) {
    	  vm.loadingNewManager = true;
		  
    	  return UserSearch.query({
    		  query: value,
          }).$promise.then(function(response){
        	  vm.loadingNewManager = false;

              return response;
          }, function(response){
        	  vm.loadingNewManager = false;
              AlertService.error(response.data.message);
          });
      }
      
      function selectAll(selectAll) {
    	  var filters = ($filter('filter')(vm.dataSearch, {selected : !selectAll}, true));
    	  
    	  if(filters.length > 0) {
    		  angular.forEach(filters, function(user) {
    			  user.selected = selectAll;
    		  });
    	  }
      }
      
      function selectUser(user) {
		  user.selected = true;
		  
    	  vm.currentUser = user;
      }
      
      function moveUsers() {
    	  var filters1 = ($filter('filter')(vm.dataSearch, {selected : true}, true));

    	  if(filters1.length > 0) {
    		  angular.forEach(filters1, function(user) {
    			  if(vm.selectedUsers.length > 0) {
    				  var filters2 = ($filter('filter')(vm.selectedUsers, {id : user.id}, true));

    				  if(filters2.length == 0) {
    					  vm.selectedUsers.push(user);
    				  }
    			  } else {
    				  vm.selectedUsers.push(user);
    			  }
    		  });
    	  }
      }

      vm.save = save;
      
      function save() {
          vm.isSaving = true;
          
          var users = [];
          angular.forEach(vm.selectedUsers, function(user) {
        	  users.push(user.login);
          });
          
          var userManager = {
    		  managedByUser: vm.newManager.login,
    		  users: users
          }
          
          User.updateManager(userManager, onSaveSuccess, onSaveError);
      }

      var onSaveSuccess = function (result) {
          AlertService.success($filter('translate')('userManagement.updatedManager', {param: result.managedByUser}));
          
          vm.newManager = null;
          vm.selectedUsers = [];
          clear();
          
          vm.isSaving = false;
      }

      var onSaveError = function () {
          vm.isSaving = false;
      }
  }
})();;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DashboardSettingDialogController', DashboardSettingDialogController);

    DashboardSettingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'DashboardSetting'];

    function DashboardSettingDialogController ($timeout, $scope, $uibModalInstance, entity, DashboardSetting) {
        var vm = this;
        vm.dashboardSetting = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:dashboardSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.dashboardSetting.id !== null) {
                DashboardSetting.update(vm.dashboardSetting, onSaveSuccess, onSaveError);
            } else {
                DashboardSetting.save(vm.dashboardSetting, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DashboardDetailController', DashboardDetailController);

    DashboardDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function DashboardDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.dashboardSetting = entity;

        var unsubscribe = $rootScope.$on('sceaApp:dashboardSettingUpdate', function(event, result) {
            vm.dashboardSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DashboardSettingDeleteController',DashboardSettingDeleteController);

    DashboardSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'DashboardSetting'];

    function DashboardSettingDeleteController($uibModalInstance, entity, DashboardSetting) {
        var vm = this;
        vm.dashboardSetting = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            DashboardSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dashboard-setting', {
            parent: 'admin',
            url: '/dashboard-setting?page&sort&search&roleName',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'dashboardSetting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/dashboard-setting/dashboard-setting.html',
                    controller: 'DashboardSettingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard-setting');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard-setting-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'dashboardSetting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/dashboard-setting/dashboard-setting-detail.html',
                    controller: 'DashboardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard-setting');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard-setting.new', {
            parent: 'dashboard-setting',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/dashboard-setting/dashboard-setting-dialog.html',
                    controller: 'DashboardSettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                title: null,
                                url: null,
                                secretKey: null,
                                metabasePayload: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dashboard-setting', null, { reload: true });
                }, function() {
                    $state.go('dashboard-setting');
                });
            }]
        })
        .state('dashboard-setting.edit', {
            parent: 'dashboard-setting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/dashboard-setting/dashboard-setting-dialog.html',
                    controller: 'DashboardSettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DashboardSetting', function(DashboardSetting) {
                            return DashboardSetting.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboard-setting', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dashboard-setting.delete', {
            parent: 'dashboard-setting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/dashboard-setting/dashboard-setting-delete-dialog.html',
                    controller: 'DashboardSettingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DashboardSetting', function(DashboardSetting) {
                            return DashboardSetting.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboard-setting', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('DashboardSetting', DashboardSetting);

    DashboardSetting.$inject = ['$resource'];

    function DashboardSetting ($resource) {
        var resourceUrl = 'api/dashboard-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'metabaseEmbeddedUrl': {
                url: 'api/dashboard-settings/embedded-url',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('DashboardSettingSearch', DashboardSettingSearch);

    DashboardSettingSearch.$inject = ['$resource'];

    function DashboardSettingSearch($resource) {
        var resourceUrl =  'api/_search/dashboard-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('DashboardSettingController', DashboardSettingController);

    DashboardSettingController.$inject = ['$scope', '$state', 'DashboardSetting', 'DashboardSettingSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DashboardSettingController ($scope, $state, DashboardSetting, DashboardSettingSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DashboardSettingSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DashboardSetting.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dashboardSettings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApplicationSettingDialogController', ApplicationSettingDialogController);

    ApplicationSettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationSetting'];

    function ApplicationSettingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationSetting) {
        var vm = this;
        vm.applicationSetting = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sceaApp:applicationSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.applicationSetting.id !== null) {
                ApplicationSetting.update(vm.applicationSetting, onSaveSuccess, onSaveError);
            } else {
                ApplicationSetting.save(vm.applicationSetting, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApplicationSettingDetailController', ApplicationSettingDetailController);

    ApplicationSettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationSetting'];

    function ApplicationSettingDetailController($scope, $rootScope, $stateParams, entity, ApplicationSetting) {
        var vm = this;
        vm.applicationSetting = entity;
        
        var unsubscribe = $rootScope.$on('sceaApp:applicationSettingUpdate', function(event, result) {
            vm.applicationSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApplicationSettingDeleteController',ApplicationSettingDeleteController);

    ApplicationSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationSetting'];

    function ApplicationSettingDeleteController($uibModalInstance, entity, ApplicationSetting) {
        var vm = this;
        vm.applicationSetting = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ApplicationSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-setting', {
            parent: 'admin',
            url: '/application-setting',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.applicationSetting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/application-setting/application-settings.html',
                    controller: 'ApplicationSettingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationSetting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ApplicationSetting', ApplicationSetting);

    ApplicationSetting.$inject = ['$resource'];

    function ApplicationSetting ($resource) {
        var resourceUrl =  'api/application-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByKey': {
            	url: 'api/application-settings/:key',
            	method: 'GET'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .factory('ApplicationSettingSearch', ApplicationSettingSearch);

    ApplicationSettingSearch.$inject = ['$resource'];

    function ApplicationSettingSearch($resource) {
        var resourceUrl =  'api/_search/application-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApplicationSettingController', ApplicationSettingController);

    ApplicationSettingController.$inject = ['$scope', '$state', '$filter', 'ApplicationSetting'];

    function ApplicationSettingController ($scope, $state, $filter, ApplicationSetting) {
        var vm = this;

        vm.checkValidDate = checkValidDate;
        vm.updateOutletRadius = updateOutletRadius;
    	vm.updatePcFormSetting = updatePcFormSetting;
    	vm.updateBirtViewerAddress = updateBirtViewerAddress;
    	vm.updateActiveRetailMappingPeriodFrom = updateActiveRetailMappingPeriodFrom;
    	vm.updateActiveRetailMappingPeriodTo = updateActiveRetailMappingPeriodTo;

    	initPcFormSetting();
    	initOutletRadius();
    	initBirtViewerAddress();
    	initActiveRetailMappingPeriod();

    	function initPcFormSetting() {
    		ApplicationSetting.queryByKey({
    			key: 'PC_INPUT_FORM'
    		}, function(data) {
    			vm.pcFormSetting = data;
    			var result = data.value.split(",");

    			angular.forEach(result, function(value) {
    				if(value == 'POP') {
    			    	vm.pop = true;
    				}
    				if(value == 'FIXTURE') {
    					vm.fixture = true;
    				}
    				if(value == 'EQUIPMENT') {
    					vm.equipment = true;
    				}
    				if(value == 'INTERNET') {
    					vm.internet = true;
    				}
    				if(value == 'PHOTO') {
    					vm.photo = true;
    				}
    			});
    		});
    	}

    	function updatePcFormSetting() {
    		var values = '';

    		if(vm.pop) values += 'POP,';
    		if(vm.fixture) values += 'FIXTURE,';
    		if(vm.equipment) values += 'EQUIPMENT,';
    		if(vm.internet) values += 'INTERNET,';
    		if(vm.photo) values += 'PHOTO,';

    		values = values.substring(0, values.length-1);
    		vm.pcFormSetting.value = values;

    		if(values.length > 0) {
        		ApplicationSetting.update(vm.pcFormSetting);
    		} else {
    			initPcFormSetting();
    		}
    	}

    	function initOutletRadius() {
    		ApplicationSetting.queryByKey({
    			key: 'VISIT_VAL_BY_RAD_INMETER'
    		}, function(data) {
    			vm.outletRadius = data;
    			vm.radius = parseFloat(data.value);
    		});
    	}

    	function updateOutletRadius() {
    		vm.outletRadius.value = vm.radius.toString();

    		ApplicationSetting.update(vm.outletRadius);
    	}

    	function initActiveRetailMappingPeriod() {
    		ApplicationSetting.queryByKey({
    			key: 'ACTIVE_RETAIL_MAPPING_FROM'
    		}, function(data) {
    			vm.activeRetailMappingFrom = data;
    			vm.rmFrom = moment(data.value, 'DD/MM/YYYY').toDate();
    		});
            ApplicationSetting.queryByKey({
                 key: 'ACTIVE_RETAIL_MAPPING_TO'
            }, function(data) {
                 vm.activeRetailMappingTo = data;
                 vm.rmTo = moment(data.value, 'DD/MM/YYYY').toDate();
            });
    	}

        function updateActiveRetailMappingPeriodFrom() {
     		vm.activeRetailMappingFrom.value = moment(vm.rmFrom).format('DD/MM/YYYY');
     		ApplicationSetting.update(vm.activeRetailMappingFrom);
     	}

        function updateActiveRetailMappingPeriodTo() {
            vm.activeRetailMappingTo.value = moment(vm.rmTo).format('DD/MM/YYYY');
            ApplicationSetting.update(vm.activeRetailMappingTo);
        }

    	function initBirtViewerAddress() {
    		vm.invalidDate = false;
    		
    		ApplicationSetting.queryByKey({
    			key: 'BIRT_VIEWER_ADDRESS'
    		}, function(data) {
    			vm.birtViewerAddress = data;
    		}, function() {
    			vm.birtViewerAddress = {
    				id: null,
    				key: 'BIRT_VIEWER_ADDRESS',
    				value: null
    			}
    		});
    	}

		vm.datePickerOpenStatus = {};
		vm.datePickerOpenStatus.fromDate = false;
		vm.datePickerOpenStatus.toDate = false;

		vm.openCalendar = function(date) {
			vm.datePickerOpenStatus[date] = true;
		};
        
        function checkValidDate(datePicker) {
        	if(vm.rmFrom != null && vm.rmTo != null) {
            	var isValid = moment(vm.rmTo).isAfter(vm.rmFrom);
            	if(isValid) {
            		vm.invalidDate = false;
            		
            		if(datePicker == 'from') {
            			updateActiveRetailMappingPeriodFrom();
            		}
            		if(datePicker == 'to') {
            			updateActiveRetailMappingPeriodTo();
            		}
            	} else {
            		vm.invalidDate = true;
            	}        		
        	}
        }

    	function updateBirtViewerAddress() {
    		if(vm.birtViewerAddress.id !== null) {
    			ApplicationSetting.update(vm.birtViewerAddress);
    		} else {
    			ApplicationSetting.save(vm.birtViewerAddress);
    		}
    	}
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApiKeyDialogController', ApiKeyDialogController);

    ApiKeyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApiKey'];

    function ApiKeyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApiKey) {
        var vm = this;

        vm.apiKey = entity;
        vm.clear = clear;
        vm.save = save;
        vm.editMode = true;
        vm.generatingToken = false;
        vm.generateToken = generateToken;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();


            vm.editMode = false;
            (function(){
                if (entity.name != null) {
                    vm.editMode = true;
                }

                if (!vm.editMode) {
                    vm.generateToken();
                }
            })();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.apiKey.id !== null) {
                ApiKey.update(vm.apiKey, onSaveSuccess, onSaveError);
            } else {
                ApiKey.save(vm.apiKey, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sceaApp:apiKeyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function generateToken () {
            vm.generatingToken = true
            ApiKey.generateToken().then(function(response){
                vm.apiKey.token = response.data;
                vm.generatingToken = false;
            }, function(error){
                vm.generatingToken = false;
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApiKeyDetailController', ApiKeyDetailController);

    ApiKeyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ApiKey'];

    function ApiKeyDetailController($scope, $rootScope, $stateParams, previousState, entity, ApiKey) {
        var vm = this;

        vm.apiKey = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sceaApp:apiKeyUpdate', function(event, result) {
            vm.apiKey = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApiKeyDeleteController',ApiKeyDeleteController);

    ApiKeyDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApiKey'];

    function ApiKeyDeleteController($uibModalInstance, entity, ApiKey) {
        var vm = this;

        vm.apiKey = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApiKey.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('api-key', {
            parent: 'admin',
            url: '/api-key?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.apiKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/api-key/api-keys.html',
                    controller: 'ApiKeyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('apiKey');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('api-key-detail', {
            parent: 'api-key',
            url: '/api-key/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'sceaApp.apiKey.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/api-key/api-key-detail.html',
                    controller: 'ApiKeyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('apiKey');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApiKey', function($stateParams, ApiKey) {
                    return ApiKey.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'api-key',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('api-key-detail.edit', {
            parent: 'api-key-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/api-key/api-key-dialog.html',
                    controller: 'ApiKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApiKey', function(ApiKey) {
                            return ApiKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('api-key.new', {
            parent: 'api-key',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/api-key/api-key-dialog.html',
                    controller: 'ApiKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                token: null,
                                active: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('api-key', null, { reload: 'api-key' });
                }, function() {
                    $state.go('api-key');
                });
            }]
        })
        .state('api-key.delete', {
            parent: 'api-key',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/api-key/api-key-delete-dialog.html',
                    controller: 'ApiKeyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApiKey', function(ApiKey) {
                            return ApiKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('api-key', null, { reload: 'api-key' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('sceaApp')
        .factory('ApiKey', ApiKey);

    ApiKey.$inject = ['$resource', '$http'];

    function ApiKey ($resource, $http) {
        var resourceUrl =  'api/api-keys/:id';

        var res = $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return {
            query: res.query,
            get: res.get,
            update: res.update,
            delete: res.delete,
            generateToken: function() {
                return $http.get('api/api-keys/token-generation');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ApiKeyController', ApiKeyController);

    ApiKeyController.$inject = ['$state', 'ApiKey', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ApiKeyController($state, ApiKey, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.setActive = setActive;

        loadAll();

        function loadAll () {
            ApiKey.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'name') {
                    result.push('name');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.apiKeys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'name';
            vm.reverse = true;
            vm.transition();
        }

        function setActive(apiKey, active) {
            apiKey.active = active;
            ApiKey.update(apiKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'PC', 'VDO', 'VDE'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
//(function() {
//    'use strict';
//
//    angular
//        .module('sceaApp')
//        .config(stateConfig);
//
//    stateConfig.$inject = ['$stateProvider'];
//
//    function stateConfig($stateProvider) {
//        $stateProvider.state('register', {
//            parent: 'account',
//            url: '/register',
//            data: {
//                authorities: [],
//                pageTitle: 'register.title'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/account/register/register.html',
//                    controller: 'RegisterController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                    $translatePartialLoader.addPart('register');
//                    return $translate.refresh();
//                }]
//            }
//        });
//    }
//})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_ADMIN', 'ARCO', 'SPV', 'PC', 'VDO', 'VDE'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('sceaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("sceaApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<div ng-cloak><div ng-switch=\"vm.isAuthenticated()\"><div ng-switch-when=\"false\"><div class=\"row\"><div class=\"col-md-offset-4 col-md-8\"><h1 translate=\"home.title\">Welcome to Scea</h1><p class=\"lead\" translate=\"home.subtitle\">Samsung Consumer Electronics Automation</p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a> to continue to Scea</div></div></div></div></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"settings.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"settings.messages.error.fail\"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/admin/api-key/api-key-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.apiKey.name)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"sceaApp.apiKey.delete.question\" translate-values=\"{id: \'{{vm.apiKey.name}}\'}\">Are you sure you want to delete this Api Key?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/api-key/api-key-detail.html","<div><h2><span data-translate=\"sceaApp.apiKey.detail.title\">Api Key</span> {{vm.apiKey.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"sceaApp.apiKey.name\">Name</span></dt><dd><span>{{vm.apiKey.name}}</span></dd><dt><span data-translate=\"sceaApp.apiKey.token\">Token</span></dt><dd><span>{{vm.apiKey.token}}</span></dd><dt><span data-translate=\"sceaApp.apiKey.active\">Active</span></dt><dd><span>{{vm.apiKey.active}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/api-key/api-key-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApiKeyLabel\" data-translate=\"sceaApp.apiKey.home.createOrEditLabel\">Create or edit a Api Key</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.apiKey.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.apiKey.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.apiKey.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.apiKey.name\" ng-disabled=\"vm.editMode\" required ng-minlength=\"1\" ng-maxlength=\"20\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.minlength\" data-translate=\"entity.validation.minlength\" translate-value-min=\"1\">This field is required to be at least 1 characters.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"20\">This field cannot be longer than 20 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.apiKey.token\" for=\"field_token\">Token</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"token\" id=\"field_token\" ng-model=\"vm.apiKey.token\" disabled=\"disabled\" required><div class=\"input-group-addon\"><button type=\"button\" class=\"btn btn-xs btn-block\" ng-click=\"vm.generateToken()\" data-translate=\"sceaApp.apiKey.generateToken\">Generate</button></div></div><div ng-show=\"editForm.token.$invalid\"><p class=\"help-block\" ng-show=\"editForm.token.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/api-key/api-keys.html","<div><h2 data-translate=\"sceaApp.apiKey.home.title\">Api Keys</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"api-key.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs-down\" data-translate=\"sceaApp.apiKey.home.createLabel\">Create new Api Key</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"name\"><span data-translate=\"sceaApp.apiKey.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"token\"><span data-translate=\"sceaApp.apiKey.token\">Token</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"active\"><span data-translate=\"sceaApp.apiKey.active\">Active</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"apiKey in vm.apiKeys track by apiKey.name\"><td>{{apiKey.name}}</td><td>{{apiKey.token}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(apiKey, true)\" ng-show=\"!apiKey.active\" translate=\"sceaApp.apiKey.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(apiKey, false)\" ng-show=\"apiKey.active\" translate=\"sceaApp.apiKey.activated\" style=\"cursor: pointer\">Activated</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"api-key-detail({id:apiKey.name})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"api-key.delete({id:apiKey.name})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'d MMMM y\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/application-setting/application-setting-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.applicationSetting.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.applicationSetting.delete.question\" translate-values=\"{id: \'{{vm.applicationSetting.id}}\'}\">Are you sure you want to delete this Application Setting?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/application-setting/application-setting-detail.html","<div><h2><span translate=\"sceaApp.applicationSetting.detail.title\">Application Setting</span> {{vm.applicationSetting.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.applicationSetting.key\">Key</span></dt><dd><span>{{vm.applicationSetting.key}}</span></dd><dt><span translate=\"sceaApp.applicationSetting.value\">Value</span></dt><dd><span>{{vm.applicationSetting.value}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/application-setting/application-setting-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myApplicationSettingLabel\" translate=\"sceaApp.applicationSetting.home.createOrEditLabel\">Create or edit a Application Setting</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.applicationSetting.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.applicationSetting.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.applicationSetting.key\" for=\"field_key\">Key</label><input type=\"text\" class=\"form-control\" name=\"key\" id=\"field_key\" ng-model=\"vm.applicationSetting.key\" required><div ng-show=\"editForm.key.$invalid\"><p class=\"help-block\" ng-show=\"editForm.key.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.applicationSetting.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.applicationSetting.value\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/application-setting/application-settings.html","<div><h2 translate=\"sceaApp.applicationSetting.home.title\">Application Settings</h2><!-- <jhi-alert></jhi-alert> --><br><uib-accordion close-others=\"true\"><div uib-accordion-group class=\"panel-primary\" is-open=\"isOpen1\"><uib-accordion-heading><span translate=\"sceaApp.applicationSetting.pcFormSetting.title\">PC Form Setting</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isOpen1, \'glyphicon-chevron-right\': !isOpen1}\"></i></uib-accordion-heading><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.pop\" ng-change=\"vm.updatePcFormSetting()\"> <span translate=\"sceaApp.applicationSetting.pcFormSetting.POP\"></span></label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.fixture\" ng-change=\"vm.updatePcFormSetting()\"> <span translate=\"sceaApp.applicationSetting.pcFormSetting.FIXTURE\"></span></label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.equipment\" ng-change=\"vm.updatePcFormSetting()\"> <span translate=\"sceaApp.applicationSetting.pcFormSetting.EQUIPMENT\"></span></label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.internet\" ng-change=\"vm.updatePcFormSetting()\"> <span translate=\"sceaApp.applicationSetting.pcFormSetting.INTERNET\"></span></label></div><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.photo\" ng-change=\"vm.updatePcFormSetting()\"> <span translate=\"sceaApp.applicationSetting.pcFormSetting.PHOTO\"></span></label></div></div><div uib-accordion-group class=\"panel-primary\" is-open=\"isOpen2\"><uib-accordion-heading><span translate=\"sceaApp.applicationSetting.outletRadius.title\">Radius visit validation</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isOpen2, \'glyphicon-chevron-right\': !isOpen2}\"></i></uib-accordion-heading><div class=\"form-inline\"><div class=\"form-group\"><label>Radius</label>&nbsp; <input type=\"number\" class=\"form-control\" step=\"0.1\" ng-model=\"vm.radius\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.updateOutletRadius()\">&nbsp; <span>In Meter</span></div></div></div><div uib-accordion-group class=\"panel-primary\" is-open=\"isOpen4\"><uib-accordion-heading><span translate=\"sceaApp.applicationSetting.activeRetailMappingPeriod.title\">Active Retail Mapping Period</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isOpen4, \'glyphicon-chevron-right\': !isOpen4}\"></i></uib-accordion-heading><div class=\"row\"><div class=\"col-xs-4\"><label>From</label>&nbsp;<div class=\"input-group\"><input id=\"field_fromDate\" type=\"text\" class=\"form-control\" name=\"fromDate\" uib-datepicker-popup=\"d MMMM y\" ng-model=\"vm.rmFrom\" is-open=\"vm.datePickerOpenStatus.fromDate\" ng-change=\"vm.checkValidDate(\'from\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'fromDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-4\"><label>To</label>&nbsp;<div class=\"input-group\"><input id=\"field_toDate\" type=\"text\" class=\"form-control\" name=\"toDate\" uib-datepicker-popup=\"d MMMM y\" ng-model=\"vm.rmTo\" is-open=\"vm.datePickerOpenStatus.toDate\" ng-change=\"vm.checkValidDate(\'to\')\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'toDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div ng-show=\"vm.invalidDate\"><p class=\"text-danger\" style=\"margin-top: 10px\" data-translate=\"entity.validation.datefromuntil\">End Date should be greater than start date</p></div></div><div uib-accordion-group class=\"panel-primary\" is-open=\"isOpen3\"><uib-accordion-heading><span translate=\"sceaApp.applicationSetting.birtViewerAddress.title\">Birt Viewer Address</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isOpen3, \'glyphicon-chevron-right\': !isOpen3}\"></i></uib-accordion-heading><div class=\"form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.birtViewerAddress.value\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.updateBirtViewerAddress()\"></div></div></uib-accordion></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/dashboard-setting/dashboard-setting-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.dashboardSetting.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"dashboardSetting.delete.question\" translate-values=\"{id: \'{{vm.dashboardSetting.id}}\'}\">Are you sure you want to delete this Dashboard Setting?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/dashboard-setting/dashboard-setting-detail.html","<div><h2><span translate=\"dashboardSetting.detail.title\">Dashboard Setting</span> {{vm.dashboardSetting.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"dashboardSetting.title\">Title</span></dt><dd><span>{{vm.dashboardSetting.title}}</span></dd><dt><span translate=\"dashboardSetting.url\">Url</span></dt><dd><span>{{vm.dashboardSetting.url}}</span></dd><dt><span translate=\"dashboardSetting.secretKey\">Secret Key</span></dt><dd><span>{{vm.dashboardSetting.secretKey}}</span></dd><dt><span translate=\"dashboardSetting.metabasePayload\">Metabase Payload</span></dt><dd><span>{{vm.dashboardSetting.metabasePayload}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/dashboard-setting/dashboard-setting-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBrandLabel\" translate=\"dashboardSetting.home.createOrEditLabel\">Create or edit a Dashboard Setting</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.dashboardSetting.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.dashboardSetting.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"dashboardSetting.title\" for=\"field_title\">Brand Name</label><input type=\"text\" class=\"form-control\" name=\"title\" id=\"field_title\" ng-model=\"vm.dashboardSetting.title\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"dashboardSetting.url\" for=\"field_url\">Url</label><input type=\"text\" class=\"form-control\" name=\"url\" id=\"field_url\" ng-model=\"vm.dashboardSetting.url\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"dashboardSetting.secretKey\" for=\"field_secretKey\">Secret Key</label><input type=\"text\" class=\"form-control\" name=\"secretKey\" id=\"field_secretKey\" ng-model=\"vm.dashboardSetting.secretKey\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"dashboardSetting.metabasePayload\" for=\"field_metabasePayload\">Metabase Payload</label><input type=\"text\" class=\"form-control\" name=\"metabasePayload\" id=\"field_metabasePayload\" ng-model=\"vm.dashboardSetting.metabasePayload\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/dashboard-setting/dashboard-setting.html","<div><h2 translate=\"dashboardSetting.home.title\">Dashboard Setting</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"dashboard-setting.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"dashboardSetting.home.createLabel\">Create new Dashboard Setting</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'dashboardSetting.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"title\"><span translate=\"dashboardSetting.title\">Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"url\"><span translate=\"dashboardSetting.url\">Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"secretKey\"><span translate=\"dashboardSetting.secretKey\">Secret Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"metabasePayload\"><span translate=\"dashboardSetting.metabasePayload\">Metabase Payload</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"dashboardSetting in vm.dashboardSettings track by dashboardSetting.id\"><td><a ui-sref=\"dashboard-setting-detail({id:dashboardSetting.id})\">{{dashboardSetting.id}}</a></td><td>{{dashboardSetting.title}}</td><td>{{dashboardSetting.url}}</td><td>{{dashboardSetting.secretKey}}</td><td>{{dashboardSetting.metabasePayload}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"dashboard-setting-detail({id:dashboardSetting.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"dashboard-setting.edit({id:dashboardSetting.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"dashboard-setting.delete({id:dashboardSetting.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html","<form name=\"reindexForm\" ng-submit=\"vm.confirmReindex()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"elasticsearch.reindex.dialog.title\">Confirm reindex operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"elasticsearch.reindex.dialog.question\">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span data-translate=\"elasticsearch.reindex.dialog.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span>&nbsp; <span data-translate=\"elasticsearch.reindex.dialog.confirm\">Reindex</span></button></div></form>");
$templateCache.put("app/admin/elasticsearch-reindex/elasticsearch-reindex.html","<div class=\"clearfix\"><h1 data-translate=\"elasticsearch.reindex.title\">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate=\"elasticsearch.reindex.instructions1\">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see \"Elasticsearch: Successfully performed reindexing\" in your logs when this is complete.</p><p data-translate=\"elasticsearch.reindex.instructions2\">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type=\"button\" class=\"btn btn-primary pull-right\" ui-sref=\"elasticsearch-reindex.dialog\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span> <span data-translate=\"elasticsearch.reindex.go\">Go</span></button></div>");
$templateCache.put("app/admin/edit-manager/edit-manager.html","<div><h2 translate=\"sceaApp.editManager.home.title\"></h2><jhi-alert></jhi-alert><div class=\"container-fluid no-padding-right no-padding-left\"><div class=\"col-xs-6\" style=\"width: 47%\"><div class=\"row\"><label class=\"col-xs-5 form-control-static\"><span data-translate=\"sceaApp.editManager.searchBy\"></span></label><div class=\"col-xs-7\"><select class=\"form-control input-sm\" ng-model=\"vm.searchBy\" ng-change=\"vm.clear()\"><option value=\"manager\" data-translate=\"sceaApp.editManager.manager\"></option><option value=\"user\" data-translate=\"sceaApp.editManager.user\"></option></select></div></div><div class=\"form-group\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" ng-if=\"vm.searchBy == \'manager\'\" placeholder=\"{{ \'sceaApp.editManager.home.searchByManager\' | translate }}\" uib-typeahead=\"user as user.firstName +\' \'+ user.lastName for user in vm.getUser($viewValue)\" typeahead-on-select=\"vm.selectUser($item)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-min-length=\"1\" autocomplete=\"off\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" ng-if=\"vm.searchBy == \'user\'\" placeholder=\"{{ \'sceaApp.editManager.home.searchByUser\' | translate }}\" uib-typeahead=\"user as user.firstName +\' \'+ user.lastName for user in vm.getUser($viewValue)\" typeahead-on-select=\"vm.selectUser($item)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-min-length=\"1\" autocomplete=\"off\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\" ng-disabled=\"!vm.currentUser\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentUser\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\" ng-disabled=\"vm.isGetUsers\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div><hr class=\"custom-hr\"><div class=\"custom-grid\"><table class=\"jh-table table\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th class=\"col-xs-1\"><input type=\"checkbox\" style=\"outline: none\" ng-model=\"selectAll\" ng-init=\"selectAll = true\" ng-click=\"vm.selectAll(selectAll)\" ng-disabled=\"vm.isGetUsers || vm.dataSearch.length == 0\"></th><th class=\"col-xs-6 text-center\" jh-sort-by=\"firstName\"><span translate=\"userManagement.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-5 text-center\" jh-sort-by=\"lastName\"><span translate=\"userManagement.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead></table><div style=\"max-height: 500px; overflow: auto\"><div class=\"row\" ng-repeat=\"data in vm.dataSearch | orderBy : vm.predicate : !vm.reverse\"><div class=\"col-xs-1 text-center\" style=\"padding: 7px 0 5px 0\"><input type=\"checkbox\" style=\"outline: none\" ng-model=\"data.selected\"></div><div class=\"col-xs-6 text-center\" style=\"padding: 10px 0 5px 0\">{{data.firstName ? data.firstName : \'-\'}}</div><div class=\"col-xs-5 text-center\" style=\"padding: 10px 0 5px 0\">{{data.lastName ? data.lastName : \'-\'}}</div></div></div></div></div><div class=\"col-xs-1 text-center\" style=\"width: 6%; padding: 0; padding-top: 100px\"><div style=\"margin-bottom: 10px\"><button class=\"btn btn-default\" ng-click=\"vm.moveUsers()\" ng-disabled=\"vm.isGetUsers || vm.dataSearch.length == 0\"><span class=\"glyphicon glyphicon-chevron-right\"></span></button></div><div><button class=\"btn btn-default\" ng-click=\"vm.selectedUsers = []\" ng-disabled=\"vm.selectedUsers.length == 0\"><span class=\"glyphicon glyphicon-erase\"></span></button></div></div><div class=\"col-xs-5\" style=\"width: 47%\"><div class=\"row\" style=\"margin: 0\"><div class=\"form-group col-xs-9 no-padding-left no-padding-right\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.newManager\" placeholder=\"{{ \'sceaApp.editManager.home.searchNewManager\' | translate }}\" uib-typeahead=\"user as user.firstName +\' \'+ user.lastName for user in vm.getNewManager($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingNewManager\" typeahead-min-length=\"1\" autocomplete=\"off\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.newManager = null\" ng-disabled=\"!vm.newManager\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></div><div class=\"col-xs-3 no-padding-right text-right\"><button class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-disabled=\"!vm.newManager || vm.isSaving || vm.isGetUsers || vm.selectedUsers.length == 0\"><span class=\"glyphicon glyphicon-save\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.save\"></span></button></div></div><div class=\"custom-grid\"><table class=\"jh-table table\"><thead><tr jh-sort=\"vm.predicateSelected\" ascending=\"vm.reverseSelected\"><th class=\"col-xs-6 text-center\" jh-sort-by=\"firstName\"><span translate=\"userManagement.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-6 text-center\" jh-sort-by=\"lastName\"><span translate=\"userManagement.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead></table><div style=\"max-height: 548px; overflow: auto\"><div class=\"row\" ng-repeat=\"user in vm.selectedUsers | orderBy : vm.predicateSelected : !vm.reverseSelected\"><div class=\"col-xs-6 text-center\" style=\"padding: 10px 0 5px 0\">{{user.firstName ? user.firstName : \'-\'}}</div><div class=\"col-xs-6 text-center\" style=\"padding: 10px 0 5px 0\">{{user.lastName ? user.lastName : \'-\'}}</div></div></div></div></div></div></div>");
$templateCache.put("app/admin/entity-audit/entity-audit.detail.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Audit Details</h4></div><div class=\"modal-body pad\"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class=\"diff diff-key\">Old/Removed value</del> &nbsp; <ins class=\"diff diff-key\">New/Added value</ins></div><br><label>Changed Fields</label><pre id=\"resultChanges\" ng-bind-html=\"vm.diffValueChanges\"></pre><label>All Fields</label><pre id=\"result\" ng-bind-html=\"vm.diffValue\"></pre></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/entity-audit/entity-audits.html","<div ng-cloak class=\"pad\"><div class=\"row\"><h3 class=\"col-sm-12\">Entity Audits</h3></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 pad\"><h4>Filter</h4><form name=\"auditForm\" role=\"form\" novalidate show-validation><div class=\"row\"><div class=\"col-md-8 form-group\"><label>Entity/Table</label><select class=\"input-sm form-control\" name=\"qualifiedName\" id=\"qualifiedName\" required ng-options=\"vm.getEntityName(entity) for entity in vm.entities\" ng-model=\"vm.qualifiedName\"></select><div ng-show=\"auditForm.qualifiedName.$invalid\"><p class=\"help-block\" ng-show=\"auditForm.qualifiedName.$error.required\">This field is required</p></div></div><div class=\"col-md-4 form-group\"><label>Limit to</label><select class=\"input-sm form-control\" name=\"limit\" id=\"limit\" required ng-options=\"option for option in vm.limits\" ng-model=\"vm.limit\"></select></div></div><div class=\"row pad\"><button ng-disabled=\"auditForm.$invalid\" class=\"btn btn-primary pull-right\" ng-click=\"vm.loadChanges()\"><i class=\"glyphicon glyphicon-import\"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show=\"!vm.loading\"><div class=\"table-responsive\" ng-if=\"vm.audits.length > 0\"><p ng-if=\"vm.qualifiedName\">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class=\"form-inline\"><div class=\"form-group\"><label for=\"searchField\">Filter:</label><input type=\"text\" class=\"form-control\" id=\"searchField\" ng-model=\"filter.$\" placeholder=\"global filter\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"searchFieldEntityId\" ng-model=\"filter.entityId\" placeholder=\"entity id filter\"></div></form><table class=\"table table-bordered table-hover table-striped\"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class=\"glyphicon glyphicon-eye-open\"></i></th></tr></thead><tbody><tr ng-repeat=\"audit in vm.audits | filter:filter\"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class=\"audit-obj\" ng-bind-html=\"vm.format(audit.entityValue)\"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class=\"no-pad\">\n                        <div class=\"audit-obj\">\n                            <table class=\"table table-bordered table-hover no-margin\">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                                <tr ng-repeat=\"(k,v) in audit.entityValue\" ng-if=\"!vm.isObject(v)\">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if=\"vm.isDate(k)\">{{v | date:\'medium\'}}</span>\n                                        <span ng-if=\"!vm.isDate(k)\">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type=\"button\" ng-click=\"vm.openChange(audit)\" uib-tooltip=\"View Audit Change Details\" uib-tooltip-placement=\"auto\" class=\"btn btn-info btn-xs\"><i class=\"glyphicon glyphicon-eye-open\"></i></button></td></tr></tbody></table></div><p ng-if=\"vm.displayedChanges.length == 0\">No Data found for the filters</p></div></div>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/pop-fulfillment/pop-fulfillment.html","<div><h2 translate=\"sceaApp.popFulfillment.home.title\">POP Fulfillment</h2><jhi-alert></jhi-alert><uib-tabset active=\"vm.active\"><uib-tab index=\"0\" disable=\"true\"><uib-tab-heading><span translate=\"sceaApp.popFulfillment.orders\">Orders</span> <span class=\"badge\">{{vm.badgeOrders}}</span></uib-tab-heading><div class=\"uib-tab-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-left\"><div class=\"input-group\"><div class=\"input-group-btn\"><button class=\"btn btn-secondary dropdown-toggle\" data-toggle=\"dropdown\"><span ng-if=\"!vm.selectedField\">CODE/CITY/NAME</span>{{vm.selectedField | uppercase}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"field in vm.searchFields\"><a ng-click=\"vm.selectField(field)\" class=\"dropdown-item\">{{field | uppercase}}</a></li></ul></div><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchOrder\" id=\"searchQuery1\" placeholder=\"{{ \'sceaApp.popFulfillment.home.searchOrder\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.searchOutletOrder(vm.searchOrder)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clearOutletOrder()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></div><div class=\"col-xs-4 no-padding-right\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.next()\" ng-disabled=\"vm.badgeOrders == 0\"><span class=\"glyphicon glyphicon-arrow-right\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.next\">Next</span></button></div></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th></th><th class=\"text-center\" jh-sort-by=\"outletCode\"><span translate=\"sceaApp.popFulfillment.shopCode\">Shop Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"outletName\"><span translate=\"sceaApp.popFulfillment.shopName\">Shop Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"areaName\"><span translate=\"sceaApp.popFulfillment.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"perfectStoreStatus\"><span translate=\"sceaApp.popFulfillment.perfectStore\">Perfect Store</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"pcStatus\"><span translate=\"sceaApp.popFulfillment.pc\">PC</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"risStatus\"><span translate=\"sceaApp.popFulfillment.ris\">RIS</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"text-center\" jh-sort-by=\"visitCycleStoreGrade\"><span translate=\"sceaApp.popFulfillment.grade\">Grade</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody infinite-scroll=\"vm.loadMoreOutletOrder()\" infinite-scroll-disabled=\"vm.disableLoadOutletOrders\" infinite-scroll-distance=\"\" infinite-scroll-immediate-check=\"false\"><tr class=\"text-center\" ng-repeat=\"outletOrderPop in vm.outletOrderPops track by outletOrderPop.id\"><td><input type=\"checkbox\" style=\"outline: none\" ng-model=\"outletOrderPop.selected\" ng-change=\"vm.selectOutletOrder(outletOrderPop)\"></td><td>{{outletOrderPop.outletCode}}</td><td>{{outletOrderPop.outletName}}</td><td>{{outletOrderPop.areaName}}</td><td>{{outletOrderPop.perfectStoreStatus}}</td><td>{{outletOrderPop.pcStatus}}</td><td>{{outletOrderPop.risStatus}}</td><td>{{outletOrderPop.visitCycleStoreGrade}}</td></tr></tbody></table></div></div></uib-tab><uib-tab index=\"1\" disable=\"true\"><uib-tab-heading><span translate=\"sceaApp.popFulfillment.pops\">POPs</span></uib-tab-heading><div class=\"uib-tab-content\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchPop\" id=\"searchQuery2\" placeholder=\"{{ \'sceaApp.popFulfillment.home.searchPop\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.searchPop = \'\'\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></div><div class=\"col-xs-8 no-padding-right text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.generatePickingList()\" ng-disabled=\"vm.onProcess\"><span translate=\"sceaApp.popFulfillment.generatePickingList\">Generate Picking List</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.requestDate\">Request Date</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.requestBy\">Request By</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.outletName\">Outlet Name</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.popName\">POP Name</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.category\">Category</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.requested\">Requested</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.stock\">Stock</span></th><th class=\"text-center\"><span translate=\"sceaApp.popFulfillment.willBeSent\">Will Be Sent</span></th></tr></thead><tbody><tr class=\"text-center\" ng-class=\"{\'success\': orderPop.requestQty == orderPop.sentQty, \'danger\': orderPop.requestQty > orderPop.sentQty}\" ng-repeat=\"orderPop in vm.orderPops | filter:vm.searchPop\" ng-if=\"orderPop.containPop\"><td>{{orderPop.requestDate | date:\'d MMMM y HH:mm\'}}</td><td>{{orderPop.userLogin}}</td><td>{{orderPop.outletName}}</td><td>{{orderPop.popName}}</td><td>{{orderPop.popCategoryName}}</td><td>{{orderPop.requestQty | number}}</td><td>{{vm.stocks[orderPop.popId].remaining | number}}</td><td><input type=\"number\" class=\"form-control\" ng-model=\"orderPop.sentQty\" ng-change=\"vm.checkStock(orderPop)\"></td></tr></tbody></table></div><div class=\"table-responsive\" id=\"exportable\" ng-show=\"alwaysHidden\"><table class=\"jh-table table table-striped\"><tbody><tr><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>POP REFILL</td></tr><tr><td>&nbsp;</td><td>{{vm.today | date:\'d MMMM yyyy\'}}</td></tr><tr><td>&nbsp;</td></tr></tbody></table><table class=\"jh-table table table-striped\"><thead><tr><th class=\"text-center\">No</th><th class=\"text-center\">POP Name</th><th class=\"text-center\">Category</th><th class=\"text-center\">Stock</th><th class=\"text-center\">All Request</th><th class=\"text-center\" ng-repeat=\"outlet in vm.selectedOutlets\">{{outlet.outletName}}</th></tr></thead><tbody><tr class=\"text-center\" ng-repeat=\"(key, value) in vm.stocks\"><td>{{$index+1}}</td><td>{{vm.stocks[key].popName}}</td><td>{{vm.stocks[key].productCategory.categoryName}}</td><td>{{vm.stocks[key].remaining | number}}</td><td>{{vm.stocks[key].stock - vm.stocks[key].remaining | number}}</td><td ng-repeat=\"outlet in vm.selectedOutlets\">{{vm.stocks[key][outlet.id] ? vm.stocks[key][outlet.id] : \'0\' | number}}</td></tr></tbody></table></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 no-padding-left\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.back()\" ng-disabled=\"vm.onProcess\"><span class=\"glyphicon glyphicon-arrow-left\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.back\">Back</span></button></div><div class=\"col-xs-6 no-padding-right text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-disabled=\"vm.onProcess\"><span class=\"hidden-xs hidden-sm\" translate=\"sceaApp.popFulfillment.fulfill\">Fulfill</span></button></div></div></div></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/admin/spv-call-plan-creation/spv-call-plan-creation.html","<div><h2 translate=\"sceaApp.spvCallPlanCreation.home.title\">SPV Call Plan Creation</h2><jhi-alert></jhi-alert><br><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.month\" ng-change=\"vm.getSpvSummaries(vm.year, vm.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.year\" ng-change=\"vm.getSpvSummaries(vm.year, vm.month)\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><br><div class=\"text-center\" ng-show=\"vm.spvSummaries.length == 0\"><b><i><span translate=\"sceaApp.spvCallPlanCreation.noData\">No Data</span></i></b></div><div class=\"table-responsive\" ng-show=\"vm.spvSummaries.length > 0\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"employeeName\"><span translate=\"sceaApp.spvCallPlanCreation.supervisor\">Supervisor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-repeat=\"week in vm.spvSummaries[0].weeks | orderBy:\'week\':false\"><span translate=\"sceaApp.calendar.week\">Week</span> <span>{{week.week}}</span></th></tr></thead><tbody><tr ng-repeat=\"spvSummary in vm.spvSummaries | orderBy:vm.predicate:vm.reverse\"><td>{{spvSummary.employeeName}}</td><td ng-repeat=\"week in spvSummary.weeks | orderBy:\'week\':false\"><a ui-sref=\"spv-call-plan-creation.outlet({employeeId:spvSummary.employeeId, calendarId:week.calendarId})\"><span>{{week.target}}/{{week.succeed}}</span></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/spv-call-plan-creation/spv-outlet-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.spvCallPlanCreation.outlets.add\">Add Oultet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><uib-tabset><uib-tab heading=\"Coverage Outlet\"><div class=\"input-group\" style=\"margin-top: 20px\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></div></div><br><table class=\"jh-table table\" style=\"margin-bottom: 0\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th class=\"col-xs-2\"></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"outletCode\"><span data-translate=\"sceaApp.outlet.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"outletName\"><span data-translate=\"sceaApp.outlet.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"visitCycleStoreGrade\"><span data-translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"startVisitWeek\"><span data-translate=\"sceaApp.outlet.startVisitWeek\">Start Visit Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead></table><div style=\"max-height: 300px; overflow: auto\"><div class=\"row text-center\" style=\"border-bottom: 1px solid #ddd; margin-left: 0;  margin-right: 0; padding: 5px 0\" ng-repeat=\"outlet in vm.outlets\n 	 	                	| orderBy: vm.predicate : !vm.reverse  \n 	 	                	| filter : {outletName: vm.searchQuery}\"><div class=\"col-xs-2\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.addOutlet(outlet)\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outlet.detail.add\">Add</span></button></div></div><div class=\"col-xs-2\">{{outlet.outletCode ? outlet.outletCode : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.outletName ? outlet.outletName : \'-\'}}</div><div class=\"col-xs-2\">{{outlet.visitCycleStoreGrade ? outlet.visitCycleStoreGrade : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.startVisitWeek ? outlet.startVisitWeek : \'-\'}}</div></div></div><br><div><b><span translate=\"sceaApp.spvCallPlanCreation.total\">Total</span> <span>{{vm.outlets.length}}</span></b></div></uib-tab><uib-tab heading=\"All Outlet\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\" ng-disabled=\"!vm.searchQuery\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clearSearch()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form><br><table class=\"jh-table table\" style=\"margin-bottom: 0\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th class=\"col-xs-2\"></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"outletCode\"><span data-translate=\"sceaApp.outlet.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"outletName\"><span data-translate=\"sceaApp.outlet.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"visitCycle.storeGrade\"><span data-translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"startVisitWeek\"><span data-translate=\"sceaApp.outlet.startVisitWeek\">Start Visit Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead></table><div style=\"max-height: 300px; overflow: auto\"><div class=\"row text-center\" style=\"border-bottom: 1px solid #ddd; margin-left: 0;  margin-right: 0; padding: 5px 0\" ng-repeat=\"outlet in vm.masterOutlets\"><div class=\"col-xs-2\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.addOutlet(outlet)\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outlet.detail.add\">Add</span></button></div></div><div class=\"col-xs-2\">{{outlet.outletCode ? outlet.outletCode : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.outletName ? outlet.outletName : \'-\'}}</div><div class=\"col-xs-2\">{{outlet.visitCycleStoreGrade ? outlet.visitCycleStoreGrade : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.startVisitWeek ? outlet.startVisitWeek : \'-\'}}</div></div></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" style=\"margin: 0\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></form>");
$templateCache.put("app/admin/spv-call-plan-creation/spv-outlet-dialog.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.spvCallPlanCreation.outlets.title\">Outlets</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addOutlet()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"entity.action.add\">Add</span></button></div><br><table class=\"jh-table table\" style=\"margin-bottom: 0\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th class=\"col-xs-2 text-center\" jh-sort-by=\"outletCode\"><span data-translate=\"sceaApp.spvCallPlanCreation.outlets.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"outletName\"><span data-translate=\"sceaApp.spvCallPlanCreation.outlets.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"failedReason\"><span data-translate=\"sceaApp.spvCallPlanCreation.outlets.failedReason\">Failed Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"note\"><span data-translate=\"sceaApp.spvCallPlanCreation.outlets.note\">Note</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-1\"></th></tr></thead></table><div style=\"max-height: 300px; overflow: auto\"><div class=\"row text-center\" style=\"border-bottom: 1px solid #ddd; margin-left: 0;  margin-right: 0; padding: 5px 0\" ng-style=\"outlet.status == \'Not Downloaded\' && {\'background-color\':\'lightgrey\'}\n          			|| outlet.status == \'Succeed\' && {\'background-color\':\'lightgreen\'}\n          			|| outlet.status == \'Failed\' && {\'background-color\':\'lightpink\'}\n          			|| outlet.status == \'In Progress\' && {\'background-color\':\'lightyellow\'}\" ng-repeat=\"outlet in vm.outlets | orderBy : vm.predicate : !vm.reverse\"><div class=\"col-xs-2\">{{outlet.outletCode ? outlet.outletCode : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.outletName ? outlet.outletName : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.failedReason ? outlet.failedReason : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.note ? outlet.note : \'-\'}}</div><div class=\"col-xs-1\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-disabled=\"outlet.status != \'Not Downloaded\'\" ng-click=\"vm.deleteOutlet(outlet)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs\" translate=\"entity.action.delete\"></span></button></div></div></div></div><br><div><b><span translate=\"sceaApp.spvCallPlanCreation.total\">Total</span> <span>{{vm.outlets.length}}</span></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.employeeCode\">Employee Code</span></dt><dd><span>{{vm.user.employeeCode}}</span></dd><dt><span translate=\"userManagement.manager\">Manager</span></dt><dd><span>{{vm.user.managerName}}</span></dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'d MMMM y HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'d MMMM y HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-maxlength=\"50\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.password\">Password</label><input type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"vm.user.password\" ng-minlength=\"4\" ng-maxlength=\"50\" ng-required=\"vm.user.id == null\" placeholder=\"{{vm.user.password ? \'\' : \'****\'}}\"><div ng-show=\"editForm.password.$invalid\"><p class=\"help-block\" ng-show=\"editForm.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"editForm.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" name=\"profile\" ng-model=\"vm.user.authorities\" ng-options=\"\'userManagement.role.\' + profile | translate for profile in vm.profiles\"></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.employeeCode\" for=\"field_employeeCode\">Employee Code</label><input type=\"text\" class=\"form-control\" name=\"employeeCode\" id=\"field_employeeCode\" ng-model=\"vm.user.employeeCode\"></div><div class=\"form-group has-feedback\"><label translate=\"userManagement.manager\" for=\"field_manager\">Manager</label><input type=\"text\" ng-model=\"vm.managerOpt\" name=\"managerName\" uib-typeahead=\"emp as emp.firstName + \' \' + emp.midleName + \' \' + emp.lastName for emp in vm.getEmployee($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingEmployee\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"container-fluid\" style=\"margin-bottom: 16px\"><div class=\"row\"><div class=\"col-xs-6 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span class=\"hidden-xs\" translate=\"userManagement.home.createLabel\">Create a new User</span></button></div><div class=\"col-xs-6 text-right\"><button class=\"btn btn-primary\" ng-click=\"vm.exportAsCsv()\"><span class=\"glyphicon glyphicon-export\"></span> Export as CSV</button></div></div></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th style=\"white-space: nowrap\" jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"login\"><span translate=\"userManagement.login\">Login</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"email\"><span translate=\"userManagement.email\">Email</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"firstName\"><span translate=\"userManagement.firstName\">First Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"lastName\"><span translate=\"userManagement.lastName\">Last Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"employeeCode\"><span translate=\"userManagement.employeeCode\">Employee Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"manager.id\"><span translate=\"userManagement.manager\">Manager</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"activated\"><span translate=\"userManagement.activated\">Activated</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"langKey\"><span translate=\"userManagement.langKey\">Lang Key</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" translate=\"userManagement.profiles\">Profiles</th><th style=\"white-space: nowrap\" jh-sort-by=\"createdDate\"><span translate=\"userManagement.createdDate\">Created Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"lastModifiedBy\"><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"white-space: nowrap\" jh-sort-by=\"lastModifiedDate\"><spat translate=\"userManagement.lastModifiedDate\">Last Modified Date</spat><span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr><tr><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.id\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.login\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.email\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.firstName\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.lastName\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.employeeCode\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><input type=\"text\" class=\"form-control\" style=\"min-width: 70px\" ng-model=\"vm.filter.managerName\" ng-model-options=\"vm.ngModelOpt\" ng-change=\"vm.filterChange()\"></th><th><select class=\"form-control\" name=\"profile\" ng-model=\"vm.filter.activated\" ng-change=\"vm.filterChange()\" style=\"min-width: 125px\"><option value=\"\">All</option><option value=\"true\">Activated</option><option value=\"false\">Deactivated</option></select></th><th></th><th><select class=\"form-control\" name=\"profile\" ng-model=\"vm.filter.profiles\" ng-change=\"vm.filterChange()\" style=\"min-width: 123px\" ng-options=\"\'userManagement.role.\' + profile | translate for profile in vm.profiles\"></select></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.employeeCode}}</td><td>{{user.managerName}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'d MMMM y HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'d MMMM y HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><!--\n            <div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>\n                You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a>\n            </div>\n            --></div></div></div>");
$templateCache.put("app/home/dashboard-asm/dashboard-asm.html","<div><jhi-alert></jhi-alert><br><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-3 form-check-label\"><span translate=\"sceaApp.dashboard.monthly\">Monthly </span><input class=\"form-check-input\" ng-model=\"vm.showChart\" type=\"checkbox\" ng-change=\"vm.transition()\"></label></div></div><!-- filter week, month, year --><div class=\"container-fluid\"><div class=\"form-group\"><div ng-hide=\"vm.showChart\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.week\">week</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.week\" ng-change=\"vm.transition()\"><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" ng-change=\"vm.updateWeeks()\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-change=\"vm.updateWeeks()\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><br><!-- filter vdr, vdo coo, vdo  --><div class=\"container-fluid\"><div class=\"form-group\"><div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdr\">VDR</span></label><div class=\"col-md-3\"><select ng-options=\"vdr.firstName for vdr in vm.vdr\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vdr\" ng-change=\"vm.onVdrChange();\"><option value=\"\" ng-hide=\"vm.isVdo || vm.isVde\">All</option></select></div></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdoCoo\">VDO COO</span></label><div class=\"col-md-3\"><select ng-options=\"vdo.firstName for vdo in vm.vdo\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vdo\" ng-change=\"vm.onVdoChange()\"><option value=\"\">All</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdo\">VDO</span></label><div class=\"col-md-3\"><select ng-options=\"vde.firstName for vde in vm.vde\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vde\" ng-change=\"vm.onVdeChange()\"><option value=\"\">All</option></select></div></div></div><br><div ng-show=\"!vm.showChart\"><div class=\"jumbotron text-center\" style=\"cursor: pointer\" ui-sref=\"vdo-callplan-detail({week:\n				vm.calendar.week,\n				month: vm.calendar.month,\n				year: vm.calendar.year})\"><h3>VDO Callplan</h3><h1>{{vm.asmSummariesCp.percentage ? vm.asmSummariesCp.percentage : 0 | percentage:2}}</h1></div><div class=\"jumbotron text-center\" style=\"cursor: pointer\" ui-sref=\"pop-compliance-detail({week:\n			vm.calendar.week,\n			month: vm.calendar.month,\n			year: vm.calendar.year})\"><h3>POP Compliance</h3><h1>{{vm.asmSummariesPc.percentage ? vm.asmSummariesPc.percentage : 0 | percentage:2}}</h1></div><!-- <div class=\"jumbotron text-center\" style=\"cursor: pointer\" ui-sref=\"pop-tracking-detail({week:\n			vm.calendar.week,\n			month: vm.calendar.month,\n			year: vm.calendar.year})\">\n			<h3>POP Tracking</h3>\n			<h1>{{vm.asmSummariesPt.percentage | percentage:2}}</h1>\n		</div> --><!-- <div class=\"jumbotron text-center\">\n			<h3>Drop Point Stock Level</h3>\n			<h1>{{vm.asmSummariesDp.percentage | percentage:2}}</h1>\n		</div> --></div><div ng-show=\"vm.showChart\"><!-- chart starts here --><div id=\"chart1\" style=\"min-width: 310px;max-width:65%; height: 300px; margin: 0 auto\"></div><hr><div id=\"chart2\" style=\"min-width: 310px;max-width:65%; height: 300px; margin: 0 auto\"></div><hr><!-- <div id=\"chart3\" style=\"min-width: 310px;max-width:65%; height: 300px; margin: 0 auto\"></div>\n		<hr> --></div></div>");
$templateCache.put("app/home/dashboard-asm/pop-compliance-detail.html","<div><jhi-alert></jhi-alert><div><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.back()\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div><br><!-- filter week, month, year --><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.week\">week</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.week\" ng-change=\"vm.transition()\"><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><!-- filter vdr, vdo coo, vdo  --><div class=\"container-fluid\"><div class=\"form-group\"><div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdr\">VDR</span></label><div class=\"col-md-3\"><select ng-options=\"vdr.firstName for vdr in vm.vdr\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vdr\" ng-change=\"vm.onVdrChange();\"><option value=\"\" ng-hide=\"vm.isVdo || vm.isVde\">All</option></select></div></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdoCoo\">VDO COO</span></label><div class=\"col-md-3\"><select ng-options=\"vdo.firstName for vdo in vm.vdo\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vdo\" ng-change=\"vm.onVdoChange()\"><option value=\"\">All</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.dashboard.vdo\">VDO</span></label><div class=\"col-md-3\"><select ng-options=\"vde.firstName for vde in vm.vde\" class=\"form-control input-sm\" ng-model=\"vm.selectedRole.vde\" ng-change=\"vm.onVdeChange()\"><option value=\"\">All</option></select></div></div></div><br><div class=\"text-center\" ng-show=\"!vm.popCompliance.length\"><b><i><span>No Data</span></i></b></div><div ng-show=\"vm.popCompliance.length\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"employeeName\" rowspan=\"2\"><span>Employee name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th colspan=\"3\"><span>AV</span></th><th colspan=\"3\"><span>HA</span></th><th colspan=\"3\"><span>CE</span></th></tr><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"actualAv\"><span>Actual</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetAv\"><span>Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"achievementAv\"><span>Achievement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"actualHa\"><span>Actual</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetHa\"><span>Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"achievementHa\"><span>Achievement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"actualCE\"><span>Actual</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetCe\"><span>Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"achievementCe\"><span>Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"popCompliance in vm.popCompliance | orderBy:vm.predicate:!vm.reverse\"><td>{{popCompliance.employeeName}}</td><td>{{popCompliance.actualAv}}</td><td>{{popCompliance.targetAv}}</td><td>{{popCompliance.achievementAv | number:2}}</td><td>{{popCompliance.actualHa}}</td><td>{{popCompliance.targetHa}}</td><td>{{popCompliance.achievementHa | number:2}}</td><td>{{popCompliance.actualCe}}</td><td>{{popCompliance.targetCe}}</td><td>{{popCompliance.achievementCe | number:2}}</td></tr><tr><td><b>Total</b></td><td>{{vm.total.actualAv}}</td><td>{{vm.total.targetAv}}</td><td>{{vm.total.achievementAv | number:2}}</td><td>{{vm.total.actualHa}}</td><td>{{vm.total.targetHa}}</td><td>{{vm.total.achievementHa | number:2}}</td><td>{{vm.total.actualCe}}</td><td>{{vm.total.targetCe}}</td><td>{{vm.total.achievementCe | number:2}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/home/dashboard-asm/pop-tracking-detail.html","<div><jhi-alert></jhi-alert><div><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.back(vm.calendar)\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div><br><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.week\">week</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.week\" ng-change=\"vm.updateParams(vm.calendar)\"><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><br><div class=\"text-center\" ng-show=\"vm.popTracking.length == 0\"><b><i><span>No Data</span></i></b></div><div ng-show=\"vm.popTracking.length > 0\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><!--<th jh-sort-by=\"-employeeId\">--><!--<span>Employee ID</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span>--><!--</th>--><th jh-sort-by=\"-employeeName\"><span>Store name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"-roleName\">--><!--<span>Role</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span>--><!--</th>--><th jh-sort-by=\"-achievements.actual\"><span>Actual</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-achievements.target\"><span>Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-achievement\"><span>Achievement</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"popTracking in vm.popTracking | orderBy:vm.predicate:vm.reverse\"><!--<td>{{popTracking.employeeId}}</td>--><td>{{popTracking.employeeName}}</td><!--<td>{{popTracking.roleName}}</td>--><td>{{popTracking.achievements.actual}}</td><td>{{popTracking.achievements.target}}</td><td>{{popTracking.achievement | number:2}}%</td></tr><tr><!--<td></td>--><!--<td></td>--><td><b>Total</b></td><td><b>{{vm.popTracking.sumActual}}</b></td><td><b>{{vm.popTracking.sumTarget}}</b></td><td><b>{{vm.popTracking.sumAchievement | number:2}}%</b></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/home/dashboard-asm/vdo-callplan-detail.html","<div><jhi-alert></jhi-alert><div><button type=\"button\" class=\"btn btn-info\" ng-click=\"vm.back(vm.calendar)\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div><br><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.week\">week</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.week\" ng-change=\"vm.updateParams(vm.calendar)\"><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-change=\"vm.updateWeeks(vm.calendar.year, vm.calendar.month)\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><br><div class=\"text-center\" ng-show=\"vm.vdoSummaries.length == 0\"><b><i><span>No Data</span></i></b></div><div class=\"table-responsive\" ng-show=\"vm.vdoSummaries.length > 0\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><!--<th jh-sort-by=\"-employeeId\">--><!--<span>Employee ID</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span>--><!--</th>--><th jh-sort-by=\"-employeeName\"><span>Employee Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"-roleName\">--><!--<span>Role</span>--><!--<span class=\"glyphicon glyphicon-sort\"></span>--><!--</th>--><th jh-sort-by=\"-achievements.actual\"><span>Actual</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-achievements.target\"><span>Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-achievement\"><span>Achievement</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vdoSummary in vm.vdoSummaries | orderBy:vm.predicate:vm.reverse\"><!--<td>{{vdoSummary.employeeId}}</td>--><td>{{vdoSummary.employeeName}}</td><!--<td>{{vdoSummary.roleName}}</td>--><td>{{vdoSummary.achievements.actual}}</td><td>{{vdoSummary.achievements.target}}</td><td>{{vdoSummary.achievement | number:2}}%</td><td><button class=\"btn btn-info btn-xs\" ng-click=\"vm.openOutletDialog(vdoSummary.employeeId)\"><i class=\"fa fa-eye\"></i></button></td></tr><tr><!--<td></td>--><!--<td></td>--><td><b>Total</b></td><td><b>{{vm.vdoSummaries.sumActual}}</b></td><td><b>{{vm.vdoSummaries.sumTarget}}</b></td><td><b>{{vm.vdoSummaries.sumAchievement | number:2}}%</b></td></tr></tbody></table></div></div>");
$templateCache.put("app/home/metabase-dashboard/metabase-dashboard.html","<div ng-if=\"vm.metabaseResources.length && !vm.isLoading\"><div uib-dropdown><div href id=\"dashboard-dropdown\" uib-dropdown-toggle style=\"margin: 0px 0px 16px 0px;display: flex;align-items: center\"><h1 style=\"margin: 0px 10px 0px 0px\">{{vm.selectedDashboard.dashboardTitle}}</h1><i class=\"glyphicon glyphicon-chevron-down\" style=\"font-size: 18px\"></i></div><ul class=\"dropdown-menu\" uib-dropdown-menu aria-labelledby=\"dashboard-dropdown\"><li ng-repeat=\"resource in vm.metabaseResources\" ng-click=\"vm.selectDashboard(resource)\"><a style=\"font-size: 16px\">{{resource.dashboardTitle}}</a></li></ul></div><iframe style=\"height: calc(100vh - 225px)\" ng-src=\"{{vm.selectedUrl}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" scrolling=\"auto\" target=\"_top\"></iframe></div><div ng-if=\"vm.isLoading\" style=\"height: calc(100vh - 180px);display: flex;justify-content: center;align-items: center\"><h1><span style=\"margin-right: 10px\">Loading Dashboard</span> <span class=\"fa fa-spinner fa-spin\"></span></h1></div><div ng-if=\"!vm.metabaseResources.length && !vm.isLoading\" style=\"height: calc(100vh - 180px);display: flex;justify-content: center;align-items: center\"><h1>Cant load dashboard data please check you dashboard config</h1></div>");
$templateCache.put("app/layouts/dynamic-form/dynamic-form.html","<div class=\"form-horizontal\"><div class=\"form-group\" ng-repeat=\"item in vm.taskDetailed.formProperties\" ng-if=\"item.name != \'Approval\'\"><label class=\"col-md-4 control-label\" ng-if=\"(item.type==\'scea_project\' && vm.project==null)\n			|| item.type!=\'scea_project\'\"><span ng-if=\"item.alias == null && item.name != null\">{{item.name}}</span> <span ng-if=\"item.alias != null && item.name != null\">{{item.alias}}</span> <span ng-show=\"item.required\">*</span></label><div class=\"col-md-7\"><input ng-if=\"item.type==\'string\'\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"> <input ng-if=\"item.type==\'long\' || item.type==\'double\'\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\" format=\"number\"> <input ng-if=\"item.type==\'boolean\'\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" type=\"checkbox\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\" style=\"width: 16px; height: 25px\"><div ng-if=\"item.type==\'enum\' && item.name!=\'Approval\'\"><select ng-visible=\"item.readable\" ng-enabled=\"item.writable\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"><option ng-repeat=\"enum in item.enumValues track by enum.id\" value=\"{{enum.name}}\">{{enum.name}}</option></select></div><div ng-if=\"item.type==\'date\'\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-if=\"!item.writable\" ng-required=\"item.required\"> <input type=\"text\" class=\"form-control\" datetime-picker=\"{{item.datePattern}}\" is-open=\"vm.taskDetailed.formProperties[$index].opened\" ng-model=\"vm.taskDetailed.formProperties[$index].value\" ng-visible=\"item.readable\" ng-if=\"item.writable\" ng-required=\"item.required\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"{{item.writable == false}}\" ng-click=\"vm.openDatePicker(vm.taskDetailed.formProperties[$index])\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><input ng-if=\"item.type==\'scea_project\' && vm.project == null\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"><div ng-if=\"item.type==\'scea_business_unit\' && item.writable==true\"><select ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" class=\"form-control\" ng-required=\"item.required\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"><option value=\"\" disabled=\"disabled\" selected=\"selected\">{{item.name}}</option><option ng-repeat=\"businessUnit in vm.businessUnit track by businessUnit.id\" value=\"{{businessUnit.id}}\">{{businessUnit.name}}</option></select></div><div ng-if=\"item.type==\'scea_business_unit\' && item.writable==false\"><input ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\" type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"></div><input ng-if=\"item.type==\'scea_outlet\' && item.writable\" type=\"text\" class=\"form-control\" ng-visible=\"item.readable\" ng-required=\"item.required\" ng-model=\"vm.taskDetailed.formProperties[$index].value\" typeahead-editable=\"false\" typeahead-show-hint=\"true\" typeahead-min-length=\"2\" typeahead-loading=\"vm.loadingOutlet\" uib-typeahead=\"outlet as outlet.outletName for outlet in vm.getOutlet($viewValue)\"> <input ng-if=\"item.type==\'scea_outlet\' && !item.writable\" type=\"text\" class=\"form-control\" ng-disabled=\"{{item.writable == false}}\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"><div ng-if=\"item.type==\'scea_file\'\"><div ng-if=\"item.writable\"><div ngf-drop ngf-change=\"vm.setContent($file, vm.attachment[$index])\"><p class=\"input-group\"><input ng-disabled=\"true\" type=\"text\" class=\"form-control\" ng-model=\"vm.attachment[$index].name\" ng-click=\"vm.openFile(vm.attachment[$index].contentContentType, vm.attachment[$index].content)\"> <span class=\"input-group-btn\"><button type=\"file\" ngf-select class=\"btn btn-default pull-right\" ngf-change=\"vm.setContent($file, vm.attachment[$index])\" translate=\"entity.action.addfile\" ng-visible=\"item.readable\" ng-disabled=\"{{item.writable == false}}\" ng-required=\"item.required\">Add File</button></span></p></div><input type=\"hidden\" class=\"form-control\" name=\"content\" id=\"field_content\" ng-model=\"vm.attachment[$index].content\" ng-required=\"item.required\" maxbytes=\"50000000\"><div ng-show=\"editForm.content.$invalid\"><p class=\"help-block\" ng-show=\"editForm.content.$error.maxbytes\" translate=\"entity.validation.maxbytes\" translate-value-max=\"50000000\">This field cannot be more than 50000000.</p></div></div><div ng-if=\"!item.writable\"><p class=\"input-group\"><input ng-disabled=\"true\" type=\"text\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value.fileName\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"vm.taskDetailed.formProperties[$index].value == null\" ng-click=\"vm.download(vm.taskDetailed.formProperties[$index].value)\">Download</button></span></p></div></div><div ng-if=\"item.type==\'scea_formula\'\"><p class=\"input-group\"><input ng-visible=\"item.readable\" ng-disabled=\"true\" ng-required=\"item.required\" type=\"number\" class=\"form-control\" ng-model=\"vm.taskDetailed.formProperties[$index].value\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-disabled=\"{{item.writable == false}}\" ng-click=\"vm.calculate($index)\">Calculate</button></span></p></div></div></div></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><!--             <span class=\"hipster img-responsive img-rounded\"></span> --></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand logo\" href=\"#/dashboard\" ng-click=\"vm.collapseNavbar()\"><img class=\"logo-img\" src=\"content/images/samsung-logo.png\"></a></div><div class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"home\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, ARCO, SPV, PC, VDO, VDE\"><a ui-sref=\"dashboard\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span> <span class=\"hidden-sm\" translate=\"global.menu.dashboard\">Dashboard</span></a></li><li ng-class=\"{active: vm.$state.includes(\'merchandiser-activity\')}\" has-any-authority=\"ROLE_ADMIN, SPV, VDO, VDR\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"merchandiser-activity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.merchandiserActivity.main\">Merchandiser Activity </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, VDO, VDR\"><a ui-sref=\"call-plan-creation\"><span class=\"glyphicon glyphicon-edit\"></span>&nbsp; <span translate=\"global.menu.merchandiserActivity.callPlanCreation\">Call Plan Creation</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, VDO, ARCO, VDR\"><a ui-sref=\"other-job-approval\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.merchandiserActivity.otherJobApproval\">Other Job Approval</span></a></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-th\"></span>&nbsp; <span translate=\"global.menu.merchandiserActivity.storeCompletion.main\">Store Completion</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"task\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.merchandiserActivity.storeCompletion.tasks\">Tasks</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"project-list\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.merchandiserActivity.storeCompletion.projectLists\">Project Lists</span></a></li></ul></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'report\')}\" has-any-authority=\"ROLE_ADMIN, ARCO, SPV, VDO, VDR\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"report-menu\"><span><span class=\"glyphicon glyphicon-list-alt\"></span> <span class=\"hidden-sm\" translate=\"global.menu.report.main\">Report </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.pop.title\">POP</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"pop-dashboard\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.dashboard\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.rowData\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-checklist\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.checklist\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-difference\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.difference\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"request-status-pop-report\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.requestStatus\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-request-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.requestRowData\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-summary-request\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.summaryRequest\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"inventory-valuation\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.inventoryValuation\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"stock-move\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.pop.stockMove\"></span></a></li></ul></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.fixture.title\">Fixture</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"fixture-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.fixture.rowData\"></span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"fixture-planogram\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.fixture.planogram\"></span></a></li></ul></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.equipment.title\">Equipment</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"equipment-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.equipment.rowData\"></span></a></li></ul></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.internet.title\">Internet</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"internet-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.internet.rowData\"></span></a></li></ul></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.image.title\">Internet</span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"image-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.image.rowData\"></span></a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"store-completeness-report\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.storeCompleteness\">Store Completeness</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"other-brand-display-report\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.otherBrandDisplay\">Other Brand Display</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"visit-audit\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.visitAudit\">Visit Audit</span></a></li><li class=\"menu-item dropdown dropdown-submenu\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.retailMapping.title\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ui-sref-active=\"active\"><a ui-sref=\"retail-mapping-row-data\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.retailMapping.rowData\"></span></a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"vdo-audit-row-data\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.vdoAudit\">VDO Audit</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"report-incentive\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.incentive\">Incentive</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"report-promotion\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.promotion\">Promotion</span></a></li><!--\n                        <li ui-sref-active=\"active\">\n	                        <a ui-sref=\"row-data-pop-report\">\n	                            <span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp;\n	                            <span translate=\"global.menu.report.pop\">POP</span>\n	                        </a>\n                        </li> --><li ui-sref-active=\"active\"><a ui-sref=\"call-plan-all-outlet\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.report.callPlan\">Call Plan</span></a></li><!--\n                        <li ui-sref-active=\"active\">\n	                        <a ui-sref=\"store-completeness-report\">\n	                            <span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp;\n	                            <span translate=\"global.menu.report.storeCompleteness\">Store Completeness</span>\n	                        </a>\n                        </li>\n                        <li ui-sref-active=\"active\">\n	                        <a ui-sref=\"other-brand-display-report\">\n	                            <span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp;\n	                            <span translate=\"global.menu.report.otherBrandDisplay\">Other Brand Display</span>\n	                        </a>\n                        </li>\n                        <li ui-sref-active=\"active\" >\n                            <a ui-sref=\"visit-audit\" ng-click=\"vm.collapseNavbar()\">\n                                <span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp;\n                                <span translate=\"global.menu.report.visitAudit\">Visit Audit</span>\n                            </a>\n                        </li> --></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown has-any-authority=\"ROLE_ADMIN, VDR\" class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-asterisk\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"area\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.area\">Area</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"area-level\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.areaLevel\">Area Level</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"brand\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.brand\">Brand</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"calendar\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.calendar\">Calendar</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"channel\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.channel\">Channel</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"equipment\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.equipment\">Equipment</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"fixtures\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.fixtures\">Fixtures</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"formula-field\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.formulaField\">Formula Field</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"internet\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.internet\">Internet</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"internet-answer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.internetAnswer\">Internet Answer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"internet-connection\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.internetConnection\">Internet Connection</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"internet-qa\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.internetQa\">Internet Qa</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"launch-period\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.launchPeriod\">Launch Period</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"other-job-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.otherJobType\">Other Job Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"outlet\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.outlet\">Outlet</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"outlet-account\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.outletAccount\">Outlet Account</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"outlet-type\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.outletType\">Outlet Type</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.pop\">Pop</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.product\">Product</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productCategory\">Product Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"product-inch\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.productInch\">Product Inch</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"project\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.project\">Project</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"sellout\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.sellout\">Sellout</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"store-completeness\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.storeCompleteness\">Store Completeness</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"ticket-result\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.ticketResult\">Ticket Result</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"order-pop\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.orderPop\">Order Pop</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"promo-material\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.promoMaterial\">Promo Material</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"promotion\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.promotion\">Promotion</span></a></li><!--\n                        <li ui-sref-active=\"active\" >\n                            <a ui-sref=\"promotion-dtl\" ng-click=\"vm.collapseNavbar()\">\n                                <span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp;\n                                <span translate=\"global.menu.entities.promotionDtl\">Promotion Dtl</span>\n                            </a>\n                        </li> --><li ui-sref-active=\"active\"><a ui-sref=\"t-file-image-other-job\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.tFileImageOtherJob\">T File Image Other Job</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"visit-cycle\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.gradeAndVisitCycle\">Grade and Visit Cycle</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"retail-mapping-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.retailMappingCategory\">Retail Mapping Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"retail-mapping-sub-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.retailMappingSubCategory\">Retail Mapping Sub Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dealer\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.dealer\">Dealer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"retail-mapping-photo-category\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.retailMappingPhotoCategory\">Retail Mapping Photo Category</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"principal\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.principal\">Principal</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"upload-retail-mapping-allocation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span data-translate=\"global.menu.entities.uploadRetailMappingAllocation\">Upload Retail Mapping Allocation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"ris-product-target\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span data-translate=\"global.menu.entities.risProductTarget\">Ris Product Target</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"outlet-retail-mapping\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span data-translate=\"global.menu.entities.outletRetailMapping\">Outlet Retail Mapping</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"droppoint\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.droppoint\">Droppoint</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"outletpoint\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.outletpoint\">Outletpoint</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-inv\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.popInv\">Pop Inv</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"pop-pair-version\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.popPairVersion\">Pop Pair Version</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"planogram\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-asterisk\"></span>&nbsp; <span translate=\"global.menu.entities.planogram\">Planogram</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"><span><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm\" translate=\"global.menu.account.main\">Account </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-any-authority=\"ROLE_ADMIN, ARCO, SPV\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"dashboard-setting\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-blackboard\"></span>&nbsp; <span translate=\"global.menu.admin.dashboardSetting\">Dashbaord Setting</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"edit-manager\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-certificate\"></span>&nbsp; <span translate=\"global.menu.admin.editManager\">Edit Manager</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"application-setting\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cog\"></span>&nbsp; <span translate=\"global.menu.admin.applicationSetting\">Application Setting</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"achievement-data-adjustment\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-cog\"></span>&nbsp; <span translate=\"global.menu.admin.achievementDataAdjustment\">Achievement Data Adjustment</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"spv-call-plan-creation\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-modal-window\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.spvCallPlanCreation\">SPV Call Plan Creation</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"pop-fulfillment\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.popFulfillment\">POP Fulfillment</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"api-key\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-console\"></span>&nbsp; <span data-translate=\"global.menu.admin.apiKey\">Api Key</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"entity-audit\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.entity-audit\">Entity Audit</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"elasticsearch-reindex\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span>&nbsp; <span translate=\"global.menu.admin.elasticsearch-reindex\">Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><!--\n		                <li ng-class=\"{active: vm.$state.includes(\'system-administration\')}\" ng-switch-when=\"true\" uib-dropdown has-authority=\"ROLE_ADMIN\" class=\"dropdown pointer\">\n		                    <a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"merchandiser-activity-menu\">\n		                        <span>\n									<span class=\"glyphicon glyphicon-stats\"></span>\n									<span class=\"hidden-sm\" translate=\"global.menu.systemAdministration.main\">\n										System Administration\n									</span>\n									<b class=\"caret\"></b>\n		                        </span>\n		                    </a>\n		                    <ul class=\"dropdown-menu\" role=\"menu\">\n		                        <li class=\"menu-item dropdown dropdown-submenu\">\n			                        <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n			                            <span class=\"glyphicon glyphicon-calendar\"></span>&nbsp;\n			                            <span translate=\"global.menu.systemAdministration.outletManagement.main\">Outlet Management</span>\n			                        </a>\n			                        <ul class=\"dropdown-menu\" role=\"menu\">\n				                        <li class=\"menu-item\" ui-sref-active=\"active\">\n					                        <a ui-sref=\"visit-cycle\" class=\"dropdown-toggle\" ng-click=\"vm.collapseNavbar()\">\n					                            <span translate=\"global.menu.systemAdministration.outletManagement.gradeAndVisitCycle\">Grade and Visit Cycle</span>\n					                        </a>\n				                        </li>\n				                    </ul>\n		                        </li>\n\n		                        <li class=\"menu-item\" ui-sref-active=\"active\">\n			                        <a ui-sref=\"achievement-data-adjustment\">\n			                            <span class=\"glyphicon glyphicon-signal\"></span>&nbsp;\n			                            <span translate=\"global.menu.systemAdministration.achievementDataAdjustment\">Achievement Data Adjustment</span>\n			                        </a>\n		                        </li>\n		                    </ul>\n		                </li>\n		                --></ul></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("app/entities/accumulation/accumulation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.accumulation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.accumulation.delete.question\" translate-values=\"{id: \'{{vm.accumulation.id}}\'}\">Are you sure you want to delete this Accumulation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/accumulation/accumulation-detail.html","<div><h2><span translate=\"sceaApp.accumulation.detail.title\">Accumulation</span> {{vm.accumulation.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.accumulation.insertDate\">Insert Date</span></dt><dd><span>{{vm.accumulation.insertDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.accumulation.category\">Category</span></dt><dd><span translate=\"{{\'sceaApp.Category.\' + vm.accumulation.category}}\">{{vm.accumulation.category}}</span></dd><dt><span translate=\"sceaApp.accumulation.year\">Year</span></dt><dd><span>{{vm.accumulation.year}}</span></dd><dt><span translate=\"sceaApp.accumulation.month\">Month</span></dt><dd><span>{{vm.accumulation.month}}</span></dd><dt><span translate=\"sceaApp.accumulation.week\">Week</span></dt><dd><span>{{vm.accumulation.week}}</span></dd><dt><span translate=\"sceaApp.accumulation.targetYtd\">Target Ytd</span></dt><dd><span>{{vm.accumulation.targetYtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.actualYtd\">Actual Ytd</span></dt><dd><span>{{vm.accumulation.actualYtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.targetMtd\">Target Mtd</span></dt><dd><span>{{vm.accumulation.targetMtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.actualMtd\">Actual Mtd</span></dt><dd><span>{{vm.accumulation.actualMtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.targetWtd\">Target Wtd</span></dt><dd><span>{{vm.accumulation.targetWtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.actualWtd\">Actual Wtd</span></dt><dd><span>{{vm.accumulation.actualWtd}}</span></dd><dt><span translate=\"sceaApp.accumulation.storeType\">Store Type</span></dt><dd><span translate=\"{{\'sceaApp.StoreType.\' + vm.accumulation.storeType}}\">{{vm.accumulation.storeType}}</span></dd><dt><span translate=\"sceaApp.accumulation.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.accumulation.employee.id})\">{{vm.accumulation.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/accumulation/accumulation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAccumulationLabel\" translate=\"sceaApp.accumulation.home.createOrEditLabel\">Create or edit a Accumulation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.accumulation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.accumulation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.insertDate\" for=\"field_insertDate\">Insert Date</label><div class=\"input-group\"><input id=\"field_insertDate\" type=\"text\" class=\"form-control\" name=\"insertDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.accumulation.insertDate\" is-open=\"vm.datePickerOpenStatus.insertDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'insertDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.category\" for=\"field_category\">Category</label><select class=\"form-control\" name=\"category\" ng-model=\"vm.accumulation.category\" id=\"field_category\"><option value=\"CALLPLAN\" translate=\"sceaApp.Category.CALLPLAN\">CALLPLAN</option><option value=\"POP\" translate=\"sceaApp.Category.POP\">POP</option><option value=\"FIXTURE\" translate=\"sceaApp.Category.FIXTURE\">FIXTURE</option><option value=\"EQUIPMENT\" translate=\"sceaApp.Category.EQUIPMENT\">EQUIPMENT</option><option value=\"PLANOGRAM\" translate=\"sceaApp.Category.PLANOGRAM\">PLANOGRAM</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.year\" for=\"field_year\">Year</label><input type=\"number\" class=\"form-control\" name=\"year\" id=\"field_year\" ng-model=\"vm.accumulation.year\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.month\" for=\"field_month\">Month</label><input type=\"number\" class=\"form-control\" name=\"month\" id=\"field_month\" ng-model=\"vm.accumulation.month\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.week\" for=\"field_week\">Week</label><input type=\"number\" class=\"form-control\" name=\"week\" id=\"field_week\" ng-model=\"vm.accumulation.week\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.targetYtd\" for=\"field_targetYtd\">Target Ytd</label><input type=\"number\" class=\"form-control\" name=\"targetYtd\" id=\"field_targetYtd\" ng-model=\"vm.accumulation.targetYtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.actualYtd\" for=\"field_actualYtd\">Actual Ytd</label><input type=\"number\" class=\"form-control\" name=\"actualYtd\" id=\"field_actualYtd\" ng-model=\"vm.accumulation.actualYtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.targetMtd\" for=\"field_targetMtd\">Target Mtd</label><input type=\"number\" class=\"form-control\" name=\"targetMtd\" id=\"field_targetMtd\" ng-model=\"vm.accumulation.targetMtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.actualMtd\" for=\"field_actualMtd\">Actual Mtd</label><input type=\"number\" class=\"form-control\" name=\"actualMtd\" id=\"field_actualMtd\" ng-model=\"vm.accumulation.actualMtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.targetWtd\" for=\"field_targetWtd\">Target Wtd</label><input type=\"number\" class=\"form-control\" name=\"targetWtd\" id=\"field_targetWtd\" ng-model=\"vm.accumulation.targetWtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.actualWtd\" for=\"field_actualWtd\">Actual Wtd</label><input type=\"number\" class=\"form-control\" name=\"actualWtd\" id=\"field_actualWtd\" ng-model=\"vm.accumulation.actualWtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.accumulation.storeType\" for=\"field_storeType\">Store Type</label><select class=\"form-control\" name=\"storeType\" ng-model=\"vm.accumulation.storeType\" id=\"field_storeType\"><option value=\"VDE\" translate=\"sceaApp.StoreType.VDE\">VDE</option><option value=\"RIS\" translate=\"sceaApp.StoreType.RIS\">RIS</option><option value=\"PERFECT\" translate=\"sceaApp.StoreType.PERFECT\">PERFECT</option><option value=\"PC\" translate=\"sceaApp.StoreType.PC\">PC</option></select></div><div class=\"form-group\"><label translate=\"sceaApp.accumulation.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.accumulation.employee\" ng-options=\"employee as employee.firstName for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/accumulation/accumulations.html","<div><h2 translate=\"sceaApp.accumulation.home.title\">Accumulations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"accumulation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.accumulation.home.createLabel\">Create new Accumulation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.accumulation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"sceaApp.accumulation.insertDate\">Insert Date</span></th><th><span translate=\"sceaApp.accumulation.category\">Category</span></th><th><span translate=\"sceaApp.accumulation.year\">Year</span></th><th><span translate=\"sceaApp.accumulation.month\">Month</span></th><th><span translate=\"sceaApp.accumulation.week\">Week</span></th><th><span translate=\"sceaApp.accumulation.targetYtd\">Target Ytd</span></th><th><span translate=\"sceaApp.accumulation.actualYtd\">Actual Ytd</span></th><th><span translate=\"sceaApp.accumulation.targetMtd\">Target Mtd</span></th><th><span translate=\"sceaApp.accumulation.actualMtd\">Actual Mtd</span></th><th><span translate=\"sceaApp.accumulation.targetWtd\">Target Wtd</span></th><th><span translate=\"sceaApp.accumulation.actualWtd\">Actual Wtd</span></th><th><span translate=\"sceaApp.accumulation.storeType\">Store Type</span></th><th><span translate=\"sceaApp.accumulation.employee\">Employee</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"accumulation in vm.accumulations track by accumulation.id\"><td><a ui-sref=\"accumulation-detail({id:accumulation.id})\">{{accumulation.id}}</a></td><td>{{accumulation.insertDate | date:\'d MMMM y\'}}</td><td translate=\"{{\'sceaApp.Category.\' + accumulation.category}}\">{{accumulation.category}}</td><td>{{accumulation.year}}</td><td>{{accumulation.month}}</td><td>{{accumulation.week}}</td><td>{{accumulation.targetYtd}}</td><td>{{accumulation.actualYtd}}</td><td>{{accumulation.targetMtd}}</td><td>{{accumulation.actualMtd}}</td><td>{{accumulation.targetWtd}}</td><td>{{accumulation.actualWtd}}</td><td translate=\"{{\'sceaApp.StoreType.\' + accumulation.storeType}}\">{{accumulation.storeType}}</td><td><a ui-sref=\"employee-detail({id:accumulation.employee.id})\">{{accumulation.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"accumulation-detail({id:accumulation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"accumulation.edit({id:accumulation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"accumulation.delete({id:accumulation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/adjusted-accumulation/adjusted-accumulation-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.adjustedAccumulation.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.adjustedAccumulation.delete.question\" translate-values=\"{id: \'{{vm.adjustedAccumulation.id}}\'}\">Are you sure you want to delete this Adjusted Accumulation?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/adjusted-accumulation/adjusted-accumulation-detail.html","<div><h2><span translate=\"sceaApp.adjustedAccumulation.detail.title\">Adjusted Accumulation</span> {{vm.adjustedAccumulation.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.adjustedAccumulation.insertDate\">Insert Date</span></dt><dd><span>{{vm.adjustedAccumulation.insertDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.lastUpdatedDate\">Last Updated Date</span></dt><dd><span>{{vm.adjustedAccumulation.lastUpdatedDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.year\">Year</span></dt><dd><span>{{vm.adjustedAccumulation.year}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.month\">Month</span></dt><dd><span>{{vm.adjustedAccumulation.month}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.week\">Week</span></dt><dd><span>{{vm.adjustedAccumulation.week}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.category\">Category</span></dt><dd><span translate=\"{{\'sceaApp.Category.\' + vm.adjustedAccumulation.category}}\">{{vm.adjustedAccumulation.category}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.storeType\">Store Type</span></dt><dd><span translate=\"{{\'sceaApp.StoreType.\' + vm.adjustedAccumulation.storeType}}\">{{vm.adjustedAccumulation.storeType}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.percentageYtd\">Percentage Ytd</span></dt><dd><span>{{vm.adjustedAccumulation.percentageYtd}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.percentageMtd\">Percentage Mtd</span></dt><dd><span>{{vm.adjustedAccumulation.percentageMtd}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.percentageWtd\">Percentage Wtd</span></dt><dd><span>{{vm.adjustedAccumulation.percentageWtd}}</span></dd><dt><span translate=\"sceaApp.adjustedAccumulation.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.adjustedAccumulation.employee.id})\">{{vm.adjustedAccumulation.employee.id}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/adjusted-accumulation/adjusted-accumulation-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAdjustedAccumulationLabel\" translate=\"sceaApp.adjustedAccumulation.home.createOrEditLabel\">Create or edit a Adjusted Accumulation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.adjustedAccumulation.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.adjustedAccumulation.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.insertDate\" for=\"field_insertDate\">Insert Date</label><div class=\"input-group\"><input id=\"field_insertDate\" type=\"text\" class=\"form-control\" name=\"insertDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.adjustedAccumulation.insertDate\" is-open=\"vm.datePickerOpenStatus.insertDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'insertDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.lastUpdatedDate\" for=\"field_lastUpdatedDate\">Last Updated Date</label><div class=\"input-group\"><input id=\"field_lastUpdatedDate\" type=\"text\" class=\"form-control\" name=\"lastUpdatedDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.adjustedAccumulation.lastUpdatedDate\" is-open=\"vm.datePickerOpenStatus.lastUpdatedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastUpdatedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.year\" for=\"field_year\">Year</label><input type=\"number\" class=\"form-control\" name=\"year\" id=\"field_year\" ng-model=\"vm.adjustedAccumulation.year\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.month\" for=\"field_month\">Month</label><input type=\"number\" class=\"form-control\" name=\"month\" id=\"field_month\" ng-model=\"vm.adjustedAccumulation.month\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.week\" for=\"field_week\">Week</label><input type=\"number\" class=\"form-control\" name=\"week\" id=\"field_week\" ng-model=\"vm.adjustedAccumulation.week\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.category\" for=\"field_category\">Category</label><select class=\"form-control\" name=\"category\" ng-model=\"vm.adjustedAccumulation.category\" id=\"field_category\"><option value=\"CALLPLANACOJTGT\" translate=\"sceaApp.Category.CALLPLANACOJTGT\">CALLPLANACOJTGT</option><option value=\"CALLPLANACOJRCP\" translate=\"sceaApp.Category.CALLPLANACOJRCP\">CALLPLANACOJRCP</option><option value=\"CALLPLANACTGT\" translate=\"sceaApp.Category.CALLPLANACTGT\">CALLPLANACTGT</option><option value=\"CALLPLANACRCP\" translate=\"sceaApp.Category.CALLPLANACRCP\">CALLPLANACRCP</option><option value=\"POPALL\" translate=\"sceaApp.Category.POPALL\">POPALL</option><option value=\"POPAV\" translate=\"sceaApp.Category.POPAV\">POPAV</option><option value=\"POPHA\" translate=\"sceaApp.Category.POPHA\">POPHA</option><option value=\"FIXTURE\" translate=\"sceaApp.Category.FIXTURE\">FIXTURE</option><option value=\"EQUIPMENT\" translate=\"sceaApp.Category.EQUIPMENT\">EQUIPMENT</option><option value=\"PLANOGRAM\" translate=\"sceaApp.Category.PLANOGRAM\">PLANOGRAM</option><option value=\"INTERNET\" translate=\"sceaApp.Category.INTERNET\">INTERNET</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.storeType\" for=\"field_storeType\">Store Type</label><select class=\"form-control\" name=\"storeType\" ng-model=\"vm.adjustedAccumulation.storeType\" id=\"field_storeType\"><option value=\"VDE\" translate=\"sceaApp.StoreType.VDE\">VDE</option><option value=\"RIS\" translate=\"sceaApp.StoreType.RIS\">RIS</option><option value=\"PERFECT\" translate=\"sceaApp.StoreType.PERFECT\">PERFECT</option><option value=\"PC\" translate=\"sceaApp.StoreType.PC\">PC</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.percentageYtd\" for=\"field_percentageYtd\">Percentage Ytd</label><input type=\"number\" class=\"form-control\" name=\"percentageYtd\" id=\"field_percentageYtd\" ng-model=\"vm.adjustedAccumulation.percentageYtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.percentageMtd\" for=\"field_percentageMtd\">Percentage Mtd</label><input type=\"number\" class=\"form-control\" name=\"percentageMtd\" id=\"field_percentageMtd\" ng-model=\"vm.adjustedAccumulation.percentageMtd\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.adjustedAccumulation.percentageWtd\" for=\"field_percentageWtd\">Percentage Wtd</label><input type=\"number\" class=\"form-control\" name=\"percentageWtd\" id=\"field_percentageWtd\" ng-model=\"vm.adjustedAccumulation.percentageWtd\"></div><div class=\"form-group\"><label translate=\"sceaApp.adjustedAccumulation.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.adjustedAccumulation.employee\" ng-options=\"employee as employee.id for employee in vm.employees track by employee.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/adjusted-accumulation/adjusted-accumulations.html","<div><h2 translate=\"sceaApp.adjustedAccumulation.home.title\">Adjusted Accumulations</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"adjusted-accumulation.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.adjustedAccumulation.home.createLabel\">Create new Adjusted Accumulation</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.adjustedAccumulation.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"sceaApp.adjustedAccumulation.insertDate\">Insert Date</span></th><th><span translate=\"sceaApp.adjustedAccumulation.lastUpdatedDate\">Last Updated Date</span></th><th><span translate=\"sceaApp.adjustedAccumulation.year\">Year</span></th><th><span translate=\"sceaApp.adjustedAccumulation.month\">Month</span></th><th><span translate=\"sceaApp.adjustedAccumulation.week\">Week</span></th><th><span translate=\"sceaApp.adjustedAccumulation.category\">Category</span></th><th><span translate=\"sceaApp.adjustedAccumulation.storeType\">Store Type</span></th><th><span translate=\"sceaApp.adjustedAccumulation.percentageYtd\">Percentage Ytd</span></th><th><span translate=\"sceaApp.adjustedAccumulation.percentageMtd\">Percentage Mtd</span></th><th><span translate=\"sceaApp.adjustedAccumulation.percentageWtd\">Percentage Wtd</span></th><th><span translate=\"sceaApp.adjustedAccumulation.employee\">Employee</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"adjustedAccumulation in vm.adjustedAccumulations track by adjustedAccumulation.id\"><td><a ui-sref=\"adjusted-accumulation-detail({id:adjustedAccumulation.id})\">{{adjustedAccumulation.id}}</a></td><td>{{adjustedAccumulation.insertDate | date:\'d MMMM y\'}}</td><td>{{adjustedAccumulation.lastUpdatedDate | date:\'d MMMM y\'}}</td><td>{{adjustedAccumulation.year}}</td><td>{{adjustedAccumulation.month}}</td><td>{{adjustedAccumulation.week}}</td><td translate=\"{{\'sceaApp.Category.\' + adjustedAccumulation.category}}\">{{adjustedAccumulation.category}}</td><td translate=\"{{\'sceaApp.StoreType.\' + adjustedAccumulation.storeType}}\">{{adjustedAccumulation.storeType}}</td><td>{{adjustedAccumulation.percentageYtd}}</td><td>{{adjustedAccumulation.percentageMtd}}</td><td>{{adjustedAccumulation.percentageWtd}}</td><td><a ui-sref=\"employee-detail({id:adjustedAccumulation.employee.id})\">{{adjustedAccumulation.employee.id}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"adjusted-accumulation-detail({id:adjustedAccumulation.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"adjusted-accumulation.edit({id:adjustedAccumulation.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"adjusted-accumulation.delete({id:adjustedAccumulation.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/area/area-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.area.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.area.delete.question\" translate-values=\"{id: \'{{vm.area.id}}\'}\">Are you sure you want to delete this Area?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/area/area-detail.html","<div><h2><span translate=\"sceaApp.area.detail.title\">Area</span> {{vm.area.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.area.areaName\">Area Name</span></dt><dd><span>{{vm.area.areaName}}</span></dd><dt><span translate=\"sceaApp.area.parent\">Parent</span></dt><dd><a ui-sref=\"area-detail({id:vm.area.parentId})\">{{vm.area.parentName}}</a></dd><dt><span translate=\"sceaApp.area.areaLevel\">Area Level</span></dt><dd><a ui-sref=\"area-level-detail({id:vm.area.areaLevelId})\">{{vm.area.areaLevelName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/area/area-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAreaLabel\" translate=\"sceaApp.area.home.createOrEditLabel\">Create or edit a Area</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.area.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.area.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.area.areaName\" for=\"field_areaName\">Area Name</label><input type=\"text\" class=\"form-control\" name=\"areaName\" id=\"field_areaName\" ng-model=\"vm.area.areaName\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.area.parent\" for=\"field_parent\">Parent</label><input type=\"text\" ng-model=\"vm.parent\" name=\"parentName\" uib-typeahead=\"area as area.areaName for area in vm.getArea($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingArea\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group\"><label translate=\"sceaApp.area.areaLevel\" for=\"field_areaLevel\">Area Level</label><select class=\"form-control\" id=\"field_areaLevel\" name=\"areaLevel\" ng-model=\"vm.area.areaLevelId\" ng-options=\"areaLevel.id as areaLevel.levelName for areaLevel in vm.arealevels\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/area/areas.html","<div><h2 translate=\"sceaApp.area.home.title\">Areas</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"area.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.area.home.createLabel\">Create new Area</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.area.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"areaName\"><span translate=\"sceaApp.area.areaName\">Area Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parentId\"><span translate=\"sceaApp.area.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"areaLevelId\"><span translate=\"sceaApp.area.areaLevel\">Area Level</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"area in vm.areas track by area.id\"><td><a ui-sref=\"area-detail({id:area.id})\">{{area.id}}</a></td><td>{{area.areaName}}</td><td><a ui-sref=\"area-detail({id:area.parentId})\">{{area.parentName}}</a></td><td><a ui-sref=\"area-level-detail({id:area.areaLevelId})\">{{area.areaLevelName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"area-detail({id:area.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"area.edit({id:area.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"area.delete({id:area.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/area-level/area-level-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.areaLevel.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.areaLevel.delete.question\" translate-values=\"{id: \'{{vm.areaLevel.id}}\'}\">Are you sure you want to delete this Area Level?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/area-level/area-level-detail.html","<div><h2><span translate=\"sceaApp.areaLevel.detail.title\">Area Level</span> {{vm.areaLevel.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.areaLevel.levelName\">Level Name</span></dt><dd><span>{{vm.areaLevel.levelName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/area-level/area-level-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAreaLevelLabel\" translate=\"sceaApp.areaLevel.home.createOrEditLabel\">Create or edit a Area Level</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.areaLevel.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.areaLevel.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.areaLevel.levelName\" for=\"field_levelName\">Level Name</label><input type=\"text\" class=\"form-control\" name=\"levelName\" id=\"field_levelName\" ng-model=\"vm.areaLevel.levelName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/area-level/area-levels.html","<div><h2 translate=\"sceaApp.areaLevel.home.title\">Area Levels</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"area-level.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.areaLevel.home.createLabel\">Create new Area Level</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.areaLevel.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"levelName\"><span translate=\"sceaApp.areaLevel.levelName\">Level Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"areaLevel in vm.areaLevels track by areaLevel.id\"><td><a ui-sref=\"area-level-detail({id:areaLevel.id})\">{{areaLevel.id}}</a></td><td>{{areaLevel.levelName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"area-level-detail({id:areaLevel.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"area-level.edit({id:areaLevel.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"area-level.delete({id:areaLevel.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/attachment/attachment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.attachment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.attachment.delete.question\" translate-values=\"{id: \'{{vm.attachment.id}}\'}\">Are you sure you want to delete this Attachment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/attachment/attachment-detail.html","<div><h2><span translate=\"sceaApp.attachment.detail.title\">Attachment</span> {{vm.attachment.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.attachment.content\">Content</span></dt><dd><div ng-if=\"vm.attachment.content\">{{vm.attachment.contentContentType}}, {{vm.byteSize(vm.attachment.content)}}</div></dd><dt><span translate=\"sceaApp.attachment.fileName\">File Name</span></dt><dd><span>{{vm.attachment.fileName}}</span></dd><dt><span translate=\"sceaApp.attachment.size\">Size</span></dt><dd><span>{{vm.attachment.size}}</span></dd><dt><span translate=\"sceaApp.attachment.creationDate\">Creation Date</span></dt><dd><span>{{vm.attachment.creationDate | date:\'d MMMM y\'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/attachment/attachment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAttachmentLabel\" translate=\"sceaApp.attachment.home.createOrEditLabel\">Create or edit a Attachment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.attachment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.attachment.id\" readonly=\"readonly\"></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setContent($file, vm.attachment)\"><label class=\"control-label\" translate=\"sceaApp.attachment.content\" for=\"field_content\">Content</label><div><div ng-if=\"vm.attachment.content\" class=\"help-block clearfix\"><span class=\"pull-left\">{{vm.attachment.contentContentType}}, {{vm.byteSize(vm.attachment.content)}}</span> <button ng-click=\"vm.attachment.content=null;vm.attachment.contentContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setContent($file, vm.attachment)\" translate=\"entity.action.addblob\">Add blob</button></div><input type=\"hidden\" class=\"form-control\" name=\"content\" id=\"field_content\" ng-model=\"vm.attachment.content\" required maxbytes=\"5000000\"> <input type=\"hidden\" class=\"form-control\" name=\"contentContentType\" id=\"field_contentContentType\" ng-model=\"vm.attachment.contentContentType\"><div ng-show=\"editForm.content.$invalid\"><p class=\"help-block\" ng-show=\"editForm.content.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.content.$error.maxbytes\" translate=\"entity.validation.maxbytes\" translate-value-max=\"5000000\">This field cannot be more than 5000000.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.attachment.fileName\" for=\"field_fileName\">File Name</label><input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\" ng-model=\"vm.attachment.fileName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.attachment.size\" for=\"field_size\">Size</label><input type=\"number\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.attachment.size\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.attachment.creationDate\" for=\"field_creationDate\">Creation Date</label><div class=\"input-group\"><input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.attachment.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/attachment/attachments.html","<div><h2 translate=\"sceaApp.attachment.home.title\">Attachments</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"attachment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.attachment.home.createLabel\">Create new Attachment</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.attachment.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"content\"><span translate=\"sceaApp.attachment.content\">Content</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileName\"><span translate=\"sceaApp.attachment.fileName\">File Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"size\"><span translate=\"sceaApp.attachment.size\">Size</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creationDate\"><span translate=\"sceaApp.attachment.creationDate\">Creation Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"attachment in vm.attachments track by attachment.id\"><td><a ui-sref=\"attachment-detail({id:attachment.id})\">{{attachment.id}}</a></td><td><span ng-if=\"attachment.content\">{{attachment.contentContentType}}, {{vm.byteSize(attachment.content)}}</span></td><td>{{attachment.fileName}}</td><td>{{attachment.size}}</td><td>{{attachment.creationDate | date:\'d MMMM y\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"attachment-detail({id:attachment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"attachment.edit({id:attachment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"attachment.delete({id:attachment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/calendar/calendar-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.calendar.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.calendar.delete.question\" translate-values=\"{id: \'{{vm.calendar.id}}\'}\">Are you sure you want to delete this Calendar?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/calendar/calendar-detail.html","<div><h2><span translate=\"sceaApp.calendar.detail.title\">Calendar</span> {{vm.calendar.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.calendar.year\">Year</span></dt><dd><span>{{vm.calendar.year}}</span></dd><dt><span translate=\"sceaApp.calendar.month\">Month</span></dt><dd><span>{{vm.calendar.month}}</span></dd><dt><span translate=\"sceaApp.calendar.week\">Week</span></dt><dd><span>{{vm.calendar.week}}</span></dd><dt><span translate=\"sceaApp.calendar.startDate\">Start Date</span></dt><dd><span>{{vm.calendar.startDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.calendar.endDate\">End Date</span></dt><dd><span>{{vm.calendar.endDate | date:\'d MMMM y\'}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/calendar/calendar-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCalendarLabel\" translate=\"sceaApp.calendar.home.createOrEditLabel\">Create or edit a Calendar</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.calendar.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.calendar.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.calendar.year\" for=\"field_year\">Year</label><input type=\"number\" class=\"form-control\" name=\"year\" id=\"field_year\" ng-model=\"vm.calendar.year\" required max=\"9999\"><div ng-show=\"editForm.year.$invalid\"><p class=\"help-block\" ng-show=\"editForm.year.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.year.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999\">This field cannot be more than 9999.</p><p class=\"help-block\" ng-show=\"editForm.year.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.calendar.month\" for=\"field_month\">Month</label><input type=\"number\" class=\"form-control\" name=\"month\" id=\"field_month\" ng-model=\"vm.calendar.month\" required max=\"12\"><div ng-show=\"editForm.month.$invalid\"><p class=\"help-block\" ng-show=\"editForm.month.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.month.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"12\">This field cannot be more than 12.</p><p class=\"help-block\" ng-show=\"editForm.month.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.calendar.week\" for=\"field_week\">Week</label><input type=\"number\" class=\"form-control\" name=\"week\" id=\"field_week\" ng-model=\"vm.calendar.week\" required max=\"99\"><div ng-show=\"editForm.week.$invalid\"><p class=\"help-block\" ng-show=\"editForm.week.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.week.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"99\">This field cannot be more than 99.</p><p class=\"help-block\" ng-show=\"editForm.week.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.calendar.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" uib-datepicker-popup=\"d MMMM y\" ng-model=\"vm.calendar.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\" ng-change=\"vm.checkValidDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"vm.invalidDate\"><p class=\"help-block\" style=\"display: block\" data-translate=\"entity.validation.datefromuntil\">End Date should be greater than start date</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.calendar.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"d MMMM y\" ng-model=\"vm.calendar.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" ng-change=\"vm.checkValidDate()\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"vm.invalidDate\"><p class=\"help-block\" style=\"display: block\" data-translate=\"entity.validation.datefromuntil\">End Date should be greater than start date</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.invalidDate || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/calendar/calendars.html","<div><h2 translate=\"sceaApp.calendar.home.title\">Calendars</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"calendar.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.calendar.home.createLabel\">Create new Calendar</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.calendar.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"year\"><span translate=\"sceaApp.calendar.year\">Year</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"month\"><span translate=\"sceaApp.calendar.month\">Month</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"week\"><span translate=\"sceaApp.calendar.week\">Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"sceaApp.calendar.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"sceaApp.calendar.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"calendar in vm.calendars track by calendar.id\"><td><a ui-sref=\"calendar-detail({id:calendar.id})\">{{calendar.id}}</a></td><td>{{calendar.year}}</td><td>{{calendar.month}}</td><td>{{calendar.week}}</td><td>{{calendar.startDate | date:\'d MMMM y\'}}</td><td>{{calendar.endDate | date:\'d MMMM y\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"calendar-detail({id:calendar.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"calendar.edit({id:calendar.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"calendar.delete({id:calendar.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--     <div class=\"text-center\"> --><!--         <jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count> --><!--     </div> --><!--     <uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager> --><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/brand/brand-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.brand.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.brand.delete.question\" translate-values=\"{id: \'{{vm.brand.id}}\'}\">Are you sure you want to delete this Brand?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/brand/brand-detail.html","<div><h2><span translate=\"sceaApp.brand.detail.title\">Brand</span> {{vm.brand.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.brand.brandName\">Brand Name</span></dt><dd><span>{{vm.brand.brandName}}</span></dd><dt><span translate=\"sceaApp.brand.flag\">Flag</span></dt><dd><span>{{vm.brand.flag}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/brand/brand-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBrandLabel\" translate=\"sceaApp.brand.home.createOrEditLabel\">Create or edit a Brand</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.brand.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.brand.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.brand.brandName\" for=\"field_brandName\">Brand Name</label><input type=\"text\" class=\"form-control\" name=\"brandName\" id=\"field_brandName\" ng-model=\"vm.brand.brandName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.brand.flag\" for=\"field_flag\">Flag</label><select class=\"form-control\" id=\"field_flag\" name=\"flag\" ng-model=\"vm.brand.flag\"><option value=\"MA\">MA</option><option value=\"RIS\">RIS</option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/brand/brands.html","<div><h2 translate=\"sceaApp.brand.home.title\">Brands</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"brand.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.brand.home.createLabel\">Create new Brand</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.brand.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"brandName\"><span translate=\"sceaApp.brand.brandName\">Brand Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"flag\"><span translate=\"sceaApp.brand.flag\">Flag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"brand in vm.brands track by brand.id\"><td><a ui-sref=\"brand-detail({id:brand.id})\">{{brand.id}}</a></td><td>{{brand.brandName}}</td><td>{{brand.flag}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"brand-detail({id:brand.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"brand.edit({id:brand.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"brand.delete({id:brand.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/channel/channel-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.channel.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.channel.delete.question\" translate-values=\"{id: \'{{vm.channel.id}}\'}\">Are you sure you want to delete this Channel?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/channel/channel-detail.html","<div><h2><span translate=\"sceaApp.channel.detail.title\">Channel</span> {{vm.channel.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.channel.channelName\">Channel Name</span></dt><dd><span>{{vm.channel.channelName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/channel/channel-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myChannelLabel\" translate=\"sceaApp.channel.home.createOrEditLabel\">Create or edit a Channel</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.channel.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.channel.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.channel.channelName\" for=\"field_channelName\">Channel Name</label><input type=\"text\" class=\"form-control\" name=\"channelName\" id=\"field_channelName\" ng-model=\"vm.channel.channelName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/channel/channels.html","<div><h2 translate=\"sceaApp.channel.home.title\">Channels</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"channel.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.channel.home.createLabel\">Create new Channel</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.channel.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channelName\"><span translate=\"sceaApp.channel.channelName\">Channel Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"channel in vm.channels track by channel.id\"><td><a ui-sref=\"channel-detail({id:channel.id})\">{{channel.id}}</a></td><td>{{channel.channelName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"channel-detail({id:channel.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"channel.edit({id:channel.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"channel.delete({id:channel.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/dealer/dealer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.dealer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.dealer.delete.question\" translate-values=\"{id: \'{{vm.dealer.id}}\'}\">Are you sure you want to delete this Dealer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/dealer/dealer-detail.html","<div><h2><span translate=\"sceaApp.dealer.detail.title\">Dealer</span> {{vm.dealer.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.dealer.dealer_name\">Dealer Name</span></dt><dd><span>{{vm.dealer.dealer_name}}</span></dd><dt><span translate=\"sceaApp.dealer.dealer_address\">Dealer Address</span></dt><dd><span>{{vm.dealer.dealer_address}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/dealer/dealer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDealerLabel\" translate=\"sceaApp.dealer.home.createOrEditLabel\">Create or edit a Dealer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.dealer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.dealer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.dealer.dealer_name\" for=\"field_dealer_name\">Dealer Name</label><input type=\"text\" class=\"form-control\" name=\"dealer_name\" id=\"field_dealer_name\" ng-model=\"vm.dealer.dealer_name\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.dealer.dealer_address\" for=\"field_dealer_address\">Dealer Address</label><input type=\"text\" class=\"form-control\" name=\"dealer_address\" id=\"field_dealer_address\" ng-model=\"vm.dealer.dealer_address\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/dealer/dealers.html","<div><h2 translate=\"sceaApp.dealer.home.title\">Dealers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"dealer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.dealer.home.createLabel\">Create new Dealer</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.dealer.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dealer_name\"><span translate=\"sceaApp.dealer.dealer_name\">Dealer Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dealer_address\"><span translate=\"sceaApp.dealer.dealer_address\">Dealer Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"dealer in vm.dealers track by dealer.id\"><td><a ui-sref=\"dealer-detail({id:dealer.id})\">{{dealer.id}}</a></td><td>{{dealer.dealer_name}}</td><td>{{dealer.dealer_address}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"dealer-detail({id:dealer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"dealer.edit({id:dealer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"dealer.delete({id:dealer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/droppoint/droppoint-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.droppoint.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.droppoint.delete.question\" translate-values=\"{id: \'{{vm.droppoint.id}}\'}\">Are you sure you want to delete this Droppoint?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/droppoint/droppoint-detail.html","<div><h2><span translate=\"sceaApp.droppoint.detail.title\">Droppoint</span> {{vm.droppoint.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.droppoint.name\">Name</span></dt><dd><span>{{vm.droppoint.name}}</span></dd><dt><span translate=\"sceaApp.droppoint.code\">Code</span></dt><dd><span>{{vm.droppoint.code}}</span></dd><dt><span translate=\"sceaApp.droppoint.externalId\">External Id</span></dt><dd><span>{{vm.droppoint.externalId}}</span></dd><dt><span translate=\"sceaApp.droppoint.pic\">Pic</span></dt><dd>{{vm.droppoint.picLogin}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/droppoint/droppoint-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDroppointLabel\" translate=\"sceaApp.droppoint.home.createOrEditLabel\">Create or edit a Droppoint</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.droppoint.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.droppoint.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.droppoint.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.droppoint.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.droppoint.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.droppoint.code\" ng-minlength=\"1\" ng-maxlength=\"5\" required><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.minlength\" data-translate=\"entity.validation.minlength\" translate-value-min=\"1\">This field is required to be at least 1 characters.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"5\">This field cannot be longer than 5 characters.</p></div></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"sceaApp.droppoint.externalId\" for=\"field_externalId\">External Id</label>--><!--<input type=\"text\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\"--><!--ng-model=\"vm.droppoint.externalId\"--><!--/>--><!--</div>--><div class=\"form-group has-feedback\"><label translate=\"sceaApp.droppoint.pic\" for=\"field_pic\">Pic</label><input type=\"text\" ng-model=\"vm.vdo\" id=\"field_pic\" name=\"pic\" uib-typeahead=\"user as user.firstName+\' \'+user.lastName for user in vm.getUser(\'VDO\', $viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/droppoint/droppoints.html","<div><h2 translate=\"sceaApp.droppoint.home.title\">Droppoints</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"droppoint.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.droppoint.home.createLabel\">Create new Droppoint</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.droppoint.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.droppoint.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span translate=\"sceaApp.droppoint.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"picLogin\"><span translate=\"sceaApp.droppoint.pic\">Pic</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"sceaApp.droppoint.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"droppoint in vm.droppoints track by droppoint.id\"><td><a ui-sref=\"droppoint-detail({id:droppoint.id})\">{{droppoint.id}}</a></td><td>{{droppoint.name}}</td><td>{{droppoint.code}}</td><td><a ui-sref=\"user-management-detail({login:droppoint.picLogin})\">{{droppoint.picLogin}}</a></td><td>{{droppoint.externalId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"droppoint-detail({id:droppoint.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"droppoint.edit({id:droppoint.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"droppoint.delete({id:droppoint.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/equipment/equipment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.equipment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.equipment.delete.question\" translate-values=\"{id: \'{{vm.equipment.id}}\'}\">Are you sure you want to delete this Equipment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/equipment/equipment-detail.html","<div><h2><span translate=\"sceaApp.equipment.detail.title\">Equipment</span> {{vm.equipment.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.equipment.equipmentName\">Equipment Name</span></dt><dd><span>{{vm.equipment.equipmentName}}</span></dd><dt><span translate=\"sceaApp.equipment.highlight\">Highlight</span></dt><dd><span>{{vm.equipment.highlight}}</span></dd><dt><span translate=\"sceaApp.equipment.serialNumber\">Serial Number</span></dt><dd><span>{{vm.equipment.serialNumber}}</span></dd><dt><span translate=\"sceaApp.equipment.parent\">Parent</span></dt><dd><a ui-sref=\"equipment-detail({id:vm.equipment.parentId})\">{{vm.equipment.parentName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/equipment/equipment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myEquipmentLabel\" translate=\"sceaApp.equipment.home.createOrEditLabel\">Create or edit a Equipment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.equipment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.equipment.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.equipmentName\" for=\"field_equipmentName\">Equipment Name</label><input type=\"text\" class=\"form-control\" name=\"equipmentName\" id=\"field_equipmentName\" ng-model=\"vm.equipment.equipmentName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.highlight\" for=\"field_highlight\">Highlight</label><input type=\"checkbox\" class=\"form-control\" name=\"highlight\" id=\"field_highlight\" ng-model=\"vm.equipment.highlight\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.serialNumber\" for=\"field_serialNumber\">Serial Number</label><input type=\"checkbox\" class=\"form-control\" name=\"serialNumber\" id=\"field_serialNumber\" ng-model=\"vm.equipment.serialNumber\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.equipment.parent\">Parent</label><input type=\"text\" ng-model=\"vm.equipment.parentName\" name=\"parent\" uib-typeahead=\"prnt as prnt.equipmentName for prnt in vm.getParent($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingParent\" typeahead-on-select=\"vm.onSelectParent($item, $model, $label)\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/equipment/equipment.html","<div><h2 translate=\"sceaApp.equipment.home.title\">Equipment</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"equipment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.equipment.home.createLabel\">Create new Equipment</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.equipment.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"equipmentName\"><span translate=\"sceaApp.equipment.equipmentName\">Equipment Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"highlight\"><span translate=\"sceaApp.equipment.highlight\">Highlight</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serialNumber\"><span translate=\"sceaApp.equipment.serialNumber\">Serial Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parent.id\"><span translate=\"sceaApp.equipment.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"equipment in vm.equipment track by equipment.id\"><td><a ui-sref=\"equipment-detail({id:equipment.id})\">{{equipment.id}}</a></td><td>{{equipment.equipmentName}}</td><td>{{equipment.highlight}}</td><td>{{equipment.serialNumber}}</td><td><a ui-sref=\"equipment-detail({id:equipment.parentId})\">{{equipment.parentName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"equipment-detail({id:equipment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"equipment.edit({id:equipment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"equipment.delete({id:equipment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/fixtures/fixture-table-template.html","<div class=\"table-responsive\"><table class=\"table tree-grid\"><thead><tr><th><span ng-if=\"expandingProperty.sortable\" ng-click=\"sortBy(expandingProperty)\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}} &nbsp;&nbsp; <span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</span> <i ng-if=\"expandingProperty.sorted\" class=\"glyphicon {{expandingProperty.sortDirection == \'asc\' ? \'glyphicon-sort-by-attributes\' : \'glyphicon-sort-by-attributes-alt\'}}\"></i> <i ng-if=\"!expandingProperty.sorted\" class=\"glyphicon glyphicon-sort\"></i> </span><span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field}}</span></th><th ng-repeat=\"col in colDefinitions\"><span ng-if=\"col.sortable\" ng-click=\"sortBy(col);expandingProperty.sorted = false\">{{col.displayName || col.field}} &nbsp;&nbsp; <i ng-if=\"col.sorted\" class=\"glyphicon {{col.sortDirection == \'asc\' ? \'glyphicon-sort-by-attributes\' : \'glyphicon-sort-by-attributes-alt\'}}\"></i> <i ng-if=\"!col.sorted\" class=\"glyphicon glyphicon-sort\"></i> </span><span ng-if=\"!col.sortable\">{{col.displayName || col.field}}</span></th></tr></thead><tbody><tr ng-repeat=\"row in tree_rows | searchFor:$parent.vm.filterString:expandingProperty:colDefinitions:true track by row.branch.uid\" ng-class=\"\'level-\' + {{ row.level }} + (row.branch.selected ? \' active\':\'\')\" class=\"tree-grid-row\"><td><a ng-click=\"user_clicks_branch(row.branch)\"><i ng-class=\"row.level === 1 && !row.branch.children.length ? \'fa fa-folder-o\' : row.tree_icon\" ng-click=\"row.branch.expanded = !row.branch.expanded\" class=\"indented tree-icon\"></i> </a><span class=\"indented tree-label\" ng-click=\"on_user_click(row.branch)\">{{row.branch[expandingProperty.field] || row.branch[expandingProperty]}}</span></td><td ng-repeat=\"col in colDefinitions\"><div ng-if=\"col.cellTemplate\" compile=\"col.cellTemplate\" cell-template-scope=\"col.cellTemplateScope\"></div><div ng-if=\"!col.cellTemplate\">{{row.branch[col.field]}}</div></td></tr></tbody></table></div>");
$templateCache.put("app/entities/fixtures/fixtures-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.fixtures.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.fixtures.delete.question\" translate-values=\"{id: \'{{vm.fixtures.id}}\'}\">Are you sure you want to delete this Fixtures?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/fixtures/fixtures-detail.html","<div><h2><span translate=\"sceaApp.fixtures.detail.title\">Fixtures</span> {{vm.fixtures.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.fixtures.fixtureName\">Fixture Name</span></dt><dd><span>{{vm.fixtures.fixtureName}}</span></dd><dt><span translate=\"sceaApp.fixtures.parent\">Parent</span></dt><dd><a ui-sref=\"fixtures-detail({id:vm.fixtures.parentId})\">{{vm.fixtures.parentName}}</a></dd><dt><span translate=\"sceaApp.fixtures.category\">Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.fixtures.categoryId})\">{{vm.fixtures.categoryCategoryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/fixtures/fixtures-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFixturesLabel\" translate=\"sceaApp.fixtures.home.createOrEditLabel\">Create or edit a Fixtures</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.fixture.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.fixture.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.fixtures.fixtureName\" for=\"field_fixtureName\">Fixture Name</label><input type=\"text\" class=\"form-control\" name=\"fixtureName\" id=\"field_fixtureName\" ng-model=\"vm.fixture.fixtureName\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.fixtures.parent\" for=\"field_parent\">Parent</label><input type=\"text\" ng-model=\"vm.fixtureParent\" name=\"fixtureParent\" ng-disabled=\"vm.disableParent\" class=\"form-control\" id=\"field_parent\" uib-typeahead=\"fixture as fixture.fixtureName for fixture in vm.parents | filter:{fixtureName:$viewValue} | limitTo: 5\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingFixture\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group\"><label translate=\"sceaApp.fixtures.category\" for=\"field_category\">Category</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-model=\"vm.fixture.categoryId\" ng-options=\"productCategory.id as productCategory.categoryName for productCategory in vm.productCategories\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/fixtures/fixtures.html","<div><h2 translate=\"sceaApp.fixtures.home.title\">Fixtures</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-5 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"fixtures.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-md hidden-sm\" translate=\"sceaApp.fixtures.home.createLabel\">Create new Fixtures</span></button> <button class=\"btn btn-primary\" ng-click=\"myTree.expand_all();\"><span class=\"fa fa-folder-open\"></span> <span class=\"hidden-xs hidden-md hidden-sm\">Expand All</span></button> <button class=\"btn btn-primary\" ng-click=\"myTree.collapse_all();\"><span class=\"fa fa-folder\"></span> <span class=\"hidden-xs hidden-md hidden-sm\">Collapse All</span></button></div><div class=\"col-xs-7 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.fixtures.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.filterString\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div><tree-grid tree-data=\"vm.fixtures\" icon-expand=\"fa fa-folder\" icon-collapse=\"fa fa-folder-open\" expand-on=\"vm.expandProp\" col-defs=\"vm.colDefinitions\" tree-control=\"myTree\" template-url=\"app/entities/fixtures/fixture-table-template.html\"></tree-grid></div></div>");
$templateCache.put("app/entities/formula-widget/formula-widgets.html","<div ng-init=\"vm.initWidget()\" id=\"formulaWidget\"><div class=\"row\"><div class=\"col-md-12\"><span><b>Select a field</b></span><br><div class=\"panel panel-default\" style=\"height: 80px; overflow-y: auto; padding: 5px\"><p style=\"margin: 0\" ng-repeat=\"field in vm.optionsField\" ng-click=\"vm.generateField(field)\">{{field.columnName}}</p></div></div><div class=\"col-md-8\"><span><b>Sellout</b></span><br><form name=\"formSellout\" class=\"panel panel-default\" style=\"padding: 1em\"><div class=\"form-group\"><div><label class=\"radio-inline\"><input type=\"radio\" name=\"selloutOptions\" value=\"outlet\" ng-model=\"vm.sellout.formula\"> <span>Outlet</span></label><label class=\"radio-inline\"><input type=\"radio\" name=\"selloutOptions\" value=\"branch\" ng-model=\"vm.sellout.formula\"> <span>Branch(Sum.)</span></label></div><br><div><span><b>From :</b></span><br><div class=\"form-horizontal\" style=\"padding-left: 1em\"><div class=\"form-group custom-margin\"><div class=\"col-md-2 text-right\" style=\"padding: 8px 15px\"><span for=\"fromYear\">Year :</span></div><div class=\"col-md-4\" style=\"padding: 0\"><select class=\"form-control input-sm\" ng-model=\"vm.sellout.optionFromYear\"><option value=\"inYear\">Input year</option><option value=\"lpYear\">Last project year</option></select></div><div class=\"col-md-1\" style=\"padding: 0\"><select class=\"form-control input-sm\" style=\"padding: 5px\" ng-model=\"vm.sellout.oprFromYear\"><option value=\"+\">+</option><option value=\"-\">-</option></select></div><div class=\"col-md-2\" style=\"padding: 0\"><input type=\"number\" class=\"form-control input-sm\" ng-pattern=\"/^[0-9]+$/\" name=\"inputFromYear\" min=\"0\" ng-model=\"vm.sellout.inputFromYear\"></div><div class=\"col-md-3\" style=\"padding: 5px 15px\"><span ng-if=\"formSellout.inputFromYear.$valid == true\">years</span> <span ng-if=\"formSellout.inputFromYear.$valid == false\">Invalid input</span></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-2 text-right\" style=\"padding: 8px 15px\"><span for=\"fromYear\">Month :</span></div><div class=\"col-md-4\" style=\"padding: 0\"><select class=\"form-control input-sm\" ng-model=\"vm.sellout.optionFromMonth\"><option value=\"inMonth\">Input month</option><option value=\"lpMonth\">Last project month</option><option ng-repeat=\"month in [1,2,3,4,5,6,7,8,9,10,11,12]\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><div class=\"col-md-1\" style=\"padding: 0\"><select class=\"form-control input-sm\" style=\"padding: 5px\" ng-model=\"vm.sellout.oprFromMonth\"><option value=\"+\">+</option><option value=\"-\">-</option></select></div><div class=\"col-md-2\" style=\"padding: 0\"><input type=\"number\" class=\"form-control input-sm\" ng-pattern=\"/^[0-9]+$/\" name=\"inputFromMonth\" min=\"0\" ng-model=\"vm.sellout.inputFromMonth\"></div><div class=\"col-md-3\" style=\"padding: 5px 15px\"><span ng-if=\"formSellout.inputFromMonth.$valid == true\">months</span> <span ng-if=\"formSellout.inputFromMonth.$valid == false\"><small>Invalid input</small></span></div></div></div></div><br><div><span><b>To :</b></span><br><div class=\"form-horizontal\" style=\"padding-left: 1em\"><div class=\"form-group custom-margin\"><div class=\"col-md-2 text-right\" style=\"padding: 8px 15px\"><span for=\"fromYear\">Year :</span></div><div class=\"col-md-4\" style=\"padding: 0\"><select class=\"form-control input-sm\" ng-model=\"vm.sellout.optionToYear\"><option value=\"inYear\">Input year</option><option value=\"lpYear\">Last project year</option></select></div><div class=\"col-md-1\" style=\"padding: 0\"><select class=\"form-control input-sm\" style=\"padding: 5px\" ng-model=\"vm.sellout.oprToYear\"><option value=\"+\">+</option><option value=\"-\">-</option></select></div><div class=\"col-md-2\" style=\"padding: 0\"><input type=\"number\" class=\"form-control input-sm\" ng-pattern=\"/^[0-9]+$/\" name=\"inputToYear\" min=\"0\" ng-model=\"vm.sellout.inputToYear\"></div><div class=\"col-md-3\" style=\"padding: 5px 15px\"><span ng-if=\"formSellout.inputToYear.$valid == true\">years</span> <span ng-if=\"formSellout.inputToYear.$valid == false\">Invalid input</span></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-2 text-right\" style=\"padding: 8px 15px\"><span for=\"fromYear\">Month :</span></div><div class=\"col-md-4\" style=\"padding: 0\"><select class=\"form-control input-sm\" ng-model=\"vm.sellout.optionToMonth\"><option value=\"inMonth\">Input month</option><option value=\"lpMonth\">Last project month</option><option ng-repeat=\"month in [1,2,3,4,5,6,7,8,9,10,11,12]\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><div class=\"col-md-1\" style=\"padding: 0\"><select class=\"form-control input-sm\" style=\"padding: 5px\" ng-model=\"vm.sellout.oprToMonth\"><option value=\"+\">+</option><option value=\"-\">-</option></select></div><div class=\"col-md-2\" style=\"padding: 0\"><input type=\"number\" class=\"form-control input-sm\" ng-pattern=\"/^[0-9]+$/\" name=\"inputToMonth\" min=\"0\" ng-model=\"vm.sellout.inputToMonth\"></div><div class=\"col-md-3\" style=\"padding: 5px 15px\"><span ng-if=\"formSellout.inputToMonth.$valid == true\">months</span> <span ng-if=\"formSellout.inputToMonth.$valid == false\">Invalid input</span></div></div></div></div></div><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addSellout()\" ng-disabled=\"formSellout.$invalid\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;<span translate=\"entity.action.add\">Add</span></button></div></form></div><div class=\"col-md-4\"><span><b>Choose Operators</b></span><br><div class=\"panel panel-default\" id=\"paddding-popover\" style=\"padding: 1em\"><div class=\"text-center\"><p><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\"(\" ng-click=\"vm.addFormula(\'(\', \'(\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\")\" ng-click=\"vm.addFormula(\')\', \')\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\"*\" ng-click=\"vm.addFormula(\'*\', \'*\', \'opr\')\"></p><p><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\"/\" ng-click=\"vm.addFormula(\'/\', \'/\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\"-\" ng-click=\"vm.addFormula(\'-\', \'-\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\"+\" ng-click=\"vm.addFormula(\'+\', \'+\', \'opr\')\"></p><p><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"7\" ng-click=\"vm.addFormula(\'7\', \'7\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"8\" ng-click=\"vm.addFormula(\'8\', \'8\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"9\" ng-click=\"vm.addFormula(\'9\', \'9\', \'opr\')\"></p><p><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"4\" ng-click=\"vm.addFormula(\'4\', \'4\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"5\" ng-click=\"vm.addFormula(\'5\', \'5\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"6\" ng-click=\"vm.addFormula(\'6\', \'6\', \'opr\')\"></p><p><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"1\" ng-click=\"vm.addFormula(\'1\', \'1\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"2\" ng-click=\"vm.addFormula(\'2\', \'2\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"3\" ng-click=\"vm.addFormula(\'3\', \'3\', \'opr\')\"></p><p style=\"margin: 3px\"><input type=\"button\" class=\"btn btn-calculator btn-warning\" value=\"c\" ng-click=\"vm.clearFormula()\"><input type=\"button\" class=\"btn btn-calculator btn-info\" value=\"0\" ng-click=\"vm.addFormula(\'0\', \'0\', \'opr\')\"><input type=\"button\" class=\"btn btn-calculator btn-default\" value=\".\" ng-click=\"vm.addFormula(\'.\', \'.\', \'opr\')\"></p></div></div></div></div><div class=\"formulaWidget dropzone\" style=\"height: 150px; overflow-y: auto; border: 1px solid #DDDDDD\"><div class=\"dropzone\"><ul dnd-list=\"vm.formulas\" dnd-allowed-types=\"[\'itemType\']\" dnd-horizontal-list=\"true\" dnd-external-sources=\"true\" class=\"itemlist\"><li ng-repeat=\"item in vm.formulas\" dnd-draggable=\"item\" dnd-type=\"\'itemType\'\" dnd-effect-allowed=\"moveCopy\" dnd-moved=\"vm.formulas.splice($index, 1)\" dnd-canceled=\"vm.formulas.splice($index, 1)\" id=\"{{item.type}}\">{{item.label}}</li></ul></div></div></div>");
$templateCache.put("app/entities/formula-field/formula-field-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.formulaField.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.formulaField.delete.question\" translate-values=\"{id: \'{{vm.formulaField.id}}\'}\">Are you sure you want to delete this Formula Field?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/formula-field/formula-field-detail.html","<div><h2><span translate=\"sceaApp.formulaField.detail.title\">Formula Field</span> {{vm.formulaField.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.formulaField.name\">Name</span></dt><dd><span>{{vm.formulaField.name}}</span></dd><dt><span translate=\"sceaApp.formulaField.formula\">Formula</span></dt><dd><!--             <span>{{vm.formulaField.formula}}</span> --> <span ng-repeat=\"formula in vm.formulaField.formula track by $index\">{{formula}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/formula-field/formula-field-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFormulaFieldLabel\" translate=\"sceaApp.formulaField.home.createOrEditLabel\">Create or edit a Formula Field</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"form-group\" ng-show=\"vm.formulaField.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.formulaField.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.formulaField.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.formulaField.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.formulaField.formula\" for=\"field_formula\">Formula</label><div class=\"form-control\" style=\"height: 75px; overflow-y: auto; border: 1px solid #DDDDDD\" uib-popover-template=\"vm.dynamicPopover\" popover-placement=\"bottom-left\"><span ng-repeat=\"formula in vm.formulas\">{{formula.label}}</span></div><input type=\"hidden\" name=\"formula\" id=\"field_formula\" ng-model=\"vm.formulaField.formula\" class=\"form-control\" popover-placement=\"bottom-left\" required><div ng-show=\"editForm.formula.$invalid\"><p class=\"help-block\" ng-show=\"editForm.formula.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/formula-field/formula-fields.html","<div><h2 translate=\"sceaApp.formulaField.home.title\">Formula Fields</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"formula-field.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.formulaField.home.createLabel\">Create new Formula Field</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.formulaField.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.formulaField.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formula\"><span translate=\"sceaApp.formulaField.formula\">Formula</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"formulaField in vm.formulaFields track by formulaField.id\"><td><a ui-sref=\"formula-field-detail({id:formulaField.id})\">{{formulaField.id}}</a></td><td>{{formulaField.name}}</td><td><span ng-repeat=\"formula in formulaField.formula track by $index\">{{formula}}</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"formula-field-detail({id:formulaField.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"formula-field.edit({id:formulaField.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"formula-field.delete({id:formulaField.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/internet/internet-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.internet.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.internet.delete.question\" translate-values=\"{id: \'{{vm.internet.id}}\'}\">Are you sure you want to delete this Internet?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/internet/internet-detail.html","<div><h2><span translate=\"sceaApp.internet.detail.title\">Internet</span> {{vm.internet.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.internet.internetName\">Internet Name</span></dt><dd><span>{{vm.internet.internetName}}</span></dd><dt><span translate=\"sceaApp.internet.connection\">Connection</span></dt><dd><a ui-sref=\"internet-connection-detail({id:vm.internet.connectionId})\">{{vm.internet.connectionConnectionName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/internet/internet-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInternetLabel\" translate=\"sceaApp.internet.home.createOrEditLabel\">Create or edit a Internet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.internet.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.internet.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.internet.internetName\" for=\"field_internetName\">Internet Name</label><input type=\"text\" class=\"form-control\" name=\"internetName\" id=\"field_internetName\" ng-model=\"vm.internet.internetName\"></div><div class=\"form-group\"><label translate=\"sceaApp.internet.connection\" for=\"field_connection\">Connection</label><select class=\"form-control\" id=\"field_connection\" name=\"connection\" ng-model=\"vm.internet.connectionId\" ng-options=\"internetConnection.id as internetConnection.connectionName for internetConnection in vm.internetconnections\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/internet/internets.html","<div><h2 translate=\"sceaApp.internet.home.title\">Internets</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"internet.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.internet.home.createLabel\">Create new Internet</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.internet.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"internetName\"><span translate=\"sceaApp.internet.internetName\">Internet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"connection.connectionName\"><span translate=\"sceaApp.internet.connection\">Connection</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"internet in vm.internets track by internet.id\"><td><a ui-sref=\"internet-detail({id:internet.id})\">{{internet.id}}</a></td><td>{{internet.internetName}}</td><td><a ui-sref=\"internet-connection-detail({id:internet.connectionId})\">{{internet.connectionConnectionName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"internet-detail({id:internet.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"internet.edit({id:internet.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"internet.delete({id:internet.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/internet-answer/internet-answer-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.internetAnswer.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.internetAnswer.delete.question\" translate-values=\"{id: \'{{vm.internetAnswer.id}}\'}\">Are you sure you want to delete this Internet Answer?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/internet-answer/internet-answer-detail.html","<div><h2><span translate=\"sceaApp.internetAnswer.detail.title\">Internet Answer</span> {{vm.internetAnswer.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.internetAnswer.answerName\">Answer Name</span></dt><dd><span>{{vm.internetAnswer.answerName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/internet-answer/internet-answer-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInternetAnswerLabel\" translate=\"sceaApp.internetAnswer.home.createOrEditLabel\">Create or edit a Internet Answer</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.internetAnswer.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.internetAnswer.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.internetAnswer.answerName\" for=\"field_answerName\">Answer Name</label><input type=\"text\" class=\"form-control\" name=\"answerName\" id=\"field_answerName\" ng-model=\"vm.internetAnswer.answerName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/internet-answer/internet-answers.html","<div><h2 translate=\"sceaApp.internetAnswer.home.title\">Internet Answers</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"internet-answer.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.internetAnswer.home.createLabel\">Create new Internet Answer</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.internetAnswer.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"answerName\"><span translate=\"sceaApp.internetAnswer.answerName\">Answer Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"internetAnswer in vm.internetAnswers track by internetAnswer.id\"><td><a ui-sref=\"internet-answer-detail({id:internetAnswer.id})\">{{internetAnswer.id}}</a></td><td>{{internetAnswer.answerName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"internet-answer-detail({id:internetAnswer.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"internet-answer.edit({id:internetAnswer.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"internet-answer.delete({id:internetAnswer.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/internet-connection/internet-connection-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.internetConnection.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.internetConnection.delete.question\" translate-values=\"{id: \'{{vm.internetConnection.id}}\'}\">Are you sure you want to delete this Internet Connection?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/internet-connection/internet-connection-detail.html","<div><h2><span translate=\"sceaApp.internetConnection.detail.title\">Internet Connection</span> {{vm.internetConnection.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.internetConnection.connectionName\">Connection Name</span></dt><dd><span>{{vm.internetConnection.connectionName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/internet-connection/internet-connection-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInternetConnectionLabel\" translate=\"sceaApp.internetConnection.home.createOrEditLabel\">Create or edit a Internet Connection</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.internetConnection.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.internetConnection.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.internetConnection.connectionName\" for=\"field_connectionName\">Connection Name</label><input type=\"text\" class=\"form-control\" name=\"connectionName\" id=\"field_connectionName\" ng-model=\"vm.internetConnection.connectionName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/internet-connection/internet-connections.html","<div><h2 translate=\"sceaApp.internetConnection.home.title\">Internet Connections</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"internet-connection.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.internetConnection.home.createLabel\">Create new Internet Connection</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.internetConnection.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"connectionName\"><span translate=\"sceaApp.internetConnection.connectionName\">Connection Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"internetConnection in vm.internetConnections track by internetConnection.id\"><td><a ui-sref=\"internet-connection-detail({id:internetConnection.id})\">{{internetConnection.id}}</a></td><td>{{internetConnection.connectionName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"internet-connection-detail({id:internetConnection.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"internet-connection.edit({id:internetConnection.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"internet-connection.delete({id:internetConnection.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/internet-qa/internet-qa-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.internetQa.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.internetQa.delete.question\" translate-values=\"{id: \'{{vm.internetQa.id}}\'}\">Are you sure you want to delete this Internet Qa?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/internet-qa/internet-qa-detail.html","<div><h2><span translate=\"sceaApp.internetQa.detail.title\">Internet Qa</span> {{vm.internetQa.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.internetQa.internet\">Internet</span></dt><dd><a ui-sref=\"internet-detail({id:vm.internetQa.internetId})\">{{vm.internetQa.internetInternetName}}</a></dd><dt><span translate=\"sceaApp.internetQa.answer\">Answer</span></dt><dd><a ui-sref=\"internet-answer-detail({id:vm.internetQa.answerId})\">{{vm.internetQa.answerAnswerName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/internet-qa/internet-qa-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInternetQaLabel\" translate=\"sceaApp.internetQa.home.createOrEditLabel\">Create or edit a Internet Qa</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.internetQa.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.internetQa.id\" readonly=\"readonly\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.internetQa.internet\">Internet</label><input type=\"text\" ng-model=\"vm.internetQa.internetInternetName\" name=\"internet\" uib-typeahead=\"inet as inet.internetName for inet in vm.getInternet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingInternet\" typeahead-on-select=\"vm.onSelectInternet($item, $model, $label)\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.internetQa.answer\">Answer</label><input type=\"text\" ng-model=\"vm.internetQa.answerAnswerName\" name=\"answer\" uib-typeahead=\"aswr as aswr.answerName for aswr in vm.getAnswer($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingAnswer\" typeahead-on-select=\"vm.onSelectAnswer($item, $model, $label)\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/internet-qa/internet-qas.html","<div><h2 translate=\"sceaApp.internetQa.home.title\">Internet Qas</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"internet-qa.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.internetQa.home.createLabel\">Create new Internet Qa</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.internetQa.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"internetInternetName\"><span translate=\"sceaApp.internetQa.internet\">Internet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"answerAnswerName\"><span translate=\"sceaApp.internetQa.answer\">Answer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"internetQa in vm.internetQas track by internetQa.id\"><td><a ui-sref=\"internet-qa-detail({id:internetQa.id})\">{{internetQa.id}}</a></td><td><a ui-sref=\"internet-detail({id:internetQa.internetId})\">{{internetQa.internetInternetName}}</a></td><td><a ui-sref=\"internet-answer-detail({id:internetQa.answerId})\">{{internetQa.answerAnswerName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"internet-qa-detail({id:internetQa.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"internet-qa.edit({id:internetQa.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"internet-qa.delete({id:internetQa.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/launch-period/launch-period-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.launchPeriod.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.launchPeriod.delete.question\" translate-values=\"{id: \'{{vm.launchPeriod.id}}\'}\">Are you sure you want to delete this Launch Period?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/launch-period/launch-period-detail.html","<div><h2><span translate=\"sceaApp.launchPeriod.detail.title\">Launch Period</span> {{vm.launchPeriod.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.launchPeriod.periodName\">Period Name</span></dt><dd><span>{{vm.launchPeriod.periodName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/launch-period/launch-period-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myLaunchPeriodLabel\" translate=\"sceaApp.launchPeriod.home.createOrEditLabel\">Create or edit a Launch Period</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.launchPeriod.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.launchPeriod.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.launchPeriod.periodName\" for=\"field_periodName\">Period Name</label><input type=\"text\" class=\"form-control\" name=\"periodName\" id=\"field_periodName\" ng-model=\"vm.launchPeriod.periodName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/launch-period/launch-periods.html","<div><h2 translate=\"sceaApp.launchPeriod.home.title\">Launch Periods</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"launch-period.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.launchPeriod.home.createLabel\">Create new Launch Period</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.launchPeriod.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"periodName\"><span translate=\"sceaApp.launchPeriod.periodName\">Period Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"launchPeriod in vm.launchPeriods track by launchPeriod.id\"><td><a ui-sref=\"launch-period-detail({id:launchPeriod.id})\">{{launchPeriod.id}}</a></td><td>{{launchPeriod.periodName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"launch-period-detail({id:launchPeriod.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"launch-period.edit({id:launchPeriod.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"launch-period.delete({id:launchPeriod.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/order-pop/order-pop-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.orderPop.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.orderPop.delete.question\" translate-values=\"{id: \'{{vm.orderPop.id}}\'}\">Are you sure you want to delete this Order Pop?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order-pop/order-pop-detail.html","<div><h2><span translate=\"sceaApp.orderPop.detail.title\">Order Pop</span> {{vm.orderPop.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.orderPop.requestQty\">Request Qty</span></dt><dd><span>{{vm.orderPop.requestQty}}</span></dd><dt><span translate=\"sceaApp.orderPop.sentQty\">Sent Qty</span></dt><dd><span>{{vm.orderPop.sentQty}}</span></dd><dt><span translate=\"sceaApp.orderPop.deliveredQty\">Delivered Qty</span></dt><dd><span>{{vm.orderPop.deliveredQty}}</span></dd><dt><span translate=\"sceaApp.orderPop.requestDate\">Request Date</span></dt><dd><span>{{vm.orderPop.requestDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.orderPop.sentDate\">Sent Date</span></dt><dd><span>{{vm.orderPop.sentDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.orderPop.deliveredDate\">Delivered Date</span></dt><dd><span>{{vm.orderPop.deliveredDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.orderPop.requestStatus\">Request Status</span></dt><dd><span translate=\"{{\'sceaApp.RequestStatus.\' + vm.orderPop.requestStatus}}\">{{vm.orderPop.requestStatus}}</span></dd><dt><span translate=\"sceaApp.orderPop.user\">User</span></dt><dd>{{vm.orderPop.userLogin}}</dd><dt><span translate=\"sceaApp.orderPop.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.orderPop.outletId})\">{{vm.orderPop.outletName}}</a></dd><dt><span translate=\"sceaApp.orderPop.pop\">Pop</span></dt><dd><a ui-sref=\"pop-detail({id:vm.orderPop.popId})\">{{vm.orderPop.popName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order-pop/order-pop-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderPopLabel\" translate=\"sceaApp.orderPop.home.createOrEditLabel\">Create or edit a Order Pop</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.orderPop.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.orderPop.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.requestQty\" for=\"field_requestQty\">Request Qty</label><input type=\"number\" class=\"form-control\" name=\"requestQty\" id=\"field_requestQty\" ng-model=\"vm.orderPop.requestQty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.sentQty\" for=\"field_sentQty\">Sent Qty</label><input type=\"number\" class=\"form-control\" name=\"sentQty\" id=\"field_sentQty\" ng-model=\"vm.orderPop.sentQty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.deliveredQty\" for=\"field_deliveredQty\">Delivered Qty</label><input type=\"number\" class=\"form-control\" name=\"deliveredQty\" id=\"field_deliveredQty\" ng-model=\"vm.orderPop.deliveredQty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.requestDate\" for=\"field_requestDate\">Request Date</label><div class=\"input-group\"><input id=\"field_requestDate\" type=\"text\" class=\"form-control\" name=\"requestDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.orderPop.requestDate\" is-open=\"vm.datePickerOpenStatus.requestDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'requestDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.sentDate\" for=\"field_sentDate\">Sent Date</label><div class=\"input-group\"><input id=\"field_sentDate\" type=\"text\" class=\"form-control\" name=\"sentDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.orderPop.sentDate\" is-open=\"vm.datePickerOpenStatus.sentDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'sentDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.deliveredDate\" for=\"field_deliveredDate\">Delivered Date</label><div class=\"input-group\"><input id=\"field_deliveredDate\" type=\"text\" class=\"form-control\" name=\"deliveredDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.orderPop.deliveredDate\" is-open=\"vm.datePickerOpenStatus.deliveredDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'deliveredDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.orderPop.requestStatus\" for=\"field_requestStatus\">Request Status</label><select class=\"form-control\" name=\"requestStatus\" ng-model=\"vm.orderPop.requestStatus\" id=\"field_requestStatus\" required><option value=\"REQUESTED\" translate=\"sceaApp.RequestStatus.REQUESTED\">REQUESTED</option><option value=\"SENT\" translate=\"sceaApp.RequestStatus.SENT\">SENT</option><option value=\"DELIVERED\" translate=\"sceaApp.RequestStatus.DELIVERED\">DELIVERED</option><option value=\"NOTSENT\" translate=\"sceaApp.RequestStatus.NOTSENT\">NOTSENT</option></select><div ng-show=\"editForm.requestStatus.$invalid\"><p class=\"help-block\" ng-show=\"editForm.requestStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"sceaApp.orderPop.user\" for=\"field_user\">User</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.orderPop.userId\" ng-options=\"user.id as user.login for user in vm.users\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.user.$invalid\"><p class=\"help-block\" ng-show=\"editForm.user.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"sceaApp.orderPop.outlet\" for=\"field_outlet\">Outlet</label><select class=\"form-control\" id=\"field_outlet\" name=\"outlet\" ng-model=\"vm.orderPop.outletId\" ng-options=\"outlet.id as outlet.name for outlet in vm.outlets\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.outlet.$invalid\"><p class=\"help-block\" ng-show=\"editForm.outlet.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"sceaApp.orderPop.pop\" for=\"field_pop\">Pop</label><select class=\"form-control\" id=\"field_pop\" name=\"pop\" ng-model=\"vm.orderPop.popId\" ng-options=\"pop.id as pop.name for pop in vm.pops\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.pop.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pop.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order-pop/order-pops.html","<div><h2 translate=\"sceaApp.orderPop.home.title\">Order Pops</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"order-pop.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.orderPop.home.createLabel\">Create new Order Pop</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.orderPop.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestQty\"><span translate=\"sceaApp.orderPop.requestQty\">Request Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sentQty\"><span translate=\"sceaApp.orderPop.sentQty\">Sent Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deliveredQty\"><span translate=\"sceaApp.orderPop.deliveredQty\">Delivered Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestDate\"><span translate=\"sceaApp.orderPop.requestDate\">Request Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sentDate\"><span translate=\"sceaApp.orderPop.sentDate\">Sent Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deliveredDate\"><span translate=\"sceaApp.orderPop.deliveredDate\">Delivered Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestStatus\"><span translate=\"sceaApp.orderPop.requestStatus\">Request Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userLogin\"><span translate=\"sceaApp.orderPop.user\">User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletName\"><span translate=\"sceaApp.orderPop.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popName\"><span translate=\"sceaApp.orderPop.pop\">Pop</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"orderPop in vm.orderPops track by orderPop.id\"><td><a ui-sref=\"order-pop-detail({id:orderPop.id})\">{{orderPop.id}}</a></td><td>{{orderPop.requestQty}}</td><td>{{orderPop.sentQty}}</td><td>{{orderPop.deliveredQty}}</td><td>{{orderPop.requestDate | date:\'d MMMM y\'}}</td><td>{{orderPop.sentDate | date:\'d MMMM y\'}}</td><td>{{orderPop.deliveredDate | date:\'d MMMM y\'}}</td><td translate=\"{{\'sceaApp.RequestStatus.\' + orderPop.requestStatus}}\">{{orderPop.requestStatus}}</td><td>{{orderPop.userLogin}}</td><td><a ui-sref=\"outlet-detail({id:orderPop.outletId})\">{{orderPop.outletName}}</a></td><td><a ui-sref=\"pop-detail({id:orderPop.popId})\">{{orderPop.popName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-pop-detail({id:orderPop.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order-pop.edit({id:orderPop.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order-pop.delete({id:orderPop.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/other-job-brand/other-job-brand-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.otherJobBrand.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.otherJobBrand.delete.question\" translate-values=\"{id: \'{{vm.otherJobBrand.id}}\'}\">Are you sure you want to delete this Other Job Brand?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/other-job-brand/other-job-brand-detail.html","<div><h2><span translate=\"sceaApp.otherJobBrand.detail.title\">Other Job Brand</span> {{vm.otherJobBrand.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.otherJobBrand.formNo\">Form No</span></dt><dd><span>{{vm.otherJobBrand.formNo}}</span></dd><dt><span translate=\"sceaApp.otherJobBrand.value\">Value</span></dt><dd><span>{{vm.otherJobBrand.value}}</span></dd><dt><span translate=\"sceaApp.otherJobBrand.brand\">Brand</span></dt><dd><a ui-sref=\"brand-detail({id:vm.otherJobBrand.brandId})\">{{vm.otherJobBrand.brandBrandName}}</a></dd><dt><span translate=\"sceaApp.otherJobBrand.productInch\">Product Inch</span></dt><dd><a ui-sref=\"product-inch-detail({id:vm.otherJobBrand.productInchId})\">{{vm.otherJobBrand.productInchDeskripsi}}</a></dd><dt><span translate=\"sceaApp.otherJobBrand.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.otherJobBrand.productCategoryId})\">{{vm.otherJobBrand.productCategoryCategoryName}}</a></dd><dt><span translate=\"sceaApp.otherJobBrand.otherJob\">Other Job</span></dt><dd><a ui-sref=\"other-job-detail({id:vm.otherJobBrand.otherJobId})\">{{vm.otherJobBrand.otherJobId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/other-job-brand/other-job-brand-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOtherJobBrandLabel\" translate=\"sceaApp.otherJobBrand.home.createOrEditLabel\">Create or edit a Other Job Brand</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.otherJobBrand.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.otherJobBrand.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.otherJobBrand.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.otherJobBrand.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.otherJobBrand.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.otherJobBrand.value\"></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobBrand.brand\" for=\"field_brand\">Brand</label><select class=\"form-control\" id=\"field_brand\" name=\"brand\" ng-model=\"vm.otherJobBrand.brandId\" ng-options=\"brand.id as brand.brandName for brand in vm.brands\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobBrand.productInch\" for=\"field_productInch\">Product Inch</label><select class=\"form-control\" id=\"field_productInch\" name=\"productInch\" ng-model=\"vm.otherJobBrand.productInchId\" ng-options=\"productInch.id as productInch.deskripsi for productInch in vm.productinches\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobBrand.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" name=\"productCategory\" ng-model=\"vm.otherJobBrand.productCategoryId\" ng-options=\"productCategory.id as productCategory.categoryName for productCategory in vm.productcategories\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobBrand.otherJob\" for=\"field_otherJob\">Other Job</label><select class=\"form-control\" id=\"field_otherJob\" name=\"otherJob\" ng-model=\"vm.otherJobBrand.otherJobId\" ng-options=\"otherJob.id as otherJob.id for otherJob in vm.otherjobs\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/other-job-brand/other-job-brands.html","<div><h2 translate=\"sceaApp.otherJobBrand.home.title\">Other Job Brands</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"other-job-brand.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.otherJobBrand.home.createLabel\">Create new Other Job Brand</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.otherJobBrand.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.otherJobBrand.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.otherJobBrand.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"brandBrandName\"><span translate=\"sceaApp.otherJobBrand.brand\">Brand</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productInchDeskripsi\"><span translate=\"sceaApp.otherJobBrand.productInch\">Product Inch</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCategoryCategoryName\"><span translate=\"sceaApp.otherJobBrand.productCategory\">Product Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"otherJobId\"><span translate=\"sceaApp.otherJobBrand.otherJob\">Other Job</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"otherJobBrand in vm.otherJobBrands track by otherJobBrand.id\"><td><a ui-sref=\"other-job-brand-detail({id:otherJobBrand.id})\">{{otherJobBrand.id}}</a></td><td>{{otherJobBrand.formNo}}</td><td>{{otherJobBrand.value}}</td><td><a ui-sref=\"brand-detail({id:otherJobBrand.brandId})\">{{otherJobBrand.brandBrandName}}</a></td><td><a ui-sref=\"product-inch-detail({id:otherJobBrand.productInchId})\">{{otherJobBrand.productInchDeskripsi}}</a></td><td><a ui-sref=\"product-category-detail({id:otherJobBrand.productCategoryId})\">{{otherJobBrand.productCategoryCategoryName}}</a></td><td><a ui-sref=\"other-job-detail({id:otherJobBrand.otherJobId})\">{{otherJobBrand.otherJobId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"other-job-brand-detail({id:otherJobBrand.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"other-job-brand.edit({id:otherJobBrand.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"other-job-brand.delete({id:otherJobBrand.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/other-job-store-completeness/other-job-store-completeness-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.otherJobStoreCompleteness.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.otherJobStoreCompleteness.delete.question\" translate-values=\"{id: \'{{vm.otherJobStoreCompleteness.id}}\'}\">Are you sure you want to delete this Other Job Store Completeness?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/other-job-store-completeness/other-job-store-completeness-detail.html","<div><h2><span translate=\"sceaApp.otherJobStoreCompleteness.detail.title\">Other Job Store Completeness</span> {{vm.otherJobStoreCompleteness.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.otherJobStoreCompleteness.value\">Value</span></dt><dd><span>{{vm.otherJobStoreCompleteness.value}}</span></dd><dt><span translate=\"sceaApp.otherJobStoreCompleteness.formNo\">Form No</span></dt><dd><span>{{vm.otherJobStoreCompleteness.formNo}}</span></dd><dt><span translate=\"sceaApp.otherJobStoreCompleteness.storeCompleteness\">Store Completeness</span></dt><dd><a ui-sref=\"store-completeness-detail({id:vm.otherJobStoreCompleteness.storeCompletenessId})\">{{vm.otherJobStoreCompleteness.storeCompletenessDescription}}</a></dd><dt><span translate=\"sceaApp.otherJobStoreCompleteness.otherJob\">Other Job</span></dt><dd><a ui-sref=\"other-job-detail({id:vm.otherJobStoreCompleteness.otherJobId})\">{{vm.otherJobStoreCompleteness.otherJobId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/other-job-store-completeness/other-job-store-completeness-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOtherJobStoreCompletenessLabel\" translate=\"sceaApp.otherJobStoreCompleteness.home.createOrEditLabel\">Create or edit a Other Job Store Completeness</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.otherJobStoreCompleteness.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.otherJobStoreCompleteness.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.otherJobStoreCompleteness.value\" for=\"field_value\">Value</label><input type=\"checkbox\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.otherJobStoreCompleteness.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.otherJobStoreCompleteness.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.otherJobStoreCompleteness.formNo\"></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobStoreCompleteness.storeCompleteness\" for=\"field_storeCompleteness\">Store Completeness</label><select class=\"form-control\" id=\"field_storeCompleteness\" name=\"storeCompleteness\" ng-model=\"vm.otherJobStoreCompleteness.storeCompletenessId\" ng-options=\"storeCompleteness.id as storeCompleteness.description for storeCompleteness in vm.storecompletenesses\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.otherJobStoreCompleteness.otherJob\" for=\"field_otherJob\">Other Job</label><select class=\"form-control\" id=\"field_otherJob\" name=\"otherJob\" ng-model=\"vm.otherJobStoreCompleteness.otherJobId\" ng-options=\"otherJob.id as otherJob.id for otherJob in vm.otherjobs\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/other-job-store-completeness/other-job-store-completenesses.html","<div><h2 translate=\"sceaApp.otherJobStoreCompleteness.home.title\">Other Job Store Completenesses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"other-job-store-completeness.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.otherJobStoreCompleteness.home.createLabel\">Create new Other Job Store Completeness</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.otherJobStoreCompleteness.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.otherJobStoreCompleteness.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.otherJobStoreCompleteness.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"storeCompletenessDescription\"><span translate=\"sceaApp.otherJobStoreCompleteness.storeCompleteness\">Store Completeness</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"otherJobId\"><span translate=\"sceaApp.otherJobStoreCompleteness.otherJob\">Other Job</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"otherJobStoreCompleteness in vm.otherJobStoreCompletenesses track by otherJobStoreCompleteness.id\"><td><a ui-sref=\"other-job-store-completeness-detail({id:otherJobStoreCompleteness.id})\">{{otherJobStoreCompleteness.id}}</a></td><td>{{otherJobStoreCompleteness.value}}</td><td>{{otherJobStoreCompleteness.formNo}}</td><td><a ui-sref=\"store-completeness-detail({id:otherJobStoreCompleteness.storeCompletenessId})\">{{otherJobStoreCompleteness.storeCompletenessDescription}}</a></td><td><a ui-sref=\"other-job-detail({id:otherJobStoreCompleteness.otherJobId})\">{{otherJobStoreCompleteness.otherJobId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"other-job-store-completeness-detail({id:otherJobStoreCompleteness.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"other-job-store-completeness.edit({id:otherJobStoreCompleteness.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"other-job-store-completeness.delete({id:otherJobStoreCompleteness.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/other-job-type/other-job-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.otherJobType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.otherJobType.delete.question\" translate-values=\"{id: \'{{vm.otherJobType.id}}\'}\">Are you sure you want to delete this Other Job Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/other-job-type/other-job-type-detail.html","<div><h2><span translate=\"sceaApp.otherJobType.detail.title\">Other Job Type</span> {{vm.otherJobType.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.otherJobType.typeName\">Type Name</span></dt><dd><span>{{vm.otherJobType.typeName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/other-job-type/other-job-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOtherJobTypeLabel\" translate=\"sceaApp.otherJobType.home.createOrEditLabel\">Create or edit a Other Job Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.otherJobType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.otherJobType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.otherJobType.typeName\" for=\"field_typeName\">Type Name</label><input type=\"text\" class=\"form-control\" name=\"typeName\" id=\"field_typeName\" ng-model=\"vm.otherJobType.typeName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/other-job-type/other-job-types.html","<div><h2 translate=\"sceaApp.otherJobType.home.title\">Other Job Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"other-job-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.otherJobType.home.createLabel\">Create new Other Job Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.otherJobType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"typeName\"><span translate=\"sceaApp.otherJobType.typeName\">Type Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"otherJobType in vm.otherJobTypes track by otherJobType.id\"><td><a ui-sref=\"other-job-type-detail({id:otherJobType.id})\">{{otherJobType.id}}</a></td><td>{{otherJobType.typeName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"other-job-type-detail({id:otherJobType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"other-job-type.edit({id:otherJobType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"other-job-type.delete({id:otherJobType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/outlet/outlet-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outlet.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.outlet.delete.question\" translate-values=\"{id: \'{{vm.outlet.id}}\'}\">Are you sure you want to delete this Outlet?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/outlet/outlet-detail.html","<div><h2><span translate=\"sceaApp.outlet.detail.title\">Outlet</span> {{vm.outlet.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.outlet.outletCode\">Outlet Code</span></dt><dd><span>{{vm.outlet.outletCode}}</span></dd><dt><span translate=\"sceaApp.outlet.outletName\">Outlet Name</span></dt><dd><span>{{vm.outlet.outletName}}</span></dd><dt><span translate=\"sceaApp.outlet.outletAddress\">Outlet Address</span></dt><dd><span>{{vm.outlet.outletAddress}}</span></dd><dt><span translate=\"sceaApp.outlet.latitude\">Latitude</span></dt><dd><span>{{vm.outlet.latitude}}</span></dd><dt><span translate=\"sceaApp.outlet.longitude\">Longitude</span></dt><dd><span>{{vm.outlet.longitude}}</span></dd><dt><span translate=\"sceaApp.outlet.outletFacility\">Outlet Facility</span></dt><dd><span>{{vm.outlet.outletFacility}}</span></dd><dt><span translate=\"sceaApp.outlet.pcStatus\">Pc Status</span></dt><dd><span>{{vm.outlet.pcStatus}}</span></dd><dt><span translate=\"sceaApp.outlet.perfectStoreStatus\">Perfect Store Status</span></dt><dd><span>{{vm.outlet.perfectStoreStatus}}</span></dd><dt><span translate=\"sceaApp.outlet.risStatus\">Ris Status</span></dt><dd><span>{{vm.outlet.risStatus}}</span></dd><dt><span translate=\"sceaApp.outlet.channel\">Channel</span></dt><dd><a ui-sref=\"channel-detail({id:vm.outlet.channelId})\">{{vm.outlet.channelName}}</a></dd><dt><span translate=\"sceaApp.outlet.account\">Account</span></dt><dd><a ui-sref=\"outlet-account-detail({id:vm.outlet.accountId})\">{{vm.outlet.accountName}}</a></dd><dt><span translate=\"sceaApp.outlet.outletType\">Outlet Type</span></dt><dd><a ui-sref=\"outlet-type-detail({id:vm.outlet.outletTypeId})\">{{vm.outlet.outletTypeName}}</a></dd><dt><span translate=\"sceaApp.outlet.promotor\">Promotor</span></dt><dd><a ui-sref=\"user-management-detail({login:vm.outlet.promotorLogin})\">{{vm.outlet.promotorLogin}}</a></dd><dt><span translate=\"sceaApp.outlet.vdo\">VDO</span></dt><dd><a ui-sref=\"user-management-detail({login:vm.outlet.grade})\">{{vm.outlet.vdoFirstName}} {{vm.outlet.vdoLastName}}</a></dd><dt><span translate=\"sceaApp.outlet.city\">City</span></dt><dd><a ui-sref=\"area-detail({id:vm.outlet.areaId})\">{{vm.outlet.areaName}}</a></dd><dt><span translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span></dt><dd><a ui-sref=\"visit-cycle-detail({id:vm.outlet.visitCycleId})\">{{vm.outlet.visitCycleStoreGrade}}</a></dd><dt><span translate=\"sceaApp.outlet.popPairVersion\">POP Pair Version</span></dt><dd><a ui-sref=\"pop-pair-version-detail({id:vm.outlet.popPairVersionId})\">{{vm.outlet.popPairVersionName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet/outlet-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletLabel\" translate=\"sceaApp.outlet.home.createOrEditLabel\">Create or edit a Outlet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.outlet.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.outlet.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletCode\" for=\"field_outletCode\">Outlet Code</label><input type=\"text\" class=\"form-control\" name=\"outletCode\" id=\"field_outletCode\" ng-model=\"vm.outlet.outletCode\" ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.checkOutletCode(vm.outlet.outletCode)\" required><div ng-show=\"editForm.outletCode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.outletCode.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.outletCode.$error.unique\">This code already exists.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletName\" for=\"field_outletName\">Outlet Name</label><input type=\"text\" class=\"form-control\" name=\"outletName\" id=\"field_outletName\" ng-model=\"vm.outlet.outletName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletAddress\" for=\"field_outletAddress\">Outlet Address</label><input type=\"text\" class=\"form-control\" name=\"outletAddress\" id=\"field_outletAddress\" ng-model=\"vm.outlet.outletAddress\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletFacility\" for=\"field_outletFacility\">Outlet Facility</label><input type=\"checkbox\" class=\"form-control\" name=\"outletFacility\" id=\"field_outletFacility\" ng-model=\"vm.outlet.outletFacility\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.pcStatus\" for=\"field_pcStatus\">Pc Status</label><input type=\"checkbox\" class=\"form-control\" name=\"pcStatus\" id=\"field_pcStatus\" ng-model=\"vm.outlet.pcStatus\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.perfectStoreStatus\" for=\"field_perfectStoreStatus\">Perfect Store Status</label><input type=\"checkbox\" class=\"form-control\" name=\"perfectStoreStatus\" id=\"field_perfectStoreStatus\" ng-model=\"vm.outlet.perfectStoreStatus\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.risStatus\" for=\"field_risStatus\">Ris Status</label><input type=\"checkbox\" class=\"form-control\" name=\"risStatus\" id=\"field_risStatus\" ng-model=\"vm.outlet.risStatus\"></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.channel\" for=\"field_channel\">Channel</label><select class=\"form-control\" id=\"field_channel\" name=\"channel\" ng-model=\"vm.outlet.channelId\" ng-options=\"channel.id as channel.channelName for channel in vm.channels\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.account\" for=\"field_account\">Account</label><select class=\"form-control\" id=\"field_account\" name=\"account\" ng-model=\"vm.outlet.accountId\" ng-options=\"outletAccount.id as outletAccount.accountName for outletAccount in vm.outletaccounts\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.outletType\" for=\"field_outletType\">Outlet Type</label><select class=\"form-control\" id=\"field_outletType\" name=\"outletType\" ng-model=\"vm.outlet.outletTypeId\" ng-options=\"outletType.id as outletType.outletTypeName for outletType in vm.outlettypes\"><option value=\"\"></option></select></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outlet.promotor\" for=\"field_promotor\">Promotor</label><input type=\"text\" ng-model=\"vm.promotor\" id=\"field_promotor\" name=\"promotor\" uib-typeahead=\"user as user.firstName+\' \'+user.lastName for user in vm.getUser(\'PC\', $viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outlet.vde\" for=\"field_vdo\">VDE</label><input type=\"text\" ng-model=\"vm.vdo\" id=\"field_vdo\" name=\"vdo\" uib-typeahead=\"user as user.firstName+\' \'+user.lastName for user in vm.getUser(\'VDE\', $viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outlet.city\" for=\"field_area\">City</label><input type=\"text\" ng-model=\"vm.outletArea\" name=\"area\" uib-typeahead=\"area as area.areaName for area in vm.getArea($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingArea\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outlet.popPairVersion\" for=\"field_popPairVersion\">POP Pair Version</label><input type=\"text\" ng-model=\"vm.popPairVersion\" name=\"popPairVersion\" uib-typeahead=\"popPairVersion as popPairVersion.name for popPairVersion in vm.getPopPairVersion($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingPopPairVersion\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.visitCycle\" for=\"field_visitCycle\">Visit Cycle</label><select class=\"form-control\" id=\"field_visitCycle\" name=\"visitCycle\" ng-model=\"vm.outlet.visitCycleId\" ng-options=\"visitCycle.id as visitCycle.storeGrade for visitCycle in vm.visitcycles\"><option value=\"\"></option></select></div><div class=\"form-group\"><div><leaflet style=\"width: 100%; height: 50vh\"></leaflet></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outlet.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.outlet.latitude\" ng-change=\"vm.updateMarker()\" min=\"-90\" max=\"90\" step=\"0.001\"><div ng-show=\"editForm.latitude.$invalid\"><p class=\"help-block\" ng-show=\"editForm.latitude.$error.min\" data-translate=\"entity.validation.min\" translate-value-min=\"-90\">This field should be more than -90.</p><p class=\"help-block\" ng-show=\"editForm.latitude.$error.max\" data-translate=\"entity.validation.max\" translate-value-max=\"90\">This field cannot be more than 90.</p><p class=\"help-block\" ng-show=\"editForm.latitude.$error.number\" data-translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outlet.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.outlet.longitude\" ng-change=\"vm.updateMarker()\" min=\"-180\" max=\"180\" step=\"0.001\"><div ng-show=\"editForm.longitude.$invalid\"><p class=\"help-block\" ng-show=\"editForm.longitude.$error.min\" data-translate=\"entity.validation.min\" translate-value-min=\"-180\">This field should be more than -180.</p><p class=\"help-block\" ng-show=\"editForm.longitude.$error.max\" data-translate=\"entity.validation.max\" translate-value-max=\"180\">This field cannot be more than 180.</p><p class=\"help-block\" ng-show=\"editForm.longitude.$error.number\" data-translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/outlet/outlet-grade-import.html","<div><h2><span data-translate=\"sceaApp.outlet.import.gradeImport.title\">Import Outlet</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet/outlet-import.html","<div><h2><span data-translate=\"sceaApp.outlet.import.title\">Import Outlet</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet/outlet-map.html","<div><jhi-alert></jhi-alert><div id=\"outlet-map\"></div></div>");
$templateCache.put("app/entities/outlet/outlet-pop-pair-version-import.html","<div><h2><span data-translate=\"sceaApp.outlet.import.popPairVersionImport.title\">Import Outlet</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet/outlet-vdo-import.html","<div><h2><span data-translate=\"sceaApp.outlet.import.vdoImport.title\">Import Outlet</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet/outlets.html","<div><h2 translate=\"sceaApp.outlet.home.title\">Outlets</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-2 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"outlet.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outlet.home.createLabel\">Create new Outlet</span></button></div><div class=\"col-xs-4\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span translate=\"entity.action.action\">Action</span><span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ui-sref=\"outlet-map\"><span class=\"glyphicon glyphicon-map-marker\"></span> <span>Show on Map</span></a></li><li><a ng-click=\"vm.exportAsCsv()\"><span class=\"glyphicon glyphicon-export\"></span> <span>Export as CSV</span></a></li><li><a ui-sref=\"outlet-import\"><span class=\"glyphicon glyphicon-import\"></span> <span translate=\"sceaApp.outlet.home.importLabel\">Import Outlet</span></a></li><li><a ui-sref=\"outlet-vdo-import\"><span class=\"glyphicon glyphicon-import\"></span> <span translate=\"sceaApp.outlet.home.importVDOLabel\">Import VDO Mapping</span></a></li><li><a ui-sref=\"outlet-grade-import\"><span class=\"glyphicon glyphicon-import\"></span> <span translate=\"sceaApp.outlet.home.importGradeLabel\">Import Grade Mapping</span></a></li><li><a ui-sref=\"outlet-pop-pair-version-import\"><span class=\"glyphicon glyphicon-import\"></span> <span translate=\"sceaApp.outlet.home.importPopPairVersionLabel\">Import Pop Pair Version Mapping</span></a></li></ul></div></div><div class=\"col-xs-6 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletCode\"><span translate=\"sceaApp.outlet.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletName\"><span translate=\"sceaApp.outlet.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletAddress\"><span translate=\"sceaApp.outlet.outletAddress\">Outlet Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletFacility\"><span translate=\"sceaApp.outlet.outletFacility\">Outlet Facility</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pcStatus\"><span translate=\"sceaApp.outlet.pcStatus\">Pc Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"perfectStoreStatus\"><span translate=\"sceaApp.outlet.perfectStoreStatus\">Perfect Store Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"risStatus\"><span translate=\"sceaApp.outlet.risStatus\">Ris Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channel.id\"><span translate=\"sceaApp.outlet.channel\">Channel</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"account.id\"><span translate=\"sceaApp.outlet.account\">Account</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletType.id\"><span translate=\"sceaApp.outlet.outletType\">Outlet Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"promotor.login\"><span translate=\"sceaApp.outlet.promotor\">Promotor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vdo.firstName\"><span translate=\"sceaApp.outlet.vde\">VDE</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"area.id\"><span translate=\"sceaApp.outlet.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"visitCycle.storeGrade\"><span translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popPairVersion.name\"><span translate=\"sceaApp.outlet.popPairVersion\">POP Pair Version</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span translate=\"sceaApp.outlet.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span translate=\"sceaApp.outlet.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outlet in vm.outlets track by outlet.id\"><td><a ui-sref=\"outlet-detail({id:outlet.id})\">{{outlet.id}}</a></td><td>{{outlet.outletCode}}</td><td>{{outlet.outletName}}</td><td>{{outlet.outletAddress}}</td><td>{{outlet.outletFacility}}</td><td>{{outlet.pcStatus}}</td><td>{{outlet.perfectStoreStatus}}</td><td>{{outlet.risStatus}}</td><td><a ui-sref=\"channel-detail({id:outlet.channelId})\">{{outlet.channelName}}</a></td><td><a ui-sref=\"outlet-account-detail({id:outlet.accountId})\">{{outlet.accountName}}</a></td><td><a ui-sref=\"outlet-type-detail({id:outlet.outletTypeId})\">{{outlet.outletTypeName}}</a></td><td><a ui-sref=\"user-management-detail({login:outlet.promotorLogin})\">{{outlet.promotorLogin}}</a></td><td><a ui-sref=\"user-management-detail({login:outlet.grade})\">{{outlet.vdoFirstName}} {{outlet.vdoLastName}}</a></td><td><a ui-sref=\"area-detail({id:outlet.areaId})\">{{outlet.areaName}}</a></td><td><a ui-sref=\"visit-cycle-detail({id:outlet.visitCycleId})\">{{outlet.visitCycleStoreGrade}}</a></td><td><a ui-sref=\"pop-pair-version-detail({id:outlet.popPairVersionId})\">{{outlet.popPairVersionName}}</a></td><td>{{outlet.latitude}}</td><td>{{outlet.longitude}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"outlet-detail({id:outlet.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"outlet.edit({id:outlet.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"outlet.delete({id:outlet.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/outlet-account/outlet-account-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outletAccount.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.outletAccount.delete.question\" translate-values=\"{id: \'{{vm.outletAccount.id}}\'}\">Are you sure you want to delete this Outlet Account?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/outlet-account/outlet-account-detail.html","<div><h2><span translate=\"sceaApp.outletAccount.detail.title\">Outlet Account</span> {{vm.outletAccount.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.outletAccount.accountName\">Account Name</span></dt><dd><span>{{vm.outletAccount.accountName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet-account/outlet-account-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletAccountLabel\" translate=\"sceaApp.outletAccount.home.createOrEditLabel\">Create or edit a Outlet Account</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.outletAccount.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.outletAccount.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outletAccount.accountName\" for=\"field_accountName\">Account Name</label><input type=\"text\" class=\"form-control\" name=\"accountName\" id=\"field_accountName\" ng-model=\"vm.outletAccount.accountName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/outlet-account/outlet-accounts.html","<div><h2 translate=\"sceaApp.outletAccount.home.title\">Outlet Accounts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"outlet-account.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outletAccount.home.createLabel\">Create new Outlet Account</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outletAccount.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"accountName\"><span translate=\"sceaApp.outletAccount.accountName\">Account Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outletAccount in vm.outletAccounts track by outletAccount.id\"><td><a ui-sref=\"outlet-account-detail({id:outletAccount.id})\">{{outletAccount.id}}</a></td><td>{{outletAccount.accountName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"outlet-account-detail({id:outletAccount.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"outlet-account.edit({id:outletAccount.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"outlet-account.delete({id:outletAccount.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/outlet-retail-mapping/outlet-retail-mapping-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outletRetailMapping.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"sceaApp.outletRetailMapping.delete.question\" translate-values=\"{id: \'{{vm.outletRetailMapping.id}}\'}\">Are you sure you want to delete this Outlet Retail Mapping?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/outlet-retail-mapping/outlet-retail-mapping-detail.html","<div><h2><span data-translate=\"sceaApp.outletRetailMapping.detail.title\">Outlet Retail Mapping</span> {{vm.outletRetailMapping.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"sceaApp.outletRetailMapping.code\">Code</span></dt><dd><span>{{vm.outletRetailMapping.code}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.name\">Name</span></dt><dd><span>{{vm.outletRetailMapping.name}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.address\">Address</span></dt><dd><span>{{vm.outletRetailMapping.address}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.phoneNumber\">Phone Number</span></dt><dd><span>{{vm.outletRetailMapping.phoneNumber}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.personInCharge\">Person In Charge</span></dt><dd><span>{{vm.outletRetailMapping.personInCharge}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.picStatus\">Pic Status</span></dt><dd><span>{{vm.outletRetailMapping.picStatus}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.provinsi\">Provinsi</span></dt><dd><span>{{vm.outletRetailMapping.provinsi}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.kabupaten\">Kabupaten</span></dt><dd><span>{{vm.outletRetailMapping.kabupaten}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.kecamatan\">Kecamatan</span></dt><dd><span>{{vm.outletRetailMapping.kecamatan}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.kelurahan\">Kelurahan</span></dt><dd><span>{{vm.outletRetailMapping.kelurahan}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.postalCode\">Postal Code</span></dt><dd><span>{{vm.outletRetailMapping.postalCode}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.mcsOutletId\">Mcs Outlet Id</span></dt><dd><span>{{vm.outletRetailMapping.mcsOutletId}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.withPromotor\">With Promotor</span></dt><dd><span>{{vm.outletRetailMapping.withPromotor}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.longitude\">Longitude</span></dt><dd><span>{{vm.outletRetailMapping.longitude}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.latitude\">Latitude</span></dt><dd><span>{{vm.outletRetailMapping.latitude}}</span></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.channel\">Channel</span></dt><dd><a ui-sref=\"channel-detail({id:vm.outletRetailMapping.channelId})\">{{vm.outletRetailMapping.channelChannelName}}</a></dd><dt><span data-translate=\"sceaApp.outletRetailMapping.retailMappingSurveyor\">Retail Mapping Surveyor</span></dt><dd>{{vm.outletRetailMapping.retailMappingSurveyorLogin}}</dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"outlet-retail-mapping-detail.edit({id:vm.outletRetailMapping.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/outlet-retail-mapping/outlet-retail-mapping-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletRetailMappingLabel\" data-translate=\"sceaApp.outletRetailMapping.home.createOrEditLabel\">Create or edit a Outlet Retail Mapping</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.outletRetailMapping.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.outletRetailMapping.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.outletRetailMapping.code\" required><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.outletRetailMapping.name\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.outletRetailMapping.address\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.phoneNumber\" for=\"field_phoneNumber\">Phone Number</label><input type=\"text\" class=\"form-control\" name=\"phoneNumber\" id=\"field_phoneNumber\" ng-model=\"vm.outletRetailMapping.phoneNumber\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.personInCharge\" for=\"field_personInCharge\">Person In Charge</label><input type=\"text\" class=\"form-control\" name=\"personInCharge\" id=\"field_personInCharge\" ng-model=\"vm.outletRetailMapping.personInCharge\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.picStatus\" for=\"field_picStatus\">Pic Status</label><input type=\"text\" class=\"form-control\" name=\"picStatus\" id=\"field_picStatus\" ng-model=\"vm.outletRetailMapping.picStatus\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.provinsi\" for=\"field_provinsi\">Provinsi</label><input type=\"text\" class=\"form-control\" name=\"provinsi\" id=\"field_provinsi\" ng-model=\"vm.outletRetailMapping.provinsi\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.kabupaten\" for=\"field_kabupaten\">Kabupaten</label><input type=\"text\" class=\"form-control\" name=\"kabupaten\" id=\"field_kabupaten\" ng-model=\"vm.outletRetailMapping.kabupaten\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.kecamatan\" for=\"field_kecamatan\">Kecamatan</label><input type=\"text\" class=\"form-control\" name=\"kecamatan\" id=\"field_kecamatan\" ng-model=\"vm.outletRetailMapping.kecamatan\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.kelurahan\" for=\"field_kelurahan\">Kelurahan</label><input type=\"text\" class=\"form-control\" name=\"kelurahan\" id=\"field_kelurahan\" ng-model=\"vm.outletRetailMapping.kelurahan\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.postalCode\" for=\"field_postalCode\">Postal Code</label><input type=\"number\" class=\"form-control\" name=\"postalCode\" id=\"field_postalCode\" ng-model=\"vm.outletRetailMapping.postalCode\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.mcsOutletId\" for=\"field_mcsOutletId\">Mcs Outlet Id</label><input type=\"text\" class=\"form-control\" name=\"mcsOutletId\" id=\"field_mcsOutletId\" ng-model=\"vm.outletRetailMapping.mcsOutletId\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.withPromotor\" for=\"field_withPromotor\">With Promotor</label><input type=\"checkbox\" name=\"withPromotor\" id=\"field_withPromotor\" ng-model=\"vm.outletRetailMapping.withPromotor\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.outletRetailMapping.longitude\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.outletRetailMapping.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.outletRetailMapping.latitude\"></div><div class=\"form-group\"><label data-translate=\"sceaApp.outletRetailMapping.channel\" for=\"field_channel\">Channel</label><select class=\"form-control\" id=\"field_channel\" name=\"channel\" ng-model=\"vm.outletRetailMapping.channelId\" ng-options=\"channel.id as channel.channelName for channel in vm.channels\"><option value=\"\"></option></select></div><div class=\"form-group has-feedback\"><label data-translate=\"sceaApp.outletRetailMapping.retailMappingSurveyor\" for=\"field_retailMappingSurveyor\">Retail Mapping Surveyor</label><input type=\"text\" ng-model=\"vm.surveyor\" id=\"field_retailMappingSurveyor\" name=\"retailMappingSurveyor\" uib-typeahead=\"user as user.firstName+\' \'+user.lastName for user in vm.getUser(null, $viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingUser\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/outlet-retail-mapping/outlet-retail-mapping-import.html","<div><h2><span data-translate=\"sceaApp.outletRetailMapping.import.title\">Import Outlet Retail Mapping</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"sceaApp.outletRetailMapping.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"sceaApp.outletRetailMapping.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet-retail-mapping/outlet-retail-mappings.html","<div><h2 data-translate=\"sceaApp.outletRetailMapping.home.title\">Outlet Retail Mappings</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"outlet-retail-mapping.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs-down\" data-translate=\"sceaApp.outletRetailMapping.home.createLabel\">Create new Outlet Retail Mapping</span></button> <button class=\"btn btn-primary\" ui-sref=\"outlet-retail-mapping-import\"><span class=\"glyphicon glyphicon-import\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"sceaApp.outletRetailMapping.home.importLabel\">Import Outlet Retail Mapping</span></button></div><div class=\"col-xs-4 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outletRetailMapping.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"code\"><span data-translate=\"sceaApp.outletRetailMapping.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span data-translate=\"sceaApp.outletRetailMapping.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span data-translate=\"sceaApp.outletRetailMapping.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"phoneNumber\"><span data-translate=\"sceaApp.outletRetailMapping.phoneNumber\">Phone Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personInCharge\"><span data-translate=\"sceaApp.outletRetailMapping.personInCharge\">Person In Charge</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"picStatus\"><span data-translate=\"sceaApp.outletRetailMapping.picStatus\">Pic Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"provinsi\"><span data-translate=\"sceaApp.outletRetailMapping.provinsi\">Provinsi</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kabupaten\"><span data-translate=\"sceaApp.outletRetailMapping.kabupaten\">Kabupaten</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kecamatan\"><span data-translate=\"sceaApp.outletRetailMapping.kecamatan\">Kecamatan</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kelurahan\"><span data-translate=\"sceaApp.outletRetailMapping.kelurahan\">Kelurahan</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postalCode\"><span data-translate=\"sceaApp.outletRetailMapping.postalCode\">Postal Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mcsOutletId\"><span data-translate=\"sceaApp.outletRetailMapping.mcsOutletId\">Mcs Outlet Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"withPromotor\"><span data-translate=\"sceaApp.outletRetailMapping.withPromotor\">With Promotor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span data-translate=\"sceaApp.outletRetailMapping.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span data-translate=\"sceaApp.outletRetailMapping.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"channelChannelName\"><span data-translate=\"sceaApp.outletRetailMapping.channel\">Channel</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"retailMappingSurveyorLogin\"><span data-translate=\"sceaApp.outletRetailMapping.retailMappingSurveyor\">Retail Mapping Surveyor</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outletRetailMapping in vm.outletRetailMappings track by outletRetailMapping.id\"><td><a ui-sref=\"outlet-retail-mapping-detail({id:outletRetailMapping.id})\">{{outletRetailMapping.id}}</a></td><td>{{outletRetailMapping.code}}</td><td>{{outletRetailMapping.name}}</td><td>{{outletRetailMapping.address}}</td><td>{{outletRetailMapping.phoneNumber}}</td><td>{{outletRetailMapping.personInCharge}}</td><td>{{outletRetailMapping.picStatus}}</td><td>{{outletRetailMapping.provinsi}}</td><td>{{outletRetailMapping.kabupaten}}</td><td>{{outletRetailMapping.kecamatan}}</td><td>{{outletRetailMapping.kelurahan}}</td><td>{{outletRetailMapping.postalCode}}</td><td>{{outletRetailMapping.mcsOutletId}}</td><td>{{outletRetailMapping.withPromotor}}</td><td>{{outletRetailMapping.longitude}}</td><td>{{outletRetailMapping.latitude}}</td><td><a ui-sref=\"channel-detail({id:outletRetailMapping.channelId})\">{{outletRetailMapping.channelChannelName}}</a></td><td><a ui-sref=\"user-management-detail({login:outletRetailMapping.retailMappingSurveyorLogin})\">{{outletRetailMapping.retailMappingSurveyorLogin}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"outlet-retail-mapping-detail({id:outletRetailMapping.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"outlet-retail-mapping.edit({id:outletRetailMapping.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"outlet-retail-mapping.delete({id:outletRetailMapping.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/outlet-type/outlet-type-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outletType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.outletType.delete.question\" translate-values=\"{id: \'{{vm.outletType.id}}\'}\">Are you sure you want to delete this Outlet Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/outlet-type/outlet-type-detail.html","<div><h2><span translate=\"sceaApp.outletType.detail.title\">Outlet Type</span> {{vm.outletType.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.outletType.outletTypeName\">Outlet Type Name</span></dt><dd><span>{{vm.outletType.outletTypeName}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outlet-type/outlet-type-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletTypeLabel\" translate=\"sceaApp.outletType.home.createOrEditLabel\">Create or edit a Outlet Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.outletType.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.outletType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outletType.outletTypeName\" for=\"field_outletTypeName\">Outlet Type Name</label><input type=\"text\" class=\"form-control\" name=\"outletTypeName\" id=\"field_outletTypeName\" ng-model=\"vm.outletType.outletTypeName\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/outlet-type/outlet-types.html","<div><h2 translate=\"sceaApp.outletType.home.title\">Outlet Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"outlet-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outletType.home.createLabel\">Create new Outlet Type</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outletType.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletTypeName\"><span translate=\"sceaApp.outletType.outletTypeName\">Outlet Type Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outletType in vm.outletTypes track by outletType.id\"><td><a ui-sref=\"outlet-type-detail({id:outletType.id})\">{{outletType.id}}</a></td><td>{{outletType.outletTypeName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"outlet-type-detail({id:outletType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"outlet-type.edit({id:outletType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"outlet-type.delete({id:outletType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/outletpoint/outletpoint-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outletpoint.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.outletpoint.delete.question\" translate-values=\"{id: \'{{vm.outletpoint.id}}\'}\">Are you sure you want to delete this Outletpoint?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/outletpoint/outletpoint-detail.html","<div><h2><span translate=\"sceaApp.outletpoint.detail.title\">Outletpoint</span> {{vm.outletpoint.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.outletpoint.externalId\">External Id</span></dt><dd><span>{{vm.outletpoint.externalId}}</span></dd><dt><span translate=\"sceaApp.outletpoint.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.outletpoint.outletId})\">{{vm.outletpoint.outletName}} - {{vm.outletpoint.outletCode}}</a></dd><dt><span translate=\"sceaApp.outletpoint.droppoint\">Droppoint</span></dt><dd><a ui-sref=\"droppoint-detail({id:vm.outletpoint.droppointId})\">{{vm.outletpoint.droppointName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/outletpoint/outletpoint-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletpointLabel\" translate=\"sceaApp.outletpoint.home.createOrEditLabel\">Create or edit a Outletpoint</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.outletpoint.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.outletpoint.id\" readonly=\"readonly\"></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"sceaApp.outletpoint.externalId\" for=\"field_externalId\">External Id</label>--><!--<input type=\"text\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\"--><!--ng-model=\"vm.outletpoint.externalId\"--><!--/>--><!--</div>--><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outletpoint.outlet\" for=\"field_outlet\">Outlet</label><input type=\"text\" ng-model=\"vm.selectedOutlet\" id=\"field_outlet\" name=\"outlet\" uib-typeahead=\"outlet as outlet.outletName + \' - \' + outlet.outletCode for outlet in vm.searchOutlet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.searchingOutlet\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div ng-show=\"editForm.outlet.$invalid\"><p class=\"help-block\" ng-show=\"editForm.outlet.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.outletpoint.droppoint\" for=\"field_droppoint\">Droppoint</label><input type=\"text\" ng-model=\"vm.selectedDroppoint\" id=\"field_droppoint\" name=\"droppoint\" uib-typeahead=\"droppoint as droppoint.code for droppoint in vm.searchDroppoint($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.searchingDroppoint\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div ng-show=\"editForm.droppoint.$invalid\"><p class=\"help-block\" ng-show=\"editForm.droppoint.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/outletpoint/outletpoints.html","<div><h2 translate=\"sceaApp.outletpoint.home.title\">Outletpoints</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"outletpoint.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outletpoint.home.createLabel\">Create new Outletpoint</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.outletpoint.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.outletpoint.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"droppointName\"><span translate=\"sceaApp.outletpoint.droppoint\">Droppoint</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"sceaApp.outletpoint.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outletpoint in vm.outletpoints track by outletpoint.id\"><td><a ui-sref=\"outletpoint-detail({id:outletpoint.id})\">{{outletpoint.id}}</a></td><td><a ui-sref=\"outlet-detail({id:outletpoint.outletId})\">{{outletpoint.outletName}} - {{outletpoint.outletCode}}</a></td><td><a ui-sref=\"droppoint-detail({id:outletpoint.droppointId})\">{{outletpoint.droppointName}}</a></td><td>{{outletpoint.externalId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"outletpoint-detail({id:outletpoint.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"outletpoint.edit({id:outletpoint.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"outletpoint.delete({id:outletpoint.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/planogram/equipment-export.html","<form name=\"exportForm\" role=\"form\" novalidate show-validation><h4 id=\"myEquipmentLabel\" translate=\"sceaApp.equipment.home.export\">Export As CSV</h4><hr><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.exportDialog.year\" for=\"field_year\">Year</label><select class=\"form-control input-sm\" id=\"field_year\" ng-model=\"vm.exportRequest.year\" ng-change=\"vm.getWeeks()\" required><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.exportDialog.month\" for=\"field_month\">Month</label><select class=\"form-control input-sm\" id=\"field_month\" ng-model=\"vm.exportRequest.month\" ng-change=\"vm.getWeeks(vm.exportRequest.year, vm.exportRequest.month)\" ng-disabled=\"!vm.exportRequest.year\" required><option translate=\"sceaApp.calendar.months.{{month}}\" ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\">{{month}}</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.equipment.exportDialog.week\" for=\"field_week\">Week</label><select class=\"form-control input-sm\" id=\"field_week\" ng-model=\"vm.exportRequest.week\" ng-disabled=\"!vm.exportRequest.month || vm.weeks.length == 0\" required><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div><hr><div class=\"text-right\"><div class=\"pull-left\"><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp; <span translate=\"entity.action.back\">Back</span></button></div><button type=\"submit\" ng-disabled=\"exportForm.$invalid || vm.isExporting\" class=\"btn btn-primary\" ng-click=\"vm.exportAsCsv()\"><span ng-show=\"!vm.isExporting\" class=\"glyphicon glyphicon-export\"></span> <span ng-show=\"vm.isExporting\"><i class=\"fa fa-refresh fa-spin\"></i> </span>&nbsp; <span translate=\"sceaApp.equipment.exportDialog.export\">Export</span></button></div></form>");
$templateCache.put("app/entities/planogram/fixtures-export.html","<form name=\"exportForm\" role=\"form\" novalidate show-validation><h4 id=\"myFixturesLabel\" translate=\"sceaApp.fixtures.home.export\">Export As CSV</h4><hr><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.fixtures.exportDialog.year\" for=\"field_year\">Year</label><select class=\"form-control input-sm\" id=\"field_year\" ng-model=\"vm.exportRequest.year\" ng-change=\"vm.getWeeks()\" required><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.fixtures.exportDialog.month\" for=\"field_month\">Month</label><select class=\"form-control input-sm\" id=\"field_month\" ng-model=\"vm.exportRequest.month\" ng-change=\"vm.getWeeks(vm.exportRequest.year, vm.exportRequest.month)\" ng-disabled=\"!vm.exportRequest.year\" required><option translate=\"sceaApp.calendar.months.{{month}}\" ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\">{{month}}</option></select></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.fixtures.exportDialog.week\" for=\"field_week\">Week</label><select class=\"form-control input-sm\" id=\"field_week\" ng-model=\"vm.exportRequest.week\" ng-disabled=\"!vm.exportRequest.month || vm.weeks.length == 0\" required><option ng-repeat=\"week in vm.weeks track by $index\" value=\"{{week}}\">{{week}}</option></select></div><div class=\"form-group\"><label translate=\"sceaApp.fixtures.category\" for=\"field_category\">Category</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-model=\"vm.exportRequest.categoryId\" ng-options=\"productCategory.id as productCategory.categoryName for productCategory in vm.productcategories\" required><option value=\"\"></option></select></div><hr><div class=\"text-right\"><div class=\"pull-left\"><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp; <span translate=\"entity.action.back\">Back</span></button></div><button type=\"submit\" ng-disabled=\"exportForm.$invalid || vm.isExporting\" class=\"btn btn-primary\" ng-click=\"vm.exportAsCsv()\"><span ng-show=\"!vm.isExporting\" class=\"glyphicon glyphicon-export\"></span> <span ng-show=\"vm.isExporting\"><i class=\"fa fa-refresh fa-spin\"></i> </span>&nbsp; <span translate=\"sceaApp.fixtures.exportDialog.export\">Export</span></button></div></form>");
$templateCache.put("app/entities/planogram/planogram-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.planogram.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.planogram.delete.question\" translate-values=\"{id: \'{{vm.planogram.id}}\'}\">Are you sure you want to delete this Planogram?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/planogram/planogram-detail.html","<div><!-- <h2 translate=\"sceaApp.planogram.detail.title\">Detail Planogram</h2> --><h2><span translate=\"sceaApp.planogram.detail.title\" translate-values=\"{id: \'{{vm.planogram.id}}\'}\">Detail Planogram</span></h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><!-- master planogram form --><form name=\"editForm\" role=\"form\" novalidate><div class=\"row\" style=\"margin-bottom:10px; margin-top:10px\"><div class=\"col-xs-5\"><div class=\"form-group\"><label translate=\"sceaApp.planogram.outlet\" for=\"field_outlet\">Outlet</label><input ng-disabled=\"vm.var\" type=\"text\" ng-model=\"vm.planogram.outletOutletName\" name=\"outlet\" class=\"form-control\" readonly=\"readonly\"></div></div></div><div class=\"row\" style=\"margin-bottom:20px\"><div class=\"col-xs-5\"><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.planogram.periodStart\" for=\"field_periodStart\">Start Date</label><div class=\"input-group\"><input id=\"field_periodStart\" type=\"text\" class=\"form-control\" name=\"periodStart\" value=\"{{vm.planogram.periodStart | date:vm.dateFormat}}\" readonly=\"readonly\"> <span class=\"input-group-btn\"><button disabled=\"disabled\" type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></form><!-- tabs fixtures and equipmnet (render tab if vm.planogram.id is exsits) --><uib-tabset><uib-tab heading=\"Fixtures\"><div style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"><div class=\"row\"><div class=\"col-xs-2\" ng-if=\"vm.fixtureCategory.length\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.categories\">Categories</span></th></tr></thead><tbody><tr ng-repeat=\"category in vm.fixtureCategory track by category.id\" ng-click=\"vm.onSelectFixtureCategory(category.id)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': category.id == vm.selectedIndexFixtureCategory}\">{{category.categoryName}}</td></tr></tbody></table></div><div class=\"col-xs-4\" ng-if=\"vm.selectedIndexFixtureCategory\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\">Fixtures</th><th class=\"text-center\">Qty</th></tr></thead><tbody><tr ng-repeat=\"fixture in vm.fixtures track by fixture.id\" ng-click=\"vm.onSelectFixture(fixture.fixtureId)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': fixture.fixtureId == vm.selectedIndexFixture}\">{{fixture.fixtureName}}</td><td class=\"text-center\" ng-class=\"{\'bg-info\': fixture.fixtureId == vm.selectedIndexFixture}\">{{fixture.target}}</td></tr></tbody></table></div><div class=\"col-xs-4\" ng-if=\"vm.selectedIndexFixture\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.subFixtures\">Sub Fixtures</span></th><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.qty\">Qty</span></th></tr></thead><tbody><tr ng-repeat=\"subFixture in vm.subFixtures track by subFixture.id\" ng-click=\"vm.onSelectSubFixture(subFixture.fixtureId)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': subFixture.fixtureId == vm.selectedIndexSubFixture}\">{{subFixture.fixtureName}}</td><td class=\"text-center\" ng-class=\"{\'bg-info\': subFixture.fixtureId == vm.selectedIndexSubFixture}\">{{subFixture.target}}</td></tr></tbody></table></div><div class=\"col-xs-2\" ng-if=\"vm.selectedIndexSubFixture\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.targetProducts\">Target Products</span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.fixtureProducts track by product.id\"><td class=\"text-center\">{{product.productCode}}</td></tr></tbody></table></div></div></div></uib-tab><uib-tab heading=\"Equipment\" ng-click=\"vm.loadEquipmentCategories()\"><div style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"><div class=\"row\"><div class=\"col-xs-2\" ng-if=\"vm.equipmentCategories.length\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.categories\">Categories</span></th></tr></thead><tbody><tr ng-repeat=\"category in vm.equipmentCategories\" ng-click=\"vm.onSelectEquipmentCategories(category.id)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': category.id == vm.selectedIndexEquipmentCategory}\">{{category.equipmentName}}</td></tr></tbody></table></div><div ng-if=\"vm.selectedIndexEquipmentCategory\" class=\"col-xs-4\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.subCategories\">Sub Categories</span></th></tr></thead><tbody><tr ng-repeat=\"subCategory in vm.equipmentSubCategories\" ng-click=\"vm.onSelectEquipmentSubCategories(subCategory.id)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': subCategory.id == vm.selectedIndexEquipmentSubCategory}\">{{subCategory.equipmentName}}</td></tr></tbody></table></div><div ng-if=\"vm.selectedIndexEquipmentSubCategory\" class=\"col-xs-4\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.material\">Material</span></th><th class=\"text-center\"><span translate=\"sceaApp.planogram.detail.qty\">Qty</span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.equipmentProducts\"><td class=\"text-center\">{{product.equipmentEquipmentName}}</td><td class=\"text-center\">{{product.target}}</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset><br><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp; <span translate=\"entity.action.back\">Back</span></button></div></div>");
$templateCache.put("app/entities/planogram/planogram-export.html","<div><h2 translate=\"sceaApp.planogram.home.export\">Planograms</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><uib-tabset><uib-tab heading=\"Fixtures\"><div ui-view=\"fixtures\" style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"></div></uib-tab><uib-tab heading=\"Equipment\"><div ui-view=\"equipment\" style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/entities/planogram/planogram-form.html","<div><h2 translate=\"sceaApp.planogram.home.createOrEditLabel\">Create or edit a Planogram</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><!-- master planogram form --><form name=\"editForm\" role=\"form\" novalidate><div class=\"row\" style=\"margin-bottom:10px; margin-top:10px\"><div class=\"col-xs-5\"><div class=\"form-group has-feedback\"><label translate=\"sceaApp.planogram.outlet\" for=\"field_outlet\">Outlet</label><input ng-disabled=\"vm.isEditing\" type=\"text\" ng-model=\"vm.outlet\" name=\"outlet\" class=\"form-control\" uib-typeahead=\"outlet as outlet.outletName for outlet in vm.getOutlet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingOutlet\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" autocomplete=\"off\" typeahead-on-select=\"vm.onSelectOutlet($item)\" required> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div></div><div class=\"row\" style=\"margin-bottom:20px\"><div class=\"col-xs-5\"><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.planogram.periodStart\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" datepicker-options=\"vm.dateOptions\" show-button-bar=\"false\" uib-datepicker-popup=\"d MMMM y\" ng-model=\"vm.planogram.periodStart\" is-open=\"vm.datePickerOpenStatus\" readonly=\"readonly\" required> <span class=\"input-group-btn\"><button ng-disabled=\"vm.isEditing\" type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><button type=\"submit\" ng-if=\"!vm.isEditing\" ng-disabled=\"editForm.$invalid\" class=\"btn btn-primary\" ng-click=\"vm.savePlanogramMaster(\'save\')\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp; <span translate=\"entity.action.save\">Save</span></button> <button type=\"submit\" ng-if=\"vm.isEditing\" ng-disabled=\"editForm.$invalid\" class=\"btn btn-primary\" ng-click=\"vm.savePlanogramMaster(\'edit\')\"><span class=\"glyphicon glyphicon-pencil\"></span>&nbsp; <span translate=\"entity.action.edit\">edit</span></button></div></div></form><!-- tabs fixtures and equipmnet (render tab if vm.planogram.id is exsits) --><uib-tabset ng-if=\"vm.planogram.id\"><!-- Fixtures --><uib-tab heading=\"Fixtures\"><div style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"><button class=\"btn btn-default\" ng-click=\"vm.openImportFixtureDialog()\"><span class=\"glyphicon glyphicon-import\"></span>&nbsp; <span>Import Planogram</span></button><hr><div class=\"row\"><div class=\"col-xs-5\"><table class=\"table table-striped table-bordered\" ng-if=\"vm.fixtures.length\"><thead><tr><th class=\"text-center\">Fixtures</th><th class=\"text-center\">Category</th><th class=\"text-center\">Qty</th></tr></thead><tbody><tr ng-repeat=\"fixture in vm.fixtures\"><td style=\"width:45%\" class=\"text-left\" ng-class=\"{\'bg-info\': fixture.fixtureId == vm.selectedFixtureId}\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteFixture(fixture, $index, 1)\"><span class=\"glyphicon glyphicon-remove\"></span></button> &nbsp; <a style=\"color:black\" ng-click=\"vm.onSelectFixture(fixture)\">{{fixture.fixtureName}}</a> &nbsp;{{fixture.saved ? \'\' : \'*\'}}</td><td style=\"width:40%\" class=\"text-center\" ng-class=\"{\'bg-info\': fixture.fixtureId == vm.selectedFixtureId}\">{{fixture.categoryName}}</td><td class=\"text-center\" style=\"width:15%\" ng-class=\"{\'bg-info\': fixture.fixtureId == vm.selectedFixtureId}\"><input style=\"width:100%\" ng-change=\"vm.putFixture(fixture)\" class=\"text-center\" type=\"number\" ng-model=\"fixture.target\" min=\"0\" disable-negative-input disable-decimal-input></td></tr></tbody></table><button type=\"submit\" ng-click=\"vm.openFixtureDialog()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span>Add Fixtures</span></button></div><div class=\"col-xs-4\" ng-if=\"vm.selectedFixtureId\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\">Sub Fixtures</th><th class=\"text-center\">Qty</th></tr></thead><tbody><tr ng-repeat=\"subFixture in vm.subFixtures\"><td style=\"width:80%\" class=\"text-left\" ng-class=\"{\'bg-info\': subFixture.fixtureId == vm.selectedSubFixtureId}\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteFixture(subFixture, $index, 2)\"><span class=\"glyphicon glyphicon-remove\"></span></button> &nbsp; <a style=\"color:black\" ng-click=\"vm.onSelectSubFixture(subFixture.fixtureId)\">{{subFixture.fixtureName}}</a> &nbsp;{{subFixture.saved ? \'\' : \'*\'}}</td><td style=\"width:20%\" ng-class=\"{\'bg-info\': subFixture.fixtureId == vm.selectedSubFixtureId}\"><input style=\"width:100%\" ng-change=\"vm.putFixture(subFixture)\" type=\"number\" class=\"text-center\" ng-model=\"subFixture.target\" min=\"0\" disable-negative-input disable-decimal-input></td></tr></tbody></table><button type=\"submit\" class=\"btn btn-info\" ng-click=\"vm.openSubFixtureDialog()\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span>Add Sub Fixtures</span></button></div><div class=\"col-xs-3\" style=\"border-left: 1px solid #ddd\" ng-if=\"vm.selectedSubFixtureId\"><div class=\"form-group has-feedback\"><input type=\"text\" ng-model=\"vm.productOpt\" name=\"product\" uib-typeahead=\"product.productCode for product in vm.getProductFixture($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingProductFixture\" typeahead-show-hint=\"true\" typeahead-on-select=\"vm.onSelectFixtureProduct($item)\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\" placeholder=\"search product\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\">Target Product</th></tr></thead><tbody><tr ng-repeat=\"product in vm.fixtureProducts\"><td class=\"text-left\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteFixtureProduct(product, $index)\"><span class=\"glyphicon glyphicon-remove\"></span></button> &nbsp; {{product.productCode}}</td></tr></tbody></table></div></div></div></uib-tab><!-- Equipment --><uib-tab heading=\"Equipment\" ng-click=\"vm.loadEquipmentCategories()\"><div style=\"padding: 20px; border: 1px solid #ddd; border-top: 0px;background-color: #fff\"><button class=\"btn btn-default\" ng-click=\"vm.openImportEquipmentDialog()\"><span class=\"glyphicon glyphicon-import\"></span>&nbsp; <span>Import Planogram</span></button><hr><div class=\"row\"><div class=\"col-xs-3\"><table class=\"table table-striped table-bordered\" ng-if=\"vm.categoryEquipmentTree.length\"><thead><tr><th class=\"text-center\">Category</th></tr></thead><tbody><tr ng-repeat=\"category in vm.categoryEquipmentTree\" ng-click=\"vm.onSelectEquipmentCategories(category)\"><td class=\"text-center\" class=\"text-center\" ng-class=\"{\'bg-info\': category.id === vm.selectedCategory.id}\">{{category.equipmentName}}</td></tr></tbody></table><button type=\"submit\" ng-click=\"vm.openMaterialDialog()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span>Add Materials</span></button></div><div class=\"col-xs-3\" ng-if=\"vm.selectedCategory\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\">Sub Category</th></tr></thead><tbody><tr ng-repeat=\"subCategory in vm.selectedCategory.childs\" ng-click=\"vm.onSelectEquipmentSubCategories(subCategory)\"><td class=\"text-center\" ng-class=\"{\'bg-info\': subCategory.id === vm.selectedSubCategory.id}\">{{subCategory.equipmentName}}</td></tr></tbody></table></div><div class=\"col-xs-6\" ng-if=\"vm.selectedSubCategory\"><table class=\"table table-striped table-bordered\"><thead><tr><th class=\"text-center\">Materials</th><th class=\"text-center\">Qty</th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\"><td class=\"text-left\" style=\"width:80%\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteEquipmentProduct(material)\"><span class=\"glyphicon glyphicon-remove\"></span></button> &nbsp; {{material.equipmentEquipmentName}}</td><td class=\"text-center\" style=\"width:20%\"><input style=\"width:100%\" type=\"number\" class=\"text-center\" ng-change=\"vm.putEquipment(material)\" ng-model=\"material.target\" min=\"0\" disable-negative-input disable-decimal-input></td></tr></tbody></table></div></div></div></uib-tab></uib-tabset><br><button type=\"submit\" ui-sref=\"planogram\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp; <span translate=\"entity.action.back\">Back</span></button></div></div>");
$templateCache.put("app/entities/planogram/planograms.html","<div><h2 translate=\"sceaApp.planogram.home.title\">Planograms</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><!-- create button --><div class=\"col-xs-3 no-padding-left\" style=\"margin-right: 20px\"><button class=\"btn btn-primary\" ui-sref=\"planogram.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.planogram.home.createLabel\">Create new Outlet</span></button></div><!-- dropdown action button --><div class=\"col-xs-3\"><button class=\"btn btn-primary\" ui-sref=\"planogram.export\"><span class=\"glyphicon glyphicon-export\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.planogram.home.exportLabel\">Export Planogram</span></button></div><!-- search bar --><div class=\"col-xs-5 no-padding-right pull-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.planogram.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><!-- render table --><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.planogram.outlet\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"periodEnd\"><span translate=\"sceaApp.planogram.periodStart\">Period Start</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"planogram in vm.planogram track by planogram.id\"><td><a ui-sref=\"planogram-detail({id:planogram.id})\">{{planogram.id}}</a></td><td>{{planogram.outletOutletName}}</td><td>{{planogram.periodStart | date: vm.dateFormat}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"planogram-detail({id:planogram.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"planogram.edit({id:planogram.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"planogram.delete({id:planogram.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!-- paging --><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/planogram-equipment/planogram-equipment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.planogramEquipment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.planogramEquipment.delete.question\" translate-values=\"{id: \'{{vm.planogramEquipment.id}}\'}\">Are you sure you want to delete this Planogram Equipment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/planogram-equipment/planogram-equipment-detail.html","<div><h2><span translate=\"sceaApp.planogramEquipment.detail.title\">Planogram Equipment</span> {{vm.planogramEquipment.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.planogramEquipment.target\">Target</span></dt><dd><span>{{vm.planogramEquipment.target}}</span></dd><dt><span translate=\"sceaApp.planogramEquipment.planogram\">Planogram</span></dt><dd><a ui-sref=\"planogram-detail({id:vm.planogramEquipment.planogramId})\">{{vm.planogramEquipment.planogramId}}</a></dd><dt><span translate=\"sceaApp.planogramEquipment.equipment\">Equipment</span></dt><dd><a ui-sref=\"equipment-detail({id:vm.planogramEquipment.equipmentId})\">{{vm.planogramEquipment.equipmentEquipmentName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/planogram-equipment/planogram-equipment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPlanogramEquipmentLabel\" translate=\"sceaApp.planogramEquipment.home.createOrEditLabel\">Create or edit a Planogram Equipment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.planogramEquipment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.planogramEquipment.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.planogramEquipment.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.planogramEquipment.target\"></div><div class=\"form-group\"><label translate=\"sceaApp.planogramEquipment.planogram\" for=\"field_planogram\">Planogram</label><select class=\"form-control\" id=\"field_planogram\" name=\"planogram\" ng-model=\"vm.planogramEquipment.planogramId\" ng-options=\"planogram.id as planogram.id for planogram in vm.planograms\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.planogramEquipment.equipment\" for=\"field_equipment\">Equipment</label><select class=\"form-control\" id=\"field_equipment\" name=\"equipment\" ng-model=\"vm.planogramEquipment.equipmentId\" ng-options=\"equipment.id as equipment.equipmentName for equipment in vm.equipment\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/planogram-equipment/planogram-equipments.html","<div><h2 translate=\"sceaApp.planogramEquipment.home.title\">Planogram Equipments</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"planogram-equipment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.planogramEquipment.home.createLabel\">Create new Planogram Equipment</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.planogramEquipment.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span translate=\"sceaApp.planogramEquipment.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"planogramId\"><span translate=\"sceaApp.planogramEquipment.planogram\">Planogram</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"equipmentEquipmentName\"><span translate=\"sceaApp.planogramEquipment.equipment\">Equipment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"planogramEquipment in vm.planogramEquipments track by planogramEquipment.id\"><td><a ui-sref=\"planogram-equipment-detail({id:planogramEquipment.id})\">{{planogramEquipment.id}}</a></td><td>{{planogramEquipment.target}}</td><td><a ui-sref=\"planogram-detail({id:planogramEquipment.planogramId})\">{{planogramEquipment.planogramId}}</a></td><td><a ui-sref=\"equipment-detail({id:planogramEquipment.equipmentId})\">{{planogramEquipment.equipmentEquipmentName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"planogram-equipment-detail({id:planogramEquipment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"planogram-equipment.edit({id:planogramEquipment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"planogram-equipment.delete({id:planogramEquipment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/planogram-fixture/planogram-fixture-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.planogramFixture.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.planogramFixture.delete.question\" translate-values=\"{id: \'{{vm.planogramFixture.id}}\'}\">Are you sure you want to delete this Planogram Fixture?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/planogram-fixture/planogram-fixture-detail.html","<div><h2><span translate=\"sceaApp.planogramFixture.detail.title\">Planogram Fixture</span> {{vm.planogramFixture.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.planogramFixture.target\">Target</span></dt><dd><span>{{vm.planogramFixture.target}}</span></dd><dt><span translate=\"sceaApp.planogramFixture.planogram\">Planogram</span></dt><dd><a ui-sref=\"planogram-detail({id:vm.planogramFixture.planogramId})\">{{vm.planogramFixture.planogramId}}</a></dd><dt><span translate=\"sceaApp.planogramFixture.fixture\">Fixture</span></dt><dd><a ui-sref=\"fixtures-detail({id:vm.planogramFixture.fixtureId})\">{{vm.planogramFixture.fixtureFixtureName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/planogram-fixture/planogram-fixture-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPlanogramFixtureLabel\" translate=\"sceaApp.planogramFixture.home.createOrEditLabel\">Create or edit a Planogram Fixture</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.planogramFixture.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.planogramFixture.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.planogramFixture.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.planogramFixture.target\"></div><div class=\"form-group\"><label translate=\"sceaApp.planogramFixture.planogram\" for=\"field_planogram\">Planogram</label><select class=\"form-control\" id=\"field_planogram\" name=\"planogram\" ng-model=\"vm.planogramFixture.planogramId\" ng-options=\"planogram.id as planogram.id for planogram in vm.planograms\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.planogramFixture.fixture\" for=\"field_fixture\">Fixture</label><select class=\"form-control\" id=\"field_fixture\" name=\"fixture\" ng-model=\"vm.planogramFixture.fixtureId\" ng-options=\"fixtures.id as fixtures.fixtureName for fixtures in vm.fixtures\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/planogram-fixture/planogram-fixtures.html","<div><h2 translate=\"sceaApp.planogramFixture.home.title\">Planogram Fixtures</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"planogram-fixture.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.planogramFixture.home.createLabel\">Create new Planogram Fixture</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.planogramFixture.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span translate=\"sceaApp.planogramFixture.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"planogramId\"><span translate=\"sceaApp.planogramFixture.planogram\">Planogram</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fixtureFixtureName\"><span translate=\"sceaApp.planogramFixture.fixture\">Fixture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"planogramFixture in vm.planogramFixtures track by planogramFixture.id\"><td><a ui-sref=\"planogram-fixture-detail({id:planogramFixture.id})\">{{planogramFixture.id}}</a></td><td>{{planogramFixture.target}}</td><td><a ui-sref=\"planogram-detail({id:planogramFixture.planogramId})\">{{planogramFixture.planogramId}}</a></td><td><a ui-sref=\"fixtures-detail({id:planogramFixture.fixtureId})\">{{planogramFixture.fixtureFixtureName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"planogram-fixture-detail({id:planogramFixture.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"planogram-fixture.edit({id:planogramFixture.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"planogram-fixture.delete({id:planogramFixture.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/planogram-product/planogram-product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.planogramProduct.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.planogramProduct.delete.question\" translate-values=\"{id: \'{{vm.planogramProduct.id}}\'}\">Are you sure you want to delete this Planogram Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/planogram-product/planogram-product-detail.html","<div><h2><span translate=\"sceaApp.planogramProduct.detail.title\">Planogram Product</span> {{vm.planogramProduct.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.planogramProduct.planogram\">Planogram</span></dt><dd><a ui-sref=\"planogram-detail({id:vm.planogramProduct.planogramId})\">{{vm.planogramProduct.planogramId}}</a></dd><dt><span translate=\"sceaApp.planogramProduct.fixture\">Fixture</span></dt><dd><a ui-sref=\"fixtures-detail({id:vm.planogramProduct.fixtureId})\">{{vm.planogramProduct.fixtureFixtureName}}</a></dd><dt><span translate=\"sceaApp.planogramProduct.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.planogramProduct.productId})\">{{vm.planogramProduct.productProductCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/planogram-product/planogram-product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPlanogramProductLabel\" translate=\"sceaApp.planogramProduct.home.createOrEditLabel\">Create or edit a Planogram Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.planogramProduct.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.planogramProduct.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label translate=\"sceaApp.planogramProduct.planogram\" for=\"field_planogram\">Planogram</label><select class=\"form-control\" id=\"field_planogram\" name=\"planogram\" ng-model=\"vm.planogramProduct.planogramId\" ng-options=\"planogram.id as planogram.id for planogram in vm.planograms\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.planogramProduct.fixture\" for=\"field_fixture\">Fixture</label><select class=\"form-control\" id=\"field_fixture\" name=\"fixture\" ng-model=\"vm.planogramProduct.fixtureId\" ng-options=\"fixtures.id as fixtures.fixtureName for fixtures in vm.fixtures\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.planogramProduct.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.planogramProduct.productId\" ng-options=\"product.id as product.productName for product in vm.products\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/planogram-product/planogram-products.html","<div><h2 translate=\"sceaApp.planogramProduct.home.title\">Planogram Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"planogram-product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.planogramProduct.home.createLabel\">Create new Planogram Product</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.planogramProduct.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"planogramId\"><span translate=\"sceaApp.planogramProduct.planogram\">Planogram</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fixtureFixtureName\"><span translate=\"sceaApp.planogramProduct.fixture\">Fixture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productProductCode\"><span translate=\"sceaApp.planogramProduct.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"planogramProduct in vm.planogramProducts track by planogramProduct.id\"><td><a ui-sref=\"planogram-product-detail({id:planogramProduct.id})\">{{planogramProduct.id}}</a></td><td><a ui-sref=\"planogram-detail({id:planogramProduct.planogramId})\">{{planogramProduct.planogramId}}</a></td><td><a ui-sref=\"fixtures-detail({id:planogramProduct.fixtureId})\">{{planogramProduct.fixtureFixtureName}}</a></td><td><a ui-sref=\"product-detail({id:planogramProduct.productId})\">{{planogramProduct.productProductCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"planogram-product-detail({id:planogramProduct.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"planogram-product.edit({id:planogramProduct.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"planogram-product.delete({id:planogramProduct.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/pop/pop-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.pop.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.pop.delete.question\" translate-values=\"{id: \'{{vm.pop.id}}\'}\">Are you sure you want to delete this Pop?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/pop/pop-detail.html","<div><h2><span translate=\"sceaApp.pop.detail.title\">Pop</span> {{vm.pop.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.pop.popName\">Pop Name</span></dt><dd><span>{{vm.pop.popName}}</span></dd><dt><span translate=\"sceaApp.pop.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.pop.productCategory.id})\">{{vm.pop.productCategory.categoryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/pop/pop-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPopLabel\" translate=\"sceaApp.pop.home.createOrEditLabel\">Create or edit a Pop</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.pop.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.pop.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.pop.popName\" for=\"field_popName\">Pop Name</label><input type=\"text\" class=\"form-control\" name=\"popName\" id=\"field_popName\" ng-model=\"vm.pop.popName\"></div><div class=\"form-group\"><label translate=\"sceaApp.pop.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" name=\"productCategory\" ng-model=\"vm.pop.productCategory\" ng-options=\"productCategory as productCategory.categoryName for productCategory in vm.productcategories track by productCategory.id\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/pop/pops.html","<div><h2 translate=\"sceaApp.pop.home.title\">Pops</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"pop.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.pop.home.createLabel\">Create new Pop</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.pop.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popName\"><span translate=\"sceaApp.pop.popName\">Pop Name</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCategory.categoryName\"><span translate=\"sceaApp.pop.productCategory\">Product Category</span><span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"pop in vm.pops track by pop.id\"><td><a ui-sref=\"pop-detail({id:pop.id})\">{{pop.id}}</a></td><td>{{pop.popName}}</td><td><a ui-sref=\"product-category-detail({id:pop.productCategory.id})\">{{pop.productCategory.categoryName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"pop-detail({id:pop.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"pop.edit({id:pop.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"pop.delete({id:pop.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--     <div class=\"text-center\"> --><!-- 		<jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count> --><!-- 	    <uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.size\" --><!-- 	      	ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination> --><!-- 	</div> --><!-- 	<div class=\"text-center\"> --><!--         <jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count> --><!--     </div> --><!--     <uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager> --><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/pop-inv/pop-inv-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.popInv.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.popInv.delete.question\" translate-values=\"{id: \'{{vm.popInv.id}}\'}\">Are you sure you want to delete this Pop Inv?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/pop-inv/pop-inv-detail.html","<div><h2><span translate=\"sceaApp.popInv.detail.title\">Pop Inv</span> {{vm.popInv.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.popInv.externalId\">External Id</span></dt><dd><span>{{vm.popInv.externalId}}</span></dd><dt><span translate=\"sceaApp.popInv.pop\">Pop</span></dt><dd><a ui-sref=\"pop-detail({id:vm.popInv.popId})\">{{vm.popInv.popPopName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/pop-inv/pop-inv-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPopInvLabel\" translate=\"sceaApp.popInv.home.createOrEditLabel\">Create or edit a Pop Inv</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.popInv.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.popInv.id\" readonly=\"readonly\"></div><!--<div class=\"form-group\">--><!--<label class=\"control-label\" translate=\"sceaApp.popInv.externalId\" for=\"field_externalId\">External Id</label>--><!--<input type=\"text\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\"--><!--ng-model=\"vm.popInv.externalId\"--><!--/>--><!--</div>--><div class=\"form-group\"><label translate=\"sceaApp.popInv.pop\" for=\"field_pop\">Pop</label><select class=\"form-control\" id=\"field_pop\" name=\"pop\" ng-model=\"vm.popInv.popId\" ng-options=\"pop.id as pop.popName for pop in vm.pops | orderBy:\'id\'\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.pop.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pop.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/pop-inv/pop-invs.html","<div><h2 translate=\"sceaApp.popInv.home.title\">Pop Invs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"pop-inv.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.popInv.home.createLabel\">Create new Pop Inv</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.popInv.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popPopName\"><span translate=\"sceaApp.popInv.pop\">Pop</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"sceaApp.popInv.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"popInv in vm.popInvs track by popInv.id\"><td><a ui-sref=\"pop-inv-detail({id:popInv.id})\">{{popInv.id}}</a></td><td><a ui-sref=\"pop-detail({id:popInv.popId})\">{{popInv.popPopName}}</a></td><td>{{popInv.externalId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"pop-inv-detail({id:popInv.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button><!--<button type=\"submit\"--><!--ui-sref=\"pop-inv.edit({id:popInv.id})\"--><!--class=\"btn btn-primary btn-sm\">--><!--<span class=\"glyphicon glyphicon-pencil\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span>--><!--</button>--><!--<button type=\"submit\"--><!--ui-sref=\"pop-inv.delete({id:popInv.id})\"--><!--class=\"btn btn-danger btn-sm\">--><!--<span class=\"glyphicon glyphicon-remove-circle\"></span>--><!--<span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span>--><!--</button>--></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/pop-pair-version/pop-pair-version-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.popPairVersion.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.popPairVersion.delete.question\" translate-values=\"{id: \'{{vm.popPairVersion.id}}\'}\">Are you sure you want to delete this Pop Pair Version?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/pop-pair-version/pop-pair-version-detail.html","<div><h2><span translate=\"sceaApp.popPairVersion.detail.title\">Pop Pair Version</span> {{vm.popPairVersion.id}}</h2><hr><div class=\"row\" style=\"margin-bottom: 20px\"><div class=\"form-group\"><label class=\"col-sm-4 col-md-2 form-control-static\"><span translate=\"sceaApp.popPairVersion.name\">Name</span></label><div class=\"col-xs-4\"><input type=\"text\" class=\"form-control input-sm\" name=\"name\" id=\"field_name\" ng-model=\"vm.popPairVersion.name\" ng-disabled=\"vm.disableEdit\" readonly=\"readonly\"></div></div></div><div style=\"margin-bottom: 20px\"><div class=\"row no-padding-right no-padding-left\"><div class=\"col-xs-3\" style=\"border-right: 1px solid #ddd\"><div class=\"table-responsive\" style=\"margin-top: 20px\"><table class=\"jh-table table table-striped\" style=\"border: 1px solid #ddd\"><thead><tr><th class=\"text-center\"><span translate=\"sceaApp.popPairVersion.productCode\">Product Code</span></th></tr></thead><tbody><tr class=\"text-center\" style=\"outline: none\" ng-class=\"{\'info\': vm.product.id == product.id}\" ng-repeat=\"product in vm.products track by product.id\" ng-click=\"vm.selectProduct(product)\"><td>{{product.productCode}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.getAllProduct()\"></uib-pagination></div></div><div class=\"col-xs-9\"><div class=\"row row-tight\" ng-show=\"vm.product\"><div class=\"text-center col-xs-3\" ng-repeat=\"(tableName, tableContent) in vm.pops track by $index\"><div style=\"margin-top: 20px\"><h5 translate=\"sceaApp.popPairVersion.{{tableContent.title}}\"></h5></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\" style=\"border: 1px solid #ddd\"><thead><tr><th class=\"text-center\"><span translate=\"global.field.id\">ID</span></th><th class=\"text-center\"><span translate=\"sceaApp.popPairVersion.popName\">Pop Name</span></th></tr></thead><tbody class=\"text-center\"><tr ng-repeat=\"pop in tableContent.list track by $index\"><td>{{pop.id.pop.id}}</td><td>{{pop.id.pop.popName}}</td></tr><tr ng-show=\"tableContent.list.length == 0\"><td></td><td></td></tr></tbody></table></div></div></div></div></div></div><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/pop-pair-version/pop-pair-version-form.html","<div ng-style=\"vm.isSaving && {\'cursor\':\'not-allowed\'}\"><h2 translate=\"sceaApp.popPairVersion.home.createOrEditLabel\">Create or edit a Pop Pair Version</h2><jhi-alert-error></jhi-alert-error><br><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.savePopPairVersion()\"><div class=\"row\" style=\"margin-bottom: 20px\"><div class=\"form-group\"><label class=\"col-sm-4 col-md-2 form-control-static\"><span translate=\"sceaApp.popPairVersion.name\">Name</span></label><div class=\"col-xs-4\"><input type=\"text\" class=\"form-control input-sm\" name=\"name\" id=\"field_name\" ng-model=\"vm.popPairVersion.name\" ng-disabled=\"vm.disableEdit\" required></div><button class=\"btn btn-default btn-sm\" ng-if=\"vm.disableEdit\" ng-click=\"vm.disableEdit = false;\"><span class=\"glyphicon glyphicon-pencil\"></span>&nbsp;<span translate=\"entity.action.edit\">Edit</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary btn-sm\" ng-if=\"!vm.disableEdit\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></form><div ng-if=\"vm.popPairVersion.id\" style=\"margin-bottom: 20px\"><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-4 col-md-2 form-control-static\"><span translate=\"sceaApp.popPairVersion.category\">Category</span></label><div class=\"col-xs-2\"><select class=\"form-control input-sm\" ng-model=\"vm.category\" ng-change=\"vm.updateCategory(vm.category)\" ng-options=\"category as category.categoryName for category in vm.categories\"></select></div></div></div><hr class=\"custom-hr\"><div class=\"row no-padding-right no-padding-left\"><div class=\"col-xs-3\" style=\"border-right: 1px solid #ddd\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchProductQuery\" id=\"searchProductQuery\" placeholder=\"{{ \'sceaApp.popPairVersion.home.searchProduct\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.searchProduct(vm.searchProductQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clearSearchProduct()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form><div class=\"table-responsive\" style=\"margin-top: 20px\"><table class=\"jh-table table table-striped\" style=\"border: 1px solid #ddd\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.getAllProduct()\"><th class=\"text-center\" jh-sort-by=\"productCode\"><span translate=\"sceaApp.popPairVersion.productCode\">Product Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr class=\"text-center\" style=\"outline: none\" ng-class=\"{\'info\': vm.product.id == product.id}\" ng-repeat=\"product in vm.products track by product.id\" ng-click=\"vm.selectProduct(product)\"><td>{{product.productCode}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.getAllProduct()\"></uib-pagination></div></div><div class=\"col-xs-9\"><div class=\"row row-tight\" ng-show=\"vm.product\"><div class=\"col-xs-4\"><input type=\"text\" ng-model=\"vm.pop\" name=\"pop\" class=\"form-control\" ng-disabled=\"vm.isSaving\" placeholder=\"{{ \'sceaApp.popPairVersion.home.searchPop\' | translate }}\" uib-typeahead=\"pop as pop.popName for pop in vm.getPop($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingPop\" typeahead-on-select=\"vm.selectPop($item)\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"col-xs-8 text-right\"><div class=\"trash-box\" dnd-list=\"[]\"><span class=\"glyphicon glyphicon-trash\"></span> <span translate=\"sceaApp.popPairVersion.trash\">Drag here to remove</span></div></div></div><div class=\"row row-tight\" ng-show=\"vm.product\"><div class=\"text-center col-xs-3\" ng-repeat=\"(tableName, tableContent) in vm.pops\"><div style=\"margin-top: 20px\"><h5 translate=\"sceaApp.popPairVersion.{{tableContent.title}}\"></h5></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\" style=\"border: 1px solid #ddd\"><thead><tr><th class=\"text-center\"><span translate=\"global.field.id\">ID</span></th><th class=\"text-center\"><span translate=\"sceaApp.popPairVersion.popName\">Pop Name</span></th></tr></thead><tbody class=\"text-center\" dnd-list=\"tableContent.list\"><tr ng-style=\"!vm.isSaving && {\'cursor\':\'pointer\'} || {\'cursor\':\'default\'}\" ng-repeat=\"pop in tableContent.list track by $index\" dnd-draggable=\"pop\" dnd-dragstart=\"pop.moved = true\" dnd-canceled=\"pop.moved = false\" dnd-copied=\"vm.updatePopList(tableContent)\" dnd-effect-allowed=\"copy\" dnd-disable-if=\"vm.isSaving\"><td>{{pop.id.pop.id}}</td><td>{{pop.id.pop.popName}}</td></tr><tr ng-show=\"tableContent.list.length == 0\"><td><br></td><td><br></td></tr></tbody></table></div></div></div></div></div></div><button type=\"submit\" ui-sref=\"pop-pair-version\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/pop-pair-version/pop-pair-version-import.html","<div><h2><span data-translate=\"sceaApp.popPairVersion.import.title\">Pop Pair Version Import</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/pop-pair-version/pop-pair-versions.html","<div><h2 translate=\"sceaApp.popPairVersion.home.title\">Pop Pair Versions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"pop-pair-version.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.popPairVersion.home.createLabel\">Create new Pop Pair Version</span></button> &nbsp; <button class=\"btn btn-default\" ui-sref=\"pop-pair-version.import\"><span class=\"glyphicon glyphicon-import\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.popPairVersion.import.action\">Import Pop Pair Version</span></button></div><div class=\"col-xs-6 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.popPairVersion.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.popPairVersion.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"popPairVersion in vm.popPairVersions track by popPairVersion.id\"><td><a ui-sref=\"pop-pair-version-detail({id:popPairVersion.id})\">{{popPairVersion.id}}</a></td><td>{{popPairVersion.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"pop-pair-version-detail({id:popPairVersion.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"pop-pair-version.edit({id:popPairVersion.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"pop-pair-version.delete({id:popPairVersion.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/principal/principal-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.principal.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.principal.delete.question\" translate-values=\"{id: \'{{vm.principal.id}}\'}\">Are you sure you want to delete this Principal?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/principal/principal-detail.html","<div><h2><span translate=\"sceaApp.principal.detail.title\">Principal</span> {{vm.principal.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.principal.name\">Name</span></dt><dd><span>{{vm.principal.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/principal/principal-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPrincipalLabel\" translate=\"sceaApp.principal.home.createOrEditLabel\">Create or edit a Principal</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.principal.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.principal.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.principal.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.principal.name\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/principal/principals.html","<div><h2 translate=\"sceaApp.principal.home.title\">Principals</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"principal.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.principal.home.createLabel\">Create new Principal</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.principal.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.principal.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"principal in vm.principals track by principal.id\"><td><a ui-sref=\"principal-detail({id:principal.id})\">{{principal.id}}</a></td><td>{{principal.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"principal-detail({id:principal.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"principal.edit({id:principal.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"principal.delete({id:principal.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product/product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.product.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.product.delete.question\" translate-values=\"{id: \'{{vm.product.id}}\'}\">Are you sure you want to delete this Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product/product-detail.html","<div><h2><span translate=\"sceaApp.product.detail.title\">Product</span> {{vm.product.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.product.productCode\">Product Code</span></dt><dd><span>{{vm.product.productCode}}</span></dd><dt><span translate=\"sceaApp.product.shortCode\">Short Code</span></dt><dd><span>{{vm.product.shortCode}}</span></dd><dt><span translate=\"sceaApp.product.productName\">Product Name</span></dt><dd><span>{{vm.product.productName}}</span></dd><dt><span translate=\"sceaApp.product.target\">Target</span></dt><dd><span>{{vm.product.target}}</span></dd><dt><span translate=\"sceaApp.product.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.product.productCategoryId})\">{{vm.product.productCategoryCategoryName}}</a></dd><dt><span translate=\"sceaApp.product.launchPeriod\">Launch Period</span></dt><dd><a ui-sref=\"launch-period-detail({id:vm.product.launchPeriodId})\">{{vm.product.launchPeriodPeriodName}}</a></dd><dt><span translate=\"sceaApp.product.productInch\">Product Inch</span></dt><dd><a ui-sref=\"product-inch-detail({id:vm.product.productInchId})\">{{vm.product.productInchDeskripsi}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product/product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductLabel\" translate=\"sceaApp.product.home.createOrEditLabel\">Create or edit a Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.product.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.product.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.product.productCode\" for=\"field_productCode\">Product Code</label><input type=\"text\" class=\"form-control\" name=\"productCode\" id=\"field_productCode\" ng-model=\"vm.product.productCode\" required><div ng-show=\"editForm.productCode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.productCode.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.product.shortCode\" for=\"field_shortCode\">Short Code</label><input type=\"text\" class=\"form-control\" name=\"shortCode\" id=\"field_shortCode\" ng-model=\"vm.product.shortCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.product.productName\" for=\"field_productName\">Product Name</label><input type=\"text\" class=\"form-control\" name=\"productName\" id=\"field_productName\" ng-model=\"vm.product.productName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.product.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.product.target\" min=\"0\" max=\"1\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.product.productCategory\" for=\"field_productCategory\">Product Category</label><input type=\"text\" ng-model=\"vm.productCategory\" name=\"productCategory\" uib-typeahead=\"dataCategory as dataCategory.categoryName for dataCategory in vm.dataCategory | filter:{categoryName:$viewValue}\" class=\"form-control\" typeahead-min-length=\"1\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group\"><label translate=\"sceaApp.product.launchPeriod\" for=\"field_launchPeriod\">Launch Period</label><select class=\"form-control\" id=\"field_launchPeriod\" name=\"launchPeriod\" ng-model=\"vm.product.launchPeriodId\" ng-options=\"launchPeriod.id as launchPeriod.periodName for launchPeriod in vm.launchperiods\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.product.productInch\" for=\"field_productInch\">Product Inch</label><select class=\"form-control\" id=\"field_productInch\" name=\"productInch\" ng-model=\"vm.product.productInchId\" ng-options=\"productInch.id as productInch.deskripsi for productInch in vm.productinches\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product/products.html","<div><h2 translate=\"sceaApp.product.home.title\">Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.product.home.createLabel\">Create new Product</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.product.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCode\"><span translate=\"sceaApp.product.productCode\">Product Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shortCode\"><span translate=\"sceaApp.product.shortCode\">Short Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productName\"><span translate=\"sceaApp.product.productName\">Product Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span translate=\"sceaApp.product.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCategory.categoryName\"><span translate=\"sceaApp.product.productCategory\">Product Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"launchPeriod.periodName\"><span translate=\"sceaApp.product.launchPeriod\">Launch Period</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productInch.deskripsi\"><span translate=\"sceaApp.product.productInch\">Product Inch</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products track by product.id\"><td><a ui-sref=\"product-detail({id:product.id})\">{{product.id}}</a></td><td>{{product.productCode}}</td><td>{{product.shortCode}}</td><td>{{product.productName}}</td><td>{{product.target}}</td><td><a ui-sref=\"product-category-detail({id:product.productCategoryId})\">{{product.productCategoryCategoryName}}</a></td><td><a ui-sref=\"launch-period-detail({id:product.launchPeriodId})\">{{product.launchPeriodPeriodName}}</a></td><td><a ui-sref=\"product-inch-detail({id:product.productInchId})\">{{product.productInchDeskripsi}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-detail({id:product.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product.edit({id:product.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product.delete({id:product.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-category/product-categories.html","<div><h2 translate=\"sceaApp.productCategory.home.title\">Product Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-md hidden-sm\" translate=\"sceaApp.productCategory.home.createLabel\">Create new Product Category</span></button> <button class=\"btn btn-primary\" ng-click=\"myTree.expand_all();\"><span class=\"fa fa-folder-open\"></span> <span class=\"hidden-xs hidden-md hidden-sm\">Expand All</span></button> <button class=\"btn btn-primary\" ng-click=\"myTree.collapse_all();\"><span class=\"fa fa-folder\"></span> <span class=\"hidden-xs hidden-md hidden-sm\">Collapse All</span></button></div><div class=\"col-xs-6 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.productCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.filterString\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div><tree-grid tree-data=\"vm.productCategories\" icon-expand=\"fa fa-folder\" icon-collapse=\"fa fa-folder-open\" icon-leaf=\"\" expand-on=\"vm.expandProp\" col-defs=\"vm.colDefinitions\" tree-control=\"myTree\" template-url=\"app/entities/product-category/product-category-table-template.html\"></tree-grid></div></div>");
$templateCache.put("app/entities/product-category/product-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.productCategory.delete.question\" translate-values=\"{id: \'{{vm.productCategory.id}}\'}\">Are you sure you want to delete this Product Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-category/product-category-detail.html","<div><h2><span translate=\"sceaApp.productCategory.detail.title\">Product Category</span> {{vm.productCategory.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.productCategory.categoryName\">Category Name</span></dt><dd><span>{{vm.productCategory.categoryName}}</span></dd><dt><span translate=\"sceaApp.productCategory.parent\">Parent</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.productCategory.parentId})\">{{vm.productCategory.parentName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-category/product-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><jhi-alert></jhi-alert><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductCategoryLabel\" translate=\"sceaApp.productCategory.home.createOrEditLabel\">Create or edit a Product Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.productCategory.categoryName\" for=\"field_categoryName\">Category Name</label><input type=\"text\" class=\"form-control\" name=\"categoryName\" id=\"field_categoryName\" ng-model=\"vm.productCategory.categoryName\"></div><div class=\"form-group has-feedback scrollable-dropdown-menu\"><label translate=\"sceaApp.productCategory.parent\" for=\"field_parent\">Parent</label><input type=\"text\" ng-disabled=\"vm.level == 1 && vm.productcategories.length == 0\" ng-model=\"vm.parent\" name=\"parentName\" uib-typeahead=\"productCategory as productCategory.categoryName for productCategory in vm.productcategories | filter:{categoryName:$viewValue} | limitTo: 5\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingProductCategory\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-category/product-category-table-template.html","<div class=\"table-responsive\"><table class=\"table tree-grid\"><thead><tr><th><span ng-if=\"expandingProperty.sortable\" ng-click=\"sortBy(expandingProperty)\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}} &nbsp;&nbsp; <span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field || expandingProperty}}</span> <i ng-if=\"expandingProperty.sorted\" class=\"glyphicon {{expandingProperty.sortDirection == \'asc\' ? \'glyphicon-sort-by-attributes\' : \'glyphicon-sort-by-attributes-alt\'}}\"></i> <i ng-if=\"!expandingProperty.sorted\" class=\"glyphicon glyphicon-sort\"></i> </span><span ng-if=\"!expandingProperty.sortable\">{{expandingProperty.displayName || expandingProperty.field}}</span></th><th ng-repeat=\"col in colDefinitions\"><span ng-if=\"col.sortable\" ng-click=\"sortBy(col);expandingProperty.sorted = false\">{{col.displayName || col.field}} &nbsp;&nbsp; <i ng-if=\"col.sorted\" class=\"glyphicon {{col.sortDirection == \'asc\' ? \'glyphicon-sort-by-attributes\' : \'glyphicon-sort-by-attributes-alt\'}}\"></i> <i ng-if=\"!col.sorted\" class=\"glyphicon glyphicon-sort\"></i> </span><span ng-if=\"!col.sortable\">{{col.displayName || col.field}}</span></th></tr></thead><tbody><tr ng-repeat=\"row in tree_rows | searchFor:$parent.vm.filterString:expandingProperty:colDefinitions:true track by row.branch.uid\" ng-class=\"\'level-\' + {{ row.level }} + (row.branch.selected ? \' active\':\'\')\" class=\"tree-grid-row\"><td><a ng-click=\"user_clicks_branch(row.branch)\"><i ng-class=\"row.level === 1 && !row.branch.children.length ? \'fa fa-folder-o\' : row.tree_icon\" ng-click=\"row.branch.expanded = !row.branch.expanded\" class=\"indented tree-icon\"></i> </a><span class=\"indented tree-label\" ng-click=\"on_user_click(row.branch)\">{{row.branch[expandingProperty.field] || row.branch[expandingProperty]}}</span></td><td ng-repeat=\"col in colDefinitions\"><div ng-if=\"col.cellTemplate\" compile=\"col.cellTemplate\" cell-template-scope=\"col.cellTemplateScope\"></div><div ng-if=\"!col.cellTemplate\">{{row.branch[col.field]}}</div></td></tr></tbody></table></div>");
$templateCache.put("app/entities/project/project-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.project.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.project.delete.question\" translate-values=\"{id: \'{{vm.project.id}}\'}\">Are you sure you want to delete this Project?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/project/project-detail.html","<div><h2><span translate=\"sceaApp.project.detail.title\">Project</span> {{vm.project.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.project.projectName\">Project Name</span></dt><dd><span>{{vm.project.projectName}}</span></dd><dt><span translate=\"sceaApp.project.processDefinitionId\">Process Definition Id</span></dt><dd><span>{{vm.project.processDefinitionId}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/project/project-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProjectLabel\" translate=\"sceaApp.project.home.createOrEditLabel\">Create or edit a Project</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.project.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.project.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.project.projectName\" for=\"field_projectName\">Project Name</label><input type=\"text\" class=\"form-control\" name=\"projectName\" id=\"field_projectName\" ng-model=\"vm.project.projectName\" required><div ng-show=\"editForm.projectName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.projectName.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.project.processDefinitionId\" for=\"field_processDefinitionId\">Process Definition Id</label><input type=\"text\" class=\"form-control\" name=\"processDefinitionId\" id=\"field_processDefinitionId\" ng-model=\"vm.project.processDefinitionId\" ng-disabled=\"true\"></div><div class=\"form-group form-group-sm\"><label class=\"control-label\" translate=\"sceaApp.project.deployBpmFile\" for=\"field_uploadBpmFile\">Deploy bpmn file</label><button id=\"field_uploadBpmFile\" type=\"file\" ngf-select=\"vm.deployBpmFile($file, $invalidFiles)\" ngf-accept=\"application/xml\" ngf-max-size=\"5MB\" ng-disabled=\"vm.deployAndGetProcessProgress\" class=\"btn btn-default\" translate=\"entity.action.addfile\" ng-click=\"vm.nullValue()\" name=\"uploadBpmFile\" maxbytes=\"50000000\">AddvFile</button><div style=\"font: smaller\" id=\"test\">{{vm.bpm_file.name}} {{vm.errFile.name}}<p style=\"color:red\">{{vm.errFile.$error}} {{vm.errFile.$errorParam}}</p><span class=\"progress\" ng-show=\"f.progress >= 0\" ng-init=\"disabled=true\"><div style=\"width: {{vm.bpm_file.progress}}%\" ng-bind=\"vm.bpm_file.progress + \'%\'\"></div></span></div><p style=\"color:red\" ng-hide=\"vm.deployError\">File must be of type .bpmn20.xml, .bpmn, .bar or .zip</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.deployAndGetProcessProgress || vm.buttonSave || vm.errFile\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/project/projects.html","<div><h2 translate=\"sceaApp.project.home.title\">Projects</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"project.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.project.home.createLabel\">Create new Project</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.project.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"projectName\"><span translate=\"sceaApp.project.projectName\">Project Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"processDefinitionId\"><span translate=\"sceaApp.project.processDefinitionId\">Process Definition Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"project in vm.projects track by project.id\"><td><a ui-sref=\"project-detail({id:project.id})\">{{project.id}}</a></td><td>{{project.projectName}}</td><td>{{project.processDefinitionId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"project-detail({id:project.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"project.edit({id:project.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"project.delete({id:project.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/product-inch/product-inch-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.productInch.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.productInch.delete.question\" translate-values=\"{id: \'{{vm.productInch.id}}\'}\">Are you sure you want to delete this Product Inch?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product-inch/product-inch-detail.html","<div><h2><span translate=\"sceaApp.productInch.detail.title\">Product Inch</span> {{vm.productInch.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.productInch.deskripsi\">Deskripsi</span></dt><dd><span>{{vm.productInch.deskripsi}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product-inch/product-inch-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductInchLabel\" translate=\"sceaApp.productInch.home.createOrEditLabel\">Create or edit a Product Inch</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.productInch.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.productInch.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.productInch.deskripsi\" for=\"field_deskripsi\">Deskripsi</label><input type=\"text\" class=\"form-control\" name=\"deskripsi\" id=\"field_deskripsi\" ng-model=\"vm.productInch.deskripsi\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product-inch/product-inches.html","<div><h2 translate=\"sceaApp.productInch.home.title\">Product Inches</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product-inch.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.productInch.home.createLabel\">Create new Product Inch</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.productInch.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deskripsi\"><span translate=\"sceaApp.productInch.deskripsi\">Deskripsi</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"productInch in vm.productInches track by productInch.id\"><td><a ui-sref=\"product-inch-detail({id:productInch.id})\">{{productInch.id}}</a></td><td>{{productInch.deskripsi}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-inch-detail({id:productInch.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product-inch.edit({id:productInch.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product-inch.delete({id:productInch.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/project-column/project-column-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.projectColumn.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.projectColumn.delete.question\" translate-values=\"{id: \'{{vm.projectColumn.id}}\'}\">Are you sure you want to delete this Project Column?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/project-column/project-column-detail.html","<div><h2><span translate=\"sceaApp.projectColumn.detail.title\">Project Column</span> {{vm.projectColumn.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.projectColumn.columnId\">Column Id</span></dt><dd><span>{{vm.projectColumn.columnId}}</span></dd><dt><span translate=\"sceaApp.projectColumn.columnName\">Column Name</span></dt><dd><span>{{vm.projectColumn.columnName}}</span></dd><dt><span translate=\"sceaApp.projectColumn.columnAlias\">Column Alias</span></dt><dd><span>{{vm.projectColumn.columnAlias}}</span></dd><dt><span translate=\"sceaApp.projectColumn.sequence\">Sequence</span></dt><dd><span>{{vm.projectColumn.sequence}}</span></dd><dt><span translate=\"sceaApp.projectColumn.project\">Project</span></dt><dd><a ui-sref=\"project-detail({id:vm.projectColumn.projectId})\">{{vm.projectColumn.projectProjectName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/project-column/project-column-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProjectColumnLabel\" translate=\"sceaApp.projectColumn.home.createOrEditLabel\">Create or edit a Project Column</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.projectColumn.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.projectColumn.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.projectColumn.columnId\" for=\"field_columnId\">Column Id</label><input type=\"text\" class=\"form-control\" name=\"columnId\" id=\"field_columnId\" ng-model=\"vm.projectColumn.columnId\" required><div ng-show=\"editForm.columnId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.columnId.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.projectColumn.columnName\" for=\"field_columnName\">Column Name</label><input type=\"text\" class=\"form-control\" name=\"columnName\" id=\"field_columnName\" ng-model=\"vm.projectColumn.columnName\" required><div ng-show=\"editForm.columnName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.columnName.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.projectColumn.columnAlias\" for=\"field_columnAlias\">Column Alias</label><input type=\"text\" class=\"form-control\" name=\"columnAlias\" id=\"field_columnAlias\" ng-model=\"vm.projectColumn.columnAlias\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.projectColumn.sequence\" for=\"field_sequence\">Sequence</label><input type=\"number\" class=\"form-control\" name=\"sequence\" id=\"field_sequence\" ng-model=\"vm.projectColumn.sequence\" required><div ng-show=\"editForm.sequence.$invalid\"><p class=\"help-block\" ng-show=\"editForm.sequence.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.sequence.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"sceaApp.projectColumn.project\" for=\"field_project\">Project</label><select class=\"form-control\" id=\"field_project\" name=\"project\" ng-model=\"vm.projectColumn.projectId\" ng-options=\"project.id as project.projectName for project in vm.projects\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/project-column/project-columns.html","<div><h2 translate=\"sceaApp.projectColumn.home.title\">Project Columns</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"project-column.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.projectColumn.home.createLabel\">Create new Project Column</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.projectColumn.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"sceaApp.projectColumn.columnId\">Column Id</span></th><th><span translate=\"sceaApp.projectColumn.columnName\">Column Name</span></th><th><span translate=\"sceaApp.projectColumn.columnAlias\">Column Alias</span></th><th><span translate=\"sceaApp.projectColumn.sequence\">Sequence</span></th><th><span translate=\"sceaApp.projectColumn.project\">Project</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"projectColumn in vm.projectColumns track by projectColumn.id\"><td><a ui-sref=\"project-column-detail({id:projectColumn.id})\">{{projectColumn.id}}</a></td><td>{{projectColumn.columnId}}</td><td>{{projectColumn.columnName}}</td><td>{{projectColumn.columnAlias}}</td><td>{{projectColumn.sequence}}</td><td><a ui-sref=\"project-detail({id:projectColumn.projectId})\">{{projectColumn.projectProjectName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"project-column-detail({id:projectColumn.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"project-column.edit({id:projectColumn.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"project-column.delete({id:projectColumn.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/promo-material/promo-material-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.promoMaterial.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.promoMaterial.delete.question\" translate-values=\"{id: \'{{vm.promoMaterial.id}}\'}\">Are you sure you want to delete this Promo Material?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/promo-material/promo-material-detail.html","<div><h2><span translate=\"sceaApp.promoMaterial.detail.title\">Promo Material</span> {{vm.promoMaterial.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.promoMaterial.name\">Name</span></dt><dd><span>{{vm.promoMaterial.name}}</span></dd><dt><span translate=\"sceaApp.promoMaterial.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.promoMaterial.productCategoryId})\">{{vm.promoMaterial.productCategoryCategoryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/promo-material/promo-material-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPromoMaterialLabel\" translate=\"sceaApp.promoMaterial.home.createOrEditLabel\">Create or edit a Promo Material</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.promoMaterial.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.promoMaterial.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.promoMaterial.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.promoMaterial.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group has-feedback\"><label data-translate=\"sceaApp.promoMaterial.productCategory\" for=\"field_productCategory\">Product Category</label><input type=\"text\" ng-model=\"vm.selectedProduct\" id=\"field_productCategory\" name=\"productCategory\" uib-typeahead=\"product as product.categoryName for product in vm.getProductCategory($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingProduct\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/promo-material/promo-materials.html","<div><h2 translate=\"sceaApp.promoMaterial.home.title\">Promo Materials</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"promo-material.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.promoMaterial.home.createLabel\">Create new Promo Material</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.promoMaterial.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.promoMaterial.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCategoryCategoryName\"><span translate=\"sceaApp.promoMaterial.productCategory\">Product Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"promoMaterial in vm.promoMaterials track by promoMaterial.id\"><td><a ui-sref=\"promo-material-detail({id:promoMaterial.id})\">{{promoMaterial.id}}</a></td><td>{{promoMaterial.name}}</td><td><a ui-sref=\"product-category-detail({id:promoMaterial.productCategoryId})\">{{promoMaterial.productCategoryCategoryName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"promo-material-detail({id:promoMaterial.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"promo-material.edit({id:promoMaterial.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"promo-material.delete({id:promoMaterial.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/promotion/promotion-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.promotion.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.promotion.delete.question\" translate-values=\"{id: \'{{vm.promotion.id}}\'}\">Are you sure you want to delete this Promotion?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/promotion/promotion-detail.html","<div><h2><span translate=\"sceaApp.promotion.detail.title\">Promotion</span> {{vm.promotion.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.promotion.name\">Name</span></dt><dd><span>{{vm.promotion.name}}</span></dd><dt><span translate=\"sceaApp.promotion.validFrom\">Valid From</span></dt><dd><span>{{vm.promotion.validFrom | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.promotion.validUntil\">Valid Until</span></dt><dd><span>{{vm.promotion.validUntil | date:\'d MMMM y\'}}</span></dd></dl><div ui-view=\"promotion-dtls\"></div><button type=\"submit\" ui-sref=\"promotion\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/promotion/promotion-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPromotionLabel\" translate=\"sceaApp.promotion.home.createOrEditLabel\">Create or edit a Promotion</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.promotion.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.promotion.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.promotion.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.promotion.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.promotion.validFrom\" for=\"field_validFrom\">Valid From</label><div class=\"input-group\"><input id=\"field_validFrom\" type=\"text\" class=\"form-control\" name=\"validFrom\" datetime-picker=\"d MMMM y\" ng-model=\"vm.promotion.validFrom\" is-open=\"vm.datePickerOpenStatus.validFrom\" enable-time=\"false\" ng-change=\"vm.checkValidDate(vm.date.validFrom)\" datepicker-options=\"vm.datePickerOptions.validFrom\" readonly=\"readonly\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'validFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.promotion.validUntil\" for=\"field_validUntil\">Valid Until</label><div class=\"input-group\"><input id=\"field_validUntil\" type=\"text\" class=\"form-control\" name=\"validUntil\" datetime-picker=\"d MMMM y\" ng-model=\"vm.promotion.validUntil\" is-open=\"vm.datePickerOpenStatus.validUntil\" enable-time=\"false\" ng-disabled=\"!vm.date.validFrom\" datepicker-options=\"vm.datePickerOptions.validUntil\" ng-required=\"vm.date.fromDate\" readonly=\"readonly\"> <span class=\"input-group-btn\"><button type=\"button\" ng-disabled=\"!vm.promotion.validFrom\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'validUntil\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.invalidDate || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/promotion/promotions.html","<div><h2 translate=\"sceaApp.promotion.home.title\">Promotions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"promotion.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.promotion.home.createLabel\">Create new Promotion</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.promotion.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.promotion.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"validFrom\"><span translate=\"sceaApp.promotion.validFrom\">Valid From</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"validUntil\"><span translate=\"sceaApp.promotion.validUntil\">Valid Until</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"promotion in vm.promotions track by promotion.id\"><td><a ui-sref=\"promotion-detail({id:promotion.id})\">{{promotion.id}}</a></td><td>{{promotion.name}}</td><td>{{promotion.validFrom | date:\'d MMMM y\'}}</td><td>{{promotion.validUntil | date:\'d MMMM y\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"promotion-detail({id:promotion.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"sceaApp.promotion.viewShops\"></span></button> <button type=\"submit\" ng-disabled=\"!vm.checkExpiredPromotion({id: promotion.id, date: promotion.validUntil})\" ui-sref=\"promotion.edit({id:promotion.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-disabled=\"!vm.checkExpiredPromotion({id: promotion.id, date: promotion.validUntil})\" ui-sref=\"promotion.delete({id:promotion.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/promotion-dtl/promotion-dtl-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.promotionDtl.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.promotionDtl.delete.question\" translate-values=\"{id: \'{{vm.promotionDtl.id}}\'}\">Are you sure you want to delete this Promotion Dtl?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/promotion-dtl/promotion-dtl-detail.html","<div><h2><span translate=\"sceaApp.promotionDtl.detail.title\">Promotion Dtl</span> {{vm.promotionDtl.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.promotionDtl.allocationQty\">Allocation Qty</span></dt><dd><span>{{vm.promotionDtl.allocationQty}}</span></dd><dt><span translate=\"sceaApp.promotionDtl.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.promotionDtl.outletId})\">{{vm.promotionDtl.outletOutletName}}</a></dd><dt><span translate=\"sceaApp.promotionDtl.promoMaterial\">Promo Material</span></dt><dd><a ui-sref=\"promo-material-detail({id:vm.promotionDtl.promoMaterialId})\">{{vm.promotionDtl.promoMaterialName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/promotion-dtl/promotion-dtl-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPromotionDtlLabel\" translate=\"sceaApp.promotionDtl.home.createOrEditLabel\">Create or edit a Promotion Dtl</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class=\"form-group\" ng-show=\"vm.promotionDtl.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.promotionDtl.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.promotionDtl.allocationQty\" for=\"field_allocationQty\">Allocation Qty</label><input type=\"number\" min=\"0\" class=\"form-control\" name=\"allocationQty\" id=\"field_allocationQty\" ng-model=\"vm.promotionDtl.allocationQty\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.promotionDtl.outlet\" for=\"field_outlet\">Outlet</label><input type=\"text\" ng-model=\"vm.outlet\" name=\"outlet\" uib-typeahead=\"outlet as outlet.outletName for outlet in vm.getOutlet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingOutlet\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div ng-show=\"editForm.outlet.$invalid\"><p class=\"help-block\" ng-show=\"editForm.outlet.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.promotionDtl.promoMaterial\" for=\"field_promoMaterial\">Promo Material</label><input type=\"text\" ng-model=\"vm.promoMaterial\" name=\"promoMaterial\" uib-typeahead=\"promoMaterial as promoMaterial.name + \' - \' + promoMaterial.productCategoryCategoryName for promoMaterial in vm.getPromoMaterial($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingPromoMaterial\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div ng-show=\"editForm.promoMaterial.$invalid\"><p class=\"help-block\" ng-show=\"editForm.promoMaterial.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/promotion-dtl/promotion-dtls.html","<div><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-3 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"promotion-dtl-new\" ng-disabled=\"!vm.checkExpiredPromotion()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.promotionDtl.home.createLabel\">Create new Promotion Dtl</span></button></div><div class=\"col-xs-2\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".xlsx\" ngf-change=\"vm.setlistOrderData($file)\" data-translate=\"entity.upload.chooseFile\" ng-disabled=\"!vm.checkExpiredPromotion()\">Choose a File</button></div><div class=\"col-xs-5\"><div ng-if=\"!isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.listOrderData.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload </span><span class=\"pull-left\" ng-if=\"vm.listOrderData.size > 0\">{{vm.listOrderData.fileName}}, {{vm.listOrderData.size/1000 | number}} KB </span><button ng-if=\"vm.listOrderData.data > 0\" ng-click=\"vm.listOrderData.data = 0; vm.listOrderData.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\" ng-disabled=\"!vm.checkExpiredPromotion()\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\">Failed</span></div></div><div class=\"col-xs-2 no-padding-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.listOrderData.size || vm.listOrderData.size <= 0 || vm.isUploadFinished)\"><span class=\"glyphicon glyphicon-export\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.loadAll()\"><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.promotionDtl.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"promoMaterialName\"><span translate=\"sceaApp.promotionDtl.promoMaterial\">Promo Material</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"allocationQty\"><span translate=\"sceaApp.promotionDtl.allocationQty\">Allocation Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"received\"><span translate=\"sceaApp.promotionDtl.received\">Received</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"promotionDtl in vm.promotionDtls track by promotionDtl.id\"><td><a ui-sref=\"outlet-detail({id:promotionDtl.outletId})\">{{promotionDtl.outletOutletName}}</a></td><td><a ui-sref=\"promo-material-detail({id:promotionDtl.promoMaterialId})\">{{promotionDtl.promoMaterialName}}</a></td><td>{{promotionDtl.allocationQty | number}}</td><td>{{promotionDtl.received}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"promotion-dtl-detail({dtlId:promotionDtl.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"promotion-dtl-edit({dtlId:promotionDtl.id})\" class=\"btn btn-primary btn-sm\" ng-disabled=\"!vm.checkExpiredPromotion()\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"promotion-dtl-delete({dtlId:promotionDtl.id})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"!vm.checkExpiredPromotion()\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/retail-mapping-category/retail-mapping-categories.html","<div><h2 translate=\"sceaApp.retailMappingCategory.home.title\">Retail Mapping Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"retail-mapping-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.retailMappingCategory.home.createLabel\">Create new Retail Mapping Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.retailMappingCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.retailMappingCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"division\"><span translate=\"sceaApp.retailMappingCategory.division\">Division</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"retailMappingCategory in vm.retailMappingCategories track by retailMappingCategory.id\"><td><a ui-sref=\"retail-mapping-category-detail({id:retailMappingCategory.id})\">{{retailMappingCategory.id}}</a></td><td>{{retailMappingCategory.name}}</td><td translate=\"{{\'sceaApp.Division.\' + retailMappingCategory.division}}\">{{retailMappingCategory.division}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"retail-mapping-category-detail({id:retailMappingCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-category.edit({id:retailMappingCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-category.delete({id:retailMappingCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/retail-mapping-category/retail-mapping-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.retailMappingCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.retailMappingCategory.delete.question\" translate-values=\"{id: \'{{vm.retailMappingCategory.id}}\'}\">Are you sure you want to delete this Retail Mapping Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/retail-mapping-category/retail-mapping-category-detail.html","<div><h2><span translate=\"sceaApp.retailMappingCategory.detail.title\">Retail Mapping Category</span> {{vm.retailMappingCategory.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.retailMappingCategory.name\">Name</span></dt><dd><span>{{vm.retailMappingCategory.name}}</span></dd><dt><span translate=\"sceaApp.retailMappingCategory.division\">Division</span></dt><dd><span translate=\"{{\'sceaApp.Division.\' + vm.retailMappingCategory.division}}\">{{vm.retailMappingCategory.division}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/retail-mapping-category/retail-mapping-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRetailMappingCategoryLabel\" translate=\"sceaApp.retailMappingCategory.home.createOrEditLabel\">Create or edit a Retail Mapping Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.retailMappingCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.retailMappingCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.retailMappingCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.retailMappingCategory.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.retailMappingCategory.division\" for=\"field_division\">Division</label><select class=\"form-control\" name=\"division\" ng-model=\"vm.retailMappingCategory.division\" id=\"field_division\" required><option value=\"AV\" translate=\"sceaApp.Division.AV\">AV</option><option value=\"HA\" translate=\"sceaApp.Division.HA\">HA</option></select><div ng-show=\"editForm.division.$invalid\"><p class=\"help-block\" ng-show=\"editForm.division.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/retail-mapping-photo-category/retail-mapping-photo-categories.html","<div><h2 translate=\"sceaApp.retailMappingPhotoCategory.home.title\">Retail Mapping Photo Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"retail-mapping-photo-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.retailMappingPhotoCategory.home.createLabel\">Create new Retail Mapping Photo Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.retailMappingPhotoCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.retailMappingPhotoCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"retailMappingPhotoCategory in vm.retailMappingPhotoCategories track by retailMappingPhotoCategory.id\"><td><a ui-sref=\"retail-mapping-photo-category-detail({id:retailMappingPhotoCategory.id})\">{{retailMappingPhotoCategory.id}}</a></td><td>{{retailMappingPhotoCategory.name}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"retail-mapping-photo-category-detail({id:retailMappingPhotoCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-photo-category.edit({id:retailMappingPhotoCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-photo-category.delete({id:retailMappingPhotoCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/retail-mapping-photo-category/retail-mapping-photo-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.retailMappingPhotoCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.retailMappingPhotoCategory.delete.question\" translate-values=\"{id: \'{{vm.retailMappingPhotoCategory.id}}\'}\">Are you sure you want to delete this Retail Mapping Photo Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/retail-mapping-photo-category/retail-mapping-photo-category-detail.html","<div><h2><span translate=\"sceaApp.retailMappingPhotoCategory.detail.title\">Retail Mapping Photo Category</span> {{vm.retailMappingPhotoCategory.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.retailMappingPhotoCategory.name\">Name</span></dt><dd><span>{{vm.retailMappingPhotoCategory.name}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/retail-mapping-photo-category/retail-mapping-photo-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRetailMappingPhotoCategoryLabel\" translate=\"sceaApp.retailMappingPhotoCategory.home.createOrEditLabel\">Create or edit a Retail Mapping Photo Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.retailMappingPhotoCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.retailMappingPhotoCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.retailMappingPhotoCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.retailMappingPhotoCategory.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/retail-mapping-sub-category/retail-mapping-sub-categories.html","<div><h2 translate=\"sceaApp.retailMappingSubCategory.home.title\">Retail Mapping Sub Categories</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"retail-mapping-sub-category.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.retailMappingSubCategory.home.createLabel\">Create new Retail Mapping Sub Category</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.retailMappingSubCategory.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"sceaApp.retailMappingSubCategory.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"retailMappingCategoryName\"><span translate=\"sceaApp.retailMappingSubCategory.retailMappingCategory\">Retail Mapping Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parentName\"><span translate=\"sceaApp.retailMappingSubCategory.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"retailMappingSubCategory in vm.retailMappingSubCategories track by retailMappingSubCategory.id\"><td><a ui-sref=\"retail-mapping-sub-category-detail({id:retailMappingSubCategory.id})\">{{retailMappingSubCategory.id}}</a></td><td>{{retailMappingSubCategory.name}}</td><td><a ui-sref=\"retail-mapping-category-detail({id:retailMappingSubCategory.retailMappingCategoryId})\">{{retailMappingSubCategory.retailMappingCategoryName}}</a></td><td><a ui-sref=\"retail-mapping-sub-category-detail({id:retailMappingSubCategory.parentId})\">{{retailMappingSubCategory.parentName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"retail-mapping-sub-category-detail({id:retailMappingSubCategory.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-sub-category.edit({id:retailMappingSubCategory.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"retail-mapping-sub-category.delete({id:retailMappingSubCategory.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/retail-mapping-sub-category/retail-mapping-sub-category-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.retailMappingSubCategory.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.retailMappingSubCategory.delete.question\" translate-values=\"{id: \'{{vm.retailMappingSubCategory.id}}\'}\">Are you sure you want to delete this Retail Mapping Sub Category?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/retail-mapping-sub-category/retail-mapping-sub-category-detail.html","<div><h2><span translate=\"sceaApp.retailMappingSubCategory.detail.title\">Retail Mapping Sub Category</span> {{vm.retailMappingSubCategory.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.retailMappingSubCategory.name\">Name</span></dt><dd><span>{{vm.retailMappingSubCategory.name}}</span></dd><dt><span translate=\"sceaApp.retailMappingSubCategory.retailMappingCategory\">Retail Mapping Category</span></dt><dd><a ui-sref=\"retail-mapping-category-detail({id:vm.retailMappingSubCategory.retailMappingCategoryId})\">{{vm.retailMappingSubCategory.retailMappingCategoryName}}</a></dd><dt><span translate=\"sceaApp.retailMappingSubCategory.parent\">Parent</span></dt><dd><a ui-sref=\"retail-mapping-sub-category-detail({id:vm.retailMappingSubCategory.parentId})\">{{vm.retailMappingSubCategory.parentName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/retail-mapping-sub-category/retail-mapping-sub-category-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRetailMappingSubCategoryLabel\" translate=\"sceaApp.retailMappingSubCategory.home.createOrEditLabel\">Create or edit a Retail Mapping Sub Category</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.retailMappingSubCategory.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.retailMappingSubCategory.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.retailMappingSubCategory.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.retailMappingSubCategory.name\" required><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"sceaApp.retailMappingSubCategory.retailMappingCategory\" for=\"field_retailMappingCategory\">Retail Mapping Category</label><select class=\"form-control\" id=\"field_retailMappingCategory\" name=\"retailMappingCategory\" ng-model=\"vm.retailMappingSubCategory.retailMappingCategoryId\" ng-options=\"retailMappingCategory.id as retailMappingCategory.name for retailMappingCategory in vm.retailmappingcategories\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.retailMappingCategory.$invalid\"><p class=\"help-block\" ng-show=\"editForm.retailMappingCategory.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"sceaApp.retailMappingSubCategory.parent\" for=\"field_parent\">Parent</label><select class=\"form-control\" id=\"field_parent\" name=\"parent\" ng-model=\"vm.retailMappingSubCategory.parentId\" ng-options=\"retailMappingSubCategory.id as retailMappingSubCategory.name for retailMappingSubCategory in vm.retailmappingsubcategories\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/ris-product-target/ris-product-target-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.risProductTarget.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"sceaApp.risProductTarget.delete.question\" translate-values=\"{id: \'{{vm.risProductTarget.id}}\'}\">Are you sure you want to delete this Ris Product Target?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/ris-product-target/ris-product-target-detail.html","<div><h2><span data-translate=\"sceaApp.risProductTarget.detail.title\">Ris Product Target</span> {{vm.risProductTarget.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"sceaApp.risProductTarget.target\">Target</span></dt><dd><span>{{vm.risProductTarget.target}}</span></dd><dt><span data-translate=\"sceaApp.risProductTarget.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.risProductTarget.outletId})\">{{vm.risProductTarget.outletOutletCode}}</a></dd><dt><span data-translate=\"sceaApp.risProductTarget.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.risProductTarget.productId})\">{{vm.risProductTarget.productProductCode}}</a></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"ris-product-target-detail.edit({id:vm.risProductTarget.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/ris-product-target/ris-product-target-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRisProductTargetLabel\" data-translate=\"sceaApp.risProductTarget.home.createOrEditLabel\">Create or edit a Ris Product Target</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.risProductTarget.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.risProductTarget.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"sceaApp.risProductTarget.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.risProductTarget.target\" required><div ng-show=\"editForm.target.$invalid\"><p class=\"help-block\" ng-show=\"editForm.target.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.target.$error.number\" data-translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group has-feedback\"><label data-translate=\"sceaApp.risProductTarget.outlet\" for=\"field_outlet\">Outlet</label><input type=\"text\" ng-model=\"vm.outlet\" name=\"outlet\" id=\"field_outlet\" uib-typeahead=\"outlet as outlet.outletName for outlet in vm.getOutlet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingOutlet\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div ng-show=\"!vm.outlet\"><p class=\"help-block\" ng-show=\"!vm.outlet\" data-translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label data-translate=\"sceaApp.risProductTarget.product\" for=\"field_product\">Product</label><input type=\"text\" ng-model=\"vm.product\" name=\"product\" id=\"product\" uib-typeahead=\"product as product.productCode for product in vm.getProduct($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingProduct\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"></div><div ng-show=\"editForm.product.$invalid\"><p class=\"help-block\" ng-show=\"editForm.product.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.outlet\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/ris-product-target/ris-product-target-import.html","<div><h2><span data-translate=\"sceaApp.risProductTarget.import.title\">Import Ris Product Target</span></h2><hr><jhi-alert-error></jhi-alert-error><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div><br><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/ris-product-target/ris-product-targets.html","<div><h2 data-translate=\"sceaApp.risProductTarget.home.title\">Ris Product Targets</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"ris-product-target.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"sceaApp.risProductTarget.home.createLabel\">Create new Ris Product Target</span></button> <button class=\"btn btn-primary\" ui-sref=\"ris-product-target-import\"><span class=\"glyphicon glyphicon-import\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"sceaApp.risProductTarget.home.importLabel\">Import Ris Product Target</span></button></div><div class=\"col-xs-4 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.risProductTarget.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span data-translate=\"sceaApp.risProductTarget.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletCode\"><span data-translate=\"sceaApp.risProductTarget.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productProductCode\"><span data-translate=\"sceaApp.risProductTarget.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"risProductTarget in vm.risProductTargets track by risProductTarget.id\"><td><a ui-sref=\"ris-product-target-detail({id:risProductTarget.id})\">{{risProductTarget.id}}</a></td><td>{{risProductTarget.target}}</td><td><a ui-sref=\"outlet-detail({id:risProductTarget.outletId})\">{{risProductTarget.outletOutletCode}}</a></td><td><a ui-sref=\"product-detail({id:risProductTarget.productId})\">{{risProductTarget.productProductCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"ris-product-target-detail({id:risProductTarget.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"ris-product-target.edit({id:risProductTarget.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"ris-product-target.delete({id:risProductTarget.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/sellout/sellout-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.sellout.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.sellout.delete.question\" translate-values=\"{id: \'{{vm.sellout.id}}\'}\">Are you sure you want to delete this Sellout?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/sellout/sellout-detail.html","<div><h2><span translate=\"sceaApp.sellout.detail.title\">Sellout</span> {{vm.sellout.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.sellout.year\">Year</span></dt><dd><span>{{vm.sellout.year}}</span></dd><dt><span translate=\"sceaApp.sellout.month\">Month</span></dt><dd><span>{{vm.sellout.month}}</span></dd><dt><span translate=\"sceaApp.sellout.value\">Value</span></dt><dd><span>{{vm.sellout.value}}</span></dd><dt><span translate=\"sceaApp.sellout.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.sellout.outletId})\">{{vm.sellout.outletOutletName}}</a></dd><dt><span translate=\"sceaApp.sellout.productCategory\">Product Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.sellout.productCategoryId})\">{{vm.sellout.productCategoryCategoryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/sellout/sellout-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mySelloutLabel\" translate=\"sceaApp.sellout.home.createOrEditLabel\">Create or edit a Sellout</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.sellout.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.sellout.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.sellout.year\" for=\"field_year\">Year</label><input type=\"number\" class=\"form-control\" name=\"year\" id=\"field_year\" ng-model=\"vm.sellout.year\" required max=\"9999\"><div ng-show=\"editForm.year.$invalid\"><p class=\"help-block\" ng-show=\"editForm.year.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.year.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"9999\">This field cannot be more than 9999.</p><p class=\"help-block\" ng-show=\"editForm.year.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.sellout.month\" for=\"field_month\">Month</label><input type=\"number\" class=\"form-control\" name=\"month\" id=\"field_month\" ng-model=\"vm.sellout.month\" required max=\"12\"><div ng-show=\"editForm.month.$invalid\"><p class=\"help-block\" ng-show=\"editForm.month.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.month.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"12\">This field cannot be more than 12.</p><p class=\"help-block\" ng-show=\"editForm.month.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.sellout.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.sellout.value\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.sellout.outlet\" for=\"field_outlet\">Outlet</label><input type=\"text\" ng-model=\"vm.outlet\" name=\"outlet\" uib-typeahead=\"outlet as outlet.outletName for outlet in vm.getOutlet($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingOutlet\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><div class=\"form-group\"><label translate=\"sceaApp.sellout.productCategory\" for=\"field_productCategory\">Product Category</label><select class=\"form-control\" id=\"field_productCategory\" name=\"productCategory\" ng-model=\"vm.sellout.productCategoryId\" ng-options=\"productCategory.id as productCategory.categoryName for productCategory in vm.productcategories\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/sellout/sellouts.html","<div><h2 translate=\"sceaApp.sellout.home.title\">Sellouts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"sellout.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.sellout.home.createLabel\">Create new Sellout</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.sellout.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"year\"><span translate=\"sceaApp.sellout.year\">Year</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"month\"><span translate=\"sceaApp.sellout.month\">Month</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.sellout.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.sellout.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productCategoryCategoryName\"><span translate=\"sceaApp.sellout.productCategory\">Product Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"sellout in vm.sellouts track by sellout.id\"><td><a ui-sref=\"sellout-detail({id:sellout.id})\">{{sellout.id}}</a></td><td>{{sellout.year}}</td><td>{{sellout.month}}</td><td>{{sellout.value}}</td><td><a ui-sref=\"outlet-detail({id:sellout.outletId})\">{{sellout.outletOutletName}}</a></td><td><a ui-sref=\"product-category-detail({id:sellout.productCategoryId})\">{{sellout.productCategoryCategoryName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"sellout-detail({id:sellout.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"sellout.edit({id:sellout.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"sellout.delete({id:sellout.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/store-completeness/store-completeness-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.storeCompleteness.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.storeCompleteness.delete.question\" translate-values=\"{id: \'{{vm.storeCompleteness.id}}\'}\">Are you sure you want to delete this Store Completeness?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/store-completeness/store-completeness-detail.html","<div><h2><span translate=\"sceaApp.storeCompleteness.detail.title\">Store Completeness</span> {{vm.storeCompleteness.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.storeCompleteness.sequence\">Sequence</span></dt><dd><span>{{vm.storeCompleteness.sequence}}</span></dd><dt><span translate=\"sceaApp.storeCompleteness.description\">Description</span></dt><dd><span>{{vm.storeCompleteness.description}}</span></dd><dt><span translate=\"sceaApp.storeCompleteness.insertable\">Insertable</span></dt><dd><span>{{vm.storeCompleteness.insertable}}</span></dd><dt><span translate=\"sceaApp.storeCompleteness.parent\">Parent</span></dt><dd><a ui-sref=\"store-completeness-detail({id:vm.storeCompleteness.parentId})\">{{vm.storeCompleteness.parentDescription}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/store-completeness/store-completeness-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myStoreCompletenessLabel\" translate=\"sceaApp.storeCompleteness.home.createOrEditLabel\">Create or edit a Store Completeness</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.storeCompleteness.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.storeCompleteness.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.storeCompleteness.sequence\" for=\"field_sequence\">Sequence</label><input type=\"number\" class=\"form-control\" name=\"sequence\" id=\"field_sequence\" ng-model=\"vm.storeCompleteness.sequence\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.storeCompleteness.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.storeCompleteness.description\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.storeCompleteness.insertable\" for=\"field_insertable\">Insertable</label><input type=\"checkbox\" class=\"form-control\" name=\"insertable\" id=\"field_insertable\" ng-model=\"vm.storeCompleteness.insertable\"></div><div class=\"form-group has-feedback\"><label translate=\"sceaApp.storeCompleteness.parent\">Parent</label><input type=\"text\" ng-model=\"vm.storeCompleteness.parentDescription\" name=\"parent\" uib-typeahead=\"stc as stc.description for stc in vm.getParent($viewValue)\" typeahead-editable=\"false\" typeahead-loading=\"vm.loadingParent\" typeahead-on-select=\"vm.onSelectParent($item, $model, $label)\" typeahead-show-hint=\"true\" typeahead-min-length=\"1\" class=\"form-control\" autocomplete=\"off\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/store-completeness/store-completenesses.html","<div><h2 translate=\"sceaApp.storeCompleteness.home.title\">Store Completenesses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"store-completeness.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.storeCompleteness.home.createLabel\">Create new Store Completeness</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.storeCompleteness.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sequence\"><span translate=\"sceaApp.storeCompleteness.sequence\">Sequence</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"sceaApp.storeCompleteness.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"insertable\"><span translate=\"sceaApp.storeCompleteness.insertable\">Insertable</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"parent.description\"><span translate=\"sceaApp.storeCompleteness.parent\">Parent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"storeCompleteness in vm.storeCompletenesses track by storeCompleteness.id\"><td><a ui-sref=\"store-completeness-detail({id:storeCompleteness.id})\">{{storeCompleteness.id}}</a></td><td>{{storeCompleteness.sequence}}</td><td>{{storeCompleteness.description}}</td><td>{{storeCompleteness.insertable}}</td><td><a ui-sref=\"store-completeness-detail({id:storeCompleteness.parentId})\">{{storeCompleteness.parentDescription}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"store-completeness-detail({id:storeCompleteness.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"store-completeness.edit({id:storeCompleteness.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"store-completeness.delete({id:storeCompleteness.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-file-image-other-job/t-file-image-other-job-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tFileImageOtherJob.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tFileImageOtherJob.delete.question\" translate-values=\"{id: \'{{vm.tFileImageOtherJob.id}}\'}\">Are you sure you want to delete this T File Image Other Job?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-file-image-other-job/t-file-image-other-job-detail.html","<div><h2><span translate=\"sceaApp.tFileImageOtherJob.detail.title\">T File Image Other Job</span> {{vm.tFileImageOtherJob.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tFileImageOtherJob.createdDate\">Created Date</span></dt><dd><span>{{vm.tFileImageOtherJob.createdDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.filePath\">File Path</span></dt><dd><span>{{vm.tFileImageOtherJob.filePath}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.fileName\">File Name</span></dt><dd><span>{{vm.tFileImageOtherJob.fileName}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.longitudeX\">Longitude X</span></dt><dd><span>{{vm.tFileImageOtherJob.longitudeX}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.latitudeY\">Latitude Y</span></dt><dd><span>{{vm.tFileImageOtherJob.latitudeY}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.fileDesc\">File Desc</span></dt><dd><span>{{vm.tFileImageOtherJob.fileDesc}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.formNo\">Form No</span></dt><dd><span>{{vm.tFileImageOtherJob.formNo}}</span></dd><dt><span translate=\"sceaApp.tFileImageOtherJob.fileFlag\">File Flag</span></dt><dd><span>{{vm.tFileImageOtherJob.fileFlag}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-file-image-other-job/t-file-image-other-job-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTFileImageOtherJobLabel\" translate=\"sceaApp.tFileImageOtherJob.home.createOrEditLabel\">Create or edit a T File Image Other Job</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tFileImageOtherJob.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tFileImageOtherJob.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.createdDate\" for=\"field_createdDate\">Created Date</label><div class=\"input-group\"><input id=\"field_createdDate\" type=\"text\" class=\"form-control\" name=\"createdDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.tFileImageOtherJob.createdDate\" is-open=\"vm.datePickerOpenStatus.createdDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createdDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.filePath\" for=\"field_filePath\">File Path</label><input type=\"text\" class=\"form-control\" name=\"filePath\" id=\"field_filePath\" ng-model=\"vm.tFileImageOtherJob.filePath\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.fileName\" for=\"field_fileName\">File Name</label><input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\" ng-model=\"vm.tFileImageOtherJob.fileName\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.longitudeX\" for=\"field_longitudeX\">Longitude X</label><input type=\"number\" class=\"form-control\" name=\"longitudeX\" id=\"field_longitudeX\" ng-model=\"vm.tFileImageOtherJob.longitudeX\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.latitudeY\" for=\"field_latitudeY\">Latitude Y</label><input type=\"number\" class=\"form-control\" name=\"latitudeY\" id=\"field_latitudeY\" ng-model=\"vm.tFileImageOtherJob.latitudeY\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.fileDesc\" for=\"field_fileDesc\">File Desc</label><input type=\"text\" class=\"form-control\" name=\"fileDesc\" id=\"field_fileDesc\" ng-model=\"vm.tFileImageOtherJob.fileDesc\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tFileImageOtherJob.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tFileImageOtherJob.fileFlag\" for=\"field_fileFlag\">File Flag</label><input type=\"number\" class=\"form-control\" name=\"fileFlag\" id=\"field_fileFlag\" ng-model=\"vm.tFileImageOtherJob.fileFlag\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-file-image-other-job/t-file-image-other-jobs.html","<div><h2 translate=\"sceaApp.tFileImageOtherJob.home.title\">T File Image Other Jobs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-file-image-other-job.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tFileImageOtherJob.home.createLabel\">Create new T File Image Other Job</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tFileImageOtherJob.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdDate\"><span translate=\"sceaApp.tFileImageOtherJob.createdDate\">Created Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"filePath\"><span translate=\"sceaApp.tFileImageOtherJob.filePath\">File Path</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileName\"><span translate=\"sceaApp.tFileImageOtherJob.fileName\">File Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitudeX\"><span translate=\"sceaApp.tFileImageOtherJob.longitudeX\">Longitude X</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitudeY\"><span translate=\"sceaApp.tFileImageOtherJob.latitudeY\">Latitude Y</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileDesc\"><span translate=\"sceaApp.tFileImageOtherJob.fileDesc\">File Desc</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tFileImageOtherJob.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileFlag\"><span translate=\"sceaApp.tFileImageOtherJob.fileFlag\">File Flag</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tFileImageOtherJob in vm.tFileImageOtherJobs track by tFileImageOtherJob.id\"><td><a ui-sref=\"t-file-image-other-job-detail({id:tFileImageOtherJob.id})\">{{tFileImageOtherJob.id}}</a></td><td>{{tFileImageOtherJob.createdDate | date:\'mediumDate\'}}</td><td>{{tFileImageOtherJob.filePath}}</td><td>{{tFileImageOtherJob.fileName}}</td><td>{{tFileImageOtherJob.longitudeX}}</td><td>{{tFileImageOtherJob.latitudeY}}</td><td>{{tFileImageOtherJob.fileDesc}}</td><td>{{tFileImageOtherJob.formNo}}</td><td>{{tFileImageOtherJob.fileFlag}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-file-image-other-job-detail({id:tFileImageOtherJob.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-file-image-other-job.edit({id:tFileImageOtherJob.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-file-image-other-job.delete({id:tFileImageOtherJob.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop/t-pop-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPop.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPop.delete.question\" translate-values=\"{id: \'{{vm.tPop.id}}\'}\">Are you sure you want to delete this T Pop?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop/t-pop-detail.html","<div><h2><span translate=\"sceaApp.tPop.detail.title\">T Pop</span> {{vm.tPop.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPop.submitDate\">Submit Date</span></dt><dd><span>{{vm.tPop.submitDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.tPop.surveyStart\">Survey Start</span></dt><dd><span>{{vm.tPop.surveyStart | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.tPop.surveyEnd\">Survey End</span></dt><dd><span>{{vm.tPop.surveyEnd | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.tPop.formNo\">Form No</span></dt><dd><span>{{vm.tPop.formNo}}</span></dd><dt><span translate=\"sceaApp.tPop.value\">Value</span></dt><dd><span>{{vm.tPop.value}}</span></dd><dt><span translate=\"sceaApp.tPop.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.tPop.employeeId})\">{{vm.tPop.employeeFirstName}}</a></dd><dt><span translate=\"sceaApp.tPop.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.tPop.outletId})\">{{vm.tPop.outletOutletName}}</a></dd><dt><span translate=\"sceaApp.tPop.ticketOrder\">Ticket Order</span></dt><dd><a ui-sref=\"ticket-order-detail({id:vm.tPop.ticketOrderId})\">{{vm.tPop.ticketOrderId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop/t-pop-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopLabel\" translate=\"sceaApp.tPop.home.createOrEditLabel\">Create or edit a T Pop</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPop.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPop.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPop.submitDate\" for=\"field_submitDate\">Submit Date</label><div class=\"input-group\"><input id=\"field_submitDate\" type=\"text\" class=\"form-control\" name=\"submitDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.tPop.submitDate\" is-open=\"vm.datePickerOpenStatus.submitDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'submitDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPop.surveyStart\" for=\"field_surveyStart\">Survey Start</label><div class=\"input-group\"><input id=\"field_surveyStart\" type=\"text\" class=\"form-control\" name=\"surveyStart\" datetime-picker=\"d MMMM y\" ng-model=\"vm.tPop.surveyStart\" is-open=\"vm.datePickerOpenStatus.surveyStart\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'surveyStart\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPop.surveyEnd\" for=\"field_surveyEnd\">Survey End</label><div class=\"input-group\"><input id=\"field_surveyEnd\" type=\"text\" class=\"form-control\" name=\"surveyEnd\" datetime-picker=\"d MMMM y\" ng-model=\"vm.tPop.surveyEnd\" is-open=\"vm.datePickerOpenStatus.surveyEnd\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'surveyEnd\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPop.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPop.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPop.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tPop.value\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPop.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.tPop.employeeId\" ng-options=\"employee.id as employee.firstName for employee in vm.employees\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPop.outlet\" for=\"field_outlet\">Outlet</label><select class=\"form-control\" id=\"field_outlet\" name=\"outlet\" ng-model=\"vm.tPop.outletId\" ng-options=\"outlet.id as outlet.outletName for outlet in vm.outlets\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPop.ticketOrder\" for=\"field_ticketOrder\">Ticket Order</label><select class=\"form-control\" id=\"field_ticketOrder\" name=\"ticketOrder\" ng-model=\"vm.tPop.ticketOrderId\" ng-options=\"ticketOrder.id as ticketOrder.id for ticketOrder in vm.ticketorders\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop/t-pops.html","<div><h2 translate=\"sceaApp.tPop.home.title\">T Pops</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPop.home.createLabel\">Create new T Pop</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPop.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"submitDate\"><span translate=\"sceaApp.tPop.submitDate\">Submit Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyStart\"><span translate=\"sceaApp.tPop.surveyStart\">Survey Start</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyEnd\"><span translate=\"sceaApp.tPop.surveyEnd\">Survey End</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPop.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tPop.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employeeFirstName\"><span translate=\"sceaApp.tPop.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.tPop.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ticketOrderId\"><span translate=\"sceaApp.tPop.ticketOrder\">Ticket Order</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPop in vm.tPops track by tPop.id\"><td><a ui-sref=\"t-pop-detail({id:tPop.id})\">{{tPop.id}}</a></td><td>{{tPop.submitDate | date:\'d MMMM y\'}}</td><td>{{tPop.surveyStart | date:\'d MMMM y\'}}</td><td>{{tPop.surveyEnd | date:\'d MMMM y\'}}</td><td>{{tPop.formNo}}</td><td>{{tPop.value}}</td><td><a ui-sref=\"employee-detail({id:tPop.employeeId})\">{{tPop.employeeFirstName}}</a></td><td><a ui-sref=\"outlet-detail({id:tPop.outletId})\">{{tPop.outletOutletName}}</a></td><td><a ui-sref=\"ticket-order-detail({id:tPop.ticketOrderId})\">{{tPop.ticketOrderId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-detail({id:tPop.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop.edit({id:tPop.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop.delete({id:tPop.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop-equipment/t-pop-equipment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPopEquipment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPopEquipment.delete.question\" translate-values=\"{id: \'{{vm.tPopEquipment.id}}\'}\">Are you sure you want to delete this T Pop Equipment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop-equipment/t-pop-equipment-detail.html","<div><h2><span translate=\"sceaApp.tPopEquipment.detail.title\">T Pop Equipment</span> {{vm.tPopEquipment.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPopEquipment.formNo\">Form No</span></dt><dd><span>{{vm.tPopEquipment.formNo}}</span></dd><dt><span translate=\"sceaApp.tPopEquipment.value\">Value</span></dt><dd><span>{{vm.tPopEquipment.value}}</span></dd><dt><span translate=\"sceaApp.tPopEquipment.target\">Target</span></dt><dd><span>{{vm.tPopEquipment.target}}</span></dd><dt><span translate=\"sceaApp.tPopEquipment.remarks\">Remarks</span></dt><dd><span>{{vm.tPopEquipment.remarks}}</span></dd><dt><span translate=\"sceaApp.tPopEquipment.popTrans\">Pop Trans</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tPopEquipment.popTransId})\">{{vm.tPopEquipment.popTransId}}</a></dd><dt><span translate=\"sceaApp.tPopEquipment.equipment\">Equipment</span></dt><dd><a ui-sref=\"equipment-detail({id:vm.tPopEquipment.equipmentId})\">{{vm.tPopEquipment.equipmentEquipmentName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop-equipment/t-pop-equipment-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopEquipmentLabel\" translate=\"sceaApp.tPopEquipment.home.createOrEditLabel\">Create or edit a T Pop Equipment</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPopEquipment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPopEquipment.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopEquipment.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPopEquipment.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopEquipment.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tPopEquipment.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopEquipment.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.tPopEquipment.target\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopEquipment.remarks\" for=\"field_remarks\">Remarks</label><input type=\"text\" class=\"form-control\" name=\"remarks\" id=\"field_remarks\" ng-model=\"vm.tPopEquipment.remarks\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPopEquipment.popTrans\" for=\"field_popTrans\">Pop Trans</label><select class=\"form-control\" id=\"field_popTrans\" name=\"popTrans\" ng-model=\"vm.tPopEquipment.popTransId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopEquipment.equipment\" for=\"field_equipment\">Equipment</label><select class=\"form-control\" id=\"field_equipment\" name=\"equipment\" ng-model=\"vm.tPopEquipment.equipmentId\" ng-options=\"equipment.id as equipment.equipmentName for equipment in vm.equipment\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop-equipment/t-pop-equipments.html","<div><h2 translate=\"sceaApp.tPopEquipment.home.title\">T Pop Equipments</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop-equipment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPopEquipment.home.createLabel\">Create new T Pop Equipment</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPopEquipment.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPopEquipment.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tPopEquipment.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span translate=\"sceaApp.tPopEquipment.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"remarks\"><span translate=\"sceaApp.tPopEquipment.remarks\">Remarks</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popTransId\"><span translate=\"sceaApp.tPopEquipment.popTrans\">Pop Trans</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"equipmentEquipmentName\"><span translate=\"sceaApp.tPopEquipment.equipment\">Equipment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPopEquipment in vm.tPopEquipments track by tPopEquipment.id\"><td><a ui-sref=\"t-pop-equipment-detail({id:tPopEquipment.id})\">{{tPopEquipment.id}}</a></td><td>{{tPopEquipment.formNo}}</td><td>{{tPopEquipment.value}}</td><td>{{tPopEquipment.target}}</td><td>{{tPopEquipment.remarks}}</td><td><a ui-sref=\"t-pop-detail({id:tPopEquipment.popTransId})\">{{tPopEquipment.popTransId}}</a></td><td><a ui-sref=\"equipment-detail({id:tPopEquipment.equipmentId})\">{{tPopEquipment.equipmentEquipmentName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-equipment-detail({id:tPopEquipment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-equipment.edit({id:tPopEquipment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-equipment.delete({id:tPopEquipment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop-dtl/t-pop-dtl-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPopDtl.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPopDtl.delete.question\" translate-values=\"{id: \'{{vm.tPopDtl.id}}\'}\">Are you sure you want to delete this T Pop Dtl?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop-dtl/t-pop-dtl-detail.html","<div><h2><span translate=\"sceaApp.tPopDtl.detail.title\">T Pop Dtl</span> {{vm.tPopDtl.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPopDtl.qty\">Qty</span></dt><dd><span>{{vm.tPopDtl.qty}}</span></dd><dt><span translate=\"sceaApp.tPopDtl.formNo\">Form No</span></dt><dd><span>{{vm.tPopDtl.formNo}}</span></dd><dt><span translate=\"sceaApp.tPopDtl.tPop\">T Pop</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tPopDtl.tPopId})\">{{vm.tPopDtl.tPopId}}</a></dd><dt><span translate=\"sceaApp.tPopDtl.pop\">Pop</span></dt><dd><a ui-sref=\"pop-detail({id:vm.tPopDtl.popId})\">{{vm.tPopDtl.popPopName}}</a></dd><dt><span translate=\"sceaApp.tPopDtl.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.tPopDtl.productId})\">{{vm.tPopDtl.productProductCode}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop-dtl/t-pop-dtl-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopDtlLabel\" translate=\"sceaApp.tPopDtl.home.createOrEditLabel\">Create or edit a T Pop Dtl</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPopDtl.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPopDtl.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopDtl.qty\" for=\"field_qty\">Qty</label><input type=\"number\" class=\"form-control\" name=\"qty\" id=\"field_qty\" ng-model=\"vm.tPopDtl.qty\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopDtl.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPopDtl.formNo\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPopDtl.tPop\" for=\"field_tPop\">T Pop</label><select class=\"form-control\" id=\"field_tPop\" name=\"tPop\" ng-model=\"vm.tPopDtl.tPopId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopDtl.pop\" for=\"field_pop\">Pop</label><select class=\"form-control\" id=\"field_pop\" name=\"pop\" ng-model=\"vm.tPopDtl.popId\" ng-options=\"pop.id as pop.popName for pop in vm.pops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopDtl.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.tPopDtl.productId\" ng-options=\"product.id as product.productCode for product in vm.products\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop-dtl/t-pop-dtls.html","<div><h2 translate=\"sceaApp.tPopDtl.home.title\">T Pop Dtls</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop-dtl.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPopDtl.home.createLabel\">Create new T Pop Dtl</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPopDtl.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"qty\"><span translate=\"sceaApp.tPopDtl.qty\">Qty</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPopDtl.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tPopId\"><span translate=\"sceaApp.tPopDtl.tPop\">T Pop</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popPopName\"><span translate=\"sceaApp.tPopDtl.pop\">Pop</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productProductCode\"><span translate=\"sceaApp.tPopDtl.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPopDtl in vm.tPopDtls track by tPopDtl.id\"><td><a ui-sref=\"t-pop-dtl-detail({id:tPopDtl.id})\">{{tPopDtl.id}}</a></td><td>{{tPopDtl.qty}}</td><td>{{tPopDtl.formNo}}</td><td><a ui-sref=\"t-pop-detail({id:tPopDtl.tPopId})\">{{tPopDtl.tPopId}}</a></td><td><a ui-sref=\"pop-detail({id:tPopDtl.popId})\">{{tPopDtl.popPopName}}</a></td><td><a ui-sref=\"product-detail({id:tPopDtl.productId})\">{{tPopDtl.productProductCode}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-dtl-detail({id:tPopDtl.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-dtl.edit({id:tPopDtl.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-dtl.delete({id:tPopDtl.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop-fixture/t-pop-fixture-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPopFixture.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPopFixture.delete.question\" translate-values=\"{id: \'{{vm.tPopFixture.id}}\'}\">Are you sure you want to delete this T Pop Fixture?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop-fixture/t-pop-fixture-detail.html","<div><h2><span translate=\"sceaApp.tPopFixture.detail.title\">T Pop Fixture</span> {{vm.tPopFixture.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPopFixture.formNo\">Form No</span></dt><dd><span>{{vm.tPopFixture.formNo}}</span></dd><dt><span translate=\"sceaApp.tPopFixture.value\">Value</span></dt><dd><span>{{vm.tPopFixture.value}}</span></dd><dt><span translate=\"sceaApp.tPopFixture.target\">Target</span></dt><dd><span>{{vm.tPopFixture.target}}</span></dd><dt><span translate=\"sceaApp.tPopFixture.remarks\">Remarks</span></dt><dd><span>{{vm.tPopFixture.remarks}}</span></dd><dt><span translate=\"sceaApp.tPopFixture.popTrans\">Pop Trans</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tPopFixture.popTransId})\">{{vm.tPopFixture.popTransId}}</a></dd><dt><span translate=\"sceaApp.tPopFixture.fixture\">Fixture</span></dt><dd><a ui-sref=\"fixtures-detail({id:vm.tPopFixture.fixtureId})\">{{vm.tPopFixture.fixtureFixtureName}}</a></dd><dt><span translate=\"sceaApp.tPopFixture.category\">Category</span></dt><dd><a ui-sref=\"product-category-detail({id:vm.tPopFixture.categoryId})\">{{vm.tPopFixture.categoryCategoryName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop-fixture/t-pop-fixture-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopFixtureLabel\" translate=\"sceaApp.tPopFixture.home.createOrEditLabel\">Create or edit a T Pop Fixture</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPopFixture.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPopFixture.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopFixture.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPopFixture.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopFixture.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tPopFixture.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopFixture.target\" for=\"field_target\">Target</label><input type=\"number\" class=\"form-control\" name=\"target\" id=\"field_target\" ng-model=\"vm.tPopFixture.target\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopFixture.remarks\" for=\"field_remarks\">Remarks</label><input type=\"text\" class=\"form-control\" name=\"remarks\" id=\"field_remarks\" ng-model=\"vm.tPopFixture.remarks\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPopFixture.popTrans\" for=\"field_popTrans\">Pop Trans</label><select class=\"form-control\" id=\"field_popTrans\" name=\"popTrans\" ng-model=\"vm.tPopFixture.popTransId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopFixture.fixture\" for=\"field_fixture\">Fixture</label><select class=\"form-control\" id=\"field_fixture\" name=\"fixture\" ng-model=\"vm.tPopFixture.fixtureId\" ng-options=\"fixtures.id as fixtures.fixtureName for fixtures in vm.fixtures\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopFixture.category\" for=\"field_category\">Category</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-model=\"vm.tPopFixture.categoryId\" ng-options=\"productCategory.id as productCategory.categoryName for productCategory in vm.productcategories\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop-fixture/t-pop-fixtures.html","<div><h2 translate=\"sceaApp.tPopFixture.home.title\">T Pop Fixtures</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop-fixture.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPopFixture.home.createLabel\">Create new T Pop Fixture</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPopFixture.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPopFixture.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tPopFixture.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"target\"><span translate=\"sceaApp.tPopFixture.target\">Target</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"remarks\"><span translate=\"sceaApp.tPopFixture.remarks\">Remarks</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popTransId\"><span translate=\"sceaApp.tPopFixture.popTrans\">Pop Trans</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fixtureFixtureName\"><span translate=\"sceaApp.tPopFixture.fixture\">Fixture</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"categoryCategoryName\"><span translate=\"sceaApp.tPopFixture.category\">Category</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPopFixture in vm.tPopFixtures track by tPopFixture.id\"><td><a ui-sref=\"t-pop-fixture-detail({id:tPopFixture.id})\">{{tPopFixture.id}}</a></td><td>{{tPopFixture.formNo}}</td><td>{{tPopFixture.value}}</td><td>{{tPopFixture.target}}</td><td>{{tPopFixture.remarks}}</td><td><a ui-sref=\"t-pop-detail({id:tPopFixture.popTransId})\">{{tPopFixture.popTransId}}</a></td><td><a ui-sref=\"fixtures-detail({id:tPopFixture.fixtureId})\">{{tPopFixture.fixtureFixtureName}}</a></td><td><a ui-sref=\"product-category-detail({id:tPopFixture.categoryId})\">{{tPopFixture.categoryCategoryName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-fixture-detail({id:tPopFixture.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-fixture.edit({id:tPopFixture.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-fixture.delete({id:tPopFixture.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop-internet/t-pop-internet-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPopInternet.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPopInternet.delete.question\" translate-values=\"{id: \'{{vm.tPopInternet.id}}\'}\">Are you sure you want to delete this T Pop Internet?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop-internet/t-pop-internet-detail.html","<div><h2><span translate=\"sceaApp.tPopInternet.detail.title\">T Pop Internet</span> {{vm.tPopInternet.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPopInternet.formNo\">Form No</span></dt><dd><span>{{vm.tPopInternet.formNo}}</span></dd><dt><span translate=\"sceaApp.tPopInternet.value\">Value</span></dt><dd><span>{{vm.tPopInternet.value}}</span></dd><dt><span translate=\"sceaApp.tPopInternet.popTrans\">Pop Trans</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tPopInternet.popTransId})\">{{vm.tPopInternet.popTransId}}</a></dd><dt><span translate=\"sceaApp.tPopInternet.internet\">Internet</span></dt><dd><a ui-sref=\"internet-detail({id:vm.tPopInternet.internetId})\">{{vm.tPopInternet.internetInternetName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop-internet/t-pop-internet-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopInternetLabel\" translate=\"sceaApp.tPopInternet.home.createOrEditLabel\">Create or edit a T Pop Internet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPopInternet.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPopInternet.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopInternet.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPopInternet.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopInternet.value\" for=\"field_value\">Value</label><input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tPopInternet.value\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPopInternet.popTrans\" for=\"field_popTrans\">Pop Trans</label><select class=\"form-control\" id=\"field_popTrans\" name=\"popTrans\" ng-model=\"vm.tPopInternet.popTransId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopInternet.internet\" for=\"field_internet\">Internet</label><select class=\"form-control\" id=\"field_internet\" name=\"internet\" ng-model=\"vm.tPopInternet.internetId\" ng-options=\"internet.id as internet.internetName for internet in vm.internets\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop-internet/t-pop-internets.html","<div><h2 translate=\"sceaApp.tPopInternet.home.title\">T Pop Internets</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop-internet.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPopInternet.home.createLabel\">Create new T Pop Internet</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPopInternet.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPopInternet.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tPopInternet.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popTransId\"><span translate=\"sceaApp.tPopInternet.popTrans\">Pop Trans</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"internetInternetName\"><span translate=\"sceaApp.tPopInternet.internet\">Internet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPopInternet in vm.tPopInternets track by tPopInternet.id\"><td><a ui-sref=\"t-pop-internet-detail({id:tPopInternet.id})\">{{tPopInternet.id}}</a></td><td>{{tPopInternet.formNo}}</td><td>{{tPopInternet.value}}</td><td><a ui-sref=\"t-pop-detail({id:tPopInternet.popTransId})\">{{tPopInternet.popTransId}}</a></td><td><a ui-sref=\"internet-detail({id:tPopInternet.internetId})\">{{tPopInternet.internetInternetName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-internet-detail({id:tPopInternet.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-internet.edit({id:tPopInternet.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-internet.delete({id:tPopInternet.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-pop-planogram/t-pop-planogram-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tPopPlanogram.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tPopPlanogram.delete.question\" translate-values=\"{id: \'{{vm.tPopPlanogram.id}}\'}\">Are you sure you want to delete this T Pop Planogram?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-pop-planogram/t-pop-planogram-detail.html","<div><h2><span translate=\"sceaApp.tPopPlanogram.detail.title\">T Pop Planogram</span> {{vm.tPopPlanogram.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tPopPlanogram.formNo\">Form No</span></dt><dd><span>{{vm.tPopPlanogram.formNo}}</span></dd><dt><span translate=\"sceaApp.tPopPlanogram.value\">Value</span></dt><dd><span>{{vm.tPopPlanogram.value}}</span></dd><dt><span translate=\"sceaApp.tPopPlanogram.popTrans\">Pop Trans</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tPopPlanogram.popTransId})\">{{vm.tPopPlanogram.popTransId}}</a></dd><dt><span translate=\"sceaApp.tPopPlanogram.planogramProduct\">Planogram Product</span></dt><dd><a ui-sref=\"planogram-product-detail({id:vm.tPopPlanogram.planogramProductId})\">{{vm.tPopPlanogram.planogramProductId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-pop-planogram/t-pop-planogram-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTPopPlanogramLabel\" translate=\"sceaApp.tPopPlanogram.home.createOrEditLabel\">Create or edit a T Pop Planogram</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tPopPlanogram.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tPopPlanogram.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopPlanogram.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tPopPlanogram.formNo\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tPopPlanogram.value\" for=\"field_value\">Value</label><input type=\"number\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tPopPlanogram.value\"></div><div class=\"form-group\"><label translate=\"sceaApp.tPopPlanogram.popTrans\" for=\"field_popTrans\">Pop Trans</label><select class=\"form-control\" id=\"field_popTrans\" name=\"popTrans\" ng-model=\"vm.tPopPlanogram.popTransId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tPopPlanogram.planogramProduct\" for=\"field_planogramProduct\">Planogram Product</label><select class=\"form-control\" id=\"field_planogramProduct\" name=\"planogramProduct\" ng-model=\"vm.tPopPlanogram.planogramProductId\" ng-options=\"planogramProduct.id as planogramProduct.id for planogramProduct in vm.planogramproducts\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-pop-planogram/t-pop-planograms.html","<div><h2 translate=\"sceaApp.tPopPlanogram.home.title\">T Pop Planograms</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-pop-planogram.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tPopPlanogram.home.createLabel\">Create new T Pop Planogram</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tPopPlanogram.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tPopPlanogram.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tPopPlanogram.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"popTransId\"><span translate=\"sceaApp.tPopPlanogram.popTrans\">Pop Trans</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"planogramProductId\"><span translate=\"sceaApp.tPopPlanogram.planogramProduct\">Planogram Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tPopPlanogram in vm.tPopPlanograms track by tPopPlanogram.id\"><td><a ui-sref=\"t-pop-planogram-detail({id:tPopPlanogram.id})\">{{tPopPlanogram.id}}</a></td><td>{{tPopPlanogram.formNo}}</td><td>{{tPopPlanogram.value}}</td><td><a ui-sref=\"t-pop-detail({id:tPopPlanogram.popTransId})\">{{tPopPlanogram.popTransId}}</a></td><td><a ui-sref=\"planogram-product-detail({id:tPopPlanogram.planogramProductId})\">{{tPopPlanogram.planogramProductId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-pop-planogram-detail({id:tPopPlanogram.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-planogram.edit({id:tPopPlanogram.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-pop-planogram.delete({id:tPopPlanogram.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/t-store-completeness/t-store-completeness-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.tStoreCompleteness.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.tStoreCompleteness.delete.question\" translate-values=\"{id: \'{{vm.tStoreCompleteness.id}}\'}\">Are you sure you want to delete this T Store Completeness?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/t-store-completeness/t-store-completeness-detail.html","<div><h2><span translate=\"sceaApp.tStoreCompleteness.detail.title\">T Store Completeness</span> {{vm.tStoreCompleteness.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.tStoreCompleteness.value\">Value</span></dt><dd><span>{{vm.tStoreCompleteness.value}}</span></dd><dt><span translate=\"sceaApp.tStoreCompleteness.formNo\">Form No</span></dt><dd><span>{{vm.tStoreCompleteness.formNo}}</span></dd><dt><span translate=\"sceaApp.tStoreCompleteness.tPop\">T Pop</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.tStoreCompleteness.tPopId})\">{{vm.tStoreCompleteness.tPopId}}</a></dd><dt><span translate=\"sceaApp.tStoreCompleteness.storeCompleteness\">Store Completeness</span></dt><dd><a ui-sref=\"store-completeness-detail({id:vm.tStoreCompleteness.storeCompletenessId})\">{{vm.tStoreCompleteness.storeCompletenessDescription}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/t-store-completeness/t-store-completeness-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTStoreCompletenessLabel\" translate=\"sceaApp.tStoreCompleteness.home.createOrEditLabel\">Create or edit a T Store Completeness</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.tStoreCompleteness.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.tStoreCompleteness.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tStoreCompleteness.value\" for=\"field_value\">Value</label><input type=\"checkbox\" class=\"form-control\" name=\"value\" id=\"field_value\" ng-model=\"vm.tStoreCompleteness.value\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.tStoreCompleteness.formNo\" for=\"field_formNo\">Form No</label><input type=\"text\" class=\"form-control\" name=\"formNo\" id=\"field_formNo\" ng-model=\"vm.tStoreCompleteness.formNo\"></div><div class=\"form-group\"><label translate=\"sceaApp.tStoreCompleteness.tPop\" for=\"field_tPop\">T Pop</label><select class=\"form-control\" id=\"field_tPop\" name=\"tPop\" ng-model=\"vm.tStoreCompleteness.tPopId\" ng-options=\"tPop.id as tPop.id for tPop in vm.tpops\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.tStoreCompleteness.storeCompleteness\" for=\"field_storeCompleteness\">Store Completeness</label><select class=\"form-control\" id=\"field_storeCompleteness\" name=\"storeCompleteness\" ng-model=\"vm.tStoreCompleteness.storeCompletenessId\" ng-options=\"storeCompleteness.id as storeCompleteness.description for storeCompleteness in vm.storecompletenesses\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/t-store-completeness/t-store-completenesses.html","<div><h2 translate=\"sceaApp.tStoreCompleteness.home.title\">T Store Completenesses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"t-store-completeness.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.tStoreCompleteness.home.createLabel\">Create new T Store Completeness</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.tStoreCompleteness.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"value\"><span translate=\"sceaApp.tStoreCompleteness.value\">Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"formNo\"><span translate=\"sceaApp.tStoreCompleteness.formNo\">Form No</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tPopId\"><span translate=\"sceaApp.tStoreCompleteness.tPop\">T Pop</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"storeCompletenessDescription\"><span translate=\"sceaApp.tStoreCompleteness.storeCompleteness\">Store Completeness</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"tStoreCompleteness in vm.tStoreCompletenesses track by tStoreCompleteness.id\"><td><a ui-sref=\"t-store-completeness-detail({id:tStoreCompleteness.id})\">{{tStoreCompleteness.id}}</a></td><td>{{tStoreCompleteness.value}}</td><td>{{tStoreCompleteness.formNo}}</td><td><a ui-sref=\"t-pop-detail({id:tStoreCompleteness.tPopId})\">{{tStoreCompleteness.tPopId}}</a></td><td><a ui-sref=\"store-completeness-detail({id:tStoreCompleteness.storeCompletenessId})\">{{tStoreCompleteness.storeCompletenessDescription}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"t-store-completeness-detail({id:tStoreCompleteness.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"t-store-completeness.edit({id:tStoreCompleteness.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"t-store-completeness.delete({id:tStoreCompleteness.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/ticket-order/ticket-order-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.ticketOrder.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.ticketOrder.delete.question\" translate-values=\"{id: \'{{vm.ticketOrder.id}}\'}\">Are you sure you want to delete this Ticket Order?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/ticket-order/ticket-order-detail.html","<div><h2><span translate=\"sceaApp.ticketOrder.detail.title\">Ticket Order</span> {{vm.ticketOrder.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.ticketOrder.activityId\">Activity Id</span></dt><dd><span>{{vm.ticketOrder.activityId}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.createdDate\">Created Date</span></dt><dd><span>{{vm.ticketOrder.createdDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.targetDate\">Target Date</span></dt><dd><span>{{vm.ticketOrder.targetDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.flagAsynch\">Flag Asynch</span></dt><dd><span>{{vm.ticketOrder.flagAsynch}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.ticketWfStat\">Ticket Wf Stat</span></dt><dd><span>{{vm.ticketOrder.ticketWfStat}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.ticketDesc\">Ticket Desc</span></dt><dd><span>{{vm.ticketOrder.ticketDesc}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.expiredDate\">Expired Date</span></dt><dd><span>{{vm.ticketOrder.expiredDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.periodStart\">Period Start</span></dt><dd><span>{{vm.ticketOrder.periodStart | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.periodEnd\">Period End</span></dt><dd><span>{{vm.ticketOrder.periodEnd | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.resultNote\">Result Note</span></dt><dd><span>{{vm.ticketOrder.resultNote}}</span></dd><dt><span translate=\"sceaApp.ticketOrder.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.ticketOrder.employeeId})\">{{vm.ticketOrder.employeeFirstName}}</a></dd><dt><span translate=\"sceaApp.ticketOrder.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.ticketOrder.outletId})\">{{vm.ticketOrder.outletOutletName}}</a></dd><dt><span translate=\"sceaApp.ticketOrder.ticketResult\">Ticket Result</span></dt><dd><a ui-sref=\"ticket-result-detail({id:vm.ticketOrder.ticketResultId})\">{{vm.ticketOrder.ticketResultResultDesc}}</a></dd><dt><span translate=\"sceaApp.ticketOrder.calendar\">Calendar</span></dt><dd><a ui-sref=\"calendar-detail({id:vm.ticketOrder.calendarId})\">{{vm.ticketOrder.calendarWeek}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/ticket-order/ticket-order-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTicketOrderLabel\" translate=\"sceaApp.ticketOrder.home.createOrEditLabel\">Create or edit a Ticket Order</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.ticketOrder.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.ticketOrder.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.activityId\" for=\"field_activityId\">Activity Id</label><input type=\"number\" class=\"form-control\" name=\"activityId\" id=\"field_activityId\" ng-model=\"vm.ticketOrder.activityId\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.createdDate\" for=\"field_createdDate\">Created Date</label><div class=\"input-group\"><input id=\"field_createdDate\" type=\"text\" class=\"form-control\" name=\"createdDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.ticketOrder.createdDate\" is-open=\"vm.datePickerOpenStatus.createdDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createdDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.targetDate\" for=\"field_targetDate\">Target Date</label><div class=\"input-group\"><input id=\"field_targetDate\" type=\"text\" class=\"form-control\" name=\"targetDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.ticketOrder.targetDate\" is-open=\"vm.datePickerOpenStatus.targetDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'targetDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.flagAsynch\" for=\"field_flagAsynch\">Flag Asynch</label><input type=\"number\" class=\"form-control\" name=\"flagAsynch\" id=\"field_flagAsynch\" ng-model=\"vm.ticketOrder.flagAsynch\" required><div ng-show=\"editForm.flagAsynch.$invalid\"><p class=\"help-block\" ng-show=\"editForm.flagAsynch.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.flagAsynch.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.ticketWfStat\" for=\"field_ticketWfStat\">Ticket Wf Stat</label><input type=\"number\" class=\"form-control\" name=\"ticketWfStat\" id=\"field_ticketWfStat\" ng-model=\"vm.ticketOrder.ticketWfStat\" required><div ng-show=\"editForm.ticketWfStat.$invalid\"><p class=\"help-block\" ng-show=\"editForm.ticketWfStat.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.ticketWfStat.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.ticketDesc\" for=\"field_ticketDesc\">Ticket Desc</label><input type=\"text\" class=\"form-control\" name=\"ticketDesc\" id=\"field_ticketDesc\" ng-model=\"vm.ticketOrder.ticketDesc\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.expiredDate\" for=\"field_expiredDate\">Expired Date</label><div class=\"input-group\"><input id=\"field_expiredDate\" type=\"text\" class=\"form-control\" name=\"expiredDate\" datetime-picker=\"d MMMM y\" ng-model=\"vm.ticketOrder.expiredDate\" is-open=\"vm.datePickerOpenStatus.expiredDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expiredDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.periodStart\" for=\"field_periodStart\">Period Start</label><div class=\"input-group\"><input id=\"field_periodStart\" type=\"text\" class=\"form-control\" name=\"periodStart\" datetime-picker=\"d MMMM y\" ng-model=\"vm.ticketOrder.periodStart\" is-open=\"vm.datePickerOpenStatus.periodStart\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'periodStart\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.periodEnd\" for=\"field_periodEnd\">Period End</label><div class=\"input-group\"><input id=\"field_periodEnd\" type=\"text\" class=\"form-control\" name=\"periodEnd\" datetime-picker=\"d MMMM y\" ng-model=\"vm.ticketOrder.periodEnd\" is-open=\"vm.datePickerOpenStatus.periodEnd\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'periodEnd\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketOrder.resultNote\" for=\"field_resultNote\">Result Note</label><input type=\"text\" class=\"form-control\" name=\"resultNote\" id=\"field_resultNote\" ng-model=\"vm.ticketOrder.resultNote\"></div><div class=\"form-group\"><label translate=\"sceaApp.ticketOrder.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" name=\"employee\" ng-model=\"vm.ticketOrder.employeeId\" ng-options=\"employee.id as employee.firstName for employee in vm.employees\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.ticketOrder.outlet\" for=\"field_outlet\">Outlet</label><select class=\"form-control\" id=\"field_outlet\" name=\"outlet\" ng-model=\"vm.ticketOrder.outletId\" ng-options=\"outlet.id as outlet.outletName for outlet in vm.outlets\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.ticketOrder.ticketResult\" for=\"field_ticketResult\">Ticket Result</label><select class=\"form-control\" id=\"field_ticketResult\" name=\"ticketResult\" ng-model=\"vm.ticketOrder.ticketResultId\" ng-options=\"ticketResult.id as ticketResult.resultDesc for ticketResult in vm.ticketresults\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"sceaApp.ticketOrder.calendar\" for=\"field_calendar\">Calendar</label><select class=\"form-control\" id=\"field_calendar\" name=\"calendar\" ng-model=\"vm.ticketOrder.calendarId\" ng-options=\"calendar.id as calendar.week for calendar in vm.calendars\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/ticket-order/ticket-orders.html","<div><h2 translate=\"sceaApp.ticketOrder.home.title\">Ticket Orders</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"ticket-order.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.ticketOrder.home.createLabel\">Create new Ticket Order</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.ticketOrder.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activityId\"><span translate=\"sceaApp.ticketOrder.activityId\">Activity Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdDate\"><span translate=\"sceaApp.ticketOrder.createdDate\">Created Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetDate\"><span translate=\"sceaApp.ticketOrder.targetDate\">Target Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"flagAsynch\"><span translate=\"sceaApp.ticketOrder.flagAsynch\">Flag Asynch</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ticketWfStat\"><span translate=\"sceaApp.ticketOrder.ticketWfStat\">Ticket Wf Stat</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ticketDesc\"><span translate=\"sceaApp.ticketOrder.ticketDesc\">Ticket Desc</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expiredDate\"><span translate=\"sceaApp.ticketOrder.expiredDate\">Expired Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"periodStart\"><span translate=\"sceaApp.ticketOrder.periodStart\">Period Start</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"periodEnd\"><span translate=\"sceaApp.ticketOrder.periodEnd\">Period End</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"resultNote\"><span translate=\"sceaApp.ticketOrder.resultNote\">Result Note</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employeeFirstName\"><span translate=\"sceaApp.ticketOrder.employee\">Employee</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletOutletName\"><span translate=\"sceaApp.ticketOrder.outlet\">Outlet</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"ticketResultResultDesc\"><span translate=\"sceaApp.ticketOrder.ticketResult\">Ticket Result</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"calendarWeek\"><span translate=\"sceaApp.ticketOrder.calendar\">Calendar</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"ticketOrder in vm.ticketOrders track by ticketOrder.id\"><td><a ui-sref=\"ticket-order-detail({id:ticketOrder.id})\">{{ticketOrder.id}}</a></td><td>{{ticketOrder.activityId}}</td><td>{{ticketOrder.createdDate | date:\'d MMMM y\'}}</td><td>{{ticketOrder.targetDate | date:\'d MMMM y\'}}</td><td>{{ticketOrder.flagAsynch}}</td><td>{{ticketOrder.ticketWfStat}}</td><td>{{ticketOrder.ticketDesc}}</td><td>{{ticketOrder.expiredDate | date:\'d MMMM y\'}}</td><td>{{ticketOrder.periodStart | date:\'d MMMM y\'}}</td><td>{{ticketOrder.periodEnd | date:\'d MMMM y\'}}</td><td>{{ticketOrder.resultNote}}</td><td><a ui-sref=\"employee-detail({id:ticketOrder.employeeId})\">{{ticketOrder.employeeFirstName}}</a></td><td><a ui-sref=\"outlet-detail({id:ticketOrder.outletId})\">{{ticketOrder.outletOutletName}}</a></td><td><a ui-sref=\"ticket-result-detail({id:ticketOrder.ticketResultId})\">{{ticketOrder.ticketResultResultDesc}}</a></td><td><a ui-sref=\"calendar-detail({id:ticketOrder.calendarId})\">{{ticketOrder.calendarWeek}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"ticket-order-detail({id:ticketOrder.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"ticket-order.edit({id:ticketOrder.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"ticket-order.delete({id:ticketOrder.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/ticket-result/ticket-result-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.ticketResult.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.ticketResult.delete.question\" translate-values=\"{id: \'{{vm.ticketResult.id}}\'}\">Are you sure you want to delete this Ticket Result?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/ticket-result/ticket-result-detail.html","<div><h2><span translate=\"sceaApp.ticketResult.detail.title\">Ticket Result</span> {{vm.ticketResult.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.ticketResult.resultCode\">Result Code</span></dt><dd><span>{{vm.ticketResult.resultCode}}</span></dd><dt><span translate=\"sceaApp.ticketResult.resultDesc\">Result Desc</span></dt><dd><span>{{vm.ticketResult.resultDesc}}</span></dd><dt><span translate=\"sceaApp.ticketResult.activityId\">Activity Id</span></dt><dd><span>{{vm.ticketResult.activityId}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/ticket-result/ticket-result-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTicketResultLabel\" translate=\"sceaApp.ticketResult.home.createOrEditLabel\">Create or edit a Ticket Result</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.ticketResult.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.ticketResult.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketResult.resultCode\" for=\"field_resultCode\">Result Code</label><input type=\"text\" class=\"form-control\" name=\"resultCode\" id=\"field_resultCode\" ng-model=\"vm.ticketResult.resultCode\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketResult.resultDesc\" for=\"field_resultDesc\">Result Desc</label><input type=\"text\" class=\"form-control\" name=\"resultDesc\" id=\"field_resultDesc\" ng-model=\"vm.ticketResult.resultDesc\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.ticketResult.activityId\" for=\"field_activityId\">Activity Id</label><select class=\"form-control\" name=\"activityId\" id=\"field_activityId\" ng-model=\"vm.ticketResult.activityId\" ng-options=\"option for option in [1001,1002]\">{{option}}</select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/ticket-result/ticket-results.html","<div><h2 translate=\"sceaApp.ticketResult.home.title\">Ticket Results</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"ticket-result.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.ticketResult.home.createLabel\">Create new Ticket Result</span></button></div><div class=\"col-xs-8 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.ticketResult.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"resultCode\"><span translate=\"sceaApp.ticketResult.resultCode\">Result Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"resultDesc\"><span translate=\"sceaApp.ticketResult.resultDesc\">Result Desc</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activityId\"><span translate=\"sceaApp.ticketResult.activityId\">Activity Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"ticketResult in vm.ticketResults track by ticketResult.id\"><td><a ui-sref=\"ticket-result-detail({id:ticketResult.id})\">{{ticketResult.id}}</a></td><td>{{ticketResult.resultCode}}</td><td>{{ticketResult.resultDesc}}</td><td>{{ticketResult.activityId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"ticket-result-detail({id:ticketResult.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"ticket-result.edit({id:ticketResult.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"ticket-result.delete({id:ticketResult.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/upload-retail-mapping-allocation/upload-retail-mapping-allocation.html","<div><h2 translate=\"sceaApp.uploadRetailMappingAllocation.home.title\">Upload List Order</h2><jhi-alert></jhi-alert><br><div class=\"row\"><div class=\"col-md-2 col-md-offset-1\"><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" accept=\".xlsx\" ngf-change=\"vm.setlistOrderData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button></div><div class=\"col-md-7\"><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.listOrderData.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.listOrderData.size > 0\">{{vm.listOrderData.fileName}}, {{vm.listOrderData.size/1000 | number}} KB</span> <button ng-if=\"vm.listOrderData.data > 0\" ng-click=\"vm.listOrderData.data = 0; vm.listOrderData.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"sceaApp.uploadRetailMappingAllocation.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"sceaApp.uploadRetailMappingAllocation.importFailed\">Failed</span></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.listOrderData.size || vm.listOrderData.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-export\"></span>&nbsp;<span data-translate=\"entity.action.process\">Process</span></button></div></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div></div>");
$templateCache.put("app/merchandiser-activity/call-plan-creation/call-plan-creations.html","<div><h2 translate=\"sceaApp.callPlanCreation.home.title\">Call Plan Creation</h2><jhi-alert></jhi-alert><br><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.callPlanCreation.vdo\">VDO</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.vdo\" ng-change=\"vm.getVdeSummaries(vm.vdo.id, vm.year, vm.month)\" ng-options=\"vdo as vdo.firstName for vdo in vm.vdos\"></select></div></div></div><hr class=\"custom-hr\"><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.month\" ng-change=\"vm.getVdeSummaries(vm.vdo.id, vm.year, vm.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.year\">Year</span></label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.year\" ng-change=\"vm.getVdeSummaries(vm.vdo.id, vm.year, vm.month)\"><option ng-repeat=\"year in vm.years track by $index\" value=\"{{year}}\">{{year}}</option></select></div></div></div><br><div class=\"text-center\" ng-show=\"vm.vdeSummaries.length == 0\"><b><i><span translate=\"sceaApp.callPlanCreation.noData\">No Data</span></i></b></div><div class=\"table-responsive\" ng-show=\"vm.vdeSummaries.length > 0\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"-vdeName\"><span translate=\"sceaApp.callPlanCreation.vde\">VDE</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th ng-repeat=\"week in vm.vdeSummaries[0].weeks | orderBy:\'week\':false\"><span translate=\"sceaApp.calendar.week\">Week</span> <span>{{week.week}}</span></th></tr></thead><tbody><tr ng-repeat=\"vdeSummary in vm.vdeSummaries | orderBy:vm.predicate:vm.reverse\"><td>{{vdeSummary.employeeName}}</td><td ng-repeat=\"week in vdeSummary.weeks | orderBy:\'week\':false\"><a ui-sref=\"call-plan-creation.outlet({vdoId:vm.vdo.id, vdeId:vdeSummary.employeeId, calendarId:week.calendarId})\"><span>{{week.target}}/{{week.succeed}}</span></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/merchandiser-activity/call-plan-creation/vde-outlet-add-dialog.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.callPlanCreation.outlets.add\">Add Oultet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></div></div><br><table class=\"jh-table table\" style=\"margin-bottom: 0\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th class=\"col-xs-2\"></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"outletCode\"><span data-translate=\"sceaApp.outlet.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"outletName\"><span data-translate=\"sceaApp.outlet.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-2 text-center\" jh-sort-by=\"visitCycleStoreGrade\"><span data-translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"startVisitWeek\"><span data-translate=\"sceaApp.outlet.startVisitWeek\">Start Visit Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead></table><div style=\"max-height: 300px; overflow: auto\"><div class=\"row text-center\" style=\"border-bottom: 1px solid #ddd; margin-left: 0;  margin-right: 0; padding: 5px 0\" ng-repeat=\"outlet in vm.outlets\n                	| orderBy: vm.predicate : !vm.reverse\n                	| filter : {searchField:{$: vm.searchQuery}}\"><div class=\"col-xs-2\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.addOutlet(outlet)\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outlet.detail.add\">Add</span></button></div></div><div class=\"col-xs-2\">{{outlet.outletCode ? outlet.outletCode : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.outletName ? outlet.outletName : \'-\'}}</div><div class=\"col-xs-2\">{{outlet.visitCycleStoreGrade ? outlet.visitCycleStoreGrade : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.startVisitWeek ? outlet.startVisitWeek : \'-\'}}</div></div></div><br><div><b><span translate=\"sceaApp.callPlanCreation.total\">Total</span> <span>{{vm.outlets.length}}</span></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/call-plan-creation/vde-outlet-dialog.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.callPlanCreation.outlets.title\">Outlets</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.addOutlet()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"entity.action.add\">Add</span></button></div><br><table class=\"jh-table table\" style=\"margin-bottom: 0\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th class=\"col-xs-2 text-center\" jh-sort-by=\"outletCode\"><span data-translate=\"sceaApp.callPlanCreation.outlets.code\">Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"outletName\"><span data-translate=\"sceaApp.callPlanCreation.outlets.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"failedReason\"><span data-translate=\"sceaApp.callPlanCreation.outlets.failedReason\">Failed Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-3 text-center\" jh-sort-by=\"note\"><span data-translate=\"sceaApp.callPlanCreation.outlets.note\">Note</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th class=\"col-xs-1\"></th></tr></thead></table><div style=\"max-height: 300px; overflow: auto\"><div class=\"row text-center\" style=\"border-bottom: 1px solid #ddd; margin-left: 0;  margin-right: 0; padding: 5px 0\" ng-style=\"outlet.status == \'Not Downloaded\' && {\'background-color\':\'lightgrey\'}\n          			|| outlet.status == \'Succeed\' && {\'background-color\':\'lightgreen\'}\n          			|| outlet.status == \'Failed\' && {\'background-color\':\'lightpink\'}\n          			|| outlet.status == \'In Progress\' && {\'background-color\':\'lightyellow\'}\" ng-repeat=\"outlet in vm.outlets | orderBy : vm.predicate : !vm.reverse\"><div class=\"col-xs-2\">{{outlet.outletCode ? outlet.outletCode : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.outletName ? outlet.outletName : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.failedReason ? outlet.failedReason : \'-\'}}</div><div class=\"col-xs-3\">{{outlet.note ? outlet.note : \'-\'}}</div><div class=\"col-xs-1\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-disabled=\"outlet.status != \'Not Downloaded\'\" ng-click=\"vm.deleteOutlet(outlet)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs\" translate=\"entity.action.delete\"></span></button></div></div></div></div><br><div><b><span translate=\"sceaApp.callPlanCreation.total\">Total</span> <span>{{vm.outlets.length}}</span></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/merchandiser-activity/other-job-approval/other-job-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.otherJob.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.otherJob.delete.question\" translate-values=\"{id: \'{{vm.otherJob.id}}\'}\">Are you sure you want to delete this Other Job?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/other-job-approval/other-job-detail.html","<div><h2><span translate=\"sceaApp.otherJob.detail.title\">Other Job</span> {{vm.otherJob.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.otherJob.formNo\">Form No</span></dt><dd><span>{{vm.otherJob.formNo}}</span></dd><dt><span translate=\"sceaApp.otherJob.outletName\">Outlet Name</span></dt><dd><span>{{vm.otherJob.outletName}}</span></dd><dt><span translate=\"sceaApp.otherJob.outletAddress\">Outlet Address</span></dt><dd><span>{{vm.otherJob.outletAddress}}</span></dd><dt><span translate=\"sceaApp.otherJob.remarks\">Remarks</span></dt><dd><span>{{vm.otherJob.remarks}}</span></dd><dt><span translate=\"sceaApp.otherJob.surveyStart\">Survey Start</span></dt><dd><span>{{vm.otherJob.surveyStart | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.otherJob.surveyEnd\">Survey End</span></dt><dd><span>{{vm.otherJob.surveyEnd | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.otherJob.submitDate\">Submit Date</span></dt><dd><span>{{vm.otherJob.submitDate | date:\'d MMMM y\'}}</span></dd><dt><span translate=\"sceaApp.otherJob.wfStat\">Wf Stat</span></dt><dd><span>{{vm.otherJob.wfStat}}</span></dd><dt><span translate=\"sceaApp.otherJob.activityId\">Activity Id</span></dt><dd><span>{{vm.otherJob.activityId}}</span></dd><dt><span translate=\"sceaApp.otherJob.status\">Status</span></dt><dd><span>{{vm.otherJob.status}}</span></dd><dt><span translate=\"sceaApp.otherJob.ticketOrder\">Ticket Order</span></dt><dd><a ui-sref=\"ticket-order-detail({id:vm.otherJob.ticketOrderId})\">{{vm.otherJob.ticketOrderId}}</a></dd><dt><span translate=\"sceaApp.otherJob.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.otherJob.employeeId})\">{{vm.otherJob.employeeFirstName}}</a></dd><dt><span translate=\"sceaApp.otherJob.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.otherJob.outletId})\">{{vm.otherJob.outletOutletName}}</a></dd><dt><span translate=\"sceaApp.otherJob.otherJobType\">Other Job Type</span></dt><dd><a ui-sref=\"other-job-type-detail({id:vm.otherJob.otherJobTypeId})\">{{vm.otherJob.otherJobTypeTypeName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/merchandiser-activity/other-job-approval/other-job-dialog.html","<form name=\"editForm\" role=\"form\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOtherJobLabel\" translate=\"sceaApp.otherJob.home.createOrEditLabel\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"container-fluid no-padding-right no-padding-left\"><div class=\"col-xs-2\"><div style=\"height: 400px; overflow-x: auto; border-right: 1px solid #ddd; padding-right: 10px\"><a class=\"thumbnail\" ng-class=\"{\'active\' : vm.image.id == image.id}\" ng-repeat=\"image in vm.images\" ng-click=\"vm.image = image\"><img ng-src=\"/scea-images/{{vm.image.fileName}}\"></a></div></div><div class=\"col-xs-10\" style=\"position: absolute; bottom: 0; right: 0\"><div class=\"thumbnail\" style=\"height: 295px; padding: 5px\"><img style=\"max-height: 280px\" ng-src=\"/scea-images/{{vm.image.fileName}}\"></div><dl class=\"dl-horizontal jh-entity-details\" style=\"margin-bottom: 0\"><dt style=\"margin-bottom: 5px\"><span translate=\"sceaApp.otherJob.imageName\">Image Name</span></dt><dd style=\"margin-bottom: 5px\"><span>{{vm.image.fileName}}</span></dd><dt style=\"margin-bottom: 5px\"><span translate=\"sceaApp.otherJob.desc\">Description</span></dt><dd style=\"margin-bottom: 5px\"><span>{{vm.image.fileDesc}}</span></dd><dt style=\"margin-bottom: 5px\"><span translate=\"sceaApp.otherJob.captured\">Captured Time</span></dt><dd style=\"margin-bottom: 5px; border-bottom: 0 solid #eee; */\"><span>{{vm.image.createdDate | date:\'d MMMM y\'}}</span></dd></dl></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" class=\"btn btn-danger\" ng-show=\"vm.otherJob.status == 1\" ng-click=\"vm.save(3)\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"sceaApp.otherJob.reject\">Reject</span></button> <button type=\"button\" class=\"btn btn-primary\" ng-show=\"vm.otherJob.status == 1\" ng-click=\"vm.save(2)\"><span class=\"glyphicon glyphicon-ok-circle\"></span>&nbsp;<span translate=\"sceaApp.otherJob.approve\">Approve</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/other-job-approval/other-jobs.html","<div><h2 translate=\"sceaApp.otherJob.home.title\">Other Jobs</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 col-xs-offset-4 no-padding-right\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.otherJob.home.search\' | translate }}\"><div class=\"input-group-btn width-min\"><button type=\"button\" class=\"btn btn-default dropdown-toggle\" style=\"border-radius: 0; border-left: 1px solid transparent\" data-toggle=\"dropdown\"><span translate=\"sceaApp.otherJob.{{vm.searchStatus}}\"></span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu dropdown-menu-right\" ng-model=\"vm.searchStatus\"><li><a ng-click=\"vm.searchStatus = \'needApproval\'\"><span translate=\"sceaApp.otherJob.needApproval\">Need Approval</span> </a></li><li><a ng-click=\"vm.searchStatus = \'approved\'\"><span translate=\"sceaApp.otherJob.approved\">Approved</span> </a></li><li><a ng-click=\"vm.searchStatus = \'rejected\'\"><span translate=\"sceaApp.otherJob.rejected\">Rejected</span> </a></li></ul></div><span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"calendar.week\"><span translate=\"sceaApp.otherJob.week\">Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyStart\"><span translate=\"sceaApp.otherJob.surveyStart\">Survey Start</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyEnd\"><span translate=\"sceaApp.otherJob.surveyEnd\">Survey End</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"sceaApp.otherJob.inOutletTime\">In Outlet Time</span></th><th jh-sort-by=\"employee.firstName\"><span translate=\"sceaApp.otherJob.vde\">VDE</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"employee.manager.firstName\"><span translate=\"sceaApp.otherJob.vdo\">VDO</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outlet.outletCode\"><span translate=\"sceaApp.otherJob.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outlet.outletName\"><span translate=\"sceaApp.otherJob.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outlet.area.parent.areaName\"><span translate=\"sceaApp.otherJob.branch\">Branch</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outlet.area.areaName\"><span translate=\"sceaApp.otherJob.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"remarks\"><span translate=\"sceaApp.otherJob.remarks\">Remarks</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"sceaApp.otherJob.status\">Status</span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"otherJob in vm.otherJobs track by otherJob.id\"><td>{{otherJob.week}}</td><td>{{otherJob.surveyStart | date:\'d MMMM y HH:mm:ss\'}}</td><td>{{otherJob.surveyEnd | date:\'d MMMM y HH:mm:ss\'}}</td><td>{{vm.getInOutletTime(otherJob)}}</td><td>{{otherJob.employeeFirstName}}</td><td>{{otherJob.managerName}}</td><td>{{otherJob.outletCode}}</td><td>{{otherJob.outletOutletName}}</td><td>{{otherJob.outletBranch}}</td><td>{{otherJob.outletCity}}</td><td>{{otherJob.remarks}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"other-job-approval.edit({id:otherJob.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"sceaApp.otherJob.needApproval\" ng-show=\"otherJob.status == 1\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"sceaApp.otherJob.{{otherJob.status == 2 ? \'approved\' : \'rejected\'}}\" ng-show=\"otherJob.status == 2 || otherJob.status == 3\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/merchandiser-activity/outlet-employee/loading-dialog.html","<div><div class=\"modal-body text-center\"><h4>Loading</h4></div></div>");
$templateCache.put("app/merchandiser-activity/outlet-employee/outlet-employee-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.outlet.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.outlet.delete.question\" translate-values=\"{id: \'{{vm.outlet.id}}\'}\">Are you sure you want to delete this Outlet?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/outlet-employee/outlet-employee-detail.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.outlet.detail.title\">Add Oultet to VDE Task Plan</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></div></div><br><div class=\"table-responsive\" style=\"height: 325px; padding: 0 10px 0 0\"><table class=\"jh-table table table-condensed table-striped table-center\"><thead class=\"thead-float\"><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" class=\"tr-float\"><th style=\"width: 15%\"></th><th jh-sort-by=\"-outletCode\" class=\"th-float\" style=\"width: 17%\"><span translate=\"sceaApp.outlet.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-outletName\" class=\"th-float\" style=\"width: 30%\"><span translate=\"sceaApp.outlet.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-visitCycleStoreGrade\" class=\"th-float\" style=\"width: 13%\"><span translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-startVisitWeek\" class=\"th-float\" style=\"width: 25%\"><span translate=\"sceaApp.outlet.startVisitWeek\">Start Visit Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody class=\"tbody-float\"><tr class=\"tr-float\" ng-repeat=\"outlet in vm.outletsByEmployee \n	                	| orderBy:vm.predicate:vm.reverse\n	                	| filter : {outletName: vm.searchQuery} as result\"><td class=\"td-float text-right\" style=\"width: 15%\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.addOutlet(outlet)\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.outlet.detail.add\">Add</span></button></div></td><td class=\"td-float\" style=\"width: 17%\">{{outlet.outletCode}}</td><td class=\"td-float\" style=\"width: 30%\">{{outlet.outletName}}</td><td class=\"td-float text-center\" style=\"width: 13%\">{{vdeTaskPlanning.visitCycleStoreGrade}} <span ng-if=\"vdeTaskPlanning.visitCycleStoreGrade == null\">Other</span></td><td class=\"td-float\" style=\"width: 25%\">{{outlet.startVisitWeek}}</td></tr><tr class=\"tr-float\" ng-show=\"result.length>0\"><td class=\"td-float text-right\" style=\"width: 15%\"><span translate=\"sceaApp.outlet.total\">TOTAL</span></td><td class=\"td-float\" style=\"width: 17%\"><span>{{result.length}}</span> <span translate=\"sceaApp.outlet.stores\">Stores</span></td><td class=\"td-float\" style=\"width: 30%\"></td><td class=\"td-float text-center\" style=\"width: 13%\"></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/outlet-employee/outlet-employee-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOutletLabel\" translate=\"sceaApp.outlet.home.createOrEditLabel\">Create or edit a Outlet</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletCode\" for=\"field_outletCode\">Outlet Code</label><input type=\"text\" class=\"form-control\" id=\"field_outletCode\" ng-model=\"vm.outlet.outletCode\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.outletName\" for=\"field_outletName\">Outlet Name</label><input type=\"text\" class=\"form-control\" id=\"field_outletName\" ng-model=\"vm.outlet.outletName\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.outlet.startVisitWeek\" for=\"field_startVisitWeek\">Start Visit Week</label><input type=\"number\" class=\"form-control\" name=\"startVisitWeek\" id=\"field_startVisitWeek\" ng-model=\"vm.outlet.startVisitWeek\" required max=\"99\"><div ng-show=\"editForm.startVisitWeek.$invalid\"><p class=\"help-block\" ng-show=\"editForm.startVisitWeek.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.startVisitWeek.$error.max\" translate=\"entity.validation.max\" translate-value-max=\"99\">This field cannot be more than 99.</p><p class=\"help-block\" ng-show=\"editForm.startVisitWeek.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.employee\" for=\"field_employee\">Employee</label><select class=\"form-control\" id=\"field_employee\" ng-model=\"vm.employee\" ng-change=\"vm.updateEmployee(vm.employee)\" ng-options=\"employeeChild.firstName for employeeChild in vm.employees track by employeeChild.id\"></select></div><div class=\"form-group\"><label translate=\"sceaApp.outlet.visitCycle\" for=\"field_visitCycle\">Visit Cycle</label><input class=\"form-control\" id=\"field_visitCycle\" ng-model=\"vm.outlet.visitCycleStoreGrade\" readonly=\"readonly\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/outlet-employee/outlet-employees.html","<div><div class=\"container-fluid\"><div><div class=\"input-group\" style=\"width: 32%\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{ \'sceaApp.outlet.home.search\' | translate }}\"><div class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></div></div></div></div><br><div class=\"table-responsive\"><table class=\"table table-condensed table-striped table-center\"><thead><tr><th><span translate=\"sceaApp.outlet.outletCode\">Outlet Code</span></th><th style=\"width: 30%\"><span translate=\"sceaApp.outlet.outletName\">Outlet Name</span></th><th><span translate=\"sceaApp.outlet.visitCycle\">Visit Cycle</span></th><th><span translate=\"sceaApp.outlet.startVisitWeek\">Start Visit Week</span></th><th><span translate=\"sceaApp.outlet.employee\">Employee</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"outlet in vm.outletsByEmployee | \n	                filter : {outletName: vm.searchQuery} as result\"><td>{{outlet.outletCode}}</td><td>{{outlet.outletName}}</td><td>{{outlet.visitCycleStoreGrade}}</td><td>{{outlet.startVisitWeek}}</td><td>{{outlet.employeeName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"call-plan-creation.edit({id:outlet.id, employeeId: outlet.employeeId})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button></div></td></tr></tbody><tfoot ng-show=\"result.length > 0\"><tr><td><span translate=\"sceaApp.outlet.total\">TOTAL</span></td><td><span>{{result.length}}</span> <span translate=\"sceaApp.outlet.stores\">Stores</span></td><td></td><td></td><td></td></tr></tfoot></table></div></div>");
$templateCache.put("app/merchandiser-activity/project-list/columns.html","<div><div class=\"text-center\"><i><span translate=\"sceaApp.projectList.column.configure\">Configure the columns to show in the reporting table.</span></i></div><div class=\"dndList\"><div class=\"panel panel-default\"><div class=\"panel-body\"><ul dnd-list=\"vm.models.lists\"><li ng-repeat=\"item in vm.models.lists\" dnd-draggable=\"item\" dnd-moved=\"vm.moveColumn($index)\" dnd-effect-allowed=\"move\" dnd-selected=\"models.selected = item\" ng-class=\"{\'selected\': models.selected === item}\"><div class=\"row\"><div class=\"col-md-1 form-control-static text-center\"><span ng-class=\"{\n  									\'glyphicon glyphicon-book\': item.columnType == \'scea_project\',\n  									\'glyphicon glyphicon-calendar\': item.columnType == \'date\',\n  									\'glyphicon glyphicon-check\': item.columnType == \'enum\',\n  									\'glyphicon glyphicon-edit\': item.columnType == \'string\',\n  									\'glyphicon glyphicon-file\': item.columnType == \'scea_file\',\n  									\'glyphicon glyphicon-ok-circle\': item.columnType == \'boolean\',\n  									\'glyphicon glyphicon-shopping-cart\': item.columnType == \'scea_outlet\',\n  									\'glyphicon glyphicon-tags\': item.columnType == \'scea_business_unit\',\n  									\'glyphicon glyphicon-usd\': item.columnType == \'long\'\n  								}\"></span> <span class=\"form-control-static\" ng-if=\"item.columnType == \'scea_formula\'\"><b><i>fx</i></b></span></div><div class=\"col-md-5 form-control-static\"><span><b>{{item.columnName}}</b></span></div><div class=\"col-md-5\"><form name=\"myForm\" ng-submit=\"vm.updateAlias($index)\"><div class=\"input-group\" ng-init=\"vm.isDisabledAlias[$index] = true\"><input type=\"text\" class=\"form-control input-sm\" ng-disabled=\"vm.isDisabledAlias[$index]\" ng-model=\"item.columnAlias\" ng-model-options=\"{updateOn: \'submit\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"vm.isDisabledAlias[$index]\" ng-click=\"vm.isDisabledAlias[$index] = !vm.isDisabledAlias[$index]\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"!vm.isDisabledAlias[$index]\" ng-click=\"item.columnAlias = \'\'\"><span class=\"glyphicon glyphicon-erase\"></span></button> <button role=\"confirm\" class=\"btn btn-default btn-sm\" ng-if=\"!vm.isDisabledAlias[$index]\"><span class=\"glyphicon glyphicon-ok\"></span></button></span></div></form></div><div class=\"col-md-1 text-center\"><span class=\"form-control-static glyphicon glyphicon-remove-circle\" ng-click=\"vm.removeColumn($index)\"></span></div></div></li></ul></div></div></div><hr class=\"custom-hr\"><div class=\"btn-group\" uib-dropdown is-open=\"isOpen\" style=\"width: 100%\"><div class=\"typeahead has-feedback\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.inputVariable\" uib-dropdown-toggle ng-click=\"isOpen = true\" typeahead-editable=\"false\" typeahead-show-hint=\"true\" typeahead-min-length=\"3\" typeahead-show-hint=\"true\" uib-typeahead=\"variable.columnAlias for variable in vm.removedVariables | filter:$viewValue | limitTo:8\" placeholder=\"{{ \'sceaApp.projectList.column.addColumn\' | translate }}\"> <span class=\"glyphicon glyphicon-search form-control-feedback\"></span></div><ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"variable in vm.removedVariables\"><a ng-click=\"vm.addInputVariable(variable)\"><span ng-class=\"{\n 						\'glyphicon glyphicon-calendar\': variable.columnType == \'date\',\n 						\'glyphicon glyphicon-edit\': variable.columnType == \'string\',\n 						\'glyphicon glyphicon-check\': variable.columnType == \'enum\',\n 						\'glyphicon glyphicon-ok-circle\': variable.columnType == \'boolean\',\n 						\'glyphicon glyphicon-usd\': variable.columnType == \'long\',\n  						\'glyphicon glyphicon-file\': variable.columnType == \'scea_file\',\n  						\'glyphicon glyphicon-shopping-cart\': variable.columnType == \'scea_outlet\',\n  						\'glyphicon glyphicon-tags\': variable.columnType == \'scea_business_unit\',\n  						\'glyphicon glyphicon-book\': variable.columnType == \'scea_project\'\n					}\"></span> <span class=\"form-control-static\" ng-if=\"variable.columnType == \'scea_formula\'\"><b><i>fx</i></b></span> &nbsp; <span ng-if=\"variable.columnAlias != null\">{{variable.columnAlias}}</span> <span ng-if=\"variable.columnAlias == null\">{{variable.columnName}}</span></a></li></ul></div></div>");
$templateCache.put("app/merchandiser-activity/project-list/diagram-dialog.html","<div class=\"modal-body\"><img ng-src=\"data:image/png;base64,{{vm.diagram}}\" width=\"100%\" style=\"margin-left: -15px\"></div>");
$templateCache.put("app/merchandiser-activity/project-list/export-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.projectList.home.exportExcel\">Export as Excel</h4></div><div class=\"modal-body\"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"form-horizontal\"><div class=\"form-group\" style=\"margin-bottom: 5px\"><label class=\"col-md-4 control-label\">Project</label><div class=\"col-md-6\"><select class=\"form-control\" ng-model=\"vm.project\" required><option value=\"allProject\">All Projects</option><option ng-repeat=\"project in vm.projects\" value=\"{{project.id}}\">{{project.projectName}}</option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-4 col-md-6\"><label class=\"radio-inline\"><input type=\"radio\" name=\"optionsRadios\" value=\"false\" ng-model=\"vm.isHistoric\"> Running</label><label class=\"radio-inline\"><input type=\"radio\" name=\"optionsRadios\" value=\"true\" ng-model=\"vm.isHistoric\"> Historic</label></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">From</label><div class=\"col-md-6\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup is-open=\"isOpenFrom\" ng-model=\"vm.date.from\" close-text=\"Close\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenFrom = !isOpenFrom\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">To</label><div class=\"col-md-6\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup is-open=\"isOpenTo\" ng-model=\"vm.date.to\" close-text=\"Close\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenTo = !isOpenTo\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-new-window\"></span>&nbsp;<span translate=\"entity.action.generate\">Generate</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/project-list/project-list-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.projectList.home.createOrEditLabel\">New Project</h4></div><div class=\"modal-body\"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputProject\" class=\"col-md-4 control-label\">Project</label><div class=\"col-md-4\"><select class=\"form-control\" id=\"inputProject\" name=\"project\" ng-model=\"vm.project\" ng-change=\"vm.generateForm(vm.project)\" ng-options=\"project.projectName for project in vm.projects track by project.id\" required></select></div></div></div><hr class=\"custom-hr\" ng-if=\"vm.taskDetailed.formProperties.length > 0\"><dynamic-form></dynamic-form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.project.processDefinitionId == null\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-new-window\"></span>&nbsp;<span translate=\"sceaApp.projectList.home.startNewProject\">Start New Project</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/project-list/project-lists.html","<div><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-2\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"vm.isHistoric\" uib-btn-radio=\"false\" ng-click=\"vm.loadRunning()\">Running</label><label class=\"btn btn-default\" ng-model=\"vm.isHistoric\" uib-btn-radio=\"true\" ng-click=\"vm.loadHistoric()\">Historic</label></div></div><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.exportExcel()\" ng-disabled=\"(!vm.isHistoric && (vm.instancesList == 0 || vm.instancesList.data.length == 0))\n					|| (vm.isHistoric && (vm.historicInstancesList == 0 || vm.historicInstancesList.data.length == 0))\"><span class=\"glyphicon glyphicon-export\"></span> <span translate=\"sceaApp.projectList.exportAsExcel\">Export as Excel</span></button></div></div></div><hr class=\"custom-hr\"><div ng-if=\"!vm.isHistoric\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped table-center\"><thead><tr><th></th><th ng-repeat=\"variable in vm.variables\"><span ng-if=\"variable.columnAlias != null\">{{variable.columnAlias}}</span> <span ng-if=\"variable.columnAlias == null\">{{variable.columnName}}</span></th></tr></thead><tbody><tr ng-repeat=\"data in vm.instancesList.data\"><td ng-if=\"vm.instancesList.data.length > 0\"><span class=\"glyphicon glyphicon-folder-open\" ng-click=\"vm.openDiagram(data)\"></span></td><td ng-repeat=\"title in vm.variables\"><span ng-repeat=\"variable in data.variables\"><span ng-if=\"title.columnId == variable.name && variable.type != \'date\' && variable.type != \'scea_file\' && \n									variable.type != \'long\' && variable.type != \'boolean\'\">{{variable.value}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'date\'\">{{variable.value | date:d MMMM y}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'long\'\">{{variable.value | number:0}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'scea_file\'\"><a ng-click=\"vm.downloadFile(variable.value)\">{{variable.value.fileName}}</a> </span><span ng-if=\"title.columnId == variable.name && variable.type == \'boolean\'\"><span ng-class=\"{ \n										\'glyphicon glyphicon-unchecked\': !variable.value, \n										\'glyphicon glyphicon-check\': variable.value }\"></span></span></span></td></tr></tbody></table></div><br><div class=\"text-center\" ng-if=\"vm.instancesList.data.length > 0\"><jhi-item-count page=\"vm.pageRunning\" total=\"vm.queryCountRunning\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItemsRunning\" items-per-page=\"vm.sizeRunning\" ng-model=\"vm.pageRunning\" ng-change=\"vm.loadRunningInstances()\"></uib-pagination></div></div><div ng-if=\"vm.isHistoric\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped table-center\"><thead><tr><th></th><th ng-repeat=\"variable in vm.variables\"><span ng-if=\"variable.columnAlias != null\">{{variable.columnAlias}}</span> <span ng-if=\"variable.columnAlias == null\">{{variable.columnName}}</span></th></tr></thead><tbody><tr ng-repeat=\"data in vm.historicInstancesList.data\"><td ng-if=\"vm.historicInstancesList.data.length > 0\"><span class=\"glyphicon glyphicon-folder-close\"></span></td><td ng-repeat=\"title in vm.variables\"><span ng-repeat=\"variable in data.variables\"><span ng-if=\"title.columnId == variable.name && variable.type != \'date\' && variable.type != \'scea_file\' && \n									variable.type != \'long\' && variable.type != \'boolean\'\">{{variable.value}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'date\'\">{{variable.value | date:d MMMM y}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'long\'\">{{variable.value | number:0}}</span> <span ng-if=\"title.columnId == variable.name && variable.type == \'scea_file\'\"><a ng-click=\"vm.downloadFile(variable.value)\">{{variable.value.fileName}}</a> </span><span ng-if=\"title.columnId == variable.name && variable.type == \'boolean\'\"><span ng-class=\"{ \n										\'glyphicon glyphicon-unchecked\': !variable.value, \n										\'glyphicon glyphicon-check\': variable.value }\"></span></span></span></td></tr></tbody></table></div><br><div class=\"text-center\" ng-if=\"vm.historicInstancesList.data.length > 0\"><jhi-item-count page=\"vm.pageHistoric\" total=\"vm.queryCountHistoric\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItemsHistoric\" items-per-page=\"vm.sizeHistoric\" ng-model=\"vm.pageHistoric\" ng-change=\"vm.loadHistoricInstances()\"></uib-pagination></div></div></div>");
$templateCache.put("app/merchandiser-activity/project-list/projects.html","<div><div class=\"title\"><span translate=\"sceaApp.projectList.home.title\">Project Lists</span></div><!-- <jhi-alert></jhi-alert> --><div class=\"row\"><div class=\"col-md-12\"><label class=\"col-md-4\"><h4 style=\"margin-bottom: 4px\" translate=\"sceaApp.projectList.home.projectOf\">Project Lists Of</h4></label><div class=\"pull-right\"><button class=\"btn btn-default\" has-authority=\"VDO\" style=\"width: 170px\" ui-sref=\"project-list.new\"><span class=\"glyphicon glyphicon-new-window\"></span> <span translate=\"sceaApp.projectList.home.createLabel\">Start new Project</span></button></div></div><div class=\"col-md-12\"><div class=\"col-md-1 col-md-3\"><select class=\"form-control\" ng-model=\"vm.project\" ng-change=\"vm.updateProject(vm.project)\" ng-options=\"project.projectName for project in vm.projects track by project.id\"></select></div><div class=\"pull-right\"><button class=\"btn btn-default\" ng-show=\"!isCollapsed\" has-authority=\"ROLE_ADMIN\" ng-click=\"isCollapsed = !isCollapsed\" ng-disabled=\"variables.length == 0\" style=\"width: 170px\"><span class=\"glyphicon glyphicon-cog\"></span> <span translate=\"sceaApp.projectList.home.configureColumns\">Configure Columns</span></button> <button class=\"btn btn-default\" ng-show=\"isCollapsed\" ng-click=\"isCollapsed = !isCollapsed\" style=\"width: 170px\"><span class=\"glyphicon glyphicon-arrow-left\"></span> <span translate=\"sceaApp.projectList.home.backToTable\">Back to The Table</span></button></div></div></div><hr class=\"custom-hr\"><div uib-collapse=\"isCollapsed\"><div ui-view=\"project-list\"></div></div><div uib-collapse=\"!isCollapsed\"><div ui-view=\"columns\"></div></div></div>");
$templateCache.put("app/merchandiser-activity/task/alltasks.html","<div class=\"row\"><br><div class=\"col-md-8\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><tbody><tr ng-repeat=\"task in vm.tasks.data\"><td class=\"text-center\" style=\"width:5%; border: 1px solid grey\"><span ng-class=\"{ \n								\'glyphicon glyphicon-unchecked\': vm.role == vm.splitCandidate(task.category) && !vm.isHistoric, \n								\'glyphicon glyphicon-check\': vm.isHistoric,\n								\'glyphicon glyphicon-lock\': vm.role != vm.splitCandidate(task.category) && !vm.isHistoric }\"></span></td><td class=\"text-center\" style=\"width:15%; border: 1px solid grey\">{{ vm.splitCandidate(task.category) }}</td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ng-if=\"vm.role == vm.splitCandidate(task.category) && !vm.isHistoric\" ui-sref=\"task-detail({id: task.id, status: \'edit\'})\"><span><b>{{ vm.splitCategory(task.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(task.variables, \'project\' )}} - {{ vm.getVariableValue(task.variables, \'business_unit\') }} - {{ vm.getVariableValue(task.variables, \'store\') }}</span></td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ng-if=\"vm.role != vm.splitCandidate(task.category) && !vm.isHistoric\" ui-sref=\"task-detail({id: task.id, status: \'detail\'})\"><span><b>{{ vm.splitCategory(task.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(task.variables, \'project\' )}} - {{ vm.getVariableValue(task.variables, \'business_unit\') }} - {{ vm.getVariableValue(task.variables, \'store\') }}</span></td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ng-if=\"vm.isHistoric\" ui-sref=\"task-detail({id: task.id, status: \'historic\'})\"><span><b>{{ vm.splitCategory(task.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(task.variables, \'project\' )}} - {{ vm.getVariableValue(task.variables, \'business_unit\') }} - {{ vm.getVariableValue(task.variables, \'store\') }}</span></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.size\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div><div class=\"col-md-4\"><div><uib-accordion close-others=\"true\"><uib-accordion-group panel-class=\"panel-default\" is-open=\"vm.isInvolvement\"><uib-accordion-heading>Involvement Filter <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isInvolvement, \n							\'glyphicon-chevron-right\': !isInvolvement}\"></i></uib-accordion-heading><div class=\"checkbox\"><label><input type=\"checkbox\" value=\"Boolean(\'true\');\" ng-model=\"vm.filter.assignedToMe\" ng-click=\"vm.updateFilter()\"> Assigned to me</label></div><div class=\"checkbox\"><label><input type=\"checkbox\" value=\"Boolean(\'true\');\" ng-model=\"vm.filter.assignedToOthers\" ng-click=\"vm.updateFilter()\"> Assigned to others</label></div></uib-accordion-group><uib-accordion-group panel-class=\"panel-default\" is-open=\"vm.isAssignment\"><uib-accordion-heading>Assignment <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isAssignment, \n							\'glyphicon-chevron-right\': !isAssignment}\"></i></uib-accordion-heading><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Tasks assigned to ...\" ng-model=\"vm.filter.assignee\" typeahead-editable=\"false\" typeahead-show-hint=\"true\" typeahead-select-on-exact=\"true\" typeahead-min-length=\"1\" uib-typeahead=\"role.name for role in vm.roles | filter:$viewValue | limitTo:8\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.updateFilter()\">Apply</button></span></div></uib-accordion-group><uib-accordion-group panel-class=\"panel-default\" is-open=\"vm.isMoreFilter\"><uib-accordion-heading>More Filter <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': isMoreFilter, \n							\'glyphicon-chevron-right\': !isMoreFilter}\"></i></uib-accordion-heading><div class=\"checkbox\"><label><input type=\"checkbox\" value=\"Boolean(\'true\');\" ng-model=\"vm.filter.completed\" ng-click=\"vm.updateFilter()\"> Completed</label></div></uib-accordion-group></uib-accordion></div></div></div>");
$templateCache.put("app/merchandiser-activity/task/inbox.html","<div ng-if=\"vm.inboxTasks.size == 0 || vm.inboxTasks.length == 0\"><br><h4 class=\"text-center\"><i>No work to do for you </i></h4></div><div ng-if=\"vm.inboxTasks.size > 0\"><br><h4>Assigned to me</h4><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><tbody><tr ng-repeat=\"inboxTask in vm.inboxTasks.data\"><td class=\"text-center\" style=\"width:5%; border: 1px solid grey\"><span class=\"glyphicon glyphicon-unchecked\"></span></td><td class=\"text-center\" style=\"width:15%; border: 1px solid grey\">{{ vm.splitCandidate(inboxTask.category) }}</td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ui-sref=\"task-detail({id: inboxTask.id, status: \'edit\'})\"><span><b>{{ vm.splitCategory(inboxTask.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(inboxTask.variables, \'project\' )}} - {{ vm.getVariableValue(inboxTask.variables, \'business_unit\') }} - {{ vm.getVariableValue(inboxTask.variables, \'store\') }}</span></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.size\" ng-model=\"vm.page\" ng-change=\"getRuntimeTasks(vm.role)\"></uib-pagination></div></div>");
$templateCache.put("app/merchandiser-activity/task/task-detail.html","<div><div class=\"row\"><div class=\"col-md-12\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.isHide = !vm.isHide\" ng-show=\"!vm.isHide\"><span class=\"glyphicon glyphicon-th-list\"></span> &nbsp; <span>Show all tasks in this project</span></button></div><div class=\"pull-right\"><div class=\"btn-group\" uib-dropdown is-open=\"isOpen\"><label type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle ng-mouseenter=\"isOpen = true\"><span class=\"glyphicon glyphicon-cog\"></span></label><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\"><a ng-click=\"vm.init()\">Refresh Project</a></li><li role=\"menuitem\"><a ng-click=\"vm.closeProject()\" ng-if=\"vm.isHistoric == false\">Close This Project</a></li></ul></div></div></div></div><hr class=\"custom-hr\"><div class=\"row\"><div class=\"col-md-6\"><jhi-alert-error></jhi-alert-error><div ng-show=\"!vm.isHide\"><h3 style=\"margin-top: 0px\">Form</h3><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><dynamic-form></dynamic-form><div class=\"text-center\" ng-if=\"vm.taskDetailed.formProperties != null && vm.statusForm == \'edit\' && vm.isApprove\"><button type=\"button\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-default\" ng-click=\"vm.save(\'reject\')\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span>Reject</span></button> <button type=\"button\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save(\'approve\')\"><span class=\"glyphicon glyphicon-ok-circle\"></span>&nbsp;<span>Approve</span></button></div><div class=\"text-center\" ng-if=\"vm.taskDetailed.formProperties != null && vm.statusForm == \'edit\' && !vm.isApprove\"><button type=\"button\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save(\' \')\"><span class=\"glyphicon glyphicon-new-window\"></span>&nbsp;<span>Submit</span></button></div></form></div><div ng-show=\"vm.isHide\"><h3 style=\"margin-top: 0px\">Tasks</h3><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><tbody><tr ng-repeat=\"task in vm.tasks.data\"><td class=\"text-center\" style=\"width:5%; border: 1px solid grey\"><span ng-class=\"{ \n										\'glyphicon glyphicon-unchecked\': task.deleteReason != \'completed\', \n										\'glyphicon glyphicon-check\': task.deleteReason == \'completed\' }\"></span></td><td class=\"text-center\" style=\"width:15%; border: 1px solid grey\">{{ vm.splitCandidate(task.category) }}</td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ng-if=\"task.deleteReason != \'completed\'\" ui-sref=\"task-detail({id: task.id, status: \'edit\'})\" ng-click=\"vm.isHide = false\"><span><b>{{ vm.splitCategory(task.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(task.variables, \'project\' )}} - {{ vm.getVariableValue(task.variables, \'business_unit\') }} - {{ vm.getVariableValue(task.variables, \'store\') }}</span></td><td style=\"width:80%; border: 1px solid grey; cursor: pointer\" ng-if=\"task.deleteReason == \'completed\'\" ui-sref=\"task-detail({id: task.id, status: \'historic\'})\" ng-click=\"vm.isHide = false\"><span><b>{{ vm.splitCategory(task.category) }}</b></span><br><span style=\"font-size: 12px\">{{ vm.getVariableValue(task.variables, \'project\' )}} - {{ vm.getVariableValue(task.variables, \'business_unit\') }} - {{ vm.getVariableValue(task.variables, \'store\') }}</span></td></tr></tbody></table></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\" ng-repeat=\"historicTask in vm.historicTasks.data\"><div class=\"panel-heading\"><div class=\"container-fluid\" style=\"padding: 0px\"><span class=\"pull-left\">{{ vm.splitCandidate(historicTask.category) }} {{historicTask.deleteReason}} {{ vm.splitCategory(historicTask.category) }} </span><span class=\"pull-right\">{{ historicTask.endTime | date:\'d MMMM y\' }}</span></div></div><div class=\"panel-body\" style=\"padding-left: 10px; padding-right: 10px\"><div class=\"form-horizontal\"><div class=\"form-group\" ng-repeat=\"variable in historicTask.formProperties\" ng-if=\"variable.name != \'Approval\'\" style=\"margin-bottom: 5px\"><label class=\"col-md-4 control-label\" ng-if=\"variable.name != \'Approval\'\"><span ng-if=\"variable.alias != null\">{{variable.alias}}</span> <span ng-if=\"variable.alias == null\">{{variable.name}}</span></label><div class=\"col-md-8\" ng-if=\"variable.name != \'Approval\'\"><input ng-disabled=\"true\" class=\"form-control input-sm\" ng-if=\"variable.type != \'scea_file\'\n      								&& variable.type != \'long\' && variable.type != \'double\'\n									&& variable.type != \'boolean\'\" type=\"text\" ng-model=\"variable.value\"> <input ng-if=\"variable.type==\'boolean\'\" ng-disabled=\"true\" type=\"checkbox\" class=\"form-control\" ng-model=\"variable.value\" style=\"width: 16px; height: 25px\"><p class=\"input-group\" ng-if=\"variable.type == \'scea_file\'\"><input ng-disabled=\"true\" type=\"text\" class=\"form-control input-sm\" ng-model=\"variable.value.fileName\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.download(variable.value)\">Download</button></span></p><input ng-if=\"variable.type==\'long\' || variable.type==\'double\'\" ng-disabled=\"true\" type=\"text\" class=\"form-control input-sm\" ng-model=\"variable.value\" format=\"number\"></div></div><div class=\"form-group\" style=\"margin-bottom: 5px\" ng-if=\"historicTask.approved != null\"><div class=\"col-md-12\"><input ng-model=\"historicTask.approved\" type=\"text\" class=\"form-control text-center input-sm\" disabled=\"disabled\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/merchandiser-activity/task/tasks.html","<div><div class=\"title\"><span translate=\"sceaApp.task.home.title\">Tasks</span></div><uib-tabset><uib-tab heading=\"Inbox\"><div ui-view=\"inbox\"></div></uib-tab><uib-tab heading=\"All Tasks\"><div ui-view=\"allTasks\"></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vDETaskPlanning.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.vdeTaskPlanning.delete.question\" translate-values=\"{vdeName: \'{{vm.vDETaskPlanning.employeeId}}\'}\">Are you sure you want to delete this VDE Task Planning?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-detail.html","<div><h2><span translate=\"sceaApp.vDETaskPlanning.detail.title\">VDE Task Planning</span> {{vm.vDETaskPlanning.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.vDETaskPlanning.recommendation\">Recommendation</span></dt><dd><span>{{vm.vDETaskPlanning.recommendation}}</span></dd><dt><span translate=\"sceaApp.vDETaskPlanning.deleted\">Deleted</span></dt><dd><span>{{vm.vDETaskPlanning.deleted}}</span></dd><dt><span translate=\"sceaApp.vDETaskPlanning.calendar\">Calendar</span></dt><dd><a ui-sref=\"calendar-detail({id:vm.vDETaskPlanning.calendarId})\">{{vm.vDETaskPlanning.calendarWeek}}</a></dd><dt><span translate=\"sceaApp.vDETaskPlanning.employee\">Employee</span></dt><dd><a ui-sref=\"employee-detail({id:vm.vDETaskPlanning.employeeId})\">{{vm.vDETaskPlanning.employeeFirstName}}</a></dd><dt><span translate=\"sceaApp.vDETaskPlanning.outlet\">Outlet</span></dt><dd><a ui-sref=\"outlet-detail({id:vm.vDETaskPlanning.outletId})\">{{vm.vDETaskPlanning.outletOutletName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-dialog.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.ok()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.vdeTaskPlanning.detail.title\">VDE Task Plan</span> <span>{{vm.vde.firstName}}</span> <span translate=\"sceaApp.vdeTaskPlanning.week\">Week</span> <span>{{vm.week}}</span></h4></div><div class=\"modal-body\"><div><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.week < vm.currentCalendar.week\" ng-click=\"vm.addVdeTaskPlanning()\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.vdeTaskPlanning.detail.add\">Add</span></button></div><br><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\" style=\"height: 325px; padding: 0 10px 0 0\"><table class=\"jh-table table table-condensed table-striped\"><thead class=\"thead-float\"><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" class=\"tr-float\"><th jh-sort-by=\"-outletCode\" class=\"th-float text-center\" style=\"width: 30%\"><span translate=\"sceaApp.vdeTaskPlanning.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-outletName\" class=\"th-float text-center\" style=\"width: 30%\"><span translate=\"sceaApp.vdeTaskPlanning.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-storeGrade\" class=\"th-float text-center\" style=\"width: 20%\"><span translate=\"sceaApp.vdeTaskPlanning.storeGrade\">Grade</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th style=\"width: 20%\"></th></tr></thead><tbody class=\"tbody-float\"><tr class=\"tr-float\" ng-class=\"{\'danger\' : vm.isLast == 1 && vdeTaskPlanning.visited == false}\" ng-repeat=\"vdeTaskPlanning in vm.vdeTaskPlanningsPerWeek | orderBy:vm.predicate:vm.reverse\"><td class=\"td-float\" style=\"width: 30%\">{{vdeTaskPlanning.outletCode}}</td><td class=\"td-float\" style=\"width: 30%\">{{vdeTaskPlanning.outletName}}</td><td class=\"td-float text-center\" style=\"width: 20%\">{{vdeTaskPlanning.storeGrade}} <span ng-if=\"vdeTaskPlanning.storeGrade== null\">Other</span></td><td class=\"td-float text-right\" style=\"width: 20%\"><div class=\"btn-group flex-btn-group-container\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.week < vm.currentCalendar.week\" ng-click=\"vm.deleteVdeTaskPlanning(vdeTaskPlanning)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div><b><td><span translate=\"sceaApp.vdeTaskPlanning.total\">TOTAL</span></td><td><span>{{vm.vdeTaskPlanningsPerWeek.length}}</span> <span translate=\"sceaApp.vdeTaskPlanning.stores\">Stores</span></td></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.ok()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-dialog2.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.ok()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.vdeTaskPlanning.detail.title\">VDE Task Plan</span> <span>{{vm.vde.firstName}}</span> <span translate=\"sceaApp.vdeTaskPlanning.recommendation\">Recommendation</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\" style=\"height: 325px; padding: 0 10px 0 0\"><table class=\"jh-table table table-condensed table-striped\"><thead class=\"thead-float\"><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" class=\"tr-float\"><th jh-sort-by=\"-outletCode\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-outletName\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-storeGrade\" class=\"th-float text-center\" style=\"width: 30%\"><span translate=\"sceaApp.vdeTaskPlanning.storeGrade\">Grade</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody class=\"tbody-float\"><tr class=\"tr-float\" ng-class=\"{\'danger\' : vm.isLast == 1 && vdeTaskPlanning.visited == false}\" ng-repeat=\"vdeTaskPlanning in vm.vdeTaskPlanningsPerWeek | orderBy:vm.predicate:vm.reverse\"><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletCode}}</td><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletName}}</td><td class=\"td-float text-center\" style=\"width: 30%\">{{vdeTaskPlanning.storeGrade}} <span ng-if=\"vdeTaskPlanning.storeGrade== null\">Other</span></td></tr></tbody></table></div><div><b><td><span translate=\"sceaApp.vdeTaskPlanning.total\">TOTAL</span></td><td><span>{{vm.vdeTaskPlanningsPerWeek.length}}</span> <span translate=\"sceaApp.vdeTaskPlanning.stores\">Stores</span></td></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.ok()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-dialog3.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.ok()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.vdeTaskPlanning.detail.title\">VDE Task Plan</span> <span>{{vm.vde.firstName}}</span> <span translate=\"sceaApp.vdeTaskPlanning.targetCall\">targetCall</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\" style=\"height: 325px; padding: 0 10px 0 0\"><table class=\"jh-table table table-condensed table-striped\"><thead class=\"thead-float\"><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" class=\"tr-float\"><th jh-sort-by=\"-outletCode\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-outletName\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-storeGrade\" class=\"th-float text-center\" style=\"width: 30%\"><span translate=\"sceaApp.vdeTaskPlanning.storeGrade\">Grade</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody class=\"tbody-float\"><tr class=\"tr-float\" ng-class=\"{\'danger\' : vm.isLast == 1 && vdeTaskPlanning.visited == false}\" ng-repeat=\"vdeTaskPlanning in vm.vdeTaskPlanningsPerWeek | orderBy:vm.predicate:vm.reverse\"><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletCode}}</td><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletName}}</td><td class=\"td-float text-center\" style=\"width: 30%\">{{vdeTaskPlanning.storeGrade}} <span ng-if=\"vdeTaskPlanning.storeGrade== null\">Other</span></td></tr></tbody></table></div><div><b><td><span translate=\"sceaApp.vdeTaskPlanning.total\">TOTAL</span></td><td><span>{{vm.vdeTaskPlanningsPerWeek.length}}</span> <span translate=\"sceaApp.vdeTaskPlanning.stores\">Stores</span></td></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.ok()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-planning-dialog4.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.ok()\">&times;</button><h4 class=\"modal-title\"><span translate=\"sceaApp.vdeTaskPlanning.detail.title\">VDE Task Plan</span> <span>{{vm.vde.firstName}}</span> <span translate=\"sceaApp.vdeTaskPlanning.actualCall\">targetCall</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\" style=\"height: 325px; padding: 0 10px 0 0\"><table class=\"jh-table table table-condensed table-striped\"><thead class=\"thead-float\"><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" class=\"tr-float\"><th jh-sort-by=\"-outletCode\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-outletName\" class=\"th-float text-center\" style=\"width: 35%\"><span translate=\"sceaApp.vdeTaskPlanning.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-storeGrade\" class=\"th-float text-center\" style=\"width: 30%\"><span translate=\"sceaApp.vdeTaskPlanning.storeGrade\">Grade</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody class=\"tbody-float\"><tr class=\"tr-float\" ng-class=\"{\'danger\' : vm.isLast == 1 && vdeTaskPlanning.visited == false}\" ng-repeat=\"vdeTaskPlanning in vm.vdeTaskPlanningsPerWeek | orderBy:vm.predicate:vm.reverse\"><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletCode}}</td><td class=\"td-float\" style=\"width: 35%\">{{vdeTaskPlanning.outletName}}</td><td class=\"td-float text-center\" style=\"width: 30%\">{{vdeTaskPlanning.storeGrade}} <span ng-if=\"vdeTaskPlanning.storeGrade== null\">Other</span></td></tr></tbody></table></div><div><b><td><span translate=\"sceaApp.vdeTaskPlanning.total\">TOTAL</span></td><td><span>{{vm.vdeTaskPlanningsPerWeek.length}}</span> <span translate=\"sceaApp.vdeTaskPlanning.stores\">Stores</span></td></b></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.ok()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/merchandiser-activity/v-de-task-planning/v-de-task-plannings.html","<div><div class=\"container-fluid\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\"><span translate=\"sceaApp.calendar.month\">month</span></label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.month\" ng-change=\"vm.onChangeMonth(vm.month)\"><option ng-repeat=\"month in vm.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\"><th jh-sort-by=\"-vdeName\"><span translate=\"sceaApp.vdeTaskPlanning.vde\">VDE</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"{{vm.vdeTaskPlannings[0].week[$index].value}}\" ng-repeat=\"week in vm.vdeTaskPlannings[0].weeks track by $index\"><span translate=\"sceaApp.calendar.week\">Week</span> <span>{{week.week}}</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!-- 					<th jh-sort-by=\"-{vm.vdeTaskPlannings[0].weeks[0]}\"> --><!-- 						<span translate=\"sceaApp.calendar.week\">Week</span> --><!-- 						<span>{{vm.vdeTaskPlannings[0].weeks[0].week}}</span> --><!-- 	                	<span class=\"glyphicon glyphicon-sort\"></span> --><!-- 					</th> --><!-- 					<th jh-sort-by=\"-{vm.vdeTaskPlannings[0].weeks[1]}\"> --><!-- 						<span translate=\"sceaApp.calendar.week\">Week</span> --><!-- 						<span>{{vm.vdeTaskPlannings[0].weeks[1].week}}</span> --><!-- 	                	<span class=\"glyphicon glyphicon-sort\"></span> --><!-- 					</th> --><!-- 					<th jh-sort-by=\"-{vm.vdeTaskPlannings[0].weeks[2]}\"> --><!-- 						<span translate=\"sceaApp.calendar.week\">Week</span> --><!-- 						<span>{{vm.vdeTaskPlannings[0].weeks[2].week}}</span> --><!-- 	                	<span class=\"glyphicon glyphicon-sort\"></span> --><!-- 					</th> --><!-- 					<th jh-sort-by=\"-{vm.vdeTaskPlannings[0].weeks[3]}\"> --><!-- 						<span translate=\"sceaApp.calendar.week\">Week</span> --><!-- 						<span>{{vm.vdeTaskPlannings[0].weeks[3].week}}</span> --><!-- 	                	<span class=\"glyphicon glyphicon-sort\"></span> --><!-- 					</th> --><!-- 					<th jh-sort-by=\"-{vm.vdeTaskPlannings[0].weeks[4]}\"> --><!-- 						<span translate=\"sceaApp.calendar.week\">Week</span> --><!-- 						<span>{{vm.vdeTaskPlannings[0].weeks[4].week}}</span> --><!-- 	                	<span class=\"glyphicon glyphicon-sort\"></span> --><!-- 					</th> --><th jh-sort-by=\"-recoPlannedCall\"><span translate=\"sceaApp.vdeTaskPlanning.recommendation\">Reco. Planned Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-targetCall\"><span translate=\"sceaApp.vdeTaskPlanning.targetCall\">Target Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-actualCall\"><span translate=\"sceaApp.vdeTaskPlanning.actualCall\">Actual Call</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"-achievement\"><span translate=\"sceaApp.vdeTaskPlanning.achievement\">Achievement</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"vdeTaskPlanning in vm.vdeTaskPlannings\n	                | orderBy:vm.predicate:vm.reverse\"><td>{{vdeTaskPlanning.vdeName}}</td><td ng-repeat=\"week in vdeTaskPlanning.weeks track by $index\" ng-class=\"{ \'danger\' : vm.currentCalendar.week > week.week, \n  						\'warning\' : vm.currentCalendar.week == week.week,\n						\'success\' : vm.currentCalendar.week < week.week }\"><a ng-hide=\"$last\" ui-sref=\"call-plan-creation.detail({vdeId:vdeTaskPlanning.vdeId, calendarId:week.calendarId})\"><span>{{week.value}}</span> </a><a ng-show=\"$last\" ui-sref=\"call-plan-creation.detail({vdeId:vdeTaskPlanning.vdeId, calendarId:week.calendarId, last:1})\"><span>{{week.value}}</span></a></td><td><a ui-sref=\"call-plan-creation.detail2({vdeId:vdeTaskPlanning.vdeId, month:vm.month })\">{{vdeTaskPlanning.recoPlannedCall}}</a></td><td><a ui-sref=\"call-plan-creation.detail3({vdeId:vdeTaskPlanning.vdeId, month:vm.month })\">{{vdeTaskPlanning.targetCall}}</a></td><td><a ui-sref=\"call-plan-creation.detail4({vdeId:vdeTaskPlanning.vdeId, month:vm.month })\">{{vdeTaskPlanning.actualCall}}</a></td><td>{{vdeTaskPlanning.achievement}} <span ng-show=\"vdeTaskPlanning.achievement != null\">%</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/report/call-plan-report/call-plan-report.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/incentive/incentive.html","<div><h1 class=\"text-center\"><span translate=\"sceaApp.dashboard.home.title\">VDE Rank</span> <span>- </span><span ng-if=\"vm.dashboardParams.month != null\" translate=\"sceaApp.calendar.months.{{vm.dashboardParams.month}}\">{{vm.dashboardParams.month}} </span><span ng-if=\"vm.dashboardParams.week != null\">Week {{vm.dashboardParams.week}} </span><span>{{vm.dashboardParams.year}}</span><div class=\"pull-right\"><button class=\"btn btn-default\" ng-disabled=\"vm.exportVdeProgressing\" ng-click=\"vm.exportVde()\" tooltip-placement=\"bottom\" tooltip-popup-delay=\"250\" uib-tooltip=\"Export detail to Excel\"><span class=\"glyphicon glyphicon-export\"></span></button> <button class=\"btn btn-default\" ng-click=\"vm.openOption()\" tooltip-placement=\"bottom\" has-authority=\"ROLE_ADMIN\" tooltip-popup-delay=\"250\" uib-tooltip=\"Options\"><span class=\"glyphicon glyphicon-option-horizontal\"></span></button></div></h1><br><jhi-alert></jhi-alert><div class=\"content\"><div class=\"table-responsive\"><table class=\"table table-bordered table-striped table-center\"><thead><tr><th style=\"width: 10%\"><span translate=\"sceaApp.dashboard.rank\">rank</span></th><th style=\"width: 30%\"><span translate=\"sceaApp.dashboard.employeeName\">vde</span></th><th style=\"width: 30%\"><span translate=\"sceaApp.dashboard.achievement\">achievement</span></th><th style=\"width: 30%\"><span translate=\"sceaApp.dashboard.managerName\">vdo</span></th></tr></thead><tbody infinite-scroll=\"vm.loadMoreDashboard()\" infinite-scroll-disabled=\"vm.disableLoadDashboard\" infinite-scroll-distance=\"\" infinite-scroll-immediate-check=\"false\"><tr ng-repeat=\"dashboardData in vm.dashboardDatas\"><td style=\"width: 10%\">{{$index+1}}</td><td style=\"width: 30%\">{{dashboardData.employeeName}}</td><td style=\"width: 30%\">{{dashboardData.achievement | number:0}}%</td><td style=\"width: 30%\">{{dashboardData.managerName}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/report/other-brand-display-report/other-brand-display-reports.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"sceaApp.otherBrandDisplayReport.home.filter\">Filter</h3></div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-2\" style=\"margin-left: 6.5%\"><div class=\"checkbox\"><label><input type=\"checkbox\" style=\"top: 5px\" ng-model=\"vm.options.all\"> <b><span translate=\"sceaApp.otherBrandDisplayReport.all\">All</span></b></label></div></div></div><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsType\" value=\"area\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.region\">Region</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.region\" ng-change=\"vm.getBranchs(vm.area.region.id)\" ng-options=\"region.areaName for region in vm.area.regions\"></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.branch\">Branch</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.branch\" ng-change=\"vm.getCities(vm.area.branch.id)\" ng-options=\"branch.areaName for branch in vm.area.branchs\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.city\">City</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.city\" ng-options=\"city.areaName for city in vm.area.cities\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\" ng-hide=\"vm.isVdo\"><label><input type=\"radio\" name=\"optionsType\" value=\"employee\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.otherBrandDisplayReport.vdo\">VDO</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vdo\" ng-change=\"vm.getVdes(vm.employee.vdo.id)\" ng-options=\"vdo.firstName for vdo in vm.employee.vdos\"><option ng-hide=\"vm.isVdo\" value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.otherBrandDisplayReport.vde\">VDE</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vde\" ng-options=\"vde.firstName for vde in vm.employee.vdes\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.year\">Year</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-options=\"year for year in vm.calendar.years\" required></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.month\">Month</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" required><option ng-repeat=\"month in vm.calendar.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div></div></div></div><div class=\"panel-footer\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.generate()\"><span translate=\"entity.action.generate\">Generate</span></button></div></div></div></form>");
$templateCache.put("app/report/report-equipment/report-equipment.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/report-fixture/report-fixture.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/report-image/report-image.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/report-internet/report-internet.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/report-pop/report-pop.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/report-promotion/report-promotion.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/request-status-pop-report/request-status-pop-report.html","<div><h2 translate=\"sceaApp.requestStatusPopReport.home.title\">POP Request Status Report</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-8 no-padding-left\"><form name=\"searchForm\" class=\"form-inline\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.requestStatusPopReport.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></form></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"requestDate\"><span translate=\"sceaApp.orderPop.requestDate\">Request Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userLogin\"><span translate=\"sceaApp.requestStatusPopReport.requestBy\">Request By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletId\"><span translate=\"sceaApp.requestStatusPopReport.shopCode\">Shop Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletName\"><span translate=\"sceaApp.requestStatusPopReport.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"requestStatus\"><span translate=\"sceaApp.orderPop.requestStatus\">Request Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deliveredDate\"><span translate=\"sceaApp.orderPop.deliveredDate\">Delivered Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat-start=\"orderPop in vm.orderPops\" ng-click=\"vm.getPopDetail(orderPop.popId); vm.index = $index\"><td>{{orderPop.requestDate | date:\'d MMMM y\'}}</td><td>{{orderPop.userLogin}}</td><td>{{orderPop.outletId}}</td><td>{{orderPop.outletName}}</td><td translate=\"{{\'sceaApp.RequestStatus.\' + orderPop.requestStatus}}\">{{orderPop.requestStatus}}</td><td>{{orderPop.deliveredDate | date:\'d MMMM y\'}}</td></tr><tr ng-if=\"vm.index == $index\"><td>Pop</td><td>Requested</td><td>Sent</td><td>Delivered</td></tr><tr ng-repeat-end ng-if=\"vm.index == $index\"><td>{{vm.popDetail.popName}}</td><td>{{orderPop.requestQty}}</td><td>{{orderPop.sentQty}}</td><td>-</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/report/retail-mapping-row-data/retail-mapping-row-data.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/row-data-pop-report/row-data-pop-reports.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"sceaApp.rowDataPopReport.home.filter\">Filter</h3></div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-2\" style=\"margin-left: 6.5%\"><div class=\"checkbox\"><label><input type=\"checkbox\" style=\"top: 5px\" ng-model=\"vm.options.all\"> <b><span translate=\"sceaApp.rowDataPopReport.all\">All</span></b></label></div></div></div><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsType\" value=\"area\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.region\">Region</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.region\" ng-change=\"vm.getBranchs(vm.area.region.id)\" ng-options=\"region.areaName for region in vm.area.regions\"></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.branch\">Branch</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.branch\" ng-change=\"vm.getCities(vm.area.branch.id)\" ng-options=\"branch.areaName for branch in vm.area.branchs\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.city\">City</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.city\" ng-options=\"city.areaName for city in vm.area.cities\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\" ng-hide=\"vm.isVdo\"><label><input type=\"radio\" name=\"optionsType\" value=\"employee\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.employee.vdr\">VDR</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\' || vm.isVdo\" ng-model=\"vm.employee.vdr\" ng-change=\"vm.getVdos(vm.employee.vdr.id)\" ng-options=\"vdr.firstName for vdr in vm.employee.vdrs\"></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.employee.vdo\">VDO</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vdo\" ng-change=\"vm.getVdes(vm.employee.vdo.id)\" ng-options=\"vdo.firstName for vdo in vm.employee.vdos\"><option ng-hide=\"vm.isVdo\" value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.employee.vde\">VDE</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vde\" ng-options=\"vde.firstName for vde in vm.employee.vdes\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.rowDataPopReport.category\">Category</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.category\" ng-options=\"category.categoryName for category in vm.categories\" required></select></div></div></div></div><div class=\"panel-footer\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.generate()\"><span translate=\"entity.action.generate\">Generate</span></button></div></div></div></form>");
$templateCache.put("app/report/store-completeness-report/store-completeness-reports.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"sceaApp.storeCompletenessReport.home.filter\">Filter</h3></div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-2\" style=\"margin-left: 6.5%\"><div class=\"checkbox\"><label><input type=\"checkbox\" style=\"top: 5px\" ng-model=\"vm.options.all\"> <b><span translate=\"sceaApp.storeCompletenessReport.all\">All</span></b></label></div></div></div><div class=\"form-group\" ng-hide=\"vm.isVdo\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsType\" value=\"area\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.region\">Region</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.region\" ng-change=\"vm.getBranchs(vm.area.region.id)\" ng-options=\"region.areaName for region in vm.area.regions\"></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.branch\">Branch</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.branch\" ng-change=\"vm.getCities(vm.area.branch.id)\" ng-options=\"branch.areaName for branch in vm.area.branchs\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.city\">City</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'area\'\" ng-model=\"vm.area.city\" ng-options=\"city.areaName for city in vm.area.cities\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"><div class=\"radio\" ng-hide=\"vm.isVdo\"><label><input type=\"radio\" name=\"optionsType\" value=\"employee\" ng-disabled=\"vm.options.all\" ng-model=\"vm.options.filterType\"> <span></span></label></div></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.storeCompletenessReport.vdo\">VDO</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vdo\" ng-change=\"vm.getVdes(vm.employee.vdo.id)\" ng-options=\"vdo.firstName for vdo in vm.employee.vdos\"><option ng-hide=\"vm.isVdo\" value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.storeCompletenessReport.vde\">VDE</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-disabled=\"vm.options.all || vm.options.filterType != \'employee\'\" ng-model=\"vm.employee.vde\" ng-options=\"vde.firstName for vde in vm.employee.vdes\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-1 col-md-1\" style=\"width: 30px\"></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.year\">Year</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.year\" ng-change=\"vm.getWeeks(vm.calendar.year, vm.calendar.month)\" ng-options=\"year for year in vm.calendar.years\" required></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.month\">Month</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.month\" ng-change=\"vm.getWeeks(vm.calendar.year, vm.calendar.month)\" required><option ng-repeat=\"month in vm.calendar.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.week\">Week</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.calendar.week\" ng-options=\"week for week in vm.calendar.weeks\" required></select></div></div></div></div><div class=\"panel-footer\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.generate()\"><span translate=\"entity.action.generate\">Generate</span></button></div></div></div></form>");
$templateCache.put("app/report/vdo-audit-row-data/vdo-audit-row-data.html","<iframe ng-src=\"{{vm.birtViewerAddress}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/report/visit-audit/visit-audit-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.visitAudit.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.visitAudit.delete.question\" translate-values=\"{id: \'{{vm.visitAudit.id}}\'}\">Are you sure you want to delete this Visit Audit?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/report/visit-audit/visit-audit-detail.html","<div><h2><span translate=\"sceaApp.visitAudit.detail.title\">Visit Audit</span> {{vm.visitAudit.id}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.visitAudit.surveyStart\">Survey Start</span></dt><dd><span>{{vm.visitAudit.surveyStart | date:\'medium\'}}</span></dd><dt><span translate=\"sceaApp.visitAudit.surveyEnd\">Survey End</span></dt><dd><span>{{vm.visitAudit.surveyEnd | date:\'medium\'}}</span></dd><dt><span translate=\"sceaApp.visitAudit.popNote\">Pop Note</span></dt><dd><span>{{vm.visitAudit.popNote}}</span></dd><dt><span translate=\"sceaApp.visitAudit.fixtureNote\">Fixture Note</span></dt><dd><span>{{vm.visitAudit.fixtureNote}}</span></dd><dt><span translate=\"sceaApp.visitAudit.equipmentNote\">Equipment Note</span></dt><dd><span>{{vm.visitAudit.equipmentNote}}</span></dd><dt><span translate=\"sceaApp.visitAudit.internetNote\">Internet Note</span></dt><dd><span>{{vm.visitAudit.internetNote}}</span></dd><dt><span translate=\"sceaApp.visitAudit.auditor\">Auditor</span></dt><dd>{{vm.visitAudit.auditorFirstName}}</dd><dt><span translate=\"sceaApp.visitAudit.tPop\">T Pop</span></dt><dd><a ui-sref=\"t-pop-detail({id:vm.visitAudit.tPopId})\">{{vm.visitAudit.tPopId}}</a></dd><dt><span translate=\"sceaApp.visitAudit.calendar\">Calendar</span></dt><dd><a ui-sref=\"calendar-detail({id:vm.visitAudit.calendarId})\">{{vm.visitAudit.calendarWeek}}</a></dd><dt><span translate=\"sceaApp.visitAudit.tTicketOrder\">T Ticket Order</span></dt><dd><a ui-sref=\"t-ticket-order-detail({id:vm.visitAudit.tTicketOrderId})\">{{vm.visitAudit.tTicketOrderId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/report/visit-audit/visit-audit-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVisitAuditLabel\" translate=\"sceaApp.visitAudit.detail.title\"></h4></div><div class=\"modal-body\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"sceaApp.visitAudit.auditYear\">Audit Year</span></th><th><span translate=\"sceaApp.visitAudit.auditWeek\">Audit Week</span></th><th><span translate=\"sceaApp.visitAudit.auditStart\">Audit Start</span></th><th><span translate=\"sceaApp.visitAudit.auditEnd\">Audit End</span></th><th><span translate=\"sceaApp.visitAudit.auditorFullName\">Auditor Full Name</span></th><th><span translate=\"sceaApp.visitAudit.outletCode\">Outlet Code</span></th><th><span translate=\"sceaApp.visitAudit.outletName\">Outlet Name</span></th><th><span translate=\"sceaApp.visitAudit.surveyorFullName\">Surveyor Full Name</span></th></tr></thead><tbody><tr><td>{{vm.visitAudit.auditYear}}</td><td>{{vm.visitAudit.auditWeek}}</td><td>{{vm.visitAudit.auditStart | date:\'d MMMM y\'}}</td><td>{{vm.visitAudit.auditEnd | date:\'d MMMM y\'}}</td><td>{{vm.visitAudit.auditorFullName}}</td><td>{{vm.visitAudit.outletCode}}</td><td>{{vm.visitAudit.outletNode}}</td><td>{{vm.visitAudit.surveyorFullName}}</td></tr></tbody></table></div><div class=\"row\"><div class=\"col-xs-2 text-center no-padding-right\"><div class=\"btn-group-vertical\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-primary\': vm.noteActive == 1}\" ng-click=\"vm.noteActive = 1\"><span translate=\"sceaApp.visitAudit.pop\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-primary\': vm.noteActive == 2}\" ng-click=\"vm.noteActive = 2\"><span translate=\"sceaApp.visitAudit.fixture\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-primary\': vm.noteActive == 3}\" ng-click=\"vm.noteActive = 3\"><span translate=\"sceaApp.visitAudit.equipment\"></span></button> <button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-primary\': vm.noteActive == 4}\" ng-click=\"vm.noteActive = 4\"><span translate=\"sceaApp.visitAudit.internet\"></span></button></div></div><div class=\"col-xs-10 no-padding-left\"><div id=\"supervision-detail\" class=\"outline\"><div class=\"detail-pane\" marked=\"vm.visitAudit.popNote\" ng-show=\"vm.noteActive == 1\"></div><div class=\"detail-pane\" marked=\"vm.visitAudit.fixtureNote\" ng-show=\"vm.noteActive == 2\"></div><div class=\"detail-pane\" marked=\"vm.visitAudit.equipmentNote\" ng-show=\"vm.noteActive == 3\"></div><div class=\"detail-pane\" marked=\"vm.visitAudit.internetNote\" ng-show=\"vm.noteActive == 4\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/report/visit-audit/visit-audits.html","<div><h2 translate=\"sceaApp.visitAudit.home.title\">Visit Audits</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 no-padding-left\"><div class=\"input-group pull-right\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchQuery\" id=\"searchQuery\" placeholder=\"{{ \'sceaApp.visitAudit.home.search\' | translate }}\"> <span class=\"input-group-btn width-min\"><button class=\"btn btn-info\" ng-click=\"vm.search(vm.searchQuery)\"><span class=\"glyphicon glyphicon-search\"></span></button> </span><span class=\"input-group-btn width-min\" ng-if=\"vm.currentSearch\"><button class=\"btn btn-info\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-trash\"></span></button></span></div></div><div class=\"col-xs-6 no-padding-right text-right\"><button class=\"btn btn-primary\" ui-sref=\"visit-audit.edit\"><span class=\"glyphicon glyphicon-export\"></span> <span class=\"hidden-xs\" translate=\"entity.action.export\"></span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"auditYear\"><span translate=\"sceaApp.visitAudit.auditYear\">Audit Year</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"auditWeek\"><span translate=\"sceaApp.visitAudit.auditWeek\">Audit Week</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"auditStart\"><span translate=\"sceaApp.visitAudit.auditStart\">Audit Start</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"auditEnd\"><span translate=\"sceaApp.visitAudit.auditEnd\">Audit End</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"auditorFullName\"><span translate=\"sceaApp.visitAudit.auditorFullName\">Auditor Full Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletCode\"><span translate=\"sceaApp.visitAudit.outletCode\">Outlet Code</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"outletName\"><span translate=\"sceaApp.visitAudit.outletName\">Outlet Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"surveyorFullName\"><span translate=\"sceaApp.visitAudit.surveyorFullName\">Surveyor Full Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr style=\"cursor: pointer\" ng-repeat=\"visitAudit in vm.visitAudits track by visitAudit.id\" ui-sref=\"visit-audit.detail({id:visitAudit.id})\"><td>{{visitAudit.auditYear}}</td><td>{{visitAudit.auditWeek}}</td><td>{{visitAudit.auditStart | date:\'d MMMM y\'}}</td><td>{{visitAudit.auditEnd | date:\'d MMMM y\'}}</td><td>{{visitAudit.auditorFullName}}</td><td>{{visitAudit.outletCode}}</td><td>{{visitAudit.outletNode}}</td><td>{{visitAudit.surveyorFullName}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/system-administration/achievement/achievements.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><jhi-alert></jhi-alert><!--     <form name=\"getForm\" ng-controller=\"AchievementController\" class=\"\" ng-submit=\"vm.save()\"> --><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"col-md-12\"><label class=\"col-md-3 form-control-static\"><span class=\"ng-scope\" translate=\"sceaApp.dashboardParams.year\">Year</span></label><div class=\"col-md-6\"><select class=\"form-control input-sm\" ng-model=\"vm.achievement.year\" ng-options=\"year for year in vm.options.years\" ng-change=\"vm.getWeeks(vm.achievement.year)\" ng-click=\"vm.onClickYear(vm.achievement.year)\"></select></div></div></div><div class=\"col-md-8\"><div class=\"col-md-12\"><label class=\"col-md-2 form-control-static\"><span class=\"ng-scope\" translate=\"sceaApp.dashboardParams.storeType\">Store Type</span></label><div class=\"col-md-2\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsStoreType\" ng-model=\"vm.options.storeType.type\" value=\"VDE\" type=\"radio\" ng-click=\"vm.onClickStoreType(vm.options.storeType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.StoreType.VDE\">VDE</span></label></div></div><div class=\"col-md-2\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsStoreType\" ng-model=\"vm.options.storeType.type\" value=\"PERFECT\" type=\"radio\" ng-click=\"vm.onClickStoreType(vm.options.storeType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.StoreType.PERFECT\">Perfect</span></label></div></div></div><div class=\"col-md-12\"><div class=\"col-md-offset-2 col-md-2\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsStoreType\" ng-model=\"vm.options.storeType.type\" value=\"RIS\" type=\"radio\" ng-click=\"vm.onClickStoreType(vm.options.storeType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.StoreType.RIS\">RIS</span></label></div></div><div class=\"col-md-2\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsStoreType\" ng-model=\"vm.options.storeType.type\" value=\"PC\" type=\"radio\" ng-click=\"vm.onClickStoreType(vm.options.storeType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.StoreType.PC\">PC</span></label></div></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"col-md-12\"><label class=\"col-md-6 form-control-static\"><span class=\"ng-scope\" translate=\"sceaApp.dashboardParams.dataType\">Data Type</span></label></div><div class=\"col-md-12\"><div class=\"col-md-3\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsDataType\" ng-model=\"vm.options.dataType.type\" value=\"month\" ng-click=\"vm.onClickDataType(vm.options.dataType.type)\"> <span translate=\"sceaApp.dashboardParams.monthly\">Monthly</span></label></div></div><div class=\"col-md-6\"><select class=\"form-control input-sm\" ng-model=\"vm.achievement.month\" ng-change=\"vm.getWeeks(vm.achievement.year, vm.achievement.month)\" ng-disabled=\"vm.options.dataType.type != \'month\'\" ng-click=\"vm.onClickOptionsDataType(vm.achievement.month)\"><option ng-repeat=\"month in vm.options.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div></div><div class=\"col-md-12\"><div class=\"col-md-3\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsDataType\" ng-model=\"vm.options.dataType.type\" value=\"week\" ng-click=\"vm.onClickDataType(vm.options.dataType.type)\"> <span translate=\"sceaApp.dashboardParams.weekly\">Weekly</span></label></div></div><div class=\"col-md-6\"><select class=\"form-control input-sm\" ng-model=\"vm.achievement.week\" ng-disabled=\"vm.options.dataType.type != \'week\'\" ng-options=\"week for week in vm.options.weeks\" ng-click=\"vm.onClickOptionsDataType(vm.achievement.week)\"></select></div></div></div><div class=\"col-md-8\"><div class=\"col-md-12\"><label class=\"col-md-6 form-control-static\"><span class=\"ng-scope\" translate=\"sceaApp.dashboardParams.callPlanOption\">Call Plan Option</span></label></div><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsCallPlan\" ng-model=\"vm.options.callPlanType.type\" value=\"ACOJTGT\" type=\"radio\" ng-click=\"vm.onClickCallPlanType(vm.options.callPlanType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.CallPlanType.ACOJTGT\">Actual+Other Job / Target</span></label></div></div><div class=\"col-md-7\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsCallPlan\" ng-model=\"vm.options.callPlanType.type\" value=\"ACOJRCP\" type=\"radio\" ng-click=\"vm.onClickCallPlanType(vm.options.callPlanType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.CallPlanType.ACOJRCP\">Actual+Other Job / Recommendation C	all Plan</span></label></div></div></div><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsCallPlan\" ng-model=\"vm.options.callPlanType.type\" value=\"ACTGT\" type=\"radio\" ng-click=\"vm.onClickCallPlanType(vm.options.callPlanType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.CallPlanType.ACTGT\">Actual / Target</span></label></div></div><div class=\"col-md-7\"><div class=\"radio\"><label><input aria-invalid=\"false\" class=\"ng-valid ng-not-empty ng-dirty ng-touched\" name=\"optionsCallPlan\" ng-model=\"vm.options.callPlanType.type\" value=\"ACRCP\" type=\"radio\" ng-click=\"vm.onClickCallPlanType(vm.options.callPlanType.type)\"> <span class=\"ng-scope\" translate=\"sceaApp.CallPlanType.ACRCP\">Actual / Recommendation Call Plan</span></label></div></div></div></div></div><div class=\"col-md-offset-11\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"vm.showDisabled\" ng-click=\"vm.onClickGetData(vm.achievement.year, vm.achievement.month, vm.achievement.week, vm.options.storeType.type, vm.options.callPlanType.type)\"><span class=\"glyphicon glyphicon-share\"></span>&nbsp;<span translate=\"entity.action.show\">Show</span></button></div><div class=\"col-md-12\"><hr style=\"border-top: 2px solid #D8D8D8\" class=\"custom-hr\"></div><div class=\"col-md-offset-11\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isDisabled\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"sceaApp.dashboard.vde\">VDE</span></th><th><span translate=\"sceaApp.dashboardParams.callPlan\">Call Plan</span></th><th><span translate=\"sceaApp.dashboardParams.popav\">POP AV</span></th><th><span translate=\"sceaApp.dashboardParams.popha\">POP HA</span></th><th><span translate=\"sceaApp.dashboardParams.equipment\">Equipment</span></th><th><span translate=\"sceaApp.dashboardParams.fixture\">Fixture</span></th><th><span translate=\"sceaApp.dashboardParams.internet\">Internet</span></th></tr></thead><tbody><tr ng-repeat=\"achievement in vm.achievements track by $index\"><td>{{achievement.vde}}</td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'callPlan\'.split(\'P\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'callPlan\'.split(\'P\').join($index)}}\" ng-model=\"vm.achievements[$index].callPlan\" ng-change=\"vm.changeCallPlan($index, vm.achievements[$index].callPlan)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'callPlan\'.split(\'P\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'callPlan\'.split(\'P\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'popAV\'.split(\'V\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'popAV\'.split(\'V\').join($index)}}\" ng-model=\"vm.achievements[$index].popAV\" ng-change=\"vm.changePopAV($index, vm.achievements[$index].popAV)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'popAV\'.split(\'V\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'popAV\'.split(\'V\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'popHA\'.split(\'A\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'popHA\'.split(\'A\').join($index)}}\" ng-model=\"vm.achievements[$index].popHA\" ng-change=\"vm.changePopHA($index, vm.achievements[$index].popHA)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'popHA\'.split(\'A\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'popHA\'.split(\'A\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'equipment\'.split(\'p\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'equipment\'.split(\'p\').join($index)}}\" ng-model=\"vm.achievements[$index].equipment\" ng-change=\"vm.changeEquipment($index, vm.achievements[$index].equipment)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'equipment\'.split(\'p\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'equipment\'.split(\'p\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'fixture\'.split(\'x\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'fixture\'.split(\'x\').join($index)}}\" ng-model=\"vm.achievements[$index].fixture\" ng-change=\"vm.changeFixture($index, vm.achievements[$index].fixture)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'fixture\'.split(\'x\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'fixture\'.split(\'x\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><div class=\"input-group\" ng-class=\"{\'has-error\': editForm.{{\'internet\'.split(\'r\').join($index)}}.$invalid}\"><input type=\"number\" class=\"form-control\" min=\"0\" max=\"100\" name=\"{{\'internet\'.split(\'r\').join($index)}}\" id=\"field_internet\" ng-model=\"vm.achievements[$index].internet\" ng-change=\"vm.changeInternet($index, vm.achievements[$index].internet)\" ng-pattern=\"/^[0-9]+$/\"><div class=\"input-group-addon\">%</div></div><div ng-show=\"editForm.{{\'internet\'.split(\'r\').join($index)}}.$invalid\"><p class=\"help-block\" ng-show=\"editForm.{{\'internet\'.split(\'r\').join($index)}}.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td></tr></tbody></table></div></form>");
$templateCache.put("app/system-administration/visit-cycle/visit-cycle-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.visitCycle.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"sceaApp.visitCycle.delete.question\" translate-values=\"{storeGrade: \'{{vm.visitCycle.storeGrade}}\'}\">Are you sure you want to delete this Visit Cycle?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/system-administration/visit-cycle/visit-cycle-detail.html","<div><h2><span translate=\"sceaApp.visitCycle.detail.title\">Visit Cycle</span> {{vm.visitCycle.storeGrade}}</h2><hr><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"sceaApp.visitCycle.storeGrade\">Store Grade</span></dt><dd><span>{{vm.visitCycle.storeGrade}}</span></dd><dt><span translate=\"sceaApp.visitCycle.visitTime\">Visit Time</span></dt><dd><span>{{vm.visitCycle.visitTime}}</span></dd><dt><span translate=\"sceaApp.visitCycle.cycle\">Cycle</span></dt><dd><span>{{vm.visitCycle.cycle}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/system-administration/visit-cycle/visit-cycle-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVisitCycleLabel\" translate=\"sceaApp.visitCycle.home.createOrEditLabel\">Create or edit a Visit Cycle</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.visitCycle.storeGrade\" for=\"field_storeGrade\">Store Grade</label><input type=\"text\" class=\"form-control\" name=\"storeGrade\" id=\"field_storeGrade\" ng-model=\"vm.visitCycle.storeGrade\" ng-disabled=\"vm.visitCycle.storeGrade == \'Other\'\" capitalize required><div ng-show=\"editForm.storeGrade.$invalid\"><p class=\"help-block\" ng-show=\"editForm.storeGrade.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.visitCycle.visitTime\" for=\"field_visitTime\">Visit Time</label><input type=\"number\" class=\"form-control\" name=\"visitTime\" id=\"field_visitTime\" min=\"0\" ng-model=\"vm.visitCycle.visitTime\" required><div ng-show=\"editForm.visitTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.visitTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.visitTime.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block\" ng-show=\"editForm.visitTime.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"sceaApp.visitCycle.cycle\" for=\"field_cycle\">Cycle</label><input type=\"number\" class=\"form-control\" name=\"cycle\" id=\"field_cycle\" min=\"0\" ng-model=\"vm.visitCycle.cycle\" required><div ng-show=\"editForm.cycle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.cycle.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.cycle.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block\" ng-show=\"editForm.cycle.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-disabled=\"vm.buttonCancel\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving || vm.buttonSave\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/system-administration/visit-cycle/visit-cycle-info-dialog.html","<div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.visitCycle.info.title\">Create or edit a Visit Cycle</h4></div><div class=\"form-horizontal\" style=\"padding-top: 5px; padding-bottom: 5px\"><div class=\"form-group\" ng-repeat=\"visitCycle in vm.visitCycles track by visitCycle.id\"><label class=\"col-md-offset-1 col-md-4 control-label\"><span translate=\"sceaApp.visitCycle.info.grade\" ng-hide=\"visitCycle.storeGrade == \'Other\'\">Grade</span> <span>{{visitCycle.storeGrade}}</span></label><span class=\"col-md-6 form-control-static\" style=\"min-height:5px; padding-left: 0px; padding-bottom: 0px\"><span>:</span>&nbsp;&nbsp; <span>{{visitCycle.visitTime}}x</span> <span translate=\"sceaApp.visitCycle.info.per\">per</span> <span>{{visitCycle.cycle}}</span> <span translate=\"sceaApp.visitCycle.info.week\">week</span></span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></div>");
$templateCache.put("app/system-administration/visit-cycle/visit-cycles.html","<div><div class=\"title\"><span translate=\"sceaApp.visitCycle.home.title\">Visit Cycles</span></div><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"visit-cycle.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span class=\"hidden-xs\" translate=\"sceaApp.visitCycle.home.createLabel\">Create a new Grade and Visit Cycle</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"table table-striped table-center\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span translate=\"sceaApp.visitCycle.storeGrade\">Store Grade</span></th><th><span translate=\"sceaApp.visitCycle.visitTime\">Visit Time</span></th><th><span translate=\"sceaApp.visitCycle.cycle\">Cycle (in week)</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"visitCycle in vm.visitCycles track by visitCycle.id\"><td><a ui-sref=\"visit-cycle-detail({id:visitCycle.id})\">{{visitCycle.storeGrade}}</a></td><td>{{visitCycle.visitTime}}</td><td>{{visitCycle.cycle}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"visit-cycle-detail({id:visitCycle.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"visit-cycle.edit({id:visitCycle.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-disabled=\"visitCycle.storeGrade == \'Other\'\" ui-sref=\"visit-cycle.delete({id:visitCycle.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!--     <div class=\"text-center\"> --><!--         <jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count> --><!--     </div> --><!--     <uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager> --><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");
$templateCache.put("app/home/dashboard-asm/modal/call-plan-outlet-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\">Outlets</h4></div><div class=\"modal-body\"><span style=\"margin-bottom: 10px\"><b>Target : {{vm.ticketOrders.length}}<b></b></b></span><div ng-if=\"vm.ticketOrders.length\" class=\"table-responsive\" style=\"height: 300px\"><table class=\"jh-table table table-striped table-center\"><thead><tr style=\"position: sticky;top: 0px;background: white;z-index: 2\"><th class=\"text-center\">Code</th><th class=\"text-center\">Name</th><th class=\"text-center\">Note</th></tr></thead><tbody><tr ng-repeat=\"ticketOrder in vm.ticketOrders\" ng-style=\"{\'background-color\': vm.bgColorStat[ticketOrder.status]}\"><td class=\"text-center\">{{ticketOrder.outletCode}}</td><td class=\"text-center\">{{ticketOrder.outletName}}</td><td class=\"text-center\">{{ticketOrder.note}}</td></tr></tbody></table></div><div ng-if=\"!vm.ticketOrders.length\" class=\"text-center\" style=\"padding: 20px;height: 280px;display: flex;align-items: center\"><h3 ng-if=\"vm.loading\" style=\"margin:auto\">Loading...</h3><h3 ng-if=\"!vm.loading\" style=\"margin:auto\">No Data</h3></div><br><span style=\"margin-right: 10px\"><i class=\"fa fa-circle\" style=\"margin-right: 3px\" ng-style=\"{\'color\': vm.bgColorStat[\'Not Downloaded\']}\"></i> <b>Created {{vm.total.created}}</b> </span><span style=\"margin-right: 10px\"><i class=\"fa fa-circle\" style=\"margin-right: 3px\" ng-style=\"{\'color\': vm.bgColorStat[\'Succeed\']}\"></i> <b>Success {{vm.total.success}}</b> </span><span style=\"margin-right: 10px\"><i class=\"fa fa-circle\" style=\"margin-right: 3px\" ng-style=\"{\'color\': vm.bgColorStat[\'Failed\']}\"></i> <b>Failed {{vm.total.failed}}</b> </span><span style=\"margin-right: 10px\"><i class=\"fa fa-circle\" style=\"margin-right: 3px\" ng-style=\"{\'color\': vm.bgColorStat[\'In Progress\']}\"></i> <b>Todo {{vm.total.todo}}</b></span></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-remove\"></span>&nbsp;<span translate=\"entity.action.close\">Close</span></button></div></form>");
$templateCache.put("app/entities/planogram/fixture/planogram-fixture-dialog.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" id=\"myPopLabel\" translate=\"sceaApp.planogram.dialog.addFixtures\">Create or edit a Pop</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"sceaApp.planogram.detail.categories\" for=\"field_category\">Category</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-change=\"vm.changeFixtureList(vm.option.id)\" ng-model=\"vm.option\" ng-options=\"category as category.categoryName for category in vm.categories track by category.id\"></select></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th>Fixture</th><th class=\"text-center\" width=\"20%\"><input type=\"checkbox\" ng-model=\"vm.check\" ng-change=\"vm.checkAll(vm.check)\"></th></tr></thead><tbody><tr ng-repeat=\"fixture in vm.fixtures\"><td>{{fixture.fixtureName}}</td><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"fixture.status\"></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" ng-click=\"vm.addFixture()\" class=\"btn btn-info pull-right\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span translate=\"sceaApp.planogram.dialog.add\">Add</span></button></div>");
$templateCache.put("app/entities/planogram/fixture/planogram-material-dialog.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" id=\"myPopLabel\" translate=\"sceaApp.planogram.dialog.addMaterial\">Add Material</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label style=\"font-size: 12px\" translate=\"sceaApp.planogram.detail.categories\" for=\"field_category\">categories</label><select class=\"form-control\" id=\"field_category\" name=\"category\" ng-change=\"vm.onChangeCategories(vm.catOption.id)\" ng-model=\"vm.catOption\" ng-options=\"category as category.equipmentName for category in vm.categories track by category.id\"></select></div><div class=\"form-group\"><label style=\"font-size: 12px\" translate=\"sceaApp.planogram.detail.subCategories\" for=\"field_subCategory\">Sub categories</label><select class=\"form-control\" id=\"field_subCategory\" name=\"category\" ng-change=\"vm.onChangeSubCategories(vm.subOption.id)\" ng-model=\"vm.subOption\" ng-options=\"subCategory as subCategory.equipmentName for subCategory in vm.subCategories track by subCategory.id\" ng-disabled=\"!vm.subOption\"></select></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th>Material</th><th class=\"text-center\" width=\"20%\"><input type=\"checkbox\" ng-model=\"vm.check\" ng-change=\"vm.checkAll(vm.check)\"></th></tr></thead><tbody><tr ng-repeat=\"material in vm.materials\"><td>{{material.equipmentName}}</td><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"material.status\"></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" ng-click=\"vm.addMaterial()\" class=\"btn btn-info pull-right\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span translate=\"sceaApp.planogram.dialog.add\">Add</span></button></div>");
$templateCache.put("app/entities/planogram/fixture/planogram-subfixture-dialog.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" id=\"myPopLabel\" translate=\"sceaApp.planogram.dialog.addSubFixtures\">Add Sub Fixtures</h4></div><div class=\"modal-body\" style=\"height: 70vh; overflow: auto\"><jhi-alert-error></jhi-alert-error><h6><strong>Fixture</strong></h6><span>{{vm.fixtureName}}</span><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th>Sub Fixtures</th><th class=\"text-center\" width=\"20%\"><input type=\"checkbox\" ng-model=\"vm.check\" ng-change=\"vm.checkAll(vm.check)\"></th></tr></thead><tbody><tr ng-repeat=\"subFixture in vm.subFixtures\"><td>{{subFixture.fixtureName}}</td><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"subFixture.status\"></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp; <span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-click=\"vm.addSubFixture()\" class=\"btn btn-info pull-right\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; <span translate=\"sceaApp.planogram.dialog.add\">Add</span></button></div>");
$templateCache.put("app/entities/planogram/import/planogram-import-equipment.html","<form><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 data-translate=\"sceaApp.planogram.home.importEquipment\">Import Equipment</h4></div><jhi-alert-error></jhi-alert-error><div class=\"modal-body\"><button type=\"file\" ngf-select class=\"btn btn-default\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><br><br><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp; <span data-translate=\"entity.action.process\">Process</span></button></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div></form>");
$templateCache.put("app/entities/planogram/import/planogram-import-fixture.html","<form><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 data-translate=\"sceaApp.planogram.home.importFixture\">Import Fixture</h4></div><jhi-alert-error></jhi-alert-error><div class=\"modal-body\"><button type=\"file\" ngf-select class=\"btn btn-default\" accept=\".csv\" ngf-change=\"vm.setData($file)\" data-translate=\"entity.upload.chooseFile\">Choose a File</button><div ng-if=\"!vm.isUploading\" class=\"help-block clearfix\"><span ng-if=\"!vm.data.size\" data-translate=\"entity.upload.selectFile\">Please select a file to upload</span> <span class=\"pull-left\" ng-if=\"vm.data.size > 0\">{{vm.data.fileName}}, {{vm.data.size/1000 | number}} KB</span> <button ng-if=\"vm.data.data > 0\" ng-click=\"vm.data.data = 0; vm.data.dataContentType = null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button><div ng-if=\"vm.isUploading\" class=\"help-block clearfix\"><div ng-if=\"!vm.file.result && !vm.file.error\"><span class=\"pull-left\">{{vm.file.progress}}</span></div><span ng-show=\"vm.file.result\" class=\"text-success\" translate=\"global.messages.import.importSuccess\">Success</span> <span ng-show=\"vm.file.error\" class=\"text-danger\" translate=\"global.messages.import.importFailed\">Failed</span></div></div><br><br><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.upload(vm.file)\" ng-disabled=\"(!vm.data.size || vm.data.size <= 0) || vm.isUploadFinished\"><span class=\"glyphicon glyphicon-upload\"></span>&nbsp; <span data-translate=\"entity.action.process\">Process</span></button></div><div style=\"border: 1px solid #ccc; padding: 15px; margin: 20px\" ng-if=\"vm.logs\"><h3>Logs</h3><p ng-repeat=\"log in vm.logs track by $index\">{{log}}</p></div></form>");
$templateCache.put("app/report/incentive/incentive-params/incentive-params-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" ng-init=\"vm.init()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"sceaApp.dashboardParams.home.title\">VDE Achievement Options</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-horizontal\"><div class=\"form-group custom-margin custom-margin\"><label class=\"col-md-offset-2 col-md-2 form-control-static\">Year</label><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.dashboardParams.year\" name=\"year\" ng-options=\"year for year in vm.options.years\" required></select></div><div class=\"col-md-4\"><div ng-show=\"editForm.year.$invalid\"><p class=\"help-block\" ng-show=\"editForm.year.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"form-group custom-margin custom-margin\"><label class=\"col-md-offset-2 col-md-2 form-control-static\"><span translate=\"sceaApp.dashboardParams.dataType\">Data Type</span></label><div class=\"col-md-2\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsDataType\" ng-click=\"vm.changeDataType()\" ng-model=\"vm.options.dataType.type\" value=\"month\"> <span translate=\"sceaApp.dashboardParams.monthly\">Monthly</span></label></div></div><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.dashboardParams.month\" name=\"month\" ng-disabled=\"vm.options.dataType.type != \'month\'\"><option ng-repeat=\"month in vm.options.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><div class=\"col-md-4\"><div ng-show=\"editForm.month.$invalid || vm.options.dataType.type == \'month\'\"><p class=\"help-block\" ng-show=\"vm.dashboardParams.month == null\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"form-group custom-margin\"><label class=\"col-md-offset-2 col-md-2 form-control-static\"><span></span></label><div class=\"col-md-2\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsDataType\" ng-click=\"vm.changeDataType()\" ng-model=\"vm.options.dataType.type\" value=\"week\"> <span translate=\"sceaApp.dashboardParams.weekly\">Weekly</span></label></div></div><div class=\"col-md-2\"><select class=\"form-control input-sm\" ng-model=\"vm.dashboardParams.week\" name=\"week\" ng-disabled=\"vm.options.dataType.type != \'week\'\" ng-options=\"week for week in vm.options.weeks\"></select></div><div class=\"col-md-4\"><div ng-show=\"editForm.week.$invalid || vm.options.dataType.type == \'week\'\"><p class=\"help-block\" ng-show=\"vm.dashboardParams.week == null\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"form-group custom-margin\"><label class=\"col-md-offset-2 col-md-2 form-control-static\"><span translate=\"sceaApp.dashboardParams.storeType\">Store Type</span></label><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsStoreType\" ng-model=\"vm.dashboardParams.storeType\" value=\"VDE\" translate=\"sceaApp.StoreType.VDE\">VDE</label></div></div><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsStoreType\" ng-model=\"vm.dashboardParams.storeType\" value=\"PERFECT\" translate=\"sceaApp.StoreType.PERFECT\">PERFECT</label></div></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-offset-4 col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsStoreType\" ng-model=\"vm.dashboardParams.storeType\" value=\"RIS\" translate=\"sceaApp.StoreType.RIS\">RIS</label></div></div><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsStoreType\" ng-model=\"vm.dashboardParams.storeType\" value=\"PC\" translate=\"sceaApp.StoreType.PC\">PC</label></div></div></div><div class=\"form-group custom-margin\"><label class=\"col-md-offset-2 col-md-2 form-control-static\"><span translate=\"sceaApp.dashboardParams.role\">Role</span></label><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsRole\" ng-model=\"vm.dashboardParams.roleName\" value=\"VDE\" translate=\"sceaApp.role.vde\">VDE</label></div></div><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsRole\" ng-model=\"vm.dashboardParams.roleName\" value=\"PC\" translate=\"sceaApp.role.pc\">PC</label></div></div><div class=\"col-md-1\"><div class=\"radio\"><label><input type=\"radio\" name=\"optionsRole\" ng-model=\"vm.dashboardParams.roleName\" value=\"\" translate=\"sceaApp.role.all\">ALL</label></div></div></div><div class=\"form-group custom-margin\"><label class=\"col-md-offset-2 col-md-4 form-control-static\"><span translate=\"sceaApp.dashboardParams.componentPortion\">Component Portion</span></label></div><div class=\"form-group custom-margin\"><div class=\"col-md-3\"><div ng-show=\"vm.options.callPlan.status\"><p class=\"help-block text-right\" ng-show=\"editForm.callPlan.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block text-right\" ng-show=\"editForm.callPlan.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.callPlan.$error.max\" translate=\"entity.validation.max\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.callPlan.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"col-md-2\"><div class=\"input-group\"><input class=\"form-control input-sm\" type=\"number\" name=\"callPlan\" ng-change=\"vm.changePortion()\" min=\"0\" max=\"{{vm.options.callPlan.max}}\" ng-disabled=\"!vm.options.callPlan.status\" ng-model=\"vm.dashboardParams.callPlan\" required><div class=\"input-group-addon\">%</div></div></div><div class=\"col-md-2\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.options.callPlan.status\" ng-click=\"vm.setFocus(vm.options.callPlan.status, 6)\" ng-change=\"vm.changePortion()\"> <span translate=\"sceaApp.dashboardParams.callPlan\">Call Plan</span></label></div></div><div class=\"col-md-4\"><select class=\"form-control input-sm\" name=\"callPlanType\" ng-disabled=\"!vm.options.callPlan.status\" ng-model=\"vm.dashboardParams.callPlanType\" required><option value=\"CALLPLANACOJTGT\" translate=\"sceaApp.CallPlanType.ACOJTGT\">ACOJTGT</option><option value=\"CALLPLANACTGT\" translate=\"sceaApp.CallPlanType.ACTGT\">ACTGT</option></select></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-3\"><div ng-show=\"vm.options.pop.status\"><p class=\"help-block text-right\" ng-show=\"editForm.pop.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block text-right\" ng-show=\"editForm.pop.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.pop.$error.max\" translate=\"entity.validation.max\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.pop.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"col-md-2\"><div class=\"input-group\"><input class=\"form-control input-sm\" type=\"number\" name=\"pop\" ng-change=\"vm.changePortion()\" min=\"0\" max=\"{{vm.options.pop.max}}\" ng-disabled=\"!vm.options.pop.status\" ng-model=\"vm.dashboardParams.pop\" required><div class=\"input-group-addon\">%</div></div></div><div class=\"col-md-2\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.options.pop.status\" ng-click=\"vm.setFocus(vm.options.pop.status, 7)\" ng-change=\"vm.changePortion()\"> <span translate=\"sceaApp.dashboardParams.pop\">Pop</span></label></div></div><div class=\"col-md-4\"><div ng-show=\"vm.options.callPlan.status\"><p class=\"help-block text-center\" ng-show=\"editForm.callPlanType.$invalid\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-3\"><div ng-show=\"vm.options.equipment.status\"><p class=\"help-block text-right\" ng-show=\"editForm.equipment.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block text-right\" ng-show=\"editForm.equipment.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.equipment.$error.max\" translate=\"entity.validation.max\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.equipment.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"col-md-2\"><div class=\"input-group\"><input class=\"form-control input-sm\" type=\"number\" name=\"equipment\" ng-change=\"vm.changePortion()\" min=\"0\" max=\"{{vm.options.equipment.max}}\" ng-disabled=\"!vm.options.equipment.status\" ng-model=\"vm.dashboardParams.equipment\" required><div class=\"input-group-addon\">%</div></div></div><div class=\"col-md-4\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.options.equipment.status\" ng-click=\"vm.setFocus(vm.options.equipment.status, 8)\" ng-change=\"vm.changePortion()\"> <span translate=\"sceaApp.dashboardParams.equipment\">Equipment</span></label></div></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-3\"><div ng-show=\"vm.options.fixture.status\"><p class=\"help-block text-right\" ng-show=\"editForm.fixture.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block text-right\" ng-show=\"editForm.fixture.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.fixture.$error.max\" translate=\"entity.validation.max\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.fixture.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"col-md-2\"><div class=\"input-group\"><input class=\"form-control input-sm\" type=\"number\" name=\"fixture\" ng-change=\"vm.changePortion()\" min=\"0\" max=\"{{vm.options.fixture.max}}\" ng-disabled=\"!vm.options.fixture.status\" ng-model=\"vm.dashboardParams.fixture\" required><div class=\"input-group-addon\">%</div></div></div><div class=\"col-md-4\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.options.fixture.status\" ng-click=\"vm.setFocus(vm.options.fixture.status, 9)\" ng-change=\"vm.changePortion()\"> <span translate=\"sceaApp.dashboardParams.fixture\">Fixture</span></label></div></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-3\"><div ng-show=\"vm.options.internet.status\"><p class=\"help-block text-right\" ng-show=\"editForm.internet.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block text-right\" ng-show=\"editForm.internet.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.internet.$error.max\" translate=\"entity.validation.max\">This field should be a number.</p><p class=\"help-block text-right\" ng-show=\"editForm.internet.$error.min\" translate=\"entity.validation.min\">This field should be a number.</p></div></div><div class=\"col-md-2\"><div class=\"input-group\"><input class=\"form-control input-sm\" type=\"number\" name=\"internet\" ng-change=\"vm.changePortion()\" min=\"0\" max=\"{{vm.options.internet.max}}\" ng-disabled=\"!vm.options.internet.status\" ng-model=\"vm.dashboardParams.internet\" required><div class=\"input-group-addon\">%</div></div></div><div class=\"col-md-4\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.options.internet.status\" ng-click=\"vm.setFocus(vm.options.internet.status, 10)\" ng-change=\"vm.changePortion()\"> <span translate=\"sceaApp.dashboardParams.internet\">Internet</span></label></div></div></div><div class=\"form-group custom-margin\" ng-class=\"{\'has-error\': vm.options.totalValue != 100}\"><label class=\"col-md-offset-3 col-md-2 text-right form-control-static\"><span translate=\"sceaApp.dashboardParams.total\">Total</span> <span>: {{vm.options.totalValue}}%</span></label><div class=\"col-md-6\"><span class=\"help-block\" ng-show=\"vm.options.totalValue != 100\">(Total Component Portion should be 100%)</span></div></div><div class=\"form-group custom-margin\"><div class=\"col-md-offset-3 col-md-4\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.dashboardParams.useAdjustedData\"> <span translate=\"sceaApp.dashboardParams.useAdjustedData\">Use adjusted data</span></label></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.options.totalValue!=100 || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/report/report-pop/checklist/report-pop-checklist.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\" translate=\"sceaApp.reportPopChecklist.title\"></h3></div><div class=\"panel-body\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"checkbox col-md-3\"><label><input type=\"checkbox\" ng-model=\"vm.isDisplayOnly\"> <b><span translate=\"sceaApp.reportPopChecklist.displayOnly\"></span></b></label></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.category\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedBizUnit\" ng-options=\"bizUnit.name for bizUnit in vm.bizUnits\"></select></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.type\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedType\" ng-options=\"type as type for type in vm.types\"></select></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.channel\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedChannel\" ng-options=\"channel.channelName for channel in vm.channels\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.account\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedAccount\" ng-options=\"account.accountName for account in vm.accounts\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.role\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedRole\" ng-options=\"o as o for o in vm.roles\"></select></div></div><div class=\"form-group\" style=\"margin-top:-15px\" ng-if=\"vm.selectedRole == \'VDE\'\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.vdo\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedVdo\" ng-change=\"vm.getVdes(vm.selectedVdo.id)\" ng-options=\"vdo.firstName for vdo in vm.employee.vdos\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.vde\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedVde\" ng-options=\"vde.firstName for vde in vm.employee.vdes\"><option value=\"\"></option></select></div></div><div class=\"form-group\" style=\"margin-top:-15px\" ng-if=\"vm.selectedRole == \'PC\'\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.arco\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedArco\" ng-change=\"vm.getSpvs(vm.selectedArco.id)\" ng-options=\"arco.firstName for arco in vm.employee.arcos\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.spv\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedSpv\" ng-change=\"vm.getPcs(vm.selectedSpv.id)\" ng-options=\"spv.firstName for spv in vm.employee.spvs\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.reportPopChecklist.pc\"></label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedPc\" ng-options=\"pc.firstName for pc in vm.employee.pcs\"><option value=\"\"></option></select></div></div><label translate=\"sceaApp.reportPopChecklist.area\"></label><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.region\">Region</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedRegion\" ng-change=\"vm.getBranchs(vm.selectedRegion.id)\" ng-options=\"region.areaName for region in vm.area.regions\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.branch\">Branch</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedBranch\" ng-change=\"vm.getCities(vm.selectedBranch.id)\" ng-options=\"branch.areaName for branch in vm.area.branchs\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.area.city\">City</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedCity\" ng-options=\"city.areaName for city in vm.area.cities\"><option value=\"\"></option></select></div></div><label translate=\"sceaApp.reportPopChecklist.time\"></label><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.year\">Year</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedYear\" ng-change=\"vm.getMonths()\" ng-options=\"year for year in vm.calendar.years\"><option value=\"\"></option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.month\">Month</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedMonth\" ng-change=\"vm.getWeeks(vm.selectedYear, vm.selectedMonth)\"><option value=\"\"></option><option ng-repeat=\"month in vm.calendar.months track by $index\" value=\"{{month}}\" translate=\"sceaApp.calendar.months.{{month}}\">{{month}}</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.calendar.week\">Week</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedWeek\" ng-options=\"week for week in vm.calendar.weeks\"><option value=\"\"></option></select></div></div></div></div><div class=\"panel-footer\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\" ng-click=\"vm.generate()\"><span translate=\"entity.action.generate\">Generate</span></button></div></div></div></form>");
$templateCache.put("app/report/report-pop/dashboard/report-pop-dashboard-detail.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" id=\"myPopLabel\" translate=\"sceaApp.pop.dashboardDetail.title\" translate-values=\"{name: \'{{vm.title}}\'}\">Detail of {{vm.title}}</h4></div><div class=\"modal-body\" style=\"height: 70vh; overflow: auto\"><div class=\"row\"><div class=\"col-xs-4 pull-right\" style=\"margin-bottom: 10px; display: flex\"><input type=\"text\" ng-model=\"vm.search\" id=\"search\" class=\"form-control\" ng-keyup=\"$event.keyCode == 13 && vm.onSearch()\" placeholder=\"Search\" style=\"border-top-right-radius: 0; border-bottom-right-radius: 0\"></div></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th ng-click=\"vm.sort(\'product\')\"><span translate=\"sceaApp.pop.dashboardDetail.product\">Product</span> <span ng-class=\"vm.predicate == \'product\' ? vm.reverse ? \'glyphicon-sort-by-attributes\' : \'glyphicon-sort-by-attributes-alt\' : \'glyphicon-sort\'\" class=\"glyphicon\"></span></th><th ng-click=\"vm.sort(\'qty\')\"><span translate=\"sceaApp.pop.dashboardDetail.qty\">Qty</span> <span ng-class=\"vm.predicate == \'qty\' ? vm.reverse ? \'glyphicon-sort-by-attributes-alt\' : \'glyphicon-sort-by-attributes\' : \'glyphicon-sort\'\" class=\"glyphicon\"></span></th><th><span translate=\"sceaApp.pop.dashboardDetail.pop\">POP</span></th><th><span translate=\"sceaApp.pop.dashboardDetail.qty\">Qty</span></th></tr></thead><tbody><tr ng-repeat=\"product in vm.product | orderBy:vm.predicate:vm.reverse | filter:vm.search\"><td>{{product.name}}</td><td>{{product.qty}}</td><td><ul style=\"list-style: none; padding-left: 0\"><li ng-repeat=\"item in product.item\">{{item.name}}</li></ul></td><td><ul style=\"list-style: none; padding-left: 0\"><li ng-repeat=\"item in product.item\">{{item.qty}}</li></ul></td></tr></tbody></table></div></div>");
$templateCache.put("app/report/report-pop/dashboard/report-pop-dashboard.html","<div class=\"panel panel-default page-pop-dashboard\"><div class=\"panel-heading\"><h3 class=\"panel-title\">POP</h3></div><div class=\"panel-body\" style=\"height: 600px\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.region\" style=\"padding-right: 0\">Region</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedRegion\" ng-change=\"vm.getBranchs(vm.selectedRegion.id); vm.changeResultGraph()\" ng-options=\"region.areaName for region in vm.area.regions\"><option value=\"\">ALL</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.branch\">Branch</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedBranch\" ng-change=\"vm.changeResultGraph()\" ng-options=\"branch.areaName for branch in vm.area.branchs\"><option value=\"\">ALL</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.account\">Account</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-change=\"vm.changeResultGraph()\" ng-model=\"vm.selectedAccount\" ng-options=\"account.accountName for account in vm.accounts\"><option value=\"\">ALL</option></select></div></div><div class=\"form-group\"><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.storeType\">Story Type</label><div class=\"col-md-3\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedStoryType\" ng-change=\"vm.changeResultGraph()\" ng-options=\"type.outletTypeName for type in vm.storyType\"><option value=\"\">ALL</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.grade\" style=\"text-align: right;\n                        padding-right: 25px\">Grade</label><div class=\"col-md-1\" style=\"float: left;\n                        width: 100px;\n                        padding: 0;\n                        margin-left: 15px\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedGrade\" ng-change=\"vm.changeResultGraph()\" ng-options=\"grade as grade.storeGrade for grade in vm.grades track by grade.id\"><option value=\"\">ALL</option></select></div><label class=\"col-md-1 form-control-static\" translate=\"sceaApp.pop.dashboard.div\" style=\"padding-left: 0;\n                        float: left;\n                        text-align: right;\n                        width: 40px;\n                        margin-left: 10px;\n                        padding-right: 0\">DIV</label><div class=\"col-md-1\" style=\"float: left;\n                        width: 100px;\n                        padding: 0;\n                        margin-left: 15px\"><select class=\"form-control input-sm\" ng-model=\"vm.selectedDIV\" ng-change=\"vm.changeResultGraph()\" ng-options=\"div.categoryName for div in vm.div\"><option value=\"\">ALL</option></select></div><label class=\"col-md-2 form-control-static\" translate=\"sceaApp.pop.dashboard.ris\" style=\"width: 180px;\n                        margin-left: 10px\">Show Only RIS Outlet</label><div class=\"col-md-1\" style=\"padding-left: 0;\n                        width: 40px\"><input type=\"checkbox\" class=\"form-control input-sm\" ng-model=\"vm.onlyRISOutlet\" ng-change=\"vm.changeResultGraph()\"></div></div></div><div class=\"chart-custom\" style=\"padding: 0 100px\"><div class=\"row\"><div class=\"col-md-3\"><h3>{{vm.branch.type}}<br><strong style=\"color: #28558A\">{{vm.branch.name}}</strong></h3><h3>POP Compliance<br><strong style=\"color: #28558A\">{{vm.branch.compliance}}%</strong></h3></div><div class=\"col-md-9\"><h3 class=\"text-center\">Outlets</h3><div class=\"\" style=\"max-height: 380px; overflow-y: auto\"><ul style=\"list-style: none\"><li ng-click=\"vm.detailDashboardDialog(outlet)\" ng-repeat=\"outlet in vm.outlets\" style=\"display: inline-flex;\n                                    align-items: center;\n                                    cursor: pointer;\n                                    margin-bottom: 5px\"><span class=\"name\" style=\"text-align: right;\n                                            padding-right: 10px;\n                                            display: inline-flex;\n                                            justify-content: flex-end;\n                                            width: 270px\">{{outlet.name}}</span> <span class=\"progress-bar-custom\" style=\"width: 153px;\n                                            height: 15px;\n                                            display: inline-block\"><span ng-style=\"outlet.bar == 0 && {width : \'1%\'} || outlet.bar != 0 && {width : outlet.bar + \'%\'}\" style=\"background-color: #28558A;\n                                                display: block;\n                                                height: 100%\"></span> </span><span style=\"width: 40px;\n                                            margin-left: 10px;\n                                            display: inline-block\">{{outlet.bar}}%</span></li></ul></div></div></div></div></div></div>");}]);})();